/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages", [
      "ui.router",
      "ngFileUpload",
      "BlurAdmin.pages.services",
      "BlurAdmin.pages.config",
      "BlurAdmin.pages.main",
      "BlurAdmin.pages.dashboard",
      // 'BlurAdmin.pages.ui',
      //'BlurAdmin.pages.components',
      "BlurAdmin.pages.form",
      // 'BlurAdmin.pages.tables',
      // 'BlurAdmin.pages.charts',
      // 'BlurAdmin.pages.maps',
      "BlurAdmin.pages.profile",
      "BlurAdmin.pages.authSignIn",
      "BlurAdmin.pages.authSignUp",
      "BlurAdmin.pages.system",
      "BlurAdmin.pages.account",
      "BlurAdmin.pages.usersetup",
      // 'BlurAdmin.pages.reports',
      // "BlurAdmin.pages.msync",
      // "BlurAdmin.pages.csync",
      "BlurAdmin.pages.invoices",
      "BlurAdmin.pages.partners",
      "BlurAdmin.pages.partneraccount",
      "BlurAdmin.pages.operational",
      "BlurAdmin.pages.online",
      "BlurAdmin.pages.machine",
      "BlurAdmin.pages.external",
      "BlurAdmin.pages.totalsales",
      "BlurAdmin.pages.collectors",
      "BlurAdmin.pages.shopstaff",
      "BlurAdmin.pages.supplier",
      // "BlurAdmin.pages.scanner",
      "BlurAdmin.pages.accDepartment",
      "BlurAdmin.pages.shopaddress",
      "BlurAdmin.pages.paparichpointapproval",
      "BlurAdmin.pages.shopad"
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise("/authSignIn");

    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.theme", [
    "toastr",
    // 'chart.js',
    "angular-chartist",
    // 'angular.morris-chart',
    "textAngular",
    "BlurAdmin.theme.components",
    "BlurAdmin.theme.inputs",
    "slick",
    "ckeditor",
  ]);
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment", [
      "BlurAdmin.pages.accDepartment.bill",
      "BlurAdmin.pages.accDepartment.category",
      "BlurAdmin.pages.accDepartment.accountType",
      "BlurAdmin.pages.accDepartment.pnl",
      "BlurAdmin.pages.accDepartment.ledger",
      "BlurAdmin.pages.accDepartment.approval"
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.accDepartment", {
        url: "/accDepartment",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Acc.Department",
        sidebarMeta: {
          icon: "ion-document",
          order: 202
        },
        authRoles: [1, 5, 6],
        authenticate: true
      })
      .state("main.accDepartment.bill", {
        url: "/bill",
        templateUrl: "app/pages/accDepartment/bill/bill.html",
        title: "Payment Voucher",
        controller: "BillPageCtrl",
        sidebarMeta: {
          order: 1
        },
        authRoles: [1, 5, 6],
        authenticate: true
      })
      .state("main.accDepartment.category", {
        url: "/category",
        templateUrl: "app/pages/accDepartment/category/category.html",
        title: "Code",
        controller: "CategoryPageCtrl",
        sidebarMeta: {
          order: 2
        },
        authRoles: [1, 5],
        authenticate: true
      })
      .state("main.accDepartment.accountType", {
        url: "/account-type",
        templateUrl: "app/pages/accDepartment/accountType/accountType.html",
        title: "Account Type",
        controller: "AccountTypePageCtrl",
        sidebarMeta: {
          order: 3
        },
        authRoles: [1, 5],
        authenticate: true
      })
      .state("main.accDepartment.pnl", {
        url: "/pnl",
        templateUrl: "app/pages/accDepartment/pnl/pnl.html",
        title: "P&L",
        controller: "PNLPageCtrl",
        sidebarMeta: {
          order: 4
        },
        authRoles: [1, 5],
        authenticate: true
      })
      .state("main.accDepartment.ledger", {
        url: "/ledger",
        templateUrl: "app/pages/accDepartment/ledger/ledger.html",
        title: "Ledger",
        controller: "LedgerPageCtrl",
        sidebarMeta: {
          order: 5
        },
        authRoles: [1, 5, 6],
        authenticate: true
      })
      .state("main.accDepartment.approval", {
        url: "/approval",
        templateUrl: "app/pages/accDepartment/approval/approval.html",
        title: "Official Receipt",
        controller: "InvReceiptApprovalPageCtrl",
        sidebarMeta: {
          order: 6
        },
        authRoles: [1, 5],
        authenticate: true
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.account", [
      "ui.select",
      "BlurAdmin.pages.account.partner",
      "BlurAdmin.pages.account.collector",
      "BlurAdmin.pages.account.supplier",
      "BlurAdmin.pages.account.usermapping",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.account", {
        url: "/account",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Account Setup",
        sidebarMeta: {
          icon: "ion-ios-people",
          order: 100,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.account.collector", {
        url: "/collector",
        templateUrl: "app/pages/account/collector/collector.html",
        title: "Collectors",
        controller: "CollectorPageCtrl",
        sidebarMeta: {
          order: 2,
        },
        authenticate: true,
      })
      .state("main.account.partner", {
        url: "/partner",
        templateUrl: "app/pages/account/partner/partner.html",
        title: "Partners",
        controller: "PartnerPageCtrl",
        sidebarMeta: {
          order: 3,
        },
        authenticate: true,
      })
      .state("main.account.supplier", {
        url: "/supplier",
        templateUrl: "app/pages/account/supplier/supplier.html",
        title: "Suppliers",
        controller: "SupplierPageCtrl",
        sidebarMeta: {
          order: 4,
        },
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors', [
      'BlurAdmin.pages.collectors.dailyinvoices',
      'BlurAdmin.pages.collectors.dailymachinesales'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.collectors', {
        url: '/collectors',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Collections',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 106,
        },
        authRoles: [7, 17],
        authenticate: true
      }).state('main.collectors.dailyinvoices', {
        url: '/collectors/dailyinvoices',
        templateUrl: 'app/pages/collectors/dailyinvoices/dailyinvoices.html',
        title: 'Daily Invoices',
        controller: 'dailyinvoicesCollectorPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.collectors.dailymachinesales', {
        url: '/collectors/dailymachinesales',
        templateUrl: 'app/pages/collectors/dailymachinesales/dailymachinesales.html',
        title: 'Daily Machine',
        controller: 'DailymachinesalesCollectorPageCtrl',
        sidebarMeta: {
          order: 1,
        },
        authenticate: true
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignUp', {
        url: '/authSignUp',
        templateUrl: 'app/pages/authSignUp/authSignUp.html',
        title: 'My Page',
        controller: 'authSignUpCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.authSignIn", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("authSignIn", {
      url: "/authSignIn?shopid",
      templateUrl: "app/pages/authSignIn/authSignIn.html",
      title: "My Page",
      controller: "authSignInCtrl",
      sidebarMeta: {
        order: 800,
      },
      params: {
        shopid: null,
      },
      authenticate: false,
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Charts',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 150,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
      'BlurAdmin.pages.components.mail',
      'BlurAdmin.pages.components.timeline',
      'BlurAdmin.pages.components.tree',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components', {
        url: '/components',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Components',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 100,
        },
        authenticate: true
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.external", [
      "BlurAdmin.pages.external.partnersales",
      // 'BlurAdmin.pages.external.suppliersales'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.external", {
        url: "/external",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "External",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 107,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.external.partnersales", {
        url: "/partnersales",
        templateUrl: "app/pages/external/partnersales/partnersales.html",
        title: "Sales By Partner",
        controller: "PartnersalesreportPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authenticate: true,
        // }).state('main.external.suppliersales', {
        //   url: '/suppliersales',
        //   templateUrl: 'app/pages/external/suppliersales/suppliersales.html',
        //   title: 'Sales By Supplier',
        //   controller: 'SuppliersalesreportPageCtrl',
        //   sidebarMeta: {
        //     order: 2,
        //   },
        //   authenticate: true
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync', [
  	'BlurAdmin.pages.csync.assigncollector'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.csync', {
          url: '/csync',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'cSync',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 201,
          },
          authRoles:[1,5,7,18],
          authenticate: true
        }).state('main.csync.assigncollector', {
          url: '/assigncollector',
          templateUrl: 'app/pages/csync/assigncollector/assigncollector.html',
          title: 'Assign Collector',
          controller: 'AssigncollectorPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.form", [
      "ui.select",
      "ngSanitize",
      "BlurAdmin.pages.form.onlinesales",
      "BlurAdmin.pages.form.machinesales",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.form", {
        url: "/form",
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Input Sales",
        sidebarMeta: {
          icon: "ion-compose",
          order: 103,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      // .state('main.form.inputs', {
      //   url: '/inputs',
      //   templateUrl: 'app/pages/form/inputs/inputs.html',
      //   title: 'Form Inputs',
      //   sidebarMeta: {
      //     order: 0,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.layouts', {
      //   url: '/layouts',
      //   templateUrl: 'app/pages/form/layouts/layouts.html',
      //   title: 'Form Layouts',
      //   sidebarMeta: {
      //     order: 100,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.wizard', {
      //   url: '/wizard',
      //   templateUrl: 'app/pages/form/wizard/wizard.html',
      //   controller: 'WizardCtrl',
      //   controllerAs: 'vm',
      //   title: 'Form Wizard',
      //   sidebarMeta: {
      //     order: 200,
      //   },
      //   authenticate: true
      // })
      .state("main.form.onlinesales", {
        url: "/onlinesales",
        templateUrl: "app/pages/form/onlinesales/onlinesales.html",
        title: "Online Sales",
        controller: "OnlinesalesPageCtrl",
        sidebarMeta: {
          order: 300,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.form.machinesales", {
        url: "/machinesales",
        templateUrl: "app/pages/form/machinesales/machinesales.html",
        title: "Machine Sales",
        controller: "MachinesalesPageCtrl",
        sidebarMeta: {
          order: 400,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.machine", [
      "BlurAdmin.pages.machine.dailymachinesales",
      "BlurAdmin.pages.machine.dailymachineshop",
      "BlurAdmin.pages.machine.machinesales",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.machine", {
        url: "/machine",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Machine",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 105,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.machine.dailymachinesales", {
        url: "/dailymachinesales",
        templateUrl:
          "app/pages/machine/dailymachinesales/dailymachinesales.html",
        title: "Daily Machine",
        controller: "DailymachinesalesreportPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authenticate: true,
      })
      .state("main.machine.dailymachineshop", {
        url: "/dailymachineshop",
        templateUrl: "app/pages/machine/dailymachineshop/dailymachineshop.html",
        title: "Machine By Shop",
        controller: "DailymachineshopPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authenticate: true,
      })
      .state("main.machine.machinesales", {
        url: "/machinesales",
        templateUrl: "app/pages/machine/machinesales/machinesales.html",
        title: "All Machine",
        controller: "MachinesalesreportPageCtrl",
        sidebarMeta: {
          order: 2,
        },
        authenticate: true,
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Dashboard',
        controller: 'DashboardPageCtrl',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        authRoles:[1,3,5,18],
        authenticate: true
      });
  }

})();

/**
 * @author dufrolabs
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboard',
        authenticate: true


      });
  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync', [
    'BlurAdmin.pages.msync.importofficers',
    'BlurAdmin.pages.msync.officers',
  	'BlurAdmin.pages.msync.paylist'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.msync', {
          url: '/msync',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'mSync',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 201,
          },
          authRoles:[1,12,18],
          authenticate: true
        }).state('main.msync.importofficers', {
          url: '/importofficers',
          templateUrl: 'app/pages/msync/importofficers/importofficers.html',
          title: 'Import Officers',
          controller: 'ImportofficersPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.msync.officers', {
          url: '/officers',
          templateUrl: 'app/pages/msync/officers/officers.html',
          title: 'Manage Officers',
          controller: 'OfficersPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.msync.paylist', {
          url: '/paylist',
          templateUrl: 'app/pages/msync/paylist/paylist.html',
          title: 'Manage Paylist',
          controller: 'PaylistPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices", [
      //'BlurAdmin.pages.invoices.allinvoices',
      "BlurAdmin.pages.invoices.dailyinvoices",
      "BlurAdmin.pages.invoices.allinvoices",
      "BlurAdmin.pages.invoices.companyserverinvoice",
      "BlurAdmin.pages.csync.assigncollector",
      "BlurAdmin.pages.invoices.shopcategory",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.invoices", {
        url: "/invoices",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Invoices",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 106,
        },
        authRoles: [1, 5, 3, 9, 20, 13, 7, 18],
        authenticate: true,
      })
      .state("main.invoices.dailyinvoices", {
        url: "/dailyinvoices",
        templateUrl: "app/pages/invoices/dailyinvoices/dailyinvoices.html",
        title: "Daily Invoices",
        controller: "DailyinvoicesPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5, 18],
        authRolesIf: function () {
          return false;
        },
        authenticate: true,
        params: {
          zoneid: null,
          shoptype: null,
        },
      })
      .state("main.invoices.allinvoices", {
        url: "/allinvoices",
        templateUrl: "app/pages/invoices/allinvoices/allinvoices.html",
        title: "All Invoices",
        controller: "AllinvoicesPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authRoles: [1, 5, 3, 9, 20, 13, 7, 18],
        authenticate: true,
      })
      .state("main.invoices.companyserverinvoice", {
        url: "/companyserverinvoice",
        templateUrl:
          "app/pages/invoices/companyserverinvoice/companyserverinvoice.html",
        title: "Server Invoice",
        controller: "CompanyServerInvoicePageCtrl",
        sidebarMeta: {
          order: 2,
        },
        authRoles: [1, 20],
        authenticate: true,
      })
      .state("main.invoices.shopcategory", {
        url: "/shop-category",
        templateUrl: "app/pages/invoices/shopcategory/shopCategory.html",
        title: "Category Invoice",
        controller: "ShopCategoryInvoicePageCtrl",
        sidebarMeta: {
          order: 3,
        },
        authRoles: [1],
        authenticate: true,
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.maps', {
        url: '/maps',
        templateUrl: 'app/pages/maps/maps.html',
        abstract: true,
        title: 'Maps',
        sidebarMeta: {
          icon: 'ion-ios-location-outline',
          order: 500,
        },
        authenticate: true
      })
      .state('main.maps.gmap', {
        url: '/gmap',
        templateUrl: 'app/pages/maps/google-maps/google-maps.html',
        controller: 'GmapPageCtrl',
        title: 'Google Maps',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.maps.leaflet', {
        url: '/leaflet',
        templateUrl: 'app/pages/maps/leaflet/leaflet.html',
        controller: 'LeafletPageCtrl',
        title: 'Leaflet Maps',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.maps.bubble', {
        url: '/bubble',
        templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
        controller: 'MapBubblePageCtrl',
        title: 'Bubble Maps',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      })
      .state('main.maps.line', {
        url: '/line',
        templateUrl: 'app/pages/maps/map-lines/map-lines.html',
        controller: 'MapLinesPageCtrl',
        title: 'Line Maps',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational", [
      "BlurAdmin.pages.operational.machine",
      "BlurAdmin.pages.operational.shop",
      "BlurAdmin.pages.operational.it",
      "BlurAdmin.pages.operational.shopcategory",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.operational", {
        url: "/operational",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Operation Setup",
        sidebarMeta: {
          icon: "ion-gear-a",
          order: 99,
        },
        authRoles: [1, 5, 14, 18, 19],
        authenticate: true,
      })
      .state("main.operational.machine", {
        url: "/machine",
        templateUrl: "app/pages/operational/machine/machine.html",
        title: "Machine",
        controller: "MachinePageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5, 14, 18, 19],
        authenticate: true,
      })
      .state("main.operational.it", {
        url: "/it",
        templateUrl: "app/pages/operational/it/it.html",
        title: "IT",
        controller: "ITPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5, 14, 18, 19],
        authenticate: true,
      })
      .state("main.operational.shop", {
        url: "/shop?shopid",
        params: {
          shopid: null,
        },
        templateUrl: "app/pages/operational/shop/shop.html",
        title: "Shop",
        controller: "ShopPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authRoles: [1, 5, 14, 18],
        authenticate: true,
      })
      .state("main.operational.shopcategory", {
        url: "/shopcategory",
        templateUrl: "app/pages/operational/shopcategory/shopCategory.html",
        title: "Shop Category",
        controller: "ShopCategoryPageCtrl",
        sidebarMeta: {
          order: 3,
        },
        authRoles: [1],
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online", [
      "BlurAdmin.pages.online.dailyonlinesales",
      "BlurAdmin.pages.online.dailyonlineshop",
      "BlurAdmin.pages.online.onlinesales",
      "BlurAdmin.pages.online.gamesales",
      "BlurAdmin.pages.online.serversales",
      "BlurAdmin.pages.online.dailyonlineserver",
      "BlurAdmin.pages.online.internalserverpr",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.online", {
        url: "/online",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Online",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 104,
        },
        authRoles: [1, 5, 3, 9, 20, 13, 18, 14],
        authenticate: true,
      })
      .state("main.online.dailyonlinesales", {
        url: "/dailyonlinesales",
        templateUrl: "app/pages/online/dailyonlinesales/dailyonlinesales.html",
        title: "Daily Online",
        controller: "DailyonlinesalesreportPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5, 18, 14],
        authenticate: true,
      })
      .state("main.online.dailyonlineshop", {
        url: "/dailyonlineshop",
        templateUrl: "app/pages/online/dailyonlineshop/dailyonlineshop.html",
        title: "Online By Shop",
        controller: "DailyonlineshopreportPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.online.onlinesales", {
        url: "/onlinesales",
        templateUrl: "app/pages/online/onlinesales/onlinesales.html",
        title: "All Online",
        controller: "OnlinesalesreportPageCtrl",
        sidebarMeta: {
          order: 3,
        },
        authRoles: [1, 5, 3, 9, 20, 13, 18, 14],
        authenticate: true,
      })
      .state("main.online.gamesales", {
        url: "/gamesales",
        templateUrl: "app/pages/online/gamesales/gamesales.html",
        title: "Game Sales",
        controller: "gameSalesreportPageCtrl",
        sidebarMeta: {
          order: 4,
        },
        // authRoles: [1, 5, 3, 9, 13, 18],
        authenticate: true,
      })
      .state("main.online.dailyonlineserver", {
        url: "/dailyonlineserver",
        templateUrl:
          "app/pages/online/dailyonlineserver/dailyonlineserver.html",
        title: "Input Online Server",
        controller: "DailyOnlineServerReportPageCtrl",
        sidebarMeta: {
          order: 5,
        },
        authRoles: [1, 5],
      })
      .state("main.online.serversales", {
        url: "/serversales",
        templateUrl: "app/pages/online/serversales/serversales.html",
        title: "Server Sales",
        controller: "serverSalesreportPageCtrl",
        sidebarMeta: {
          order: 6,
        },
        authRoles: [1],
        authenticate: true,
      })
      .state("main.online.internalserverpr", {
        url: "/internalserverpr",
        template: '<ui-view autoscroll="true"></ui-view>',
        abstract: true,
        title: "Internal Server PR Fee",
        sidebarMeta: {
          order: 7,
        },
        authRoles: [1],
        authenticate: true,
      })
      // List — shows in menu
      .state("main.online.internalserverpr.list", {
        url: "",
        templateUrl: "app/pages/online/internalserverpr/internalserverpr.html",
        controller: "internalServerPRPageCtrl",
      })
      // Detail — NO sidebarMeta, so it won't appear in the menu
      .state("main.online.internalserverpr.upload", {
        url: "/upload",
        templateUrl:
          "app/pages/online/internalserverpr/widgets/internalserveronlinesales.html",
        controller: "internalServerPROnlinesalesPageCtrl",
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.paparichpointapproval", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("main.paparichpointapproval", {
      url: "/paparichpointapproval",
      templateUrl: "app/pages/paparichpointapproval/paparichpointapproval.html",
      title: " 加分",
      controller: "paparichPointApprovalPageCtrl",
      sidebarMeta: {
        icon: "ion-arrow-graph-up-right",
        order: 2,
      },
      authRoles: [1, 2, 9, 13],
      authenticate: true,
    });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.partners", [
      "BlurAdmin.pages.partners.partnerinvoice",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.partners", {
        url: "/partners",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Partners",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 103,
        },
        authRoles: [9, 20, 13, 17],
        authenticate: true,
      })
      .state("main.partners.partnerinvoice", {
        url: "/partnerinvoice",
        templateUrl: "app/pages/partners/partnerinvoice/partnerinvoice.html",
        title: "Invoice Report",
        controller: "PartnerInvoicereportPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.partneraccount", [
      "BlurAdmin.pages.partneraccount.partnerusers",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.partneraccount", {
        url: "/partneraccount",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Partner Accounts",
        sidebarMeta: {
          icon: "ion-ios-people",
          order: 101,
        },
        authRoles: [9, 20],
        authenticate: true,
      })
      .state("main.partneraccount.users", {
        url: "/users",
        templateUrl: "app/pages/partneraccount/partnerusers/partnerusers.html",
        title: "Partner Users",
        controller: "PartnerUsersPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authenticate: true,
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.scanner", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("main.scanner", {
      url: "/scanner",
      templateUrl: "app/pages/scanner/scanner.html",
      title: "Scanner",
      controller: "scannerPageCtrl",
      sidebarMeta: {
        icon: "ion-camera",
        order: 101,
      },
      // authRoles: [1, 5, 16, 19],
      authRoles: [1],
      authenticate: true,
    });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports', [
	// 'BlurAdmin.pages.reports.dailymachineshop',  
	// 'BlurAdmin.pages.reports.dailyonlineshop',
	// 'BlurAdmin.pages.reports.machinesales',
	// 'BlurAdmin.pages.reports.onlinesales',
	// 'BlurAdmin.pages.reports.dailymachinesales',
	// 'BlurAdmin.pages.reports.dailyonlinesales',
	// 'BlurAdmin.pages.reports.suppliersales',
	// 'BlurAdmin.pages.reports.partnersales',
	// 'BlurAdmin.pages.reports.collector',
	// 'BlurAdmin.pages.reports.marketing'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.reports', {
          url: '/reports',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Reports',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 103,
          },
          authRoles:[1, 18],
          authenticate: true
        }).state('main.reports.dailyonlineshop', {
          url: '/dailyonlineshop',
          templateUrl: 'app/pages/reports/dailyonlineshop/dailyonlineshop.html',
          title: 'Online Sales By Shop',
          controller: 'DailyonlineshopreportPageCtrl',
          sidebarMeta: {
            order: 3,
          },
          authenticate: true
        }).state('main.reports.dailymachineshop', {
          url: '/dailymachineshop',
          templateUrl: 'app/pages/reports/dailymachineshop/dailymachineshop.html',
          title: 'Mac Sales By Shop',
          controller: 'DailymachineshopPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        }).state('main.reports.machinesales', {
          url: '/machinesales',
          templateUrl: 'app/pages/reports/machinesales/machinesales.html',
          title: 'All Machine Sales',
          controller: 'MachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 5,
          },
          authenticate: true
        }).state('main.reports.onlinesales', {
          url: '/onlinesales',
          templateUrl: 'app/pages/reports/onlinesales/onlinesales.html',
          title: 'All Online Sales',
          controller: 'OnlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 4,
          },
          authenticate: true
        }).state('main.reports.dailymachinesales', {
          url: '/dailymachinesales',
          templateUrl: 'app/pages/reports/dailymachinesales/dailymachinesales.html',
          title: 'Daily Machine Sales',
          controller: 'DailymachinesalesreportPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.reports.dailyonlinesales', {
          url: '/dailyonlinesales',
          templateUrl: 'app/pages/reports/dailyonlinesales/dailyonlinesales.html',
          title: 'Daily Online Sales',
          controller: 'DailyonlinesalesreportPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.reports.suppliersales', {
          url: '/suppliersales',
          templateUrl: 'app/pages/reports/suppliersales/suppliersales.html',
          title: 'Sales By Supplier',
          controller: 'SuppliersalesreportPageCtrl',
          sidebarMeta: {
            order: 7,
          },
          authenticate: true
        }).state('main.reports.partnersales', {
          url: '/partnersales',
          templateUrl: 'app/pages/reports/partnersales/partnersales.html',
          title: 'Sales By Partner',
          controller: 'PartnersalesreportPageCtrl',
          sidebarMeta: {
            order: 6,
          },
          authenticate: true
        }).state('main.reports.collector', {
          url: '/collector',
          templateUrl: 'app/pages/reports/collector/collector.html',
          title: 'TS By Collector',
          controller: 'CollectorreportPageCtrl',
          sidebarMeta: {
            order: 8,
          },
          authenticate: true
        }).state('main.reports.marketing', {
          url: '/marketing',
          templateUrl: 'app/pages/reports/marketing/marketing.html',
          title: 'TS By Marketing',
          controller: 'MarketingreportPageCtrl',
          sidebarMeta: {
            order: 9,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.shopad", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("main.shopad", {
      url: "/shopad",
      templateUrl: "app/pages/shopad/shopad.html",
      title: "顶店",
      controller: "shopadPageCtrl",
      sidebarMeta: {
        icon: "ion-home",
        order: 1
      },
      authRoles: [1, 9, 13, 14],
      authenticate: true
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.shopaddress", ["ngMap"]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("main.shopaddress", {
      url: "/shopaddress",
      templateUrl: "app/pages/shopaddress/shopaddress.html",
      title: "上地址",
      controller: "shopaddressPageCtrl",
      sidebarMeta: {
        icon: "ion-upload",
        order: 1
      },
      authRoles: [1, 9, 13, 14],
      authenticate: true
    });
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff', [
    'BlurAdmin.pages.shopstaff.dailymachinesales'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.shopstaff', {
          url: '/shopstaff',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Machines',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 106,
          },
          authRoles:[15],
          authenticate: true
        }).state('main.shopstaff.dailymachinesales', {
          url: '/dailymachinesales',
          templateUrl: 'app/pages/shopstaff/dailymachinesales/dailymachinesales.html',
          title: 'Daily Machine',
          controller: 'DailymachinesalesShopStaffPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system", [
      "BlurAdmin.pages.system.states",
      "BlurAdmin.pages.system.areas",
      "BlurAdmin.pages.system.gamecategory",
      "BlurAdmin.pages.system.games",
      "BlurAdmin.pages.system.zones",
      "BlurAdmin.pages.system.zonespr",
      "BlurAdmin.pages.system.site",
      "BlurAdmin.pages.system.memo",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.system", {
        url: "/system",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "System Setup",
        sidebarMeta: {
          icon: "ion-gear-a",
          order: 97,
        },
        authRoles: [1, 18, 5],
        authenticate: true,
      })
      .state("main.system.states", {
        url: "/states",
        templateUrl: "app/pages/system/states/states.html",
        title: "States",
        controller: "StatesPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 18],
        authenticate: true,
      })
      .state("main.system.zones", {
        url: "/zones",
        templateUrl: "app/pages/system/zones/zones.html",
        title: "Daerah Account",
        controller: "ZonesPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authRoles: [1, 18],
        authenticate: true,
      })
      .state("main.system.zonespr", {
        url: "/zonespr",
        templateUrl: "app/pages/system/zonespr/zonesPR.html",
        title: "Daerah PR",
        controller: "ZonesPRPageCtrl",
        sidebarMeta: {
          order: 2,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      // .state('main.system.areas', {
      //   url: '/areas',
      //   templateUrl: 'app/pages/system/areas/areas.html',
      //   title: 'Area',
      //   controller: 'AreasPageCtrl',
      //   sidebarMeta: {
      //     order: 2,
      //   },
      //   authenticate: true
      // })
      .state("main.system.site", {
        url: "/site",
        templateUrl: "app/pages/system/site/site.html",
        title: "Balai",
        controller: "SitePageCtrl",
        sidebarMeta: {
          order: 3,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.system.gamecategory", {
        url: "/gamecategory",
        templateUrl: "app/pages/system/gamecategory/gamecategory.html",
        title: "Game Category",
        controller: "GamecategoryPageCtrl",
        sidebarMeta: {
          order: 4,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.system.games", {
        url: "/games",
        templateUrl: "app/pages/system/games/games.html",
        title: "Games",
        controller: "GamesPageCtrl",
        sidebarMeta: {
          order: 5,
        },
        authRoles: [1, 5, 18],
        authenticate: true,
      })
      .state("main.system.memo", {
        url: "/memo",
        templateUrl: "app/pages/system/memo/memo.html",
        title: "Memo",
        controller: "MemoPageCtrl",
        sidebarMeta: {
          order: 6,
        },
        authRoles: [1],
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier", [
      "BlurAdmin.pages.supplier.machinesales",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.supplier", {
        url: "/supplier",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Supplier",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 105,
        },
        authRoles: [1, 5, 10, 18],
        authenticate: true,
      })
      .state("main.supplier.machinesales", {
        url: "/machinesales",
        templateUrl: "app/pages/supplier/machinesales/machinesales.html",
        title: "All Machine",
        controller: "MachinesalesSupplierPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authenticate: true,
      })
      .state("main.supplier.gameprovider", {
        url: "/gameprovider",
        templateUrl: "app/pages/supplier/gameprovider/gameprovider.html",
        title: "Game Provider",
        controller: "GameProviderPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5],
        authenticate: true,
      })
      .state("main.supplier.gameserver", {
        url: "/gameserver",
        templateUrl: "app/pages/supplier/gameserver/gameserver.html",
        title: "Game Server",
        controller: "GameServerPageCtrl",
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 5],
        authenticate: true,
      });
  }
})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.totalsales", [
      "BlurAdmin.pages.totalsales.collector",
      "BlurAdmin.pages.totalsales.marketing",
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("main.totalsales", {
        url: "/totalsales",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: "Total Sales",
        sidebarMeta: {
          icon: "ion-stats-bars",
          order: 108,
        },
        authRoles: [1, 3, 5, 14, 18],
        authenticate: true,
      })
      .state("main.totalsales.collector", {
        url: "/collector",
        templateUrl: "app/pages/totalsales/collector/collector.html",
        title: "Collector",
        controller: "CollectorreportPageCtrl",
        sidebarMeta: {
          order: 1,
        },
        authenticate: true,
      })
      .state("main.totalsales.marketing", {
        url: "/marketing",
        templateUrl: "app/pages/totalsales/marketing/marketing.html",
        title: "Marketing",
        controller: "MarketingreportPageCtrl",
        sidebarMeta: {
          order: 2,
        },
        authenticate: true,
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
      'BlurAdmin.pages.ui.typography',
      'BlurAdmin.pages.ui.buttons',
      'BlurAdmin.pages.ui.icons',
      'BlurAdmin.pages.ui.modals',
      'BlurAdmin.pages.ui.grid',
      'BlurAdmin.pages.ui.alerts',
      'BlurAdmin.pages.ui.progressBars',
      'BlurAdmin.pages.ui.notifications',
      'BlurAdmin.pages.ui.tabs',
      'BlurAdmin.pages.ui.slider',
      'BlurAdmin.pages.ui.panels',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui', {
        url: '/ui',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'UI Features',
        sidebarMeta: {
          icon: 'ion-android-laptop',
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup', [
      'ui.select',
      'BlurAdmin.pages.usersetup.roles',
      'BlurAdmin.pages.usersetup.users',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.usersetup', {
        url: '/usersetup',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'User Setup',
        sidebarMeta: {
          icon: 'ion-person',
          order: 102,
        },
        authRoles: [1, 5, 18],
        authenticate: true
      })
      .state('main.usersetup.roles', {
        url: '/roles',
        templateUrl: 'app/pages/usersetup/roles/roles.html',
        title: 'Roles',
        controller: 'RolesPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authRoles: [1, 18],
        authenticate: true
      }).state('main.usersetup.users', {
        url: '/users',
        templateUrl: 'app/pages/usersetup/users/users.html',
        title: 'Users',
        controller: 'UsersPageCtrl',
        sidebarMeta: {
          order: 1,
        },
        authRoles: [1, 5, 18],
        authenticate: true
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.theme.components", ["ui.bootstrap"]);
})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.accountType", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.approval", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.accDepartment.pnl", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.category", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.ledger", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.accDepartment.bill", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailyinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.components.mail', {
        url: '/mail',
        abstract: true,
        templateUrl: 'app/pages/components/mail/mail.html',
        controller: "MailTabCtrl",
        controllerAs: "tabCtrl",
        title: 'Mail',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.components.mail.label', {
        url: '/:label',
        templateUrl: 'app/pages/components/mail/list/mailList.html',
        title: 'Mail',
        controller: "MailListCtrl",
        controllerAs: "listCtrl",
        authenticate: true
      }).state('main.components.mail.detail', {
        url: '/:label/:id',
        templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
        title: 'Mail',
        controller: "MailDetailCtrl",
        controllerAs: "detailCtrl",
        authenticate: true
      });
    $urlRouterProvider.when('/main/components/mail', '/main/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
        title: 'Timeline',
        sidebarMeta: {
          icon: 'ion-ios-pulse',
          order: 100,
        },
        authenticate: true
      });
  }
})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function() {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.tree', {
        url: '/tree',
        templateUrl: 'app/pages/components/tree/tree.html',
        title: 'Tree View',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.external.partnersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.machinesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.companyserverinvoice", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.allinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.invoices.dailyinvoices', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.shopcategory", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.operational.it", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.machine', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shopcategory", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.shop', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineserver", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.dailyonlineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.gamesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.online.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.internalserverpr", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.online.serversales", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.partners.partnerinvoice', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () { 
  'use strict';

  angular.module('BlurAdmin.pages.partneraccount.partnerusers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/partneraccount/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailyonlineshop', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.system.memo", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.site', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.pages.system.zonespr", []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier.machinesales", [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.collector', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.marketing', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.alerts', {
        url: '/alerts',
        templateUrl: 'app/pages/ui/alerts/alerts.html',
        title: 'Alerts',
        sidebarMeta: {
          order: 500,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.buttons', {
        url: '/buttons',
        templateUrl: 'app/pages/ui/buttons/buttons.html',
        controller: 'ButtonPageCtrl',
        title: 'Buttons',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.grid', {
        url: '/grid',
        templateUrl: 'app/pages/ui/grid/grid.html',
        title: 'Grid',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.icons', {
        url: '/icons',
        templateUrl: 'app/pages/ui/icons/icons.html',
        controller: 'IconsPageCtrl',
        title: 'Icons',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.modals', {
        url: '/modals',
        templateUrl: 'app/pages/ui/modals/modals.html',
        controller: 'ModalsPageCtrl',
        title: 'Modals',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.progressBars', {
        url: '/progressBars',
        templateUrl: 'app/pages/ui/progressBars/progressBars.html',
        title: 'Progress Bars',
        sidebarMeta: {
          order: 600,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/ui/notifications/notifications.html',
        controller: 'NotificationsPageCtrl',
        title: 'Notifications',
        sidebarMeta: {
          order: 700,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.panels', {
        url: '/panels',
        templateUrl: 'app/pages/ui/panels/panels.html',
        controller: 'NotificationsPageCtrl',
        title: 'Panels',
        sidebarMeta: {
          order: 1100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.slider', {
        url: '/slider',
        templateUrl: 'app/pages/ui/slider/slider.html',
        title: 'Sliders',
        sidebarMeta: {
          order: 1000,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.typography', {
        url: '/typography',
        templateUrl: 'app/pages/ui/typography/typography.html',
        title: 'Typography',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.tabs', {
        url: '/tabs',
        templateUrl: 'app/pages/ui/tabs/tabs.html',
        title: 'Tabs & Accordions',
        sidebarMeta: {
          order: 800,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () { 
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.users', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

"use strict";

angular
  .module("BlurAdmin", [
    "ngAnimate",
    "ngSanitize",
    "ui.bootstrap",
    "ui.sortable",
    "ui.router",
    "ngTouch",
    "toastr",
    "smart-table",
    "xeditable",
    "ui.slimscroll",
    "ngJsTree",
    "angular-progress-button-styles",
    "ngResource",
    "lbServices",
    "BlurAdmin.theme",
    "BlurAdmin.pages",
    "ui.grid",
    "ui.grid.selection",
    "ui.grid.exporter",
    "angular.filter",
    "AngularPrint",
    "ja.qr",
    "chart.js",
    "angularMoment",
    "slick",
    "oitozero.ngSweetAlert"
  ])
  .run(function ($locale) {
    var currencyPatterns = $locale.NUMBER_FORMATS.PATTERNS[1];
    currencyPatterns.negPre = "(\u00a4";
    currencyPatterns.negSuf = ")";
  })
  .config(function (LoopBackResourceProvider) {
    // Use a custom auth header instead of the default 'Authorization'
    LoopBackResourceProvider.setAuthHeader("X-Access-Token");

    // Change the URL where to access the LoopBack REST API server
    LoopBackResourceProvider.setUrlBase("https://api-v2.superman.tswlab.com/api");
    // LoopBackResourceProvider.setUrlBase('https://api.test.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.vipportal.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.thor.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.ironman.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.ultraman.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://api.superman.tswlab.com/api');
  })
  .run(function ($rootScope) {
    $rootScope.getTotal = function (items, key, key2, key3, key4) {
      if (!items) return 0;

      if (_.isArray(items) && items.length === 0) return 0;

      if (_.isArray(items) && key) {
        return items
          .map(function (i) {
            var key1Sum = !!key
              ? isNaN(i[key]) || i[key] === null
                ? 0
                : parseFloat(i[key])
              : 0;
            var key2Sum = !!key2
              ? isNaN(i[key2])
                ? 0
                : parseFloat(i[key2])
              : 0;
            var key3Sum = !!key3
              ? isNaN(i[key3])
                ? 0
                : parseFloat(i[key3])
              : 0;
            var key4Sum = !!key4
              ? isNaN(i[key4])
                ? 0
                : parseFloat(i[key4])
              : 0;
            return key1Sum + key2Sum + key3Sum + key4Sum;
          })
          .reduce(function (a, c) {
            return a + c;
          }, 0);
      }

      if (_.isArray(items)) {
        return items.reduce(function (a, c) {
          return a + c;
        }, 0);
      }

      if (_.isObject(items) && key) {
        var key1Sum = !!key
          ? isNaN(items[key])
            ? 0
            : parseFloat(items[key])
          : 0;
        var key2Sum = !!key2
          ? isNaN(items[key2])
            ? 0
            : parseFloat(items[key2])
          : 0;
        var key3Sum = !!key3
          ? isNaN(items[key3])
            ? 0
            : parseFloat(items[key3])
          : 0;
        var key4Sum = !!key4
          ? isNaN(items[key4])
            ? 0
            : parseFloat(items[key4])
          : 0;
        return key1Sum + key2Sum + key3Sum + key4Sum;
      }
    };

    $rootScope.toCurrency = function (amount, fractionSize) {
      // Default fraction size: 2
      fractionSize = typeof fractionSize === "undefined" ? 2 : fractionSize;

      if (amount == null || isNaN(amount)) return "";

      // Round according to fraction size
      var number = Number(amount);
      var negative = number < 0;
      number = Math.abs(number);

      // Format with grouping and fixed decimals
      var formatted = number.toLocaleString("en-US", {
        minimumFractionDigits: fractionSize,
        maximumFractionDigits: fractionSize,
      });

      return (negative ? "-" : "") + formatted;
    };
  });

window.OneSignalDeferred = window.OneSignalDeferred || [];

OneSignalDeferred.push(function (OneSignal) {
  OneSignal.init({
    // ==== Production Keys ====
    appId: "7e1be144-ddfb-4cfe-88de-71ea7e0debb0",
    safari_web_id: "web.onesignal.auto.477dedc8-8bcf-40fd-b64c-238033111672",
    notifyButton: {
      enable: false,
    },
    // =======================
    // appId: "f524c502-5585-4a73-b28c-6b4789cc3bb9",
    // safari_web_id: "web.onesignal.auto.4bead971-106d-461b-853f-83aecbd62d40",
    // notifyButton: {
    //   enable: false,
    // },
    // allowLocalhostAsSecureOrigin: true,
  });
});

// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Role
 * @header lbServices.Role
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Roles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role.principals.findById() instead.
            "prototype$__findById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "prototype$__destroyById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "prototype$__updateById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "prototype$__get__principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "prototype$__create__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "prototype$__delete__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "prototype$__count__principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#create
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Roles",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Roles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#upsertWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Roles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#exists
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Roles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Roles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Roles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#find
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findOne
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Roles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#updateAll
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Roles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#deleteById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Roles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#count
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#prototype$patchAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Roles/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createChangeStream
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Roles/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createMany
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "POST",
            },

            // INTERNAL. Use RoleMapping.role() instead.
            "::get::RoleMapping::role": {
              url: urlBase + "/RoleMappings/:id/role",
              method: "GET",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "::findById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "::destroyById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "::updateById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "::link::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "::unlink::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "::exists::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.roles() instead.
            "::get::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "::create::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.createMany() instead.
            "::createMany::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "::delete::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "::count::User::roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.findById() instead.
            "::findById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.destroyById() instead.
            "::destroyById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.updateById() instead.
            "::updateById::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.link() instead.
            "::link::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.unlink() instead.
            "::unlink::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.exists() instead.
            "::exists::Usertransaction::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Usertransaction.roles() instead.
            "::get::Usertransaction::roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.create() instead.
            "::create::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.createMany() instead.
            "::createMany::Usertransaction::roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.destroyAll() instead.
            "::delete::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.count() instead.
            "::count::Usertransaction::roles": {
              url: urlBase + "/Usertransactions/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.role() instead.
            "::get::Usermapping::role": {
              url: urlBase + "/Usermappings/:id/role",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Role#upsert
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Role#updateOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreateWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Role#update
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Role#destroyById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#removeById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#prototype$updateAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Role#modelName
        * @propertyOf lbServices.Role
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role`.
        */
        R.modelName = "Role";

    /**
     * @ngdoc object
     * @name lbServices.Role.principals
     * @header lbServices.Role.principals
     * @object
     * @description
     *
     * The object `Role.principals` groups methods
     * manipulating `RoleMapping` instances related to `Role`.
     *
     * Call {@link lbServices.Role#principals Role.principals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Role#principals
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Queries principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::get::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#count
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Counts principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.principals.count = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::count::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#create
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.create = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::create::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#createMany
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.createMany = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::createMany::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyAll
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Deletes all principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyAll = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::delete::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Delete a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::destroyById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#findById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Find a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.findById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::findById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#updateById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Update a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.updateById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::updateById::Role::principals"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ACL
 * @header lbServices.ACL
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ACL` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ACL",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ACLs/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ACL#create
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ACLs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ACLs",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ACLs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#upsertWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ACLs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#exists
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ACLs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ACLs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ACLs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#find
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findOne
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ACLs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateAll
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ACLs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#deleteById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ACLs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#count
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ACLs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#prototype$patchAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ACLs/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createChangeStream
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ACLs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createMany
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ACL#upsert
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreateWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#update
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#destroyById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#removeById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#prototype$updateAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ACL#modelName
        * @propertyOf lbServices.ACL
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ACL`.
        */
        R.modelName = "ACL";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RoleMapping
 * @header lbServices.RoleMapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RoleMapping` model.
 *
 * **Details**
 *
 * Map principals to roles
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RoleMapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RoleMappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RoleMapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/RoleMappings/:id/role",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#create
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/RoleMappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#patchOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/RoleMappings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#replaceOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/RoleMappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#upsertWithWhere
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/RoleMappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#exists
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/RoleMappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#findById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/RoleMappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#replaceById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/RoleMappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#find
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RoleMappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#findOne
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/RoleMappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#updateAll
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/RoleMappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#deleteById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/RoleMappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#count
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/RoleMappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#prototype$patchAttributes
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/RoleMappings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#createChangeStream
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/RoleMappings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#createMany
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/RoleMappings",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.findById() instead.
            "::findById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "::destroyById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "::updateById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "::get::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "::create::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.createMany() instead.
            "::createMany::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "::delete::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "::count::Role::principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#upsert
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#updateOrCreate
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#patchOrCreateWithWhere
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#update
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#destroyById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#removeById
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#prototype$updateAttributes
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RoleMapping#modelName
        * @propertyOf lbServices.RoleMapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RoleMapping`.
        */
        R.modelName = "RoleMapping";


            /**
             * @ngdoc method
             * @name lbServices.RoleMapping#role
             * @methodOf lbServices.RoleMapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::RoleMapping::role"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AccessToken
 * @header lbServices.AccessToken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AccessToken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AccessToken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AccessTokens/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AccessToken.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#create
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/AccessTokens",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AccessTokens/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsertWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AccessTokens/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#exists
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AccessTokens/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AccessTokens/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AccessTokens/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#find
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findOne
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AccessTokens/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateAll
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AccessTokens/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#deleteById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AccessTokens/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#count
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AccessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#prototype$patchAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/AccessTokens/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createChangeStream
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AccessTokens/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createMany
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.findById() instead.
            "::findById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "::destroyById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "::updateById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "::get::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "::create::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.createMany() instead.
            "::createMany::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "::delete::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "::count::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsert
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreateWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#update
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#destroyById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#removeById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#prototype$updateAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AccessToken#modelName
        * @propertyOf lbServices.AccessToken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AccessToken`.
        */
        R.modelName = "AccessToken";


            /**
             * @ngdoc method
             * @name lbServices.AccessToken#user
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::AccessToken::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use User.accessTokens.findById() instead.
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.useraccount.findById() instead.
            "prototype$__findById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.destroyById() instead.
            "prototype$__destroyById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.updateById() instead.
            "prototype$__updateById__useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use User.roles() instead.
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "prototype$__create__roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "prototype$__delete__roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "prototype$__count__roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount() instead.
            "prototype$__get__useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.create() instead.
            "prototype$__create__useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.destroyAll() instead.
            "prototype$__delete__useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.count() instead.
            "prototype$__count__useraccount": {
              url: urlBase + "/users/:id/useraccount/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$verify
             * @methodOf lbServices.User
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/users/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/users/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#setPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/users/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            // INTERNAL. Use AccessToken.user() instead.
            "::get::AccessToken::user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Useraccount.fromuser() instead.
            "::get::Useraccount::fromuser": {
              url: urlBase + "/Useraccounts/:id/fromuser",
              method: "GET",
            },

            // INTERNAL. Use Employees.supervisor() instead.
            "::get::Employees::supervisor": {
              url: urlBase + "/Employees/:id/supervisor",
              method: "GET",
            },

            // INTERNAL. Use Employees.manager() instead.
            "::get::Employees::manager": {
              url: urlBase + "/Employees/:id/manager",
              method: "GET",
            },

            // INTERNAL. Use Employees.owner() instead.
            "::get::Employees::owner": {
              url: urlBase + "/Employees/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.user() instead.
            "::get::Usertransaction::user": {
              url: urlBase + "/Usertransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.transfer() instead.
            "::get::Usertransaction::transfer": {
              url: urlBase + "/Usertransactions/:id/transfer",
              method: "GET",
            },

            // INTERNAL. Use Supplier.user() instead.
            "::get::Supplier::user": {
              url: urlBase + "/Suppliers/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Partner.user() instead.
            "::get::Partner::user": {
              url: urlBase + "/Partners/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.user() instead.
            "::get::Usermapping::user": {
              url: urlBase + "/Usermappings/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Paylist.owner() instead.
            "::get::Paylist::owner": {
              url: urlBase + "/Paylists/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Paylist.shared() instead.
            "::get::Paylist::shared": {
              url: urlBase + "/Paylists/:id/shared",
              method: "GET",
            },

            // INTERNAL. Use Shop.user() instead.
            "::get::Shop::user": {
              url: urlBase + "/Shops/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.agent() instead.
            "::get::Machinesales::agent": {
              url: urlBase + "/Machinesales/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.agent() instead.
            "::get::Invoice::agent": {
              url: urlBase + "/Invoices/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.head() instead.
            "::get::Invoice::head": {
              url: urlBase + "/Invoices/:id/head",
              method: "GET",
            },

            // INTERNAL. Use InvoiceReceipt.approvalid() instead.
            "::get::InvoiceReceipt::approvalid": {
              url: urlBase + "/InvoiceReceipts/:id/approvalid",
              method: "GET",
            },

            // INTERNAL. Use Collector.user() instead.
            "::get::Collector::user": {
              url: urlBase + "/Collectors/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.head() instead.
            "::get::Collectormap::head": {
              url: urlBase + "/Collectormaps/:id/head",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.staff() instead.
            "::get::Collectormap::staff": {
              url: urlBase + "/Collectormaps/:id/staff",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.vip() instead.
            "::get::Collectormap::vip": {
              url: urlBase + "/Collectormaps/:id/vip",
              method: "GET",
            },

            // INTERNAL. Use PaparichPointApproval.user() instead.
            "::get::PaparichPointApproval::user": {
              url: urlBase + "/PaparichPointApprovals/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.accessTokens
     * @header lbServices.User.accessTokens
     * @object
     * @description
     *
     * The object `User.accessTokens` groups methods
     * manipulating `AccessToken` instances related to `User`.
     *
     * Call {@link lbServices.User#accessTokens User.accessTokens()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::get::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#count
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Counts accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.accessTokens.count = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::count::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#create
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.create = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::create::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#createMany
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.createMany = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::createMany::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyAll
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyAll = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::delete::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::destroyById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#findById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.findById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::findById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#updateById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.updateById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::updateById::User::accessTokens"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.roles
     * @header lbServices.User.roles
     * @object
     * @description
     *
     * The object `User.roles` groups methods
     * manipulating `Role` instances related to `User`.
     *
     * Call {@link lbServices.User#roles User.roles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#roles
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#count
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Counts roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roles.count = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::count::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#create
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.create = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::create::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#createMany
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.createMany = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::createMany::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyAll
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyAll = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::delete::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::destroyById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#exists
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.exists = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::exists::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#findById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.findById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::findById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#link
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.link = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::link::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#unlink
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.unlink = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::unlink::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#updateById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.updateById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::updateById::User::roles"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.useraccount
     * @header lbServices.User.useraccount
     * @object
     * @description
     *
     * The object `User.useraccount` groups methods
     * manipulating `Useraccount` instances related to `User`.
     *
     * Call {@link lbServices.User#useraccount User.useraccount()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#useraccount
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries useraccount of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::get::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#count
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Counts useraccount of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.useraccount.count = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::count::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#create
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Creates a new instance in useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.create = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::create::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#createMany
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Creates a new instance in useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.createMany = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::createMany::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#destroyAll
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Deletes all useraccount of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.useraccount.destroyAll = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::delete::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#destroyById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Delete a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.useraccount.destroyById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::destroyById::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#findById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Find a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.findById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::findById::User::useraccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.useraccount#updateById
             * @methodOf lbServices.User.useraccount
             *
             * @description
             *
             * Update a related item by id for useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for useraccount
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount.updateById = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::updateById::User::useraccount"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Useraccount
 * @header lbServices.Useraccount
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Useraccount` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Useraccount",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Useraccounts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Useraccount.fromuser() instead.
            "prototype$__get__fromuser": {
              url: urlBase + "/Useraccounts/:id/fromuser",
              method: "GET",
            },

            // INTERNAL. Use Useraccount.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Useraccounts/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#create
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Useraccounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#patchOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Useraccounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#replaceOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Useraccounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#upsertWithWhere
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Useraccounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#exists
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Useraccounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#findById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Useraccounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#replaceById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Useraccounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#find
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Useraccounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#findOne
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Useraccounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#updateAll
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Useraccounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#deleteById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Useraccounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#count
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Useraccounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#prototype$patchAttributes
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Useraccounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#createChangeStream
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Useraccounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#tokenByRole
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roleId` – `{integer=}` -
             *
             *  - `realm` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "tokenByRole": {
              url: urlBase + "/Useraccounts/tokenByRole",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#getCategoryWiseReport
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userid` – `{*=}` -
             *
             *  - `month` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getCategoryWiseReport": {
              url: urlBase + "/Useraccounts/getCategoryWiseReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#getIncomeExpenseReport
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userid` – `{*=}` -
             *
             *  - `month` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getIncomeExpenseReport": {
              url: urlBase + "/Useraccounts/getIncomeExpenseReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#createMany
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Useraccounts",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.findById() instead.
            "::findById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.destroyById() instead.
            "::destroyById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.updateById() instead.
            "::updateById::User::useraccount": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/useraccount/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.useraccount() instead.
            "::get::User::useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "GET",
            },

            // INTERNAL. Use User.useraccount.create() instead.
            "::create::User::useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.createMany() instead.
            "::createMany::User::useraccount": {
              isArray: true,
              url: urlBase + "/users/:id/useraccount",
              method: "POST",
            },

            // INTERNAL. Use User.useraccount.destroyAll() instead.
            "::delete::User::useraccount": {
              url: urlBase + "/users/:id/useraccount",
              method: "DELETE",
            },

            // INTERNAL. Use User.useraccount.count() instead.
            "::count::User::useraccount": {
              url: urlBase + "/users/:id/useraccount/count",
              method: "GET",
            },

            // INTERNAL. Use Paylist.useraccount() instead.
            "::get::Paylist::useraccount": {
              url: urlBase + "/Paylists/:id/useraccount",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Useraccount#upsert
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#updateOrCreate
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#patchOrCreateWithWhere
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#update
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#destroyById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#removeById
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#prototype$updateAttributes
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Useraccount#modelName
        * @propertyOf lbServices.Useraccount
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Useraccount`.
        */
        R.modelName = "Useraccount";


            /**
             * @ngdoc method
             * @name lbServices.Useraccount#fromuser
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Fetches belongsTo relation fromuser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.fromuser = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Useraccount::fromuser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Useraccount#account
             * @methodOf lbServices.Useraccount
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Useraccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Useraccount::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Accounts
 * @header lbServices.Accounts
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Accounts` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Accounts",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Accounts#create
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Accounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Accounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsertWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Accounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#exists
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Accounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Accounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Accounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#find
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findOne
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Accounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateAll
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Accounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#deleteById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Accounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#count
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#prototype$patchAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Accounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createChangeStream
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Accounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createMany
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "POST",
            },

            // INTERNAL. Use Useraccount.account() instead.
            "::get::Useraccount::account": {
              url: urlBase + "/Useraccounts/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.account() instead.
            "::get::Usertransaction::account": {
              url: urlBase + "/Usertransactions/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Paylist.account() instead.
            "::get::Paylist::account": {
              url: urlBase + "/Paylists/:id/account",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsert
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreateWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#update
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#destroyById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#removeById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#prototype$updateAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Accounts#modelName
        * @propertyOf lbServices.Accounts
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Accounts`.
        */
        R.modelName = "Accounts";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.State
 * @header lbServices.State
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `State` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "State",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/States/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use State.areas.findById() instead.
            "prototype$__findById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.areas.destroyById() instead.
            "prototype$__destroyById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.updateById() instead.
            "prototype$__updateById__areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.sites.findById() instead.
            "prototype$__findById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.sites.destroyById() instead.
            "prototype$__destroyById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.updateById() instead.
            "prototype$__updateById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.zones.findById() instead.
            "prototype$__findById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.zones.destroyById() instead.
            "prototype$__destroyById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.zones.updateById() instead.
            "prototype$__updateById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.zonespr.findById() instead.
            "prototype$__findById__zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.zonespr.destroyById() instead.
            "prototype$__destroyById__zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.zonespr.updateById() instead.
            "prototype$__updateById__zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.areas() instead.
            "prototype$__get__areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "GET",
            },

            // INTERNAL. Use State.areas.create() instead.
            "prototype$__create__areas": {
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.destroyAll() instead.
            "prototype$__delete__areas": {
              url: urlBase + "/States/:id/areas",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.count() instead.
            "prototype$__count__areas": {
              url: urlBase + "/States/:id/areas/count",
              method: "GET",
            },

            // INTERNAL. Use State.sites() instead.
            "prototype$__get__sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use State.sites.create() instead.
            "prototype$__create__sites": {
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.destroyAll() instead.
            "prototype$__delete__sites": {
              url: urlBase + "/States/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.count() instead.
            "prototype$__count__sites": {
              url: urlBase + "/States/:id/sites/count",
              method: "GET",
            },

            // INTERNAL. Use State.zones() instead.
            "prototype$__get__zones": {
              isArray: true,
              url: urlBase + "/States/:id/zones",
              method: "GET",
            },

            // INTERNAL. Use State.zones.create() instead.
            "prototype$__create__zones": {
              url: urlBase + "/States/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use State.zones.destroyAll() instead.
            "prototype$__delete__zones": {
              url: urlBase + "/States/:id/zones",
              method: "DELETE",
            },

            // INTERNAL. Use State.zones.count() instead.
            "prototype$__count__zones": {
              url: urlBase + "/States/:id/zones/count",
              method: "GET",
            },

            // INTERNAL. Use State.zonespr() instead.
            "prototype$__get__zonespr": {
              isArray: true,
              url: urlBase + "/States/:id/zonespr",
              method: "GET",
            },

            // INTERNAL. Use State.zonespr.create() instead.
            "prototype$__create__zonespr": {
              url: urlBase + "/States/:id/zonespr",
              method: "POST",
            },

            // INTERNAL. Use State.zonespr.destroyAll() instead.
            "prototype$__delete__zonespr": {
              url: urlBase + "/States/:id/zonespr",
              method: "DELETE",
            },

            // INTERNAL. Use State.zonespr.count() instead.
            "prototype$__count__zonespr": {
              url: urlBase + "/States/:id/zonespr/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#create
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/States",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/States",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/States/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#upsertWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/States/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#exists
             * @methodOf lbServices.State
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/States/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/States/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/States/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#find
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/States",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findOne
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/States/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#updateAll
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/States/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#deleteById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/States/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#count
             * @methodOf lbServices.State
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/States/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#prototype$patchAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/States/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createChangeStream
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/States/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createMany
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/States",
              method: "POST",
            },

            // INTERNAL. Use Area.state() instead.
            "::get::Area::state": {
              url: urlBase + "/Areas/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Site.state() instead.
            "::get::Site::state": {
              url: urlBase + "/Sites/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Summon.state() instead.
            "::get::Summon::state": {
              url: urlBase + "/Summons/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Department.state() instead.
            "::get::Department::state": {
              url: urlBase + "/Departments/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Zones.state() instead.
            "::get::Zones::state": {
              url: urlBase + "/Zones/:id/state",
              method: "GET",
            },

            // INTERNAL. Use ZonesPR.state() instead.
            "::get::ZonesPR::state": {
              url: urlBase + "/ZonesPRs/:id/state",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.State#upsert
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.State#updateOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreateWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.State#update
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.State#destroyById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#removeById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#prototype$updateAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.State#modelName
        * @propertyOf lbServices.State
        * @description
        * The name of the model represented by this $resource,
        * i.e. `State`.
        */
        R.modelName = "State";

    /**
     * @ngdoc object
     * @name lbServices.State.areas
     * @header lbServices.State.areas
     * @object
     * @description
     *
     * The object `State.areas` groups methods
     * manipulating `Area` instances related to `State`.
     *
     * Call {@link lbServices.State#areas State.areas()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#areas
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries areas of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#count
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Counts areas of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.areas.count = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::count::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#create
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Creates a new instance in areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.create = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::create::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#createMany
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Creates a new instance in areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.createMany = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::createMany::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#destroyAll
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Deletes all areas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.areas.destroyAll = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::delete::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#destroyById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Delete a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.areas.destroyById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::destroyById::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#findById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Find a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.findById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::findById::State::areas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.areas#updateById
             * @methodOf lbServices.State.areas
             *
             * @description
             *
             * Update a related item by id for areas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for areas
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.areas.updateById = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::updateById::State::areas"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.State.sites
     * @header lbServices.State.sites
     * @object
     * @description
     *
     * The object `State.sites` groups methods
     * manipulating `Site` instances related to `State`.
     *
     * Call {@link lbServices.State#sites State.sites()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#sites
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries sites of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#count
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Counts sites of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sites.count = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::count::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#create
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.create = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::create::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#createMany
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.createMany = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::createMany::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#destroyAll
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Deletes all sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyAll = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::delete::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#destroyById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Delete a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::destroyById::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#findById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Find a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.findById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::findById::State::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.sites#updateById
             * @methodOf lbServices.State.sites
             *
             * @description
             *
             * Update a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.updateById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::updateById::State::sites"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.State.zones
     * @header lbServices.State.zones
     * @object
     * @description
     *
     * The object `State.zones` groups methods
     * manipulating `Zones` instances related to `State`.
     *
     * Call {@link lbServices.State#zones State.zones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#zones
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries zones of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#count
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Counts zones of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.zones.count = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::count::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#create
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Creates a new instance in zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.create = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::create::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#createMany
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Creates a new instance in zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.createMany = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::createMany::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#destroyAll
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Deletes all zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zones.destroyAll = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::delete::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#destroyById
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Delete a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zones.destroyById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::destroyById::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#findById
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Find a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.findById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::findById::State::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zones#updateById
             * @methodOf lbServices.State.zones
             *
             * @description
             *
             * Update a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.updateById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::updateById::State::zones"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.State.zonespr
     * @header lbServices.State.zonespr
     * @object
     * @description
     *
     * The object `State.zonespr` groups methods
     * manipulating `ZonesPR` instances related to `State`.
     *
     * Call {@link lbServices.State#zonespr State.zonespr()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.State#zonespr
             * @methodOf lbServices.State
             *
             * @description
             *
             * Queries zonespr of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonespr = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::get::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#count
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Counts zonespr of State.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.zonespr.count = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::count::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#create
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Creates a new instance in zonespr of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonespr.create = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::create::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#createMany
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Creates a new instance in zonespr of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonespr.createMany = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::createMany::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#destroyAll
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Deletes all zonespr of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zonespr.destroyAll = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::delete::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#destroyById
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Delete a related item by id for zonespr.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zonespr
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zonespr.destroyById = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::destroyById::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#findById
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Find a related item by id for zonespr.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zonespr
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonespr.findById = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::findById::State::zonespr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.State.zonespr#updateById
             * @methodOf lbServices.State.zonespr
             *
             * @description
             *
             * Update a related item by id for zonespr.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             *  - `fk` – `{*}` - Foreign key for zonespr
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonespr.updateById = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::updateById::State::zonespr"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ShopCategory
 * @header lbServices.ShopCategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ShopCategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ShopCategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ShopCategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ShopCategory.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use ShopCategory.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ShopCategory.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ShopCategory.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/ShopCategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use ShopCategory.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/ShopCategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use ShopCategory.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/ShopCategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use ShopCategory.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/ShopCategories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#create
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ShopCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#patchOrCreate
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ShopCategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#replaceOrCreate
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ShopCategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#upsertWithWhere
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ShopCategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#exists
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ShopCategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#findById
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ShopCategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#replaceById
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ShopCategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#find
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ShopCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#findOne
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ShopCategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#updateAll
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ShopCategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#deleteById
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ShopCategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#count
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ShopCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#prototype$patchAttributes
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ShopCategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#createChangeStream
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ShopCategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#getShopCategoryInvoice
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `date` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getShopCategoryInvoice": {
              url: urlBase + "/ShopCategories/getShopCategoryInvoice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#createMany
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ShopCategories",
              method: "POST",
            },

            // INTERNAL. Use Shop.category() instead.
            "::get::Shop::category": {
              url: urlBase + "/Shops/:id/category",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#upsert
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#updateOrCreate
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#patchOrCreateWithWhere
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#update
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#destroyById
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#removeById
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#prototype$updateAttributes
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ShopCategory#modelName
        * @propertyOf lbServices.ShopCategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ShopCategory`.
        */
        R.modelName = "ShopCategory";

    /**
     * @ngdoc object
     * @name lbServices.ShopCategory.subs
     * @header lbServices.ShopCategory.subs
     * @object
     * @description
     *
     * The object `ShopCategory.subs` groups methods
     * manipulating `Shop` instances related to `ShopCategory`.
     *
     * Call {@link lbServices.ShopCategory#subs ShopCategory.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ShopCategory#subs
             * @methodOf lbServices.ShopCategory
             *
             * @description
             *
             * Queries subs of ShopCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#count
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Counts subs of ShopCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::count::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#create
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::create::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#createMany
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::createMany::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#destroyAll
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::delete::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#destroyById
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::destroyById::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#findById
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::findById::ShopCategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ShopCategory.subs#updateById
             * @methodOf lbServices.ShopCategory.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopCategory id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::updateById::ShopCategory::subs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Area
 * @header lbServices.Area
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Area` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Area",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Areas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Area.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Areas/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.findById() instead.
            "prototype$__findById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.destroyById() instead.
            "prototype$__destroyById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.updateById() instead.
            "prototype$__updateById__sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Area.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Areas/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Area.sites() instead.
            "prototype$__get__sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.create() instead.
            "prototype$__create__sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.destroyAll() instead.
            "prototype$__delete__sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.count() instead.
            "prototype$__count__sites": {
              url: urlBase + "/Areas/:id/sites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#create
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Areas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Areas",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Areas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#upsertWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Areas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#exists
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Areas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Areas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Areas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#find
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findOne
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Areas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#updateAll
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Areas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#deleteById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Areas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#count
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Areas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#prototype$patchAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Areas/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createChangeStream
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Areas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createMany
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.findById() instead.
            "::findById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.areas.destroyById() instead.
            "::destroyById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.updateById() instead.
            "::updateById::State::areas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/areas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.areas() instead.
            "::get::State::areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "GET",
            },

            // INTERNAL. Use State.areas.create() instead.
            "::create::State::areas": {
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.createMany() instead.
            "::createMany::State::areas": {
              isArray: true,
              url: urlBase + "/States/:id/areas",
              method: "POST",
            },

            // INTERNAL. Use State.areas.destroyAll() instead.
            "::delete::State::areas": {
              url: urlBase + "/States/:id/areas",
              method: "DELETE",
            },

            // INTERNAL. Use State.areas.count() instead.
            "::count::State::areas": {
              url: urlBase + "/States/:id/areas/count",
              method: "GET",
            },

            // INTERNAL. Use Summon.area() instead.
            "::get::Summon::area": {
              url: urlBase + "/Summons/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Employees.area() instead.
            "::get::Employees::area": {
              url: urlBase + "/Employees/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Department.area() instead.
            "::get::Department::area": {
              url: urlBase + "/Departments/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.area() instead.
            "::get::Usermapping::area": {
              url: urlBase + "/Usermappings/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Shop.area() instead.
            "::get::Shop::area": {
              url: urlBase + "/Shops/:id/area",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Area#upsert
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Area#updateOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreateWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Area#update
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Area#destroyById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#removeById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#prototype$updateAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Area#modelName
        * @propertyOf lbServices.Area
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Area`.
        */
        R.modelName = "Area";


            /**
             * @ngdoc method
             * @name lbServices.Area#state
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Area::state"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Area.sites
     * @header lbServices.Area.sites
     * @object
     * @description
     *
     * The object `Area.sites` groups methods
     * manipulating `Site` instances related to `Area`.
     *
     * Call {@link lbServices.Area#sites Area.sites()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Area#sites
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Queries sites of Area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#count
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Counts sites of Area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sites.count = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::count::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#create
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.create = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::create::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#createMany
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Creates a new instance in sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.createMany = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::createMany::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#destroyAll
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Deletes all sites of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyAll = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::delete::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#destroyById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Delete a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sites.destroyById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::destroyById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#findById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Find a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.findById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::findById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area.sites#updateById
             * @methodOf lbServices.Area.sites
             *
             * @description
             *
             * Update a related item by id for sites.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `fk` – `{*}` - Foreign key for sites
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.sites.updateById = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::updateById::Area::sites"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Area#zone
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Area::zone"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Site
 * @header lbServices.Site
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Site` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Site",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Sites/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Site.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Sites/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Site.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Sites/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Site.zonepr() instead.
            "prototype$__get__zonepr": {
              url: urlBase + "/Sites/:id/zonepr",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#create
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Sites",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#patchOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Sites",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#replaceOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Sites/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#upsertWithWhere
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Sites/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#exists
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Sites/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#findById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Sites/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#replaceById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Sites/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#find
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Sites",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#findOne
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Sites/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#updateAll
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Sites/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#deleteById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Sites/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#count
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Sites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#prototype$patchAttributes
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Sites/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#createChangeStream
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Sites/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Site#createMany
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.findById() instead.
            "::findById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.sites.destroyById() instead.
            "::destroyById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.updateById() instead.
            "::updateById::State::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.sites() instead.
            "::get::State::sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use State.sites.create() instead.
            "::create::State::sites": {
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.createMany() instead.
            "::createMany::State::sites": {
              isArray: true,
              url: urlBase + "/States/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use State.sites.destroyAll() instead.
            "::delete::State::sites": {
              url: urlBase + "/States/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use State.sites.count() instead.
            "::count::State::sites": {
              url: urlBase + "/States/:id/sites/count",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.findById() instead.
            "::findById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.destroyById() instead.
            "::destroyById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.updateById() instead.
            "::updateById::Area::sites": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Areas/:id/sites/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Area.sites() instead.
            "::get::Area::sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "GET",
            },

            // INTERNAL. Use Area.sites.create() instead.
            "::create::Area::sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.createMany() instead.
            "::createMany::Area::sites": {
              isArray: true,
              url: urlBase + "/Areas/:id/sites",
              method: "POST",
            },

            // INTERNAL. Use Area.sites.destroyAll() instead.
            "::delete::Area::sites": {
              url: urlBase + "/Areas/:id/sites",
              method: "DELETE",
            },

            // INTERNAL. Use Area.sites.count() instead.
            "::count::Area::sites": {
              url: urlBase + "/Areas/:id/sites/count",
              method: "GET",
            },

            // INTERNAL. Use Projects.site() instead.
            "::get::Projects::site": {
              url: urlBase + "/Projects/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Summon.site() instead.
            "::get::Summon::site": {
              url: urlBase + "/Summons/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Employees.site() instead.
            "::get::Employees::site": {
              url: urlBase + "/Employees/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.site() instead.
            "::get::Usertransaction::site": {
              url: urlBase + "/Usertransactions/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Shop.site() instead.
            "::get::Shop::site": {
              url: urlBase + "/Shops/:id/site",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Site#upsert
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Site#updateOrCreate
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Site#patchOrCreateWithWhere
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Site#update
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Site#destroyById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Site#removeById
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Site#prototype$updateAttributes
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Site#modelName
        * @propertyOf lbServices.Site
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Site`.
        */
        R.modelName = "Site";


            /**
             * @ngdoc method
             * @name lbServices.Site#state
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Site::state"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Site#zone
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Site::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Site#zonepr
             * @methodOf lbServices.Site
             *
             * @description
             *
             * Fetches belongsTo relation zonepr.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Site id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonepr = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::get::Site::zonepr"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Projects
 * @header lbServices.Projects
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Projects` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Projects",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Projects/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Projects.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Projects/:id/site",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#create
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Projects",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#patchOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Projects",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#replaceOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Projects/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#upsertWithWhere
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Projects/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#exists
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Projects/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#findById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Projects/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#replaceById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Projects/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#find
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#findOne
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Projects/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#updateAll
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Projects/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#deleteById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Projects/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#count
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Projects/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#prototype$patchAttributes
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Projects/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#createChangeStream
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Projects/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Projects#createMany
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "POST",
            },

            // INTERNAL. Use Assets.project() instead.
            "::get::Assets::project": {
              url: urlBase + "/Assets/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Cctv.project() instead.
            "::get::Cctv::project": {
              url: urlBase + "/Cctvs/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Employees.project() instead.
            "::get::Employees::project": {
              url: urlBase + "/Employees/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.project() instead.
            "::get::Usertransaction::project": {
              url: urlBase + "/Usertransactions/:id/project",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Projects#upsert
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#updateOrCreate
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#patchOrCreateWithWhere
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#update
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#destroyById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#removeById
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Projects#prototype$updateAttributes
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Projects#modelName
        * @propertyOf lbServices.Projects
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Projects`.
        */
        R.modelName = "Projects";


            /**
             * @ngdoc method
             * @name lbServices.Projects#site
             * @methodOf lbServices.Projects
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Projects id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Projects::site"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Assets
 * @header lbServices.Assets
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Assets` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Assets",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Assets/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Assets.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Assets/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#create
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Assets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#patchOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Assets",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#replaceOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Assets/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#upsertWithWhere
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Assets/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#exists
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Assets/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#findById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Assets/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#replaceById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Assets/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#find
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Assets",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#findOne
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Assets/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#updateAll
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Assets/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#deleteById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Assets/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#count
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Assets/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#prototype$patchAttributes
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Assets/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#createChangeStream
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Assets/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assets#createMany
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Assets",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Assets#upsert
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#updateOrCreate
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#patchOrCreateWithWhere
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#update
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#destroyById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#removeById
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assets#prototype$updateAttributes
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assets` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Assets#modelName
        * @propertyOf lbServices.Assets
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Assets`.
        */
        R.modelName = "Assets";


            /**
             * @ngdoc method
             * @name lbServices.Assets#project
             * @methodOf lbServices.Assets
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assets id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Assets::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cctv
 * @header lbServices.Cctv
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cctv` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cctv",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cctvs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cctv.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Cctvs/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#create
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cctvs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#patchOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Cctvs",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#replaceOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cctvs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#upsertWithWhere
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cctvs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#exists
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cctvs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#findById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cctvs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#replaceById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cctvs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#find
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cctvs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#findOne
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cctvs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#updateAll
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cctvs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#deleteById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cctvs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#count
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cctvs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#prototype$patchAttributes
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Cctvs/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#createChangeStream
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cctvs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cctv#createMany
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cctvs",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cctv#upsert
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#updateOrCreate
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#patchOrCreateWithWhere
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#update
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#destroyById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#removeById
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cctv#prototype$updateAttributes
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cctv` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cctv#modelName
        * @propertyOf lbServices.Cctv
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cctv`.
        */
        R.modelName = "Cctv";


            /**
             * @ngdoc method
             * @name lbServices.Cctv#project
             * @methodOf lbServices.Cctv
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cctv id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Cctv::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Emprate
 * @header lbServices.Emprate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Emprate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Emprate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emprates/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Emprate#create
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Emprates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#patchOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Emprates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#replaceOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Emprates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#upsertWithWhere
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Emprates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#exists
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Emprates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#findById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Emprates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#replaceById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Emprates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#find
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Emprates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#findOne
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Emprates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#updateAll
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Emprates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#deleteById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Emprates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#count
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Emprates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#prototype$patchAttributes
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Emprate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Emprates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#createChangeStream
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Emprates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Emprate#createMany
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Emprates",
              method: "POST",
            },

            // INTERNAL. Use Employees.emprate() instead.
            "::get::Employees::emprate": {
              url: urlBase + "/Employees/:id/emprate",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Emprate#upsert
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#updateOrCreate
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#patchOrCreateWithWhere
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#update
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#destroyById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#removeById
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Emprate#prototype$updateAttributes
             * @methodOf lbServices.Emprate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Emprate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Emprate#modelName
        * @propertyOf lbServices.Emprate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Emprate`.
        */
        R.modelName = "Emprate";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Maincategory
 * @header lbServices.Maincategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Maincategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Maincategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Maincategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Maincategory.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Maincategory.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/Maincategories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#create
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Maincategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Maincategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsertWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Maincategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#exists
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Maincategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Maincategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Maincategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#find
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findOne
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Maincategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateAll
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Maincategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#deleteById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Maincategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#count
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Maincategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#prototype$patchAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Maincategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createChangeStream
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Maincategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createMany
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            // INTERNAL. Use Category.main() instead.
            "::get::Category::main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.main() instead.
            "::get::Usertransaction::main": {
              url: urlBase + "/Usertransactions/:id/main",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsert
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreateWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#update
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#destroyById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#removeById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#prototype$updateAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Maincategory#modelName
        * @propertyOf lbServices.Maincategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Maincategory`.
        */
        R.modelName = "Maincategory";

    /**
     * @ngdoc object
     * @name lbServices.Maincategory.subs
     * @header lbServices.Maincategory.subs
     * @object
     * @description
     *
     * The object `Maincategory.subs` groups methods
     * manipulating `Category` instances related to `Maincategory`.
     *
     * Call {@link lbServices.Maincategory#subs Maincategory.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Maincategory#subs
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Queries subs of Maincategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#count
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Counts subs of Maincategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#create
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#createMany
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#destroyAll
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#destroyById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#findById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Maincategory::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Maincategory.subs#updateById
             * @methodOf lbServices.Maincategory.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Maincategory::subs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Categories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Category.main() instead.
            "prototype$__get__main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Category.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Categories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Categories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Categories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsertWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Categories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#exists
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Categories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Categories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Categories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findOne
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Categories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#updateAll
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Categories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#deleteById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Categories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Categories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createChangeStream
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Categories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.findById() instead.
            "::findById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.destroyById() instead.
            "::destroyById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.updateById() instead.
            "::updateById::Maincategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Maincategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Maincategory.subs() instead.
            "::get::Maincategory::subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Maincategory.subs.create() instead.
            "::create::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.createMany() instead.
            "::createMany::Maincategory::subs": {
              isArray: true,
              url: urlBase + "/Maincategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Maincategory.subs.destroyAll() instead.
            "::delete::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Maincategory.subs.count() instead.
            "::count::Maincategory::subs": {
              url: urlBase + "/Maincategories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Category.parent() instead.
            "::get::Category::parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "::findById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "::destroyById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "::updateById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.subs() instead.
            "::get::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "::create::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.createMany() instead.
            "::createMany::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "::delete::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "::count::Category::subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.category() instead.
            "::get::Usertransaction::category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.parent() instead.
            "::get::Usertransaction::parent": {
              url: urlBase + "/Usertransactions/:id/parent",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#upsert
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Category#updateOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreateWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Category#update
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#removeById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";


            /**
             * @ngdoc method
             * @name lbServices.Category#main
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation main.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R.main = function() {
          var TargetResource = $injector.get("Maincategory");
          var action = TargetResource["::get::Category::main"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category#parent
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::parent"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Category.subs
     * @header lbServices.Category.subs
     * @object
     * @description
     *
     * The object `Category.subs` groups methods
     * manipulating `Category` instances related to `Category`.
     *
     * Call {@link lbServices.Category#subs Category.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Category#subs
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Queries subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#count
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Counts subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#create
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#createMany
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyAll
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#findById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#updateById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Category::subs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Receipts
 * @header lbServices.Receipts
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Receipts` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Receipts",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Receipts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Receipts#create
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Receipts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#patchOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Receipts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#replaceOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Receipts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#upsertWithWhere
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Receipts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#exists
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Receipts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#findById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Receipts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#replaceById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Receipts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#find
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#findOne
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Receipts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#updateAll
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Receipts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#deleteById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Receipts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#count
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Receipts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#prototype$patchAttributes
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipts id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Receipts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#createChangeStream
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Receipts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipts#createMany
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.receipt() instead.
            "::get::Usertransaction::receipt": {
              url: urlBase + "/Usertransactions/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.receipt() instead.
            "::get::Machinesales::receipt": {
              url: urlBase + "/Machinesales/:id/receipt",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Receipts#upsert
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#updateOrCreate
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#patchOrCreateWithWhere
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#update
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#destroyById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#removeById
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipts#prototype$updateAttributes
             * @methodOf lbServices.Receipts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipts id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Receipts#modelName
        * @propertyOf lbServices.Receipts
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Receipts`.
        */
        R.modelName = "Receipts";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Summoncategory
 * @header lbServices.Summoncategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Summoncategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Summoncategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Summoncategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Summoncategory.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Summoncategories/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#create
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Summoncategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#patchOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Summoncategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#replaceOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Summoncategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#upsertWithWhere
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Summoncategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#exists
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Summoncategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#findById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Summoncategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#replaceById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Summoncategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#find
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Summoncategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#findOne
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Summoncategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#updateAll
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Summoncategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#deleteById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Summoncategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#count
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Summoncategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#prototype$patchAttributes
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Summoncategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#createChangeStream
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Summoncategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#createMany
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Summoncategories",
              method: "POST",
            },

            // INTERNAL. Use Summoncategory.parent() instead.
            "::get::Summoncategory::parent": {
              url: urlBase + "/Summoncategories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.sumcat() instead.
            "::get::Usertransaction::sumcat": {
              url: urlBase + "/Usertransactions/:id/sumcat",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#upsert
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#updateOrCreate
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#patchOrCreateWithWhere
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#update
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#destroyById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#removeById
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#prototype$updateAttributes
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Summoncategory#modelName
        * @propertyOf lbServices.Summoncategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Summoncategory`.
        */
        R.modelName = "Summoncategory";


            /**
             * @ngdoc method
             * @name lbServices.Summoncategory#parent
             * @methodOf lbServices.Summoncategory
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summoncategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Summoncategory");
          var action = TargetResource["::get::Summoncategory::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Summon
 * @header lbServices.Summon
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Summon` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Summon",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Summons/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Summon.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Summons/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Summon.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Summons/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Summon.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Summons/:id/state",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#create
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Summons",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#patchOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Summons",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#replaceOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Summons/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#upsertWithWhere
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Summons/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#exists
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Summons/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#findById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Summons/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#replaceById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Summons/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#find
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Summons",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#findOne
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Summons/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#updateAll
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Summons/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#deleteById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Summons/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#count
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Summons/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#prototype$patchAttributes
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Summons/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#createChangeStream
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Summons/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Summon#createMany
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Summons",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.summon() instead.
            "::get::Usertransaction::summon": {
              url: urlBase + "/Usertransactions/:id/summon",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Summon#upsert
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#updateOrCreate
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#patchOrCreateWithWhere
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#update
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#destroyById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#removeById
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Summon#prototype$updateAttributes
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Summon#modelName
        * @propertyOf lbServices.Summon
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Summon`.
        */
        R.modelName = "Summon";


            /**
             * @ngdoc method
             * @name lbServices.Summon#site
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Summon::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Summon#area
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Summon::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Summon#state
             * @methodOf lbServices.Summon
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Summon id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Summon::state"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Employees
 * @header lbServices.Employees
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Employees` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Employees",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Employees/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Employees.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Employees/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Employees.emprate() instead.
            "prototype$__get__emprate": {
              url: urlBase + "/Employees/:id/emprate",
              method: "GET",
            },

            // INTERNAL. Use Employees.supervisor() instead.
            "prototype$__get__supervisor": {
              url: urlBase + "/Employees/:id/supervisor",
              method: "GET",
            },

            // INTERNAL. Use Employees.manager() instead.
            "prototype$__get__manager": {
              url: urlBase + "/Employees/:id/manager",
              method: "GET",
            },

            // INTERNAL. Use Employees.owner() instead.
            "prototype$__get__owner": {
              url: urlBase + "/Employees/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Employees.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Employees/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Employees.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Employees/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Employees.department() instead.
            "prototype$__get__department": {
              url: urlBase + "/Employees/:id/department",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#create
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Employees",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#patchOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Employees",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#replaceOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Employees/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#upsertWithWhere
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Employees/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#exists
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Employees/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#findById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Employees/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#replaceById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Employees/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#find
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#findOne
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Employees/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#updateAll
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Employees/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#deleteById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Employees/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#count
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Employees/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#prototype$patchAttributes
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Employees/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#createChangeStream
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Employees/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummary
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummary": {
              url: urlBase + "/Employees/officerSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL1
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL1": {
              url: urlBase + "/Employees/officerSummaryL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL2
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             *  - `areaid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL2": {
              url: urlBase + "/Employees/officerSummaryL2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#officerSummaryL3
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ownerid` – `{string=}` -
             *
             *  - `areaid` – `{string=}` -
             *
             *  - `siteid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "officerSummaryL3": {
              url: urlBase + "/Employees/officerSummaryL3",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employees#createMany
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.employee() instead.
            "::get::Usertransaction::employee": {
              url: urlBase + "/Usertransactions/:id/employee",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Employees#upsert
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#updateOrCreate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#patchOrCreateWithWhere
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#update
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#destroyById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#removeById
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employees#prototype$updateAttributes
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Employees#modelName
        * @propertyOf lbServices.Employees
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Employees`.
        */
        R.modelName = "Employees";


            /**
             * @ngdoc method
             * @name lbServices.Employees#project
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Employees::project"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#emprate
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation emprate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Emprate` object.)
             * </em>
             */
        R.emprate = function() {
          var TargetResource = $injector.get("Emprate");
          var action = TargetResource["::get::Employees::emprate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#supervisor
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation supervisor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.supervisor = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::supervisor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#manager
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation manager.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.manager = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#owner
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation owner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.owner = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Employees::owner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#site
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Employees::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#area
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Employees::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employees#department
             * @methodOf lbServices.Employees
             *
             * @description
             *
             * Fetches belongsTo relation department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employees id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.department = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Employees::department"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Department
 * @header lbServices.Department
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Department` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Department",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Departments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Department.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Departments/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Department.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Departments/:id/area",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#create
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Departments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#patchOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Departments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#replaceOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Departments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#upsertWithWhere
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Departments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#exists
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Departments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#findById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Departments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#replaceById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Departments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#find
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Departments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#findOne
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Departments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#updateAll
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Departments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#deleteById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Departments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#count
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Departments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$patchAttributes
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Departments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#createChangeStream
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Departments/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#createMany
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Departments",
              method: "POST",
            },

            // INTERNAL. Use Employees.department() instead.
            "::get::Employees::department": {
              url: urlBase + "/Employees/:id/department",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Department#upsert
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Department#updateOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Department#patchOrCreateWithWhere
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Department#update
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Department#destroyById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Department#removeById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$updateAttributes
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Department#modelName
        * @propertyOf lbServices.Department
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Department`.
        */
        R.modelName = "Department";


            /**
             * @ngdoc method
             * @name lbServices.Department#state
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Department::state"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department#area
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Department id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Department::area"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usertransaction
 * @header lbServices.Usertransaction
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usertransaction` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usertransaction",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Usertransactions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usertransaction.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Usertransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Usertransactions/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.summon() instead.
            "prototype$__get__summon": {
              url: urlBase + "/Usertransactions/:id/summon",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Usertransactions/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Usertransactions/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.main() instead.
            "prototype$__get__main": {
              url: urlBase + "/Usertransactions/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Usertransactions/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Usertransactions/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/Usertransactions/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.sumcat() instead.
            "prototype$__get__sumcat": {
              url: urlBase + "/Usertransactions/:id/sumcat",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.transfer() instead.
            "prototype$__get__transfer": {
              url: urlBase + "/Usertransactions/:id/transfer",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.findById() instead.
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.destroyById() instead.
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.updateById() instead.
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.link() instead.
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usertransaction.roles.unlink() instead.
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.exists() instead.
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Usertransactions/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Usertransaction.paylist() instead.
            "prototype$__get__paylist": {
              url: urlBase + "/Usertransactions/:id/paylist",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles() instead.
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/Usertransactions/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.roles.create() instead.
            "prototype$__create__roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.roles.destroyAll() instead.
            "prototype$__delete__roles": {
              url: urlBase + "/Usertransactions/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use Usertransaction.roles.count() instead.
            "prototype$__count__roles": {
              url: urlBase + "/Usertransactions/:id/roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#create
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Usertransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Usertransactions",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Usertransactions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsertWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Usertransactions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#exists
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Usertransactions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Usertransactions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Usertransactions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#find
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findOne
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Usertransactions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateAll
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Usertransactions/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#deleteById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Usertransactions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#count
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Usertransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#prototype$patchAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Usertransactions/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createChangeStream
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Usertransactions/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createMany
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsert
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreateWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#update
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#destroyById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#removeById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#prototype$updateAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Usertransaction#modelName
        * @propertyOf lbServices.Usertransaction
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usertransaction`.
        */
        R.modelName = "Usertransaction";


            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#user
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usertransaction::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#project
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Projects` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Projects");
          var action = TargetResource["::get::Usertransaction::project"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#summon
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation summon.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summon` object.)
             * </em>
             */
        R.summon = function() {
          var TargetResource = $injector.get("Summon");
          var action = TargetResource["::get::Usertransaction::summon"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#employee
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employees` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employees");
          var action = TargetResource["::get::Usertransaction::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#account
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Usertransaction::account"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#category
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Usertransaction::category"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#main
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation main.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R.main = function() {
          var TargetResource = $injector.get("Maincategory");
          var action = TargetResource["::get::Usertransaction::main"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#parent
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Usertransaction::parent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#site
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Usertransaction::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#receipt
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipts");
          var action = TargetResource["::get::Usertransaction::receipt"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#sumcat
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation sumcat.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Summoncategory` object.)
             * </em>
             */
        R.sumcat = function() {
          var TargetResource = $injector.get("Summoncategory");
          var action = TargetResource["::get::Usertransaction::sumcat"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#transfer
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation transfer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.transfer = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usertransaction::transfer"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usertransaction.roles
     * @header lbServices.Usertransaction.roles
     * @object
     * @description
     *
     * The object `Usertransaction.roles` groups methods
     * manipulating `Role` instances related to `Usertransaction`.
     *
     * Call {@link lbServices.Usertransaction#roles Usertransaction.roles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#roles
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Queries roles of Usertransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#count
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Counts roles of Usertransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roles.count = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::count::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#create
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.create = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::create::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#createMany
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.createMany = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::createMany::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#destroyAll
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyAll = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::delete::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#destroyById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::destroyById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#exists
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.exists = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::exists::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#findById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.findById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::findById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#link
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.link = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::link::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#unlink
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.unlink = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::unlink::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction.roles#updateById
             * @methodOf lbServices.Usertransaction.roles
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.updateById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::updateById::Usertransaction::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#paylist
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation paylist.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R.paylist = function() {
          var TargetResource = $injector.get("Paylist");
          var action = TargetResource["::get::Usertransaction::paylist"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Gamecategory
 * @header lbServices.Gamecategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Gamecategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Gamecategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Gamecategories/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#create
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Gamecategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#patchOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Gamecategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#replaceOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Gamecategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#upsertWithWhere
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Gamecategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#exists
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Gamecategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#findById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Gamecategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#replaceById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Gamecategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#find
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Gamecategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#findOne
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Gamecategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#updateAll
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Gamecategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#deleteById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Gamecategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#count
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Gamecategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#prototype$patchAttributes
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Gamecategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Gamecategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#createChangeStream
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Gamecategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#createMany
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Gamecategories",
              method: "POST",
            },

            // INTERNAL. Use Games.gamecat() instead.
            "::get::Games::gamecat": {
              url: urlBase + "/Games/:id/gamecat",
              method: "GET",
            },

            // INTERNAL. Use Machine.gamecategory() instead.
            "::get::Machine::gamecategory": {
              url: urlBase + "/Machines/:id/gamecategory",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#upsert
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#updateOrCreate
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#patchOrCreateWithWhere
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#update
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#destroyById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#removeById
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Gamecategory#prototype$updateAttributes
             * @methodOf lbServices.Gamecategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Gamecategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Gamecategory#modelName
        * @propertyOf lbServices.Gamecategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Gamecategory`.
        */
        R.modelName = "Gamecategory";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Games
 * @header lbServices.Games
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Games` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Games",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Games/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Games.gamecat() instead.
            "prototype$__get__gamecat": {
              url: urlBase + "/Games/:id/gamecat",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#create
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Games",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#patchOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Games",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#replaceOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Games/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#upsertWithWhere
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Games/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#exists
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Games/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#findById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Games/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#replaceById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Games/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#find
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Games",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#findOne
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Games/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#updateAll
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Games/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#deleteById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Games/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#count
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Games/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#prototype$patchAttributes
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Games/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#createChangeStream
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Games/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Games#createMany
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Games",
              method: "POST",
            },

            // INTERNAL. Use Onlineshop.game() instead.
            "::get::Onlineshop::game": {
              url: urlBase + "/Onlineshops/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.game() instead.
            "::get::Onlinesales::game": {
              url: urlBase + "/Onlinesales/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Machine.game() instead.
            "::get::Machine::game": {
              url: urlBase + "/Machines/:id/game",
              method: "GET",
            },

            // INTERNAL. Use GameProvider.game() instead.
            "::get::GameProvider::game": {
              url: urlBase + "/GameProviders/:id/game",
              method: "GET",
            },

            // INTERNAL. Use InternalServerOnlineSales.game() instead.
            "::get::InternalServerOnlineSales::game": {
              url: urlBase + "/InternalServerOnlineSales/:id/game",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Games#upsert
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Games#updateOrCreate
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Games#patchOrCreateWithWhere
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Games#update
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Games#destroyById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Games#removeById
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Games#prototype$updateAttributes
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Games#modelName
        * @propertyOf lbServices.Games
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Games`.
        */
        R.modelName = "Games";


            /**
             * @ngdoc method
             * @name lbServices.Games#gamecat
             * @methodOf lbServices.Games
             *
             * @description
             *
             * Fetches belongsTo relation gamecat.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Games id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R.gamecat = function() {
          var TargetResource = $injector.get("Gamecategory");
          var action = TargetResource["::get::Games::gamecat"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Zones
 * @header lbServices.Zones
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Zones` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Zones",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Zones/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Zones.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/Zones/:id/state",
              method: "GET",
            },

            // INTERNAL. Use Zones.bill.findById() instead.
            "prototype$__findById__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "GET",
            },

            // INTERNAL. Use Zones.bill.destroyById() instead.
            "prototype$__destroyById__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.updateById() instead.
            "prototype$__updateById__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Zones.bill.link() instead.
            "prototype$__link__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Zones.bill.unlink() instead.
            "prototype$__unlink__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.exists() instead.
            "prototype$__exists__bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Zones.bill() instead.
            "prototype$__get__bill": {
              isArray: true,
              url: urlBase + "/Zones/:id/bill",
              method: "GET",
            },

            // INTERNAL. Use Zones.bill.create() instead.
            "prototype$__create__bill": {
              url: urlBase + "/Zones/:id/bill",
              method: "POST",
            },

            // INTERNAL. Use Zones.bill.destroyAll() instead.
            "prototype$__delete__bill": {
              url: urlBase + "/Zones/:id/bill",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.count() instead.
            "prototype$__count__bill": {
              url: urlBase + "/Zones/:id/bill/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#create
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Zones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Zones",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Zones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#upsertWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Zones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#exists
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Zones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Zones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Zones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#find
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findOne
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Zones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateAll
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Zones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#deleteById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Zones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#count
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Zones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#prototype$patchAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Zones/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createChangeStream
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Zones/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createMany
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "POST",
            },

            // INTERNAL. Use State.zones.findById() instead.
            "::findById::State::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.zones.destroyById() instead.
            "::destroyById::State::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.zones.updateById() instead.
            "::updateById::State::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.zones() instead.
            "::get::State::zones": {
              isArray: true,
              url: urlBase + "/States/:id/zones",
              method: "GET",
            },

            // INTERNAL. Use State.zones.create() instead.
            "::create::State::zones": {
              url: urlBase + "/States/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use State.zones.createMany() instead.
            "::createMany::State::zones": {
              isArray: true,
              url: urlBase + "/States/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use State.zones.destroyAll() instead.
            "::delete::State::zones": {
              url: urlBase + "/States/:id/zones",
              method: "DELETE",
            },

            // INTERNAL. Use State.zones.count() instead.
            "::count::State::zones": {
              url: urlBase + "/States/:id/zones/count",
              method: "GET",
            },

            // INTERNAL. Use Area.zone() instead.
            "::get::Area::zone": {
              url: urlBase + "/Areas/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Site.zone() instead.
            "::get::Site::zone": {
              url: urlBase + "/Sites/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.zone() instead.
            "::get::Usermapping::zone": {
              url: urlBase + "/Usermappings/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Machine.zone() instead.
            "::get::Machine::zone": {
              url: urlBase + "/Machines/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Shop.zone() instead.
            "::get::Shop::zone": {
              url: urlBase + "/Shops/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Invoice.zone() instead.
            "::get::Invoice::zone": {
              url: urlBase + "/Invoices/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Bill.zones.findById() instead.
            "::findById::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Bill.zones.destroyById() instead.
            "::destroyById::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.updateById() instead.
            "::updateById::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.zones.link() instead.
            "::link::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.zones.unlink() instead.
            "::unlink::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.exists() instead.
            "::exists::Bill::zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Bill.zones() instead.
            "::get::Bill::zones": {
              isArray: true,
              url: urlBase + "/Bills/:id/zones",
              method: "GET",
            },

            // INTERNAL. Use Bill.zones.create() instead.
            "::create::Bill::zones": {
              url: urlBase + "/Bills/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use Bill.zones.createMany() instead.
            "::createMany::Bill::zones": {
              isArray: true,
              url: urlBase + "/Bills/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use Bill.zones.destroyAll() instead.
            "::delete::Bill::zones": {
              url: urlBase + "/Bills/:id/zones",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.count() instead.
            "::count::Bill::zones": {
              url: urlBase + "/Bills/:id/zones/count",
              method: "GET",
            },

            // INTERNAL. Use BillZones.zones() instead.
            "::get::BillZones::zones": {
              url: urlBase + "/BillZones/:id/zones",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Zones#upsert
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreateWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#update
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#destroyById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#removeById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#prototype$updateAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Zones#modelName
        * @propertyOf lbServices.Zones
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Zones`.
        */
        R.modelName = "Zones";


            /**
             * @ngdoc method
             * @name lbServices.Zones#state
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::Zones::state"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Zones.bill
     * @header lbServices.Zones.bill
     * @object
     * @description
     *
     * The object `Zones.bill` groups methods
     * manipulating `Bill` instances related to `Zones`.
     *
     * Call {@link lbServices.Zones#bill Zones.bill()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Zones#bill
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Queries bill of Zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::get::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#count
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Counts bill of Zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bill.count = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::count::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#create
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Creates a new instance in bill of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.create = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::create::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#createMany
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Creates a new instance in bill of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.createMany = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::createMany::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#destroyAll
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Deletes all bill of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bill.destroyAll = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::delete::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#destroyById
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Delete a related item by id for bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bill.destroyById = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::destroyById::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#exists
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Check the existence of bill relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.exists = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::exists::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#findById
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Find a related item by id for bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.findById = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::findById::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#link
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Add a related item by id for bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.link = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::link::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#unlink
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Remove the bill relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bill.unlink = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::unlink::Zones::bill"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Zones.bill#updateById
             * @methodOf lbServices.Zones.bill
             *
             * @description
             *
             * Update a related item by id for bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             *  - `fk` – `{*}` - Foreign key for bill
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill.updateById = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::updateById::Zones::bill"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ZonesPR
 * @header lbServices.ZonesPR
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ZonesPR` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ZonesPR",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ZonesPRs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ZonesPR.state() instead.
            "prototype$__get__state": {
              url: urlBase + "/ZonesPRs/:id/state",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#create
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ZonesPRs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#patchOrCreate
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ZonesPRs",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#replaceOrCreate
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ZonesPRs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#upsertWithWhere
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ZonesPRs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#exists
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ZonesPRs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#findById
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ZonesPRs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#replaceById
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ZonesPRs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#find
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ZonesPRs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#findOne
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ZonesPRs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#updateAll
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ZonesPRs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#deleteById
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ZonesPRs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#count
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ZonesPRs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#prototype$patchAttributes
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ZonesPR id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ZonesPRs/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#createChangeStream
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ZonesPRs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#createMany
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ZonesPRs",
              method: "POST",
            },

            // INTERNAL. Use State.zonespr.findById() instead.
            "::findById::State::zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "GET",
            },

            // INTERNAL. Use State.zonespr.destroyById() instead.
            "::destroyById::State::zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use State.zonespr.updateById() instead.
            "::updateById::State::zonespr": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/States/:id/zonespr/:fk",
              method: "PUT",
            },

            // INTERNAL. Use State.zonespr() instead.
            "::get::State::zonespr": {
              isArray: true,
              url: urlBase + "/States/:id/zonespr",
              method: "GET",
            },

            // INTERNAL. Use State.zonespr.create() instead.
            "::create::State::zonespr": {
              url: urlBase + "/States/:id/zonespr",
              method: "POST",
            },

            // INTERNAL. Use State.zonespr.createMany() instead.
            "::createMany::State::zonespr": {
              isArray: true,
              url: urlBase + "/States/:id/zonespr",
              method: "POST",
            },

            // INTERNAL. Use State.zonespr.destroyAll() instead.
            "::delete::State::zonespr": {
              url: urlBase + "/States/:id/zonespr",
              method: "DELETE",
            },

            // INTERNAL. Use State.zonespr.count() instead.
            "::count::State::zonespr": {
              url: urlBase + "/States/:id/zonespr/count",
              method: "GET",
            },

            // INTERNAL. Use Site.zonepr() instead.
            "::get::Site::zonepr": {
              url: urlBase + "/Sites/:id/zonepr",
              method: "GET",
            },

            // INTERNAL. Use Shop.zonepr() instead.
            "::get::Shop::zonepr": {
              url: urlBase + "/Shops/:id/zonepr",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#upsert
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#updateOrCreate
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#patchOrCreateWithWhere
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#update
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#destroyById
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#removeById
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#prototype$updateAttributes
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ZonesPR id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ZonesPR#modelName
        * @propertyOf lbServices.ZonesPR
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ZonesPR`.
        */
        R.modelName = "ZonesPR";


            /**
             * @ngdoc method
             * @name lbServices.ZonesPR#state
             * @methodOf lbServices.ZonesPR
             *
             * @description
             *
             * Fetches belongsTo relation state.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ZonesPR id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R.state = function() {
          var TargetResource = $injector.get("State");
          var action = TargetResource["::get::ZonesPR::state"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Supplier
 * @header lbServices.Supplier
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Supplier` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Supplier",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Suppliers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Supplier.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Suppliers/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#create
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Suppliers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#patchOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Suppliers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#replaceOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Suppliers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#upsertWithWhere
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Suppliers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#exists
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Suppliers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#findById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Suppliers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#replaceById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Suppliers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#find
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Suppliers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#findOne
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Suppliers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#updateAll
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Suppliers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#deleteById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Suppliers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#count
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Suppliers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#prototype$patchAttributes
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Suppliers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#createChangeStream
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Suppliers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Supplier#createMany
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Suppliers",
              method: "POST",
            },

            // INTERNAL. Use Machineshop.supplier() instead.
            "::get::Machineshop::supplier": {
              url: urlBase + "/Machineshops/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machine.supplier() instead.
            "::get::Machine::supplier": {
              url: urlBase + "/Machines/:id/supplier",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Supplier#upsert
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#updateOrCreate
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#patchOrCreateWithWhere
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#update
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#destroyById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#removeById
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Supplier#prototype$updateAttributes
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Supplier#modelName
        * @propertyOf lbServices.Supplier
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Supplier`.
        */
        R.modelName = "Supplier";


            /**
             * @ngdoc method
             * @name lbServices.Supplier#user
             * @methodOf lbServices.Supplier
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Supplier id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Supplier::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Partner
 * @header lbServices.Partner
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Partner` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Partner",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Partners/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Partner.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Partners/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Partner.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Partners/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#create
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Partners",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#patchOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Partners",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#replaceOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Partners/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#upsertWithWhere
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Partners/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#exists
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Partners/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#findById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Partners/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#replaceById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Partners/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#find
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Partners",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#findOne
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Partners/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#updateAll
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Partners/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#deleteById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Partners/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#count
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Partners/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#prototype$patchAttributes
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Partners/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#createChangeStream
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Partners/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Partner#createMany
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Partners",
              method: "POST",
            },

            // INTERNAL. Use Partner.parent() instead.
            "::get::Partner::parent": {
              url: urlBase + "/Partners/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Shop.partner() instead.
            "::get::Shop::partner": {
              url: urlBase + "/Shops/:id/partner",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Partner#upsert
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#updateOrCreate
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#patchOrCreateWithWhere
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#update
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#destroyById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#removeById
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Partner#prototype$updateAttributes
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Partner#modelName
        * @propertyOf lbServices.Partner
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Partner`.
        */
        R.modelName = "Partner";


            /**
             * @ngdoc method
             * @name lbServices.Partner#user
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Partner::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Partner#parent
             * @methodOf lbServices.Partner
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Partner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Partner");
          var action = TargetResource["::get::Partner::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usermapping
 * @header lbServices.Usermapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usermapping` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usermapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Usermappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usermapping.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Usermappings/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Usermappings/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/Usermappings/:id/role",
              method: "GET",
            },

            // INTERNAL. Use Usermapping.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Usermappings/:id/area",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#create
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Usermappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#patchOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Usermappings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#replaceOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Usermappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#upsertWithWhere
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Usermappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#exists
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Usermappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#findById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Usermappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#replaceById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Usermappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#find
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Usermappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#findOne
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Usermappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#updateAll
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Usermappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#deleteById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Usermappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#count
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Usermappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#prototype$patchAttributes
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Usermappings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#createChangeStream
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Usermappings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#createMany
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Usermappings",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usermapping#upsert
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#updateOrCreate
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#patchOrCreateWithWhere
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#update
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#destroyById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#removeById
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#prototype$updateAttributes
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usermapping` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Usermapping#modelName
        * @propertyOf lbServices.Usermapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usermapping`.
        */
        R.modelName = "Usermapping";


            /**
             * @ngdoc method
             * @name lbServices.Usermapping#zone
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Usermapping::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#user
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Usermapping::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#role
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Usermapping::role"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usermapping#area
             * @methodOf lbServices.Usermapping
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usermapping id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Usermapping::area"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Onlineshop
 * @header lbServices.Onlineshop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Onlineshop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Onlineshop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Onlineshops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Onlineshop.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Onlineshops/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlineshop.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Onlineshops/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Onlineshop.gameserver() instead.
            "prototype$__get__gameserver": {
              url: urlBase + "/Onlineshops/:id/gameserver",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#create
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Onlineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#patchOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Onlineshops",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#replaceOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Onlineshops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#upsertWithWhere
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Onlineshops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#exists
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Onlineshops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#findById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Onlineshops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#replaceById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Onlineshops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#find
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Onlineshops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#findOne
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Onlineshops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#updateAll
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Onlineshops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#deleteById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Onlineshops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#count
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Onlineshops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#prototype$patchAttributes
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Onlineshops/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#createChangeStream
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Onlineshops/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#getOnlineShopAndGameServer
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getOnlineShopAndGameServer": {
              url: urlBase + "/Onlineshops/getOnlineShopAndGameServer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#upsertMany
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create or update multiple Onlineshop records at once.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upsertMany": {
              url: urlBase + "/Onlineshops/upsertMany",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#createMany
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Onlineshops",
              method: "POST",
            },

            // INTERNAL. Use Shop.onlineshop.findById() instead.
            "::findById::Shop::onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Shop.onlineshop.destroyById() instead.
            "::destroyById::Shop::onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.onlineshop.updateById() instead.
            "::updateById::Shop::onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Shop.onlineshop() instead.
            "::get::Shop::onlineshop": {
              isArray: true,
              url: urlBase + "/Shops/:id/onlineshop",
              method: "GET",
            },

            // INTERNAL. Use Shop.onlineshop.create() instead.
            "::create::Shop::onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop",
              method: "POST",
            },

            // INTERNAL. Use Shop.onlineshop.createMany() instead.
            "::createMany::Shop::onlineshop": {
              isArray: true,
              url: urlBase + "/Shops/:id/onlineshop",
              method: "POST",
            },

            // INTERNAL. Use Shop.onlineshop.destroyAll() instead.
            "::delete::Shop::onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.onlineshop.count() instead.
            "::count::Shop::onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#upsert
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#updateOrCreate
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#patchOrCreateWithWhere
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#update
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#destroyById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#removeById
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#prototype$updateAttributes
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Onlineshop#modelName
        * @propertyOf lbServices.Onlineshop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Onlineshop`.
        */
        R.modelName = "Onlineshop";


            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#game
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Onlineshop::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#shop
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Onlineshop::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlineshop#gameserver
             * @methodOf lbServices.Onlineshop
             *
             * @description
             *
             * Fetches belongsTo relation gameserver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R.gameserver = function() {
          var TargetResource = $injector.get("GameServer");
          var action = TargetResource["::get::Onlineshop::gameserver"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machineshop
 * @header lbServices.Machineshop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machineshop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machineshop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machineshops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machineshop.supplier() instead.
            "prototype$__get__supplier": {
              url: urlBase + "/Machineshops/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.machine() instead.
            "prototype$__get__machine": {
              url: urlBase + "/Machineshops/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Machineshops/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#create
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machineshops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#patchOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Machineshops",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#replaceOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machineshops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#upsertWithWhere
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machineshops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#exists
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machineshops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#findById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machineshops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#replaceById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machineshops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#find
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machineshops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#findOne
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machineshops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#updateAll
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machineshops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#deleteById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machineshops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#count
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machineshops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#prototype$patchAttributes
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Machineshops/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#createChangeStream
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machineshops/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#createMany
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machineshops",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.findById() instead.
            "::findById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.destroyById() instead.
            "::destroyById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.updateById() instead.
            "::updateById::Machine::machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Machine.machineshop() instead.
            "::get::Machine::machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.create() instead.
            "::create::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.createMany() instead.
            "::createMany::Machine::machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.destroyAll() instead.
            "::delete::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.count() instead.
            "::count::Machine::machineshop": {
              url: urlBase + "/Machines/:id/machineshop/count",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machineshop() instead.
            "::get::Machinesales::machineshop": {
              url: urlBase + "/Machinesales/:id/machineshop",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machineshop#upsert
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#updateOrCreate
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#patchOrCreateWithWhere
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#update
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#destroyById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#removeById
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#prototype$updateAttributes
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machineshop#modelName
        * @propertyOf lbServices.Machineshop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machineshop`.
        */
        R.modelName = "Machineshop";


            /**
             * @ngdoc method
             * @name lbServices.Machineshop#supplier
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation supplier.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R.supplier = function() {
          var TargetResource = $injector.get("Supplier");
          var action = TargetResource["::get::Machineshop::supplier"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#machine
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R.machine = function() {
          var TargetResource = $injector.get("Machine");
          var action = TargetResource["::get::Machineshop::machine"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machineshop#shop
             * @methodOf lbServices.Machineshop
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machineshop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Machineshop::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Onlinesales
 * @header lbServices.Onlinesales
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Onlinesales` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Onlinesales",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Onlinesales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Onlinesales.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Onlinesales/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Onlinesales/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#create
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Onlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#patchOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Onlinesales",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#replaceOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Onlinesales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#upsertWithWhere
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Onlinesales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#exists
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Onlinesales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#findById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Onlinesales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#replaceById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Onlinesales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#find
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Onlinesales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#findOne
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Onlinesales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#updateAll
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Onlinesales/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#deleteById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Onlinesales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#count
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Onlinesales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#prototype$patchAttributes
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Onlinesales/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#createChangeStream
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Onlinesales/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getOnlineSalesPlaytechByZonePR
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `zoneprid` – `{*=}` -
             *
             *  - `gameid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getOnlineSalesPlaytechByZonePR": {
              url: urlBase + "/Onlinesales/getOnlineSalesPlaytechByZonePR",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getOnlineSalesByZonePR
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `zoneprid` – `{*=}` -
             *
             *  - `siteid` – `{*=}` -
             *
             *  - `address` – `{*=}` -
             *
             *  - `username` – `{*=}` -
             *
             *  - `isPRAdmin` – `{*=}` -
             *
             *  - `noSite` – `{*=}` -
             *
             *  - `netgamingStatus` – `{*=}` -
             *
             *  - `shopWithAddress` – `{*=}` -
             *
             *  - `shopname` – `{*=}` -
             *
             *  - `limit` – `{*=}` -
             *
             *  - `offset` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getOnlineSalesByZonePR": {
              url: urlBase + "/Onlinesales/getOnlineSalesByZonePR",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#grpShop
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpShop": {
              url: urlBase + "/Onlinesales/grpShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#generateInvoiceOnline
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generateInvoiceOnline": {
              url: urlBase + "/Onlinesales/generateInvoiceOnline",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getDailyOnlinesales
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyOnlinesales": {
              url: urlBase + "/Onlinesales/getDailyOnlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getAllOnlinesales
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `partnerid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `kiosk` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllOnlinesales": {
              url: urlBase + "/Onlinesales/getAllOnlinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getAllPartnerShop
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `partnerid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllPartnerShop": {
              url: urlBase + "/Onlinesales/getAllPartnerShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getPNLSalesReport
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getPNLSalesReport": {
              url: urlBase + "/Onlinesales/getPNLSalesReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#getPNLSalesDetailReport
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shopid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getPNLSalesDetailReport": {
              url: urlBase + "/Onlinesales/getPNLSalesDetailReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#autoGetDailySalesFromJoka
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "autoGetDailySalesFromJoka": {
              url: urlBase + "/Onlinesales/autoGetDailySalesFromJoka",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#autoGetDailySalesFromPaparich
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "autoGetDailySalesFromPaparich": {
              url: urlBase + "/Onlinesales/autoGetDailySalesFromPaparich",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#createMany
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Onlinesales",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#upsert
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#updateOrCreate
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#patchOrCreateWithWhere
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#update
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#destroyById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#removeById
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#prototype$updateAttributes
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlinesales` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Onlinesales#modelName
        * @propertyOf lbServices.Onlinesales
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Onlinesales`.
        */
        R.modelName = "Onlinesales";


            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#game
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Onlinesales::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlinesales#shop
             * @methodOf lbServices.Onlinesales
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Onlinesales::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Paylist
 * @header lbServices.Paylist
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Paylist` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Paylist",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Paylists/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Paylist.owner() instead.
            "prototype$__get__owner": {
              url: urlBase + "/Paylists/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Paylist.shared() instead.
            "prototype$__get__shared": {
              url: urlBase + "/Paylists/:id/shared",
              method: "GET",
            },

            // INTERNAL. Use Paylist.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/Paylists/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Paylist.useraccount() instead.
            "prototype$__get__useraccount": {
              url: urlBase + "/Paylists/:id/useraccount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#create
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Paylists",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#patchOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Paylists",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#replaceOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Paylists/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#upsertWithWhere
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Paylists/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#exists
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Paylists/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#findById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Paylists/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#replaceById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Paylists/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#find
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Paylists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#findOne
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Paylists/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#updateAll
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Paylists/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#deleteById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Paylists/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#count
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Paylists/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#prototype$patchAttributes
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Paylists/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#createChangeStream
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Paylists/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Paylist#createMany
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Paylists",
              method: "POST",
            },

            // INTERNAL. Use Usertransaction.paylist() instead.
            "::get::Usertransaction::paylist": {
              url: urlBase + "/Usertransactions/:id/paylist",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Paylist#upsert
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#updateOrCreate
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#patchOrCreateWithWhere
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#update
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#destroyById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#removeById
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Paylist#prototype$updateAttributes
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Paylist` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Paylist#modelName
        * @propertyOf lbServices.Paylist
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Paylist`.
        */
        R.modelName = "Paylist";


            /**
             * @ngdoc method
             * @name lbServices.Paylist#owner
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation owner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.owner = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Paylist::owner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#shared
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation shared.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.shared = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Paylist::shared"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#account
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Accounts");
          var action = TargetResource["::get::Paylist::account"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Paylist#useraccount
             * @methodOf lbServices.Paylist
             *
             * @description
             *
             * Fetches belongsTo relation useraccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Paylist id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Useraccount` object.)
             * </em>
             */
        R.useraccount = function() {
          var TargetResource = $injector.get("Useraccount");
          var action = TargetResource["::get::Paylist::useraccount"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machine
 * @header lbServices.Machine
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machine` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machine",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machines/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machine.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Machines/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Machine.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/Machines/:id/game",
              method: "GET",
            },

            // INTERNAL. Use Machine.gamecategory() instead.
            "prototype$__get__gamecategory": {
              url: urlBase + "/Machines/:id/gamecategory",
              method: "GET",
            },

            // INTERNAL. Use Machine.supplier() instead.
            "prototype$__get__supplier": {
              url: urlBase + "/Machines/:id/supplier",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.findById() instead.
            "prototype$__findById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.destroyById() instead.
            "prototype$__destroyById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.updateById() instead.
            "prototype$__updateById__machineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Machines/:id/machineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Machine.machineshop() instead.
            "prototype$__get__machineshop": {
              isArray: true,
              url: urlBase + "/Machines/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machine.machineshop.create() instead.
            "prototype$__create__machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "POST",
            },

            // INTERNAL. Use Machine.machineshop.destroyAll() instead.
            "prototype$__delete__machineshop": {
              url: urlBase + "/Machines/:id/machineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Machine.machineshop.count() instead.
            "prototype$__count__machineshop": {
              url: urlBase + "/Machines/:id/machineshop/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#create
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#patchOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Machines",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#replaceOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machines/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#upsertWithWhere
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machines/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#exists
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machines/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#findById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machines/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#replaceById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machines/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#find
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machines",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#findOne
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machines/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#updateAll
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machines/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#deleteById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machines/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#count
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machines/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#prototype$patchAttributes
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Machines/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#createChangeStream
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machines/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machine#createMany
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machines",
              method: "POST",
            },

            // INTERNAL. Use Machineshop.machine() instead.
            "::get::Machineshop::machine": {
              url: urlBase + "/Machineshops/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machine() instead.
            "::get::Machinesales::machine": {
              url: urlBase + "/Machinesales/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use StockTracking.machine() instead.
            "::get::StockTracking::machine": {
              url: urlBase + "/StockTrackings/:id/machine",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machine#upsert
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#updateOrCreate
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#patchOrCreateWithWhere
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#update
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#destroyById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#removeById
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machine#prototype$updateAttributes
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machine#modelName
        * @propertyOf lbServices.Machine
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machine`.
        */
        R.modelName = "Machine";


            /**
             * @ngdoc method
             * @name lbServices.Machine#zone
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Machine::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine#game
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::Machine::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine#gamecategory
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation gamecategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Gamecategory` object.)
             * </em>
             */
        R.gamecategory = function() {
          var TargetResource = $injector.get("Gamecategory");
          var action = TargetResource["::get::Machine::gamecategory"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine#supplier
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Fetches belongsTo relation supplier.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Supplier` object.)
             * </em>
             */
        R.supplier = function() {
          var TargetResource = $injector.get("Supplier");
          var action = TargetResource["::get::Machine::supplier"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Machine.machineshop
     * @header lbServices.Machine.machineshop
     * @object
     * @description
     *
     * The object `Machine.machineshop` groups methods
     * manipulating `Machineshop` instances related to `Machine`.
     *
     * Call {@link lbServices.Machine#machineshop Machine.machineshop()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Machine#machineshop
             * @methodOf lbServices.Machine
             *
             * @description
             *
             * Queries machineshop of Machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::get::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#count
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Counts machineshop of Machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.machineshop.count = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::count::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#create
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Creates a new instance in machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.create = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::create::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#createMany
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Creates a new instance in machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.createMany = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::createMany::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#destroyAll
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Deletes all machineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.machineshop.destroyAll = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::delete::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#destroyById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Delete a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.machineshop.destroyById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::destroyById::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#findById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Find a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.findById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::findById::Machine::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machine.machineshop#updateById
             * @methodOf lbServices.Machine.machineshop
             *
             * @description
             *
             * Update a related item by id for machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machine id
             *
             *  - `fk` – `{*}` - Foreign key for machineshop
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop.updateById = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::updateById::Machine::machineshop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Shop
 * @header lbServices.Shop
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Shop` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Shop",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Shops/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Shop.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Shops/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Shop.zonepr() instead.
            "prototype$__get__zonepr": {
              url: urlBase + "/Shops/:id/zonepr",
              method: "GET",
            },

            // INTERNAL. Use Shop.partner() instead.
            "prototype$__get__partner": {
              url: urlBase + "/Shops/:id/partner",
              method: "GET",
            },

            // INTERNAL. Use Shop.area() instead.
            "prototype$__get__area": {
              url: urlBase + "/Shops/:id/area",
              method: "GET",
            },

            // INTERNAL. Use Shop.site() instead.
            "prototype$__get__site": {
              url: urlBase + "/Shops/:id/site",
              method: "GET",
            },

            // INTERNAL. Use Shop.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Shops/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Shop.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/Shops/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Shop.onlineshop.findById() instead.
            "prototype$__findById__onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "GET",
            },

            // INTERNAL. Use Shop.onlineshop.destroyById() instead.
            "prototype$__destroyById__onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.onlineshop.updateById() instead.
            "prototype$__updateById__onlineshop": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/onlineshop/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Shop.shopAddress.findById() instead.
            "prototype$__findById__shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "GET",
            },

            // INTERNAL. Use Shop.shopAddress.destroyById() instead.
            "prototype$__destroyById__shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.shopAddress.updateById() instead.
            "prototype$__updateById__shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Shop.onlineshop() instead.
            "prototype$__get__onlineshop": {
              isArray: true,
              url: urlBase + "/Shops/:id/onlineshop",
              method: "GET",
            },

            // INTERNAL. Use Shop.onlineshop.create() instead.
            "prototype$__create__onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop",
              method: "POST",
            },

            // INTERNAL. Use Shop.onlineshop.destroyAll() instead.
            "prototype$__delete__onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.onlineshop.count() instead.
            "prototype$__count__onlineshop": {
              url: urlBase + "/Shops/:id/onlineshop/count",
              method: "GET",
            },

            // INTERNAL. Use Shop.shopAddress() instead.
            "prototype$__get__shopAddress": {
              isArray: true,
              url: urlBase + "/Shops/:id/shopAddress",
              method: "GET",
            },

            // INTERNAL. Use Shop.shopAddress.create() instead.
            "prototype$__create__shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress",
              method: "POST",
            },

            // INTERNAL. Use Shop.shopAddress.destroyAll() instead.
            "prototype$__delete__shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.shopAddress.count() instead.
            "prototype$__count__shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#create
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Shops",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#patchOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Shops",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#replaceOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Shops/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#upsertWithWhere
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Shops/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#exists
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Shops/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#findById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Shops/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#replaceById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Shops/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#find
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Shops",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#findOne
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Shops/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#updateAll
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Shops/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#deleteById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Shops/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#count
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Shops/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#prototype$patchAttributes
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Shops/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#createChangeStream
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Shops/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#getShopsSummary
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `shopmap` – `{*=}` -
             *
             *  - `zonemap` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getShopsSummary": {
              url: urlBase + "/Shops/getShopsSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#getShopByPartner
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `partnerid` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getShopByPartner": {
              url: urlBase + "/Shops/getShopByPartner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Shop#createMany
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Shops",
              method: "POST",
            },

            // INTERNAL. Use ShopCategory.subs.findById() instead.
            "::findById::ShopCategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use ShopCategory.subs.destroyById() instead.
            "::destroyById::ShopCategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ShopCategory.subs.updateById() instead.
            "::updateById::ShopCategory::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ShopCategories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ShopCategory.subs() instead.
            "::get::ShopCategory::subs": {
              isArray: true,
              url: urlBase + "/ShopCategories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use ShopCategory.subs.create() instead.
            "::create::ShopCategory::subs": {
              url: urlBase + "/ShopCategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use ShopCategory.subs.createMany() instead.
            "::createMany::ShopCategory::subs": {
              isArray: true,
              url: urlBase + "/ShopCategories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use ShopCategory.subs.destroyAll() instead.
            "::delete::ShopCategory::subs": {
              url: urlBase + "/ShopCategories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use ShopCategory.subs.count() instead.
            "::count::ShopCategory::subs": {
              url: urlBase + "/ShopCategories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Onlineshop.shop() instead.
            "::get::Onlineshop::shop": {
              url: urlBase + "/Onlineshops/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machineshop.shop() instead.
            "::get::Machineshop::shop": {
              url: urlBase + "/Machineshops/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Onlinesales.shop() instead.
            "::get::Onlinesales::shop": {
              url: urlBase + "/Onlinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.shop() instead.
            "::get::Machinesales::shop": {
              url: urlBase + "/Machinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Invoice.shop() instead.
            "::get::Invoice::shop": {
              url: urlBase + "/Invoices/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use StockTracking.shop() instead.
            "::get::StockTracking::shop": {
              url: urlBase + "/StockTrackings/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Onlineserver.shop() instead.
            "::get::Onlineserver::shop": {
              url: urlBase + "/Onlineservers/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use BillExp.shop() instead.
            "::get::BillExp::shop": {
              url: urlBase + "/BillExps/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use ShopAddress.shop() instead.
            "::get::ShopAddress::shop": {
              url: urlBase + "/ShopAddresses/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use InternalServerOnlineSales.shop() instead.
            "::get::InternalServerOnlineSales::shop": {
              url: urlBase + "/InternalServerOnlineSales/:id/shop",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Shop#upsert
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#updateOrCreate
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#patchOrCreateWithWhere
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#update
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#destroyById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#removeById
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Shop#prototype$updateAttributes
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Shop#modelName
        * @propertyOf lbServices.Shop
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Shop`.
        */
        R.modelName = "Shop";


            /**
             * @ngdoc method
             * @name lbServices.Shop#zone
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Shop::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#zonepr
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation zonepr.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ZonesPR` object.)
             * </em>
             */
        R.zonepr = function() {
          var TargetResource = $injector.get("ZonesPR");
          var action = TargetResource["::get::Shop::zonepr"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#partner
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation partner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Partner` object.)
             * </em>
             */
        R.partner = function() {
          var TargetResource = $injector.get("Partner");
          var action = TargetResource["::get::Shop::partner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#area
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation area.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R.area = function() {
          var TargetResource = $injector.get("Area");
          var action = TargetResource["::get::Shop::area"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#site
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Site` object.)
             * </em>
             */
        R.site = function() {
          var TargetResource = $injector.get("Site");
          var action = TargetResource["::get::Shop::site"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#user
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Shop::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop#category
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopCategory` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("ShopCategory");
          var action = TargetResource["::get::Shop::category"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Shop.onlineshop
     * @header lbServices.Shop.onlineshop
     * @object
     * @description
     *
     * The object `Shop.onlineshop` groups methods
     * manipulating `Onlineshop` instances related to `Shop`.
     *
     * Call {@link lbServices.Shop#onlineshop Shop.onlineshop()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Shop#onlineshop
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Queries onlineshop of Shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R.onlineshop = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::get::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#count
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Counts onlineshop of Shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.onlineshop.count = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::count::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#create
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Creates a new instance in onlineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R.onlineshop.create = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::create::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#createMany
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Creates a new instance in onlineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R.onlineshop.createMany = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::createMany::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#destroyAll
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Deletes all onlineshop of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.onlineshop.destroyAll = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::delete::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#destroyById
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Delete a related item by id for onlineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for onlineshop
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.onlineshop.destroyById = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::destroyById::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#findById
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Find a related item by id for onlineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for onlineshop
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R.onlineshop.findById = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::findById::Shop::onlineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.onlineshop#updateById
             * @methodOf lbServices.Shop.onlineshop
             *
             * @description
             *
             * Update a related item by id for onlineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `fk` – `{*}` - Foreign key for onlineshop
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineshop` object.)
             * </em>
             */
        R.onlineshop.updateById = function() {
          var TargetResource = $injector.get("Onlineshop");
          var action = TargetResource["::updateById::Shop::onlineshop"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Shop.shopAddress
     * @header lbServices.Shop.shopAddress
     * @object
     * @description
     *
     * The object `Shop.shopAddress` groups methods
     * manipulating `ShopAddress` instances related to `Shop`.
     *
     * Call {@link lbServices.Shop#shopAddress Shop.shopAddress()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Shop#shopAddress
             * @methodOf lbServices.Shop
             *
             * @description
             *
             * Queries shopAddress of Shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R.shopAddress = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::get::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#count
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Counts shopAddress of Shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.shopAddress.count = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::count::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#create
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Creates a new instance in shopAddress of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R.shopAddress.create = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::create::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#createMany
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Creates a new instance in shopAddress of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R.shopAddress.createMany = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::createMany::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#destroyAll
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Deletes all shopAddress of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.shopAddress.destroyAll = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::delete::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#destroyById
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Delete a related item by id for shopAddress.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for shopAddress
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.shopAddress.destroyById = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::destroyById::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#findById
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Find a related item by id for shopAddress.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for shopAddress
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R.shopAddress.findById = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::findById::Shop::shopAddress"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Shop.shopAddress#updateById
             * @methodOf lbServices.Shop.shopAddress
             *
             * @description
             *
             * Update a related item by id for shopAddress.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Shop id
             *
             *  - `fk` – `{*}` - Foreign key for shopAddress
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R.shopAddress.updateById = function() {
          var TargetResource = $injector.get("ShopAddress");
          var action = TargetResource["::updateById::Shop::shopAddress"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Machinesales
 * @header lbServices.Machinesales
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Machinesales` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Machinesales",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Machinesales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Machinesales.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Machinesales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machine() instead.
            "prototype$__get__machine": {
              url: urlBase + "/Machinesales/:id/machine",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.machineshop() instead.
            "prototype$__get__machineshop": {
              url: urlBase + "/Machinesales/:id/machineshop",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/Machinesales/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Machinesales.agent() instead.
            "prototype$__get__agent": {
              url: urlBase + "/Machinesales/:id/agent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#create
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Machinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#patchOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Machinesales",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#replaceOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Machinesales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#upsertWithWhere
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Machinesales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#exists
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Machinesales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#findById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Machinesales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#replaceById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Machinesales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#find
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Machinesales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#findOne
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Machinesales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#updateAll
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Machinesales/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#deleteById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Machinesales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#count
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Machinesales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#prototype$patchAttributes
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Machinesales/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#createChangeStream
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Machinesales/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSupplier
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSupplier": {
              url: urlBase + "/Machinesales/grpSupplier",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpPartner
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `parentid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpPartner": {
              url: urlBase + "/Machinesales/grpPartner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpByPartnerByShopC
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpByPartnerByShopC": {
              url: urlBase + "/Machinesales/grpByPartnerByShopC",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesByShopC
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `partnerId` – `{*=}` -
             *
             *  - `shopname` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesByShopC": {
              url: urlBase + "/Machinesales/grpSalesByShopC",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpByPartnerByShopM
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpByPartnerByShopM": {
              url: urlBase + "/Machinesales/grpByPartnerByShopM",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesByShopM
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `partnerId` – `{*=}` -
             *
             *  - `shopname` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesByShopM": {
              url: urlBase + "/Machinesales/grpSalesByShopM",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesOfSupplier
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `suppId` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesOfSupplier": {
              url: urlBase + "/Machinesales/grpSalesOfSupplier",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpSalesOfPartner
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `partnerId` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpSalesOfPartner": {
              url: urlBase + "/Machinesales/grpSalesOfPartner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#grpShop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "grpShop": {
              url: urlBase + "/Machinesales/grpShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAvailableMacByZone
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAvailableMacByZone": {
              url: urlBase + "/Machinesales/getAvailableMacByZone",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#generateInvoice
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generateInvoice": {
              url: urlBase + "/Machinesales/generateInvoice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDailyMachinesales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `daynight` – `{*=}` -
             *
             *  - `shopid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyMachinesales": {
              url: urlBase + "/Machinesales/getDailyMachinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAllMachinesales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `daynight` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllMachinesales": {
              url: urlBase + "/Machinesales/getAllMachinesales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getAllSuppliersales
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `daynight` – `{*=}` -
             *
             *  - `supplierid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllSuppliersales": {
              url: urlBase + "/Machinesales/getAllSuppliersales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDailyMachinesalesSummary
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `shopid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyMachinesalesSummary": {
              url: urlBase + "/Machinesales/getDailyMachinesalesSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDashboardV1
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV1": {
              url: urlBase + "/Machinesales/getDashboardV1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#getDashboardV2
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV2": {
              url: urlBase + "/Machinesales/getDashboardV2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#shopsReportWithGames
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "shopsReportWithGames": {
              url: urlBase + "/Machinesales/shopsReportWithGames",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#createMany
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Machinesales",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Machinesales#upsert
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#updateOrCreate
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#patchOrCreateWithWhere
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#update
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#destroyById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#removeById
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#prototype$updateAttributes
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machinesales` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Machinesales#modelName
        * @propertyOf lbServices.Machinesales
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Machinesales`.
        */
        R.modelName = "Machinesales";


            /**
             * @ngdoc method
             * @name lbServices.Machinesales#shop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Machinesales::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#machine
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R.machine = function() {
          var TargetResource = $injector.get("Machine");
          var action = TargetResource["::get::Machinesales::machine"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#machineshop
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation machineshop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machineshop` object.)
             * </em>
             */
        R.machineshop = function() {
          var TargetResource = $injector.get("Machineshop");
          var action = TargetResource["::get::Machinesales::machineshop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#receipt
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipts` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipts");
          var action = TargetResource["::get::Machinesales::receipt"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Machinesales#agent
             * @methodOf lbServices.Machinesales
             *
             * @description
             *
             * Fetches belongsTo relation agent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Machinesales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.agent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Machinesales::agent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Invoice
 * @header lbServices.Invoice
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Invoice` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Invoice",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Invoices/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Invoice.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Invoices/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Invoice.zone() instead.
            "prototype$__get__zone": {
              url: urlBase + "/Invoices/:id/zone",
              method: "GET",
            },

            // INTERNAL. Use Invoice.agent() instead.
            "prototype$__get__agent": {
              url: urlBase + "/Invoices/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Invoice.head() instead.
            "prototype$__get__head": {
              url: urlBase + "/Invoices/:id/head",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#create
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Invoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Invoices",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Invoices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsertWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Invoices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#exists
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Invoices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Invoices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Invoices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#find
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findOne
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Invoices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#updateAll
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Invoices/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#deleteById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Invoices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#count
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Invoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#prototype$patchAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Invoices/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#createChangeStream
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Invoices/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceWithSales
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `ispaid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `categoryid` – `{*=}` -
             *
             *  - `allowInvocing` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceWithSales": {
              url: urlBase + "/Invoices/getDailyInvoiceWithSales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getAllInvoiceWithShop
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shopid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `ispaid` – `{*=}` -
             *
             *  - `partnerid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `categoryid` – `{*=}` -
             *
             *  - `allowInvocing` – `{*=}` -
             *
             *  - `ids` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllInvoiceWithShop": {
              url: urlBase + "/Invoices/getAllInvoiceWithShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getAllInvoiceWithSales
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `bdate` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `agentid` – `{*=}` -
             *
             *  - `ispaid` – `{*=}` -
             *
             *  - `partnerid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `categoryid` – `{*=}` -
             *
             *  - `allowInvocing` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllInvoiceWithSales": {
              url: urlBase + "/Invoices/getAllInvoiceWithSales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL1
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shopmap` – `{*=}` -
             *
             *  - `zonemap` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL1": {
              url: urlBase + "/Invoices/getDailyInvoiceL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL2
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shopmap` – `{*=}` -
             *
             *  - `zonemap` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL2": {
              url: urlBase + "/Invoices/getDailyInvoiceL2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#getDailyInvoiceL3
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{*=}` -
             *
             *  - `shopmap` – `{*=}` -
             *
             *  - `zonemap` – `{*=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyInvoiceL3": {
              url: urlBase + "/Invoices/getDailyInvoiceL3",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#createMany
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "POST",
            },

            // INTERNAL. Use InvoicePaid.invoice() instead.
            "::get::InvoicePaid::invoice": {
              url: urlBase + "/InvoicePaids/:id/invoice",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsert
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#updateOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreateWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#update
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#destroyById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#removeById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#prototype$updateAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Invoice#modelName
        * @propertyOf lbServices.Invoice
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Invoice`.
        */
        R.modelName = "Invoice";


            /**
             * @ngdoc method
             * @name lbServices.Invoice#shop
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Invoice::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#zone
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation zone.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zone = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Invoice::zone"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#agent
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation agent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.agent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invoice::agent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#head
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation head.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.head = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invoice::head"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InvoicePaid
 * @header lbServices.InvoicePaid
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InvoicePaid` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InvoicePaid",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/InvoicePaids/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InvoicePaid.invoice() instead.
            "prototype$__get__invoice": {
              url: urlBase + "/InvoicePaids/:id/invoice",
              method: "GET",
            },

            // INTERNAL. Use InvoicePaid.invoicereceiptid() instead.
            "prototype$__get__invoicereceiptid": {
              url: urlBase + "/InvoicePaids/:id/invoicereceiptid",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#create
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/InvoicePaids",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#patchOrCreate
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/InvoicePaids",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#replaceOrCreate
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/InvoicePaids/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#upsertWithWhere
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/InvoicePaids/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#exists
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/InvoicePaids/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#findById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/InvoicePaids/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#replaceById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/InvoicePaids/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#find
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/InvoicePaids",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#findOne
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/InvoicePaids/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#updateAll
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/InvoicePaids/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#deleteById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/InvoicePaids/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#count
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/InvoicePaids/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#prototype$patchAttributes
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoicePaid id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/InvoicePaids/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#createChangeStream
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/InvoicePaids/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#getPaidInvoicByDate
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `shoptype` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             *  - `stateid` – `{*=}` -
             *
             *  - `ismonthly` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getPaidInvoicByDate": {
              url: urlBase + "/InvoicePaids/getPaidInvoicByDate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#getInvoiceReceiptById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `receiptid` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getInvoiceReceiptById": {
              url: urlBase + "/InvoicePaids/getInvoiceReceiptById",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#createMany
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/InvoicePaids",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#upsert
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#updateOrCreate
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#patchOrCreateWithWhere
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#update
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#destroyById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#removeById
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#prototype$updateAttributes
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoicePaid id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoicePaid` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InvoicePaid#modelName
        * @propertyOf lbServices.InvoicePaid
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InvoicePaid`.
        */
        R.modelName = "InvoicePaid";


            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#invoice
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Fetches belongsTo relation invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoicePaid id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R.invoice = function() {
          var TargetResource = $injector.get("Invoice");
          var action = TargetResource["::get::InvoicePaid::invoice"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.InvoicePaid#invoicereceiptid
             * @methodOf lbServices.InvoicePaid
             *
             * @description
             *
             * Fetches belongsTo relation invoicereceiptid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoicePaid id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R.invoicereceiptid = function() {
          var TargetResource = $injector.get("InvoiceReceipt");
          var action = TargetResource["::get::InvoicePaid::invoicereceiptid"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InvoiceReceipt
 * @header lbServices.InvoiceReceipt
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InvoiceReceipt` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InvoiceReceipt",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/InvoiceReceipts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InvoiceReceipt.approvalid() instead.
            "prototype$__get__approvalid": {
              url: urlBase + "/InvoiceReceipts/:id/approvalid",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#create
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/InvoiceReceipts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#patchOrCreate
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/InvoiceReceipts",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#replaceOrCreate
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/InvoiceReceipts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#upsertWithWhere
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/InvoiceReceipts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#exists
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/InvoiceReceipts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#findById
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/InvoiceReceipts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#replaceById
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/InvoiceReceipts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#find
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/InvoiceReceipts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#findOne
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/InvoiceReceipts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#updateAll
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/InvoiceReceipts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#deleteById
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/InvoiceReceipts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#count
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/InvoiceReceipts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#prototype$patchAttributes
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoiceReceipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/InvoiceReceipts/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#createChangeStream
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/InvoiceReceipts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#generate
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `paidAt` – `{string=}` -
             *
             *  - `description` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generate": {
              url: urlBase + "/InvoiceReceipts/generate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#getAllByDate
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getAllByDate": {
              url: urlBase + "/InvoiceReceipts/getAllByDate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#createMany
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/InvoiceReceipts",
              method: "POST",
            },

            // INTERNAL. Use InvoicePaid.invoicereceiptid() instead.
            "::get::InvoicePaid::invoicereceiptid": {
              url: urlBase + "/InvoicePaids/:id/invoicereceiptid",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#upsert
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#updateOrCreate
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#patchOrCreateWithWhere
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#update
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#destroyById
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#removeById
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#prototype$updateAttributes
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoiceReceipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceReceipt` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InvoiceReceipt#modelName
        * @propertyOf lbServices.InvoiceReceipt
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InvoiceReceipt`.
        */
        R.modelName = "InvoiceReceipt";


            /**
             * @ngdoc method
             * @name lbServices.InvoiceReceipt#approvalid
             * @methodOf lbServices.InvoiceReceipt
             *
             * @description
             *
             * Fetches belongsTo relation approvalid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InvoiceReceipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.approvalid = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::InvoiceReceipt::approvalid"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collector
 * @header lbServices.Collector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectors/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Collector.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Collectors/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Collector.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Collectors/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#create
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Collectors",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#upsertWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#exists
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#find
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findOne
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateAll
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#deleteById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#count
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#prototype$patchAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Collectors/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createChangeStream
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createMany
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "POST",
            },

            // INTERNAL. Use Collector.parent() instead.
            "::get::Collector::parent": {
              url: urlBase + "/Collectors/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.collector() instead.
            "::get::Collectormap::collector": {
              url: urlBase + "/Collectormaps/:id/collector",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collector#upsert
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreateWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#update
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#destroyById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#removeById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#prototype$updateAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collector#modelName
        * @propertyOf lbServices.Collector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collector`.
        */
        R.modelName = "Collector";


            /**
             * @ngdoc method
             * @name lbServices.Collector#user
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collector::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collector#parent
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Collector");
          var action = TargetResource["::get::Collector::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collectormap
 * @header lbServices.Collectormap
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collectormap` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collectormap",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectormaps/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Collectormap.head() instead.
            "prototype$__get__head": {
              url: urlBase + "/Collectormaps/:id/head",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.staff() instead.
            "prototype$__get__staff": {
              url: urlBase + "/Collectormaps/:id/staff",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.vip() instead.
            "prototype$__get__vip": {
              url: urlBase + "/Collectormaps/:id/vip",
              method: "GET",
            },

            // INTERNAL. Use Collectormap.collector() instead.
            "prototype$__get__collector": {
              url: urlBase + "/Collectormaps/:id/collector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#create
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectormaps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Collectormaps",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectormaps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsertWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectormaps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#exists
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectormaps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectormaps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectormaps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#find
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findOne
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectormaps/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateAll
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectormaps/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#deleteById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectormaps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#count
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectormaps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#prototype$patchAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Collectormaps/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createChangeStream
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectormaps/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createMany
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsert
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreateWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#update
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#destroyById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#removeById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#prototype$updateAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collectormap#modelName
        * @propertyOf lbServices.Collectormap
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collectormap`.
        */
        R.modelName = "Collectormap";


            /**
             * @ngdoc method
             * @name lbServices.Collectormap#head
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation head.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.head = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::head"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#staff
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation staff.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.staff = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::staff"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#vip
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation vip.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.vip = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Collectormap::vip"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#collector
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Fetches belongsTo relation collector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R.collector = function() {
          var TargetResource = $injector.get("Collector");
          var action = TargetResource["::get::Collectormap::collector"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.StockTracking
 * @header lbServices.StockTracking
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `StockTracking` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "StockTracking",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/StockTrackings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use StockTracking.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/StockTrackings/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use StockTracking.machine() instead.
            "prototype$__get__machine": {
              url: urlBase + "/StockTrackings/:id/machine",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#create
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/StockTrackings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#patchOrCreate
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/StockTrackings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#replaceOrCreate
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/StockTrackings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#upsertWithWhere
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/StockTrackings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#exists
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/StockTrackings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#findById
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/StockTrackings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#replaceById
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/StockTrackings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#find
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/StockTrackings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#findOne
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/StockTrackings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#updateAll
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/StockTrackings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#deleteById
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/StockTrackings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#count
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/StockTrackings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#prototype$patchAttributes
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StockTracking id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/StockTrackings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#createChangeStream
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/StockTrackings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#generateNew
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `machineid` – `{number=}` -
             *
             *  - `shopid` – `{number=}` -
             *
             *  - `type` – `{string=}` -
             *
             *  - `remark` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "generateNew": {
              url: urlBase + "/StockTrackings/generateNew",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#createMany
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/StockTrackings",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.StockTracking#upsert
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#updateOrCreate
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#patchOrCreateWithWhere
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#update
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#destroyById
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#removeById
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#prototype$updateAttributes
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StockTracking id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StockTracking` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.StockTracking#modelName
        * @propertyOf lbServices.StockTracking
        * @description
        * The name of the model represented by this $resource,
        * i.e. `StockTracking`.
        */
        R.modelName = "StockTracking";


            /**
             * @ngdoc method
             * @name lbServices.StockTracking#shop
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StockTracking id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::StockTracking::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StockTracking#machine
             * @methodOf lbServices.StockTracking
             *
             * @description
             *
             * Fetches belongsTo relation machine.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StockTracking id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Machine` object.)
             * </em>
             */
        R.machine = function() {
          var TargetResource = $injector.get("Machine");
          var action = TargetResource["::get::StockTracking::machine"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GameProvider
 * @header lbServices.GameProvider
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GameProvider` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GameProvider",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/GameProviders/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GameProvider.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/GameProviders/:id/game",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#create
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/GameProviders",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#patchOrCreate
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/GameProviders",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#replaceOrCreate
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/GameProviders/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#upsertWithWhere
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/GameProviders/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#exists
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/GameProviders/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#findById
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/GameProviders/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#replaceById
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/GameProviders/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#find
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/GameProviders",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#findOne
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/GameProviders/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#updateAll
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/GameProviders/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#deleteById
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/GameProviders/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#count
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/GameProviders/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#prototype$patchAttributes
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameProvider id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/GameProviders/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#createChangeStream
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/GameProviders/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#createMany
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/GameProviders",
              method: "POST",
            },

            // INTERNAL. Use GameServer.gameprovider() instead.
            "::get::GameServer::gameprovider": {
              url: urlBase + "/GameServers/:id/gameprovider",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GameProvider#upsert
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#updateOrCreate
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#patchOrCreateWithWhere
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#update
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#destroyById
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#removeById
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GameProvider#prototype$updateAttributes
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameProvider id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GameProvider#modelName
        * @propertyOf lbServices.GameProvider
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GameProvider`.
        */
        R.modelName = "GameProvider";


            /**
             * @ngdoc method
             * @name lbServices.GameProvider#game
             * @methodOf lbServices.GameProvider
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameProvider id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::GameProvider::game"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GameServer
 * @header lbServices.GameServer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GameServer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GameServer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/GameServers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GameServer.gameprovider() instead.
            "prototype$__get__gameprovider": {
              url: urlBase + "/GameServers/:id/gameprovider",
              method: "GET",
            },

            // INTERNAL. Use GameServer.onlineserver.findById() instead.
            "prototype$__findById__onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "GET",
            },

            // INTERNAL. Use GameServer.onlineserver.destroyById() instead.
            "prototype$__destroyById__onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GameServer.onlineserver.updateById() instead.
            "prototype$__updateById__onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GameServer.onlineserver() instead.
            "prototype$__get__onlineserver": {
              isArray: true,
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "GET",
            },

            // INTERNAL. Use GameServer.onlineserver.create() instead.
            "prototype$__create__onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "POST",
            },

            // INTERNAL. Use GameServer.onlineserver.destroyAll() instead.
            "prototype$__delete__onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "DELETE",
            },

            // INTERNAL. Use GameServer.onlineserver.count() instead.
            "prototype$__count__onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#create
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/GameServers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#patchOrCreate
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/GameServers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#replaceOrCreate
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/GameServers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#upsertWithWhere
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/GameServers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#exists
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/GameServers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#findById
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/GameServers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#replaceById
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/GameServers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#find
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/GameServers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#findOne
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/GameServers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#updateAll
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/GameServers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#deleteById
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/GameServers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#count
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/GameServers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#prototype$patchAttributes
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/GameServers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#createChangeStream
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/GameServers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GameServer#createMany
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/GameServers",
              method: "POST",
            },

            // INTERNAL. Use Onlineshop.gameserver() instead.
            "::get::Onlineshop::gameserver": {
              url: urlBase + "/Onlineshops/:id/gameserver",
              method: "GET",
            },

            // INTERNAL. Use Onlineserver.gameserverid() instead.
            "::get::Onlineserver::gameserverid": {
              url: urlBase + "/Onlineservers/:id/gameserverid",
              method: "GET",
            },

            // INTERNAL. Use Inputserver.gameserverid() instead.
            "::get::Inputserver::gameserverid": {
              url: urlBase + "/Inputservers/:id/gameserverid",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GameServer#upsert
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#updateOrCreate
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#patchOrCreateWithWhere
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#update
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#destroyById
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#removeById
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GameServer#prototype$updateAttributes
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GameServer#modelName
        * @propertyOf lbServices.GameServer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GameServer`.
        */
        R.modelName = "GameServer";


            /**
             * @ngdoc method
             * @name lbServices.GameServer#gameprovider
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Fetches belongsTo relation gameprovider.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameProvider` object.)
             * </em>
             */
        R.gameprovider = function() {
          var TargetResource = $injector.get("GameProvider");
          var action = TargetResource["::get::GameServer::gameprovider"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.GameServer.onlineserver
     * @header lbServices.GameServer.onlineserver
     * @object
     * @description
     *
     * The object `GameServer.onlineserver` groups methods
     * manipulating `Onlineserver` instances related to `GameServer`.
     *
     * Call {@link lbServices.GameServer#onlineserver GameServer.onlineserver()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GameServer#onlineserver
             * @methodOf lbServices.GameServer
             *
             * @description
             *
             * Queries onlineserver of GameServer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R.onlineserver = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::get::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#count
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Counts onlineserver of GameServer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.onlineserver.count = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::count::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#create
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Creates a new instance in onlineserver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R.onlineserver.create = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::create::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#createMany
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Creates a new instance in onlineserver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R.onlineserver.createMany = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::createMany::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#destroyAll
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Deletes all onlineserver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.onlineserver.destroyAll = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::delete::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#destroyById
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Delete a related item by id for onlineserver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for onlineserver
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.onlineserver.destroyById = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::destroyById::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#findById
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Find a related item by id for onlineserver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for onlineserver
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R.onlineserver.findById = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::findById::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GameServer.onlineserver#updateById
             * @methodOf lbServices.GameServer.onlineserver
             *
             * @description
             *
             * Update a related item by id for onlineserver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GameServer id
             *
             *  - `fk` – `{*}` - Foreign key for onlineserver
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R.onlineserver.updateById = function() {
          var TargetResource = $injector.get("Onlineserver");
          var action = TargetResource["::updateById::GameServer::onlineserver"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Onlineserver
 * @header lbServices.Onlineserver
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Onlineserver` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Onlineserver",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Onlineservers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Onlineserver.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/Onlineservers/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use Onlineserver.gameserverid() instead.
            "prototype$__get__gameserverid": {
              url: urlBase + "/Onlineservers/:id/gameserverid",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#create
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Onlineservers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#patchOrCreate
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Onlineservers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#replaceOrCreate
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Onlineservers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#upsertWithWhere
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Onlineservers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#exists
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Onlineservers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#findById
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Onlineservers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#replaceById
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Onlineservers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#find
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Onlineservers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#findOne
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Onlineservers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#updateAll
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Onlineservers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#deleteById
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Onlineservers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#count
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Onlineservers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#prototype$patchAttributes
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Onlineservers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#createChangeStream
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Onlineservers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#getDailyOnlineServerDetail
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `from` – `{*=}` -
             *
             *  - `to` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyOnlineServerDetail": {
              url: urlBase + "/Onlineservers/getDailyOnlineServerDetail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#getDailyOnlineServerByGame
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `from` – `{*=}` -
             *
             *  - `to` – `{*=}` -
             *
             *  - `zoneid` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDailyOnlineServerByGame": {
              url: urlBase + "/Onlineservers/getDailyOnlineServerByGame",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#getOnlineServerByShop
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `filter` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getOnlineServerByShop": {
              url: urlBase + "/Onlineservers/getOnlineServerByShop",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#createMany
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Onlineservers",
              method: "POST",
            },

            // INTERNAL. Use GameServer.onlineserver.findById() instead.
            "::findById::GameServer::onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "GET",
            },

            // INTERNAL. Use GameServer.onlineserver.destroyById() instead.
            "::destroyById::GameServer::onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GameServer.onlineserver.updateById() instead.
            "::updateById::GameServer::onlineserver": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GameServers/:id/onlineserver/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GameServer.onlineserver() instead.
            "::get::GameServer::onlineserver": {
              isArray: true,
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "GET",
            },

            // INTERNAL. Use GameServer.onlineserver.create() instead.
            "::create::GameServer::onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "POST",
            },

            // INTERNAL. Use GameServer.onlineserver.createMany() instead.
            "::createMany::GameServer::onlineserver": {
              isArray: true,
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "POST",
            },

            // INTERNAL. Use GameServer.onlineserver.destroyAll() instead.
            "::delete::GameServer::onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver",
              method: "DELETE",
            },

            // INTERNAL. Use GameServer.onlineserver.count() instead.
            "::count::GameServer::onlineserver": {
              url: urlBase + "/GameServers/:id/onlineserver/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#upsert
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#updateOrCreate
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#patchOrCreateWithWhere
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#update
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#destroyById
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#removeById
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#prototype$updateAttributes
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Onlineserver` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Onlineserver#modelName
        * @propertyOf lbServices.Onlineserver
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Onlineserver`.
        */
        R.modelName = "Onlineserver";


            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#shop
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::Onlineserver::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Onlineserver#gameserverid
             * @methodOf lbServices.Onlineserver
             *
             * @description
             *
             * Fetches belongsTo relation gameserverid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Onlineserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R.gameserverid = function() {
          var TargetResource = $injector.get("GameServer");
          var action = TargetResource["::get::Onlineserver::gameserverid"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Inputserver
 * @header lbServices.Inputserver
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Inputserver` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Inputserver",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Inputservers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Inputserver.gameserverid() instead.
            "prototype$__get__gameserverid": {
              url: urlBase + "/Inputservers/:id/gameserverid",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#create
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Inputservers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#patchOrCreate
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Inputservers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#replaceOrCreate
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Inputservers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#upsertWithWhere
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Inputservers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#exists
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Inputservers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#findById
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Inputservers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#replaceById
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Inputservers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#find
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Inputservers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#findOne
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Inputservers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#updateAll
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Inputservers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#deleteById
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Inputservers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#count
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Inputservers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#prototype$patchAttributes
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Inputserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Inputservers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#createChangeStream
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Inputservers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#saveInputServer
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `startdate` – `{*=}` -
             *
             *  - `enddate` – `{*=}` -
             *
             *  - `gameserverid` – `{*=}` -
             *
             *  - `amount` – `{*=}` -
             *
             *  - `charge` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "saveInputServer": {
              url: urlBase + "/Inputservers/saveInputServer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#createMany
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Inputservers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Inputserver#upsert
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#updateOrCreate
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#patchOrCreateWithWhere
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#update
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#destroyById
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#removeById
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Inputserver#prototype$updateAttributes
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Inputserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Inputserver` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Inputserver#modelName
        * @propertyOf lbServices.Inputserver
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Inputserver`.
        */
        R.modelName = "Inputserver";


            /**
             * @ngdoc method
             * @name lbServices.Inputserver#gameserverid
             * @methodOf lbServices.Inputserver
             *
             * @description
             *
             * Fetches belongsTo relation gameserverid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Inputserver id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GameServer` object.)
             * </em>
             */
        R.gameserverid = function() {
          var TargetResource = $injector.get("GameServer");
          var action = TargetResource["::get::Inputserver::gameserverid"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Bill
 * @header lbServices.Bill
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Bill` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Bill",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Bills/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Bill.zones.findById() instead.
            "prototype$__findById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Bill.zones.destroyById() instead.
            "prototype$__destroyById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.updateById() instead.
            "prototype$__updateById__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.zones.link() instead.
            "prototype$__link__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.zones.unlink() instead.
            "prototype$__unlink__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.exists() instead.
            "prototype$__exists__zones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/zones/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Bill.billExp.findById() instead.
            "prototype$__findById__billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "GET",
            },

            // INTERNAL. Use Bill.billExp.destroyById() instead.
            "prototype$__destroyById__billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.billExp.updateById() instead.
            "prototype$__updateById__billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.zones() instead.
            "prototype$__get__zones": {
              isArray: true,
              url: urlBase + "/Bills/:id/zones",
              method: "GET",
            },

            // INTERNAL. Use Bill.zones.create() instead.
            "prototype$__create__zones": {
              url: urlBase + "/Bills/:id/zones",
              method: "POST",
            },

            // INTERNAL. Use Bill.zones.destroyAll() instead.
            "prototype$__delete__zones": {
              url: urlBase + "/Bills/:id/zones",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.zones.count() instead.
            "prototype$__count__zones": {
              url: urlBase + "/Bills/:id/zones/count",
              method: "GET",
            },

            // INTERNAL. Use Bill.billExp() instead.
            "prototype$__get__billExp": {
              isArray: true,
              url: urlBase + "/Bills/:id/billExp",
              method: "GET",
            },

            // INTERNAL. Use Bill.billExp.create() instead.
            "prototype$__create__billExp": {
              url: urlBase + "/Bills/:id/billExp",
              method: "POST",
            },

            // INTERNAL. Use Bill.billExp.destroyAll() instead.
            "prototype$__delete__billExp": {
              url: urlBase + "/Bills/:id/billExp",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.billExp.count() instead.
            "prototype$__count__billExp": {
              url: urlBase + "/Bills/:id/billExp/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#create
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Bills",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#patchOrCreate
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Bills",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#replaceOrCreate
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Bills/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#upsertWithWhere
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Bills/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#exists
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Bills/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#findById
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Bills/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#replaceById
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Bills/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#find
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Bills",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#findOne
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Bills/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#updateAll
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Bills/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#deleteById
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Bills/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#count
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Bills/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#prototype$patchAttributes
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Bills/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#createChangeStream
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Bills/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#deleteFromAmySystem
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "deleteFromAmySystem": {
              url: urlBase + "/Bills/amy-system-delete",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bill#createMany
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Bills",
              method: "POST",
            },

            // INTERNAL. Use Zones.bill.findById() instead.
            "::findById::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "GET",
            },

            // INTERNAL. Use Zones.bill.destroyById() instead.
            "::destroyById::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.updateById() instead.
            "::updateById::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Zones.bill.link() instead.
            "::link::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Zones.bill.unlink() instead.
            "::unlink::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.exists() instead.
            "::exists::Zones::bill": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Zones/:id/bill/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Zones.bill() instead.
            "::get::Zones::bill": {
              isArray: true,
              url: urlBase + "/Zones/:id/bill",
              method: "GET",
            },

            // INTERNAL. Use Zones.bill.create() instead.
            "::create::Zones::bill": {
              url: urlBase + "/Zones/:id/bill",
              method: "POST",
            },

            // INTERNAL. Use Zones.bill.createMany() instead.
            "::createMany::Zones::bill": {
              isArray: true,
              url: urlBase + "/Zones/:id/bill",
              method: "POST",
            },

            // INTERNAL. Use Zones.bill.destroyAll() instead.
            "::delete::Zones::bill": {
              url: urlBase + "/Zones/:id/bill",
              method: "DELETE",
            },

            // INTERNAL. Use Zones.bill.count() instead.
            "::count::Zones::bill": {
              url: urlBase + "/Zones/:id/bill/count",
              method: "GET",
            },

            // INTERNAL. Use BillZones.bill() instead.
            "::get::BillZones::bill": {
              url: urlBase + "/BillZones/:id/bill",
              method: "GET",
            },

            // INTERNAL. Use BillExp.bill() instead.
            "::get::BillExp::bill": {
              url: urlBase + "/BillExps/:id/bill",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Bill#upsert
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#updateOrCreate
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#patchOrCreateWithWhere
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#update
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#destroyById
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#removeById
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bill#prototype$updateAttributes
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Bill#modelName
        * @propertyOf lbServices.Bill
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Bill`.
        */
        R.modelName = "Bill";

    /**
     * @ngdoc object
     * @name lbServices.Bill.zones
     * @header lbServices.Bill.zones
     * @object
     * @description
     *
     * The object `Bill.zones` groups methods
     * manipulating `Zones` instances related to `Bill`.
     *
     * Call {@link lbServices.Bill#zones Bill.zones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Bill#zones
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Queries zones of Bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#count
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Counts zones of Bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.zones.count = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::count::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#create
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Creates a new instance in zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.create = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::create::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#createMany
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Creates a new instance in zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.createMany = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::createMany::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#destroyAll
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Deletes all zones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zones.destroyAll = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::delete::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#destroyById
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Delete a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zones.destroyById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::destroyById::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#exists
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Check the existence of zones relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.exists = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::exists::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#findById
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Find a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.findById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::findById::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#link
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Add a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.link = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::link::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#unlink
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Remove the zones relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.zones.unlink = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::unlink::Bill::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.zones#updateById
             * @methodOf lbServices.Bill.zones
             *
             * @description
             *
             * Update a related item by id for zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `fk` – `{*}` - Foreign key for zones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones.updateById = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::updateById::Bill::zones"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Bill.billExp
     * @header lbServices.Bill.billExp
     * @object
     * @description
     *
     * The object `Bill.billExp` groups methods
     * manipulating `BillExp` instances related to `Bill`.
     *
     * Call {@link lbServices.Bill#billExp Bill.billExp()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Bill#billExp
             * @methodOf lbServices.Bill
             *
             * @description
             *
             * Queries billExp of Bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R.billExp = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::get::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#count
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Counts billExp of Bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.billExp.count = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::count::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#create
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Creates a new instance in billExp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R.billExp.create = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::create::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#createMany
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Creates a new instance in billExp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R.billExp.createMany = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::createMany::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#destroyAll
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Deletes all billExp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.billExp.destroyAll = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::delete::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#destroyById
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Delete a related item by id for billExp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for billExp
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.billExp.destroyById = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::destroyById::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#findById
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Find a related item by id for billExp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for billExp
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R.billExp.findById = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::findById::Bill::billExp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Bill.billExp#updateById
             * @methodOf lbServices.Bill.billExp
             *
             * @description
             *
             * Update a related item by id for billExp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bill id
             *
             *  - `fk` – `{*}` - Foreign key for billExp
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R.billExp.updateById = function() {
          var TargetResource = $injector.get("BillExp");
          var action = TargetResource["::updateById::Bill::billExp"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BillZones
 * @header lbServices.BillZones
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BillZones` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BillZones",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BillZones/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BillZones.zones() instead.
            "prototype$__get__zones": {
              url: urlBase + "/BillZones/:id/zones",
              method: "GET",
            },

            // INTERNAL. Use BillZones.bill() instead.
            "prototype$__get__bill": {
              url: urlBase + "/BillZones/:id/bill",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#create
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BillZones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#patchOrCreate
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BillZones",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#replaceOrCreate
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BillZones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#upsertWithWhere
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BillZones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#exists
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BillZones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#findById
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BillZones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#replaceById
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BillZones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#find
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BillZones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#findOne
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BillZones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#updateAll
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/BillZones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#deleteById
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BillZones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#count
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BillZones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#prototype$patchAttributes
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillZones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BillZones/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#createChangeStream
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/BillZones/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#updateFromAmySystem
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number=}` -
             *
             *  - `zones` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "updateFromAmySystem": {
              url: urlBase + "/BillZones/amy-system-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillZones#createMany
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BillZones",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BillZones#upsert
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#updateOrCreate
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#patchOrCreateWithWhere
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#update
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#destroyById
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#removeById
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BillZones#prototype$updateAttributes
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillZones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillZones` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BillZones#modelName
        * @propertyOf lbServices.BillZones
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BillZones`.
        */
        R.modelName = "BillZones";


            /**
             * @ngdoc method
             * @name lbServices.BillZones#zones
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Fetches belongsTo relation zones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillZones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R.zones = function() {
          var TargetResource = $injector.get("Zones");
          var action = TargetResource["::get::BillZones::zones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BillZones#bill
             * @methodOf lbServices.BillZones
             *
             * @description
             *
             * Fetches belongsTo relation bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillZones id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::get::BillZones::bill"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BillExp
 * @header lbServices.BillExp
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BillExp` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BillExp",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BillExps/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BillExp.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/BillExps/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use BillExp.bill() instead.
            "prototype$__get__bill": {
              url: urlBase + "/BillExps/:id/bill",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#create
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BillExps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#patchOrCreate
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BillExps",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#replaceOrCreate
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BillExps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#upsertWithWhere
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BillExps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#exists
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BillExps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#findById
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BillExps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#replaceById
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BillExps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#find
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BillExps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#findOne
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BillExps/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#updateAll
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/BillExps/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#deleteById
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BillExps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#count
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BillExps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#prototype$patchAttributes
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillExp id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BillExps/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#createChangeStream
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/BillExps/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#deleteFromAmySystem
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "deleteFromAmySystem": {
              url: urlBase + "/BillExps/amy-system-delete",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#updateFromAmySystem
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number=}` -
             *
             *  - `shop` – `{*=}` -
             *
             *  - `bill` – `{*=}` -
             *
             *  - `photo` – `{*=}` -
             *
             *  - `billDate` – `{string=}` -
             *
             *  - `description` – `{*=}` -
             *
             *  - `amount` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "updateFromAmySystem": {
              url: urlBase + "/BillExps/amy-system-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BillExp#createMany
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BillExps",
              method: "POST",
            },

            // INTERNAL. Use Bill.billExp.findById() instead.
            "::findById::Bill::billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "GET",
            },

            // INTERNAL. Use Bill.billExp.destroyById() instead.
            "::destroyById::Bill::billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.billExp.updateById() instead.
            "::updateById::Bill::billExp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Bills/:id/billExp/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Bill.billExp() instead.
            "::get::Bill::billExp": {
              isArray: true,
              url: urlBase + "/Bills/:id/billExp",
              method: "GET",
            },

            // INTERNAL. Use Bill.billExp.create() instead.
            "::create::Bill::billExp": {
              url: urlBase + "/Bills/:id/billExp",
              method: "POST",
            },

            // INTERNAL. Use Bill.billExp.createMany() instead.
            "::createMany::Bill::billExp": {
              isArray: true,
              url: urlBase + "/Bills/:id/billExp",
              method: "POST",
            },

            // INTERNAL. Use Bill.billExp.destroyAll() instead.
            "::delete::Bill::billExp": {
              url: urlBase + "/Bills/:id/billExp",
              method: "DELETE",
            },

            // INTERNAL. Use Bill.billExp.count() instead.
            "::count::Bill::billExp": {
              url: urlBase + "/Bills/:id/billExp/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BillExp#upsert
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#updateOrCreate
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#patchOrCreateWithWhere
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#update
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#destroyById
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#removeById
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BillExp#prototype$updateAttributes
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillExp id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BillExp` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BillExp#modelName
        * @propertyOf lbServices.BillExp
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BillExp`.
        */
        R.modelName = "BillExp";


            /**
             * @ngdoc method
             * @name lbServices.BillExp#shop
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillExp id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::BillExp::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BillExp#bill
             * @methodOf lbServices.BillExp
             *
             * @description
             *
             * Fetches belongsTo relation bill.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BillExp id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bill` object.)
             * </em>
             */
        R.bill = function() {
          var TargetResource = $injector.get("Bill");
          var action = TargetResource["::get::BillExp::bill"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Memo
 * @header lbServices.Memo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Memo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Memo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Memos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Memo#create
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Memos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#patchOrCreate
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Memos",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#replaceOrCreate
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Memos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#upsertWithWhere
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Memos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#exists
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Memos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#findById
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Memos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#replaceById
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Memos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#find
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Memos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#findOne
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Memos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#updateAll
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Memos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#deleteById
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Memos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#count
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Memos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#prototype$patchAttributes
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Memo id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Memos/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#createChangeStream
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Memos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Memo#createMany
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Memos",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Memo#upsert
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#updateOrCreate
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#patchOrCreateWithWhere
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#update
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#destroyById
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#removeById
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Memo#prototype$updateAttributes
             * @methodOf lbServices.Memo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Memo id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Memo` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Memo#modelName
        * @propertyOf lbServices.Memo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Memo`.
        */
        R.modelName = "Memo";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PaparichPointApproval
 * @header lbServices.PaparichPointApproval
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PaparichPointApproval` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PaparichPointApproval",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/PaparichPointApprovals/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PaparichPointApproval.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/PaparichPointApprovals/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#create
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/PaparichPointApprovals",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#patchOrCreate
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/PaparichPointApprovals",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#replaceOrCreate
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/PaparichPointApprovals/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#upsertWithWhere
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/PaparichPointApprovals/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#exists
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/PaparichPointApprovals/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#findById
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/PaparichPointApprovals/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#replaceById
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/PaparichPointApprovals/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#find
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/PaparichPointApprovals",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#findOne
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/PaparichPointApprovals/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#updateAll
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/PaparichPointApprovals/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#deleteById
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/PaparichPointApprovals/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#count
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/PaparichPointApprovals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#prototype$patchAttributes
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaparichPointApproval id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/PaparichPointApprovals/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#createChangeStream
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/PaparichPointApprovals/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#getPointApprovalSummary
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `playtechid` – `{*=}` -
             *
             *  - `partnercode` – `{*=}` -
             *
             *  - `data` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getPointApprovalSummary": {
              url: urlBase + "/PaparichPointApprovals/getPointApprovalSummary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#approval
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `status` – `{*=}` -
             *
             *  - `id` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "approval": {
              url: urlBase + "/PaparichPointApprovals/approval",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#createMany
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/PaparichPointApprovals",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#upsert
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#updateOrCreate
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#patchOrCreateWithWhere
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#update
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#destroyById
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#removeById
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#prototype$updateAttributes
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaparichPointApproval id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaparichPointApproval` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PaparichPointApproval#modelName
        * @propertyOf lbServices.PaparichPointApproval
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PaparichPointApproval`.
        */
        R.modelName = "PaparichPointApproval";


            /**
             * @ngdoc method
             * @name lbServices.PaparichPointApproval#user
             * @methodOf lbServices.PaparichPointApproval
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaparichPointApproval id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::PaparichPointApproval::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ShopAddress
 * @header lbServices.ShopAddress
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ShopAddress` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ShopAddress",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ShopAddresses/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ShopAddress.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/ShopAddresses/:id/shop",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#create
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ShopAddresses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#patchOrCreate
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ShopAddresses",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#replaceOrCreate
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ShopAddresses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#upsertWithWhere
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ShopAddresses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#exists
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ShopAddresses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#findById
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ShopAddresses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#replaceById
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ShopAddresses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#find
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ShopAddresses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#findOne
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ShopAddresses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#updateAll
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ShopAddresses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#deleteById
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ShopAddresses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#count
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ShopAddresses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#prototype$patchAttributes
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopAddress id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ShopAddresses/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#createChangeStream
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ShopAddresses/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#upsertMany
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Create or update multiple ShopAddress records at once.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upsertMany": {
              url: urlBase + "/ShopAddresses/upsertMany",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#deleteByID
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Delete multiple ShopAddress records by an array of IDs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "deleteByID": {
              url: urlBase + "/ShopAddresses/deleteByID",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#createMany
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ShopAddresses",
              method: "POST",
            },

            // INTERNAL. Use Shop.shopAddress.findById() instead.
            "::findById::Shop::shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "GET",
            },

            // INTERNAL. Use Shop.shopAddress.destroyById() instead.
            "::destroyById::Shop::shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.shopAddress.updateById() instead.
            "::updateById::Shop::shopAddress": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Shops/:id/shopAddress/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Shop.shopAddress() instead.
            "::get::Shop::shopAddress": {
              isArray: true,
              url: urlBase + "/Shops/:id/shopAddress",
              method: "GET",
            },

            // INTERNAL. Use Shop.shopAddress.create() instead.
            "::create::Shop::shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress",
              method: "POST",
            },

            // INTERNAL. Use Shop.shopAddress.createMany() instead.
            "::createMany::Shop::shopAddress": {
              isArray: true,
              url: urlBase + "/Shops/:id/shopAddress",
              method: "POST",
            },

            // INTERNAL. Use Shop.shopAddress.destroyAll() instead.
            "::delete::Shop::shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress",
              method: "DELETE",
            },

            // INTERNAL. Use Shop.shopAddress.count() instead.
            "::count::Shop::shopAddress": {
              url: urlBase + "/Shops/:id/shopAddress/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#upsert
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#updateOrCreate
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#patchOrCreateWithWhere
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#update
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#destroyById
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#removeById
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#prototype$updateAttributes
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopAddress id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ShopAddress` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ShopAddress#modelName
        * @propertyOf lbServices.ShopAddress
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ShopAddress`.
        */
        R.modelName = "ShopAddress";


            /**
             * @ngdoc method
             * @name lbServices.ShopAddress#shop
             * @methodOf lbServices.ShopAddress
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ShopAddress id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::ShopAddress::shop"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InternalServerFile
 * @header lbServices.InternalServerFile
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InternalServerFile` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InternalServerFile",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/InternalServerFiles/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#create
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/InternalServerFiles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#patchOrCreate
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/InternalServerFiles",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#replaceOrCreate
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/InternalServerFiles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#upsertWithWhere
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/InternalServerFiles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#exists
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/InternalServerFiles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#findById
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/InternalServerFiles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#replaceById
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/InternalServerFiles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#find
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/InternalServerFiles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#findOne
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/InternalServerFiles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#updateAll
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/InternalServerFiles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#deleteById
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/InternalServerFiles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#count
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/InternalServerFiles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#prototype$patchAttributes
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerFile id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/InternalServerFiles/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#createChangeStream
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/InternalServerFiles/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#createMany
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/InternalServerFiles",
              method: "POST",
            },

            // INTERNAL. Use InternalServerOnlineSales.file() instead.
            "::get::InternalServerOnlineSales::file": {
              url: urlBase + "/InternalServerOnlineSales/:id/file",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#upsert
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#updateOrCreate
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#patchOrCreateWithWhere
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#update
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#destroyById
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#removeById
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerFile#prototype$updateAttributes
             * @methodOf lbServices.InternalServerFile
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerFile id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InternalServerFile#modelName
        * @propertyOf lbServices.InternalServerFile
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InternalServerFile`.
        */
        R.modelName = "InternalServerFile";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InternalServerOnlineSales
 * @header lbServices.InternalServerOnlineSales
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InternalServerOnlineSales` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InternalServerOnlineSales",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/InternalServerOnlineSales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InternalServerOnlineSales.shop() instead.
            "prototype$__get__shop": {
              url: urlBase + "/InternalServerOnlineSales/:id/shop",
              method: "GET",
            },

            // INTERNAL. Use InternalServerOnlineSales.game() instead.
            "prototype$__get__game": {
              url: urlBase + "/InternalServerOnlineSales/:id/game",
              method: "GET",
            },

            // INTERNAL. Use InternalServerOnlineSales.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/InternalServerOnlineSales/:id/file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#create
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/InternalServerOnlineSales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#patchOrCreate
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/InternalServerOnlineSales",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#replaceOrCreate
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/InternalServerOnlineSales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#upsertWithWhere
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/InternalServerOnlineSales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#exists
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/InternalServerOnlineSales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#findById
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/InternalServerOnlineSales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#replaceById
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/InternalServerOnlineSales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#find
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/InternalServerOnlineSales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#findOne
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/InternalServerOnlineSales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#updateAll
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/InternalServerOnlineSales/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#deleteById
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/InternalServerOnlineSales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#count
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/InternalServerOnlineSales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#prototype$patchAttributes
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerOnlineSales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/InternalServerOnlineSales/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#createChangeStream
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/InternalServerOnlineSales/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#getInternalServerPRFee
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `fileid` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getInternalServerPRFee": {
              url: urlBase + "/InternalServerOnlineSales/getInternalServerPRFee",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#createMany
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/InternalServerOnlineSales",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#upsert
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#updateOrCreate
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#patchOrCreateWithWhere
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#update
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#destroyById
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#removeById
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#prototype$updateAttributes
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerOnlineSales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerOnlineSales` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InternalServerOnlineSales#modelName
        * @propertyOf lbServices.InternalServerOnlineSales
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InternalServerOnlineSales`.
        */
        R.modelName = "InternalServerOnlineSales";


            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#shop
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Fetches belongsTo relation shop.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerOnlineSales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Shop` object.)
             * </em>
             */
        R.shop = function() {
          var TargetResource = $injector.get("Shop");
          var action = TargetResource["::get::InternalServerOnlineSales::shop"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#game
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Fetches belongsTo relation game.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerOnlineSales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Games` object.)
             * </em>
             */
        R.game = function() {
          var TargetResource = $injector.get("Games");
          var action = TargetResource["::get::InternalServerOnlineSales::game"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.InternalServerOnlineSales#file
             * @methodOf lbServices.InternalServerOnlineSales
             *
             * @description
             *
             * Fetches belongsTo relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InternalServerOnlineSales id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InternalServerFile` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("InternalServerFile");
          var action = TargetResource["::get::InternalServerOnlineSales::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(50)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp')
    .controller('authSignUpCtrl', authSignUpCtrl);

  /** @ngInject */
  function authSignUpCtrl($scope, validationService, toastr, userService, $state, stateService) {
    var vm = this;
    console.log("Inside authSignUpCtrl");

    $scope.register = {};
    $scope.states = [];
    //  [{
    //     "name": "Kuala Lumpur",
    //     "description": "Malaysia",
    //     "created": "2019-06-28T08:38:39.011Z",
    //     "lastupdated": "2019-09-30T09:37:24.025Z",
    //     "id": 2
    //   },
    //   {
    //     "name": "Selangor",
    //     "description": "Malaysia",
    //     "created": "2019-06-28T08:38:48.487Z",
    //     "lastupdated": "2019-06-28T08:58:04.745Z",
    //     "id": 3
    //   },
    //   {
    //     "name": "Seremban",
    //     "description": "Malaysia",
    //     "created": "2019-12-10T03:33:21.400Z",
    //     "lastupdated": "2020-07-06T03:50:28.023Z",
    //     "id": 5
    //   }
    // ];

    $scope.getStates = function () {
      var obj = {}

      obj.onSuccess = function (results) {
        $scope.states = results;
        $scope.register.state = _.first($scope.states);
      }
      stateService.getStates(obj);
    }
    $scope.getStates();


    $scope.validateRegistration = function (register) {
      console.log("Inside validateRegistration");
      console.log("Name = " + register.name);
      console.log("username = " + register.username);
      console.log("mobile = " + register.mobile);
      console.log("mobile = " + register.password);
      console.log("state = " + register.state.name);

      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(register.name) &&
        validationService.isEmptyOrNullValidation(register.username) &&
        validationService.isEmptyOrNullValidation(register.password) &&
        validationService.isEmptyOrNullValidation(register.mobile)) {

        if (!validationService.verifyPhoneFormat(register.mobile)) {
          isFormValidated = false;
          console.log("Not a numer");
          toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
        }

      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        toastr.error('Please fill all the Required Fields', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};
        Object.assign(obj.params, register);
        obj.params.credentials = {};
        obj.params.credentials.name = register.name;
        obj.params.credentials.mobile = "+60" + register.mobile;
        obj.params.credentials.statemap = [register.state.id];

        console.log("username is " + obj.params.username);
        console.log("name is " + obj.params.name);
        console.log("mobile is " + obj.params.mobile);
        console.log("password is " + obj.params.password);
        console.log("credentials is " + obj.params.credentials);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.register = {};
          toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
          $state.transitionTo("authSignIn");
        };

        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);

          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else if (err.status === 422) {
            $scope.register = {};
            toastr.error('Username or Mobile Already Exists', 'ERROR');
          } else {
            $scope.register = {};
            toastr.error('Unauthorized Access', 'ERROR');
          }
        };

        userService.userSignup(obj);
      }
    };
  }
})();
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.authSignIn")
    .controller("authSignInCtrl", authSignInCtrl);

  /** @ngInject */
  function authSignInCtrl(
    $scope,
    localStorage,
    $state,
    validationService,
    toastr,
    userService,
    $rootScope,
    $stateParams
  ) {
    var vm = this;

    console.log("Inside authSignInCtrl");
    $scope.user = {};

    var paramShop = $stateParams.shopid;
    var redirectTo = paramShop ? "main.operational.shop" : null;

    init();

    function init() {
      localStorage.clear();
    }

    vm.logar = logar;

    function logar() {
      var dadosUser = {
        user: vm.user,
        passWord: vm.passWord,
      };
      localStorage.setObject("dataUser", dadosUser);
      $state.go("main.dashboard");
    }

    $scope.login = function (user) {
      console.log("Login  Tapped");
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation(user.username) &&
        validationService.isEmptyOrNullValidation(user.password)
      ) {
        //No More Checks
        console.log("All Passed");
      } else {
        isFormValidated = false;
        toastr.error("Please fill all the Required Fields", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};
        obj.params = user;
        console.log("LoginID is " + obj.params.username);
        console.log("Password is " + obj.params.password);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS Login");
          console.log(result);
          $rootScope.userData = {};
          $rootScope.userData = result.user;
          $rootScope.userData.tokenId = result.id;
          $rootScope.userData.roleId = result.roleId;
          var localUser = {};
          //  userData.roleId = result.roleId;
          localUser.tokenId = result.id;
          //  userData.name = result.user.credentials.name;
          //  userData.mobile = result.user.credentials.mobile;
          localStorage.setObject("userData", $rootScope.userData);

          $state.go(
            redirectTo || "main.dashboard",
            redirectTo ? { shopid: paramShop } : null
          );
        };

        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "ERROR"
            );
          } else {
            $scope.user = {};
            toastr.error("Unauthorized Access", "ERROR");
          }
        };

        userService.userLogin(obj);
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("BlurAdmin.pages.config").run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart(
    $rootScope,
    $state,
    localStorage,
    OneSignalService
  ) {
    $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams) {
        $rootScope.userData = localStorage.getObject("userData");
        if (toState.authenticate && _.isEmpty($rootScope.userData)) {
          var hasShopFromAmySystem = toParams.shopid;

          // User isn’t authenticated
          $state.transitionTo("authSignIn", { shopid: hasShopFromAmySystem });
          event.preventDefault();
        }

        if (toState.authenticate && !_.isEmpty($rootScope.userData)) {
          OneSignalService.promptOnFirstLogin($rootScope.userData.id).then(
            function (result) {
              if (result.prompted && result.accepted) {
                console.log("✅ User subscribed to push notifications!");
              } else if (result.prompted && !result.accepted) {
                console.log("❌ User declined push notifications.");
              } else {
                console.log("⏭️ Skipped — already prompted before.");
              }
            }
          );
        }
      }
    );
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.dashboard")
    .controller("DashboardPageCtrl", DashboardPageCtrl);

  /** @ngInject */
  function DashboardPageCtrl(
    $scope,
    $filter,
    $state,
    editableOptions,
    editableThemes,
    collectorreportService,
    zoneService,
    gameService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    $rootScope,
    dashboardService
  ) {
    $scope.weekLabels = [];
    $scope.v2ListMerge = {};

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }
    window.a = $scope;

    $scope.dashboardV1List = [];
    $scope.getDashboardV1 = function () {
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value += !value ? "" : ")";
          obj.params.zoneid = value;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          if (result.result) {
            $scope.dashboardV1List = result.result;
            $scope.getDashboardV2();
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        dashboardService.getDashboardV1(obj);
      }
    };

    $scope.statesChartData = {};

    function calculateStatesData() {
      var result = {};
      $scope.dashboardV2List.forEach(function (data) {
        if (!result[data.stateid]) {
          result[data.stateid] = {};
        }

        if (!result[data.stateid][data.indate]) {
          result[data.stateid][data.indate] = {
            mactotal: 0,
            ontotal: 0,
          };
        }

        result[data.stateid][data.indate].mactotal += +data.mactotal;
        result[data.stateid][data.indate].ontotal += +data.ontotal;
      });

      Object.keys(result).map(function (stateid) {
        $scope.statesChartData[stateid] = [];
        var weekMachineData = [];
        var weekOnlinbeData = [];
        $scope.weekLabels.forEach(function (week, index) {
          var myStateData = result[stateid][week.indate] || {
            mactotal: 0,
            ontotal: 0,
          };
          if (index < 10) {
            weekMachineData.push(myStateData.mactotal);
          }

          if (index < 10) {
            weekOnlinbeData.push(myStateData.ontotal);
          }
        });
        $scope.statesChartData[stateid].push(weekMachineData);
        $scope.statesChartData[stateid].push(weekOnlinbeData);
      });
    }

    $scope.dashboardV2List = [];
    $scope.dashboardV2ListDailysales = [];
    $scope.getDashboardV2 = function () {
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value += !value ? "" : ")";
          obj.params.zoneid = value;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          if (result.result) {
            $scope.dashboardV2List = result.result;
            calculateStatesData();

            var allZones = [];
            $scope.dashboardV2List.forEach(function (v2) {
              if (!allZones.includes(v2.zoneid)) {
                allZones.push(v2.zoneid);
              }
            });

            allZones.forEach(function (zone) {
              var matchList = $scope.dashboardV2List.filter(function (v2) {
                return v2.zoneid === zone;
              });

              if (!matchList.length) {
                return;
              }

              // get basic info like zone, state
              var detail = matchList[0];
              detail.weekLabels = [];

              detail.dailysales = [];
              $scope.weekLabels.forEach(function (week, index) {
                if (index < 10) {
                  detail.weekLabels.push(week.indate);
                }
                var matchDateWithFullShopList = matchList.find(function (ml) {
                  return ml.indate === week.indate && ml.shoptype === "100%";
                });

                var matchDateWithHalfShopList = matchList.find(function (ml) {
                  return ml.indate === week.indate && ml.shoptype === "5/5";
                });

                if (!matchDateWithFullShopList) {
                  detail.dailysales.push({
                    indate: week.indate,
                    displayDate: week.displayDate,
                    shoptype: "100%",
                  });
                } else {
                  detail.dailysales.push(
                    Object.assign(matchDateWithFullShopList, week)
                  );
                }

                if (!matchDateWithHalfShopList) {
                  detail.dailysales.push({
                    indate: week.indate,
                    displayDate: week.displayDate,
                    shoptype: "5/5",
                  });
                } else {
                  detail.dailysales.push(
                    Object.assign(matchDateWithHalfShopList, week)
                  );
                }
              });

              $scope.dashboardV2ListDailysales.push(detail);
            });

            var v2ListMergeResult = {};
            $scope.dashboardV2List.forEach(function (v2) {
              if (!v2ListMergeResult[v2.zoneid]) {
                v2ListMergeResult[v2.zoneid] = {};
              }

              if (!v2ListMergeResult[v2.zoneid][v2.indate]) {
                v2ListMergeResult[v2.zoneid][v2.indate] = {
                  mactotal: 0,
                  ontotal: 0,
                };
              }

              v2ListMergeResult[v2.zoneid][v2.indate].mactotal += Number(
                v2.mactotal
              );

              v2ListMergeResult[v2.zoneid][v2.indate].ontotal += Number(
                v2.ontotal
              );
            });

            Object.keys(v2ListMergeResult).map(function (zoneid) {
              $scope.v2ListMerge[zoneid] = [];
              var weekMachineData = [];
              var weekOnlinbeData = [];
              $scope.weekLabels.forEach(function (week, index) {
                var myZoneData = v2ListMergeResult[zoneid][week] || {
                  mactotal: 0,
                  ontotal: 0,
                };

                if (index < 10) {
                  weekMachineData.push(myZoneData.mactotal);
                }

                if (index < 10) {
                  weekOnlinbeData.push(myZoneData.ontotal);
                }
              });

              $scope.v2ListMerge[zoneid].push(weekMachineData);
              $scope.v2ListMerge[zoneid].push(weekOnlinbeData);
            });

            if ($scope.dashboardV1List.length > 0) {
              for (var i = 0; i < $scope.dashboardV1List.length; i++) {
                $scope.dashboardV1List[i].weekLabels = [];
                for (
                  var j = 0;
                  j <
                  ($scope.weekLabels.length > 10
                    ? 10
                    : $scope.weekLabels.length);
                  j++
                ) {
                  $scope.dashboardV1List[i].weekLabels.push(
                    $scope.weekLabels[j].indate
                  );
                }
              }
            }
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        dashboardService.getDashboardV2(obj);
      }
    };

    $scope.setDateFromNow = function () {
      $scope.weekLabels = [];
      var now = moment().utcOffset(8).startOf("day").subtract(1, "day");

      for (var i = 0; i < now.clone().date(); i++) {
        $scope.weekLabels.push({
          indate: now.clone().subtract(i, "day").format("MM-DD"),
          displayDate: now.clone().subtract(i, "day").format("D/M/YY"),
        });
      }
    };

    $scope.init = function () {
      $scope.setDateFromNow();
      $scope.getDashboardV1();
    };

    $scope.init();

    /****************************************** */

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.dateList.from = new Date();
    $scope.dateList.to = new Date();
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.reportFilter = {};
    $scope.searchSales = function (reportFilter) {
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from),
          y = fd.getFullYear(),
          m = fd.getMonth() + 1;
        var date1 = y + "-" + m + "-" + (fd.getDate() - 1);

        var td = new Date($scope.dateList.to);
        y = td.getFullYear();
        m = td.getMonth() + 1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y + "-" + m + "-" + (td.getDate() - 1);

        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          if (result.result) {
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            var mactotalData = [];
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              mactotalData.push($scope.managePartnersalesList[i].mactotal);

              var onmacTotal =
                parseFloat($scope.managePartnersalesList[i].ontotal) +
                parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 250;

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;

    $scope.getTotalserver = function (items) {
      return (items && Array.isArray(items)
        ? items.map(function (x) {
            return Number(x.server) || 0;
          })
        : [items.server]
      ).reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b);
      });
    };

    $scope.getTotalEWalletTotal = function (items) {
      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return Number(x.dewallet) || 0;
            })
          : [items.dewallet]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getTotalSales = function (items) {
      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return Number(x.sales) || 0;
            })
          : [items.sales]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getTotalontotal = function (items) {
      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return Number(x.ontotal) || 0;
            })
          : [items.ontotal]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getV2Server = function (items) {
      var server = items.servercompany || 0;
      return ($scope.getV2Totaltotal(items) * server) / 100;
    };

    $scope.getTotalServerClaim = function (items) {
      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return $scope.getV2Server(x) - Number(x.claim || 0);
            })
          : [$scope.getV2Server(items) - Number(items.claim || 0)]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getV2Totaltotal = function (items) {
      function getSalesByShopType(item) {
        return (
          Number(item.sales || 0) +
          Number(item.banksales || 0) -
          Number(item.bankoutsales || 0) +
          Number(item.dewallet || 0) +
          Number(item.dcc || 0)
        );
      }

      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return getSalesByShopType(x);
            })
          : [getSalesByShopType(items)]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getTotaltotal = function (items) {
      function getSalesByShopType(item) {
        return item.shoptype === "100%"
          ? Number(item.sales || 0) +
              Number(item.banksales || 0) -
              Number(item.bankoutsales || 0) +
              Number(item.dewallet || 0) +
              Number(item.dcc || 0)
          : Number(item.sales || 0);
      }

      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return getSalesByShopType(x);
            })
          : [getSalesByShopType(items)]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };
    $scope.getTotalshops = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.shopcount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };

    $scope.getTotalbanktotal = function (items) {
      if (items) {
        return (items && Array.isArray(items)
          ? items.map(function (x) {
              return x.banksales || 0;
            })
          : [items.banksales]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getTotalbankouttotal = function (items) {
      if (items) {
        return -(items && Array.isArray(items)
          ? items.map(function (x) {
              return x.bankoutsales || 0;
            })
          : [items.bankoutsales]
        ).reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
      }
    };

    $scope.getParsedBankOut = function (item) {
      return item.bankoutsales !== 0 ? -item.bankoutsales : 0;
    };

    $scope.viewStateDetail = function (stateid) {
      $scope.filterZone = {
        stateid: stateid,
      };
    };

    $scope.gotoDailyInvoice = function (data) {
      $state.go("main.invoices.dailyinvoices", {
        zoneid: data.zoneid,
        shoptype: data.shoptype,
      });
    };

    $scope.filterZone = {
      stateid: null,
    };

    $scope.monthLabels = ["May", "Jun", "Jul", "Aug", "Sep"];

    $scope.weekSeries = ["Machine (大机)", "Online (网机)"];

    $scope.backgroundColor = ["#dfb81c", "#2dacd1"];

    $scope.datasetOverride = [
      {
        fill: true,
        backgroundColor: [
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
          "#dfb81c",
        ],
      },
      {
        fill: true,
        backgroundColor: [
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
          "#2dacd1",
        ],
      },
    ];

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.dashboard")
    .service("dashboardService", dashboardService);

  /** @ngInject */
  function dashboardService(Machinesales) {
    var getDashboardV1 = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      // var td = new Date('07-01-2020');
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;
      //  var dailyDate = '2018-04-25';

      console.log("date", dailyDate);

      Machinesales.getDashboardV1({
        adate: dailyDate,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDashboardV2 = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      // var td = new Date('07-01-2020');
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + "1";

      // var dailyDate = '2018-04-21';
      console.log("date", dailyDate);

      Machinesales.getDashboardV2({
        adate: dailyDate,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getDashboardV1: getDashboardV1,
      getDashboardV2: getDashboardV2,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.paparichpointapproval")
    .controller("paparichPointApprovalPageCtrl", paparichPointApprovalPageCtrl);

  /** @ngInject */
  function paparichPointApprovalPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    zoneService,
    paparichpointapprovalService,
    roleService,
    validationService,
    $sce
  ) {
    $scope.isAdmin = $rootScope.userData.credentials.role === 1;
    $scope.isAmy = $rootScope.userData.credentials.role === 2;
    $scope.pointApprovalList = [];
    $scope.selectedPointApproval = null;
    $scope.errorMessage = "";
    $scope.allowToUpdate = true;
    $scope.allowToSubmit = true;
    var partnercode =
      $rootScope.userData.credentials && $rootScope.userData.credentials.partner
        ? $rootScope.userData.credentials.partner.code
        : null;
    var collectedDeposit =
      $rootScope.userData.credentials &&
      $rootScope.userData.credentials.collectedDeposit
        ? $rootScope.userData.credentials.collectedDeposit
        : 0;
    var panlimit =
      $rootScope.userData.credentials &&
      $rootScope.userData.credentials.pan_limit
        ? $rootScope.userData.credentials.pan_limit
        : 0;
    var rateCharge = 0.4;

    $scope.smartTablePageSize = 25;

    $scope.summary = {
      active: false,
      withdrawLimit: 0,
      depositCollected: 0,
      currentUserPointLimit: 0,
      unpaidInvoice: 0,
      estimateOutstanding: 0
    };

    $scope.formLoading = false;

    $scope.reportFilter = {
      from: moment().startOf("day").toDate(),
      to: moment().endOf("day").toDate()
    };

    $scope.isPartner =
      $rootScope.userData.credentials.role === 9 ||
      $rootScope.userData.credentials.role === 13;
    $scope.curentUserMasterID =
      $rootScope.userData.credentials.paparichMasterID;

    if ($scope.isPartner && !$scope.curentUserMasterID) {
      $scope.errorMessage =
        "No Paparich Master ID associated with the current user. Please contact administrator.";
      return;
    }

    $scope.onInputChanged = function () {
      $scope.$evalAsync(function () {
        $scope.recalulate();
      });
    };

    $scope.approvalStatus =
      paparichpointapprovalService.getPaparichApprovalStatus();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.openDetailInfo = function (pointApproval) {
      $scope.tableLoading = true;

      paparichpointapprovalService
        .getPointApprovalSummary({
          partnercode:
            pointApproval && pointApproval.partnercode
              ? pointApproval.partnercode
              : partnercode,
          playtechid:
            pointApproval && pointApproval.paparichMasterID
              ? pointApproval.paparichMasterID
              : $scope.curentUserMasterID,
          data: pointApproval
        })
        .then(function (res) {
          var topupCashoutSummary = res.result.topupCashoutSummary;
          var unpaidInvoice = res.result.unpaidInvoice;
          var latestPointApproval = res.result.pointApproval;

          if (!latestPointApproval) {
            $scope.selectedPointApproval = {
              date: new Date(),
              point: 0,
              pointafterrate: 0,
              status: "Pending",
              userid: $rootScope.userData.id,
              partnercode: partnercode,
              paparichMasterID: $scope.curentUserMasterID || "",
              withdrawlimit: topupCashoutSummary.online_witdraw_limit || 0,
              depositcollected: collectedDeposit || 0,
              panlimit: panlimit || 0,
              unpaidinvoice: unpaidInvoice.total_unpaid
                ? Number(unpaidInvoice.total_unpaid)
                : 0,
              totalpointaddedcount: topupCashoutSummary.total_topup_count || 0,
              totalpointadded: topupCashoutSummary.total_topup_amount || 0,
              totalpointaddedafterrate: 0
            };

            $scope.recalulate();
          } else {
            var isPending =
              latestPointApproval.status.toLowerCase() === "pending";
            var totalpointadded = isPending
              ? Number(topupCashoutSummary.total_topup_amount) || 0
              : Number(latestPointApproval.totalpointadded) || 0;
            var unpaidinvoice = isPending
              ? unpaidInvoice.total_unpaid
                ? Number(unpaidInvoice.total_unpaid)
                : 0
              : Number(latestPointApproval.unpaidinvoice) || 0;
            var totalpointaddedafterrate = isPending
              ? (Number(topupCashoutSummary.total_topup_amount) || 0) *
                rateCharge
              : Number(latestPointApproval.totalpointaddedafterrate) || 0;
            var pointafterrate = Number(latestPointApproval.point) * rateCharge;

            // show latest summary data when pending only. else show last updated saved data
            $scope.selectedPointApproval = {
              date: new Date(latestPointApproval.date),
              point: Number(latestPointApproval.point),
              pointafterrate: pointafterrate,
              id: latestPointApproval.id,
              status: latestPointApproval.status,
              partnercode: latestPointApproval.partnercode,
              paparichMasterID: latestPointApproval.paparichMasterID,
              withdrawlimit: isPending
                ? topupCashoutSummary.online_witdraw_limit || 0
                : Number(latestPointApproval.withdrawlimit) || 0,
              depositcollected:
                Number(latestPointApproval.depositcollected) || 0,
              panlimit: Number(latestPointApproval.panlimit) || 0,
              unpaidinvoice: unpaidinvoice,
              totalpointaddedcount: isPending
                ? topupCashoutSummary.total_topup_count || 0
                : Number(latestPointApproval.totalpointaddedcount) || 0,
              totalpointadded: totalpointadded,
              totalpointaddedafterrate: totalpointaddedafterrate,
              estimateoutstanding:
                unpaidinvoice + totalpointaddedafterrate + pointafterrate
            };
          }

          $scope.allowToUpdate =
            $scope.isPartner &&
            (!$scope.selectedPointApproval.id ||
              $scope.selectedPointApproval.status === "Pending");

          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl:
              "app/pages/paparichpointapproval/modals/pointApprovalFormModal.html",
            scope: $scope
          });
          modalInstance.result.then(function (isConfirm) {
            if (!isConfirm) {
              return;
            }
          });
        })
        .finally(function () {
          $scope.tableLoading = false;
        });
    };

    $scope.savePointApproval = function (close) {
      if (!$scope.selectedPointApproval.paparichMasterID) {
        toastr.warning("Paparich Master ID cannot be empty ", "WARNING");
        return;
      }

      $scope.formLoading = true;
      paparichpointapprovalService
        .savePaparichPointApproval($scope.selectedPointApproval)
        .then(
          function (res) {
            toastr.success("加分 saved successfully", "SUCCESS");
            $scope.load();

            $scope.selectedPointApproval = null;
            close();
          },
          function (err) {
            toastr.error(err.data.error.message, "ERROR");
          }
        )
        .finally(function () {
          $scope.formLoading = false;
        });
    };

    $scope.recalulate = function () {
      if (!$scope.selectedPointApproval) {
        return;
      }

      $scope.selectedPointApproval.pointafterrate =
        $scope.selectedPointApproval.point * rateCharge;
      $scope.selectedPointApproval.totalpointaddedafterrate =
        $scope.selectedPointApproval.totalpointadded * rateCharge;
      $scope.selectedPointApproval.estimateoutstanding =
        $scope.selectedPointApproval.pointafterrate +
        $scope.selectedPointApproval.unpaidinvoice +
        $scope.selectedPointApproval.totalpointaddedafterrate;
    };

    $scope.init = function () {
      $scope.load();
    };

    $scope.load = function () {
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.reportFilter.from) &&
        validationService.isEmptyOrNullValidation($scope.reportFilter.to)
      ) {
        if (
          !validationService.verifyDate($scope.reportFilter.from) ||
          !validationService.verifyDate($scope.reportFilter.to)
        ) {
          isFormValidated = false;
          toastr.warning(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "Warning"
          );
        }
      } else {
        isFormValidated = false;
        toastr.warning("Please fill From and To Date for Search", "Warning");
      }

      if (!isFormValidated) {
        return;
      }

      if ($scope.isPartner) {
        $scope.reportFilter.userid = $rootScope.userData.id;
      }

      $scope.loading = true;

      $scope.pointApprovalList = [];

      paparichpointapprovalService
        .getPaparichPointApprovals($scope.reportFilter)
        .then(
          function (res) {
            $scope.pointApprovalList = res.map(function (item) {
              item.username = item.user ? item.user.username : "";
              return item;
            });
          },
          function (err) {
            toastr.error(err.data.error.message, "ERROR");
          }
        )
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.toggleApprovalDialog = function (status, close) {
      $scope.formLoading = true;

      paparichpointapprovalService
        .approveOrRejectPointApproval({
          id: $scope.selectedPointApproval.id,
          status: !!status
        })
        .then(
          function (res) {
            toastr.success(
              status ? "Approved successfully" : "Rejected successfully",
              "SUCCESS"
            );

            $scope.load();

            close();
          },
          function (err) {
            toastr.error(
              err.data.error.message || "Something went wrong",
              "FAILED"
            );
          }
        )
        .finally(function () {
          $scope.formLoading = false;
        });
    };

    $scope.toggleDeleteDialog = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/paparichpointapproval/modals/dangerModal.html",
        scope: $scope
      });

      $scope.confirmDelete = function () {
        $scope.loading = true;

        paparichpointapprovalService
          .deletePaparichPointApproval(id)
          .then(
            function (res) {
              toastr.success("Data deleted successfully", "SUCCESS");

              modalInstance.close();

              $scope.load();
            },
            function (err) {
              toastr.error(
                err.data.error.message || "Something went wrong",
                "FAILED"
              );

              $scope.loading = false;
            }
          )
          .finally(function () {});
      };
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        from: null,
        to: null
      };
    };

    $scope.init();
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.paparichpointapproval")
    .service("paparichpointapprovalService", paparichpointapprovalService);

  /** @ngInject */
  function paparichpointapprovalService(PaparichPointApproval) {
    var getUserPointInfo = function (username) {
      return PaparichPointApproval.getUserPointInfo({ username: username })
        .$promise;
    };
    var getPaparichApprovalStatus = function () {
      return [
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" }
      ];
    };
    var getPaparichPointApprovals = function (obj) {
      var where = {};
      if (obj.userid) {
        where.userid = obj.userid;
      }

      where.date = {
        between: [
          moment(obj.from).format("YYYY-MM-DD"),
          moment(obj.to).format("YYYY-MM-DD")
        ]
      };

      return PaparichPointApproval.find({
        filter: {
          where: where,
          order: ["date DESC", "created DESC"],
          include: ["user"]
        }
      }).$promise;
    };

    var deletePaparichPointApproval = function (id) {
      return PaparichPointApproval.deleteById({
        id: id
      }).$promise;
    };

    var savePaparichPointApproval = function (obj) {
      var date = new Date();

      return obj.id
        ? PaparichPointApproval.prototype$patchAttributes({
            id: obj.id,
            point: obj.point,
            lastupdated: date
          }).$promise
        : PaparichPointApproval.create({
            status: obj.status,
            point: obj.point,
            paparichMasterID: obj.paparichMasterID,
            partnercode: obj.partnercode,
            panlimit: obj.panlimit,
            depositcollected: obj.depositcollected,
            created: date,
            lastupdated: date,
            date: moment(obj.date).format("YYYY-MM-DD"),
            userid: obj.userid
          }).$promise;
    };

    var approveOrRejectPointApproval = function (obj) {
      return PaparichPointApproval.approval(obj).$promise;
    };

    var getPointApprovalSummary = function (obj) {
      return PaparichPointApproval.getPointApprovalSummary(obj).$promise;
    };

    return {
      getPaparichPointApprovals: getPaparichPointApprovals,
      deletePaparichPointApproval: deletePaparichPointApproval,
      approveOrRejectPointApproval: approveOrRejectPointApproval,
      getPaparichApprovalStatus: getPaparichApprovalStatus,
      savePaparichPointApproval: savePaparichPointApproval,
      getUserPointInfo: getUserPointInfo,
      getPointApprovalSummary: getPointApprovalSummary
    };
  }
})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal,
    validationService, toastr, userService, $state, $rootScope, roleService) {

    console.log("Inside ProfilePageCtrl");

    //Getting Roles
    $scope.manageRoleList = [];
    $scope.initManageRole = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };

    $scope.initManageRole();

    $scope.manageProfile = {};
    $scope.manageProfile = $rootScope.userData;
    // $scope.manageProfile.id = $rootScope.userData.id;
    // $scope.manageProfile.name = $rootScope.userData.credentials.name;
    // $scope.manageProfile.mobile = $rootScope.userData.credentials.mobile;
    // $scope.manageProfile.role = $rootScope.userData.credentials.role;
    // $scope.manageProfile.credentials = $rootScope.userData.credentials;

    console.log($scope.manageProfile.id);


    $scope.udpateProfile = function (manageProfile) {
      console.log("Inside udpateProfile");
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(manageProfile.credentials.name) &&
        validationService.isEmptyOrNullValidation(manageProfile.password) &&
        validationService.isEmptyOrNullValidation(manageProfile.credentials.mobile)) {

        var phoneNumber = manageProfile.credentials.mobile;
        phoneNumber = phoneNumber.startsWith('+') ? phoneNumber.substring(2) : phoneNumber;

        if (!validationService.verifyPhoneFormat(phoneNumber)) {
          isFormValidated = false;
          console.log("Not a numer");
          toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
        }

        if (manageProfile.password !== manageProfile.confirmPassword) {
          isFormValidated = false;
          console.log("Not a numer");
          toastr.error('Password does not match', 'ERROR');
        }

      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        toastr.error('Please fill all the Required Fields', 'ERROR');
      }

      if (isFormValidated) {
        console.log("All cOmpleted");

        var obj = {};
        obj.params = {};
        obj.params = $scope.manageProfile;
        //obj.params.credentials = manageProfile.credentials;
        //obj.params.id = manageProfile.userId;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.register = {};
          toastr.success('Your Profile is updated. Please Login again', 'SUCCESS');
          $state.transitionTo("authSignIn");
        };

        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);

          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else if (err.status === 422) {
            $scope.register = {};
            toastr.error('Username or Mobile Already Exists', 'ERROR');
          } else {
            $scope.register = {};
            toastr.error('Unauthorized Access', 'ERROR');
          }
        };
        userService.saveUser(obj);

      }

    };




    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [{
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
        item.href = link;
      });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
        .then(function (result) {
          $scope.picture = result;
        });
    };

    $scope.showRoles = function (role) {
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.scanner")
    .controller("scannerPageCtrl", scannerPageCtrl);

  /** @ngInject */
  function scannerPageCtrl(
    $scope,
    shopService,
    machineService,
    toastr,
    $rootScope,
    scannerService
  ) {
    var html5QrCode;
    var cameraId;

    $scope.showCamera = false;

    $scope.list = {
      shops: [],
      types: [
        { label: "Scan In", value: "scan in" },
        { label: "Scan Out", value: "scan out" },
      ],
    };
    $scope.selected = {
      shop: "",
      type: $scope.list.types[0].value,
      remark: "",
    };

    function onScanSuccess(decodedText, decodedResult) {
      var obj = {};
      obj.code = decodedText;

      obj.onSuccess = function (result) {
        var stockObj = {};
        stockObj.params = {};
        console.log("machine code checking", result);

        stockObj.onSuccess = function (stockResult) {
          $scope.selected = {
            shop: "",
            type: $scope.list.types[0].value,
            remark: "",
          };

          toastr.success(
            "Machine " + stockObj.params.type + " success",
            "Success"
          );
        };

        stockObj.onFailure = function (stockErr) {
          console.log(stockErr);
          var msg =
            stockErr.data && stockErr.data.error && stockErr.data.error.message
              ? stockErr.data.error.message
              : "Something went wrong";
          toastr.error(msg, "Scan Failed");
        };

        if (!result.length) {
          toastr.error("Machine not found", "Error");
          return;
        }

        stockObj.params.machineid = result[0].id;
        stockObj.params.shopid = $scope.selected.shop.id;
        stockObj.params.type = $scope.selected.type;
        stockObj.params.remark = $scope.selected.remark;

        scannerService.saveStock(stockObj);
      };

      obj.onFailure = function (err) {
        console.log(err);
      };
      html5QrCode
        .stop()
        .then(function (ignore) {
          html5QrCode.clear();
          machineService.getMachineByCode(obj);
        })
        .catch(function (err) {
          console.log(err);
          toastr.error("Camara failed to stop. Please try again", "Error");
          // Stop failed, handle it.
        });
    }

    $scope.openCamera = function () {
      if (!$scope.selected.shop) {
        toastr.warning("Shop is required", "Warning");
        return;
      }
      Html5Qrcode.getCameras()
        .then(function (devices) {
          /**
           *
           * devices would be an array of objects of type:
           * { id: "id", label: "label" }
           */
          if (devices && devices.length) {
            cameraId = devices[0].id;

            html5QrCode = new Html5Qrcode(/* element id */ "reader");
            html5QrCode
              .start(
                { facingMode: "environment" },
                {
                  qrbox: { width: 200, height: 200 },
                  fps: 10, // Optional, frame per seconds for qr code scanning
                },
                onScanSuccess
              )
              .catch(function (err) {
                // Start failed, handle it.
              });
          }
        })
        .catch(function (err) {
          console.log("err", err);
          var msg = err || "Something went wrong";
          toastr.error(msg, "Error");
        });
    };

    $scope.init = function () {
      var zones = $rootScope.userData.credentials.zonemap;
      var role = $rootScope.userData.credentials.role;

      var obj = {};
      obj.params = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        $scope.list.shops = result;
        console.log(result);
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };

      if (role && [1, 5].includes(role)) {
        shopService.getShop(obj);
      } else if (zones && zones.length) {
        obj.params.zoneid = zones;
        shopService.getShopByZones(obj);
      }
    };

    $scope.init();

    // $scope.$watch("showCamera", function (currentVlaue, previousValue, c) {
    //   if (currentVlaue) {
    //     html5QrCode = new Html5Qrcode(/* element id */ "reader");
    //     html5QrCode
    //       .start(
    //         cameraId,
    //         {
    //           qrbox: { width: 200, height: 200 },
    //           fps: 10, // Optional, frame per seconds for qr code scanning
    //         },
    //         onScanSuccess
    //       )
    //       .catch(function (err) {
    //         // Start failed, handle it.
    //       });
    //   }
    // });
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.scanner")
    .service("scannerService", scannerService);

  /** @ngInject */
  function scannerService(StockTracking) {
    var saveStock = function (obj) {
      StockTracking.generateNew({
        machineid: Number(obj.params.machineid),
        shopid: Number(obj.params.shopid),
        remark: obj.params.remark,
        type: obj.params.type,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      saveStock: saveStock,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.shopad")
    .controller("shopadPageCtrl", shopadPageCtrl);

  /** @ngInject */
  function shopadPageCtrl(
    $scope,
    shopService,
    toastr,
    $rootScope,
    shopadService,
    NgMap,

    $uibModal,
    UploadService,
    partnerService
  ) {
    $scope.dpOpenStatus = {};
    $scope.showHeader = true;
    $scope.myUserID = $rootScope.userData.id;

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.isAdmin = $rootScope.userData.credentials.role == 1;
    $scope.isMarketing = $rootScope.userData.credentials.role == 14;

    $scope.formDisabled = false;

    $scope.selectedShopAd = null;
    $scope.manageShopAdList = [];
    $scope.loading = false;
    $scope.formLoading = false;
    $scope.manageShopList = [];
    $scope.searchShopList = [];

    $scope.reportFilter = {};

    $scope.reportFilter = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate()
    };

    $scope.smartTablePageSize = 25;

    $scope.saveShopAd = function () {
      if (
        !$scope.selectedShopAd.address ||
        !$scope.selectedShopAd.address.trim().length
      ) {
        toastr.warning("Address is required", "Required");
        return;
      }

      if (!$scope.selectedShopAd.contactName) {
        toastr.warning("联络人 is required", "Required");
        return;
      }

      var photoPormises = [];
      $scope.formLoading = true;

      $scope.selectedShopAd.photos
        .filter(function (photo) {
          return photo.file;
        })
        .forEach(function (photo) {
          photoPormises.push({
            file: photo.file
          });
        });

      Promise.all(
        photoPormises.length
          ? photoPormises.map(function (pro) {
              return new Promise(function (resolve) {
                UploadService.uploadFile(pro.file, "shop-ad").then(
                  function (res) {
                    return resolve({
                      url: res.data.url,
                      type: pro.type
                    });
                  },
                  function (err) {
                    return resolve({
                      url: "",
                      type: ""
                    });
                  }
                );
              });
            })
          : []
      ).then(function (photosres) {
        var body = {
          id: $scope.selectedShopAd.id,
          amount: Number($scope.selectedShopAd.amount),
          vipShopId:
            $scope.selectedShopAd && $scope.selectedShopAd.shop
              ? $scope.selectedShopAd.shop.id
              : null,
          address: $scope.selectedShopAd.address,
          contactName: $scope.selectedShopAd.contactName,
          contactPhoneNumbersOne: $scope.selectedShopAd.contactPhoneNumbersOne,
          contactPhoneNumbersTwo: $scope.selectedShopAd.contactPhoneNumbersTwo,
          createdBySupermanUserID:
            $scope.selectedShopAd.createdBySupermanUserID,
          photos: $scope.selectedShopAd.photos
            .filter(function (photo) {
              return !photo.file;
            })
            .concat(photosres)
            .map(function (photo) {
              return photo.url;
            })
        };

        shopadService
          .save(body)
          .then(
            function (res) {
              toastr.success("保存成功");

              $scope.back();

              $scope.load();
            },
            function (err) {
              console.log(err);
              toastr.error(err.data.message, "保存失败");
            }
          )
          .finally(function () {
            $scope.formLoading = false;
          });
      });
    };

    $scope.initManagePartner = function () {
      shopService
        .getShopByPartner(
          $rootScope.userData.credentials &&
            $rootScope.userData.credentials.partner
            ? $rootScope.userData.credentials.partner.id
            : 0
        )
        .then(
          function (result) {
            $scope.searchShopList = result.result || [];
          },
          function (err) {
            console.log(err);
          }
        );
    };

    $scope.init = function () {
      $scope.initManagePartner();
      setTimeout(function () {
        $scope.load();
      }, 1000);
    };

    $scope.load = function () {
      $scope.loading = true;
      $scope.manageShopAdList = [];

      if (!$scope.reportFilter.from || !$scope.reportFilter.to) {
        toastr.warning("Data is required", "Required");
        return;
      }

      shopadService
        .getList({
          startAt: moment($scope.reportFilter.from).format("YYYY-MM-DD"),
          endAt: moment($scope.reportFilter.to).format("YYYY-MM-DD")
        })
        .then(
          function (res) {
            $scope.manageShopAdList = res.data.map(function (item) {
              return $scope.formatToLocalDataFormat(item);
            });
          },
          function (err) {
            toastr.error(err.data.message, "加载失败");
          }
        )
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.editOrCreateShopAd = function (shopAd) {
      if (shopAd && shopAd.id) {
        $scope.selectedShopAd = shopAd;
      } else {
        $scope.selectedShopAd = $scope.formatToLocalDataFormat();

        $scope.formDisabled = false;
      }
    };

    $scope.formatToLocalDataFormat = function (data) {
      data = data || {};
      data.amount = Number(data.amount || 0);
      //  must before createdBySupermanUserID
      data.canDeleteData =
        data &&
        data.createdBySupermanUserID &&
        data.createdBySupermanUserID === $rootScope.userData.id;

      data.createdBySupermanUserID =
        data && data.id ? data.createdBySupermanUserID : $rootScope.userData.id;

      data.photos = (data && data.photos ? data.photos : []).map(
        function (photo) {
          return { url: photo };
        }
      );
      data.shop = data.shop
        ? { id: data.shop.vipShopId, code: data.shop.code }
        : null;

      return data;
    };

    $scope.back = function () {
      $scope.selectedShopAd = null;

      $scope.showHeader = false;
      window.scrollTo(0, 0);

      setTimeout(function () {
        $scope.showHeader = true;
        $scope.$apply();

        setTimeout(function () {
          $scope.$broadcast("stickyTableHeader:recalculate");
        }, 300);
      }, 100);
    };

    window["a"] = $scope;

    $scope.reset = function () {
      // $scope.reportFilter.zonepr = null;
    };

    $scope.deleteImage = function (index) {
      $scope.selectedShopAd.photos = $scope.selectedShopAd.photos.filter(
        function (photo, i) {
          return index !== i;
        }
      );
    };

    $scope.onFileChange = function (files) {
      if (!files.length) {
        return;
      }

      Array.from(files).forEach(function (file) {
        var reader = new FileReader();

        reader.addEventListener("load", function (result) {
          $scope.selectedShopAd.photos.unshift({
            buffer: new Uint8Array(reader.result),
            file: file,
            filename: file.name.toString().trim().replace(/ /g, ""),
            url: window.URL.createObjectURL(file),
            contentType: file.type
          });
        });

        // reader.readAsDataURL(file);
        reader.readAsArrayBuffer(file);
      });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = (Array.isArray(photos) ? photos : [photos]).map(
        function (photo) {
          return photo.url;
        }
      );

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg"
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%"
      };
    };

    $scope.confirmDeleteShopAd = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/shopad/modals/deleteShopAdModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          shopadService.delete(id).then(
            function (res) {
              toastr.success("Data is deleted successfully", "SUCCESS");
              $scope.manageShopAdList = $scope.manageShopAdList.filter(
                function (sad) {
                  return sad.id !== id;
                }
              );
            },
            function (err) {
              toastr.error(err.data.message, "DELETE FAILED");
            }
          );
        },
        function () {}
      );
    };

    $scope.onShopSelect = function (item) {
      if (!item || !item.id) {
        $scope.selectedShopAd.shop = null;
      }

      $scope.selectedShopAd.address =
        item && item.address ? item.address : null;
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.init();
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.shopad")
    .service("shopadService", shopadService);

  /** @ngInject */
  function shopadService($http) {
    var getList = function (obj) {
      return httpToSpidermanPRSystem("/public-shop-ad/list", "POST", obj);
    };

    var save = function (obj) {
      return httpToSpidermanPRSystem("/public-shop-ad", "POST", obj);
    };

    var deleteShopAd = function (id) {
      return httpToSpidermanPRSystem("/public-shop-ad/" + id, "DELETE");
    };

    var searchShopList = function (keyword, zoneprids, isAdmin) {
      return httpToSpidermanPRSystem("/public-shop-ad/search-shop", "POST", {
        keyword: keyword || "",
        vipZoneID: zoneprids || [],
        isAdmin: isAdmin || false
      });
    };

    var httpToSpidermanPRSystem = function (url, method, data, headers) {
      var myHeaders = Object.assign(
        {
          "x-api-token": "kNSoThTqR2"
        },
        headers || {}
      );
      return $http({
        method: method || "GET",
        url: "https://api.spiderman-pr.tswlab.com" + url,
        headers: myHeaders,
        data: data || null
      });
    };

    return {
      getList: getList,
      save: save,
      searchShopList: searchShopList,
      delete: deleteShopAd
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.shopaddress")
    .controller("shopaddressPageCtrl", shopaddressPageCtrl);

  /** @ngInject */
  function shopaddressPageCtrl(
    $scope,
    shopService,
    toastr,
    $rootScope,
    shopaddressService,
    NgMap,
    $timeout,
    zonePRService,
    $uibModal,
    UploadService,
    $injector,
    SweetAlert
  ) {
    $scope.shopAddressStatusList = shopaddressService.getShopAddressStatus();
    $scope.shopAddressPackageTypeList =
      shopaddressService.getShopAddressPackageType();
    $scope.modesApprovalStatusList =
      shopaddressService.getModesApprovalStatus();

    $scope.dpOpenStatus = {};
    $scope.showHeader = true;

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.lazyLoadGoogleMapsUrl =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBGLADk-ZHI7uo3fiyb9VyIqO60fwZYUDc&libraries=places";
    $scope.markerPos = null;

    $scope.mapCenter = "3.0738,101.5183";
    $scope.search = {
      address: "",
      lng: null,
      lat: null,
      googleMapsUrl: "",
      wazeUrl: ""
    };
    $scope.isAdmin = $rootScope.userData.credentials.role == 1;
    $scope.isMarketing = $rootScope.userData.credentials.role == 14;

    $scope.map;
    $scope.geocoder;

    // contain 1,2,3 only
    $scope.currentStep = 0;
    $scope.formDisabled = false;

    $scope.selectedShopAddress = null;
    $scope.manageShopAddressList = [];
    $scope.loading = false;
    $scope.formLoading = false;
    $scope.manageZonesPRList = [];
    $scope.manageSAJModes = [];
    $scope.reportFilter = {
      zonepr: null
    };

    $scope.reportFilter = {
      from: moment("20260430", "YYYYMMDD").startOf("day").toDate(),
      to: moment().endOf("day").toDate()
    };

    $scope.smartTablePageSize = 25;

    function initManageZonePR() {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageZonesPRList = result;
      };
      obj.onFailure = function (err) {};
      zonePRService.getZonesPR(obj);
    }

    $scope.saveShopAddress = function () {
      if ($scope.currentStep === 1) {
        $scope.saveStepOne();
      } else if ($scope.currentStep === 2) {
        $scope.saveStepTwo();
      } else if ($scope.currentStep === 3) {
        $scope.saveStepThree();
      }
    };

    $scope.saveStepThree = function () {
      if (!$scope.selectedShopAddress.photosAfterRenovation.length) {
        toastr.warning("装修后照片 is required", "Required");
        return;
      }

      if (
        !$scope.isAdmin &&
        $scope.selectedShopAddress.address.toLowerCase().trim() !==
          $scope.selectedShopAddress.confirmedAddress.toLowerCase().trim()
      ) {
        toastr.warning("水电单地址与之前不一样。请联络ADMIN。", "地址不匹配");
        return;
      }

      var photoPormises = [];
      $scope.formLoading = true;
      $scope.selectedShopAddress.photosAfterRenovation
        .filter(function (photo) {
          return photo.file;
        })
        .forEach(function (photo) {
          photoPormises.push({
            file: photo.file
          });
        });

      Promise.all(
        photoPormises.length
          ? photoPormises.map(function (pro) {
              return new Promise(function (resolve) {
                UploadService.uploadFile(pro.file, "shop-address").then(
                  function (res) {
                    return resolve({
                      url: res.data.url,
                      type: pro.type
                    });
                  },
                  function (err) {
                    return resolve({
                      url: "",
                      type: ""
                    });
                  }
                );
              });
            })
          : []
      ).then(function (photosres) {
        var photosAfterRenovation = [];

        photosres.forEach(function (photo) {
          photosAfterRenovation.push({ url: photo.url });
        });

        shopaddressService
          .saveShopAddressStepThree({
            id: $scope.selectedShopAddress.id,
            confirmedAddress: $scope.selectedShopAddress.confirmedAddress,
            photosAfterRenovation: photosAfterRenovation
              .concat(
                $scope.selectedShopAddress.photosAfterRenovation.filter(
                  function (photo) {
                    return !photo.file;
                  }
                )
              )
              .map(function (photo) {
                return photo.url;
              }),
            step: $scope.currentStep
          })
          .then(
            function (res) {
              toastr.success(" Data saved successfully.", "Success");
              $scope.back();

              $scope.load();
            },
            function (err) {
              console.log(err);
              toastr.error(err.data.message, "Failed to save data");
            }
          )
          .finally(function () {
            $scope.formLoading = false;
          });
      });
    };

    $scope.saveStepTwo = function () {
      $scope.formLoading = true;

      shopaddressService
        .saveShopAddressStepTwo({
          id: $scope.selectedShopAddress.id,
          step: $scope.currentStep
        })
        .then(
          function (res) {
            toastr.success(
              "Tenancy Agreement confirmed successfully" +
                (res.data.renovationCountdownDuration
                  ? " You have " +
                    res.data.renovationCountdownDuration +
                    " days left for renovation complete."
                  : ""),
              "Success"
            );

            $scope.back();

            $scope.load();
          },
          function (err) {
            console.log(err);
            toastr.error(
              err.data.message,
              "Failed to save Tenancy Agreement photos"
            );
          }
        )
        .finally(function () {
          $scope.formLoading = false;
        });
    };

    $scope.saveStepOne = function () {
      if (!$scope.selectedShopAddress.houseUnitNo) {
        toastr.warning("Unit/No. is required", "Required");
        return;
      }

      if (!$scope.selectedShopAddress.address) {
        toastr.warning("水电单 Address is required", "Required");
        return;
      }

      if (!$scope.selectedShopAddress.zonepr) {
        toastr.warning("Daerah PR is required", "Required");
        return;
      }

      if (!$scope.selectedShopAddress.personInCharge) {
        toastr.warning("联络人 is required", "Required");
        return;
      }

      if (!$scope.selectedShopAddress.phone) {
        toastr.warning("联络人电话 is required", "Required");
        return;
      }

      if (!$scope.selectedShopAddress.photosBeforeRenovation.length) {
        toastr.warning("装修前的照片 is required", "Required");
        return;
      }

      if (
        !$scope.selectedShopAddress.modes ||
        !$scope.selectedShopAddress.modes.length
      ) {
        toastr.warning("请选择至少一个模式A", "Required");
        return;
      }

      if (
        !$scope.selectedShopAddress.myModePackage ||
        !Object.keys($scope.selectedShopAddress.myModePackage || []).filter(
          function (mode) {
            return !!mode;
          }
        ).length
      ) {
        toastr.warning("请选择4D或Top Up (Paparich)", "Required");
        return;
      }

      var selectedModesDisplayText = $scope.shopAddressPackageTypeList
        .filter(function (key) {
          return $scope.selectedShopAddress.myModePackage[key.value];
        })
        .map(function (key) {
          return key.label;
        })
        .join(" and ");

      var pendingConfirmation = function () {
        return new Promise(function (resolve, reject) {
          if (!!$scope.selectedShopAddress.id) {
            resolve(true);
          } else {
            SweetAlert.swal(
              {
                title: "Confirm submit new address?",
                text: selectedModesDisplayText + " is/are selected",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#209e91",
                confirmButtonText: "Yes, Confirm and Submit!",
                closeOnConfirm: true
              },
              function (isConfirm) {
                if (isConfirm) {
                  resolve(true);
                } else {
                  reject(false);
                }
              }
            );
          }
        });
      };

      pendingConfirmation().then(function (confirm) {
        if (!confirm) {
          return;
        }

        var photoPormises = [];
        $scope.formLoading = true;
        $scope.selectedShopAddress.photosBeforeRenovation
          .filter(function (photo) {
            return photo.file;
          })
          .forEach(function (photo) {
            photoPormises.push({
              file: photo.file,
              type: "renovation"
            });
          });

        $scope.selectedShopAddress.photos
          .filter(function (photo) {
            return photo.file;
          })
          .forEach(function (photo) {
            photoPormises.push({
              file: photo.file,
              type: "electriBill"
            });
          });

        Promise.all(
          photoPormises.length
            ? photoPormises.map(function (pro) {
                return new Promise(function (resolve) {
                  UploadService.uploadFile(pro.file, "shop-address").then(
                    function (res) {
                      return resolve({
                        url: res.data.url,
                        type: pro.type
                      });
                    },
                    function (err) {
                      return resolve({
                        url: "",
                        type: ""
                      });
                    }
                  );
                });
              })
            : []
        ).then(function (photosres) {
          var photosBeforeRenovation = [];
          var photos = [];

          photosres.forEach(function (photo) {
            if (photo.type === "renovation") {
              photosBeforeRenovation.push({ url: photo.url });
            } else if (photo.type === "electriBill") {
              photos.push({ url: photo.url });
            }
          });

          var body = {
            id: $scope.selectedShopAddress.id,
            houseUnitNo: $scope.selectedShopAddress.houseUnitNo,
            address: $scope.selectedShopAddress.address,
            personInCharge: $scope.selectedShopAddress.personInCharge,
            phone: $scope.selectedShopAddress.phone,
            createdBySupermanUser: $scope.selectedShopAddress.id
              ? undefined
              : $rootScope.userData,
            zonepr: $scope.selectedShopAddress.zonepr
              ? { id: $scope.selectedShopAddress.zonepr.id }
              : null,
            modes: $scope.selectedShopAddress.modes,
            createdAtRemark: $scope.selectedShopAddress.createdAtRemark,
            remarkFromSuperman: $scope.selectedShopAddress.remarkFromSuperman,
            step: $scope.currentStep,
            modesType: $scope.shopAddressPackageTypeList
              .filter(function (key) {
                return $scope.selectedShopAddress.myModePackage[key.value];
              })
              .map(function (key) {
                return key.value;
              })
          };

          body.photosBeforeRenovation = photosBeforeRenovation
            .concat(
              $scope.selectedShopAddress.photosBeforeRenovation.filter(
                function (photo) {
                  return !photo.file;
                }
              )
            )
            .map(function (photo) {
              return photo.url;
            });
          //水电单照片
          body.photos = photos
            .concat(
              $scope.selectedShopAddress.photos.filter(function (photo) {
                return !photo.file;
              })
            )
            .map(function (photo) {
              return photo.url;
            });
          if (body.address == $scope.search.address) {
            body.lat = Number($scope.search.lat);
            body.lng = Number($scope.search.lng);
          } else {
            body.lat = null;
            body.lng = null;
          }

          shopaddressService
            .saveShopAddress(body)
            .then(
              function (res) {
                toastr.success("地址保存成功");

                $scope.back();

                $scope.load();
              },
              function (err) {
                console.log(err);
                toastr.error(err.data.message, "地址保存失败");
              }
            )
            .finally(function () {
              $scope.formLoading = false;
            });
        });
      });
    };

    function initManageSAJModes() {
      shopaddressService.getShopAddressModes().then(
        function (res) {
          $scope.manageSAJModes = res.data;
        },
        function (err) {}
      );
    }

    $scope.init = function () {
      initManageZonePR();
      initManageSAJModes();

      $scope.load();
    };

    $scope.load = function () {
      $scope.loading = true;
      $scope.manageShopAddressList = [];

      shopaddressService
        .getShopAddress({
          startAt: moment($scope.reportFilter.from).format("YYYY-MM-DD"),
          endAt: moment($scope.reportFilter.to).format("YYYY-MM-DD"),
          vipZoneprID: $scope.reportFilter.zonepr
            ? $scope.reportFilter.zonepr.id
            : null,
          userid:
            $scope.isAdmin || $scope.isMarketing ? null : $rootScope.userData.id
        })
        .then(
          function (res) {
            $scope.manageShopAddressList = res.data.map(function (item) {
              return $scope.formatToLocalDataFormat(item);
            });
          },
          function (err) {
            toastr.error(err.data.message, "地址加载失败");
          }
        )
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.editOrCreateShopAddress = function (shopAddress) {
      if (shopAddress && shopAddress.id) {
        $scope.formLoading = true;
        shopaddressService
          .getShopAddressDetail(shopAddress.id)
          .then(
            function (res) {
              $scope.selectedShopAddress = $scope.formatToLocalDataFormat(
                res.data
              );

              // 4 mean all field will disabled
              $scope.currentStep = $scope.selectedShopAddress.completedAt
                ? 4
                : $scope.selectedShopAddress.status === "Pending"
                  ? 1
                  : [
                        "Approved",
                        "Rejected",
                        "Admin Approved",
                        "Admin Rejected"
                      ].includes($scope.selectedShopAddress.status) &&
                      $scope.selectedShopAddress.renovationCountdownDuration !==
                        null
                    ? 3
                    : [
                          "Approved",
                          "Rejected",
                          "Admin Approved",
                          "Admin Rejected"
                        ].includes($scope.selectedShopAddress.status) &&
                        $scope.selectedShopAddress
                          .tenancyAggrementCountdownDuration !== null
                      ? 2
                      : 4;

              $scope.search.address = $scope.selectedShopAddress.address;

              $scope.formDisabled =
                $scope.currentStep === 4 ||
                ["Rejected", "Admin Rejected"].includes(
                  $scope.selectedShopAddress.status
                ) ||
                (!$scope.isAdmin &&
                  !!$scope.selectedShopAddress.confirmAddressAt);

              if (
                $scope.selectedShopAddress.lat &&
                $scope.selectedShopAddress.lng
              ) {
                $scope.search.lat = $scope.selectedShopAddress.lat;
                $scope.search.lng = $scope.selectedShopAddress.lng;

                $scope.setGoogleMapsAndWazeUrl(
                  $scope.search.lat,
                  $scope.search.lng
                );

                $scope.markerPos = $scope.search.lat + "," + $scope.search.lng;
                $scope.mapCenter = $scope.markerPos;
              }
            },
            function (err) {
              toastr.error(err.data.message, "地址详情加载失败");
            }
          )
          .finally(function () {
            $scope.formLoading = false;
          });
      } else {
        $scope.selectedShopAddress = $scope.formatToLocalDataFormat();
        $scope.currentStep = 1;
        $scope.formDisabled = false;
      }
    };

    $scope.formatToLocalDataFormat = function (data) {
      data = data || {};
      data.address =
        data && data.addresses && data.addresses.length
          ? data.addresses[0].name
          : "";
      data.confirmedAddress =
        data && data.confirmedAddress ? data.confirmedAddress : "";

      data.myModePackage = {};

      data.localfourDStatus = data && data.fourDStatus ? data.fourDStatus : "";
      data.localtopupStatus = data && data.topUpStatus ? data.topUpStatus : "";

      if (data.modesType && data.modesType.length) {
        data.modesType.forEach(function (mode) {
          data.myModePackage[mode] = true;
        });
      }

      if (data) {
        if (!data.localfourDStatus && data.myModePackage["4D"]) {
          data.localfourDStatus = "Pending";
        }

        if (!data.localtopupStatus && data.myModePackage["Top Up"]) {
          data.localtopupStatus = "Pending";
        }
      }

      data.approvalAtRemark =
        (data.topUpApprovalAtRemark ? data.topUpApprovalAtRemark + "\n" : "") +
        (data.fourDApprovalAtRemark ? data.fourDApprovalAtRemark + "\n" : "") +
        (data.approvalAtRemark ? data.approvalAtRemark : "");

      data.modesTitle = (data.modes || [])
        .map(function (mode) {
          return mode.title;
        })
        .join(",");
      data.photosBeforeRenovation = (
        data && data.photosBeforeRenovation ? data.photosBeforeRenovation : []
      ).map(function (url) {
        return { url: url };
      });
      data.photosAfterRenovation = (
        data && data.photosAfterRenovation ? data.photosAfterRenovation : []
      ).map(function (url) {
        return { url: url };
      });
      data.photos = (data && data.photos ? data.photos : []).map(
        function (url) {
          return { url: url };
        }
      );

      data.photosTenancyAgreement = (
        data && data.photosTenancyAgreement ? data.photosTenancyAgreement : []
      ).map(function (url) {
        return { url: url };
      });

      data.zonepr = $scope.manageZonesPRList.find(function (zone) {
        return data.zonepr && zone.id === data.zonepr.vipZonePRId;
      });

      return data;
    };

    $scope.onMarkerDragEnd = function (e) {
      var latLng = e.latLng;
      $scope.markerPos = latLng.lat() + "," + latLng.lng();
      $scope.mapCenter = $scope.markerPos;

      $scope.geocoder.geocode({ location: latLng }, function (results, status) {
        if (status === "OK" && results[0]) {
          $timeout(function () {
            $scope.search.address = results[0].formatted_address;
            $scope.search.lat = latLng.lat();
            $scope.search.lng = latLng.lng();

            $scope.selectedShopAddress.address = $scope.search.address;

            $scope.setGoogleMapsAndWazeUrl(
              $scope.search.lat,
              $scope.search.lng
            );
          });
        }
      });
    };

    $scope.openUrl = function (url) {
      window.open(url, "_blank");
    };

    $scope.setGoogleMapsAndWazeUrl = function (lat, lng) {
      $scope.search.googleMapsUrl =
        "https://www.google.com/maps/search/?api=1&query=" + lat + "," + lng;
      $scope.search.wazeUrl =
        "https://www.waze.com/ul?ll=" + lat + "," + lng + "&navigate=yes";
    };

    $scope.back = function () {
      $scope.selectedShopAddress = null;

      $scope.showHeader = false;
      window.scrollTo(0, 0);

      setTimeout(function () {
        $scope.showHeader = true;
        $scope.$apply();

        setTimeout(function () {
          $scope.$broadcast("stickyTableHeader:recalculate");
        }, 300);
      }, 100);
    };

    $scope.reset = function () {
      $scope.reportFilter.zonepr = null;
    };

    $scope.deleteImage = function (index, variableName) {
      $scope.selectedShopAddress[variableName] = $scope.selectedShopAddress[
        variableName
      ].filter(function (photo, i) {
        return index !== i;
      });
    };

    $scope.$on("mapInitialized", function (evt, map) {
      // Now `google` and `google.maps` are loaded!

      NgMap.getMap().then(function (obj) {
        $scope.map = obj;

        $timeout(function () {
          var input = document.getElementById("autocomplete");
          if (!input) return;

          $scope.geocoder = new google.maps.Geocoder();
          var autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: { country: "my" }
          });

          autocomplete.addListener("place_changed", function () {
            $scope.$apply(function () {
              var place = autocomplete.getPlace();
              if (!place.geometry) return;
              var loc = place.geometry.location;
              $scope.markerPos = loc.lat() + "," + loc.lng();

              $scope.mapCenter = $scope.markerPos;

              $scope.search.address = place.formatted_address;
              $scope.search.lat = loc.lat();
              $scope.search.lng = loc.lng();

              $scope.selectedShopAddress.address = $scope.search.address;

              $scope.setGoogleMapsAndWazeUrl(
                $scope.search.lat,
                $scope.search.lng
              );

              map.setCenter(place.geometry.location);
            });
          });
        });
      });
    });

    $scope.onFileChange = function (files, variableName) {
      if (!files.length) {
        return;
      }

      Array.from(files).forEach(function (file) {
        var reader = new FileReader();

        reader.addEventListener("load", function (result) {
          $scope.selectedShopAddress[variableName].unshift({
            buffer: new Uint8Array(reader.result),
            file: file,
            filename: file.name.toString().trim().replace(/ /g, ""),
            url: window.URL.createObjectURL(file),
            contentType: file.type
          });
        });

        // reader.readAsDataURL(file);
        reader.readAsArrayBuffer(file);
      });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = (Array.isArray(photos) ? photos : [photos]).map(
        function (photo) {
          return photo.url;
        }
      );

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg"
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%"
      };
    };

    $scope.confirmDeleteShopAddress = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/shopaddress/modals/deleteShopAddressModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          shopaddressService.deleteShopAddress(id).then(
            function (res) {
              toastr.success("Data is deleted successfully", "SUCCESS");
              $scope.manageShopAddressList =
                $scope.manageShopAddressList.filter(function (shopAddress) {
                  return shopAddress.id !== id;
                });
            },
            function (err) {
              toastr.error(err.data.message, "DELETE FAILED");
            }
          );
        },
        function () {}
      );
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.init();
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.shopaddress")
    .service("shopaddressService", shopaddressService);

  /** @ngInject */
  function shopaddressService($http) {
    var getShopAddressStatus = function () {
      return [
        { label: "Approved", value: "Approved" },
        { label: "Admin Approved", value: "Admin Approved" },
        { label: "Admin Rejected", value: "Admin Rejected" },
        { label: "Admin Terminated", value: "Admin Terminated" },
        { label: "Admin Cancelled", value: "Admin Cancelled" },
        { label: "Not My Area", value: "Not My Area" },
        { label: "Pending", value: "Pending" },
        { label: "Rejected", value: "Rejected" }
      ];
    };
    var getModesApprovalStatus = function () {
      return [
        { label: "Approved", value: "Approved" },
        { label: "Not My Area", value: "Not My Area" },
        { label: "Pending", value: "Pending" },
        { label: "Rejected", value: "Rejected" }
      ];
    };

    var getShopAddressPackageType = function () {
      return [
        { label: "4D", value: "4D" },
        { label: "Top Up (Paparich)", value: "Top Up" }
      ];
    };

    var getShopAddressModes = function (id) {
      return httpToSpidermanPRSystem("/public-csa/saj-modes", "GET");
    };

    var deleteShopAddress = function (id) {
      return httpToSpidermanPRSystem("/public-csa/" + id, "DELETE");
    };
    var getShopAddress = function (obj) {
      return httpToSpidermanPRSystem("/public-csa/list", "POST", obj);
    };

    var saveShopAddress = function (obj) {
      return httpToSpidermanPRSystem("/public-csa", "POST", obj);
    };

    var saveShopAddressStepTwo = function (obj) {
      return httpToSpidermanPRSystem("/public-csa/step-two", "POST", obj);
    };

    var saveShopAddressStepThree = function (obj) {
      return httpToSpidermanPRSystem("/public-csa/step-three", "POST", obj);
    };

    var getShopAddressDetail = function (id) {
      return httpToSpidermanPRSystem("/public-csa/" + id, "GET");
    };

    var httpToSpidermanPRSystem = function (url, method, data, headers) {
      var myHeaders = Object.assign(
        {
          "x-api-token": "kNSoThTqR2"
        },
        headers || {}
      );
      return $http({
        method: method || "GET",
        url: "https://api.spiderman-pr.tswlab.com" + url,
        headers: myHeaders,
        data: data || null
      });
    };

    return {
      getShopAddress: getShopAddress,
      saveShopAddress: saveShopAddress,
      getShopAddressDetail: getShopAddressDetail,
      getShopAddressStatus: getShopAddressStatus,
      saveShopAddressStepTwo: saveShopAddressStepTwo,
      saveShopAddressStepThree: saveShopAddressStepThree,
      deleteShopAddress: deleteShopAddress,
      getShopAddressModes: getShopAddressModes,
      getShopAddressPackageType: getShopAddressPackageType,
      getModesApprovalStatus: getModesApprovalStatus
    };
  }
})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.services")
    .factory("validationService", validationService);

  /** @ngInject */
  function validationService() {
    var obj = {};

    obj.verifyPhoneFormat = function (phoneNo) {
      //var expression1 = /^0\(?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      var expression1 = /^([0-9]{2})([0-9]{3})([0-9]{4}|[0-9]{5}|[0-9]{6})$/;
      return expression1.test(phoneNo);
    };

    obj.verifyEmailFormat = function (email) {
      var expression2 = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      return expression2.test(email);
    };

    obj.verifyAliasName = function (value) {
      var expression3 = /^([a-zA-Z0-9\s]){1,20}$/;
      return expression3.test(value);
    };
    obj.isEmptyOrNullValidation = function (value) {
      if (
        value === undefined ||
        value === "" ||
        value === null ||
        value === "null"
      ) {
        return false;
      } else {
        return true;
      }
    };

    obj.hasSpaces = function (value) {
      var expression4 = /^[a-zA-Z0-9_\-]+$/;
      return expression4.test(value);
    };

    //Checks that a password has a minimum of 6 characters, at least 1 uppercase letter, 1 lowercase letter, and 1 number with no spaces.
    obj.verifyPasswordPolicy = function (value) {
      var expression5 = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{6,})\S$/;
      return expression5.test(value);
    };

    obj.verifyDate = function (value) {
      // var expression6 = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
      // return expression6.test(value);
      return !isNaN(Date.parse(value));
    };

    obj.compareDates = function (value1, value2) {
      return value1.getTime() < value2.getTime() ? true : false;
    };

    return obj;
  }
})();

/**
 * @author dufrolabs
 * created on 29/06/2017
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.services")
    .service("localStorage", localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear,
    };

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage
        ? $window.localStorage[key] || defaultValue
        : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage
        ? angular.fromJson($window.localStorage[key] || "{}")
        : angular.fromJson($window.fakeLocalStorage[key] || "{}");
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        var columnToolbarOptions = $window.localStorage.getItem(
          "columnToolbarOptions"
        );

        $window.localStorage.clear();

        if (columnToolbarOptions) {
          setTimeout(function () {
            $window.localStorage.setItem(
              "columnToolbarOptions",
              columnToolbarOptions
            );
          });
        }
      }
    }
  }
})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('receiptService', receiptService);

  /** @ngInject */
  function receiptService(Receipts) {

  var getReceipts = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Receipts.find({
      filter: {
        where:{
          id: obj.params.receiptid
        }
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  return {
    getReceipts: getReceipts

  };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('rolemappingService', rolemappingService);

  /** @ngInject */
  function rolemappingService(RoleMapping) {

    var getRoleMappings = function(obj) {
      RoleMapping.find({
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getRoleMappingsbyID = function (obj) {
      RoleMapping.find({
        filter: {
          where: {
            and: [
              { principalId: obj.params.principalid },
              { principalType: "RoleMapping.USER" }
            ],
            include: ["role"]
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };
  
    var createRoleMapping = function(obj) {
      var date = new Date();
  
      RoleMapping.create({
        principalType: "RoleMapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
  
    var deleteRoleMapping = function(obj) {
  
      RoleMapping.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    var saveRoleMapping = function(obj) {
      var date = new Date();
  
      RoleMapping.prototype$patchAttributes({
        id: obj.params.id,
        principalType: "RoleMapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    return {
      getRoleMappings: getRoleMappings,
      createRoleMapping: createRoleMapping,
      deleteRoleMapping: deleteRoleMapping,
      saveRoleMapping: saveRoleMapping,
      getRoleMappingsbyID:getRoleMappingsbyID
    };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .factory('SheetJSExportService', SheetJSExportService);


  /** @ngInject */
    SheetJSExportService.inject = ['uiGridExporterService'];
        })();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.services")
    .service("userService", userService);

  /** @ngInject */
  function userService(User, $rootScope) {
    function getLoggedInUserStateMap() {
      return _.hasIn($rootScope.userData, "credentials.statemap") &&
        _.isArray($rootScope.userData.credentials.statemap)
        ? $rootScope.userData.credentials.statemap
        : [];
    }

    function getLoggedInUserZoneMap() {
      return _.hasIn($rootScope.userData, "credentials.zonemap") &&
        _.isArray($rootScope.userData.credentials.zonemap)
        ? $rootScope.userData.credentials.zonemap
        : [];
    }

    function setStateMapFromLoggedInUser(credentials) {
      credentials.statemap = getLoggedInUserStateMap();
      return credentials;
    }

    function setStateAndZoneMapFromLoggedInUser(credentials) {
      credentials.statemap = getLoggedInUserStateMap();
      credentials.zonemap = getLoggedInUserZoneMap();
      return credentials;
    }

    var userLogin = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      User.login({
        username: obj.params.username,
        password: obj.params.password,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var userSignup = function (obj) {
      var date = new Date();

      User.create({
        realm: "vip",
        username: obj.params.username,
        password: obj.params.password,
        credentials: obj.params.credentials,
        email: obj.params.credentials.mobile + "@vip-portal.com",
        emailVerified: false,
        status: "Active",
        created: date,
        lastUpdated: date,
        challenges: obj.params.challenges ? obj.params.challenges : null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var partnerSignup = function (obj) {
      var date = new Date();
      User.create({
        realm: "vip",
        username: obj.params.username,
        password: obj.params.password,
        credentials: setStateMapFromLoggedInUser(obj.params.credentials),
        email: obj.params.username + "@vip-portal.com",
        emailVerified: false,
        status: "Active",
        created: date,
        lastUpdated: date,
        challenges: obj.params.challenges ? obj.params.challenges : null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var collectorSignup = function (obj) {
      var date = new Date();
      User.create({
        realm: "vip",
        username: obj.params.username,
        password: obj.params.password,
        credentials: setStateAndZoneMapFromLoggedInUser(obj.params.credentials),
        email: obj.params.username + "@vip-portal.com",
        emailVerified: false,
        status: "Active",
        created: date,
        lastUpdated: date,
        challenges: obj.params.challenges ? obj.params.challenges : null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var userApproval = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      User.find({
        filter: {
          where: {
            emailVerified: false,
          },
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var userAccessApproved = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      console.log(obj.params.userId, obj.params.userId);
      User.prototype$patchAttributes({
        id: obj.params.userId,
        emailVerified: true,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getUsers = function (obj) {
      User.find({
        filter: {
          // where:{
          //   realm:"vip"
          // },
          include: ["roles"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getParterUsers = function (obj) {
      User.find({
        filter: {
          where: {
            and: [
              {
                realm: "vip",
              },
              {
                challenges: obj.params.parentid,
              },
            ],
          },
          include: "roles",
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };
    //emailVerified: true
    var getUsersMSync = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      User.find({
        filter: {
          where: {
            and: [
              {
                realm: "msync",
              },
              {
                emailVerified: "true",
              },
            ],
          },
          include: "roles",
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getUsersCSync = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      User.find({
        filter: {
          where: {
            and: [
              {
                realm: "csync",
              },
              {
                emailVerified: "true",
              },
            ],
          },
          include: "roles",
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getUsersCSyncVIP = function (obj) {
      User.find({
        filter: {
          where: {
            and: [
              {
                or: [
                  {
                    realm: "csync",
                  },
                  {
                    realm: "vip",
                  },
                ],
              },
              {
                emailVerified: "true",
              },
            ],
          },
          include: "roles",
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteUser = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      User.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };
    var saveUser = function (obj) {
      var date = new Date();

      User.prototype$patchAttributes({
        id: obj.params.id,
        password: obj.params.password,
        credentials: obj.params.credentials,
        emailVerified: obj.params.emailVerified,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var resetPassword = function (obj) {
      var date = new Date();

      User.prototype$patchAttributes({
        id: obj.params.id,
        password: obj.params.password,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var updateShopMap = function (obj) {
      var date = new Date();

      User.prototype$patchAttributes({
        id: obj.params.id,
        credentials: obj.params.credentials,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          ////$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getUsersFromList = function (obj) {
      User.find({
        filter: {
          where: {
            and: [
              {
                realm: "csync",
              },
              {
                id: {
                  inq: obj.params.userIDs,
                },
              },
            ],
          },
          include: ["roles"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      userLogin: userLogin,
      userSignup: userSignup,
      userApproval: userApproval,
      userAccessApproved: userAccessApproved,
      getUsers: getUsers,
      getUsersMSync: getUsersMSync,
      getUsersCSync: getUsersCSync,
      deleteUser: deleteUser,
      updateShopMap: updateShopMap,
      saveUser: saveUser,
      getParterUsers: getParterUsers,
      partnerSignup: partnerSignup,
      resetPassword: resetPassword,
      getUsersCSyncVIP: getUsersCSyncVIP,
      collectorSignup: collectorSignup,
      getUsersFromList: getUsersFromList,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive("importSheetJs", [SheetJSImportDirective]);


  /** @ngInject */


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
/**
 * Multi-select title display directive
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.theme").directive("multiSelectTitle", renderTitle);

  /** @ngInject */
  function renderTitle($timeout) {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ngModelCtrl) {
        // Watch for model changes and update the button title
        scope.$watch(
          function () {
            return ngModelCtrl.$modelValue;
          },
          function (newValue) {
            var selectedCount = Array.isArray(newValue) ? newValue.length : 0;
            // var title =
            //   selectedCount > 0
            //     ? selectedCount +
            //       " item" +
            //       (selectedCount > 1 ? "s" : "") +
            //       " selected"
            //     : "Select items...";

            element.selectpicker("refresh");

            $timeout(function () {
              // Find and update the selectpicker button's text
              var $button = element.parent(".btn-group").find("button");
              if ($button.length) {
                $button.find(".filter-option").text("All Columns");
              }
            }, 10);
          },
          true
        );
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  "use strict";

  angular.module("BlurAdmin.theme").component("tableScrollerBar", {
    bindings: {
      targetSelector: "@", // CSS selector for the target scrollable element
      parentClass: "@", // Class name of parent scrollable element (default: 'horizontal-scroll')
      height: "@", // Height of the scrollbar (default: 10px)
      trackColor: "@", // Background color of the track
      thumbColor: "@", // Color of the thumb
    },
    template:
      '<div class="sync-scrollbar-wrapper" ng-style="$ctrl.wrapperStyle">' +
      '<div class="sync-scrollbar-track" ng-style="$ctrl.trackStyle">' +
      '<div class="sync-scrollbar-thumb" ' +
      'ng-style="$ctrl.thumbStyle"' +
      'ng-mousedown="$ctrl.onThumbMouseDown($event)">' +
      "</div></div></div>",
    controller: [
      "$element",
      "$window",
      "$timeout",
      "$scope",
      function ($element, $window, $timeout, $scope) {
        var ctrl = this;
        var scrollContainer; // The element that will have overflow-x
        var targetElement; // The actual content (table)
        var isDragging = false;
        var dragStartX = 0;
        var scrollStartLeft = 0;

        // Default styles
        ctrl.wrapperStyle = {
          overflow: "hidden",
          width: "100%",
          margin: "0",
          padding: "8px 0",
          position: "sticky",
          left: 0,
          right: 0,
        };
        ctrl.trackStyle = {
          "background-color": "#f0f0f0",
          height: "6px",
          position: "relative",
          width: "100%",
        };
        ctrl.thumbStyle = {
          "background-color": "#666666",
          height: "100%",
          "border-radius": "5px",
          position: "absolute",
          left: "0",
          cursor: "pointer",
          transition: "background-color 0.2s",
        };

        ctrl.$onInit = function () {
          // Apply custom colors if provided
          if (ctrl.trackColor) {
            ctrl.trackStyle["background-color"] = ctrl.trackColor;
          }
          if (ctrl.thumbColor) {
            ctrl.thumbStyle["background-color"] = ctrl.thumbColor;
          }
          if (ctrl.height) {
            ctrl.trackStyle["height"] = ctrl.height;
          }

          // Find target element after DOM is ready
          $timeout(function () {
            findTargetElement();
            if (scrollContainer && targetElement) {
              setupScrollableContainer();
              setupScrollSync();
              updateScrollbar();
            } else {
            }
          }, 100);
        };

        // Find the target scrollable element
        var findTargetElement = function () {
          // Priority 1: Use explicit target selector if provided
          if (ctrl.targetSelector) {
            targetElement = angular.element(
              document.querySelector(ctrl.targetSelector)
            );
            if (targetElement.length) {
              scrollContainer = targetElement;
              return;
            }
          }

          // Priority 2: Find parent with the specified class (default: horizontal-scroll)
          var className = ctrl.parentClass || "horizontal-scroll";
          var parent = $element.parent();

          while (parent.length && parent[0] !== document.body) {
            if (parent.hasClass(className)) {
              scrollContainer = parent;

              // Find the widest child element (table, div, or any element)
              var children = scrollContainer.children();
              var widestChild = null;
              var maxWidth = 0;

              for (var i = 0; i < children.length; i++) {
                var child = children[i];
                // Skip the scrollbar component itself
                if (angular.element(child).hasClass("sync-scrollbar-wrapper")) {
                  continue;
                }

                var childWidth = child.scrollWidth || child.offsetWidth;
                if (childWidth > maxWidth) {
                  maxWidth = childWidth;
                  widestChild = child;
                }
              }

              if (widestChild) {
                targetElement = angular.element(widestChild);
                return;
              }

              break;
            }
            parent = parent.parent();
          }

          // Priority 3: Find sibling with largest scrollWidth
          var siblings = $element.parent().children();
          var widestSibling = null;
          var maxWidth = 0;

          for (var i = 0; i < siblings.length; i++) {
            var sibling = siblings[i];
            // Skip the scrollbar component itself
            if (angular.element(sibling).hasClass("sync-scrollbar-wrapper")) {
              continue;
            }

            var siblingWidth = sibling.scrollWidth || sibling.offsetWidth;
            if (siblingWidth > maxWidth) {
              maxWidth = siblingWidth;
              widestSibling = sibling;
            }
          }

          if (widestSibling) {
            targetElement = angular.element(widestSibling);
            scrollContainer = $element.parent();
            return;
          }
        };

        // Setup the container to be scrollable
        var setupScrollableContainer = function () {
          if (!scrollContainer || !scrollContainer[0]) return;

          // Make the container scrollable
          scrollContainer.css({
            "overflow-x": "auto",
            position: "relative",
          });
        };

        // Calculate scrollbar dimensions
        var calculateScrollbar = function () {
          if (
            !scrollContainer ||
            !scrollContainer[0] ||
            !targetElement ||
            !targetElement[0]
          ) {
            return null;
          }

          var containerWidth = scrollContainer[0].clientWidth;
          var contentWidth = targetElement[0].scrollWidth;
          var scrollLeft = scrollContainer[0].scrollLeft;

          // Calculate thumb width as percentage of visible area
          var thumbWidthPercent = (containerWidth / contentWidth) * 100;
          var thumbWidth = (containerWidth * thumbWidthPercent) / 100;

          // Ensure minimum thumb width
          thumbWidth = Math.max(thumbWidth, 30);

          // Calculate maximum scroll distance
          var maxScroll = contentWidth - containerWidth;

          // CRITICAL FIX: Calculate thumb position so it reaches the end
          // When scrollLeft = maxScroll, thumbLeft should = (containerWidth - thumbWidth)
          var scrollPercent = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          var maxThumbPosition = containerWidth - thumbWidth;
          var thumbLeft = scrollPercent * maxThumbPosition;
          return {
            containerWidth: containerWidth,
            contentWidth: contentWidth,
            scrollLeft: scrollLeft,
            thumbWidth: thumbWidth,
            thumbLeft: thumbLeft,
            maxThumbPosition: maxThumbPosition,
            visible: contentWidth > containerWidth,
          };
        };

        // Update scrollbar appearance
        var updateScrollbar = function () {
          var dimensions = calculateScrollbar();

          if (!dimensions) return;

          // Show/hide scrollbar based on whether content is scrollable
          ctrl.wrapperStyle["display"] = dimensions.visible ? "block" : "none";

          // Track should fill the entire wrapper (which is 100% of container)
          ctrl.trackStyle["width"] = "100%";

          // Update thumb size and position
          ctrl.thumbStyle["width"] = dimensions.thumbWidth + "px";
          ctrl.thumbStyle["left"] = dimensions.thumbLeft + "px";

          $scope.$applyAsync();
        };

        // Setup scroll synchronization
        var setupScrollSync = function () {
          // Listen to scroll container scroll
          scrollContainer.on("scroll", onTargetScroll);

          // Listen to window resize
          angular.element($window).on("resize", onResize);

          // Track click on scrollbar track
          var track = $element.find(".sync-scrollbar-track");
          track.on("mousedown", onTrackClick);

          // Watch for table content changes
          var observer = new MutationObserver(function () {
            $timeout(updateScrollbar, 100);
          });

          if (targetElement && targetElement[0]) {
            observer.observe(targetElement[0], {
              childList: true,
              subtree: true,
              attributes: true,
            });
          }

          // Store observer for cleanup
          ctrl._observer = observer;
        };

        // Handle target element scroll
        var onTargetScroll = function () {
          if (!isDragging) {
            updateScrollbar();
          }
        };

        // Handle window resize
        var onResize = function () {
          updateScrollbar();
        };

        // Handle click on track (scroll by page like native scrollbar)
        var onTrackClick = function (event) {
          if (angular.element(event.target).hasClass("sync-scrollbar-thumb")) {
            return; // Don't handle if clicking on thumb
          }

          var track = $element.find(".sync-scrollbar-track")[0];
          var trackRect = track.getBoundingClientRect();
          var clickX = event.clientX - trackRect.left;

          var dimensions = calculateScrollbar();
          if (!dimensions) return;

          var thumbRect = $element
            .find(".sync-scrollbar-thumb")[0]
            .getBoundingClientRect();
          var thumbCenter =
            thumbRect.left - trackRect.left + thumbRect.width / 2;

          // Determine direction: left or right of thumb
          var isClickBeforeThumb = clickX < thumbCenter;

          // Scroll by one page (container width)
          var pageScroll = dimensions.containerWidth * 0.9; // 90% of container width
          var currentScroll = scrollContainer[0].scrollLeft;
          var newScrollLeft;

          if (isClickBeforeThumb) {
            // Clicked before thumb - scroll left
            newScrollLeft = currentScroll - pageScroll;
          } else {
            // Clicked after thumb - scroll right
            newScrollLeft = currentScroll + pageScroll;
          }

          // Clamp to valid range
          var maxScroll = dimensions.contentWidth - dimensions.containerWidth;
          newScrollLeft = Math.max(0, Math.min(maxScroll, newScrollLeft));

          // Smooth scroll
          scrollContainer[0].scrollTo({
            left: newScrollLeft,
            behavior: "smooth",
          });
        };

        // Handle thumb drag start
        ctrl.onThumbMouseDown = function (event) {
          event.preventDefault();
          event.stopPropagation();

          isDragging = true;
          dragStartX = event.clientX;
          scrollStartLeft = scrollContainer[0].scrollLeft;

          ctrl.thumbStyle["cursor"] = "grabbing";
          ctrl.thumbStyle["background-color"] = ctrl.thumbColor || "#555";
          ctrl.thumbStyle["transition"] = "background-color 0.2s"; // Keep color transition, remove position transition

          // Add document-level listeners
          angular.element(document).on("mousemove", onThumbDrag);
          angular.element(document).on("mouseup", onThumbDragEnd);
        };

        // Handle thumb drag
        var onThumbDrag = function (event) {
          if (!isDragging) return;

          var deltaX = event.clientX - dragStartX;

          var dimensions = calculateScrollbar();
          if (!dimensions) return;

          var maxScroll = dimensions.contentWidth - dimensions.containerWidth;
          var maxThumbTravel =
            dimensions.containerWidth - dimensions.thumbWidth;

          // Calculate new scroll position based on thumb movement
          var scrollDelta =
            maxThumbTravel > 0 ? (deltaX / maxThumbTravel) * maxScroll : 0;
          var newScrollLeft = scrollStartLeft + scrollDelta;

          // Clamp to valid range
          newScrollLeft = Math.max(0, Math.min(maxScroll, newScrollLeft));

          scrollContainer[0].scrollLeft = newScrollLeft;
          updateScrollbar();
        };

        // Handle thumb drag end
        var onThumbDragEnd = function () {
          isDragging = false;

          ctrl.thumbStyle["cursor"] = "grab";
          ctrl.thumbStyle["background-color"] = ctrl.thumbColor || "#888";
          $scope.$applyAsync();

          // Remove document-level listeners
          angular.element(document).off("mousemove", onThumbDrag);
          angular.element(document).off("mouseup", onThumbDragEnd);
        };

        // Expose method to manually update scrollbar
        ctrl.update = function () {
          updateScrollbar();
        };

        // Listen for update events
        $scope.$on("syncScrollbar:update", function () {
          updateScrollbar();
        });

        // Cleanup
        ctrl.$onDestroy = function () {
          if (scrollContainer) {
            scrollContainer.off("scroll", onTargetScroll);
          }
          angular.element($window).off("resize", onResize);
          angular.element(document).off("mousemove", onThumbDrag);
          angular.element(document).off("mouseup", onThumbDragEnd);

          if (ctrl._observer) {
            ctrl._observer.disconnect();
          }
        };
      },
    ],
  });
})();

(function () {
  "use strict";

  angular.module("BlurAdmin.theme").directive("stickyOnScroll", [
    "$window",
    "$timeout",
    function ($window, $timeout) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          // ─── STATE VARIABLES ──────────────────────────────────────────────
          var isSticky = false;
          var tableContainer;
          var stickyThreshold = 68;
          var elementOriginalOffsetTop;
          var stickyClone;
          var stickyWrapper;
          var topScrollbar;
          var topScrollbarInner;
          var isSyncingScroll = false;
          var lastScrollLeft = 0;
          var lastVerticalScroll = 0;
          var focusedFilterInputIndex = -1;
          var focusedFilterInputValue = "";
          var isSyncingInput = false;
          var filterSyncInterval = null;
          var lastKnownScrollWidth = 0;
          var colspanCheckInterval = null;
          var lastColspanState = null;

          if (attrs.stickyThreshold) {
            stickyThreshold = parseInt(attrs.stickyThreshold);
          }

          // ─── UTILITY FUNCTIONS ────────────────────────────────────────────

          var hasVerticalScroll = function () {
            return document.documentElement.scrollHeight > $window.innerHeight;
          };

          var getTable = function () {
            return element.closest("table");
          };

          var findTableContainer = function () {
            var parent = element.parent();
            while (parent.length && parent[0] !== document.body) {
              var overflowX = parent.css("overflow-x");
              var overflow = parent.css("overflow");
              if (
                overflowX === "auto" ||
                overflowX === "scroll" ||
                overflow === "auto" ||
                overflow === "scroll"
              ) {
                return parent;
              }
              parent = parent.parent();
            }
            return null;
          };

          var getOriginalOffsetTop = function () {
            var rect = element[0].getBoundingClientRect();
            var scrollTop =
              $window.pageYOffset || document.documentElement.scrollTop;
            return rect.top + scrollTop;
          };

          var stripSmartTableAttrs = function (cloneEl) {
            var allEls = cloneEl.find("*").addBack();
            allEls.each(function (i, el) {
              var attrsToRemove = [];
              angular.forEach(el.attributes, function (attr) {
                if (attr.name.indexOf("st-") === 0) {
                  attrsToRemove.push(attr.name);
                }
              });
              attrsToRemove.forEach(function (name) {
                el.removeAttribute(name);
              });
            });
          };

          // ─── GET SORTABLE ROW ─────────────────────────────────────────────
          var getSortableRow = function (theadElement) {
            var sortableRow = theadElement.find("tr.sortable");
            if (sortableRow.length) {
              return sortableRow;
            }
            var allRows = theadElement.find("tr");
            return allRows.length > 0
              ? angular.element(allRows[0])
              : angular.element([]);
          };

          // ─── CHECK IF ELEMENT IS VISIBLE ──────────────────────────────────
          var isElementVisible = function (el) {
            var $el = angular.element(el);

            if ($el.hasClass("ng-hide")) {
              return false;
            }

            if ($el.css("display") === "none") {
              return false;
            }

            if (el.offsetWidth === 0) {
              return false;
            }

            var ngHide = $el.attr("ng-hide");
            if (ngHide && scope.$parent) {
              try {
                var hideValue = scope.$parent.$eval(ngHide);
                if (hideValue === true) {
                  return false;
                }
              } catch (e) {
                if (ngHide.indexOf("hideTableColumns.") === 0) {
                  var columnName = ngHide.replace("hideTableColumns.", "");
                  if (
                    scope.$parent.hideTableColumns &&
                    scope.$parent.hideTableColumns[columnName] === true
                  ) {
                    return false;
                  }
                }
              }
            }

            return true;
          };

          // ─── TRACK FOCUSED FILTER INPUT ───────────────────────────────────
          var saveFocusedFilterInputInfo = function () {
            var originalRows = element.find("tr");
            var originalFilterRow = angular.element(
              originalRows[originalRows.length - 1]
            );
            var originalInputs = originalFilterRow.find("input, select");

            originalInputs.each(function (index, input) {
              if (document.activeElement === input) {
                focusedFilterInputIndex = index;
                focusedFilterInputValue = angular.element(input).val() || "";
                return false;
              }
            });
          };

          // ─── REFOCUS FILTER INPUT ─────────────────────────────────────────
          var refocusFilterInput = function () {
            if (focusedFilterInputIndex === -1) return;

            $timeout(function () {
              var originalRows = element.find("tr");
              var originalFilterRow = angular.element(
                originalRows[originalRows.length - 1]
              );
              var originalInputs = originalFilterRow.find("input, select");

              if (originalInputs.length > focusedFilterInputIndex) {
                var $input = angular.element(
                  originalInputs[focusedFilterInputIndex]
                );
                $input[0].focus();

                if ($input[0].type === "text") {
                  var val = $input.val();
                  $input[0].setSelectionRange(val.length, val.length);
                }

                if (stickyClone) {
                  var clonedRows = stickyClone.find("tr");
                  var clonedFilterRow = angular.element(
                    clonedRows[clonedRows.length - 1]
                  );
                  var clonedInputs = clonedFilterRow.find("input, select");

                  if (clonedInputs.length > focusedFilterInputIndex) {
                    var $clonedInput = angular.element(
                      clonedInputs[focusedFilterInputIndex]
                    );
                    $timeout(function () {
                      $clonedInput[0].focus();

                      if ($clonedInput[0].type === "text") {
                        var val = $clonedInput.val();
                        $clonedInput[0].setSelectionRange(
                          val.length,
                          val.length
                        );
                      }
                    }, 50);
                  }
                }
              }

              focusedFilterInputIndex = -1;
              focusedFilterInputValue = "";
            }, 100);
          };

          // ─── SAVE SCROLL POSITION ─────────────────────────────────────────
          var saveScrollPosition = function () {
            if (tableContainer) {
              lastScrollLeft = tableContainer[0].scrollLeft;
            }
            var scrollTop =
              $window.pageYOffset || document.documentElement.scrollTop;
            lastVerticalScroll = scrollTop;
          };

          // ─── RESTORE SCROLL POSITION ──────────────────────────────────────
          var restoreScrollPosition = function () {
            if (tableContainer && lastScrollLeft > 0) {
              $timeout(function () {
                tableContainer[0].scrollLeft = lastScrollLeft;
                if (topScrollbar) {
                  topScrollbar[0].scrollLeft = lastScrollLeft;
                }
                syncStickyHeaderScroll(lastScrollLeft);
              }, 0);
            }
          };

          // ─── CHECK IF SCROLL POSITION WAS RESET ───────────────────────────
          var checkIfScrollReset = function () {
            var currentScrollTop =
              $window.pageYOffset || document.documentElement.scrollTop;
            var currentScrollLeft = tableContainer
              ? tableContainer[0].scrollLeft
              : 0;

            var verticalScrollChanged =
              Math.abs(currentScrollTop - lastVerticalScroll) > 100;
            var horizontalScrollReset =
              lastScrollLeft > 0 && currentScrollLeft === 0;

            return verticalScrollChanged || horizontalScrollReset;
          };

          // ─── COLUMN WIDTH SYNC ────────────────────────────────────────────
          var syncColumnWidths = function () {
            if (!stickyClone) return;

            var originalSortableRow = getSortableRow(element);
            var clonedSortableRow = getSortableRow(stickyClone);

            if (!originalSortableRow.length || !clonedSortableRow.length)
              return;

            var originalCells = originalSortableRow.find("th, td");
            var clonedCells = clonedSortableRow.find("th, td");

            var table = getTable();
            var tbody = table.find("tbody");
            var firstBodyRow = tbody.find("tr:first");
            var bodyCells = firstBodyRow.find("td");

            var visibleColumnMap = [];
            originalCells.each(function (index, cell) {
              var isVisible = isElementVisible(cell);
              visibleColumnMap.push(isVisible);
            });

            clonedCells.each(function (clonedIndex, clonedCell) {
              var $clonedCell = angular.element(clonedCell);
              var originalCell = originalCells[clonedIndex];

              if (!originalCell) return;

              var $originalCell = angular.element(originalCell);
              var isVisible = visibleColumnMap[clonedIndex];

              if (isVisible) {
                var width;
                if (bodyCells.length > clonedIndex) {
                  width = bodyCells[clonedIndex].getBoundingClientRect().width;
                } else {
                  width = originalCell.getBoundingClientRect().width;
                }

                $clonedCell.css({
                  width: width + "px",
                  "min-width": width + "px",
                  "max-width": width + "px",
                  display: "",
                  visibility: "visible",
                });
                $clonedCell.removeClass("ng-hide");
              } else {
                $clonedCell.css({
                  display: "none",
                  visibility: "hidden",
                  width: "0px",
                  "min-width": "0px",
                  "max-width": "0px",
                  padding: "0px",
                });
                $clonedCell.addClass("ng-hide");
              }
            });

            syncMatchingRows(bodyCells);
          };

          // ─── SYNC MATCHING ROWS ──────────────────────────────────────────
          var syncMatchingRows = function (bodyCells) {
            if (!stickyClone) return;

            var originalSortableRow = getSortableRow(element);
            var clonedSortableRow = getSortableRow(stickyClone);

            var originalCells = originalSortableRow.find("th, td");
            var sortableCellCount = originalCells.length;

            var originalRows = element.find("tr");
            var clonedRows = stickyClone.find("tr");

            clonedRows.each(function (rowIndex, row) {
              var $row = angular.element(row);
              var cells = $row.find("th, td");

              if ($row.hasClass("sortable")) {
                return;
              }

              var $originalRow = angular.element(originalRows[rowIndex]);
              var originalRowCells = $originalRow.find("th, td");

              if (cells.length === sortableCellCount) {
                cells.each(function (cellIndex, cell) {
                  var $cell = angular.element(cell);
                  var originalCell = originalCells[cellIndex];

                  if (!originalCell) return;

                  var isVisible = isElementVisible(originalCell);

                  if (bodyCells && bodyCells.length > cellIndex) {
                    var bodyCell = bodyCells[cellIndex];
                    var isBodyVisible = isElementVisible(bodyCell);
                    isVisible = isVisible && isBodyVisible;
                  }

                  if (isVisible) {
                    var width;
                    if (bodyCells && bodyCells.length > cellIndex) {
                      width =
                        bodyCells[cellIndex].getBoundingClientRect().width;
                    } else {
                      width = originalCell.getBoundingClientRect().width;
                    }

                    $cell.css({
                      width: width + "px",
                      "min-width": width + "px",
                      "max-width": width + "px",
                      display: "",
                      visibility: "visible",
                    });
                    $cell.removeClass("ng-hide");
                  } else {
                    $cell.css({
                      display: "none",
                      visibility: "hidden",
                      width: "0px",
                      "min-width": "0px",
                      "max-width": "0px",
                      padding: "0px",
                    });
                    $cell.addClass("ng-hide");
                  }
                });
              } else {
                cells.each(function (cellIndex, cell) {
                  var $cell = angular.element(cell);
                  var originalCell = originalRowCells[cellIndex];

                  if (!originalCell) return;

                  var $originalCell = angular.element(originalCell);

                  var colspan = $originalCell.attr("colspan");
                  if (colspan) {
                    $cell.attr("colspan", colspan);
                  }

                  var isVisible = isElementVisible(originalCell);

                  if (isVisible) {
                    var width = originalCell.getBoundingClientRect().width;

                    $cell.css({
                      width: width + "px",
                      "min-width": width + "px",
                      "max-width": width + "px",
                      display: "",
                      visibility: "visible",
                    });
                    $cell.removeClass("ng-hide");
                  } else {
                    $cell.css({
                      display: "none",
                      visibility: "hidden",
                      width: "0px",
                      "min-width": "0px",
                      "max-width": "0px",
                      padding: "0px",
                    });
                    $cell.addClass("ng-hide");
                  }
                });
              }
            });
          };

          // ─── BIND CLICK EVENTS ────────────────────────────────────────────
          var bindCloneEvents = function () {
            if (!stickyClone) return;

            var originalSortableRow = getSortableRow(element);
            var clonedSortableRow = getSortableRow(stickyClone);

            var originalCells = originalSortableRow.find("th");
            var clonedCells = clonedSortableRow.find("th");

            clonedCells.each(function (index, clonedCell) {
              angular.element(clonedCell).on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (originalCells[index]) {
                  angular.element(originalCells[index]).triggerHandler("click");
                }
              });
            });
          };

          // ─── FILTER INPUT SYNC ────────────────────────────────────────────
          // Replace the bindFilterInputSync function with this enhanced version:

          var bindFilterInputSync = function () {
            if (!stickyClone) return;

            var originalRows = element.find("tr");
            var clonedRows = stickyClone.find("tr");

            var originalFilterRow = angular.element(
              originalRows[originalRows.length - 1]
            );
            var clonedFilterRow = angular.element(
              clonedRows[clonedRows.length - 1]
            );

            var originalInputs = originalFilterRow.find("input, select");
            var clonedInputs = clonedFilterRow.find("input, select");

            clonedInputs.each(function (index, clonedInput) {
              var $clonedInput = angular.element(clonedInput);
              var $originalInput = angular.element(originalInputs[index]);

              if (!$originalInput.length) return;

              // Initial sync
              $clonedInput.val($originalInput.val());

              // CLONED → ORIGINAL sync
              $clonedInput.on("input change", function (e) {
                if (isSyncingInput) return;
                isSyncingInput = true;

                focusedFilterInputIndex = index;
                focusedFilterInputValue = $clonedInput.val() || "";
                saveScrollPosition();

                var clonedValue = $clonedInput.val();
                $originalInput.val(clonedValue);
                $originalInput.triggerHandler("input");
                $originalInput.triggerHandler("change");

                $timeout(function () {
                  var scrollReset = checkIfScrollReset();
                  restoreScrollPosition();

                  if (scrollReset) {
                    $timeout(function () {
                      refocusFilterInput();
                    }, 200);
                  }

                  isSyncingInput = false;
                }, 50);
              });

              // ORIGINAL → CLONED sync (bidirectional)
              $originalInput.on("input change", function (e) {
                if (isSyncingInput) return;
                isSyncingInput = true;

                var originalValue = $originalInput.val();

                // Only update if values differ to avoid loops
                if ($clonedInput.val() !== originalValue) {
                  $clonedInput.val(originalValue);
                  $clonedInput.triggerHandler("input");
                  $clonedInput.triggerHandler("change");
                }

                $timeout(function () {
                  isSyncingInput = false;
                }, 50);
              });

              // Track focus on cloned inputs
              $clonedInput.on("focus", function () {
                focusedFilterInputIndex = index;
                focusedFilterInputValue = $clonedInput.val() || "";
                saveScrollPosition();
              });

              $clonedInput.on("blur", function () {
                focusedFilterInputIndex = -1;
                focusedFilterInputValue = "";
              });

              // Track focus on original inputs
              $originalInput.on("focus", function () {
                focusedFilterInputIndex = index;
                focusedFilterInputValue = $originalInput.val() || "";
                saveScrollPosition();
              });

              $originalInput.on("blur", function () {
                focusedFilterInputIndex = -1;
                focusedFilterInputValue = "";
              });

              $clonedInput.on("keydown", function (e) {
                $originalInput.triggerHandler(e);
              });
            });

            watchFilterInputChanges(originalInputs, clonedInputs);
          };

          var watchFilterInputChanges = function (
            originalInputs,
            clonedInputs
          ) {
            if (filterSyncInterval) clearInterval(filterSyncInterval);

            filterSyncInterval = setInterval(function () {
              if (isSticky && topScrollbarInner) {
                var currentScrollWidth = getTable()[0].scrollWidth;
                if (currentScrollWidth !== lastKnownScrollWidth) {
                  lastKnownScrollWidth = currentScrollWidth;
                  topScrollbarInner.css("width", currentScrollWidth + "px");
                }
              }

              if (isSyncingInput) return;

              originalInputs.each(function (index, originalInput) {
                var $originalInput = angular.element(originalInput);
                var $clonedInput = angular.element(clonedInputs[index]);

                if (!$clonedInput.length) return;
                if (document.activeElement === $clonedInput[0]) return;
                if (document.activeElement === originalInput) return;

                var realVal = $originalInput.val();
                var cloneVal = $clonedInput.val();

                if (realVal !== cloneVal) {
                  isSyncingInput = true;
                  $clonedInput.val(realVal);
                  $originalInput.val(realVal);
                  isSyncingInput = false;
                }
              });
            }, 150);
          };

          // ─── WATCH HEADER CHANGES ─────────────────────────────────────────
          var watchHeaderChanges = function () {
            if (!stickyClone) return;

            var originalSortableRow = getSortableRow(element);
            var clonedSortableRow = getSortableRow(stickyClone);

            var originalCells = originalSortableRow.find("th");
            var clonedCells = clonedSortableRow.find("th");

            var observer = new MutationObserver(function (mutations) {
              var needsWidthRecalc = false;

              mutations.forEach(function (mutation) {
                if (mutation.attributeName === "colspan") {
                  needsWidthRecalc = true;
                }
              });

              originalCells.each(function (index, cell) {
                var clonedCell = clonedCells[index];
                if (clonedCell) {
                  angular
                    .element(clonedCell)
                    .attr("class", angular.element(cell).attr("class"));
                }
              });

              if (needsWidthRecalc) {
                $timeout(function () {
                  syncColumnWidths();
                }, 50);
              } else {
                syncColumnWidths();
              }
            });

            originalCells.each(function (i, cell) {
              observer.observe(cell, {
                attributes: true,
                attributeFilter: ["class", "style"],
              });
            });

            var allRows = element.find("tr");
            allRows.each(function (i, row) {
              var cells = angular.element(row).find("th, td");
              cells.each(function (j, cell) {
                observer.observe(cell, {
                  attributes: true,
                  attributeFilter: [
                    "colspan",
                    "ng-show",
                    "ng-hide",
                    "class",
                    "style",
                  ],
                });
              });
            });

            element.data("stickyObserver", observer);
          };

          var watchHideTableColumns = function () {
            if (scope.$parent && scope.$parent.hideTableColumns) {
              scope.$parent.$watch(
                "hideTableColumns",
                function (newVal, oldVal) {
                  if (newVal !== oldVal && isSticky) {
                    saveScrollPosition();
                    saveFocusedFilterInputInfo();

                    // CRITICAL: Use double $timeout to ensure colspan DOM updates complete
                    $timeout(function () {
                      // First timeout lets Angular finish digest
                      $timeout(function () {
                        syncColumnWidths();
                        syncTopScrollbarWidth();
                        updateStickyPosition();
                        restoreScrollPosition();

                        if (checkIfScrollReset()) {
                          refocusFilterInput();
                        }
                      }, 50); // Wait for DOM to fully settle after colspan changes
                    }, 0); // First timeout for digest cycle
                  }
                },
                true // deep watch
              );
            }
          };

          // ─── WATCH TABLE BODY COLUMN VISIBILITY ───────────────────────────
          var watchTableBodyColumns = function () {
            var table = getTable();
            if (!table.length) return;

            var tbody = table.find("tbody");
            if (!tbody.length) return;

            var firstRow = tbody.find("tr:first");
            if (!firstRow.length) return;

            var bodyCells = firstRow.find("td");

            var bodyObserver = new MutationObserver(function (mutations) {
              var needsRecalc = false;

              mutations.forEach(function (mutation) {
                if (
                  mutation.attributeName === "class" ||
                  mutation.attributeName === "ng-hide" ||
                  mutation.attributeName === "ng-show" ||
                  mutation.attributeName === "style" ||
                  mutation.attributeName === "colspan" // ADD: Watch colspan changes
                ) {
                  needsRecalc = true;
                }
              });

              if (needsRecalc && isSticky) {
                saveScrollPosition();
                saveFocusedFilterInputInfo();

                // CRITICAL: Defer recalculation to let DOM updates complete
                $timeout(function () {
                  $timeout(function () {
                    syncColumnWidths();
                    restoreScrollPosition();

                    if (checkIfScrollReset()) {
                      refocusFilterInput();
                    }
                  }, 50);
                }, 0);
              }
            });

            // Observe all cells in first few rows for visibility changes
            tbody
              .find("tr")
              .slice(0, 5)
              .each(function (i, row) {
                angular
                  .element(row)
                  .find("td")
                  .each(function (j, cell) {
                    bodyObserver.observe(cell, {
                      attributes: true,
                      attributeFilter: [
                        "class",
                        "ng-hide",
                        "ng-show",
                        "style",
                        "colspan", // ADD: Monitor colspan attribute
                      ],
                    });
                  });
              });

            element.data("stickyBodyObserver", bodyObserver);
          };

          // ─── WATCH COLSPAN CHANGES (Enhanced) ──────────────────────────────
          if (scope.$parent && scope.$parent.colspanSection) {
            scope.$parent.$watch(
              "colspanSection",
              function (newVal, oldVal) {
                if (newVal !== oldVal && isSticky) {
                  saveScrollPosition();
                  saveFocusedFilterInputInfo();

                  // CRITICAL: Double timeout for colspan changes
                  // First timeout waits for Angular digest
                  // Second timeout waits for DOM to render colspans
                  $timeout(function () {
                    $timeout(function () {
                      syncColumnWidths();
                      syncTopScrollbarWidth();
                      updateStickyPosition();
                      restoreScrollPosition();

                      if (checkIfScrollReset()) {
                        refocusFilterInput();
                      }
                    }, 100); // Increased delay for colspan recalculation
                  }, 0);
                }
              },
              true // deep watch
            );
          }

          // ─── ENHANCED COLSPAN POLLING ──────────────────────────────────────
          var checkColspanChanges = function () {
            if (!isSticky) return;

            var currentState = [];
            element.find("tr").each(function (i, row) {
              var rowState = [];
              angular
                .element(row)
                .find("th, td")
                .each(function (j, cell) {
                  var $cell = angular.element(cell);
                  var colspan = $cell.attr("colspan") || "1";
                  var ngShow = $cell.attr("ng-show") || "";
                  var ngHide = $cell.attr("ng-hide") || "";
                  var isHidden =
                    $cell.hasClass("ng-hide") ||
                    $cell.css("display") === "none";
                  rowState.push(
                    colspan + "|" + ngShow + "|" + ngHide + "|" + isHidden
                  );
                });
              currentState.push(rowState.join(","));
            });

            var stateString = currentState.join(";");
            if (lastColspanState !== null && lastColspanState !== stateString) {
              saveScrollPosition();
              saveFocusedFilterInputInfo();

              // CRITICAL: Defer recalc when colspan state changes
              $timeout(function () {
                $timeout(function () {
                  syncColumnWidths();
                  syncTopScrollbarWidth();
                  updateStickyPosition();
                  restoreScrollPosition();

                  if (checkIfScrollReset()) {
                    refocusFilterInput();
                  }
                }, 50);
              }, 0);
            }
            lastColspanState = stateString;
          };

          // Poll every 200ms when sticky is active (already in your code)
          var startColspanPolling = function () {
            if (!colspanCheckInterval) {
              colspanCheckInterval = setInterval(checkColspanChanges, 200);
            }
          };

          // ─── SYNC CELL TEXT ───────────────────────────────────────────────
          var syncCellText = function () {
            if (!stickyClone) return;

            var originalRows = element.find("tr");
            var clonedRows = stickyClone.find("tr");

            var originalFilterRow = angular.element(
              originalRows[originalRows.length - 1]
            );
            var clonedFilterRow = angular.element(
              clonedRows[clonedRows.length - 1]
            );

            var originalCells = originalFilterRow.find("th, td");
            var clonedCells = clonedFilterRow.find("th, td");

            originalCells.each(function (index, cell) {
              var $cell = angular.element(cell);
              var $clonedCell = angular.element(clonedCells[index]);

              if (!$clonedCell.length) return;
              if ($cell.find("input, select").length) return;

              var realHTML = $cell.html();
              var cloneHTML = $clonedCell.html();

              if (realHTML !== cloneHTML) {
                $clonedCell.html(realHTML);
              }
            });
          };

          var watchCellTextChanges = function () {
            if (!stickyClone) return;

            var originalRows = element.find("tr");
            var originalFilterRow = angular.element(
              originalRows[originalRows.length - 1]
            );
            var originalCells = originalFilterRow.find("th, td");

            var observer = new MutationObserver(function () {
              syncCellText();
            });

            originalCells.each(function (i, cell) {
              observer.observe(cell, {
                subtree: true,
                childList: true,
                characterData: true,
              });
            });

            element.data("stickyCellObserver", observer);
          };

          // ─── TOP SCROLLBAR ────────────────────────────────────────────────
          var createTopScrollbar = function () {
            if (topScrollbar) return;

            var table = getTable();

            topScrollbarInner = angular.element("<div></div>");
            topScrollbarInner.css({
              height: "1px",
              width: table[0].scrollWidth + "px",
              "pointer-events": "none",
            });

            topScrollbar = angular.element("<div></div>");
            topScrollbar.addClass("sticky-top-scrollbar");
            topScrollbar.css({
              "overflow-x": "scroll",
              "overflow-y": "hidden",
              width: "100%",
            });

            topScrollbar.append(topScrollbarInner);
            stickyWrapper.prepend(topScrollbar);
            topScrollbar.on("scroll", onTopScrollbarScroll);
          };

          var syncTopScrollbarWidth = function () {
            if (!topScrollbar || !topScrollbarInner) return;
            topScrollbarInner.css("width", getTable()[0].scrollWidth + "px");
          };

          var onTopScrollbarScroll = function () {
            if (isSyncingScroll) return;
            isSyncingScroll = true;

            var scrollLeft = topScrollbar[0].scrollLeft;
            lastScrollLeft = scrollLeft;

            if (tableContainer) tableContainer[0].scrollLeft = scrollLeft;
            syncStickyHeaderScroll(scrollLeft);

            isSyncingScroll = false;
          };

          var onHorizontalScroll = function () {
            if (!isSticky || isSyncingScroll) return;
            isSyncingScroll = true;

            var scrollLeft = tableContainer[0].scrollLeft;
            lastScrollLeft = scrollLeft;

            if (topScrollbar) topScrollbar[0].scrollLeft = scrollLeft;
            syncStickyHeaderScroll(scrollLeft);

            isSyncingScroll = false;
          };

          var syncStickyHeaderScroll = function (scrollLeft) {
            if (!stickyWrapper) return;
            stickyWrapper.find("table").css("margin-left", -scrollLeft + "px");
          };

          // ─── CREATE CLONE ─────────────────────────────────────────────────
          var createStickyClone = function () {
            if (stickyClone) return;

            var table = getTable();
            var tableWidth = table[0].offsetWidth;
            var tableScrollWidth = table[0].scrollWidth;

            var tableClone = angular.element("<table></table>");
            tableClone.attr("class", table.attr("class"));
            tableClone.css({
              width: tableWidth + "px",
              "min-width": tableWidth + "px",
              margin: "0",
              "table-layout": "fixed",
            });

            stickyClone = angular.element("<thead></thead>");
            element.find("tr").each(function (i, row) {
              var $row = angular.element(row);
              if (!$row.hasClass("hide-on-sticky")) {
                var clonedRow = $row.clone();
                stickyClone.append(clonedRow);
              }
            });

            stickyClone.addClass("is-sticky-clone");
            stripSmartTableAttrs(stickyClone);

            tableClone.append(stickyClone);

            stickyWrapper = angular.element("<div></div>");
            stickyWrapper.css({
              position: "fixed",
              top: stickyThreshold + "px",
              left: "0",
              width: "100%",
              "z-index": attrs.stickyZindex || "100",
              display: "none",
              overflow: "hidden",
              backgroundColor: "white",
            });

            stickyWrapper.append(tableClone);
            angular.element(document.body).append(stickyWrapper);

            $timeout(function () {
              syncColumnWidths();
              createTopScrollbar();
            }, 0);

            bindCloneEvents();
            bindFilterInputSync();
            watchHeaderChanges();
            watchHideTableColumns();
            watchTableBodyColumns();
            syncCellText();
            watchCellTextChanges();
          };

          // ─── POSITION ─────────────────────────────────────────────────────
          var updateStickyPosition = function () {
            if (!stickyWrapper) return;

            var table = getTable();
            var containerRect = tableContainer
              ? tableContainer[0].getBoundingClientRect()
              : null;
            var containerLeft = containerRect ? containerRect.left : 0;
            var containerWidth = tableContainer
              ? tableContainer[0].clientWidth
              : null;

            stickyWrapper.css({
              left: containerLeft + "px",
              width: containerWidth ? containerWidth + "px" : "100%",
            });

            var tableWidth = table[0].offsetWidth;
            stickyWrapper.find("table").css({
              width: tableWidth + "px",
              "table-layout": "fixed",
            });

            syncTopScrollbarWidth();
          };

          // ─── SHOW / HIDE ──────────────────────────────────────────────────
          var showSticky = function () {
            createStickyClone();

            // NEW: If original input was focused, transfer focus to cloned input
            if (focusedFilterInputIndex !== -1) {
              var clonedRows = stickyClone.find("tr");
              var clonedFilterRow = angular.element(
                clonedRows[clonedRows.length - 1]
              );
              var clonedInputs = clonedFilterRow.find("input, select");

              if (clonedInputs.length > focusedFilterInputIndex) {
                var $clonedInput = angular.element(
                  clonedInputs[focusedFilterInputIndex]
                );

                $timeout(function () {
                  $clonedInput[0].focus();

                  if ($clonedInput[0].type === "text") {
                    var val = $clonedInput.val();
                    if (
                      typeof $clonedInput[0].setSelectionRange === "function"
                    ) {
                      $clonedInput[0].setSelectionRange(val.length, val.length);
                    }
                  }
                }, 100); // Small delay to ensure DOM is ready
              }
            }

            // Ensure table width matches original BEFORE position/width sync
            var table = getTable();
            var tableWidth = table[0].offsetWidth;
            stickyWrapper.find("table").css({
              width: tableWidth + "px",
              "table-layout": "fixed",
            });

            updateStickyPosition();
            syncColumnWidths();
            syncTopScrollbarWidth();
            stickyWrapper.css("display", "block");
            isSticky = true;

            lastKnownScrollWidth = getTable()[0].scrollWidth;

            var scrollLeft = tableContainer ? tableContainer[0].scrollLeft : 0;
            lastScrollLeft = scrollLeft;
            syncStickyHeaderScroll(scrollLeft);
            if (topScrollbar) topScrollbar[0].scrollLeft = scrollLeft;

            startColspanPolling();
          };

          var hideSticky = function () {
            if (stickyWrapper) stickyWrapper.css("display", "none");

            // NEW: Transfer focus from cloned input back to original input
            if (focusedFilterInputIndex !== -1) {
              $timeout(function () {
                var originalRows = element.find("tr");
                var originalFilterRow = angular.element(
                  originalRows[originalRows.length - 1]
                );
                var originalInputs = originalFilterRow.find("input, select");

                if (originalInputs.length > focusedFilterInputIndex) {
                  var $originalInput = angular.element(
                    originalInputs[focusedFilterInputIndex]
                  );

                  // Ensure value is synced
                  $originalInput.val(focusedFilterInputValue);

                  // Focus and position cursor
                  $originalInput[0].focus();

                  if ($originalInput[0].type === "text") {
                    var val = $originalInput.val();
                    if (
                      typeof $originalInput[0].setSelectionRange === "function"
                    ) {
                      $originalInput[0].setSelectionRange(
                        val.length,
                        val.length
                      );
                    }
                  }
                }
              }, 0);
            }

            isSticky = false;
            stopColspanPolling();
          };

          var onWindowScroll = function () {
            if (!hasVerticalScroll()) {
              if (isSticky) hideSticky();
              return;
            }

            var scrollTop =
              $window.pageYOffset || document.documentElement.scrollTop;
            var naturalPositionFromTop = elementOriginalOffsetTop - scrollTop;
            var shouldBeSticky =
              naturalPositionFromTop <= stickyThreshold &&
              scrollTop > elementOriginalOffsetTop - stickyThreshold;

            if (shouldBeSticky && !isSticky) {
              showSticky();
            } else if (!shouldBeSticky && isSticky) {
              hideSticky();
            }
          };

          // ─── RECALCULATE ──────────────────────────────────────────────────
          var recalculatePosition = function () {
            if (!isSticky) {
              elementOriginalOffsetTop = getOriginalOffsetTop();
            }
            if (isSticky && stickyClone) {
              var observer = element.data("stickyObserver");
              if (observer) observer.disconnect();

              var cellObserver = element.data("stickyCellObserver");
              if (cellObserver) cellObserver.disconnect();

              var bodyObserver = element.data("stickyBodyObserver");
              if (bodyObserver) bodyObserver.disconnect();

              if (filterSyncInterval) {
                clearInterval(filterSyncInterval);
                filterSyncInterval = null;
              }

              if (topScrollbar)
                topScrollbar.off("scroll", onTopScrollbarScroll);

              stickyWrapper.remove();
              stickyClone = null;
              stickyWrapper = null;
              topScrollbar = null;
              topScrollbarInner = null;

              showSticky();
            }
          };

          // ─── RESIZE ───────────────────────────────────────────────────────
          var onResize = function () {
            if (!isSticky) {
              elementOriginalOffsetTop = getOriginalOffsetTop();
            }
            if (isSticky) {
              var tableWidth = getTable()[0].offsetWidth;
              stickyWrapper.find("table").css("width", tableWidth + "px");
              updateStickyPosition();
              syncColumnWidths();
              syncTopScrollbarWidth();
            }
            onWindowScroll();
          };

          // ─── LISTEN TO STICKY COLUMNS ─────────────────────────────────────
          scope.$on("stickyColumns:updated", function () {
            if (isSticky) {
              saveScrollPosition();
              saveFocusedFilterInputInfo();

              $timeout(function () {
                syncColumnWidths();
                restoreScrollPosition();

                if (checkIfScrollReset()) {
                  refocusFilterInput();
                }
              }, 100);
            }
          });

          // ─── WATCH FOR COLSPAN CHANGES ────────────────────────────────────
          if (scope.$parent && scope.$parent.colspanSection) {
            scope.$parent.$watch(
              "colspanSection",
              function (newVal, oldVal) {
                if (newVal !== oldVal && isSticky) {
                  saveScrollPosition();
                  saveFocusedFilterInputInfo();

                  $timeout(function () {
                    syncColumnWidths();
                    restoreScrollPosition();

                    if (checkIfScrollReset()) {
                      refocusFilterInput();
                    }
                  }, 100);
                }
              },
              true
            );
          }

          // ─── COLSPAN POLLING ──────────────────────────────────────────────
          var checkColspanChanges = function () {
            if (!isSticky) return;

            var currentState = [];
            element.find("tr").each(function (i, row) {
              var rowState = [];
              angular
                .element(row)
                .find("th, td")
                .each(function (j, cell) {
                  var $cell = angular.element(cell);
                  var colspan = $cell.attr("colspan") || "1";
                  var ngShow = $cell.attr("ng-show") || "";
                  var ngHide = $cell.attr("ng-hide") || "";
                  var isHidden =
                    $cell.hasClass("ng-hide") ||
                    $cell.css("display") === "none";
                  rowState.push(
                    colspan + "|" + ngShow + "|" + ngHide + "|" + isHidden
                  );
                });
              currentState.push(rowState.join(","));
            });

            var stateString = currentState.join(";");
            if (lastColspanState !== null && lastColspanState !== stateString) {
              saveScrollPosition();
              saveFocusedFilterInputInfo();

              $timeout(function () {
                syncColumnWidths();
                restoreScrollPosition();

                if (checkIfScrollReset()) {
                  refocusFilterInput();
                }
              }, 50);
            }
            lastColspanState = stateString;
          };

          var startColspanPolling = function () {
            if (!colspanCheckInterval) {
              colspanCheckInterval = setInterval(checkColspanChanges, 200);
            }
          };

          var stopColspanPolling = function () {
            if (colspanCheckInterval) {
              clearInterval(colspanCheckInterval);
              colspanCheckInterval = null;
            }
          };

          // ─── INITIALIZATION ───────────────────────────────────────────────
          $timeout(function () {
            elementOriginalOffsetTop = getOriginalOffsetTop();
            tableContainer = findTableContainer();

            angular.element($window).on("scroll", onWindowScroll);
            if (tableContainer) tableContainer.on("scroll", onHorizontalScroll);

            onWindowScroll();
          }, 0);

          angular.element($window).on("resize", onResize);
          scope.$on("stickyTableHeader:recalculate", recalculatePosition);

          // ─── CLEANUP ──────────────────────────────────────────────────────
          scope.$on("$destroy", function () {
            angular.element($window).off("scroll", onWindowScroll);
            angular.element($window).off("resize", onResize);

            if (tableContainer)
              tableContainer.off("scroll", onHorizontalScroll);
            if (topScrollbar) topScrollbar.off("scroll", onTopScrollbarScroll);
            if (filterSyncInterval) clearInterval(filterSyncInterval);

            stopColspanPolling();

            var observer = element.data("stickyObserver");
            if (observer) observer.disconnect();

            var cellObserver = element.data("stickyCellObserver");
            if (cellObserver) cellObserver.disconnect();

            var bodyObserver = element.data("stickyBodyObserver");
            if (bodyObserver) bodyObserver.disconnect();

            if (stickyWrapper) stickyWrapper.remove();
          });
        },
      };
    },
  ]);
})();

(function () {
  "use strict";

  angular.module("BlurAdmin.theme").component("tableColumnToolbar", {
    bindings: {
      columnList: "<", // One-way binding for array of strings
      onChanged: "&", // Output callback function
      storageKey: "@",
    },
    // template:
    // "<ui-select" +
    // ' style="border: 1px solid #cbcbcb"' +
    // ' class="btn-group bootstrap-select form-control"' +
    // ' ng-model="$ctrl.activeColumnList"' +
    // ' ng-disabled="false"' +
    // ' append-to-body="false"' +
    // ' search-enabled="true"' +
    // " multiple" +
    // ' close-on-select="false"' +
    // ' on-select="$ctrl.onSelect($item)"' +
    // ' on-remove="$ctrl.onRemove($item)"' +
    // ">" +
    // ' <ui-select-match placeholder="Select...">' +
    // " {{$item.title}}" +
    // " </ui-select-match>" +
    // " <ui-select-choices" +
    // ' ng-hide="!$select.open"' +
    // ' repeat="cl in $ctrl.columnList | filter: $select.search track by cl.key">' +
    // '<span style="color: black" ng-bind-html="cl.title"></span>' +
    // " </ui-select-choices>" +
    // " </ui-select>",
    template:
      "<div style='margin-top: 10px; margin-bottom: 10px; display: flex; justify-content: flex-end;'>" +
      ' <div  style="width: 50%; max-width: 300px">' +
      " <select" +
      ' class="form-control selectpicker show-tick"' +
      ' title="Columns"' +
      " selectpicker" +
      " multiple multi-select-title" +
      ' ng-model="$ctrl.activeColumnList"' +
      'ng-options="item as item.title for item in $ctrl.columnList track by item.key"' +
      ' ng-change="$ctrl.onItemChanged()"' +
      "></select></div></div>",
    controller: [
      "$element",
      "$window",
      "$timeout",
      "$scope",
      function ($element, $window, $timeout, $scope) {
        var ctrl = this;

        window.ctrl = ctrl;

        $timeout(function () {
          $element.find("select").selectpicker({
            countSelectedText: function (numSelected, numTotal) {
              return (
                numSelected +
                " item" +
                (numSelected > 1 ? "s" : "") +
                " selected"
              );
            },
          });
        });

        ctrl.activeColumnList = [];

        ctrl.getStorageValue = function () {
          var excludedStoredColumns = $window.localStorage.getItem(
            "columnToolbarOptions"
          );

          var parsedColumns = JSON.parse(excludedStoredColumns || "{}");

          return parsedColumns[ctrl.storageKey] || [];
        };

        ctrl.setStorageValue = function (excludedColumns) {
          var excludedStoredColumns = $window.localStorage.getItem(
            "columnToolbarOptions"
          );

          var parsedColumns = JSON.parse(excludedStoredColumns || "{}");

          var storageValue = Object.assign({}, parsedColumns);

          storageValue[ctrl.storageKey] = excludedColumns;

          $window.localStorage.setItem(
            "columnToolbarOptions",
            JSON.stringify(storageValue)
          );
        };

        ctrl.$onInit = function () {
          var lastStorageValue = ctrl.getStorageValue();
          ctrl.activeColumnList = ctrl.columnList.filter(function (cl) {
            return !lastStorageValue.includes(cl.key);
          });

          ctrl.onItemChanged();
        };

        ctrl.onSelect = function (item) {
          ctrl.onItemChanged();
        };

        ctrl.onRemove = function (item) {
          ctrl.onItemChanged();
        };

        ctrl.onItemChanged = function () {
          var activeList = ctrl.activeColumnList.map(function (ac) {
            return ac.key;
          });
          var fullList = ctrl.columnList.map(function (ac) {
            return ac.key;
          });
          var excludedColumns = fullList.filter(function (key) {
            return !activeList.includes(key);
          });

          ctrl.setStorageValue(excludedColumns);

          ctrl.onChanged({
            $value: { actived: activeList, excluded: excludedColumns },
          });
        };
      },
    ],
  });
})();

/**
 * Dynamic Sticky Columns Directive
 * Handles ng-hide / ng-show column visibility and recalculates sticky left positions
 *
 * Usage:
 *   <table sticky-columns>
 *     <thead>
 *       <tr>
 *         <th sticky="true" ng-hide="col.hidden">ID</th>
 *         <th sticky="true">Name</th>
 *         <th>Email</th>
 *       </tr>
 *     </thead>
 *   </table>
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.theme")
    .directive("stickyColumns", stickyColumnsDirective);

  /** @ngInject */
  function stickyColumnsDirective($timeout, $window, $rootScope) {
    return {
      restrict: "A",
      scope: {
        onStickyUpdate: "&?",
      },
      link: function (scope, element) {
        var table = element[0];
        var styleId = "sticky-style-" + scope.$id;
        var resizeTimeout;
        var updateTimeout;

        function isVisible(cell) {
          return (
            cell.offsetWidth > 0 &&
            cell.offsetHeight > 0 &&
            window.getComputedStyle(cell).display !== "none" &&
            window.getComputedStyle(cell).visibility !== "hidden"
          );
        }

        function calculateStickyPositions() {
          // Find the sortable row first, fallback to first row
          var sortableHeaderRow = table.querySelector("thead tr.sortable");
          var defaultHeaderRow = table.querySelector("thead tr");
          var headerRow = sortableHeaderRow || defaultHeaderRow;

          if (!headerRow) {
            console.warn("No header row found in table");
            return;
          }

          var headerCells = headerRow.querySelectorAll("th, td");
          var cumulativeLeft = 0;
          var stickyInfo = [];

          Array.prototype.forEach.call(headerCells, function (cell, index) {
            var isSticky = cell.getAttribute("sticky") === "true";
            var cellVisible = isVisible(cell);

            if (isSticky && cellVisible) {
              stickyInfo.push({
                index: index + 1,
                left: cumulativeLeft,
                width: cell.offsetWidth,
              });
              cumulativeLeft += cell.offsetWidth;
            }
          });

          applyStickyStyles(stickyInfo);

          if (scope.onStickyUpdate) {
            scope.onStickyUpdate({ stickyColumns: stickyInfo });
          }

          // ─── BROADCAST TO STICKY-ON-SCROLL ──────────────────────────────
          // Notify the sticky header clone to re-sync column widths
          $rootScope.$broadcast("stickyColumns:updated", {
            stickyInfo: stickyInfo,
          });
        }

        function applyStickyStyles(stickyInfo) {
          if ($window.innerWidth < 768) {
            removeStyle();
            return;
          }

          removeStyle();
          if (!stickyInfo.length) return;

          // Generate a unique identifier for this specific table
          var tableId = table.getAttribute("id");
          var tableSelector;

          if (!tableId) {
            tableId = "sticky-table-" + scope.$id;
            table.setAttribute("id", tableId);
          }

          tableSelector = "#" + tableId;

          var style = document.createElement("style");
          style.id = styleId;
          var css = "";

          stickyInfo.forEach(function (col) {
            var n = col.index;

            var bodySelector =
              tableSelector +
              " tbody tr td:nth-child(" +
              n +
              "), " +
              tableSelector +
              " tbody tr th:nth-child(" +
              n +
              ")";

            var headSelector =
              tableSelector +
              " thead tr th:nth-child(" +
              n +
              "), " +
              tableSelector +
              " thead tr td:nth-child(" +
              n +
              ")";

            css += bodySelector + " {\n";
            css += "  position: -webkit-sticky;\n";
            css += "  position: sticky;\n";
            css += "  left: " + col.left + "px;\n";
            css += "  z-index: 2;\n";
            css += "  background: inherit;\n";
            css += "}\n\n";

            css += headSelector + " {\n";
            css += "  position: -webkit-sticky;\n";
            css += "  position: sticky;\n";
            css += "  left: " + col.left + "px;\n";
            css += "  z-index: 4;\n";
            css += "  background: inherit;\n";
            css += "}\n\n";
          });

          style.textContent = css;
          document.head.appendChild(style);
        }

        function removeStyle() {
          var el = document.getElementById(styleId);
          if (el) el.remove();
        }

        function scheduleUpdate() {
          if (updateTimeout) $timeout.cancel(updateTimeout);
          updateTimeout = $timeout(calculateStickyPositions, 50);
        }

        var observer = new MutationObserver(function (mutations) {
          var needsUpdate = false;

          mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
              needsUpdate = true;
            }
            if (mutation.type === "attributes") {
              var attr = mutation.attributeName;
              if (attr === "class" || attr === "style" || attr === "sticky") {
                needsUpdate = true;
              }
            }
          });

          if (needsUpdate) scheduleUpdate();
        });

        observer.observe(table, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "style", "sticky"],
        });

        angular.element($window).on("resize", function () {
          if (resizeTimeout) $timeout.cancel(resizeTimeout);
          resizeTimeout = $timeout(calculateStickyPositions, 300);
        });

        $timeout(calculateStickyPositions, 200);

        scope.$on("$destroy", function () {
          observer.disconnect();
          angular.element($window).off("resize");
          removeStyle();
          if (updateTimeout) $timeout.cancel(updateTimeout);
          if (resizeTimeout) $timeout.cancel(resizeTimeout);
        });
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
angular.module("BlurAdmin.pages").factory("OneSignalService", [
  "$q",
  "$window",
  function ($q, $window) {
    var FIRST_LOGIN_KEY = "onesignal_prompted";
    var hasPromptedByUser = {};

    function waitForOneSignal() {
      var deferred = $q.defer();
      $window.OneSignalDeferred = $window.OneSignalDeferred || [];
      $window.OneSignalDeferred.push(function (OneSignal) {
        deferred.resolve(OneSignal);
      });
      return deferred.promise;
    }

    return {
      // ✅ Call this after successful login
      promptOnFirstLogin: function (userId) {
        var deferred = $q.defer();
        var key = FIRST_LOGIN_KEY + "_" + userId; // per-user key

        // Check if already prompted before
        var alreadyPrompted = hasPromptedByUser[key];

        if (alreadyPrompted) {
          deferred.resolve({
            prompted: false,
            reason: "Already prompted before",
          });
          return deferred.promise;
        }

        // First time — request permission
        waitForOneSignal().then(function (OneSignal) {
          OneSignal.Notifications.requestPermission()
            .then(function (accepted) {
              // Mark as prompted regardless of accept/deny
              if (accepted) {
                // Link OneSignal to your user ID
                OneSignal.login(String(userId));
              }

              hasPromptedByUser[key] = true;
              deferred.resolve({ prompted: true, accepted: accepted });
            })
            .catch(function (err) {
              deferred.reject(err);
            });
        });

        return deferred.promise;
      },

      getUserId: function () {
        var deferred = $q.defer();
        waitForOneSignal().then(function (OneSignal) {
          var id = OneSignal.User.PushSubscription.id;
          id ? deferred.resolve(id) : deferred.reject("No subscription ID");
        });
        return deferred.promise;
      },
    };
  },
]);

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.theme").service("UploadService", UploadService);

  /** @ngInject */
  function UploadService($http, LoopBackResource) {
    var uploadFile = function (file, bucketName) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("bucketName", bucketName);

      return $http.post(LoopBackResource.getUrlBase() + "/upload", formData, {
        transformRequest: angular.identity,
        headers: { "Content-Type": undefined }
      });
    };

    return {
      uploadFile: uploadFile
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.accountType")
    .controller("AccountTypePageCtrl", AccountTypePageCtrl);

  /** @ngInject */
  function AccountTypePageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    billService
  ) {
    $scope.smartTablePageSize = 25;
    $scope.accountTypeList = [];
    $scope.loading = false;
    $scope.selectedAccountType = null;
    $scope.init = function () {
      $scope.load();
    };
    $scope.load = function () {
      billService.getAccountType().then(function (res) {
        $scope.accountTypeList = res.data;
      });
    };
    $scope.createOtEditAccountType = function (item) {
      $scope.selectedAccountType = {
        id: item ? item.id : null,
        name: item ? item.name : "",
        description: item ? item.description : "",
      };
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/accountType/modals/accountTypeDetailModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          billService
            .saveAccountType($scope.selectedAccountType)
            .then(function (res) {
              toastr.success(
                !$scope.selectedAccountType.id
                  ? "Account Type generated success"
                  : "Account Type updated success",
                "SUCCESS"
              );
              $scope.load();
            });
        },
        function () {}
      );
    };
    $scope.confirmDelete = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/accountType/modals/deleteAccountTypeModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          billService.deleteAccountType(id).then(function (res) {
            toastr.success("Account Type is deleted successfully", "SUCCESS");
            $scope.load();
          });
        },
        function () {}
      );
    };
    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.approval")
    .controller("InvReceiptApprovalPageCtrl", InvReceiptApprovalPageCtrl);

  /** @ngInject */
  function InvReceiptApprovalPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    zoneService,
    invoiceReceiptService
  ) {
    $scope.smartTablePageSize = 25;
    $scope.invReceipts = [];
    $scope.loading = false;
    $scope.selectedInvReceipts = null;
    $scope.zones = [];
    $scope.states = [];
    $scope.manageZonesList = [];
    $scope.manageStatesList = [];

    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null,
      },
    };
    $scope.reportFilter = {};
    $scope.init = function () {
      $scope.load();
    };

    $scope.getInvoicePaid = function () {
      var obj = {};
      obj.params = {
        adate: $scope.dateList.from,
        bdate: $scope.dateList.to,
        ismonthly: false,
      };

      if ($scope.reportFilter.zone) {
        obj.params.zoneid = $scope.reportFilter.zone
          ? "('" + $scope.reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        }
      }

      if ($scope.reportFilter.state) {
        obj.params.stateid = $scope.reportFilter.state.id;
      }

      obj.onSuccess = function (result) {
        $scope.invReceipts = result.map(function (re) {
          re.status = (re.status || "pending").toString().toUpperCase();
          return re;
        });
      };

      invoiceReceiptService.getInvoiceReceipts(obj);
    };

    $scope.load = function () {
      var obj = {};

      obj.onSuccess = function (res) {
        var userZones = $rootScope.userData.credentials.zonemap || [];
        if ($rootScope.userData.credentials.role == 1) {
          $scope.manageZonesList = res;
        } else {
          $scope.manageZonesList = res.filter(function (zone) {
            return userZones.includes(zone.id);
          });
        }

        $scope.manageZonesList.forEach(function (zone) {
          if (!zone.state) {
            return;
          }

          var match = $scope.manageStatesList.find(function (state) {
            return state.id === zone.state.id;
          });

          if (!match) {
            $scope.manageStatesList.push(zone.state);
          }
        });

        $scope.getInvoicePaid();
      };

      zoneService.getZones(obj);
    };

    $scope.reset = function () {
      $scope.reportFilter = {};
    };

    $scope.viewInvoiceReceipt = function (item) {
      $scope.selectedInvReceipts = Object.assign(
        {
          paidAt: moment(item.paid_at).utcOffset(8).toDate(),
        },
        item
      );

      var obj = {};
      obj.params = {};
      obj.params.id = item.id;
      invoiceReceiptService.getInvoiceReceiptById(obj);

      obj.onSuccess = function (res) {
        $scope.selectedInvReceipts.invoices = res.result;
      };

      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: "modal-scrollable",
        templateUrl:
          "app/pages/accDepartment/approval/modals/paidInvoiceModal.html",
        scope: $scope,
      });
      modalInstance.result.then(function (isConfirm) {
        if (!isConfirm) {
          return;
        }

        var saveObj = {};
        saveObj.params = {
          id: $scope.selectedInvReceipts.id,
          approveby: $scope.selectedInvReceipts.approveby,
          status: isConfirm.isApproved ? "approved" : "rejected",
        };

        saveObj.onSuccess = function () {
          toastr.success("Official Receipt saved", "SUCCESS");
          $scope.getInvoicePaid();
        };

        invoiceReceiptService.saveInvoiceReceipt(saveObj);
      });
    };

    $scope.confirmDelete = function (item) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/accDepartment/approval/modals/deleteModal.html",
        scope: $scope,
      });

      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          var obj = {};
          obj.params = {};
          obj.params.id = item.id;

          invoiceReceiptService.deleteInvReceipt(obj);
          obj.onSuccess = function () {
            toastr.success(
              "Official Receipt " + item.orno + " deleted",
              "SUCCESS"
            );
            $scope.invReceipts = $scope.invReceipts.filter(function (inv) {
              return inv.id !== item.id;
            });
          };
        },
        function () {}
      );
    };

    $scope.getTotalPaidReceipt = function () {
      return ($scope.selectedInvReceipts.invoices || []).reduce(function (
        total,
        current
      ) {
        return (total += Number(current.amount));
      },
      0);
    };

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg",
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%",
      };
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.getTotaPaidNetCollect = function () {
      return ($scope.selectedInvReceipts.invoices || []).reduce(function (
        total,
        current
      ) {
        return (total += Number(current.net_collect));
      },
      0);
    };

    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.pnl")
    .controller("PNLPageCtrl", PNLPageCtrl);

  /** @ngInject */
  function PNLPageCtrl($scope, $rootScope, toastr, $uibModal, billService) {
    $scope.smartTablePageSize = 25;
    $scope.manageZonesList = [];
    $scope.months = [];
    $scope.reportFilter = {
      zone: null,
      month: null,
    };
    $scope.data = [];
    $scope.selectedPNL = null;
    $scope.pnlDetail = {};
    $scope.selectedLedger = null;
    $scope.ledgerDetail = [];
    $scope.filteredCollection = [];
    $scope.loading = false;

    var userReportDuration = $rootScope.userData.credentials.months || 12;

    $scope.init = function () {
      for (var i = 0; i < userReportDuration; i++) {
        var currentDate = moment()
          .utcOffset(8)
          .startOf("month")
          .subtract(i, "month");
        $scope.months.push({
          title: currentDate.clone().format("MM / YYYY"),
          value: currentDate.toISOString(),
        });
      }

      $scope.reportFilter.month = $scope.months[0];
      billService.getZones().then(function (res) {
        var userZones = $rootScope.userData.credentials.zonemap || [];
        if ($rootScope.userData.credentials.role === 1) {
          $scope.manageZonesList = res.data;
        } else if (userZones.length) {
          $scope.manageZonesList = res.data.filter(function (zone) {
            return userZones.includes(zone.vipZoneId);
          });
        }

        $scope.load();
      });
    };

    $scope.load = function () {
      $scope.loading = true;
      billService
        .getPNLReport({
          startDate: moment($scope.reportFilter.month.value)
            .utcOffset(8)
            .startOf("month")
            .toISOString(),
          endDate: moment($scope.reportFilter.month.value)
            .utcOffset(8)
            .endOf("month")
            .toISOString(),
          zoneid: $scope.reportFilter.zone
            ? [$scope.reportFilter.zone.id]
            : $scope.manageZonesList.map(function (zone) {
                return zone.id;
              }),
        })
        .then(
          function (res) {
            $scope.data = res.data;

            $scope.loading = false;
          },
          function (err) {
            $scope.loading = false;
          }
        );
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        zone: null,
        month: $scope.months[0],
      };
    };

    $scope.viewPNL = function (item) {
      $scope.selectedPNL = item;
      billService
        .getPNLDetailReport({
          shopid: item.shopid,
          date: $scope.reportFilter.month.value,
        })
        .then(function (res) {
          $scope.pnlDetail.onlinesales = res.data.onlinesales;
          $scope.pnlDetail.bills = res.data.bills;

          $scope.pnlDetail.month = [];
          for (var i = 0; i < 3; i++) {
            var currentMonth = moment($scope.reportFilter.month.value).subtract(
              i,
              "month"
            );
            $scope.pnlDetail.month.push({
              title: currentMonth.clone().format("MMM"),
              value: currentMonth.clone().month() + 1,
            });
          }

          $scope.pnlDetail.rate = res.data.rate || {};

          $scope.pnlDetail.salesRows = {
            data: {},
            codes: [],
            total: {},
            default: [],
          };
          $scope.pnlDetail.costRows = {
            data: {},
            codes: [],
            total: {},
            default: [],
          };
          $scope.pnlDetail.expensesRows = {
            data: {},
            codes: [],
            total: {},
            default: [],
          };

          $scope.pnlDetail.bills.forEach(function (bill) {
            var currentRows;

            if (bill.accid === 4) {
              currentRows = $scope.pnlDetail.salesRows;
              // $scope.pnlDetail.salesRows.push(bill);
            } else if (bill.accid === 5) {
              currentRows = $scope.pnlDetail.costRows;
              // $scope.pnlDetail.costRows.push(bill);
            } else if (bill.accid === 2) {
              currentRows = $scope.pnlDetail.expensesRows;
              // $scope.pnlDetail.expensesRows.push(bill);
            } else {
              return;
            }

            currentRows.default.push(bill);

            var id = bill.catid + "/" + bill.month;
            currentRows.data[id] = bill.amount;
            if (!currentRows.total[bill.month]) {
              currentRows.total[bill.month] = 0;
            }

            currentRows.total[bill.month] += Number(bill.amount);

            if (
              !currentRows.codes.find(function (cr) {
                return cr.catid === bill.catid;
              })
            ) {
              currentRows.codes.push({
                catid: bill.catid,
                catname: bill.catname,
              });
            }
          });

          $scope.pnlDetail.salesRows.codes.sort(function (a, b) {
            return a.catname.localeCompare(b.catname);
          });
          $scope.pnlDetail.costRows.codes.sort(function (a, b) {
            return a.catname.localeCompare(b.catname);
          });
          $scope.pnlDetail.expensesRows.codes.sort(function (a, b) {
            return a.catname.localeCompare(b.catname);
          });
        });
    };
    window.a = $scope;

    $scope.getFullSales = function (month) {
      return $scope.pnlDetail.onlinesales.reduce(function (total, cur) {
        return (total +=
          cur.shoptype === "100%" && cur.month === month
            ? Number(cur.sales)
            : 0);
      }, 0);
    };

    $scope.getHalfSales = function (month) {
      return $scope.pnlDetail.onlinesales.reduce(function (total, cur) {
        return (total +=
          cur.shoptype === "5/5" && cur.month === month
            ? Number(cur.sales)
            : 0);
      }, 0);
    };

    $scope.getSalesRow = function (month, code) {
      var id = code.catid + "/" + month;
      var current = $scope.pnlDetail.salesRows.data[id];
      return current || 0;
    };

    $scope.getCostRow = function (month, code) {
      var id = code.catid + "/" + month;
      var current = $scope.pnlDetail.costRows.data[id];
      return current || 0;
    };

    $scope.getExpRow = function (month, code) {
      var id = code.catid + "/" + month;
      var current = $scope.pnlDetail.expensesRows.data[id];
      return current || 0;
    };

    $scope.getTotalCost = function (month) {
      return $scope.pnlDetail.costRows.total[month] || 0;
    };

    $scope.getTotalSalesRow = function (month) {
      return $scope.pnlDetail.salesRows.total[month] || 0;
    };

    $scope.getTotalExpenses = function (month) {
      return $scope.pnlDetail.expensesRows.total[month] || 0;
    };

    $scope.getTotalSales = function (month) {
      return (
        $scope.getFullSales(month) +
        $scope.getHalfSales(month) +
        $scope.getTotalSalesRow(month)
      );
    };

    $scope.getGrossProfit = function (month) {
      return $scope.getTotalSales(month) - $scope.getTotalCost(month);
    };

    $scope.getNetProfit = function (month) {
      return $scope.getGrossProfit(month) - $scope.getTotalExpenses(month);
    };

    $scope.getTotalProfitSharing = function (month) {
      var myRate = $scope.pnlDetail.rate[month];
      var np = $scope.getNetProfit(month);
      return myRate ? (np * Number(myRate)) / 100 : np;
    };

    $scope.getProfitSharingRate = function (month) {
      var myRate = $scope.pnlDetail.rate[month];
      return myRate ? myRate + "%" : "-";
    };

    $scope.closePNLeDetail = function () {
      $scope.selectedPNL = null;
      $scope.pnlDetail = {};
    };

    $scope.closeLedger = function () {
      $scope.selectedLedger = null;
      $scope.ledgerDetail = [];
    };

    $scope.viewLedger = function (code) {
      $scope.ledgerDetail = [];
      $scope.selectedLedger = code;

      billService
        .getLedgerReport({
          codeid: code.catid,
          shopid: $scope.selectedPNL.shopid,
          startAt: moment($scope.reportFilter.month.value)
            .utcOffset(8)
            .startOf("month")
            .toISOString(),
          endAt: moment($scope.reportFilter.month.value)
            .utcOffset(8)
            .endOf("month")
            .toISOString(),
        })
        .then(function (res) {
          var balance = 0;
          $scope.ledgerDetail = res.data.map(function (dat) {
            var shopname = [];
            var zonename = [];

            dat.billExpDetails.forEach(function (expDetails) {
              if (
                expDetails.shop &&
                expDetails.shop.name &&
                !shopname.includes(expDetails.shop.name)
              ) {
                shopname.push(expDetails.shop.name);
              }

              if (
                expDetails.shop &&
                expDetails.shop.zone &&
                expDetails.shop.zone.name &&
                !zonename.includes(expDetails.shop.zone.name)
              ) {
                zonename.push(expDetails.shop.zone.name);
              }
            });

            dat.zonename = zonename.join(", ");
            dat.shopname = shopname.join(", ");
            dat.credit = dat.type === "credit" ? Number(dat.amount) : 0;
            dat.debit = dat.type === "debit" ? Number(dat.amount) : 0;
            dat.date = dat.bill.claimedDate;
            dat.billNo = dat.bill.billNo;
            dat.balance = balance + (dat.debit || -dat.credit);
            return dat;
          });
        });
    };

    $scope.exportLedgerDetail = function (items) {
      var Results = [
        [
          "Date",
          "Bil No",
          "Daerah",
          "Shop",
          "Description",
          "Debit",
          "Credit",
          "Balance",
        ],
      ];

      if (!items.length) {
        return;
      }

      items.forEach(function (collection) {
        Results.push([
          moment(collection.createdAt).format("DD/MM/YYYY"),
          collection.billNo,
          collection.zonename || "",
          collection.shopname || "",
          collection.description || "",
          collection.debit || "",
          collection.credit || "",
          collection.balance,
        ]);
      });

      $scope.export(Results, "Ledger");
    };

    $scope.exportPNL = function (items) {
      var Results = [
        [
          "Daearah",
          "Shop",
          "Sales",
          "Cost",
          "Gross Profit",
          "Expenses",
          "Net Profit",
        ],
      ];

      if (!items.length) {
        return;
      }

      items.forEach(function (collection) {
        Results.push([
          collection.zonename,
          collection.shopname,
          collection.sales,
          collection.cost,
          collection.grossProfit,
          collection.exp,
          collection.netProfit,
        ]);
      });

      $scope.export(Results, "P&L");
    };

    $scope.export = function (data, title) {
      var CsvString = "";
      data.forEach(function (RowItem, RowIndex) {
        RowItem.forEach(function (ColItem, ColIndex) {
          CsvString += ColItem + (ColIndex === RowItem.length - 1 ? "" : ",");
        });
        CsvString += "\r\n";
      });
      CsvString = "data:application/csv," + encodeURIComponent(CsvString);
      var x = document.createElement("A");
      x.setAttribute("href", CsvString);
      x.setAttribute("download", title + ".csv");
      document.body.appendChild(x);
      x.click();
    };

    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.category")
    .controller("CategoryPageCtrl", CategoryPageCtrl);

  /** @ngInject */
  function CategoryPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    billService
  ) {
    $scope.smartTablePageSize = 25;
    $scope.categoryList = [];
    $scope.loading = false;
    $scope.selectedCategory = null;
    $scope.accountTypes = [];
    $scope.zones = [];
    $scope.states = [];

    $scope.init = function () {
      $scope.load();
    };

    $scope.load = function () {
      Promise.all([billService.getAccountType(), billService.getZones()]).then(
        function (res) {
          $scope.accountTypes = res[0].data;

          var userZones = $rootScope.userData.credentials.zonemap || [];
          if ($rootScope.userData.credentials.role == 1) {
            $scope.zones = res[1].data;
          } else if (userZones.length) {
            $scope.zones = res[1].data.filter(function (zone) {
              return userZones.includes(zone.vipZoneId);
            });
          }

          $scope.zones.forEach(function (zone) {
            if (!zone.state) {
              return;
            }

            var match = $scope.states.find(function (state) {
              return state.id === zone.state.id;
            });

            if (!match) {
              $scope.states.push(zone.state);
            }
          });

          billService
            .getBillCategory($rootScope.userData, $scope.zones)
            .then(function (res) {
              $scope.categoryList = res.data.map(function (data) {
                data.myAccountType = data.accountType
                  ? data.accountType.name
                  : null;
                data.myZones = data.zones.length
                  ? data.zones
                      .map(function (zone) {
                        return zone.name;
                      })
                      .join()
                  : "";
                data.myStates = data.states.length
                  ? data.states
                      .map(function (state) {
                        return state.name;
                      })
                      .join()
                  : "";
                return data;
              });
            });
        }
      );
    };

    $scope.createOtEditCategory = function (item) {
      $scope.selectedCategory = {
        id: item ? item.id : null,
        name: item ? item.name : "",
        description: item ? item.description : "",
        accountType: item && item.accountType ? item.accountType : null,
        zones: item && item.zones ? item.zones : [],
        states: item && item.states ? item.states : [],
      };

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/category/modals/categoryDetailModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService.saveCategory($scope.selectedCategory).then(
            function (res) {
              toastr.success(
                !$scope.selectedCategory.id
                  ? "Category generated success"
                  : "Category updated success",
                "SUCCESS"
              );
              $scope.load();
            },
            function (err) {
              toastr.error(
                err.data.message ? err.data.message : "An error occurred",
                "ERROR"
              );
            }
          );
        },
        function () {}
      );
    };

    $scope.confirmDelete = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/category/modals/deleteCategoryModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService.deleteCategory(id).then(function (res) {
            toastr.success("Category is deleted successfully", "SUCCESS");
            $scope.load();
          });
        },
        function () {}
      );
    };

    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.ledger")
    .controller("LedgerPageCtrl", LedgerPageCtrl);

  /** @ngInject */
  function LedgerPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    billService,
    validationService
  ) {
    $scope.smartTablePageSize = 25;
    $scope.petrolCategoryId = 43;
    $scope.tngCategoryId = 44;
    $scope.isPetrolCategory = false;
    $scope.isTNGCategory = false;

    $scope.zoomInMode = false;
    $scope.myImageStyle = {};
    $scope.rotateDegree = 0;

    $scope.editBillExp = undefined;

    $scope.reportFilter = {
      zone: null,
      from: moment().startOf("day").toDate(),
      to: moment().endOf("day").toDate(),
    };
    $scope.data = [];
    $scope.dpOpenStatus = {};

    var userReportDuration = $rootScope.userData.credentials.months || 12;

    $scope.dateList = {
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null,
      },
    };

    $scope.init = function () {
      billService.getZones().then(function (res) {
        var userZones = $rootScope.userData.credentials.zonemap || [];
        if ($rootScope.userData.credentials.role === 1) {
          $scope.manageZonesList = res.data;
        } else {
          $scope.manageZonesList = res.data.filter(function (zone) {
            return userZones.includes(zone.vipZoneId);
          });
        }

        $scope.load();
      });
    };

    $scope.load = function () {
      if (
        validationService.isEmptyOrNullValidation($scope.reportFilter.from) &&
        validationService.isEmptyOrNullValidation($scope.reportFilter.to)
      ) {
        if (
          !validationService.verifyDate($scope.reportFilter.from) ||
          !validationService.verifyDate($scope.reportFilter.to)
        ) {
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      $scope.loading = true;
      billService
        .getLedgerReport({
          startAt: $scope.reportFilter.from,
          endAt: $scope.reportFilter.to,
          zones: $scope.reportFilter.zone
            ? [$scope.reportFilter.zone.id]
            : $rootScope.userData.credentials.role === 1
              ? []
              : $scope.manageZonesList.length
                ? $scope.manageZonesList.map(function (zone) {
                    return zone.id;
                  })
                : [0],
        })
        .then(function (res) {
          var balance = 0;

          $scope.data = res.data.map(function (dat) {
            var shopname = [];
            var zonename = [];
            var codename = [];
            var isPetrolCategory = false;
            var isTNGCategory = false;

            dat.billExpDetails.forEach(function (expDetails) {
              var isPetrolCategory =
                expDetails.category &&
                expDetails.category.id === $scope.petrolCategoryId;
              var isTNGCategory =
                expDetails.category &&
                expDetails.category.id === $scope.tngCategoryId;

              if (
                expDetails.shop &&
                expDetails.shop.name &&
                !shopname.includes(expDetails.shop.name)
              ) {
                shopname.push(expDetails.shop.name);
              }

              if (
                expDetails.shop &&
                expDetails.shop.zone &&
                expDetails.shop.zone.name &&
                !zonename.includes(expDetails.shop.zone.name)
              ) {
                zonename.push(expDetails.shop.zone.name);
              }

              if (expDetails.category) {
                var currentcodename =
                  expDetails.category.name +
                  " - " +
                  expDetails.category.description;
                if (!codename.includes(currentcodename)) {
                  codename.push(currentcodename);
                }
              }

              var carPlateDesc = dat.carPlateNo
                ? "Car Plate: " + dat.carPlateNo + "\n"
                : "";
              var touchAndGoDesc = dat.touchAndGo
                ? "TNG: " + dat.touchAndGo + "\n"
                : "";
              var milelageDesc = dat.milelage
                ? "Milage: " + dat.milelage + "\n"
                : "";
              var spName = "";

              if (isPetrolCategory || isTNGCategory) {
                spName =
                  "SP Name: " +
                  (dat.createdBy && dat.createdBy.firstName
                    ? dat.createdBy.firstName
                    : "-") +
                  "\n";
              }

              dat.customDescription =
                spName +
                (isPetrolCategory
                  ? carPlateDesc + milelageDesc
                  : isTNGCategory
                    ? touchAndGoDesc
                    : "") +
                (expDetails.description || "");
            });

            dat.zonename = zonename.join(", ");
            dat.shopname = shopname.join(", ");
            dat.credit =
              dat.type === "credit"
                ? dat.billExpDetails.reduce(function (total, detail) {
                    return total + Number(-detail.amount || 0);
                  }, 0)
                : 0;
            dat.debit =
              dat.type === "debit"
                ? dat.billExpDetails.reduce(function (total, detail) {
                    return total + Number(detail.amount || 0);
                  }, 0)
                : 0;
            dat.date = dat.bill.claimedDate;
            dat.billNo = dat.bill.billNo;
            dat.balance = balance + (dat.debit || -dat.credit);
            dat.code = codename.join(", ");

            return dat;
          });
        })
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        zone: null,
        from: null,
        to: null,
      };
    };

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.exportLedger = function (items) {
      var Results = [
        [
          "Date",
          "Payment Voucher No",
          "Daerah",
          "Shop",
          "Description",
          "Code",
          "Debit",
          "Credit",
          "Balance",
        ],
      ];

      if (!items.length) {
        return;
      }

      items.forEach(function (collection) {
        Results.push([
          moment(collection.date).format("DD/MM/YYYY"),
          collection.billNo,
          collection.zonename || "",
          collection.shopname || "",
          collection.description || "",
          collection.code || "",
          collection.debit || "",
          collection.credit || "",
          collection.balance || "",
        ]);
      });

      $scope.export(
        Results,
        "Ledger_" + moment($scope.reportFilter.from).format("DD_MM_YYYY")
      );
    };

    $scope.export = function (data, title) {
      var CsvString = "";
      data.forEach(function (RowItem, RowIndex) {
        RowItem.forEach(function (ColItem, ColIndex) {
          CsvString += ColItem + (ColIndex === RowItem.length - 1 ? "" : ",");
        });
        CsvString += "\r\n";
      });
      CsvString = "data:application/csv," + encodeURIComponent(CsvString);
      var x = document.createElement("A");
      x.setAttribute("href", CsvString);
      x.setAttribute("download", title + ".csv");
      document.body.appendChild(x);
      x.click();
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg",
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        transform: "rotate(" + $scope.rotateDegree + "deg)",
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%",
      };
    };

    $scope.onAfterChange = function () {
      console.log("hit");
      $scope.myImageStyle = {};
      $scope.zoomInMode = false;
      $scope.rotateDegree = 0;

      $scope.$apply();
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.rotateImage = function (direction) {
      $scope.zoomInMode = false;
      $scope.myImageStyle = null;

      $scope.rotateDegree =
        direction === "left"
          ? $scope.rotateDegree - 90
          : $scope.rotateDegree + 90;
    };

    $scope.editLedger = function (item) {
      $scope.editBillExp = {
        id: item.id,
        carPlateNo: item.carPlateNo,
        milelage: item.milelage,
        touchAndGo: item.touchAndGo,
        description: item.description,
      };

      var mycategories = item.billExpDetails.map(function (detail) {
        return detail.category;
      });

      $scope.isPetrolCategory = !!mycategories.find(function (cat) {
        return cat.id === $scope.petrolCategoryId;
      });
      $scope.isTNGCategory = !!mycategories.find(function (cat) {
        return cat.id === $scope.tngCategoryId;
      });

      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/accDepartment/ledger/modals/billExpModal.html",
        scope: $scope,
      });
    };

    $scope.saveBillExp = function (toClose) {
      $scope.loading = true;

      var obj = {
        id: $scope.editBillExp.id,
        description: $scope.editBillExp.description,
        touchAndGo:
          $scope.isTNGCategory && $scope.editBillExp.touchAndGo
            ? $scope.editBillExp.touchAndGo
            : null,
        carPlateNo:
          $scope.isPetrolCategory && $scope.editBillExp.carPlateNo
            ? $scope.editBillExp.carPlateNo
            : null,
        milelage:
          $scope.isPetrolCategory && $scope.editBillExp.milelage
            ? $scope.editBillExp.milelage
            : null,
      };

      billService.saveBillExpDesc(obj).then(function () {
        toastr.success("Exp has been saved successfully!", "SUCCESS");

        toClose();

        $scope.editBillExp = null;

        $scope.load();
      });
    };

    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.bill")
    .controller("BillPageCtrl", BillPageCtrl);

  /** @ngInject */
  function BillPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,

    billService,
    $sce
  ) {
    $scope.loading = false;
    $scope.searching = false;
    $scope.pendingApprovalConfig = {
      loading: false,
      data: {},
      pendingCount: 0
    };
    $scope.smartTablePageSize = 25;
    $scope.billExpList = [];
    $scope.reportFilter = {
      state: null,
      zone: null
    };
    $scope.manageStatesList = [];
    $scope.manageZonesList = [];
    $scope.manageShopsList = [];
    $scope.manageShopsListByZone = [];
    $scope.categories = [];
    $scope.paymentHistoryList = [];
    $scope.categoryToPaid = [];

    $scope.selectedEditBill = null;
    $scope.selectedBillExpDetail = null;
    $scope.selectedBillExpDetailHistory = null;
    $scope.rotateDegree = 0;
    $scope.selectedBillExpCodeByShops = [];

    $scope.petrolCategoryId = 43;
    $scope.tngCategoryId = 44;
    $scope.isPetrolCategory = false;
    $scope.isTNGCategory = false;

    $scope.photoURL = [];
    $scope.selectedPhotos = [];

    $scope.selectedBillExpsToPaid = {};
    $scope.isAdmin =
      $rootScope.userData.credentials.role === 1 ||
      $rootScope.userData.credentials.role === 5;
    $scope.allowToViewShopCategory =
      $rootScope.userData.credentials.role === 1 ||
      $rootScope.userData.credentials.role === 5 ||
      $rootScope.userData.credentials.role === 6;
    $scope.shopCategory = [];

    $scope.billChecker = {
      checkAll: false
    };
    $scope.billExpStatus = billService.getBillExpStatus();
    $scope.billLogTypes = billService.getBillLogType();
    $scope.searchBillList = [];
    $scope.pendingBillExp = {
      pendingReason: null
    };

    $scope.statusFilter = "";

    $scope.onStatusFilterChange = function (status) {
      if (!status) {
        // "All" — show full list
        $scope.billExpList = $scope.billExpListOriginal.slice();
      } else {
        $scope.billExpList = $scope.billExpListOriginal.filter(function (item) {
          return item.status === status;
        });
      }
    };

    $scope.countStatus = {
      New: 0,
      Pending: 0,
      "Pending Approved": 0,
      Rejected: 0
    };

    var userReportDuration = $rootScope.userData.credentials.months;

    $scope.dateList = {
      from: moment().startOf("day").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : $rootScope.userData.roleId === 6
            ? moment().subtract(45, "day").toDate()
            : null
      }
    };

    $scope.popUpUrl;
    $scope.popUpPhoto;

    $scope.zoomInMode = false;
    $scope.myImageStyle = {};

    $scope.loading = false;

    $scope.init = function () {
      $scope.searching = true;
      if ($rootScope.userData.id && $rootScope.userData.credentials) {
        $rootScope.userData.credentials.id = $rootScope.userData.id;
      }
      Promise.all([
        billService.getZones(),
        billService.getShops(),
        billService.getPaidCategory($rootScope.userData),
        billService.getStates(),
        $scope.allowToViewShopCategory ? billService.getShopCategories() : null
      ]).then(function (res) {
        var userZones = $rootScope.userData.credentials.zonemap || [];
        var userStates = $rootScope.userData.credentials.statemap || [];
        if ($scope.allowToViewShopCategory) {
          $scope.shopCategory = res[4].data;
        }

        if ($rootScope.userData.credentials.role === 1) {
          $scope.manageZonesList = res[0].data;

          $scope.manageStatesList = res[3].data;
        } else {
          if (userZones.length) {
            $scope.manageZonesList = res[0].data.filter(function (zone) {
              return userZones.includes(zone.vipZoneId);
            });
          }

          if (userStates.length) {
            $scope.manageStatesList = res[3].data.filter(function (state) {
              return userStates.includes(state.vipStateId);
            });
          }
        }

        var zonesIds = $scope.manageZonesList.map(function (zone) {
          return zone.id;
        });
        $scope.manageShopsList = res[1].data.filter(function (shop) {
          return shop.zone && zonesIds.includes(shop.zone.id);
        });
        $scope.manageShopsListByZone = $scope.manageShopsList;

        $scope.categoryToPaid = res[2].data;

        billService
          .getBillCategory($rootScope.userData, $scope.manageZonesList)
          .then(function (res) {
            $scope.categories = res.data;
            $scope.load();
          });
      });
    };

    $scope.load = function (reset) {
      $scope.searching = true;
      if (reset) {
        $scope.reportFilter = {
          zone: null,
          state: null,
          categoryid: null
        };
      }
      var filter = [];
      var statusFilter = {};

      $scope.getStatusCount();

      // set filter for data that relate to user assigned zones
      var userZones = $rootScope.userData.credentials.zonemap || [];
      if ($scope.reportFilter.state) {
        filter.push({
          field: "bill_zone_state.id",
          search: $scope.reportFilter.state.id,
          operation: "eq"
        });

        statusFilter.state = $scope.reportFilter.state.id;
      }

      if ($scope.reportFilter.zone) {
        filter.push({
          field: "bill_zones.id",
          search: $scope.reportFilter.zone.id,
          operation: "eq"
        });

        statusFilter.zone = $scope.reportFilter.zone.id
          ? [$scope.reportFilter.zone.id]
          : [];
      } else if ($rootScope.userData.credentials.role !== 1) {
        var myZones = userZones
          .map(function (zone) {
            var manageZone = $scope.manageZonesList.find(function (mz) {
              return mz.vipZoneId === zone;
            });

            return manageZone ? manageZone.id : null;
          })
          .filter(function (zone) {
            return !!zone;
          });
        filter.push({
          field: myZones.length ? "bill_zones.id" : "id",
          search: myZones.length ? myZones : true,
          operation: myZones.length ? "in" : "isnull"
        });

        statusFilter.zone = myZones.length ? myZones : [];
      }

      if ($scope.reportFilter.categoryid) {
        filter.push({
          field: "shop_category.id",
          search: $scope.reportFilter.categoryid.id,
          operation: "eq"
        });

        statusFilter.categoryid = $scope.reportFilter.categoryid.id;
      }

      filter.push(
        {
          field: "bill.claimedDate",
          search: moment($scope.dateList.from)
            .utcOffset(8)
            .startOf("day")
            .toISOString(),
          operation: "gte"
        },
        {
          field: "bill.claimedDate",
          search: moment($scope.dateList.to)
            .utcOffset(8)
            .endOf("day")
            .toISOString(),
          operation: "lte"
        }
      );

      statusFilter.startDate = moment($scope.dateList.from)
        .utcOffset(8)
        .startOf("day")
        .toISOString();
      statusFilter.endDate = moment($scope.dateList.to)
        .utcOffset(8)
        .endOf("day")
        .toISOString();

      billService
        .getBillExpDetailList(filter)
        .then(
          function (res) {
            $scope.billExpListOriginal = res.data.map(function (dat) {
              return $scope.formatBillExp(dat);
            });
            $scope.billExpList = $scope.billExpListOriginal.slice();
          },
          function (err) {}
        )
        .finally(function () {
          $scope.searching = false;
        });
    };

    $scope.getStatusCount = function () {
      var statusFilter = {};

      if ($scope.reportFilter.state) {
        statusFilter.state = $scope.reportFilter.state.id;
      }

      if ($scope.reportFilter.zone) {
        statusFilter.zone = $scope.reportFilter.zone.id
          ? [$scope.reportFilter.zone.id]
          : [];
      } else if ($rootScope.userData.credentials.role !== 1) {
        var userZones = $rootScope.userData.credentials.zonemap || [];

        var myZones = userZones
          .map(function (zone) {
            var manageZone = $scope.manageZonesList.find(function (mz) {
              return mz.vipZoneId === zone;
            });

            return manageZone ? manageZone.id : null;
          })
          .filter(function (zone) {
            return !!zone;
          });

        statusFilter.zone = myZones.length ? myZones : [];
      }

      if ($scope.reportFilter.categoryid) {
        statusFilter.categoryid = $scope.reportFilter.categoryid.id;
      }

      statusFilter.startDate = moment($scope.dateList.from)
        .utcOffset(8)
        .startOf("day")
        .toISOString();
      statusFilter.endDate = moment($scope.dateList.to)
        .utcOffset(8)
        .endOf("day")
        .toISOString();

      billService
        .getBillExpDetailStatusCount(statusFilter)
        .then(function (res) {
          if (res.data) {
            $scope.countStatus = Object.keys($scope.countStatus).reduce(
              function (result, status) {
                result[status] = res.data[status] || 0;
                return result;
              },
              {}
            );
          }
        });
    };

    $scope.paidBillExpDetail = function (item) {
      $scope.selectedBillExpsToPaid = {};
      $scope.selectedBillExpsToPaid.paidTo = null;
      $scope.selectedBillExpsToPaid.paidAt = new Date();
      $scope.selectedBillExpsToPaid.exps = Array.isArray(item) ? item : [item];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/paidBillExpModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          if (!$scope.selectedBillExpsToPaid.paidTo) {
            toastr.error("SAVED FAILED. Paid by cannot be empty.", "ERROR");
            return;
          }

          var obj = [];

          $scope.selectedBillExpsToPaid.exps
            .filter(function (bilexp) {
              return !!bilexp.shouldPaidAmount;
            })
            .forEach(function (billexpdetail) {
              obj.push({
                amount: Number(billexpdetail.shouldPaidAmount),
                paidToBillExpDetail: { id: billexpdetail.id },
                paidFrom: { id: $scope.selectedBillExpsToPaid.paidTo.id },
                supermanUser: $rootScope.userData.credentials,
                paidAt: moment($scope.selectedBillExpsToPaid.paidAt)
                  .utcOffset(8)
                  .startOf("day")
                  .toISOString()
              });
            });

          if (!obj.length) {
            toastr.error("Saved Failed. No input amount", "ERROR");
            return;
          }

          billService.saveBillExpPaid(obj).then(
            function () {
              toastr.success("Payment Voucher paid successfully!", "SUCCESS");

              $scope.selectedBillExpsToPaid.exps.forEach(function (billexp) {
                $scope.refreshAndFormatBillExp(billexp.id);
              });

              $scope.selectedBillExpsToPaid = null;
            },
            function (err) {
              toastr.error(err.message || err.data.message, "ERROR");
            }
          );
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.createOrEditBillExp = function (item) {
      $scope.photoURL = [];
      $scope.selectedBillExpCodeByShops = [];

      $scope.isPetrolCategory = false;
      $scope.isTNGCategory = false;

      $scope.selectedBillExpDetail = {
        id: null,
        myshops: [],
        photo: null,
        amount: 0,
        myzones: [],
        billExpDetails: [],
        carPlateNo: null,
        touchAndGo: null,
        milelage: null,
        mycategories: [],
        bill: null,
        type: "debit",
        billExp: null
      };

      if (item && item.id) {
        $scope.pendingApprovalConfig.loading = true;

        billService
          .getPendingBillExp(item.id)
          .then(function (res) {
            var pendingBillExp = res.data.lastBillExpDetail
              ? $scope.formatBillExp(res.data.lastBillExpDetail)
              : null;

            var currentBillExp = res.data.billExpDetail
              ? $scope.formatBillExp(res.data.billExpDetail)
              : null;

            $scope.selectedBillExpDetail = Object.assign({}, currentBillExp);

            var toUpdatedTableRowDataIndex = $scope.billExpList.findIndex(
              function (list) {
                return list.id === $scope.selectedBillExpDetail.id;
              }
            );

            if (toUpdatedTableRowDataIndex !== -1) {
              $scope.billExpList[toUpdatedTableRowDataIndex] =
                $scope.selectedBillExpDetail;
            }

            $scope.onZoneSelect();

            if ($scope.selectedBillExpDetail.mycategories.length) {
              $scope.selectedBillExpDetail.mycategories.forEach(function (cat) {
                $scope.onCategorySelect(
                  cat,
                  $scope.selectedBillExpDetail.billExpDetails
                );
              });
            }

            $scope.photoURL = ($scope.selectedBillExpDetail.photos || []).map(
              function (photo) {
                return {
                  file: null,
                  url: photo
                };
              }
            );

            $scope.pendingApprovalConfig.data = {};
            $scope.pendingApprovalConfig.pendingCount =
              res.data.pendingCount || 0;

            if (pendingBillExp) {
              var itemCats = $scope.selectedBillExpDetail.mycategories.map(
                function (cat) {
                  return cat.id;
                }
              );
              var pendingCats = pendingBillExp.mycategories.map(function (cat) {
                return cat.id;
              });
              var isSameCats = itemCats.every(function (cat) {
                return pendingCats.includes(cat);
              });

              $scope.pendingApprovalConfig.data.description =
                Number(pendingBillExp.description) !==
                Number($scope.selectedBillExpDetail.description);

              $scope.pendingApprovalConfig.data.amount =
                Number(pendingBillExp.amount) !==
                Number($scope.selectedBillExpDetail.amount);

              $scope.pendingApprovalConfig.data.type =
                pendingBillExp.type !== $scope.selectedBillExpDetail.type;

              $scope.pendingApprovalConfig.data.mycategories = !isSameCats;

              $scope.pendingApprovalConfig.data.carPlateNo =
                formatString(pendingBillExp.carPlateNo) !==
                formatString($scope.selectedBillExpDetail.carPlateNo);

              $scope.pendingApprovalConfig.data.milelage =
                formatString(pendingBillExp.milelage) !==
                formatString($scope.selectedBillExpDetail.milelage);

              $scope.pendingApprovalConfig.data.touchAndGo =
                formatString(pendingBillExp.touchAndGo) !==
                formatString($scope.selectedBillExpDetail.touchAndGo);

              var pendingPhotos = pendingBillExp.photos || [];
              var itemPhotos = $scope.selectedBillExpDetail.photos || [];
              $scope.pendingApprovalConfig.data.photos =
                pendingPhotos.sort().toString() !==
                itemPhotos.sort().toString();

              var diffDescription =
                ($scope.selectedBillExpDetail.description || "").trim() !==
                (pendingBillExp.description || "").trim();
              if ($scope.pendingApprovalConfig.data.amount || diffDescription) {
                var invalidShop = pendingBillExp.myshops.length
                  ? pendingBillExp.myshops[0]
                  : $scope.selectedBillExpDetail.myshops.length
                    ? $scope.selectedBillExpDetail.myshops[0]
                    : null;

                if (invalidShop) {
                  $scope.pendingApprovalConfig.data.shops = {};

                  $scope.pendingApprovalConfig.data.shops[invalidShop.id] = {
                    amount: $scope.pendingApprovalConfig.data.amount,
                    description: diffDescription
                  };
                }
              }
            }
          })
          .finally(function () {
            $scope.pendingApprovalConfig.loading = false;
          });
      }

      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/accDepartment/bill/modals/billexpModal.html",
        scope: $scope
      });
    };

    $scope.saveBillExp = function (toClose) {
      if (!$scope.selectedBillExpDetail.bill) {
        toastr.warning("Error", "Payment voucher is required");
        return;
      }

      var totalShopAmount = $scope.selectedBillExpCodeByShops.reduce(function (
        total,
        code
      ) {
        return (
          total +
          code.shops.reduce(function (shopTotal, shop) {
            return shopTotal + Number(shop.amount || 0);
          }, 0)
        );
      }, 0);

      if (
        totalShopAmount !== $scope.selectedBillExpDetail.amount &&
        Math.abs(totalShopAmount - $scope.selectedBillExpDetail.amount) > 0.01
      ) {
        toastr.warning(
          "Error",
          "Amount different with shop amount: " +
            totalShopAmount +
            "," +
            $scope.selectedBillExpDetail.amount
        );
        return;
      }

      $scope.loading = true;

      ($scope.photoURL.length
        ? Promise.all(
            $scope.photoURL.map(function (photo) {
              return photo.file ? billService.uploadImage(photo.file) : photo;
            })
          )
        : Promise.resolve([])
      ).then(function (urls) {
        var currentBillExpDetails = [];

        $scope.selectedBillExpCodeByShops.forEach(function (cat) {
          cat.shops.forEach(function (shop) {
            if (shop.id || Number(shop.amount || 0) !== 0) {
              currentBillExpDetails.push({
                id: shop.id || undefined,
                amount: Number(shop.amount || 0),
                category: { id: cat.catid },
                shop: { id: shop.shopid },
                description: (shop.description || "").toString().trim() || null
              });
            }
          });
        });

        var obj = {
          type: $scope.selectedBillExpDetail.type,
          // use bill exp  id
          billDetailId: $scope.selectedBillExpDetail.id,
          id:
            $scope.selectedBillExpDetail.billExp &&
            $scope.selectedBillExpDetail.billExp.id
              ? $scope.selectedBillExpDetail.billExp.id
              : null,
          photos: urls.map(function (url) {
            return url.data && url.data.url ? url.data.url : url.url;
          }),
          bill: { id: $scope.selectedBillExpDetail.bill.id },
          touchAndGo:
            $scope.isTNGCategory && $scope.selectedBillExpDetail.touchAndGo
              ? $scope.selectedBillExpDetail.touchAndGo
              : null,
          carPlateNo:
            $scope.isPetrolCategory && $scope.selectedBillExpDetail.carPlateNo
              ? $scope.selectedBillExpDetail.carPlateNo
              : null,
          milelage:
            $scope.isPetrolCategory && $scope.selectedBillExpDetail.milelage
              ? $scope.selectedBillExpDetail.milelage
              : null,
          amount: Number($scope.selectedBillExpDetail.amount),
          billExpDetails: currentBillExpDetails,
          supermanUser: $scope.selectedBillExpDetail.id
            ? undefined
            : $rootScope.userData.credentials
        };

        billService.saveBillExp(obj).then(
          function (res) {
            toastr.success(
              "Payment Voucher Exp has been saved successfully!",
              "SUCCESS"
            );

            $scope.loading = false;

            toClose();

            $scope.selectedBillExpDetail = null;

            $scope.refreshAndFormatBillExp(
              res.data.billExpDetail.map(function (dat) {
                return dat.id;
              }),
              res.data.deletedBillEexpDetail
            );
          },
          function (err) {
            toastr.error(err.message || err.data.message, "ERROR");
            $scope.loading = false;
          }
        );
      });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};
      $scope.rotateDegree = 0;

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg"
      });
    };

    $scope.onAfterChange = function () {
      $scope.myImageStyle = {};
      $scope.zoomInMode = false;
      $scope.rotateDegree = 0;

      $scope.$apply();
    };

    $scope.viewPaymentHistory = function (item) {
      $scope.selectedBillExpDetailHistory = item;
      $scope.loading = true;
      $scope.paymentHistoryList = [];

      billService
        .getBillExpHistoryLogs(item.id)
        .then(function (res) {
          $scope.paymentHistoryList = res.data;
        })
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.refreshAndFormatBillExp = function (id, deletedRowID) {
      $scope.loading = true;

      $scope.getStatusCount();

      var ids = Array.isArray(id) ? id : [id];

      Promise.all(
        ids.map(function (detailid) {
          return billService.getBillExpDetailById(detailid);
        })
      )
        .then(function (billExps) {
          billExps.forEach(function (billExp) {
            var currentBillExp = $scope.formatBillExp(billExp.data);

            var matchedOriginalIndex = $scope.billExpListOriginal.findIndex(
              function (b) {
                return b.id === currentBillExp.id;
              }
            );

            if (matchedOriginalIndex !== -1) {
              $scope.billExpListOriginal[matchedOriginalIndex] = currentBillExp;
            } else {
              $scope.billExpListOriginal.unshift(currentBillExp);
            }

            $scope.onStatusFilterChange($scope.statusFilter);
          });

          if (deletedRowID) {
            $scope.billExpListOriginal = $scope.billExpListOriginal.filter(
              function (bill) {
                return bill.id !== deletedRowID;
              }
            );
          }
        })
        .finally(function () {
          $scope.loading = false;

          $scope.billExpList = $scope.billExpListOriginal.slice();
        });
    };

    $scope.confirmDeleteBillPaymentHistory = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/deletePaymentHistoryModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService.deletePaymentHistory(id).then(
            function (res) {
              toastr.success("Payment is deleted successfully", "SUCCESS");
              $scope.paymentHistoryList = $scope.paymentHistoryList.filter(
                function (payment) {
                  return payment.pid !== id;
                }
              );
            },
            function (err) {
              toastr.error(err.data.message, "DELETE FAILED");
            }
          );
        },
        function () {}
      );
    };

    $scope.confirmDeleteBillExpDetail = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/deleteBillExpModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService.deleteBillExpDetail(id).then(
            function (res) {
              toastr.success(
                "Payment Voucher is deleted successfully",
                "SUCCESS"
              );
              $scope.billExpList = $scope.billExpList.filter(function (bill) {
                return bill.id !== id;
              });
            },
            function (err) {
              toastr.error(err.data.message, "DELETE FAILED");
            }
          );
        },
        function () {}
      );
    };

    $scope.init();

    $scope.editBill = function (item) {
      $scope.selectedEditBill = item;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/accDepartment/bill/modals/billModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          var obj = {
            id: $scope.selectedEditBill.id || null,
            status: "Pending",
            claimedDate: moment($scope.selectedEditBill.claimedDate)
              .utcOffset("8")
              .startOf("day")
              .toISOString(),
            createdBySuperman: $rootScope.userData.credentials,
            zones: $scope.selectedEditBill.zones.map(function (zone) {
              return { id: zone.id, code: zone.code };
            })
          };

          billService.saveBill(obj).then(function (res) {
            toastr.success(
              !$scope.selectedEditBill.id
                ? "Payment Voucher" + res.data.billNo + "generated success"
                : "Payment Voucher updated success",
              "SUCCESS"
            );
          });
        },
        function () {}
      );
    };

    $scope.generateBill = function () {
      $scope.editBill({
        zones: [],
        claimedDate: moment().utcOffset(8).toDate(),
        status: "Pending",
        createdBySuperman: $rootScope.userData.credentials
      });
    };

    $scope.closeDetail = function () {
      $scope.selectedBillExpDetailHistory = null;

      $scope.billChecker = {
        checkAll: false
      };
      $scope.load();
    };

    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.onFileChange = function (files) {
      if (!files.length) {
        return;
      }

      Array.from(files).forEach(function (file) {
        var processedFile = $scope.isAdmin
          ? new Promise(function (resolve, reject) {
              var image = new Image();
              var imageURL = URL.createObjectURL(file);

              image.onload = function () {
                URL.revokeObjectURL(imageURL);

                try {
                  var canvas = document.createElement("canvas");
                  canvas.width = image.naturalWidth;
                  canvas.height = image.naturalHeight;
                  canvas.getContext("2d").drawImage(image, 0, 0);
                  watermark.text.lowerLeft(
                    "OFFICE",
                    "20px sans-serif",
                    "red"
                  )(canvas);
                  canvas.toBlob(
                    function (blob) {
                      canvas.width = 0;
                      canvas.height = 0;
                      if (blob) {
                        resolve(blob);
                      } else {
                        reject(
                          new Error("Could not encode watermarked photo.")
                        );
                      }
                    },
                    "image/jpeg",
                    1
                  );
                } catch (error) {
                  reject(error);
                }
              };

              image.onerror = function () {
                URL.revokeObjectURL(imageURL);
                reject(new Error("Could not load photo for watermarking."));
              };
              image.src = imageURL;
            })
          : Promise.resolve(file);

        processedFile
          .then(function (file) {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              $scope.$evalAsync(function () {
                $scope.photoURL.unshift({ file: file, url: reader.result });
              });
            });

            reader.readAsDataURL(file);
          })
          .catch(function (error) {
            $scope.$evalAsync(function () {
              toastr.error(error.message, "Photo upload failed");
            });
          });
      });
    };

    $scope.approvedOrRejectSelected = function (status) {
      var selectedBillExps = $scope.billExpList.filter(function (exp) {
        return $scope.billChecker[exp.id] === true;
      });

      if (!selectedBillExps.length) {
        toastr.error("No data is selected", "ERROR");
        return;
      }

      $scope.approveOrRejectBillExp(selectedBillExps, status);
    };

    $scope.paidSelected = function (isPaidAll) {
      var selectedBillExps = isPaidAll
        ? isPaidAll.filter(function (exp) {
            return exp.shouldPaidAmount !== 0;
          })
        : $scope.billExpList.filter(function (exp) {
            return $scope.billChecker[exp.id] === true;
          });

      if (!selectedBillExps.length) {
        toastr.error("No data is selected", "ERROR");
        return;
      }

      $scope.paidBillExpDetail(selectedBillExps);
    };

    $scope.onCheckBoxChange = function (billExpId) {
      if (billExpId) {
        var hasItemUncheck = $scope.billExpList.find(function (billexp) {
          return !$scope.billChecker[billexp.id];
        });

        $scope.billChecker.checkAll = !hasItemUncheck;
      } else {
        $scope.billExpList.forEach(function (dat) {
          $scope.billChecker[dat.id] = $scope.billChecker.checkAll;
        });
      }
    };

    $scope.deleteImage = function (index) {
      $scope.photoURL = $scope.photoURL.filter(function (photo, i) {
        return index !== i;
      });
    };

    $scope.onColumnClick = function (billExp, size, index) {
      $scope.billChecker[billExp.id] = !$scope.billChecker[billExp.id];
      $scope.onCheckBoxChange(billExp.id);
    };

    $scope.onZoneSelect = function (item, model) {
      $scope.manageShopsListByZone = $scope.manageShopsList.filter(
        function (shop) {
          return (
            shop.zone &&
            $scope.selectedBillExpDetail.myzones.find(function (myzone) {
              return myzone.id === shop.zone.id;
            })
          );
        }
      );

      if ($scope.selectedBillExpDetail.myshops.length) {
        var match = $scope.manageShopsListByZone.filter(function (shop) {
          return $scope.selectedBillExpDetail.myshops.find(function (myshop) {
            return myshop.id === shop.id;
          });
        });

        $scope.selectedBillExpDetail.myshops = match.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        $scope.selectedBillExpCodeByShops =
          $scope.selectedBillExpCodeByShops.map(function (cat) {
            cat.shops = cat.shops.filter(function (shop) {
              return match.find(function (m) {
                return m.id === shop.shopid;
              });
            });
            return cat;
          });
      }
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        transform: "rotate(" + $scope.rotateDegree + "deg)",
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%"
      };
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.rotateImage = function (direction) {
      // if ($scope.zoomInMode) {
      //   $scope.myImageStyle = Object.assign({}, $scope.myImageStyle, {
      //     transform: "rotate(" + (direction === "left" ? -90 : 90) + "deg)",
      //   });
      //   return;
      // }

      $scope.zoomInMode = false;
      $scope.myImageStyle = null;

      $scope.rotateDegree =
        direction === "left"
          ? $scope.rotateDegree - 90
          : $scope.rotateDegree + 90;
    };

    $scope.onShopSelect = function (item, model) {
      if (!$scope.selectedBillExpCodeByShops.length) {
        return;
      }

      if (item.zone) {
        $scope.selectedBillExpCodeByShops =
          $scope.selectedBillExpCodeByShops.map(function (cat) {
            var existingShop = cat.shops.find(function (shop) {
              return shop.shopid === item.id;
            });
            if (!existingShop) {
              cat.shops.push({
                id: undefined,
                shopid: item.id,
                shopname: item.name,
                amount: 0,
                description: ""
              });
            }
            return cat;
          });
      }
    };

    $scope.onShopRemove = function (item) {
      $scope.selectedBillExpCodeByShops = $scope.selectedBillExpCodeByShops.map(
        function (cat) {
          cat.shops = cat.shops.filter(function (shop) {
            return shop.shopid !== item.id;
          });
          return cat;
        }
      );
    };

    $scope.onCategoryRemove = function (item) {
      $scope.selectedBillExpCodeByShops =
        $scope.selectedBillExpCodeByShops.filter(function (cat) {
          return cat.catid !== item.id;
        });

      $scope.checkPetrolAndTngVisibility();
    };

    $scope.onCategorySelect = function (item, defaultValues) {
      $scope.checkPetrolAndTngVisibility();
      var existedCategory = $scope.selectedBillExpCodeByShops.find(
        function (cat) {
          return cat.catid === item.id;
        }
      );

      if (existedCategory) {
        return;
      }

      var codeByShop = {
        catid: item.id,
        name: item.name + " - " + (item.description || ""),
        shops: []
      };

      if ($scope.selectedBillExpDetail.myshops.length) {
        $scope.selectedBillExpDetail.myshops.forEach(function (shop) {
          var currentDefaultValue =
            defaultValues &&
            defaultValues.find(function (def) {
              return (
                def.shop &&
                def.shop.id === shop.id &&
                def.category &&
                def.category.id === item.id
              );
            });

          codeByShop.shops.push({
            id: currentDefaultValue ? currentDefaultValue.id : null,
            amount: currentDefaultValue
              ? Number(currentDefaultValue.amount)
              : 0,
            shopid: shop.id,
            shopname: shop.name,
            description: currentDefaultValue
              ? currentDefaultValue.description
              : ""
          });
        });
      }

      $scope.selectedBillExpCodeByShops.push(codeByShop);
    };

    $scope.checkPetrolAndTngVisibility = function () {
      $scope.isPetrolCategory =
        !!$scope.selectedBillExpDetail.mycategories.find(function (cat) {
          return cat.id === $scope.petrolCategoryId;
        });
      $scope.isTNGCategory = $scope.selectedBillExpDetail.mycategories.find(
        function (cat) {
          return cat.id === $scope.tngCategoryId;
        }
      );
    };

    $scope.confirmPending = function (item) {
      $scope.pendingBillExp = {
        expDetailId: item.id,
        pendingReason: item.pendingReason,
        supermanUser: $rootScope.userData.credentials
      };

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/billExpPendingModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService.setToPendingBillExp($scope.pendingBillExp).then(
            function (res) {
              toastr.success("Exp set to pending successfully", "SUCCESS");

              $scope.refreshAndFormatBillExp(item.id);
            },
            function (err) {
              toastr.error(err.data.message, "ERROR");
            }
          );
        },
        function () {}
      );
    };

    $scope.approveOrRejectBillExp = function (item, status) {
      var items = Array.isArray(item) ? item : [item];

      $scope.approvedRejectBillExpStatus = { items: items, status: status };

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/accDepartment/bill/modals/rejectModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          billService
            .approveRejectBillExp({
              status: status,
              ids: items.map(function (ite) {
                return ite.id;
              }),
              supermanUser: $rootScope.userData.credentials
            })
            .then(
              function (res) {
                toastr.success(
                  (items.length > 1 ? items.length : "") +
                    " Payment Voucher Exp " +
                    (!!$scope.approvedRejectBillExpStatus.status
                      ? "approved"
                      : "rejected") +
                    " successfully",
                  "SUCCESS"
                );

                $scope.billExpList = $scope.billExpList.map(function (item) {
                  if (
                    items.find(function (ite) {
                      return ite.id === item.id;
                    })
                  ) {
                    item.status = !!status ? "Approved" : "Rejected";
                    return item;
                  }

                  return item;
                });
              },
              function (err) {
                if (err.data && err.data.message) {
                  toastr.error(err.data.message, "ERROR");
                }
              }
            );
        },
        function (err) {}
      );
    };

    $scope.searchRepositories = function (searchText) {
      if (!searchText || searchText.length < 1) {
        $scope.searchBillList = [];
        return;
      }

      $scope.searchBillList = [{ id: 0, billNo: "Loading..." }];

      billService
        .getBillList([
          {
            field: "billNo",
            search: searchText || "",
            operation: "contL"
          }
        ])
        .then(function (res) {
          $scope.searchBillList = res.data.length
            ? res.data
            : [{ id: 0, billNo: "No Payment Voucher Found" }];
        });
    };

    $scope.formatBillExp = function (dat) {
      var cur = dat;
      var isPetrolCategory = false;
      var isTNGCategory = false;
      var myshops = [];
      var myzones = [];
      var mycategories = [];
      var myshopCategory = [];

      cur.id = dat.id;
      cur.amount = Number(dat.amount);
      cur.name = dat.billExp.createdBy
        ? dat.billExp.createdBy.firstName
        : dat.billExp.supermanUser
          ? dat.billExp.supermanUser.name
          : "";
      cur.ramount =
        dat.billExp.type === "debit" ? Number(cur.amount) : -Number(cur.amount);
      cur.type = dat.billExp.type;
      cur.billExpDetails = dat.id
        ? [
            {
              id: dat.id,
              category: dat.category,
              shop: dat.shop,
              amount: dat.amount,
              description: dat.description
            }
          ]
        : [];
      cur.photos = dat.billExp.photos || [];
      cur.carPlateNo = dat.billExp.carPlateNo || "";
      cur.touchAndGo = dat.billExp.touchAndGo || "";
      cur.milelage = dat.billExp.milelage || "";
      cur.description = dat.description || "";

      cur.pamount = (dat.paidBys || []).reduce(function (total, paid) {
        return total + Number(paid.amount);
      }, 0);

      cur.shouldPaidAmount = Number(cur.ramount) - cur.pamount;
      cur.pendingReason = dat.pendingReason || "";

      if (!isPetrolCategory && dat.category.id === $scope.petrolCategoryId) {
        isPetrolCategory = true;
      }

      if (!isTNGCategory && dat.category.id === $scope.tngCategoryId) {
        isTNGCategory = true;
      }

      var existedShop = myshops.find(function (shop) {
        return dat.shop && shop.id === dat.shop.id;
      });

      var existedZone = myzones.find(function (zone) {
        return dat.shop && dat.shop.zone && zone.id === dat.shop.zone.id;
      });

      var existedShopCategory = myshopCategory.find(function (sc) {
        return (
          dat.shop &&
          dat.shop.shopCategory &&
          sc.id === dat.shop.shopCategory.id
        );
      });

      if (dat.shop && !existedShop) {
        myshops.push(dat.shop);
        if (dat.shop.zone && !existedZone) {
          myzones.push(dat.shop.zone);
        }
      }

      if (
        dat.category &&
        !mycategories.find(function (cat) {
          return cat.id === dat.category.id;
        })
      ) {
        mycategories.push(dat.category);
      }

      if (dat.shop.shopCategory && !existedShopCategory) {
        myshopCategory.push(dat.shop.shopCategory);
      }

      cur.mycategories = mycategories.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      cur.catname = cur.mycategories
        .map(function (cat) {
          return cat.name;
        })
        .join(",");
      cur.myzones = myzones;
      cur.zonename = myzones
        .map(function (zone) {
          return zone.name || zone.code;
        })
        .join(",");
      cur.myshops = myshops.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      cur.shopname = cur.myshops
        .map(function (shop) {
          return shop.name || shop.code;
        })
        .join(",");
      cur.shopcategory = myshopCategory
        .sort(function (a, b) {
          return a.name.localeCompare(b.name);
        })
        .map(function (sc) {
          return sc.name || sc.code;
        })
        .join(",");
      cur.billNo =
        dat.billExp.bill && dat.billExp.bill.billNo
          ? dat.billExp.bill.billNo
          : "";
      cur.bill = dat.billExp.bill;
      // todo
      cur.status = dat.status;

      cur.dispalyClaimedDate =
        dat.billExp.bill && dat.billExp.bill.claimedDate
          ? moment(dat.billExp.bill.claimedDate)
              .utcOffset(8)
              .format("DD/MM/YYYY")
          : "";

      var carPlateDesc = cur.carPlateNo
        ? "Car Plate: " + cur.carPlateNo + "\n"
        : "";
      var touchAndGoDesc = cur.touchAndGo
        ? "TNG: " + cur.touchAndGo + "\n"
        : "";
      var milelageDesc = cur.milelage ? "Milage: " + cur.milelage + "\n" : "";

      cur.customDescription =
        (isPetrolCategory
          ? carPlateDesc + milelageDesc
          : isTNGCategory
            ? touchAndGoDesc
            : "") + (cur.description || "");

      return cur;
    };

    $scope.onPaymentVoucherSelect = function (item) {
      if (!item || !item.id) {
        $scope.selectedBillExpDetail.bill = null;
      }
    };

    $scope.updatePendingData = function (key, approval) {
      if (approval) {
        $scope.selectedBillExpDetail[key] =
          $scope.pendingApprovalConfig.data[key];
      }

      delete $scope.pendingApprovalConfig.data[key];
    };

    function formatString(str) {
      if (!str) {
        return;
      }

      return str.toLowerCase().trim();
    }
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.accDepartment.bill")
    .service("billService", billService);

  /** @ngInject */
  function billService($http) {
    var getBillList = function (filter) {
      return httpToAymSystem(
        parseFilterToQueryParams(
          filter,
          "/public-bill?sort=createdAt,DESC&limit=10"
        ),
        "GET"
      );
    };

    var getBillExpDetailList = function (filter) {
      return httpToAymSystem(
        parseFilterToQueryParams(filter, "/public-bill-exp-detail"),
        "GET"
      );
    };

    var getBillExpDetailById = function (id) {
      return httpToAymSystem("/public-bill-exp-detail/" + id, "GET");
    };

    var getFEmployee = function () {
      return httpToAymSystem("/public/f-user", "GET");
    };

    var uploadImage = function (file) {
      var form = new FormData();
      form.append("file", file);
      form.append("extra", JSON.stringify({}));
      form.append("usage", "bill-exp");

      return httpToAymSystem("/asset/upload", "POST", form, {
        "Content-Type": undefined
      });
    };

    var getAccountType = function () {
      return httpToAymSystem("/public-bill/bill-account-type", "GET");
    };

    var getPaidCategory = function (userData) {
      var isAdmin = userData.credentials.role === 1;
      var queryParams = "";

      if (!isAdmin) {
        var userZones = userData.credentials.zonemap || [];

        userZones.forEach(function (zone, index) {
          queryParams += (index > 0 ? "&" : "") + "zones=" + zone;
        });

        if (!userZones.length) {
          queryParams = "zones=" + 0;
        }

      }

      return httpToAymSystem(
        "/public-bill/category-paid?" + queryParams,
        "GET"
      );
    };

    var getBillExpListBy = function (billid) {
      return httpToAymSystem("/public-bill/exp/" + billid, "GET");
    };

    var getBillExpHistoryLogs = function (billexpid) {
      return httpToAymSystem(
        "/public-bill/exp-detail-history/" + billexpid,
        "GET"
      );
    };

    var getPendingBillExp = function (billexpid) {
      return httpToAymSystem("/public-bill/exp-pending/" + billexpid, "GET");
    };

    var getBillCategory = function (userData, zones) {
      var isAdmin = userData.credentials.role === 1;
      var queryParams = "";

      if (!isAdmin) {
        var userZones = userData.credentials.zonemap || [];

        var myZones = userZones
          .map(function (zone) {
            var manageZone = zones.find(function (mz) {
              return mz.vipZoneId === zone;
            });

            return manageZone ? manageZone.id : null;
          })
          .filter(function (zone) {
            return !!zone;
          });

        myZones.forEach(function (zone, index) {
          queryParams += (index > 0 ? "&" : "") + "zones=" + zone;
        });

        if (!myZones.length) {
          queryParams = "zones=" + 0;
        }
      }

      return httpToAymSystem("/public-bill/category?" + queryParams, "GET");
    };

    var getZones = function () {
      return httpToAymSystem("/public/zones", "GET");
    };

    var getStates = function () {
      return httpToAymSystem("/public/states", "GET");
    };

    var getShops = function () {
      return httpToAymSystem("/public/shops", "GET");
    };

    var getShopCategories = function () {
      return httpToAymSystem("/public/shop-categories", "GET");
    };

    var deleteAccountType = function (id) {
      return httpToAymSystem("/public-bill/bill-account-type/" + id, "DELETE");
    };

    var deletePaymentHistory = function (id) {
      return httpToAymSystem("/public-bill/paid-history/" + id, "DELETE");
    };

    var deleteCategory = function (id) {
      return httpToAymSystem("/public-bill/category/" + id, "DELETE");
    };

    var deleteBillExpDetail = function (id) {
      return httpToAymSystem("/public-bill-exp-detail/" + id, "DELETE");
    };

    var approveRejectBillExp = function (dto) {
      return httpToAymSystem("/public-bill/exp/approval", "POST", dto);
    };

    var deleteBill = function (id) {
      return httpToAymSystem("/public-bill/" + id, "DELETE");
    };

    var saveBill = function (body) {
      body.type = "Driver Claim";
      return httpToAymSystem("/public-bill", "POST", body);
    };

    var setToPendingBillExp = function (body) {
      return httpToAymSystem("/public-bill-exp-detail/pending", "POST", body);
    };

    var getBillExpDetailStatusCount = function (body) {
      return httpToAymSystem(
        "/public-bill-exp-detail/status-count",
        "POST",
        body
      );
    };

    var parseFilterToQueryParams = function (filterObj, path) {
      if (!filterObj || !filterObj.length) {
        return path;
      }

      var queryString = { $and: [] };

      filterObj.forEach(function (filter) {
        var fallbackOperation = filter.operation || "eq";
        var objs = {};
        objs[filter.field] = {};
        objs[filter.field][fallbackOperation] = filter.search;

        queryString.$and.push(objs);
      });

      var filterQueryString = encodeURIComponent(JSON.stringify(queryString));

      return filterObj && filterObj.length
        ? path + (path.includes("?") ? "&" : "?") + "s=" + filterQueryString
        : path;
    };

    var saveAccountType = function (body) {
      return httpToAymSystem(
        "/public-bill/bill-account-type/save",
        "POST",
        body
      );
    };

    var saveCategory = function (body) {
      return httpToAymSystem("/public-bill/category/save", "POST", body);
    };

    var saveBillExp = function (body) {
      return httpToAymSystem(
        "/public-bill-exp-detail/custom-save",
        "POST",
        body
      );
    };

    var saveBillExpDesc = function (body) {
      return httpToAymSystem("/public-bill/exp/save-desc", "POST", body);
    };

    var saveCategoryToZones = function (body) {
      return httpToAymSystem("/public-bill/category-zones/bulk", "POST", {
        bulk: body
      });
    };

    var saveBillExpPaid = function (body) {
      return httpToAymSystem("/public-bill/exp-paid/bulk", "POST", {
        bulk: body
      });
    };

    var saveProfitSharingHistory = function (body) {
      return httpToAymSystem("/public-bill/psh/save", "POST", body);
    };

    var getProfitSharingHistory = function (id) {
      return httpToAymSystem("/public-bill/psh/shop/" + id, "GET");
    };

    var getLedgerReport = function (body) {
      return httpToAymSystem("/public-bill/ledger", "POST", body);
    };

    var getPNLReport = function (body) {
      return httpToAymSystem("/public-bill/pnl", "POST", body);
    };

    var getPNLDetailReport = function (body) {
      return httpToAymSystem("/public-bill/pnl-detail", "POST", body);
    };

    var getBillExpStatus = function () {
      return ["Paid", "New", "Pending", "Pending Approved", "Rejected"];
    };

    var getBillLogType = function () {
      return ["EXP", "PAYMENT"];
    };

    var httpToAymSystem = function (url, method, data, headers) {
      var myHeaders = Object.assign(
        {
          "x-api-token": "SgwrvgWEkwFxfjHjznQ2"
        },
        headers || {}
      );
      return $http({
        method: method || "GET",
        url: "https://api-amy-system-v2.store.tswlab.com" + url,
        headers: myHeaders,
        data: data || null
      });
    };

    return {
      getBillList: getBillList,
      getZones: getZones,
      getStates: getStates,
      getBillExpDetailList: getBillExpDetailList,
      getBillCategory: getBillCategory,
      getShops: getShops,
      getShopCategories: getShopCategories,
      uploadImage: uploadImage,
      saveBillExp: saveBillExp,
      saveBillExpDesc: saveBillExpDesc,
      getFEmployee: getFEmployee,
      saveBillExpPaid: saveBillExpPaid,
      deleteBill: deleteBill,
      saveBill: saveBill,
      deleteBillExpDetail: deleteBillExpDetail,
      approveRejectBillExp: approveRejectBillExp,
      deleteCategory: deleteCategory,
      saveCategory: saveCategory,
      getAccountType: getAccountType,
      saveAccountType: saveAccountType,
      deleteAccountType: deleteAccountType,
      getBillExpHistoryLogs: getBillExpHistoryLogs,
      deletePaymentHistory: deletePaymentHistory,
      saveCategoryToZones: saveCategoryToZones,
      getPaidCategory: getPaidCategory,
      getPNLReport: getPNLReport,
      getPNLDetailReport: getPNLDetailReport,
      getLedgerReport: getLedgerReport,
      getProfitSharingHistory: getProfitSharingHistory,
      saveProfitSharingHistory: saveProfitSharingHistory,
      getBillExpStatus: getBillExpStatus,
      getBillLogType: getBillLogType,
      getBillExpDetailById: getBillExpDetailById,
      setToPendingBillExp: setToPendingBillExp,
      getPendingBillExp: getPendingBillExp,
      getBillExpDetailStatusCount: getBillExpDetailStatusCount
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.account.collector")
    .controller("CollectorPageCtrl", CollectorPageCtrl);

  /** @ngInject */
  function CollectorPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    collectorService,
    toastr,
    $uibModal,
    userService,
    zoneService,
    $rootScope
  ) {
    console.log("Inside CollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteCollector(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Collector List
    $scope.manageParentCollectorList = [];
    $scope.initManageParentCollector = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getParentCollector(obj);
    };

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (
          typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
          $rootScope.userData.credentials.zonemap.length > 0
        ) {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.init = function () {
      $scope.initManageParentCollector();
      $scope.initManageStates();
    };
    $scope.init();

    $scope.manageCollector = {};
    $scope.manageCollectorList = [];
    $scope.reportFilter = {};
    $scope.initManageCollector = function (reportFilter) {
      $scope.initManageParentCollector();
      // $scope.initManageStates();
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? [reportFilter.zone.id] : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        } else {
          obj.params.zoneid = reportFilter.zone ? [reportFilter.zone.id] : null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getCollector(obj);
    };
    $scope.initManageCollector($scope.reportFilter);
    // $scope.initManageStates();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageCollectorList.push($scope.inserted);
    };

    $scope.createCollector = function (manageCollector) {
      var obj = {};
      obj.params = {};
      obj.params.name = manageCollector.name;
      obj.params.code = manageCollector.code;
      obj.params.contact = manageCollector.contact;
      obj.params.parentid = manageCollector.parent
        ? manageCollector.parent.id
        : null;
      obj.params.zones = manageCollector.zones ? manageCollector.zones : null;
      // obj.params.isparent = manageCollector.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = manageCollector.isparent;
      //obj.params.description = manageCollector.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollector = {};
        toastr.success("New Collector has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Collector successfully created.");
        $scope.initManageCollector($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };

      collectorService.createCollector(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/account/collector/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteCollector = function (res) {
      console.log("Inside deleteCollector");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Collector has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageCollector($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        collectorService.deleteCollector(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (collector) {
      console.log("Inside editCollector");
      console.log(collector);
      // $scope.manageCollector.id = $scope.manageCollector.id;
      // $scope.manageCollector.name = state.name;
      // $scope.manageCollector.description = state.description;
      // $scope.manageCollector.created = state.created;
      // $scope.manageCollector.lastupdated = state.lastupdated;
      $scope.manageCollector = collector;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveCollector = function (manageCollector, id) {
      if (id === undefined) {
        $scope.createCollector(manageCollector);
      } else {
        var obj = {};
        var currentCollector = $scope.manageCollectorList.find(function (
          collector
        ) {
          return collector.id === id;
        });

        console.log(manageCollector);

        obj.params = {};
        obj.params.id = id;
        obj.params.name = manageCollector.name;
        obj.params.code = manageCollector.code;
        obj.params.contact = manageCollector.contact || "";
        obj.params.parentid = manageCollector.parent
          ? manageCollector.parent.id
          : null;
        obj.params.userid = currentCollector.userid
          ? currentCollector.userid
          : null;
        obj.params.isparent = manageCollector.isparent;
        obj.params.zones = manageCollector.zones ? manageCollector.zones : null;

        console.log("obj.params", obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollector = {};
          toastr.success("Collector has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageCollector($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        collectorService.saveCollector(obj);
      }
    };
    $scope.showStatus = function () {
      var selected = $filter("filter")($scope.statuses, {
        value: $scope.user.status,
      });
      return $scope.user.status && selected.length
        ? selected[0].text
        : "Not set";
    };

    $scope.userAccess = function (manageCollector) {
      console.log("Inside userAccess");
      console.log("manageCollector", manageCollector);

      var obj = {};
      obj.params = {};
      obj.params.username = manageCollector.code;
      obj.params.password = "password";
      obj.params.credentials = {};
      obj.params.credentials.name = manageCollector.name;
      obj.params.credentials.mobile = manageCollector.contact
        ? manageCollector.contact
        : null;
      obj.params.credentials.role = manageCollector.isparent ? 7 : 8;
      obj.params.credentials.collector = manageCollector;
      obj.params.challenges = manageCollector.parentid;

      console.log("obj.params", obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageCollector.userid = result.id;
        manageCollector.zones = manageCollector.zoneid;
        $scope.saveCollector(manageCollector, manageCollector.id);
        toastr.success(
          "Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.",
          "SUCCESS"
        );
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "ERROR");
        } else if (err.status === 422) {
          toastr.error("Username or Mobile Already Exists", "ERROR");
        } else {
          toastr.error("Unauthorized Access", "ERROR");
        }
      };

      userService.collectorSignup(obj);
    };

    $scope.showZones = function (zones) {
      if (zones && $scope.manageZonesList.length) {
        var selected = $filter("filter")(
          $scope.manageZonesList,
          {
            id: zones,
          },
          true
        );
        return selected.length
          ? selected[0].code + ", " + selected[0].name
          : "Not set";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector')
    .service('collectorService', collectorService);

  /** @ngInject */
  function collectorService(Collector) {
    var getCollector = function (obj) {
      if (_.isArray(obj.params.zoneid) && obj.params.zoneid.length > 0) {
        Collector.find({
          filter: {
            where: {
              // zoneid: obj.params.zoneid.length > 0 ? {
              //   inq: obj.params.zoneid
              // } : obj.params.zoneid,
              zoneid: {
                inq: obj.params.zoneid
              },
            },
            include: ["user", "parent"]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {

        Collector.find({
          filter: {
            include: ["user", "parent"]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }
    };
    var getParentCollector = function (obj) {

      Collector.find({
        filter: {
          where: {
            isparent: true
          },
          include: ["user", "parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getCollectorStaff = function (obj) {

      Collector.find({
        filter: {
          where: {
            parentid: obj.params.parentid
          },
          include: ["user"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createCollector = function (obj) {
      var date = new Date();

      Collector.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zones

      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteCollector = function (obj) {

      Collector.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveCollector = function (obj) {
      var date = new Date();

      Collector.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zones
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var unbindCollector = function (obj) {
      var date = new Date();

      Collector.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getCollector: getCollector,
      createCollector: createCollector,
      deleteCollector: deleteCollector,
      saveCollector: saveCollector,
      getParentCollector: getParentCollector,
      unbindCollector: unbindCollector,
      getCollectorStaff: getCollectorStaff
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner')
    .controller('PartnerPageCtrl', PartnerPageCtrl);

  /** @ngInject */
  function PartnerPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnerService, toastr, $uibModal, userService, zoneService, $rootScope) {
    console.log("Inside PartnerPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletePartner(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.reportFilter={};
    $scope.initManagePartner = function (reportFilter){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined" && $rootScope.userData.credentials.zonemap.length > 0) {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManagePartner($scope.reportFilter);

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Partner List
    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentPartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getParentPartner(obj);
    };

    $scope.managePartner = {};
    $scope.managePartnerList = [];
    $scope.reportFilter={};
    $scope.initManagePartner = function (reportFilter) {
      $scope.initManageParentPartner();
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined" && $rootScope.userData.credentials.zonemap.length > 0) {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner($scope.reportFilter);

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.managePartnerList.push($scope.inserted);
    };

    $scope.createPartner = function (managePartner) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createPartner");
      console.log(managePartner);
      console.log(managePartner.name);
      console.log(managePartner.code);
      console.log(managePartner.contact);
      //console.log(managePartner.description);

      var obj = {};
      obj.params = {};
      obj.params.name = managePartner.name;
      obj.params.code = managePartner.code;
      obj.params.contact = managePartner.contact;
      obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
      // obj.params.isparent = managePartner.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = managePartner.isparent;
      obj.params.zoneid = managePartner.zoneid?managePartner.zoneid:null;
      //obj.params.name = managePartner.name?manageZones.name.zones:null;
      //obj.params.description = managePartner.description;
      console.log('obj.params',obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartner = {};
        toastr.success('New Partner has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Partner successfully created.");
        $scope.initManagePartner($scope.reportFilter);

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      partnerService.createPartner(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/account/partner/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deletePartner = function (res) {
      console.log("Inside deletePartner");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Partner has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManagePartner($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        partnerService.deletePartner(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (partner) {
      console.log("Inside editPartner");
      console.log(partner);
      // $scope.managePartner.id = $scope.managePartner.id;
      // $scope.managePartner.name = state.name;
      // $scope.managePartner.description = state.description;
      // $scope.managePartner.created = state.created;
      // $scope.managePartner.lastupdated = state.lastupdated;
      $scope.managePartner = partner;
      $scope.manageZones = zoneid;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.savePartner = function (managePartner, id) {

      console.log("Inside savePartner");
     // console.log("Inside saveZones");
      console.log(managePartner);
      console.log(id);

      if (id === undefined) {
        $scope.createPartner(managePartner);
        //$scope.createZones(manageZones);
      } else {

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = managePartner.name;
        //obj.params.name = manageZones.name;
        obj.params.code = managePartner.code;
        obj.params.contact = managePartner.contact;
        obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
        obj.params.userid = managePartner.userid?managePartner.userid:null;
        obj.params.isparent = managePartner.isparent;
        obj.params.zoneid = managePartner.zoneid?managePartner.zoneid:null;

        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartner = {};
          //$scope.manageZones = {};
          toastr.success('Partner has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManagePartner($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnerService.savePartner(obj);

      }

    }
    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/account/partner/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.userAccess = function(managePartner){
      console.log('Inside userAccess');
      console.log('managePartner',managePartner);

      var obj = {};
      obj.params = {};
      obj.params.username = managePartner.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=managePartner.name;
      obj.params.credentials.mobile=managePartner.contact?managePartner.contact:null;
      obj.params.credentials.role = managePartner.isparent?9:13;
      obj.params.credentials.zonemap = managePartner.zoneid ? [managePartner.zoneid] : [];
      obj.params.credentials.partner = managePartner;
      obj.params.challenges = managePartner.parentid;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        managePartner.userid = result.id;
        $scope.savePartner(managePartner,managePartner.id);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

      $scope.showZones = function(zones) {
        if (zones && $scope.manageZonesList.length) {
          var selected = $filter('filter')($scope.manageZonesList, {
            id: zones
          },true);
          return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
        } else return 'Not set';
      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.account.partner")
    .service("partnerService", partnerService);

  /** @ngInject */
  function partnerService(Partner) {
    var getPartner = function (obj) {
      if (obj.params && obj.params.zoneid != null) {
        Partner.find({
          filter: {
            where: {
              zoneid:
                obj.params.zoneid.length > 0
                  ? { inq: obj.params.zoneid }
                  : obj.params.zoneid,
            },
            include: ["user", "parent"],
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      } else {
        Partner.find({
          filter: {
            include: ["user", "parent"],
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      }
    };

    var getParentPartner = function (obj) {
      Partner.find({
        filter: {
          where: {
            isparent: true,
          },
          include: ["user", "parent"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getPartnerStaff = function (obj) {
      Partner.find({
        filter: {
          where: {
            parentid: obj.params.parentid,
          },
          include: ["user"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createPartner = function (obj) {
      var date = new Date();

      Partner.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid,
        zoneid: obj.params.zoneid,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deletePartner = function (obj) {
      Partner.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var savePartner = function (obj) {
      var date = new Date();

      Partner.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        zoneid: obj.params.zoneid,
        userid: obj.params.userid || null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var unbindPartner = function (obj) {
      var date = new Date();

      Partner.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getPartner: getPartner,
      createPartner: createPartner,
      deletePartner: deletePartner,
      savePartner: savePartner,
      getParentPartner: getParentPartner,
      unbindPartner: unbindPartner,
      getPartnerStaff: getPartnerStaff,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .controller('SupplierPageCtrl', SupplierPageCtrl);

  /** @ngInject */
  function SupplierPageCtrl($scope, $filter, editableOptions, editableThemes,
    supplierService, toastr, $uibModal,userService, zoneService, $rootScope) {
    console.log("Inside SupplierPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteSupplier(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.reportFilter={};
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            console.log('Inside Zonemap');
             for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
               var zonelist = $filter('filter')(result, {
                 id: $rootScope.userData.credentials.zonemap[index]
               }, true);
               console.log('zonelist',zonelist);
   
               $scope.manageZonesList.push(zonelist[0]);
             }
           }else{
             $scope.manageZonesList = result;
           }
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates($scope.reportFilter);

   
    $scope.manageSupplier = {};
    $scope.manageSupplierList = [];
    $scope.reportFilter={};
    $scope.initManageStates = function(reportFilter) {
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=reportFilter.zone?reportFilter.zone.id:null;
        }
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates($scope.reportFilter);

    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageSupplierList.push($scope.inserted);
    };

    $scope.createSupplier = function(manageSupplier) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSupplier");
      console.log(manageSupplier);
      console.log(manageSupplier.name);
      console.log(manageSupplier.code);
      console.log(manageSupplier.contact);
      //console.log(manageSupplier.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageSupplier.name;
      obj.params.code = manageSupplier.code;
      obj.params.contact = manageSupplier.contact;
      obj.params.rate = manageSupplier.rate;
      obj.params.zones = manageSupplier.zones?manageSupplier.zones:null;
      //obj.params.description = manageSupplier.description;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplier = {};
        toastr.success('New Supplier has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Supplier successfully created.");
        $scope.initManageStates($scope.reportFilter);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      supplierService.createSupplier(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/supplier/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteSupplier = function(res) {
      console.log("Inside deleteSupplier");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Supplier has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageStates($scope.reportFilter);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.deleteSupplier(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(supplier) {
      console.log("Inside editSupplier");
      console.log(supplier);
      // $scope.manageSupplier.id = $scope.manageSupplier.id;
      // $scope.manageSupplier.name = state.name;
      // $scope.manageSupplier.description = state.description;
      // $scope.manageSupplier.created = state.created;
      // $scope.manageSupplier.lastupdated = state.lastupdated;
      $scope.manageSupplier = supplier;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveSupplier = function(manageSupplier, id) {

      console.log("Inside saveSupplier");
      console.log(manageSupplier);
      console.log(id);

      if (id === undefined && manageSupplier.id === undefined) {
        $scope.createSupplier(manageSupplier);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSupplier;
        obj.params.id = id?id:manageSupplier.id;
        obj.params.zones = manageSupplier.zones?manageSupplier.zones:null;
        //obj.params.contact = manageSupplier.contact;
        // obj.params.name = $scope.manageSupplier.name;
        // obj.params.description = $scope.manageSupplier.description;
        //obj.params.created = $scope.manageSupplier.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.saveSupplier(obj);

        //$scope.modal.hide();
      }

    };

    $scope.userAccess = function(manageSupplier){
      console.log('Inside userAccess');
      console.log('manageSupplier',manageSupplier);

      var obj = {};
      obj.params = {};
      obj.params.username = manageSupplier.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=manageSupplier.name;
      obj.params.credentials.mobile=manageSupplier.contact?manageSupplier.contact:null;
      obj.params.credentials.role = 10; //Supplier Role id
      obj.params.credentials.supplier = manageSupplier;
      //obj.params.challenges = manageSupplier.id;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageSupplier.userid = result.id;
        $scope.saveSupplier(manageSupplier);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

      $scope.showZones = function(zones) {
        if (zones && $scope.manageZonesList.length) {
          var selected = $filter('filter')($scope.manageZonesList, {
            id: zones
          },true);
          return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
        } else return 'Not set';
      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .service('supplierService', supplierService);

  /** @ngInject */
  function supplierService(Supplier) {
    var getSupplier = function(obj) {
      if (obj.params.zoneid != null && typeof obj.params.zoneid !== "undefined") {
      Supplier.find({
        filter: {
          where:{
            zoneid:obj.params.zoneid.length>0?{inq:obj.params.zoneid}:obj.params.zoneid
          },
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    }else{
      Supplier.find({
        filter: {
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });

    }
  };

    var createSupplier = function(obj) {
      var date = new Date();

      Supplier.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        rate: obj.params.rate,
        zoneid: obj.params.zones

      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteSupplier = function(obj) {

      Supplier.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveSupplier = function(obj) {
      var date = new Date();

      Supplier.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        rate: obj.params.rate,
        userid: obj.params.userid,
        zoneid: obj.params.zones
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var unbindSupplier = function (obj) {
      var date = new Date();

      Supplier.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getSupplier: getSupplier,
      createSupplier: createSupplier,
      deleteSupplier: deleteSupplier,
      saveSupplier: saveSupplier,
      unbindSupplier:unbindSupplier
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.collectors.dailyinvoices")
    .service("dailyInvoiceCollectorService", dailyInvoiceCollectorService);

  /** @ngInject */
  function dailyInvoiceCollectorService(Invoice) {
    var getInvoice = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.find({
        filter: {
          where: {
            indate: { gte: dailyDate },
          },
          include: ["shop"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDailyInvoiceWithSales = function (obj) {
      // var days = obj.params.days ? obj.params.days : 1; // Days you want to subtract
      // var td = new Date();
      // var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      // var day = fd.getDate();
      // var month = fd.getMonth() + 1;
      // var year = fd.getFullYear();
      var today = new Date();
      var yesterday = new Date(today.setDate(today.getDate() - 1));
      var day = yesterday.getDate();
      var month = yesterday.getMonth() + 1;
      var year = yesterday.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.getDailyInvoiceWithSales({
        adate: obj.params.adate || dailyDate,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid ? obj.params.agentid : null,
        ispaid: obj.params.ispaid ? obj.params.ispaid : null,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getInvoiceByZone = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.find({
        filter: {
          where: {
            and: [
              { indate: { gte: dailyDate } },
              { zoneid: obj.params.zoneselection },
            ],
          },
          include: ["shop"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getInvoiceByKey = function (obj) {
      Invoice.find({
        filter: {
          where: {
            ikey: obj.params.ikey,
          },
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createInvoice = function (obj) {
      var date = new Date();

      Invoice.createMany(obj.params).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteInvoice = function (obj) {
      Invoice.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var payInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getInvoice: getInvoice,
      getInvoiceByZone: getInvoiceByZone,
      getInvoiceByKey: getInvoiceByKey,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getDailyInvoiceWithSales: getDailyInvoiceWithSales,
      payInvoice: payInvoice,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.collectors.dailyinvoices")
    .controller(
      "dailyinvoicesCollectorPageCtrl",
      dailyinvoicesCollectorPageCtrl
    );

  /** @ngInject */
  function dailyinvoicesCollectorPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    dailyInvoiceCollectorService,
    onlineShopService,
    gameService,
    shopService,
    zoneService,
    partnerService,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    toastr,
    $uibModal,
    userService,
    $rootScope,
    assigncollectorService
  ) {
    console.log("Inside dailyinvoicesCollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteInvoice(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.total = {};
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [
      {
        value: "PAID",
      },
      {
        value: "UNPAID",
      },
    ];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    //get zone table data
    // $scope.zoneselection = -99;

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.manageUsersList = [];
    $scope.initManageUsers = function () {
      if ($rootScope.userData.roleId === 7) {
        console.log("Inside initManageOfficers");
        console.log("$rootScope.userData.id", $rootScope.userData.id);

        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);

          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log("userIDs", userIDs);

            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      } else {
        var obj = {};
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }
    };
    $scope.initManageUsers();

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    $scope.manageDailyinvoices = {};
    $scope.manageDailyinvoicesList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter = {
      upload: moment().subtract(1, "days").toDate(),
    };

    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      console.log("reportFilter", reportFilter);

      var obj = {};
      obj.params = {};
      obj.params.ispaid = reportFilter.ispaid
        ? reportFilter.ispaid.value
        : null;
      obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;

      obj.params.adate = moment(reportFilter.upload, "DD-MM-YYYY")
        .startOf("day")
        .format("YYYY-M-D");

      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        console.log(
          "$rootScope.userData.credentials.days",
          $rootScope.userData.credentials.days
        );
        obj.params.days = $rootScope.userData.credentials.days
          ? $rootScope.userData.credentials.days
          : 1;
      }

      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone
          ? "('" + reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        }
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype
          ? reportFilter.shoptype.value
          : null;
      }

      obj.onSuccess = function (result) {
        console.log("Inside getAllZoneSales SUCCESS");
        var indate = moment(reportFilter.upload).utcOffset(8).startOf("day");
        $scope.manageDailyinvoicesList = result.result.filter(function (res) {
          var parseInDate = moment(res.indate).utcOffset(8).startOf("day");
          return parseInDate.diff(indate) === 0;
        });
        console.log(
          "$scope.manageDailyinvoicesList",
          $scope.manageDailyinvoicesList
        );
        $scope.totalSalesLabelFooter = 0;
        $scope.mSalesTotal = 0;
        $scope.oSalesTotal = 0;
        if ($scope.manageDailyinvoicesList) {
          for (
            var index = 0;
            index < $scope.manageDailyinvoicesList.length;
            index++
          ) {
            $scope.manageDailyinvoicesList[index].totalsales =
              parseFloat($scope.manageDailyinvoicesList[index].mcsales) +
              parseFloat($scope.manageDailyinvoicesList[index].ocsales);
            $scope.totalSalesLabelFooter =
              $scope.totalSalesLabelFooter +
              parseFloat($scope.manageDailyinvoicesList[index].totalsales);
            $scope.mSalesTotal =
              $scope.mSalesTotal +
              parseFloat($scope.manageDailyinvoicesList[index].mactotal);
            $scope.oSalesTotal =
              $scope.oSalesTotal +
              parseFloat($scope.manageDailyinvoicesList[index].ontotal);
          }
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside getAllZoneSales Failure");
        console.log(err);
      };
      dailyInvoiceCollectorService.getDailyInvoiceWithSales(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/collectors/dailyinvoices/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function (res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Invoice has been deleted successfully!", "SUCCESS");
          //$scope.initManageStates();
          $scope.initManageInvoice();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyInvoiceCollectorService.deleteInvoice(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isEdit = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices);
    };

    $scope.saveInvoice = function (id) {
      console.log("Inside saveInvoice");
      //console.log(itemInvoice);
      console.log(id);
      var obj = {};
      obj.params = {};
      obj.params.machineshorts = $scope.manageDailyinvoices.machineshorts;
      obj.params.onlineshorts = $scope.manageDailyinvoices.onlineshorts;
      obj.params.id = id;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDailyinvoices = result;
        toastr.success("Invoice has been updated successfully!", "SUCCESS");
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      dailyInvoiceCollectorService.saveInvoice(obj);
    };

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = result;

        if (
          _.isEmpty($scope.machineInvoiceDetails) &&
          !_.isEmpty($scope.onlineInvoiceDetails)
        ) {
          console.log("Inside Empty MachineShop");
          $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        }
        $scope.total.online = 0;
        $scope.total.onlineST = 0;
        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        var online = 0;
        if ($scope.onlineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
            online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
          }

          $scope.total.online = online;
          $scope.total.onlineST =
            online + parseFloat($scope.manageDailyinvoices.onlineshorts);
        }

        $scope.total.NG_net_collect =
          $scope.onlineInvoiceDetails[0] &&
          $scope.onlineInvoiceDetails[0].algorithm === "NG"
            ? Number($scope.onlineInvoiceDetails[0].net_collect)
            : 0;

        $scope.total.NP_net_collect =
          $scope.onlineInvoiceDetails[0] &&
          $scope.onlineInvoiceDetails[0].algorithm === "NP"
            ? Number($scope.onlineInvoiceDetails[0].net_collect)
            : 0;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };
    $scope.ddmmyyyy = function (date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? "" : "0") + dd,
        (mm > 9 ? "" : "0") + mm,
        date.getFullYear(),
      ].join("");
    };
    $scope.getMachineSales = function (manageDailyinvoices) {
      var obj = {};
      obj.params = {};
      // if (manageDailyinvoices.shop.shoptype==="100%"){
      //   var date = new Date(manageDailyinvoices.indate);
      //   var d = $scope.ddmmyyyy(date);
      //   var tempikey = manageDailyinvoices.shop.id+''+d
      //   console.log('tempikey',tempikey);
      //   obj.params.ikey = tempikey;
      // }else{
      //   obj.params.ikey = manageDailyinvoices.ikey;
      // }
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0;
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          $scope.total.machine = machine;
          $scope.total.machineST =
            machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };
    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id,
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageDailyinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageDailyinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageDailyinvoices);
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.manageDailyinvoices.shop.partnerid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };

    $scope.saveShorts = function () {
      console.log($scope.manageDailyinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageDailyinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageDailyinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      $scope.initManageInvoice();
      $scope.manageDailyinvoices = {};
    };

    $scope.print = function () {
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter("filter")(
          $scope.manageUsersList,
          {
            id: userid,
          },
          true
        );
        if (selected.length)
          return selected.length
            ? selected[0].credentials.name
              ? selected[0].credentials.name
              : selected[0].credentials.firstName +
                " " +
                selected[0].credentials.lastName
            : "";

        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return "";
    };

    $scope.openPayNow = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.payInvoice(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.payNowId = null;
    $scope.confirmPayNow = function (id) {
      $scope.openPayNow(
        "app/pages/collectors/dailyinvoices/modals/PayNowModal.html"
      );
      $scope.payNowId = id;
    };

    $scope.payInvoice = function (res) {
      console.log("Inside payInvoice");
      if (res) {
        console.log("Sure!");
        console.log($scope.payNowId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.payNowId;
        obj.params.agentid = $rootScope.userData.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS payInvoice");
          toastr.success("Invoice Payment Received", "SUCCESS");
          $scope.searchAllinvoices($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure payInvoice");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyInvoiceCollectorService.payInvoice(obj);
      } else {
        console.log("Not sure!");
      }
    };

    //Group Totals
    $scope.getTotalmcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.mcsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalocsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.ocsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaltotalsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.totalsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalTotalNetCollect = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.net_collect;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.psales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.csales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales')
    .controller('DailymachinesalesCollectorPageCtrl', DailymachinesalesCollectorPageCtrl);

  /** @ngInject */
  function DailymachinesalesCollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesCollectorService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService,  $rootScope, zoneService, userService) {
    console.log("Inside DailymachinesalesCollectorPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function(){
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
    };
    $scope.init();
    $scope.reportFilter={};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.getDailyMachinesales = function(reportFilter) {
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }
      if (reportFilter.agent){
        obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
      }
      if (reportFilter.daynight){
        obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
      }
      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        obj.params.days=$rootScope.userData.credentials.days?$rootScope.userData.credentials.days:1;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesCollectorService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/collectors/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesCollectorService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachinesalesCollectorService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/collectors/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales&& $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesCollectorService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.collectors.dailymachinesales')
    .service('dailymachinesalesCollectorService', dailymachinesalesCollectorService);

  /** @ngInject */
  function dailymachinesalesCollectorService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = obj.params.days?obj.params.days:1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .controller('UsermappingPageCtrl', UsermappingPageCtrl);

  /** @ngInject */
  function UsermappingPageCtrl($scope, $filter, editableOptions, editableThemes,
    usermappingService, toastr, $uibModal, userService, roleService, zoneService, areaService) {
    console.log("Inside UsermappingPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUsermapping(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //Getting States
    $scope.manageUserList = [];
	$scope.manageRoleList = [];
	$scope.manageAreaList = [];
    $scope.manageZonesList = [];
    
	$scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
	
	$scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
	
	$scope.initManageArea = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageUsermappingList = [];
    $scope.manageUsermapping = {};
    $scope.initManageUsermapping = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermappingList = result;
        $scope.initManageUser();
		$scope.initManageRole();
		$scope.initManageArea();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      usermappingService.getUsermapping(obj);
    };
    $scope.initManageUsermapping();

    $scope.addUsermapping = function() {
      //genericModalService.show('modules/modals/addUsermapping.html',$scope);
      $scope.inserted = {
        //name: null,
        //description: null,
      };
      $scope.manageUsermappingList.push($scope.inserted);
    };

    $scope.createUsermapping = function(manageUsermapping) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUsermapping");
      console.log(manageUsermapping);

      var obj = {};
      obj.params = {};
      obj.params = manageUsermapping;
      // obj.params.name = manageUsermapping.name;
      // obj.params.description = manageUsermapping.description;
      // obj.params.zoneid = manageUsermapping.zones
      // obj.params.stateid = manageUsermapping.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermapping = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageUsermapping();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      usermappingService.createUsermapping(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/usermapping/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteUsermapping = function(res) {
      console.log("Inside deleteUsermapping");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageUsermapping();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.deleteUsermapping(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(usermapping) {
      console.log("Inside editArea");
      console.log(usermapping);
      // $scope.manageUsermapping.id = $scope.manageUsermapping.id;
      // $scope.manageUsermapping.name = state.name;
      // $scope.manageUsermapping.description = state.description;
      // $scope.manageUsermapping.created = state.created;
      // $scope.manageUsermapping.lastupdated = state.lastupdated;
      $scope.manageUsermapping = state;
      genericModalService.show('modules/modals/addUsermapping.html', $scope);
    }

    $scope.saveUsermapping = function(manageUsermapping, id) {

      console.log("Inside saveUsermapping");
      console.log(manageUsermapping);
      console.log(id);

      console.log(manageUsermapping.zones);
      console.log(manageUsermapping.role);
	  console.log(manageUsermapping.user);
	  console.log(manageUsermapping.area);


      if (id === undefined) {
        $scope.createUsermapping(manageUsermapping);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageUsermapping;
        obj.params.id = id;
        // obj.params.name = $scope.manageUsermapping.name;
        // obj.params.description = $scope.manageUsermapping.description;
        //obj.params.created = $scope.manageUsermapping.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsermapping = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageUsermapping();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.saveUsermapping(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showUsers = function(user) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (user && $scope.manageUserList.length) {
        var selected = $filter('filter')($scope.manageUserList, {
          id: user.id
        },true);
        return selected.length ? selected[0].username : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showRoles = function(role) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showAreas = function(area) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter('filter')($scope.manageAreaList, {
          id: area.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .service('usermappingService', usermappingService);

  /** @ngInject */
  function usermappingService(Usermapping) {
    var getUsermapping = function(obj) {

    Usermapping.find({
      filter:{
        include:["user","zone","role","area"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Usermapping.create({
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Usermapping.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});


    Usermapping.prototype$patchAttributes({
      id: obj.params.id,
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getUsermapping: getUsermapping,
      createUsermapping: createUsermapping,
      deleteUsermapping: deleteUsermapping,
      saveUsermapping: saveUsermapping
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.external.partnersales")
    .controller("PartnersalesreportPageCtrl", PartnersalesreportPageCtrl);

  /** @ngInject */
  function PartnersalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    partnersalesreportService,
    gameService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    $rootScope,
    zoneService,
    receiptService
  ) {
    console.log("Inside PartnersalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentPartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getParentPartner(obj);
    };
    $scope.initManageParentPartner();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null,
      },
    };
    $scope.reportFilter = {};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from),
          y = fd.getFullYear(),
          m = fd.getMonth() + 1;
        var date1 = y + "-" + m + "-" + fd.getDate();

        var td = new Date($scope.dateList.to);
        y = td.getFullYear();
        m = td.getMonth() + 1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y + "-" + m + "-" + td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log("From", fd);
        console.log("TO", td);
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        if (typeof $rootScope.userData.credentials.parent !== "undefined") {
          obj.params.parentid = $rootScope.userData.credentials.parent;
        } else {
          obj.params.parentid = reportFilter.parent
            ? reportFilter.parent.id
            : null;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          if (result.result) {
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              var onmacTotal =
                parseFloat($scope.managePartnersalesList[i].ontotal) +
                parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        partnersalesreportService.getGrpMacSalesInRange(obj);
      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner();

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        //        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.managePartnersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/external/partnersales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.deleteMachinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveMachinesales = function (managePartnersales, id) {
      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      if (managePartnersales.id === undefined) {
        $scope.createMachinesales(managePartnersales);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = managePartnersales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnersales = {};
          toastr.success(
            "Machinesales has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, "ERROR");
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      $scope.getMachineSalesOfPartner(managePartnersales.partnerid);
      //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getMachineSalesOfPartner = function (partnerid) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();
      var td = new Date($scope.dateList.to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();

      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = "(" + partnerid + ")";
      console.log(obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.mPSalesTotal = 0;
        $scope.mCSalesTotal = 0;
        $scope.mSalesTotal = 0;
        $scope.npTotal = 0;
        $scope.oPSalesTotal = 0;
        $scope.oCSalesTotal = 0;
        $scope.oNetCollectTotal = 0;
        $scope.oSalesTotal = 0;
        $scope.shopTotal = 0;
        $scope.compTotal = 0;
        $scope.shopOverTotal = 0;
        $scope.compOverTotal = 0;

        $scope.machineSalesOfPartnerList = result;

        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 =
            parseFloat(result.result[i].ontotal) +
            parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].npng = parseFloat(
            result.result[i].net_purchase_and_gaming
          );
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter =
            $scope.totalSalesLabelFooter + onMacTotalL2;
          $scope.mPSalesTotal =
            $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
          $scope.mCSalesTotal =
            $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
          $scope.mSalesTotal =
            $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
          $scope.npTotal =
            $scope.npTotal +
            parseFloat(result.result[i].net_purchase_and_gaming);
          $scope.oPSalesTotal =
            $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
          $scope.oCSalesTotal =
            $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
          $scope.oNetCollectTotal =
            $scope.oNetCollectTotal + parseFloat(result.result[i].net_collect);
          $scope.oSalesTotal =
            $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
          $scope.machineSalesOfPartnerList.result[i].shopTotal =
            parseFloat(result.result[i].mpsales) +
            parseFloat(result.result[i].opsales);
          $scope.machineSalesOfPartnerList.result[i].compTotal =
            parseFloat(result.result[i].mcsales) +
            parseFloat(result.result[i].net_collect);
          $scope.shopOverTotal =
            $scope.shopOverTotal +
            $scope.machineSalesOfPartnerList.result[i].shopTotal;
          $scope.compOverTotal =
            $scope.compOverTotal +
            $scope.machineSalesOfPartnerList.result[i].compTotal;
        }
        console.log($scope.totalSalesLabelFooter);
      };
      obj.onFailure = function (err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      partnersalesreportService.getMachinesalesByPartner(obj);
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: gid,
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (managePartnersales) {
      if (managePartnersales.shop && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.managePartnersales.shop.partnerid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.manageDailyinvoices = {};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isInvoice = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      if ($scope.manageDailyinvoices.ikey) {
        $scope.manageDailyinvoices.invoicedate = $scope.dateFormater(
          $scope.manageDailyinvoices.ikey
        );
      }
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices.ikey);
    };

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = {
          NG: result.filter(function (r) {
            return r.algorithm === "NG";
          }),
          NP: result.filter(function (r) {
            return r.algorithm === "NP" || r.algorithm === null;
          }),
        };

        // set shop
        $scope.shopInvoiceDetails = result.length > 0 && result[0].shop;

        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        $scope.total.NP_csales_total = 0;
        $scope.total.NP_totalsales = 0;

        $scope.total.NP_csales_total = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.csales);
          },
          0
        );

        $scope.total.NG_net_collect = $scope.onlineInvoiceDetails.NG.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_net_collect = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_totalsales = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.totalsales);
          },
          0
        );
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }

        var machine = 0;
        $scope.total.machineST = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          $scope.total.machine = parseFloat(machine);
          $scope.total.machineST =
            machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) {
          return x.mpsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) {
          return x.mcsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) {
          return x.mactotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) {
          return x.opsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaloNetCollect = function (items) {
      return items
        .map(function (x) {
          return x.net_collect;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalnetpurhase = function (items) {
      return items
        .map(function (x) {
          return x.npng;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) {
          return x.ocsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) {
          return x.ontotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) {
          return x.shopTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) {
          return x.compTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) {
          return x.totalsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };

    $scope.getShopSalesOfPartner = function (salesOfPartnerList) {
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = false;
      $scope.shopSalesOfPartnerList = {};
      $scope.shopSalesOfPartnerList = salesOfPartnerList;
      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.npTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.oNetCollectTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 =
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal) +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].npng = parseFloat(
          $scope.shopSalesOfPartnerList[i].net_purchase_and_gaming
        );
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter =
          $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal =
          $scope.mPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal =
          $scope.mCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal =
          $scope.mSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.npTotal =
          $scope.npTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].net_purchase_and_gaming);
        $scope.oPSalesTotal =
          $scope.oPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal =
          $scope.oCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oNetCollectTotal =
          $scope.oNetCollectTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].net_collect);
        $scope.oSalesTotal =
          $scope.oSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].net_collect);
        $scope.shopOverTotal =
          $scope.shopOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal =
          $scope.compOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].compTotal);
      }
    };

    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log("receiptid", receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open(
            "app/pages/invoices/dailyinvoices/modals/receiptModal.html"
          );
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.partnersales')
    .service('partnersalesreportService', partnersalesreportService);

  /** @ngInject */
  function partnersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid,
        parentid: obj.params.parentid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales')
    .controller('SuppliersalesreportPageCtrl', SuppliersalesreportPageCtrl);

  /** @ngInject */
  function SuppliersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    suppliersalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside SuppliersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      

      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          $scope.totalSalesLabel = 0;
          $scope.totalSalesLabelFooter = 0;
          for (var i = 0; i < result.result.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageSuppliersalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        suppliersalesreportService.getGrpMacSalesInRange(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageSuppliersales = {};
    $scope.manageSuppliersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageSuppliersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      suppliersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/external/suppliersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageSuppliersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.saveMachinesales = function(manageSuppliersales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageSuppliersales);
      console.log(manageSuppliersales.id);

      if (manageSuppliersales.id === undefined) {
        $scope.createMachinesales(manageSuppliersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSuppliersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSuppliersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageSuppliersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.manageSuppliersales = manageSuppliersales;
      console.log($scope.manageSuppliersales.id);

      $scope.getMachineSalesOfSupplier(manageSuppliersales.id);
    };

    $scope.getMachineSalesOfSupplier = function(suppId) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfSupplier = {};
      $scope.machineSalesOfSupplierList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = fd;
      obj.params.bdate = td;
      obj.params.suppId = suppId;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfSupplier SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabelFooter);
        $scope.machineSalesOfSupplierList = result;
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfSupplier Failure");
      }
      suppliersalesreportService.getMachinesalesBySupplier(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageSuppliersales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageSuppliersales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageSuppliersales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageSuppliersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.external.suppliersales')
    .service('suppliersalesreportService', suppliersalesreportService);

  /** @ngInject */
  function suppliersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      var newDate  = new Date(date);
      console.log('date',newDate);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": newDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesBySupplier = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        suppId: obj.params.suppId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };
    
    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesBySupplier: getMachinesalesBySupplier,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      getAvailableMachineByZone: getAvailableMachineByZone,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector')
    .controller('AssigncollectorPageCtrl', AssigncollectorPageCtrl);

  /** @ngInject */
  function AssigncollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    assigncollectorService, toastr, $uibModal, userService, shopService, validationService, $rootScope) {
    console.log("Inside AssigncollectorPageCtrl");

    $scope.shopFilter = {
      byUserZoneAndState: true,
    };

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    $scope.smartTablePageSize = 100;
    $scope.totalSalesLabel = 0;
    $scope.isAgentView = false;

    $scope.manageCollector = {};
    $scope.manageCollectorsList = [];
    // $scope.initManageOfficers = function() {
    //   var obj = {};

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageCollectorsList = result;
    //     $scope.initManageShops();
    //     $scope.isEdit = false;
    //     $scope.isAssignNewShop = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   userService.getUsersCSync(obj);
    // };
    $scope.initManageOfficers = function () {
      console.log('Inside initManageOfficers');
      console.log('$rootScope.userData.id', $rootScope.userData.id);

      if ($rootScope.userData.roleId === 1 || $rootScope.userData.roleId === 5) {
        var obj = {};

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollectorsList = result;
          //$scope.initManageShops();
          $scope.isEdit = false;
          $scope.isAssignNewShop = false;
          $scope.isAgentView = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSync(obj);
      } else {
        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);

          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log('userIDs', userIDs);

            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageCollectorsList = result;
              console.log($scope.manageCollectorsList);
              //$scope.initManageShops();
              $scope.isEdit = false;
              $scope.isAssignNewShop = false;
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);

          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      }


    };


    $scope.manageShop = {};
    $scope.manageShopsList = [];

    $scope.initManageShops = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopsList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.Filter = {};

    $scope.addOfficer = function () {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageCollectorsList.push($scope.inserted);
    };

    $scope.selectedShopList = [];
    $scope.notSelectedShopList = [];
    $scope.viewCollectorDetails = function (manageCollector) {
      console.log("Inside editMachine");
      $scope.isEdit = true;

      $scope.manageCollector = manageCollector;
      console.log($scope.manageCollector)
      $scope.selectedShopList = [];
      $scope.notSelectedShopList = [];
      $scope.getSelectedShops(manageCollector);
      console.log($scope.selectedShopList);
      $scope.getNotSelectedShops(manageCollector);
      console.log($scope.notSelectedShopList);
    };

    $scope.getSelectedShops = function (manageCollector) {
      if (manageCollector.credentials.shopmap) {
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap;
        console.log(manageCollector.credentials.shopmap);

        obj.onSuccess = function (result) {
          console.log("Inside getSelectedShops SUCCESS");
          console.log(result);
          $scope.selectedShopList = result;

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findAssignedShop(obj);
      }
    };

    $scope.getNotSelectedShops = function (manageCollector) {

      if ($rootScope.userData.roleId === 1 || $rootScope.userData.roleId === 5) {
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap ? manageCollector.credentials.shopmap : [];

        console.log('obj.params', obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          console.log(manageCollector);
          if ($scope.shopFilter.byUserZoneAndState && manageCollector.credentials && manageCollector.credentials.zonemap) {
            $scope.notSelectedShopList = result.filter(function (r) {
              return manageCollector.credentials.zonemap.some(function (z) {
                return z == r.zoneid;
              });
            })
          } else {
            $scope.notSelectedShopList = result;
          }
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findNotAssignedShopForAdmin(obj);
      } else {
        var obj = {};
        obj.params = {};
        obj.params.shopmap = manageCollector.credentials.shopmap;
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        }
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zonemap = $rootScope.userData.credentials.zonemap;
        }

        console.log('obj.params', obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          $scope.notSelectedShopList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        shopService.findNotAssignedShop(obj);
      }
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/areas/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.removeShop = function (res) {
      console.log("Inside removeShop");
      console.log(res.id);

      if (res) {

        var arr = $scope.manageCollector.credentials.shopmap;
        var index = arr.indexOf(res.id);
        if (index > -1) {
          arr.splice(index, 1);
        }
        $scope.manageCollector.credentials.shopmap = arr;
        //        console.log($scope.manageCollector.credentials.shopmap)
        console.log($scope.manageCollector.credentials)

        var obj = {};
        obj.params = {};
        obj.params.credentials = {};
        obj.params.id = $scope.manageCollector.id
        obj.params.credentials = $scope.manageCollector.credentials
        //obj.params.credentials.shopmap = $scope.manageCollector.credentials.shopmap;
        obj.onSuccess = function (result) {
          console.log("Inside removeShop SUCCESS");
          console.log(result);
          toastr.success('Shop has been deleted successfully!', 'SUCCESS');
          $scope.viewCollectorDetails($scope.manageCollector)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateShopMap(obj);
      } else {
        console.log('Not sure!');
      }
    }
    $scope.addShop = function () {
      $scope.isAssignNewShop = true;
    };

    $scope.assignShop = function (res) {
      console.log("Inside assignShop");
      console.log(res.id);

      if (res) {


        var arr = $scope.manageCollector.credentials.shopmap ? $scope.manageCollector.credentials.shopmap : [];
        arr.push(res.id);
        $scope.manageCollector.credentials.shopmap = arr;
        //      console.log($scope.manageCollector.credentials.shopmap)
        console.log($scope.manageCollector.credentials)
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.manageCollector.id;
        obj.params.credentials = $scope.manageCollector.credentials;
        //obj.params.credentials.shopmap = $scope.manageCollector.credentials.shopmap;
        obj.onSuccess = function (result) {
          console.log("Inside assignShop SUCCESS");
          console.log(result);
          toastr.success('Shop has been added successfully!', 'SUCCESS');
          $scope.viewCollectorDetails($scope.manageCollector)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateShopMap(obj);
      } else {
        console.log('Not sure!');
      }
    }

    $scope.editArea = function (state) {
      console.log("Inside editArea");
      console.log(state);
      $scope.manageOfficer = state;
      genericModalService.show('modules/modals/addOfficer.html', $scope);
    };

    $scope.viewAgents = function (items) {
      $scope.isAgentView = true;
      $scope.manageCollectorsList = items;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.init = function () {
      $scope.initManageOfficers();
    };

    $scope.init();

  }

})();
/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.csync.assigncollector')
    .service('assigncollectorService', assigncollectorService);

  /** @ngInject */
  function assigncollectorService(Collectormap) {

    var getCollectormaps = function(obj) {

      Collectormap.find({
        filter:{
          where: {
            vipid:obj.params.headid
          },
          include: ["head","staff"],
        }
      }).$promise.then(function(data) {
        //obj.onSuccess(data);
        Collectormap.find({
          filter:{
            where: {
              headid:data[0].headid
            },
            include: ["head","staff"],
          }
        }).$promise.then(function(data) {
          obj.onSuccess(data);
        }, function(err) {
          obj.onFailure(err);
        });
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return{
      getCollectormaps: getCollectormaps
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.form.machinesales')
    .controller('MachinesalesPageCtrl', MachinesalesPageCtrl);

  /** @ngInject */
  function MachinesalesPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesService, toastr, $uibModal, SheetJSExportService,
    machineShopService, machineService, shopService, validationService) {
    console.log("Inside MachinesalesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    //    $scope.dateList = {};
    //    $scope.dpOpenStatus = {};
    //    $scope.setDpOpenStatus = function(id) {
    //      $scope.dpOpenStatus[id] = true;
    //    };

    $scope.smartTablePageSize = 100;
    $scope.manageMachinesales = {};

    $scope.manageMachinesalesList = []; // temp line
    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded?
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };

    $scope.initManageMachinesales = function () {

      $scope.initManageShop();
      $scope.initManageMachineShop();
      $scope.initManageMachine();
      $scope.manageMachinesales = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageMachinesales();

    $scope.passOnlinesales = function (manageMachinesales) {
      console.log("Inside passOnlinesales");
      console.log(manageMachinesales);
    };

    $scope.ddmmyyyy = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };

    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.createMachinesales = function (manageMachinesales) {
      console.log("Inside manageMachinesales");
      var isFormValidated = true;
      //console.log($scope.dateList.from)
      //if (validationService.isEmptyOrNullValidation($scope.dateList.from) && $scope.gridOptions.data.length) {
      if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please choose a Date and File to Upload', 'ERROR');
        toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          var date = new Date();
          var indate = new Date();
          record.mid = $scope.gridOptions.data[i].machineid; //machine code
          record.cmIn = $scope.gridOptions.data[i].cmin ? $scope.gridOptions.data[i].cmin.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.cmOut = $scope.gridOptions.data[i].cmout ? $scope.gridOptions.data[i].cmout.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.bmIn = $scope.gridOptions.data[i].bmin ? $scope.gridOptions.data[i].bmin.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          record.bmOut = $scope.gridOptions.data[i].bmout ? $scope.gridOptions.data[i].bmout.replace('MYR', '').replace(',', '').replace('$', '') : 0;
          var localMachine = $scope.getMachineDetails(record.mid);
          console.log(localMachine);

          var diffCmIn = 0,
            diffCmOut = 0,
            diffBmIn = 0,
            diffBmOut = 0;

          var localMachineShop = {};
          if (localMachine) {
            localMachineShop = $scope.getMachineShopDetails(localMachine.id);
            console.log("inside localMachine");
            diffCmIn = ((record.cmIn - localMachine.cmIn) * parseFloat(localMachine.cmRate)).toFixed(2);
            diffCmOut = ((record.cmOut - localMachine.cmOut) * parseFloat(localMachine.cmRate)).toFixed(2);
            diffBmIn = ((record.bmIn - localMachine.bmIn) * parseFloat(localMachine.bmRate)).toFixed(2);
            diffBmOut = ((record.bmOut - localMachine.bmOut) * parseFloat(localMachine.bmRate)).toFixed(2);
            record.cmInP = localMachine.cmIn;
            record.cmOutP = localMachine.cmOut;
            record.bmInP = localMachine.bmIn;
            record.bmOutP = localMachine.bmOut;
            record.totalsalesp = 0;

            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;

            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            record.machineid = localMachine.id;
          }
          if (localMachineShop) {
            console.log("Inside localMachineShop");
            console.log(localMachineShop);
            record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
            record.psales = (record.totalsales - record.csales).toFixed(2);
            record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
            record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            record.shopid = localMachineShop.shopid;
            record.machineid = localMachineShop.machineid;
            record.machineshopid = localMachineShop.id;
            if (localMachineShop.shop.shoptype == '100%') {
              var d = $scope.ddmmyyyy(date, 0);
              record.ikey = localMachineShop.shopid + '' + d;
              record.indate = $scope.getInDate(indate, 0);
              console.log(record.ikey);
            } else if (localMachineShop.shop.shoptype == '5/5') {
              var d = $scope.ddmmyyyy(date, 1);
              record.ikey = localMachineShop.shopid + '' + d;
              record.indate = $scope.getInDate(indate, 1);
              console.log(record.ikey);
            }

          }
          record.created = cdate;

          //record.created = $scope.dateList.from;
          record.lastupdated = cdate;

          console.log(record);

          obj.params.push(record);
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          $scope.initManageMachinesales();
          toastr.success('New Machine Sales has been saved successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {

            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.machineid = err.config.data[i].mid;
                data.cmin = err.config.data[i].cmIn;
                data.cmout = err.config.data[i].cmOut;
                data.bmin = err.config.data[i].bmIn;
                data.bmout = err.config.data[i].bmOut;
                if (typeof err.config.data[i].mid === 'undefined') {
                  data.ERROR = 'Blank Machine Code';
                } else if (typeof err.config.data[i].shopid === 'undefined') {
                  data.ERROR = 'No Shop Reference';
                } else if (typeof err.config.data[i].machineid === 'undefined') {
                  data.ERROR = 'No Machine Reference';
                } else if (err.config.data[i].shopid === null) {
                  data.ERROR = 'No Shop Reference';
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        machinesalesService.createMachinesales(obj);
      }
    };

    $scope.getMachineShopDetails = function (mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function (mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.machinesales')
    .service('machinesalesService', machinesalesService);

  /** @ngInject */
  function machinesalesService(Machinesales) {

    var getMachinesales = function(obj) {
      //read data from gridoptions
      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var today = y+'-'+m+'-'+d.getUTCDate();
      //var today  = new Date(date);
      console.log('date',today);
      //var yesterday = new Date(today);
      //yesterday.setDate(today.getUTCDate() - 1);
      var today = y+'-'+m+'-'+(d.getUTCDate()-1);
      console.log('date', yesterday);

      Machinesales.find({
        filter: {
          where:{
            and:[
              {created: {gte: yesterday}},
              {created: {lt:today}}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Machinesales.createMany(
        obj.params

        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getMachinesales: getMachinesales,
      saveMachinesales: saveMachinesales,
      createMachinesales: createMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";
  angular
    .module("BlurAdmin.pages.form.onlinesales")
    .controller("OnlinesalesPageCtrl", OnlinesalesPageCtrl);

  /** @ngInject */
  function OnlinesalesPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    onlinesalesService,
    toastr,
    $uibModal,
    SheetJSExportService,
    gameService,
    onlineShopService,
    shopService,
    gameServerService,
    validationService,
    onlineserverService
  ) {
    console.log("Inside OnlinesalesPageCtrl");

    $scope.loading = false;

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.invoiceBtnStatus = true;
    $scope.clickTime = 0;
    $scope.clickedInvoiceInput = function () {
      $scope.clickTime += 1;

      if ($scope.clickTime > 5) {
        $scope.invoiceBtnStatus = false;
      }
    };
    //    $scope.dateList = {};
    //    $scope.dpOpenStatus = {};
    //    $scope.setDpOpenStatus = function(id) {
    //      $scope.dpOpenStatus[id] = true;
    //    };
    $scope.smartTablePageSize = 100;
    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.mangeGameServers = [];
    $scope.initManageGameServers = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.mangeGameServers = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameServerService.getGameServer(obj);
    };
    $scope.initManageGameServers();

    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");

        $scope.manageOnlineShopList = result.filter(function (re) {
          return !!re.shop;
        });
        console.log($scope.manageOnlineShopList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlineShopService.getAllOnlineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.initManageOnlinesales = function () {
      console.log($scope.manageOnlinesales.import);
      $scope.initManageGames();
      $scope.initManageShop();
      $scope.initManageOnlineShop();
      $scope.manageOnlinesales = {};
      $scope.gridOptions = {};
      //      $scope.dateList = {};
      var filename = document.querySelector("#uploadFile");
      angular.element(filename).val(null);
    };

    $scope.initManageOnlinesales();
    $scope.passOnlinesales = function (manageOnlinesales) {
      console.log("Inside passOnlinesales");
      console.log(manageOnlinesales);
    };

    $scope.getOnlineShopByPlayTechId = function (playtechid) {
      if (playtechid && $scope.manageOnlineShopList.length) {
        var selected = $filter("filter")(
          $scope.manageOnlineShopList,
          {
            playtechid: playtechid
          },
          true
        );
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getShopDetails = function (shopid) {
      if (shopid && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageShopList,
          {
            id: shopid
          },
          true
        );
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    // To update custom date by invoices.
    // edit date below.
    // var uploadDate = moment('08-03-2020', 'MM-DD-YYYY');
    $scope.formDate = {
      upload: moment().subtract(1, "days").toDate()
    };

    $scope.createOnlinesales = function (manageOnlinesales) {
      // if (!validationService.isEmptyOrNullValidation(manageOnlinesales.game) ||
      //   $scope.gridOptions.data.length < 1) {
      //   toastr.error('Please select a Game and choose a file to Upload', 'ERROR');
      //   return
      // }

      if (
        $scope.loading ||
        !$scope.gridOptions.data ||
        !$scope.gridOptions.data.length
      ) {
        return;
      }

      var onlineuploaded = { sales: false, server: false };
      var uploadDate = moment($scope.formDate.upload, "DD-MM-YYYY").startOf(
        "day"
      );
      var cdate = moment();
      var indate = uploadDate.add(uploadDate.utcOffset(), "minutes"); //.subtract(1, 'days');

      var obj = {};
      obj.params = [];
      var invalidSales = [];

      var gsObj = {};
      gsObj.params = [];

      function parseNumber(data, columnName) {
        var _data = !!data ? data : "0";

        if (typeof _data === "string") {
          _data = _data.trim();
        }

        if (_data === "-") {
          _data = "0";
        }

        var result = _data
          .replace("MYR", "")
          .replace(/,/g, "")
          .replace("$", "");
        if (result.startsWith("(") && result.endsWith(")")) {
          result = result.replace("(", "").replace(")", "");
          if (!result.startsWith("-")) {
            result = result * -1;
          }
        }

        if (isNaN(result)) {
          throw new Error("Failed to get number from column " + columnName);
        }
        return +result;
      }

      function NetPurchaseAlgorithm(onlineShop, record) {
        var isFullShop = onlineShop.shop.shoptype === "100%";
        record.algorithm = "NP";

        if (isFullShop && onlineShop.onrate === 100) {
          // Sales = NP+ Bank
          // Net Collect = NP
          record.totalsales =
            Number(record.netpurchase) +
            Number(record.d_ewallet) +
            Number(record.d_cc) +
            Number(record.pe_payment_gateway) +
            Number(record.zpay_bank_in) +
            Number(record.zpay_qr_in) +
            Number(record.dgpay_qr_in) +
            Number(record.dgpay_bank_in) +
            Number(record.fpay_qr) +
            Number(record.fpay_d_bank) +
            Number(record.skl_qr) +
            Number(record.skl_d_bank) +
            Number(record.vpay_qr) +
            Number(record.vpay_d_bank) +
            Number(record.novapay_qr) +
            Number(record.novapay_d_bank) +
            Number(record.luxepay_qr) +
            Number(record.luxepay_d_bank) +
            Number(record.telco) +
            Number(record.crypto) +
            Number(record.payment_gateway) -
            (Number(record.pg_out) +
              Number(record.pe_pgout) +
              Number(record.fpay_w_bank) +
              Number(record.skl_w_bank) +
              Number(record.vpay_w_bank) +
              Number(record.novapay_w_bank) +
              Number(record.luxepay_w_bank) +
              Number(record.dgpay_w_bank_out)) +
            Number(record.tng_pin) +
            Number(record.vpay_tng_pin);
          record.csales = Number(record.netpurchase);
          record.net_collect = Number(record.netpurchase);
          record.psales = 0;

          var expenses =
            record.pshare +
            record.apshare -
            record.pwin -
            record.apwin +
            record.bonus_bet -
            record.bonus_win +
            record.pgsbonus;

          record.server_fee =
            (record.netgaming * record.server_fee_rate) / 100 + expenses;
          record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
          record.serverpr =
            (record.netgaming * Number(record.server_fee_rate)) / 100 +
            expenses;
        } else {
          record.totalsales = Number(
            Number(record.netpurchase) -
              Number(record.pshare) -
              Number(record.apshare) +
              Number(record.pwin) +
              Number(record.apwin)
          );

          record.d_ewallet_charge =
            Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
          record.d_cc_charge =
            Number((record.d_cc * record.d_cc_rate) / 100) || 0;
          record.pg_charge =
            Number(
              ((record.payment_gateway +
                record.dgpay_bank_in +
                record.dgpay_qr_in +
                record.zpay_bank_in +
                record.zpay_qr_in) *
                record.pg_rate) /
                100
            ) || 0;
          record.pg_out_charge =
            Number(
              ((record.pg_out + record.dgpay_w_bank_out) * record.pg_out_rate) /
                100
            ) || 0;

          var csales = Number(
            record.totalsales * Number(onlineShop.onrate / 100)
          );

          record.psales = Number(record.totalsales - csales);

          record.p_bonus_bets = Number(
            record.bonus_bet * Number(record.bet_rate / 100)
          );

          var finalCsales =
            csales +
            Number(record.pshare) +
            Number(record.apshare) -
            Number(record.pwin) -
            Number(record.apwin);

          var subCsales =
            Number(record.netpurchase) -
            Number(record.pshare) -
            Number(record.apshare) +
            Number(record.pwin) +
            Number(record.apwin) +
            Number(record.zpay_bank_in) +
            Number(record.zpay_qr_in) +
            Number(record.dgpay_qr_in) +
            Number(record.dgpay_bank_in) +
            Number(record.payment_gateway) +
            Number(record.pe_payment_gateway) +
            Number(record.d_ewallet) -
            (Number(record.pg_out) +
              Number(record.pe_pgout) +
              Number(record.dgpay_w_bank_out));
          record.csales =
            subCsales * Number(onlineShop.onrate / 100) +
            Number(record.pshare) +
            Number(record.apshare) -
            Number(record.pwin) -
            Number(record.apwin);

          var npSubtotal = subCsales + Number(record.g_ewallet);
          record.server_fee =
            (npSubtotal * Number(record.server_fee_rate)) / 100 +
            Number(record.pshare) +
            Number(record.apshare) -
            Number(record.pwin) -
            Number(record.apwin);
          record.pr_fee = (npSubtotal * Number(record.pr_fee_rate)) / 100;
          record.serverpr =
            npSubtotal * Number(onlineShop.onrate / 100) +
            Number(record.pshare) +
            Number(record.apshare) -
            Number(record.pwin) -
            Number(record.apwin);

          record.net_collect =
            finalCsales +
            record.p_bonus_bets -
            record.bonus_win -
            record.payment_gateway +
            +record.zpay_bank_in +
            record.zpay_qr_in +
            record.dgpay_qr_in +
            record.dgpay_bank_in +
            record.d_ewallet_charge +
            record.d_cc_charge +
            record.pg_charge +
            record.pg_out +
            record.pg_out_charge -
            record.d_ewallet -
            record.pe_payment_gateway +
            record.pe_pgout +
            record.dgpay_w_bank_out +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;
        }
      }

      function NetGamingAlgorithm(onlineShop, record) {
        record.algorithm = "NG";

        var isHalfShop = onlineShop.shop.shoptype === "5/5";
        var isHalfPR = onlineShop.shop.shoptype === "20%PR";

        record.totalsales = isHalfPR
          ? record.netgaming +
            record.angpao +
            record.promotion +
            record.fpromotion +
            record.commission
          : record.netgaming;

        var currentSales = Number(
          record.totalsales * Number(onlineShop.onrate / 100)
        );
        var currentPGout =
          Number(record.pg_out) +
          Number(record.pe_pgout) +
          Number(record.fpay_w_bank) +
          Number(record.skl_w_bank) +
          Number(record.vpay_w_bank) +
          Number(record.novapay_w_bank) +
          Number(record.luxepay_w_bank) +
          Number(record.dgpay_w_bank_out);

        var currentPGIn =
          Number(record.payment_gateway) +
          Number(record.zpay_bank_in) +
          Number(record.zpay_qr_in) +
          Number(record.dgpay_bank_in) +
          Number(record.dgpay_qr_in) +
          Number(record.vpay_d_bank) +
          Number(record.fpay_qr) +
          Number(record.fpay_d_bank) +
          Number(record.skl_qr) +
          Number(record.skl_d_bank) +
          Number(record.vpay_qr) +
          Number(record.novapay_d_bank) +
          Number(record.novapay_qr) +
          Number(record.luxepay_d_bank) +
          Number(record.luxepay_qr) +
          Number(record.pe_payment_gateway);

        record.d_ewallet_charge =
          Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
        record.d_cc_charge =
          Number((record.d_cc * record.d_cc_rate) / 100) || 0;
        record.pg_charge = (currentPGIn * record.pg_rate) / 100 || 0;
        record.pg_out_charge = (currentPGout * record.pg_out_rate) / 100 || 0;

        record.p_bonus_bets = Number(
          record.bonus_bet * Number(record.bet_rate / 100)
        );

        record.psales = Number(record.totalsales - currentSales);
        record.csales =
          currentSales +
          record.pshare +
          record.apshare -
          record.pwin -
          record.apwin +
          record.bonus_win +
          record.p_bonus_bets +
          record.caishen +
          record.plinko;

        // formula by MsThong
        var expenses =
          record.pshare +
          record.apshare -
          record.pwin -
          record.apwin +
          record.bonus_bet -
          record.bonus_win +
          record.pgsbonus;

        record.server_fee =
          (record.netgaming * record.server_fee_rate) / 100 + expenses;
        record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
        record.serverpr =
          (record.netgaming *
            (isHalfShop
              ? Number(onlineShop.onrate)
              : Number(record.server_fee_rate))) /
            100 +
          expenses;

        // deduct pgsbonus on csales when is 5/5 shop only
        if (isHalfShop) {
          record.csales = record.csales + record.pgsbonus;
        }

        if (isHalfPR) {
          var serverFeeTotal =
            (record.netgaming * Number(onlineShop.server)) / 100 +
            (record.pshare +
              record.apshare -
              record.pwin -
              record.apwin +
              record.bonus_win +
              record.p_bonus_bets +
              record.caishen +
              record.plinko +
              record.pgsbonus) -
            currentPGIn -
            record.d_ewallet -
            record.telco +
            currentPGout +
            record.pg_out_charge +
            record.pg_charge +
            record.d_ewallet_charge +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;

          record.net_collect =
            (record.totalsales * onlineShop.pr) / 100 + serverFeeTotal;
        } else {
          record.net_collect =
            record.csales -
            currentPGIn -
            record.d_ewallet -
            record.telco +
            currentPGout +
            record.pg_out_charge +
            record.pg_charge +
            record.d_ewallet_charge +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;
        }
      }

      function NetGamingX2Algorithm(onlineShop, record) {
        record.algorithm = "NGX2";
        var isHalfPR = onlineShop.shop.shoptype === "20%PR";

        record.totalsales = isHalfPR
          ? record.netgaming +
            record.angpao +
            record.promotion +
            record.fpromotion +
            record.commission
          : record.netgaming * 2;

        var isHalfShop = onlineShop.shop.shoptype !== "100%";
        var currentSales = Number(
          record.totalsales * Number(onlineShop.onrate / 100)
        );
        var currentPGout =
          Number(record.pg_out) +
          Number(record.pe_pgout) +
          Number(record.fpay_w_bank) +
          Number(record.skl_w_bank) +
          Number(record.vpay_w_bank) +
          Number(record.novapay_w_bank) +
          Number(record.luxepay_w_bank) +
          Number(record.dgpay_w_bank_out);

        var currentPGIn =
          Number(record.payment_gateway) +
          Number(record.zpay_bank_in) +
          Number(record.zpay_qr_in) +
          Number(record.dgpay_bank_in) +
          Number(record.dgpay_qr_in) +
          Number(record.vpay_d_bank) +
          Number(record.fpay_qr) +
          Number(record.fpay_d_bank) +
          Number(record.skl_qr) +
          Number(record.skl_d_bank) +
          Number(record.vpay_qr) +
          Number(record.novapay_d_bank) +
          Number(record.novapay_qr) +
          Number(record.luxepay_d_bank) +
          Number(record.luxepay_qr) +
          Number(record.pe_payment_gateway);

        record.d_ewallet_charge =
          Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
        record.d_cc_charge =
          Number((record.d_cc * record.d_cc_rate) / 100) || 0;
        record.pg_charge = (currentPGIn * record.pg_rate) / 100 || 0;
        record.pg_out_charge = (currentPGout * record.pg_out_rate) / 100 || 0;
        record.p_bonus_bets = Number(
          record.bonus_bet * Number(record.bet_rate / 100)
        );

        record.psales = Number(record.totalsales - currentSales);

        // formula by MsThong
        var expenses =
          record.pshare +
          record.apshare -
          record.pwin -
          record.apwin +
          record.bonus_bet -
          record.bonus_win +
          record.pgsbonus;

        record.server_fee =
          (record.netgaming * record.server_fee_rate) / 100 + expenses;
        record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
        record.serverpr =
          (record.netgaming *
            (isHalfShop
              ? Number(onlineShop.onrate)
              : Number(record.server_fee_rate))) /
            100 +
          expenses;

        record.csales =
          currentSales +
          record.pshare +
          record.apshare -
          record.pwin -
          record.apwin +
          record.bonus_win +
          record.p_bonus_bets +
          record.plinko +
          record.caishen;

        record.net_collect =
          record.csales -
          currentPGIn -
          record.d_ewallet -
          record.telco +
          currentPGout +
          record.pg_out_charge +
          record.pg_charge +
          record.d_ewallet_charge +
          record.tng_pin_charge -
          record.tng_pin -
          record.vpay_tng_pin;
      }

      $scope.gridOptions.data = $scope.gridOptions.data.map(function (dat) {
        var formatted = dat;
        Object.keys(formatted).forEach(function (key) {
          if (key) {
            formatted[key.toString().trim()] = dat[key];
          }
        });

        return formatted;
      });

      var dataLength = $scope.gridOptions.data.length;
      for (var i = 0; i < dataLength; i++) {
        var record = {};

        if (!$scope.gridOptions.data[i].Kiosk) {
          $scope.gridOptions.data[i].ERROR = "Blank Kiosk";
          invalidSales.push($scope.gridOptions.data[i]);
          continue;
        }

        record.playtechid = $scope.gridOptions.data[i].Kiosk.trim();
        var onlineShop = $scope.getOnlineShopByPlayTechId(record.playtechid);

        if (onlineShop === null) {
          $scope.gridOptions.data[i].ERROR = "No Shop Reference";
          invalidSales.push($scope.gridOptions.data[i]);
          continue;
        }

        try {
          record.wanzi_remarks = $scope.gridOptions.data[i].Remarks
            ? $scope.gridOptions.data[i].Remarks.trim()
            : "";
          record.cafe = parseNumber($scope.gridOptions.data[i].cafe, "Cafe");
          record.dart = parseNumber($scope.gridOptions.data[i].dart, "Dart");
          record.snooker = parseNumber(
            $scope.gridOptions.data[i].snooker,
            "Snooker"
          );
          record.snooker_fnb = parseNumber(
            $scope.gridOptions.data[i]["snooker F&B"],
            "Snooker F&B"
          );
          record.pshare = parseNumber($scope.gridOptions.data[i].PS, "PS");
          record.apshare = parseNumber(
            $scope.gridOptions.data[i]["AP PS"],
            "AP PS"
          );
          record.pwin = parseNumber($scope.gridOptions.data[i].PW, "PW");
          record.apwin = parseNumber(
            $scope.gridOptions.data[i]["AP PW"],
            "AP PW"
          );
          record.pgsbonus =
            parseNumber(
              $scope.gridOptions.data[i]["EVENT BONUS"],
              "EVENT BONUS"
            ) || 0;
          record.netpurchase = parseNumber($scope.gridOptions.data[i].NP, "NP");
          record.netgaming = parseNumber($scope.gridOptions.data[i].NG, "NG");
          record.angpao = parseNumber(
            $scope.gridOptions.data[i].Angpao,
            "Angpao"
          );
          record.commission = parseNumber(
            $scope.gridOptions.data[i].Commission,
            "Commission"
          );
          record.fpromotion = parseNumber(
            $scope.gridOptions.data[i].FPromotion,
            "FPromotion"
          );
          record.promotion = parseNumber(
            $scope.gridOptions.data[i].Promotion,
            "Promotion"
          );
          record.g_ewallet = 0;
          record.wanzi = parseNumber(
            $scope.gridOptions.data[i]["万字收"],
            "万字收"
          );

          record.wanzi_com = parseNumber(
            $scope.gridOptions.data[i]["公司佣金"],
            "公司佣金"
          );

          record.bonus_bet = parseNumber(
            $scope.gridOptions.data[i]["Token"],
            "Token"
          );
          record.bonus_win = parseNumber(
            $scope.gridOptions.data[i]["Lucky Wins"],
            "Lucky Wins"
          );
          record.payment_gateway = parseNumber(
            $scope.gridOptions.data[i].Bank,
            "Bank"
          );
          record.pe_payment_gateway = parseNumber(
            $scope.gridOptions.data[i]["PE Bank"],
            "PE_BANK"
          );
          record.pe_pgout = parseNumber(
            $scope.gridOptions.data[i]["PE Bank_Out"],
            "PE_BANK_OUT"
          );
          record.pg_out = parseNumber(
            $scope.gridOptions.data[i].Bank_Out,
            "Bank_Out"
          );
          record.d_ewallet = parseNumber(
            $scope.gridOptions.data[i]["e-wallet"],
            "e-wallet"
          );
          record.d_cc = 0; // || parseNumber($scope.gridOptions.data[i].d_cc, "d_cc");
          record.telco = parseNumber(
            $scope.gridOptions.data[i]["Telco"],
            "telco"
          );
          record.crypto = parseNumber(
            $scope.gridOptions.data[i]["Crypto Deposit"],
            "Crypto Deposit"
          );
          record.tng_pin = parseNumber(
            $scope.gridOptions.data[i]["Tng pin"],
            "Tng pin"
          );
          record.caishen = parseNumber(
            $scope.gridOptions.data[i]["Caishen"],
            "Caishen"
          );
          record.plinko = parseNumber(
            $scope.gridOptions.data[i]["Plinko"],
            "Plinko"
          );
          record.zpay_bank_in = parseNumber(
            $scope.gridOptions.data[i]["Zpay Bank In"],
            "Zpay Bank In"
          );
          record.zpay_qr_in = parseNumber(
            $scope.gridOptions.data[i]["Zpay QR In"],
            "Zpay QR In"
          );
          record.dgpay_bank_in = parseNumber(
            $scope.gridOptions.data[i]["DGpay D.Bank"],
            "DGpay D.Bank"
          );
          record.dgpay_qr_in = parseNumber(
            $scope.gridOptions.data[i]["DGpay QR"],
            "DGpay QR"
          );
          record.dgpay_w_bank_out = parseNumber(
            $scope.gridOptions.data[i]["DGpay W.Bank"],
            "DGpay W.Bank"
          );
          record.fpay_qr = parseNumber(
            $scope.gridOptions.data[i]["Fpay QR"],
            "Fpay QR"
          );
          record.fpay_d_bank = parseNumber(
            $scope.gridOptions.data[i]["Fpay D.Bank"],
            "Fpay D.Bank"
          );
          record.fpay_w_bank = parseNumber(
            $scope.gridOptions.data[i]["Fpay W.Bank"],
            "Fpay W.Bank"
          );
          record.skl_qr = parseNumber(
            $scope.gridOptions.data[i]["SKL QR"],
            "SKL QR"
          );
          // MsThong request remove this from upload file to avoid user confusion
          record.skl_d_bank = 0;
          record.skl_w_bank = 0;
          //
          record.vpay_qr = parseNumber(
            $scope.gridOptions.data[i]["Vpay QR"],
            "Vpay QR"
          );
          record.vpay_d_bank = parseNumber(
            $scope.gridOptions.data[i]["Vpay D.Bank"],
            "Vpay D.Bank"
          );
          record.vpay_tng_pin = parseNumber(
            $scope.gridOptions.data[i]["Vpay Tng Pin"],
            "Vpay Tng Pin"
          );
          record.vpay_w_bank = parseNumber(
            $scope.gridOptions.data[i]["Vpay W.Bank"],
            "Vpay W.Bank"
          );
          record.novapay_qr = parseNumber(
            $scope.gridOptions.data[i]["Novapay QR"],
            "Novapay QR"
          );
          record.novapay_d_bank = parseNumber(
            $scope.gridOptions.data[i]["Novapay D.Bank"],
            "Novapay D.Bank"
          );
          record.novapay_w_bank = parseNumber(
            $scope.gridOptions.data[i]["Novapay W.Bank"],
            "Novapay W.Bank"
          );
          record.luxepay_qr = parseNumber(
            $scope.gridOptions.data[i]["Luxepay QR"],
            "Luxepay QR"
          );
          record.luxepay_d_bank = parseNumber(
            $scope.gridOptions.data[i]["Luxepay D.Bank"],
            "Luxepay D.Bank"
          );
          record.luxepay_w_bank = parseNumber(
            $scope.gridOptions.data[i]["Luxepay W.Bank"],
            "Luxepay W.Bank"
          );
          record.wai_jiao_rate = $scope.gridOptions.data[i]["外交费%"];
          record.gong_shi_pan_rate =
            $scope.gridOptions.data[i]["盘口公司盘费%"];
          record.chang_zhu_rate = $scope.gridOptions.data[i]["跟场主收%"];

          record.wai_jiao_rate =
            record.wai_jiao_rate === "" || isNaN(record.wai_jiao_rate)
              ? 15
              : Number(record.wai_jiao_rate);
          record.gong_shi_pan_rate =
            record.gong_shi_pan_rate === "" || isNaN(record.gong_shi_pan_rate)
              ? 15
              : Number(record.gong_shi_pan_rate);
          record.chang_zhu_rate =
            record.chang_zhu_rate === "" || isNaN(record.chang_zhu_rate)
              ? 0
              : Number(record.chang_zhu_rate);
        } catch (err) {
          $scope.gridOptions.data[i].ERROR = err.message;
          invalidSales.push($scope.gridOptions.data[i]);
          continue;
        }

        if (!onlineShop.shop) {
          $scope.gridOptions.data[i].ERROR = "Online game not assign to shop.";
          invalidSales.push($scope.gridOptions.data[i]);
          continue;
        }

        record.shopid = onlineShop.shop.id;

        if (!onlineShop.game) {
          $scope.gridOptions.data[i].ERROR = "No Game Found";
          invalidSales.push($scope.gridOptions.data[i]);
          continue;
        }

        record.gameid = onlineShop.game.id; // manageOnlinesales.game ? manageOnlinesales.game.id : null;

        record.pg_rate =
          onlineShop.shop.pg_rate === 0 ? 0 : onlineShop.shop.pg_rate || 2.0;
        record.pg_out_rate =
          onlineShop.shop.pg_out_rate === 0
            ? 0
            : onlineShop.shop.pg_out_rate || 2.0;
        record.d_ewallet_rate =
          onlineShop.shop.d_ewallet_rate === 0
            ? 0
            : onlineShop.shop.d_ewallet_rate || 2.0;
        record.d_cc_rate = onlineShop.shop.d_cc_rate || 0;

        record.bet_rate = onlineShop.bet_rate || 100;
        record.onrate = onlineShop.onrate || 0;
        record.server_fee_rate = Number(onlineShop.server) || 0;
        record.pr_fee_rate = Number(onlineShop.pr) || 0;
        record.tng_pin_rate = Number(onlineShop.shop.tng_pin_rate) || 5;
        record.tng_pin_charge =
          ((Number(record.tng_pin) + Number(record.vpay_tng_pin)) *
            record.tng_pin_rate) /
          100;

        if (onlineShop.algorithm === "NP") {
          NetPurchaseAlgorithm(onlineShop, record);
        } else if (onlineShop.algorithm === "NG") {
          NetGamingAlgorithm(onlineShop, record);
        } else if (onlineShop.algorithm === "NGX2") {
          NetGamingX2Algorithm(onlineShop, record);
        }

        record.created = cdate.toDate();
        record.lastupdated = cdate.toDate();
        record.indate = indate.toDate();

        var ikeyDateFormat = indate.utc().format("DDMMYYYY");
        record.ikey = onlineShop.shopid + "" + ikeyDateFormat;

        obj.params.push(record);

        $scope.mangeGameServers.forEach(function (gameserver) {
          var uploadedServerData = $scope.gridOptions.data[i][gameserver.name];
          if (uploadedServerData !== undefined && uploadedServerData !== null) {
            gsObj.params.push({
              playtechid: record.playtechid,
              amount: Number(uploadedServerData),
              shopid: record.shopid,
              gameserverid: gameserver.id,
              ikey: record.ikey,
              indate: record.indate
            });
          }
        });
      }

      $scope.loading = true;
      function success() {
        if (!onlineuploaded.sales || !onlineuploaded.server) {
          return;
        }

        $scope.loading = false;

        var filename = document.querySelector("#uploadFile");
        angular.element(filename).val(null);
        toastr.success(
          "New Online Sales has been saved successfully!",
          "SUCCESS"
        );
      }

      gsObj.onSuccess = function (result) {
        //$scope.dateList = {};
        onlineuploaded.server = true;
        success();
      };

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.gridOptions = {};
        //$scope.dateList = {};
        onlineuploaded.sales = true;
        success();
        if (invalidSales.length > 0) {
          $scope.gridOptions.data = invalidSales;
        } else {
          $scope.gridOptions = {};
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "ERROR");
        } else {
          var errdetails = [];
          errdetails = err.data.error.details;

          toastr.error("Issue with upload!", "ERROR");
          var errObj = [];

          for (var i = 0; i < errdetails.length; i++) {
            if (errdetails[i]) {
              var data = {};
              data.Kiosk = err.config.data[i].playtechid;
              data.PS = err.config.data[i].pshare;
              data.PW = err.config.data[i].pwin;
              data.NP = err.config.data[i].netpurchase;
              data.NG = err.config.data[i].netgaming;
              if (typeof err.config.data[i].playtechid === "undefined") {
                data.ERROR = "Blank Kiosk";
              } else if (err.config.data[i].shopid === null) {
                data.ERROR = "No Shop Reference";
              }
              errObj.push(data);
            }
          }
          console.log(errObj);
          $scope.gridOptions.data = errObj;
        }
      };

      if (obj.params.length) {
        onlinesalesService.createOnlinesales(obj);
      } else {
        onlineuploaded.sales = true;
      }

      if (gsObj.params.length) {
        onlineserverService.saveOnlineServer(gsObj);
      } else {
        onlineuploaded.server = true;
      }
    };

    $scope.confirmDelete = function (id) {
      if (confirm("Remove record?")) {
        $scope.gridOptions.data.splice(id, 1);
      }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales')
    .service('onlinesalesService', onlinesalesService);

  /** @ngInject */
  function onlinesalesService(Onlinesales) {

    var getOnlinesales = function (obj) {
      //read data from gridoptions
      Onlinesales.find({
        filter: {
          include: ["onlineshop", "shop", "game"]
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Onlinesales.createMany(
        obj.params
        // id: obj.params.id,
        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      obj.params.lastupdated = new Date();

      Onlinesales.prototype$patchAttributes(
        obj.params
        // {
        //   id: obj.params.id,
        //   playtechid: obj.params.playtechid,
        //   pshare: obj.params.pshare,
        //   pwin: obj.params.pwin,
        //   netpurchase: obj.params.netpurchase,
        //   netgaming: obj.params.netgaming,
        //   totalsales: obj.params.totalsales,
        //   csales: obj.params.csales,
        //   psales: obj.params.psales,
        //   lastupdated: date
        // }
      ).$promise.then(function (data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getOnlinesales: getOnlinesales,
      saveOnlinesales: saveOnlinesales,
      createOnlinesales: createOnlinesales
    };

  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales')
    .controller('DailymachinesalesreportPageCtrl', DailymachinesalesreportPageCtrl);

  /** @ngInject */
  function DailymachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr,
    $uibModal, receiptService, $rootScope, zoneService, userService, machineService) {
    console.log("Inside DailymachinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{
      value: 'day'
    }, {
      value: 'night'
    }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{
        value: $rootScope.userData.credentials.shopType
      }];
    } else {
      $scope.shopTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };


    $scope.manageUsersList = [];
    $scope.initAgents = function () {
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageMachine();
    };
    $scope.init();
    $scope.reportFilter = {};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.getDailyMachinesales = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0) {
              value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }
      if (reportFilter.agent) {
        obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;
      }
      if (reportFilter.daynight) {
        obj.params.daynight = reportFilter.daynight ? reportFilter.daynight.value : null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/machine/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveCorrection = function (manageMachinesales) {
      console.log('Inside saveMachineRead');

      var record = {};

      if (manageMachinesales && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: manageMachinesales.mid
        }, true);

        var localMachine = selected.length ? selected[0] : null;

        if (localMachine) {
          if (localMachine && $scope.manageMachineShopList.length) {
            var selected1 = $filter('filter')($scope.manageMachineShopList, {
              machineid: localMachine.id,
              status: true
            }, true);

            var localMachineShop = selected1.length ? selected1[0] : null;

            var diffCmIn = ((manageMachinesales.cm_in - manageMachinesales.cm_in_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffCmOut = ((manageMachinesales.cm_out - manageMachinesales.cm_out_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffBmIn = ((manageMachinesales.bm_in - manageMachinesales.bm_in_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var diffBmOut = ((manageMachinesales.bm_out - manageMachinesales.bm_out_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;

            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            if (localMachineShop) {
              record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
              record.psales = (record.totalsales - record.csales).toFixed(2);
              record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
              record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            }

            var obj = {};
            obj.params = {};
            obj.params.id = manageMachinesales.id;
            obj.params.cmin = manageMachinesales.cm_in;
            obj.params.cmout = manageMachinesales.cm_out;
            obj.params.bmin = manageMachinesales.bm_in;
            obj.params.bmout = manageMachinesales.bm_out;
            obj.params.csales = record.csales;
            obj.params.psales = record.psales;
            obj.params.totalsales = record.totalsales;
            obj.params.vcmsales = record.vcmsales;
            obj.params.vpmsales = record.vpmsales;

            console.log('obj.params', obj.params);

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS saveMachineRead");
              console.log(result);
              toastr.success('Machine Sales has been updated successfully!', 'SUCCESS');
              $scope.getDailyMachinesales($scope.reportFilter);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initAgents");
              console.log(err);
            };
            dailymachinesalesreportService.saveMachinesales(obj);

          }
        } else {
          toastr.error('Something went wrong. Please try again', 'ERROR');
        }
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
      obj.params = {};
      obj.params.receiptid = manageMachinesales.receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          $scope.viewReceipts = JSON.parse(result[0].content);
          console.log($scope.viewReceipts);
        }
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code) {
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/machine/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid,
          status: true
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function (agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        }, true);
        return selected.length ? selected[0].credentials.name : '';
      } else return 'Not set';
    };


    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate, 2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate, 0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate, 1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate, 0);

              console.log('checkInDate', checkInDate);
              console.log('resultInDate', resultInDate);

              if (checkInDate >= resultInDate) {
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)) {
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length) {
            dailyInvoiceService.createInvoice(objInvoice);
          } else {
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else {
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.totalsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.csales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.psales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };



  }
})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachinesales')
    .service('dailymachinesalesreportService', dailymachinesalesreportService);

  /** @ngInject */
  function dailymachinesalesreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine","receipt"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveMachinesales = function(obj) {
      var date = new Date();

      Machinesales.prototype$patchAttributes({
        id: obj.params.id,
        cmIn: obj.params.cmin,
        cmOut: obj.params.cmout,
        bmIn: obj.params.bmin,
        bmOut: obj.params.bmout,
        csales: obj.params.csales,
        psales: obj.params.psales,
        totalsales: obj.params.totalsales,
        vcmsales: obj.params.vcmsales,
        vpmsales: obj.params.vpmsales,
        lastupdated: date
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice,
      saveMachinesales:saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop')
    .controller('DailymachineshopPageCtrl', DailymachineshopPageCtrl);

  /** @ngInject */
  function DailymachineshopPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineshopService, dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, $uibModal, $rootScope, zoneService) {
    console.log("Inside DailymachineshopPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };



    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      //$scope.initManageGames();
      $scope.initManageMachineShop();
    };
    $scope.init();

    $scope.totalSalesLabel = 0;
    $scope.manageDailymachineshop = {};
    $scope.manageDailymachineshopList = [];
    $scope.reportFilter = {};
    $scope.getDailyGroupedMachinesales = function (reportFilter) {

      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0) {
              value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        $scope.totalSalesLabel = 0;
        //$scope.initManagePrevMachineReading();
        $scope.manageDailymachineshopList = result.result;
        for (var i = 0; i < $scope.manageDailymachineshopList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageDailymachineshopList[i].totalsales);
        }
        console.log($scope.manageDailymachineshopList);
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //dailymachineshopService.getDailyMachinesales(obj);
      dailymachineshopService.getDailyGroupedMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.getDailyGroupedMachinesales();

    $scope.deleteId = null;
    /*
        $scope.confirmDelete = function(id) {
          $scope.open('app/pages/machine/dailymachineshop/modals/dangerModal.html');
          $scope.deleteId = id;
        };
    
        $scope.deleteMachinesales = function(res) {
          console.log("Inside deleteMachinesales");
          if (res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function(result) {
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
              //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
              $scope.getDailyGroupedMachinesales();
            };
            obj.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else {
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            };
            dailymachineshopService.deleteMachinesales(obj);
          } else {
            console.log('Not sure!');
          }
    
        };
    */

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageDailymachineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageDailymachineshop, id) {

      console.log("Inside saveMachinesales");
      console.log(manageDailymachineshop);
      console.log(manageDailymachineshop.id);

      if (manageDailymachineshop.id === undefined) {
        $scope.createMachinesales(manageDailymachineshop);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageDailymachineshop;
        /*        obj.params.id = manageDailymachineshop.id;
                obj.params.playtechid= manageDailymachineshop.playtechid;
                obj.params.pshare= manageDailymachineshop.pshare;
                obj.params.pwin= manageDailymachineshop.pwin;
                obj.params.netpurchase= manageDailymachineshop.netpurchase;
                obj.params.netgaming= manageDailymachineshop.netgaming;
                obj.params.totalsales= manageDailymachineshop.totalsales;
                obj.params.csales= manageDailymachineshop.csales;
                obj.params.psales= manageDailymachineshop.psales;
                obj.params.shopid= manageDailymachineshop.shopid;
                obj.params.gameid= manageDailymachineshop.gameid;
                // obj.params.name = $scope.manageDailymachineshop.name;
                // obj.params.description = $scope.manageDailymachineshop.description;
                //obj.params.created = $scope.manageDailymachineshop.created;
        */
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.manageDailymachineshop = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.getDailyGroupedMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.salesNumbers = {};
    $scope.viewMachinesales = function (manageDailymachineshop) {
      console.log("Inside viewMachinesales");
      console.log(manageDailymachineshop);
      $scope.isEdit = true;
      $scope.manageDailymachineshop = manageDailymachineshop;

      console.log(manageDailymachineshop.ikey);
      $scope.machineSalesInvoice = {};
      $scope.getMachineInvoiceDetails(manageDailymachineshop.ikey);
      console.log($scope.machineSalesInvoice);
      $scope.getMachineSales(manageDailymachineshop.ikey);
      console.log($scope.machineSalesDetails);
    };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      $scope.machineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineSalesDetails = result;
        var data = {};
        var shopDetails = $scope.getShopDetails($scope.machineSalesDetails[0].shopid);
        console.log(shopDetails)
        console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(shopDetails.shop.partnerid);
        data.created = shopDetails.shop.created;
        $scope.salesNumbers.data = data;
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }

    $scope.getTotalAmount = function (items) {
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseInt(a) + parseInt(b); });
    };

    $scope.showPartnerById = function (partnerid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (partnerid && $scope.managePartnerList.length) {
        //console.log($scope.manageDailymachineshop);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getShopDetails = function (shopid) {
      if (shopid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          shopid: shopid
        }, true);
        console.log(selected);
        return selected.length ? selected[0] : null;
      } else return null;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.dailymachineshop')
    .service('dailymachineshopService', dailymachineshopService);

  /** @ngInject */
  function dailymachineshopService(Machinesales) {
    var getDailyMachinesales = function (obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where: {
            indate: {
              "gte": dailyDate
            }
          },
          include: ["machine", "shop"]
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyGroupedMachinesales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('dailyDate ',dailyDate);
      Machinesales.grpShop({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function (obj) {
      Machinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    /*  var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
*/
    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyGroupedMachinesales: getDailyGroupedMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey
      //      createMachinesales: createMachinesales,
      //      deleteMachinesales: deleteMachinesales
      //    saveMachinesales: saveMachinesales
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales')
    .controller('MachinesalesreportPageCtrl', MachinesalesreportPageCtrl);

  /** @ngInject */
  function MachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesreportService, machineShopService, gameService, shopService, partnerService, machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal, $rootScope, zoneService, receiptService, userService, machineService, dailymachinesalesreportService) {
    console.log("Inside MachinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dayNightFilter = [{
      value: 'day'
    }, {
      value: 'night'
    }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {
      from: moment().startOf('month').toDate(),
      to: moment().toDate(),
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{
        value: $rootScope.userData.credentials.shopType
      }];
    } else {
      $scope.shopTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function () {
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getAllMachine(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageMachine();
    }
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0) {
                value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }
        if (reportFilter.agent) {
          obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;
        }
        if (reportFilter.daynight) {
          obj.params.daynight = reportFilter.daynight ? reportFilter.daynight.value : null;
        }
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.manageMachinesalesList = result.result;
          for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          // $scope.initManagePartner();
          // $scope.initManageGames();
          // $scope.initManageMachineShop();
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesreportService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    // $scope.searchMachinesales = function() {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.initManagePartner();
    //     $scope.initManageGames();
    //     $scope.initManageMachineShop();
    //     //$scope.initManagePrevMachineReading();
    //     $scope.manageMachinesalesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machinesalesreportService.getBetweenDatesMachinesales(obj);
    //   //$scope.$broadcast('scroll.refreshComplete');
    // };
    //$scope.searchMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/machine/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.searchMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.searchMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;

      $scope.viewReceipts = {};

      var obj = {};
      obj.params = {};
      obj.params.receiptid = manageMachinesales.receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          $scope.viewReceipts = JSON.parse(result[0].content);
          console.log($scope.viewReceipts);
        }
        $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);

    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid,
          status: true
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function (agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        }, true);
        return selected.length ? selected[0].credentials.name : '';
      } else return 'Not set';
    };

    $scope.getTotaltotalsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.totalsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.csales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.psales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };




    $scope.saveCorrection = function (manageMachinesales) {
      console.log('Inside saveMachineRead');

      var record = {};

      if (manageMachinesales && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: manageMachinesales.mid
        }, true);

        var localMachine = selected.length ? selected[0] : null;

        if (localMachine) {
          if (localMachine && $scope.manageMachineShopList.length) {
            var selected1 = $filter('filter')($scope.manageMachineShopList, {
              machineid: localMachine.id,
              status: true
            }, true);

            var localMachineShop = selected1.length ? selected1[0] : null;

            var diffCmIn = ((manageMachinesales.cm_in - manageMachinesales.cm_in_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffCmOut = ((manageMachinesales.cm_out - manageMachinesales.cm_out_p) * parseFloat(localMachine.cmRate)).toFixed(2);
            var diffBmIn = ((manageMachinesales.bm_in - manageMachinesales.bm_in_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var diffBmOut = ((manageMachinesales.bm_out - manageMachinesales.bm_out_p) * parseFloat(localMachine.bmRate)).toFixed(2);
            var cmTotalSales = diffCmIn - diffCmOut;
            var bmTotalSales = diffBmIn - diffBmOut;

            if (localMachine.calby)
              record.totalsales = cmTotalSales.toFixed(2);
            else {
              record.totalsales = bmTotalSales.toFixed(2);
            }

            if (localMachineShop) {
              record.csales = (record.totalsales * localMachineShop.macrate / 100).toFixed(2);
              record.psales = (record.totalsales - record.csales).toFixed(2);
              record.vcmsales = (record.totalsales * localMachineShop.macvirtual / 100).toFixed(2);
              record.vpmsales = (record.totalsales - record.vcmsales).toFixed(2);
            }

            var obj = {};
            obj.params = {};
            obj.params.id = manageMachinesales.id;
            obj.params.cmin = manageMachinesales.cm_in;
            obj.params.cmout = manageMachinesales.cm_out;
            obj.params.bmin = manageMachinesales.bm_in;
            obj.params.bmout = manageMachinesales.bm_out;
            obj.params.csales = record.csales;
            obj.params.psales = record.psales;
            obj.params.totalsales = record.totalsales;
            obj.params.vcmsales = record.vcmsales;
            obj.params.vpmsales = record.vpmsales;

            console.log('obj.params', obj.params);

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS saveMachineRead");
              console.log(result);
              toastr.success('Machine Sales has been updated successfully!', 'SUCCESS');
              $scope.searchMachinesales($scope.reportFilter);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initAgents");
              console.log(err);
            };
            dailymachinesalesreportService.saveMachinesales(obj);

          }
        } else {
          toastr.error('Something went wrong. Please try again', 'ERROR');
        }
      }
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.machine.machinesales')
    .service('machinesalesreportService', machinesalesreportService);

  /** @ngInject */
  function machinesalesreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getUTCDate();
    //   //var newDate  = new Date(date);
    //   console.log('date',date);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": date}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   td.setHours(23);
    //   td.setMinutes(59);
    //   td.setSeconds(59);
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('client from date',fd);
    //   console.log('client from date1',date1); 
    //   console.log('client to date',td);
    //   console.log('client to date2',date2); 

    //   Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {indate: {gte: date1}},
    //                 {indate: {lte: date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    var getBetweenDatesMachinesales = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Machinesales.getAllMachinesales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var deleteMachinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      // getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales,
     getAvailableMachineByZone:getAvailableMachineByZone
    };

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var date = new Date();
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month'
      },
      selectable: false,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'Today',
          start: date,
          color: dashboardColors.silverTree,
          allDay: true
        }
        // {
        //   title: 'Long Event',
        //   start: '2016-03-07',
        //   end: '2016-03-10',
        //   color: dashboardColors.blueStone
        // },
        // {
        //   title: 'Dinner',
        //   start: '2016-03-14T20:00:00',
        //   color: dashboardColors.surfieGreen
        // },
        // {
        //   title: 'Birthday Party',
        //   start: '2016-04-01T07:00:00',
        //   color: dashboardColors.gossipDark
        // }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.msync.importofficers')
    .controller('ImportofficersPageCtrl', ImportofficersPageCtrl);

  /** @ngInject */
  function ImportofficersPageCtrl($scope, $filter, editableOptions, editableThemes,
    importofficersService, toastr, $uibModal, SheetJSExportService, areaService, emprateService, departmentService,
    userService, validationService, siteService, $rootScope) {
    console.log("Inside ImportofficersPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 100;
    $scope.manageImportofficers = {
      user: $rootScope.userData,
    };
    $scope.manageImportofficersList = [];
    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };


    $scope.initManageImportofficers = function () {
      console.log($scope.manageImportofficers.import);
      $scope.initManageDepartments();
      $scope.initManageEmprate();
      $scope.initManageAreas();
      $scope.initManageUser();
      $scope.initManageSite();
      $scope.manageImportofficers = {
        user: $rootScope.userData,
      };
      $scope.gridOptions = {};

      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageImportofficers();
    $scope.passOnlinesales = function (manageImportofficers) {
      console.log("Inside passOnlinesales");
      console.log(manageImportofficers);
    }

    $scope.getDepartmentId = function (deptName) {
      if (deptName && $scope.manageDepartmentList.length) {
        var selected = $filter('filter')($scope.manageDepartmentList, {
          name: deptName
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getEmprateId = function (emprate) {
      if (emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {
          name: emprate
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getAreaId = function (area) {
      if (area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {
          name: area
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.getSiteId = function (site) {
      if (site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {
          name: site
        }, true);
        return selected.length ? selected[0].id : null;
      } else return null;
    };

    $scope.createImportofficers = function () {
      console.log("Inside manageImportofficers");
      console.log($scope.gridOptions.data);
      var isFormValidated = true;

      if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        toastr.error('Please select file to Upload', 'ERROR');
      }

      if (isFormValidated) {

        var date = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          if ($scope.gridOptions.data[i].post && $scope.gridOptions.data[i].name && $scope.gridOptions.data[i].area) {
            console.log('$scope.gridOptions.data[i]', $scope.gridOptions.data[i]);

            record.emprateid = $scope.getEmprateId(($scope.gridOptions.data[i].post).trim());
            record.firstname = $scope.gridOptions.data[i].name;
            record.sprate = $scope.gridOptions.data[i].rate ? ($scope.gridOptions.data[i].rate).trim() : 0;
            record.sprate1 = $scope.gridOptions.data[i].rate1 ? ($scope.gridOptions.data[i].rate1).trim() : 0;
            record.departmentid = $scope.gridOptions.data[i].department ? $scope.getDepartmentId(($scope.gridOptions.data[i].department).trim()) : null;
            record.areaid = $scope.getAreaId(($scope.gridOptions.data[i].area).trim());
            record.siteid = $scope.gridOptions.data[i].balai ? $scope.getSiteId(($scope.gridOptions.data[i].balai).trim()) : null;
            record.managerid = $scope.manageImportofficers.user.id;
            record.ownerid = $scope.manageImportofficers.user.id;
            record.created = date;
            record.lastupdated = date;
            console.log(record);
            obj.params.push(record);
          }
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};

          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          toastr.success('New Officer Details has been saved successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {
            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.rate = err.config.data[i].emprateid;
                data.name = err.config.data[i].firstname;
                data.rate = err.config.data[i].sprate;
                data.rate1 = err.config.data[i].sprate1;
                data.department = err.config.data[i].departmentid;
                data.area = err.config.data[i].areaid;
                if (typeof err.config.data[i].firstname === 'undefined') {
                  data.ERROR = 'Blank Officer Name';
                } else if (typeof err.config.data[i].departmentid === 'undefined') {
                  data.ERROR = 'Blank Department';
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        }
        importofficersService.createImportofficers(obj);
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('departmentService', departmentService);

  /** @ngInject */

  function departmentService(Department) {

    var getDepartments = function(obj) {
      
          Department.find({
            filter:{
              include:["area"]
            }
          }).$promise.then(function(data) {
            console.log(data);
            obj.onSuccess(data);
      
          }, function(err) {
            //$ionicLoading.hide();
            obj.onFailure(err);
          });
        };
    return {
      getDepartments: getDepartments
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('emprateService', emprateService);

  /** @ngInject */

  function emprateService(Emprate) {

    var getEmprate = function(obj) {
      Emprate.find().$promise.then(function(data) {
            console.log(data);
            obj.onSuccess(data);
      
          }, function(err) {
            //$ionicLoading.hide();
            obj.onFailure(err);
          });
        };
    return {
      getEmprate: getEmprate
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.importofficers')
    .service('importofficersService', importofficersService);

  /** @ngInject */

  function importofficersService(Employees) {

    var createImportofficers = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Employees.createMany(
        obj.params
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      createImportofficers: createImportofficers
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers')
    .controller('OfficersPageCtrl', OfficersPageCtrl);

  /** @ngInject */
  function OfficersPageCtrl($scope, $filter, editableOptions, editableThemes,
    officersService, toastr, $uibModal, userService,emprateService, departmentService, areaService, zoneService, validationService, siteService) {
    console.log("Inside OfficersPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageZoneList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZoneList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    
    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };

    $scope.smartTablePageSize = 100;

    
    $scope.manageOfficersList = [];
    $scope.manageOfficer = {};
    $scope.initManageOfficers = function() {
      var obj = {};
      obj.params = {};
//      $scope.manageOfficer.user = user.credentials.firstName;
      obj.params.firstname = $scope.manageOfficer.userSearch;
      console.log($scope.manageOfficer.userSearch);
      

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficersList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      officersService.getOfficers(obj);
    };

    //$scope.initManageOfficers();

    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.initManageUser();
    $scope.initManageAreas();
    $scope.initManageZones();
    $scope.initManageEmprate();
    $scope.initManageDepartments();
    $scope.initManageSite();

    $scope.searchOfficers = function (userid) {
      var obj = {};
      obj.params = {};
      //$scope.manageOfficer.userSearch = user.credentials.firstName;
      obj.params.ownerid = userid;
      console.log(userid);
      $scope.manageOfficer.userSearch = userid;
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(userid)) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
        toastr.error('Please select Mobile User', 'ERROR');
      }

      if (isFormValidated) {
        obj.onSuccess = function (result) {
          console.log("Inside searchOfficers SUCCESS");
          console.log(result);
          $scope.totalAmount = 0;
          $scope.totalAmount1 = 0;
          for (var i = 0; i < result.length; i++) {
            $scope.totalAmount =  $scope.totalAmount + parseFloat(result[i].sprate);
            $scope.totalAmount1 =  $scope.totalAmount1 + parseFloat(result[i].sprate1);
          }
          $scope.manageOfficersList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside searchOfficers Failure");
          console.log(err);
        };
        officersService.getOfficers(obj);
      }
    }

    $scope.addOfficer = function() {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOfficersList.push($scope.inserted);
    };

    $scope.createOfficer = function(manageOfficer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOfficer");
      console.log(manageOfficer);

      var obj = {};
      obj.params = {};
      obj.params = manageOfficer;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficer = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        //$scope.initManageOfficers();
        $scope.searchOfficers($scope.manageOfficer.userSearch);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      officersService.createOfficer(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/msync/officers/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOfficer = function(res) {
      console.log("Inside deleteOfficer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          //$scope.initManageOfficers();
          $scope.searchOfficers($scope.manageOfficer.userSearch);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        officersService.deleteOfficer(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageOfficer.id = $scope.manageOfficer.id;
      // $scope.manageOfficer.name = state.name;
      // $scope.manageOfficer.description = state.description;
      // $scope.manageOfficer.created = state.created;
      // $scope.manageOfficer.lastupdated = state.lastupdated;
      $scope.manageOfficer = state;
      genericModalService.show('modules/modals/addOfficer.html', $scope);
    }

    $scope.saveOfficer = function(manageOfficer, id,ownerid) {

      console.log("Inside saveOfficer");
      console.log(manageOfficer);
      console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.sprate = manageOfficer.sprate;
        obj.params.sprate1 = manageOfficer.sprate1;
        obj.params.emprateid = manageOfficer.emprateid;
        obj.params.firstname = manageOfficer.firstname;
        obj.params.departmentid = manageOfficer.departmentid;
        obj.params.siteid = manageOfficer.siteid;
        obj.params.areaid = manageOfficer.areaid;
        obj.params.zoneid = manageOfficer.zoneid;
        obj.params.id = id;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOfficer = {};
          toastr.success('Officer record has been saved successfully!', 'SUCCESS');
          $scope.searchOfficers(ownerid);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        officersService.saveOfficer(obj);
    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getDepartmentId = function(deptName) {
      if (deptName &&  $scope.manageDepartmentList.length){
        var selected = $filter('filter')($scope.manageDepartmentList, {id : deptName
        },true);
        return selected.length ? selected[0].name : null;
      }else return null;
    };

    $scope.getEmprateId = function(emprate) {
      if(emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {id : emprate
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };
    
    $scope.getAreaId = function(area) {
      if(area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {id: area
        });
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    $scope.getZoneId = function(zone) {
      if(zone && $scope.manageZoneList.length) {
        var selected = $filter('filter')($scope.manageZoneList, {id: zone
        });
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    $scope.getSiteId = function(site) {
      if(site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {id: site
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.officers')
    .service('officersService', officersService);

  /** @ngInject */
  function officersService(Employees) {
    var getOfficers = function(obj) {

    Employees.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include: ["project", "emprate", "supervisor", "manager","owner", "site", "area", "department"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var getUnAssingnedOfficers = function(obj) {

    Employees.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include: ["project", "emprate", "supervisor", "manager","owner", "site", "area", "department"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  // var createOfficer = function(obj) {
  //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

  //   var date = new Date();

  //   Employees.create({
  //     name:obj.params.name,
  //     description:obj.params.description?obj.params.description:null,
  //     stateid: obj.params.state,
	//      zoneid: obj.params.zone,
  //     created: date,
  //     lastupdated: date
  //   }).$promise.then(function(data) {
  //     //$ionicLoading.hide();
  //     //console.log(data);
  //     obj.onSuccess(data);

  //   }, function(err) {
  //     //$ionicLoading.hide();
  //     //console.log(err)
  //     obj.onFailure(err);
  //   });
  // };


  var deleteOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Employees.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Employees.prototype$patchAttributes({
      id: obj.params.id,
      emprateid: obj.params.emprateid,
      firstname: obj.params.firstname,
      sprate: obj.params.sprate?obj.params.sprate:0,
      sprate1: obj.params.sprate1?obj.params.sprate1:0,
      departmentid: obj.params.departmentid,
      siteid: obj.params.siteid,
      areaid: obj.params.areaid,
      zoneid: obj.params.zoneid,
      //supid: obj.params.supid,
      //managerid: obj.params.managerid,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getOfficers: getOfficers,
//      createOfficer: createOfficer,
      deleteOfficer: deleteOfficer,
      saveOfficer: saveOfficer,
      getUnAssingnedOfficers:getUnAssingnedOfficers
    };

  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist')
    .service('paylistService', paylistService);

  /** @ngInject */
  function paylistService(Paylist) {
    var getPaylist = function(obj) {

    Paylist.find({
      filter: {
        where:{
          ownerid:obj.params.ownerid,
        },
        include:["owner","shared","useraccount","account"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  // var createOfficer = function(obj) {
  //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

  //   var date = new Date();

  //   Paylist.create({
  //     name:obj.params.name,
  //     description:obj.params.description?obj.params.description:null,
  //     stateid: obj.params.state,
	//      zoneid: obj.params.zone,
  //     created: date,
  //     lastupdated: date
  //   }).$promise.then(function(data) {
  //     //$ionicLoading.hide();
  //     //console.log(data);
  //     obj.onSuccess(data);

  //   }, function(err) {
  //     //$ionicLoading.hide();
  //     //console.log(err)
  //     obj.onFailure(err);
  //   });
  // };


  var deleteOfficer = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Paylist.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var createPaylist = function(obj) {
    var date = new Date();

    Paylist.create({
      name:obj.params.name,
      ownerid:obj.params.ownerid,
      shareid:obj.params.shared,
      useraccountid: obj.params.useraccountid,
      accountid: obj.params.accountid,
      amount: obj.params.amount,
      plist: obj.params.plist,
      entrydate: date,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };


  var savePaylist = function(obj) {
    var date = new Date();

    Paylist.prototype$patchAttributes({
      id: obj.params.id,
      name:obj.params.name,
      ownerid:obj.params.ownerid,
      shareid:obj.params.shared,
      useraccountid: obj.params.useraccountid,
      accountid: obj.params.accountid,
      amount: obj.params.amount,
      plist: obj.params.plist,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

    return{
      getPaylist: getPaylist,
      createPaylist:createPaylist,
      deleteOfficer: deleteOfficer,
      savePaylist: savePaylist
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.msync.paylist')
    .controller('PaylistPageCtrl', PaylistPageCtrl);

  /** @ngInject */
  function PaylistPageCtrl($scope, $filter, editableOptions, editableThemes,
    paylistService, toastr, $uibModal, userService,emprateService, departmentService, areaService, validationService, siteService,officersService) {
    console.log("Inside PaylistPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.manageAreasList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    
    $scope.manageEmprateList = [];
    $scope.initManageEmprate = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageEmprateList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      emprateService.getEmprate(obj);
    };

    $scope.manageDepartmentList = [];
    $scope.initManageDepartments = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDepartmentList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      departmentService.getDepartments(obj);
    };

    $scope.smartTablePageSize = 100;

    
    $scope.managePaylistList = [];
    $scope.manageOfficer = {};
    $scope.initManagePaylist = function() {
      
      var obj = {};
      obj.params = {};
//      $scope.manageOfficer.user = user.credentials.firstName;
      obj.params.firstname = $scope.manageOfficer.userSearch;
      console.log($scope.manageOfficer.userSearch);
      

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePaylistList = result;
       
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      paylistService.getPaylist(obj);
    };

    //$scope.initManagePaylist();

    $scope.manageUser = {};
    $scope.manageUserList = [];
    $scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsersMSync(obj);
    };

    $scope.initManageUser();
    $scope.initManageAreas();
    $scope.initManageEmprate();
    $scope.initManageDepartments();
    $scope.initManageSite();

    $scope.searchPaylist = function (userid) {
      var obj = {};
      obj.params = {};
      //$scope.manageOfficer.userSearch = user.credentials.firstName;
      obj.params.ownerid = userid;
      console.log(userid);
      $scope.manageOfficer.userSearch = userid;
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(userid)) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
        toastr.error('Please select Mobile User', 'ERROR');
      }

      if (isFormValidated) {
        obj.onSuccess = function (result) {
          console.log("Inside searchPaylist SUCCESS");
          console.log(result);
          $scope.totalAmount = 0;
          $scope.totalAmount1 = 0;
          for (var i = 0; i < result.length; i++) {
            $scope.totalAmount =  $scope.totalAmount + parseFloat(result[i].sprate);
            $scope.totalAmount1 =  $scope.totalAmount1 + parseFloat(result[i].sprate1);
          }
          $scope.managePaylistList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside searchPaylist Failure");
          console.log(err);
        };
        paylistService.getPaylist(obj);
      }
    }

    $scope.addPaylist = function() {
      //genericModalService.show('modules/modals/addOfficer.html',$scope);
      // $scope.inserted = {
      //   name: null,
      //   description: null,
      // };
      // $scope.managePaylistList.push($scope.inserted);
      $scope.isEdit = true;
    };

    $scope.assignOfficer = function (item) {
      if (item.issprate){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) + parseFloat(item.sprate);
      }
      if (item.issprate1){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) + parseFloat(item.sprate1);
      }
      $scope.manageOfficer.plist.push(item);
    };
    $scope.removeOfficer = function (item) {
      if (item.issprate){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) - parseFloat(item.sprate);
      }
      if (item.issprate1){
        $scope.manageOfficer.amount =  parseFloat($scope.manageOfficer.amount) - parseFloat(item.sprate1);
      }
      $scope.manageOfficer.plist = $scope.manageOfficer.plist.filter(function(el){return el.id!=item.id;});
    };
    $scope.selectAmount = function(item,issprate,issprate1){
      item.issprate = null;
      item.issprate1 = null;
      if (issprate){
        item.issprate= true;
        item.issprate1= null;
      }
      if (issprate1){
        item.issprate1= true;
        item.issprate= null;
      }
    };

    $scope.createOfficer = function(manageOfficer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOfficer");
      console.log(manageOfficer);

      var obj = {};
      obj.params = {};
      obj.params = manageOfficer;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOfficer = {};
        toastr.success('New Paylist has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Playlist successfully created.");
        //$scope.initManagePaylist();
        $scope.searchPaylist($scope.manageOfficer.userSearch);

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      paylistService.createOfficer(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/msync/paylist/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteOfficer = function(res) {
      console.log("Inside deleteOfficer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Paylist has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Paylist successfully deleted.");
          //$scope.initManagePaylist();
          $scope.searchPaylist($scope.manageOfficer.userSearch);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        paylistService.deleteOfficer(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.notSelectedOfficerList = [];
    $scope.editPaylist = function(item) {
      console.log("Inside editPaylist");
      $scope.isEdit = true;
      $scope.manageOfficer = item;
      $scope.notSelectedOfficerList = [];
      //genericModalService.show('modules/modals/addOfficer.html', $scope);
      $scope.getNotSelectedOfficers(item);
    };

    $scope.addOfficer = function () {
      $scope.isAssignNewOfficer = true;
    };
    $scope.closeOfficer = function () {
      $scope.isAssignNewOfficer = false;
    };

    $scope.getNotSelectedOfficers = function (item) {

        var obj = {};
        obj.params = {};
        obj.params.ownerid = item.ownerid;
  
        console.log('obj.params', obj.params);
  
        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedShops SUCCESS");
          console.log(result);
          $scope.notSelectedOfficerList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        officersService.getUnAssingnedOfficers(obj);
    };

    $scope.savePaylist = function(managePaylist) {

      console.log("Inside savePaylist");
      console.log(managePaylist);
      //console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.id = managePaylist.id?managePaylist.id:null;
        obj.params.name = managePaylist.name;
        obj.params.ownerid = managePaylist.ownerid;
        obj.params.shared = managePaylist.shared;
        obj.params.useraccountid = managePaylist.useraccountid;
        obj.params.accountid = managePaylist.accountid;
        obj.params.amount = managePaylist.amount;
        obj.params.plist = managePaylist.plist;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Officer record has been saved successfully!', 'SUCCESS');
          $scope.searchPaylist($scope.manageOfficer.ownerid);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        paylistService.savePaylist(obj);
    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getDepartmentId = function(deptName) {
      if (deptName &&  $scope.manageDepartmentList.length){
        var selected = $filter('filter')($scope.manageDepartmentList, {id : deptName
        },true);
        return selected.length ? selected[0].name : null;
      }else return null;
    };

    $scope.getEmprateId = function(emprate) {
      if(emprate && $scope.manageEmprateList.length) {
        var selected = $filter('filter')($scope.manageEmprateList, {id : emprate
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };
    
    $scope.getAreaId = function(area) {
      if(area && $scope.manageAreasList.length) {
        var selected = $filter('filter')($scope.manageAreasList, {id: area
        });
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    $scope.getSiteId = function(site) {
      if(site && $scope.manageSiteList.length) {
        var selected = $filter('filter')($scope.manageSiteList, {id: site
        },true);
        return selected.length ? selected[0].name : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getTotaltotal = function (items) {
      if (items){
      return items
        .map(function (x) { return x.amount; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.companyserverinvoice")
    .controller("CompanyServerInvoicePageCtrl", CompanyServerInvoicePageCtrl);

  /** @ngInject */
  function CompanyServerInvoicePageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    stateService,
    onlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    dailyInvoiceService,
    toastr,
    $uibModal,
    validationService,
    $rootScope,
    zoneService
  ) {
    console.log("Inside CompanyServerInvoicePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };
    $scope.totalSalesLabel = 0;
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dateList = {
      from: new moment().subtract(1, "day").toDate(),
      to: new moment().toDate(),
    };
    $scope.reportFilter = {};
    $scope.searchOnlinesales = function (reportFilter) {
      console.log("Inside searchOnlinesales", reportFilter);
      console.log($scope.dateList);

      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (
            typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
            Array.isArray($rootScope.userData.credentials.zonemap) &&
            $rootScope.userData.credentials.zonemap.length > 0
          ) {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.partner !== "undefined") {
          obj.params.partnerid = $rootScope.userData.credentials.partner.id;
        } else if (reportFilter.partnerid) {
          obj.params.partnerid = reportFilter.partnerid.id;
        }

        if (reportFilter.state) {
          obj.params.stateid = reportFilter.state.id;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          $scope.totalSalesLabel = 0;

          // result.result = filterPartnerStaffShops(result.result);

          $scope.manageOnlinesalesList = result.result;
          $scope.isEdit = false;
          $scope.initManagePartner();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlinesalesreportService.getAllPartnerShop(obj);
      }
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (
        typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
        Array.isArray($rootScope.userData.credentials.zonemap) &&
        $rootScope.userData.credentials.zonemap.length > 0
      ) {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        for (var i = 0; i < result.length; i++) {
          $scope.totalSalesLabel =
            $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      //onlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast("scroll.refreshComplete");
    };

    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        var userPartner = $rootScope.userData.credentials
          ? $rootScope.userData.credentials.partner
          : null;

        console.log("user", $rootScope.userData);
        $scope.manageParentPartnerList =
          $rootScope.userData.roleId === 1
            ? result
            : userPartner
            ? result.filter(function (res) {
                return (
                  res.code === userPartner.code ||
                  (!!userPartner.isparent && res.parentid === userPartner.id)
                );
              })
            : [];

        console.log("partner", $scope.manageParentPartnerList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManageParentPartner();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.allinvoices")
    .controller("AllinvoicesPageCtrl", AllinvoicesPageCtrl);

  /** @ngInject */
  function AllinvoicesPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    collectorService,
    stateService,
    allInvoiceService,
    onlineShopService,
    validationService,
    zoneService,
    gameService,
    shopService,
    partnerService,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    toastr,
    $uibModal,
    userService,
    $rootScope,
    assigncollectorService,
    receiptService,
    invoiceReceiptService,
    shopCategoryService
  ) {
    console.log("Inside AllinvoicesPageCtrl");

    var s3Client = new AWS.S3({
      sslEnabled: true,
      endpoint: "https://sgp1.digitaloceanspaces.com",
      region: "us-east-1",
      credentials: {
        accessKeyId: "DO00MVXY4KLLHBJ2G7UC",
        secretAccessKey: "doCg2gc1yEY4rPkMSE+hmlx7oXF8DrXr1tmKeG7YJ58"
      }
    });

    $scope.zoomInMode = false;
    $scope.myImageStyle = {};
    $scope.showHeader = true;

    $scope.shopInvoicingOptions = [
      { id: null, label: "All" },
      { id: true, label: "YES" },
      { id: false, label: "NO" }
    ];

    $scope.paidStatusList = [
      { value: "PAID" },
      { value: "PARTIALLY PAY" },
      { value: "UNPAY" }
    ];

    $scope.isAdmin =
      [1, 5].includes($rootScope.userData.roleId) ||
      ($rootScope.userData.roleId === 20 &&
        $rootScope.userData.credentials.partner.isparent);

    $scope.canUserClickPayNow = [1, 5, 7].some(function (roleId) {
      return roleId === $rootScope.userData.roleId;
    });

    $scope.canUserClickDelete = [1, 5].some(function (roleId) {
      return roleId === $rootScope.userData.roleId;
    });

    $scope.rate = {
      earn: 0,
      charge: 0,
      pr: 0
    };

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteInvoice(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    var userReportDuration = $rootScope.userData.credentials.months;

    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null
      }
    };
    $scope.total = {};
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [
      {
        value: "PAID"
      },
      {
        value: "UNPAID"
      }
    ];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType
        }
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5"
        },
        {
          value: "100%"
        }
      ];
    }
    $scope.shopBillChecker = {
      checkAll: false
    };
    $scope.mainBillChecker = {
      checkall: false
    };

    $scope.columnList = [
      { key: "invoiceid", title: "Invoice No." },
      { key: "invoicedate", title: "Invoice Date" },
      { key: "shopcode", title: "Shop Code" },
      { key: "shopname", title: "Shop Name" },
      { key: "partnername", title: "Partner" },
      { key: "netgaming", title: "Net Gaming" },
      { key: "cafeanddart", title: "Cafe & Darts" },
      { key: "snooker", title: "Snooker" },
      { key: "net_collect", title: "Net Collect" },
      { key: "total_payment_gateway", title: "Bank" },
      { key: "total_pg_out", title: "Bank Out" },
      { key: "d_ewallet", title: "D.Ewallet" },
      { key: "tng_pin_charge", title: "Tng pin" },
      { key: "d_cc", title: "D.CC" },
      { key: "sales", title: "Sales" },
      { key: "serverpr", title: "Server" },
      { key: "claim", title: "Claim" },
      { key: "total", title: "Total" },
      { key: "localPaidStatus", title: "Paid Status" },
      { key: "pdate", title: "Paid Date" },
      { key: "agentid", title: "Agent" },
      { key: "receipts", title: "Receipts" }
    ];
    $scope.columnListOfShop = $scope.columnList.concat();

    $scope.managePaidInvoicesList = [];

    $scope.allowToViewShopCategory =
      $rootScope.userData.credentials.role === 1 ||
      $rootScope.userData.credentials.role === 5;
    $scope.shopCategory = [];
    $scope.initManageShopCategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.shopCategory = result;
      };
      obj.onFailure = function (err) {};
      shopCategoryService.getShopCategory(obj);
    };

    if ($scope.allowToViewShopCategory) {
      $scope.initManageShopCategory();
    }

    //get zone table data
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        // $scope.manageZonesList = result;
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index]
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Get the zone list before search is initiated.
    $scope.initManageZones();

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageUsersList = [];
    $scope.initManageUsers = function () {
      if ($rootScope.userData.roleId === 7) {
        console.log("Inside initManageOfficers");
        console.log("$rootScope.userData.id", $rootScope.userData.id);

        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);

          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log("userIDs", userIDs);

            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      } else if (
        $rootScope.userData.roleId === 5 &&
        typeof $rootScope.userData.credentials.collectormap !== "undefined"
      ) {
        var obj = {
          params: {
            zoneid: null
          }
        };
        // if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        //   obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        // }
        obj.onSuccess = function (result) {
          $scope.manageUsersList = result
            .filter(function (collector) {
              if (!collector.user) {
                return false;
              }
              return $rootScope.userData.credentials.collectormap.includes(
                collector.id
              );
            })
            .map(function (collector) {
              return collector.user;
            });
        };
        collectorService.getCollector(obj);
      } else {
        var obj = {};
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }
    };
    $scope.initManageUsers();

    $scope.totalSalesLabel = 0;
    $scope.reportFilter = {
      allowInvocing: { id: null }
    };
    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      $scope.loading.searching = true;

      $scope.mainBillChecker = {
        checkall: false
      };

      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        console.log("reportFilter", reportFilter);

        var obj = {};
        obj.params = {};
        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;
        obj.params.ispaid = reportFilter.ispaid
          ? reportFilter.ispaid.value
          : null;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (
            typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
            Array.isArray($rootScope.userData.credentials.zonemap) &&
            $rootScope.userData.credentials.zonemap.length > 0
          ) {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        if (typeof $rootScope.userData.credentials.partner !== "undefined") {
          // if ($rootScope.userData.credentials.partner.isparent === null && !!$rootScope.userData.credentials.partner.parentid) {
          //   obj.params.partnerid = $rootScope.userData.credentials.partner.parentid;
          // } else {
          obj.params.partnerid = $rootScope.userData.credentials.partner.id;
          // }
        }

        function filterPartnerStaffShops(result) {
          if (
            $rootScope.userData.credentials.partner &&
            $rootScope.userData.credentials.partner.isparent === null &&
            !!$rootScope.userData.credentials.partner.parentid
          ) {
            return result.filter(function (r) {
              return r.shopcode.contains(
                $rootScope.userData.credentials.partner.code
              );
            });
          }
          return result;
        }

        if (reportFilter.state) {
          obj.params.stateid = reportFilter.state.id;
        }

        obj.params.categoryid = reportFilter.categoryid
          ? reportFilter.categoryid.id
          : null;

        if (
          reportFilter.allowInvocing &&
          reportFilter.allowInvocing.id !== null
        ) {
          obj.params.allowInvocing =
            reportFilter.allowInvocing && reportFilter.allowInvocing.id
              ? true
              : false;
        }

        obj.onSuccess = function (result) {
          $scope.loading.searching = false;

          console.log("Inside getAllZoneSales SUCCESS");

          // result.result = filterPartnerStaffShops(result.result);
          $scope.manageAllinvoicesList = result.result;

          $scope.totalSalesLabelFooter = 0;
          $scope.mSalesTotal = 0;
          $scope.oSalesTotal = 0;
          $scope.totalSalesLabel = 0;

          for (
            var index = 0;
            index < $scope.manageAllinvoicesList.length;
            index++
          ) {
            $scope.totalSalesLabel =
              $scope.totalSalesLabel +
              Number($scope.getTotalSales($scope.manageAllinvoicesList[index]));
          }

          $scope.getInvoicePaid();
        };
        obj.onFailure = function (err) {
          console.log("Inside getAllZoneSales Failure");
          console.log(err);
          $scope.loading.searching = false;
        };
        allInvoiceService.getAllInvoiceWithSales(obj);
      } else {
        $scope.loading.searching = false;
      }
    };

    $scope.getAllZoneSales = function (dateList) {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function (result) {
        console.log("Inside getAllZoneSalesSUCCESS");
        console.log(result);
        $scope.manageAllinvoicesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside getAllZoneSales Failure");
        console.log(err);
      };
      allInvoiceService.getBetweenDatesInvoices(obj);
    };

    $scope.getInvoiceByZone = function (dateList, zoneid) {
      var obj = {};
      obj.params = {};

      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;
      obj.params.zoneselection = zoneid;

      obj.onSuccess = function (result) {
        console.log("Inside getInvoiceByZone SUCCESS");
        console.log(result);
        $scope.manageAllinvoicesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside getInvoiceByZone Failure");
        console.log(err);
      };
      allInvoiceService.getInvoiceByZoneBetweenDates(obj);
    };

    $scope.loading = {
      generateInvoiceReceipt: false,
      searching: false,
      paidMainInvoiceReceipt: false
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    // $scope.manageShopList = [];
    // $scope.initManageShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   shopService.getShop(obj);
    // };

    $scope.manageAllinvoices = {};
    $scope.manageAllinvoicesList = [];
    $scope.manageAllinvoicesListWithShop = [];

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    $scope.createInvoice = function (manageAllinvoices) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createInvoice");
      //console.log(manageAllinvoices.name);
      //console.log(manageAllinvoices.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageAllinvoices.id;
      obj.params.playtechid = manageAllinvoices.playtechid;
      obj.params.pshare = manageAllinvoices.pshare;
      obj.params.pwin = manageAllinvoices.pwin;
      obj.params.netpurchase = manageAllinvoices.netpurchase;
      obj.params.netgaming = manageAllinvoices.netgaming;
      obj.params.totalsales = manageAllinvoices.totalsales;
      obj.params.csales = manageAllinvoices.csales;
      obj.params.psales = manageAllinvoices.psales;

      //obj.params.description = manageAllinvoices.description;
      console.log(manageAllinvoices);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAllinvoices = {};
        toastr.success("New Invoice has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Invoice successfully created.");
        $scope.initManageInvoice();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      allInvoiceService.createInvoice(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/invoices/dailyinvoices/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function (res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Invoice has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Invoice successfully deleted.");
          $scope.initManageInvoice();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        allInvoiceService.deleteInvoice(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (invoice) {
      // console.log("Inside editInvoice");
      // console.log(invoice);
      $scope.manageAllinvoices = invoice;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getAllInvoiceWithShop = function (currentInvoice) {
      $scope.selectedInvoiceWithShop = currentInvoice;
      $scope.manageAllinvoicesListWithShop = [];

      $scope.loading.detail = true;
      $scope.totalSalesOfShop = 0;
      $scope.shopBillChecker = {
        checkAll: false
      };

      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {
        var obj = {};
        obj.params = {};
        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        obj.params.agentid = $scope.reportFilter.agent
          ? $scope.reportFilter.agent.id
          : null;
        obj.params.ispaid = $scope.reportFilter.ispaid
          ? $scope.reportFilter.ispaid.value
          : null;

        obj.params.shopid = $scope.selectedInvoiceWithShop.shopid;

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = $scope.reportFilter.shoptype
            ? $scope.reportFilter.shoptype.value
            : null;
        }

        if (typeof $rootScope.userData.credentials.partner !== "undefined") {
          obj.params.partnerid = $rootScope.userData.credentials.partner.id;
        }

        if ($scope.reportFilter.state) {
          obj.params.stateid = $scope.reportFilter.state.id;
        }

        obj.params.categoryid = $scope.reportFilter.categoryid
          ? $scope.reportFilter.categoryid.id
          : null;

        if (
          $scope.reportFilter.allowInvocing &&
          $scope.reportFilter.allowInvocing.id !== null
        ) {
          obj.params.allowInvocing =
            $scope.reportFilter.allowInvocing &&
            $scope.reportFilter.allowInvocing.id
              ? true
              : false;
        }

        obj.onSuccess = function (result) {
          $scope.loading.detail = false;

          $scope.manageAllinvoicesListWithShop = result.result.map(
            function (invoice) {
              $scope.totalSalesOfShop =
                $scope.totalSalesOfShop + Number($scope.getTotalSales(invoice));

              var hasPaidInovice = $scope.managePaidInvoicesList.filter(
                function (res) {
                  return invoice.id === res.invoiceid;
                }
              );

              var totalPaid = hasPaidInovice.reduce(function (total, curr) {
                return (total += Number(curr.amount));
              }, 0);
              var localPaidStatus = !hasPaidInovice.length
                ? "UNPAY"
                : totalPaid >= invoice.net_collect ||
                    Math.abs(totalPaid - invoice.net_collect) < 0.1
                  ? "PAID"
                  : "PARTIALLY PAY";

              invoice.ikeyToDate = invoice.ikey.substring(
                invoice.ikey.length - 8
              );

              invoice.receipts = hasPaidInovice;
              invoice.localPaidStatus = localPaidStatus;
              return invoice;
            }
          );

          // $scope.getInvoicePaid();
        };
        obj.onFailure = function (err) {
          $scope.loading.detail = false;
        };
        allInvoiceService.getAllInvoiceWithShop(obj);
      } else {
        $scope.loading.detail = false;
      }
    };

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function (manageAllinvoices) {
      $scope.isEdit = true;
      $scope.manageAllinvoices = manageAllinvoices;
      $scope.showHeader = false;

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};

      $scope.getOnlineSales($scope.manageAllinvoices.ikey);
      $scope.getMachineSales($scope.manageAllinvoices);
    };

    $scope.saveInvoice = function (id) {
      console.log("Inside saveInvoice");
      //console.log(itemInvoice);
      console.log(id);

      var obj = {};
      obj.params = {};
      obj.params.machineshorts = $scope.manageAllinvoices.machineshorts;
      obj.params.onlineshorts = $scope.manageAllinvoices.onlineshorts;
      obj.params.id = id;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAllinvoices = result;
        $scope.managePartner = {};
        toastr.success("Invoice has been updated successfully!", "SUCCESS");
        //          $scope.initManageStates();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      allInvoiceService.saveInvoice(obj);
    };

    $scope.wanziList = [];
    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        $scope.wanziList = [];

        result.forEach(function (r) {
          if ((r.wanzi && r.wanzi > 0) || r.wanzi_remarks) {
            $scope.wanziList.push(r);
          }
        });

        $scope.onlineInvoiceDetails = {
          NG: result
            .filter(function (r) {
              return r.algorithm === "NG" || r.algorithm === "NGX2";
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.skl_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              return r;
            }),
          NP: result
            .filter(function (r) {
              return r.algorithm === "NP" || r.algorithm === null;
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.skl_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              return r;
            })
        };

        // set shop
        $scope.shopInvoiceDetails = result.length > 0 && result[0].shop;
        // if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
        //   console.log('Inside Empty MachineShop');
        //   $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        // }

        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        $scope.total.NP_csales_total = 0;
        $scope.total.NP_totalsales = 0;
        $scope.total.totalSales = 0;

        $scope.total.totalSales = $scope.onlineInvoiceDetails.NG.concat(
          $scope.onlineInvoiceDetails.NP
        ).reduce(function (acc, curr) {
          return acc + Number(curr.csales);
        }, 0);

        $scope.total.NP_csales_total = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.csales);
          },
          0
        );

        $scope.total.NG_net_collect = $scope.onlineInvoiceDetails.NG.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_net_collect = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_totalsales = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.totalsales);
          },
          0
        );

        var selected =
          $scope.onlineInvoiceDetails.NP[0] ||
          $scope.onlineInvoiceDetails.NG[0];

        if (selected) {
          var onlineshop = selected.shop.onlineshop.find(function (os) {
            return os.playtechid === selected.playtechid;
          });

          var earn = selected.onrate
            ? selected.onrate
            : selected.playtechid === "WK8S6" && selected.shop.id === 1019
              ? 35
              : 0;
          var charge = Number(selected.server_fee_rate);
          var pr =
            selected.shop.shoptype === "20%PR"
              ? Number(selected.pr_fee_rate)
              : earn - charge;

          // if (
          //   moment(selected.indate, "YYYY-MM-DD")
          //     .utcOffset(8)
          //     .diff(moment("20230416").utcOffset(8).startOf("day")) >= 0 &&
          //   selected.shop.zoneid === 83
          // ) {
          //   pr = Number(selected.serverpr);
          // }

          $scope.rate = {
            earn: earn,
            charge: charge,
            pr: pr
          };
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function (manageDailyinvoices) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineInvoiceDetails = result;
        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0;
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          console.log($scope.manageAllinvoices.machineshorts);
          $scope.total.machine = machine;
          $scope.total.machineST =
            machine + parseFloat($scope.manageAllinvoices.machineshorts);
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };
    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    // $scope.showShops = function(shop) {
    //   //console.log("Inside showGames = "+JSON.stringify(game));
    //   if (shop && $scope.manageShopList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: game.id
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (manageAllinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageAllinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageAllinvoices);
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.manageAllinvoices.shop.partnerid
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };

    $scope.saveShorts = function () {
      console.log($scope.manageAllinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageAllinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageAllinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      //$scope.initManageStates();
      $scope.initManageInvoice();
      $scope.manageAllinvoices = {};
    };

    $scope.print = function () {
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter("filter")(
          $scope.manageUsersList,
          {
            id: userid
          },
          true
        );

        return selected.length
          ? selected[0].credentials.name
            ? selected[0].credentials.name
            : selected[0].credentials.firstName +
              " " +
              selected[0].credentials.lastName
          : "";

        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return "";
    };

    //Group Totals
    $scope.getCsales = function (item) {
      return item.algorithm === "NP"
        ? Number(item.csales)
        : Number(item.csales) -
            Number(item.pshare) -
            Number(item.apshare) -
            Number(item.p_bonus_bets) +
            Number(item.pwin) +
            Number(item.apwin) +
            Number(item.bonus_win);
    };
    $scope.getServerSales = function (items) {
      return $scope.getTotalSales(items) - items.serverpr;
    };
    $scope.getTotalSales = function (items) {
      return items.shoptype === "100%"
        ? Number(items.net_collect) +
            Number(items.total_payment_gateway) -
            Number(items.total_pg_out) +
            Number(items.d_ewallet) +
            Number(items.d_cc) +
            Number(items.tng_pin_charge)
        : items.ocsales;
    };
    $scope.getTotalServerFee = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.serverpr;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalServerSales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return $scope.getServerSales(x);
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };

    $scope.getTotalmcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.mcsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalocsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.ocsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaltotalsales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (acc, curr) {
          return acc + parseFloat($scope.getTotalSales(curr));
        }, 0);
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.psales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.csales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalSnooker = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.snooker);
        }, 0);
      }
    };
    $scope.getTotalCafeAndDarts = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.cafeanddarts);
        }, 0);
      }
    };
    $scope.getTotalWanziCom = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.wanzi_com);
        }, 0);
      }
    };
    $scope.getTotalTngPin = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.tng_pin_charge);
        }, 0);
      }
    };
    $scope.getTotalNetGaming = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.netgaming);
        }, 0);
      }
    };
    $scope.getTotalNetCollect = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.net_collect);
        }, 0);
      }
    };
    $scope.getTotalBank = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.total_payment_gateway);
        }, 0);
      }
    };
    $scope.getTotalBankOut = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.total_pg_out);
        }, 0);
      }
    };
    $scope.getTotalEwallet = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.d_ewallet);
        }, 0);
      }
    };
    $scope.getTotalCC = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.d_cc);
        }, 0);
      }
    };

    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log("receiptid", receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open(
            "app/pages/invoices/dailyinvoices/modals/receiptModal.html"
          );
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);
    };
    $scope.getFinalTotalPR = function () {
      return $scope.getFinalTotalEarn() - $scope.getFinalTotalCharge();
    };

    $scope.getFinalTotalCharge = function () {
      return $scope.getsubTotalCharge() + $scope.getTotalEarnCharge();
    };

    $scope.getFinalTotalEarn = function () {
      return $scope.getsubTotalEarn() + $scope.getTotalEarnCharge();
    };

    $scope.getTotalEarnCharge = function () {
      return (
        -$scope.getTotalGameOf("total_payment_gateway") -
        $scope.getTotalGameOf("d_ewallet") -
        $scope.getTotalGameOf("telco") +
        $scope.getTotalGameOf("crypto") +
        $scope.getTotalGameOf("total_pg_out") +
        $scope.getTotalGameOf("pg_charge") +
        $scope.getTotalGameOf("pg_out_charge") +
        $scope.getTotalGameOf("d_ewallet_charge") +
        $scope.getTotalGameOf("tng_pin_charge") -
        $scope.getTotalGameOf("tng_pin")
      );
    };

    $scope.getPGInRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_rate;
        });

      return (rate.pg_rate || 0) + "%";
    };

    $scope.getPGOutRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_out_rate;
        });

      return (rate.pg_out_rate || 0) + "%";
    };

    $scope.getEwalletRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.d_ewallet_rate;
        });

      return (rate.d_ewallet_rate || 0) + "%";
    };

    $scope.getTngPinRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.tng_pin_rate;
        });

      return (rate.tng_pin_rate || 0) + "%";
    };

    $scope.parseToNegativeList = function (key) {
      var value = $scope.getTotalGameOf(key);
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.parseToNegative = function (value) {
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.getPRGameEarnSubtotal = function (item, type) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return item.pr_fee;
      // }

      if (type === "NP") {
        return $scope.getTotalNpEarn(item) - $scope.getTotalNpCharge(item);
      }
      return $scope.getTotalNgEarn(item) - $scope.getTotalNgCharge(item);
    };

    $scope.getTotalGame = function (tableData, type) {
      return (
        $scope.getTotalGameEarn(tableData, type) -
        $scope.getTotalGameCharge(tableData, type)
      );
    };

    $scope.getTotalGameEarn = function (item, type) {
      var isPR = ["20%PR"].includes(item.shop.shoptype);
      if (isPR) {
        return (
          $scope.getTotalPRCharge(item) + $scope.getTotalGameCharge(item, "NG")
        );
      }

      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });
      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return (subtotal * rate) / 100;
    };

    $scope.getTotalGameCharge = function (item, type) {
      var prcompany = Number(item.server_fee_rate);
      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      return (subtotal * prcompany) / 100;
    };

    $scope.getTotalPRCharge = function (item) {
      if (!["20%PR"].includes(item.shop.shoptype)) {
        return 0;
      }

      return (
        ($scope.getFullTotal(item, item.shop.shoptype) *
          Number($scope.rate.pr)) /
        100
      );
    };

    $scope.getGameName = function (item) {
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });

      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return rate + "%" + " " + item.game.name;
    };

    $scope.getTotalGameName = function (item) {
      return "TOTAL " + item.game.name;
    };

    $scope.getFullGameName = function (item, type) {
      var gameType = type === "NP" ? "Net Purchase" : "Net Gaming";
      return "100%" + " " + gameType + " - " + item.game.name;
    };

    $scope.getItemGameName = function (item) {
      return item.game & item.game.name ? item.game.name : "";
    };

    $scope.getsubTotalEarn = function () {
      var totalNpEarn = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);

          var onlineshop = item.shop.onlineshop.find(function (os) {
            return os.playtechid === item.playtechid;
          });
          var rate = item.onrate
            ? item.onrate
            : item.playtechid === "WK8S6" && item.shop.id === 1019
              ? 35
              : 0;

          var npEarn =
            (subtotal * rate) / 100 +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);

          totalNpEarn += npEarn;
        });
      }

      var totalNGEarn = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGEarn += $scope.getTotalNgEarn(item);
        });
      }

      return totalNpEarn + totalNGEarn;
    };

    $scope.getsubTotalCharge = function () {
      var totalNpCharge = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var prcompany = Number(item.server_fee_rate);
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);
          var npcharge = (subtotal * prcompany) / 100;

          totalNpCharge +=
            npcharge +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);
        });
      }

      var totalNGCharge = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGCharge += $scope.getTotalNgCharge(item);
        });
      }

      return totalNpCharge + totalNGCharge;
    };

    $scope.getsubTotalNP = function (item) {
      return (
        $scope.getFullTotal(item, "NP") -
        Number(item.pshare) -
        Number(item.apshare) +
        Number(item.pwin) +
        Number(item.apwin) +
        Number(item.total_payment_gateway) -
        Number(item.total_pg_out) +
        Number(item.d_ewallet)
      );
    };

    $scope.getTotalNpEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }
      return (
        $scope.getTotalGameEarn(item, "NP") +
        Number(item.pshare) +
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNpCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NP") +
        Number(item.pshare) +
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNgCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) -
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    $scope.getTotalNgEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }

      return (
        $scope.getTotalGameEarn(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) -
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    // type: NP | NG
    $scope.getFullTotal = function (item, type) {
      var field =
        type === "NP"
          ? "netpurchase"
          : ["20%PR"].includes(type)
            ? "totalsales"
            : "netgaming";

      return Number(item[field]) || 0;
    };

    $scope.getTotalGameOf = function (key) {
      return []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .filter(function (tdata) {
          return !!tdata[key];
        })
        .reduce(function (total, current) {
          return (total += current[key] ? Number(current[key]) : 0);
        }, 0);
    };

    $scope.paidSelectedInvoices = function (targetInvoice) {
      var selectedInovices = $scope.manageAllinvoicesListWithShop.filter(
        function (invoice) {
          return targetInvoice
            ? targetInvoice.id === invoice.id
            : $scope.shopBillChecker[invoice.id] === true;
        }
      );

      if (!selectedInovices.length) {
        toastr.error("No invoice is selected", "ERROR");
        return;
      }

      $scope.openPaidInvoiceModal(null, selectedInovices);
    };

    $scope.paidSelectedMainInvoices = function (targetMainInvoice) {
      var selectedInovices = $scope.manageAllinvoicesList.filter(
        function (invoice) {
          return targetMainInvoice
            ? targetMainInvoice.invoice_ids === invoice.invoice_ids
            : $scope.mainBillChecker[invoice.invoice_ids] === true;
        }
      );

      var mainInvoiceIds = [];

      selectedInovices.forEach(function (invoice) {
        var invoicesplitids = invoice.invoice_ids.split(",").map(function (id) {
          return Number(id);
        });
        mainInvoiceIds = mainInvoiceIds.concat(invoicesplitids);
      });

      if (!mainInvoiceIds.length) {
        toastr.error("No invoice is selected", "ERROR");
        return;
      }

      $scope.loading.paidMainInvoiceReceipt = true;

      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;
      obj.params.agentid = $scope.reportFilter.agent
        ? $scope.reportFilter.agent.id
        : null;
      obj.params.ispaid = $scope.reportFilter.ispaid
        ? $scope.reportFilter.ispaid.value
        : null;
      obj.params.shopid = selectedInovices.map(function (invoice) {
        return invoice.shopid;
      });

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if (typeof $rootScope.userData.credentials.partner !== "undefined") {
        obj.params.partnerid = $rootScope.userData.credentials.partner.id;
      }

      if ($scope.reportFilter.state) {
        obj.params.stateid = $scope.reportFilter.state.id;
      }

      obj.params.categoryid = $scope.reportFilter.categoryid
        ? $scope.reportFilter.categoryid.id
        : null;

      if (
        $scope.reportFilter.allowInvocing &&
        $scope.reportFilter.allowInvocing.id !== null
      ) {
        obj.params.allowInvocing =
          $scope.reportFilter.allowInvocing &&
          $scope.reportFilter.allowInvocing.id
            ? true
            : false;
      }

      obj.params.ids = mainInvoiceIds;

      allInvoiceService.getAllInvoiceWithShop({
        params: obj.params,
        onSuccess: function (data) {
          $scope.loading.paidMainInvoiceReceipt = false;

          $scope.openPaidInvoiceModal(null, data.result);
          // Handle success
        },
        onFailure: function (err) {
          $scope.loading.paidMainInvoiceReceipt = false;
          // Handle error
        }
      });
    };

    $scope.openPaidInvoiceModal = function (receiptid, invoices) {
      $scope.selectedInvoicesToPaid = {};

      var selectedPaidInvoices = [];
      var selectedReceipt = {};

      if (receiptid) {
        var hasReceipts = $scope.managePaidInvoicesList.filter(
          function (receipt) {
            return (
              receipt.invoicereceiptid && receipt.invoicereceiptid === receiptid
            );
          }
        );

        if (!hasReceipts.length) {
          toastr.warning("Error", "Receipt not found");
          return;
        }

        hasReceipts.forEach(function (paidInv) {
          var myInovice = $scope.manageAllinvoicesList.find(function (invoice) {
            return invoice.invoice_ids.includes(paidInv.invoiceid);
          });

          if (!myInovice) {
            return;
          }

          selectedPaidInvoices.push({
            photoURL: paidInv.photos,
            paidAmount: Number(Number(paidInv.amount).toFixed(2)),
            id: paidInv.id,
            invoice: myInovice
          });
        });

        selectedReceipt = hasReceipts[0];
      } else if (invoices.length) {
        invoices.forEach(function (invoice) {
          var paidAmount = invoice.net_collect;
          $scope.managePaidInvoicesList
            .filter(function (paidInvoice) {
              return paidInvoice.invoiceid === invoice.id;
            })
            .forEach(function (paidInv) {
              paidAmount -= Number(paidInv.amount);
            });

          selectedPaidInvoices.push({
            photoURL: [],
            paidAmount: Number(paidAmount.toFixed(2)),
            invoice: invoice
          });
        });
      }

      $scope.selectedInvoicesToPaid.id = selectedReceipt
        ? selectedReceipt.invoicereceiptid
        : null;
      $scope.selectedInvoicesToPaid.paidAt = moment(
        selectedReceipt ? selectedReceipt.paidAt : ""
      )
        .startOf("day")
        .utcOffset(8)
        .toDate();
      $scope.selectedInvoicesToPaid.orno = selectedReceipt
        ? selectedReceipt.orno
        : "";
      $scope.selectedInvoicesToPaid.description = selectedReceipt
        ? selectedReceipt.description
        : "";
      $scope.selectedInvoicesToPaid.receivedBy = "";
      $scope.selectedInvoicesToPaid.invoices = selectedPaidInvoices;
      $scope.selectedInvoicesToPaid.status = selectedReceipt
        ? selectedReceipt.status
        : false;

      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: "modal-scrollable",
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/paidInvoiceModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          $scope.loading.generateInvoiceReceipt = true;

          var obj = {};
          obj.params = {
            id: $scope.selectedInvoicesToPaid.id,
            paidAt: moment($scope.selectedInvoicesToPaid.paidAt)
              .startOf("day")
              .utcOffset(8)
              .toISOString(),
            description: $scope.selectedInvoicesToPaid.description
          };

          invoiceReceiptService.generateInvoiceReceipt(obj);
          obj.onSuccess = function (res) {
            // upload photo
            var promises = [];
            $scope.selectedInvoicesToPaid.invoices.forEach(
              function (paidInvoice) {
                var hasNewPhoto = paidInvoice.photoURL.filter(function (photo) {
                  return photo.buffer;
                });
                if (!hasNewPhoto.length) {
                  return;
                }

                hasNewPhoto.forEach(function (photo) {
                  promises.push({
                    id: paidInvoice.invoice.id,
                    buffer: photo.buffer,
                    filename: photo.filename
                  });
                });
              }
            );

            Promise.all(
              promises.length
                ? promises.map(function (pro) {
                    return new Promise(function (resolve) {
                      s3Client.putObject(
                        {
                          Bucket: "tswlab/" + "superman-v2",
                          Body: pro.buffer,
                          ACL: "public-read",
                          Key: pro.filename
                        },
                        function (err, res) {
                          return resolve({
                            url:
                              "https://tswlab.sgp1.cdn.digitaloceanspaces.com/superman-v2/" +
                              pro.filename,
                            id: pro.id
                          });
                        }
                      );
                    });
                  })
                : []
            ).then(function (photos) {
              var invoiceObj = {};
              invoiceObj.params = [];
              $scope.selectedInvoicesToPaid.invoices.forEach(
                function (paidInvoice) {
                  var params = {};
                  params.id = paidInvoice.id;
                  params.invoiceid = paidInvoice.invoice.id;
                  params.photos = photos.filter(function (photo) {
                    return photo.id === paidInvoice.invoice.id;
                  });

                  paidInvoice.photoURL
                    .filter(function (url) {
                      return !url.buffer;
                    })
                    .forEach(function (url) {
                      params.photos.push(url);
                    });

                  params.amount = Number(paidInvoice.paidAmount);

                  params.invoicereceiptid = res.result ? res.result.id : res.id;

                  invoiceObj.params.push(params);
                }
              );

              invoiceObj.onSuccess = function (result) {
                toastr.success(
                  "Official Receipt " +
                    (res.result ? res.result.orno : res.orno) +
                    " Generated!",
                  "SUCCESS"
                );

                $scope.getInvoicePaid();
                $scope.loading.generateInvoiceReceipt = false;
              };

              invoiceReceiptService.createInvoicePaidBulk(invoiceObj);
            });
          };
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.viewPaidReceipt = function (event, item) {
      event.stopPropagation();

      if (!item.invoicereceiptid) {
        return;
      }

      $scope.openPaidInvoiceModal(item.invoicereceiptid);
    };

    $scope.getInvoicePaid = function () {
      var obj = {};
      $scope.managePaidInvoicesList = [];
      obj.params = {
        adate: $scope.dateList.from,
        bdate: $scope.dateList.to,
        ismonthly: false
      };

      if ($scope.reportFilter.zone) {
        obj.params.zoneid = $scope.reportFilter.zone
          ? "('" + $scope.reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        }
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if ($scope.reportFilter.state) {
        obj.params.stateid = $scope.reportFilter.state.id;
      }

      obj.onSuccess = function (result) {
        $scope.managePaidInvoicesList = result;

        $scope.manageAllinvoicesList = $scope.manageAllinvoicesList.map(
          function (invoice) {
            invoice.receipts = [];
            var invoiceids = (invoice.invoice_ids || "")
              .split(",")
              .map(function (id) {
                return Number(id);
              });

            var hasPaidInovice = $scope.managePaidInvoicesList.filter(
              function (res) {
                return invoiceids.includes(res.invoiceid);
              }
            );

            var totalPaid = hasPaidInovice.reduce(function (total, curr) {
              return (total += Number(curr.amount));
            }, 0);
            var localPaidStatus = !hasPaidInovice.length
              ? "UNPAY"
              : totalPaid >= invoice.net_collect ||
                  Math.abs(totalPaid - invoice.net_collect) < 0.1
                ? "PAID"
                : "PARTIALLY PAY";

            return Object.assign(invoice, {
              receipts: hasPaidInovice,
              localPaidStatus: localPaidStatus
            });
          }
        );
      };

      invoiceReceiptService.getInvoicePaid(obj);
    };

    $scope.onFileChange = function (files, index) {
      if (!files.length) {
        return;
      }

      Array.from(files).forEach(function (file) {
        var reader = new FileReader();

        reader.addEventListener("load", function (result) {
          $scope.selectedInvoicesToPaid.invoices =
            $scope.selectedInvoicesToPaid.invoices.map(function (invoice, i) {
              if (i === index) {
                invoice.photoURL.unshift({
                  buffer: reader.result,
                  // file: file,
                  filename: file.name.toString().trim().replace(/ /g, ""),
                  url: window.URL.createObjectURL(file)
                });
              }

              return invoice;
            });
        });

        // reader.readAsDataURL(file);
        reader.readAsArrayBuffer(file);
      });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg"
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%"
      };
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.deleteImage = function (event, id, index) {
      event.stopPropagation();
      $scope.selectedInvoicesToPaid.invoices =
        $scope.selectedInvoicesToPaid.invoices.map(function (paidInovice) {
          if (paidInovice.invoice.id !== id) {
            return paidInovice;
          }

          paidInovice.photoURL = paidInovice.photoURL.filter(
            function (photo, i) {
              return i !== index;
            }
          );

          return paidInovice;
        });
    };

    $scope.onAfterChange = function () {
      $scope.myImageStyle = {};
      $scope.zoomInMode = false;

      $scope.$apply();
    };

    $scope.backToList = function () {
      $scope.selectedInvoicesToPaid = null;
      $scope.manageAllinvoicesListWithShop = [];
      $scope.selectedInvoiceWithShop = null;

      $scope.showHeader = false;
      window.scrollTo(0, 0);

      setTimeout(function () {
        $scope.showHeader = true;
        $scope.$apply();

        setTimeout(function () {
          $scope.$broadcast("stickyTableHeader:recalculate");
        }, 300);
      }, 100);
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        allowInvocing: null
      };
    };

    $scope.getTotalPaidReceipt = function () {
      return $scope.selectedInvoicesToPaid.invoices.reduce(function (
        total,
        current
      ) {
        return (total += Number(current.paidAmount));
      }, 0);
    };

    $scope.getTotaPaidNetCollect = function () {
      return $scope.selectedInvoicesToPaid.invoices.reduce(function (
        total,
        current
      ) {
        return (total += Number(current.invoice.net_collect));
      }, 0);
    };

    $scope.onCheckBoxChange = function (invoiceId, currentInvocies) {
      if (!$scope.canUserClickPayNow) {
        return;
      }

      if (invoiceId) {
        $scope.shopBillChecker[invoiceId] = !$scope.shopBillChecker[invoiceId];

        var hasItemUncheck = $scope.manageAllinvoicesListWithShop.find(
          function (invoice) {
            return !$scope.shopBillChecker[invoice.id];
          }
        );

        $scope.shopBillChecker.checkAll = !hasItemUncheck;
      } else {
        $scope.manageAllinvoicesListWithShop.forEach(function (dat) {
          var match = (currentInvocies || []).find(function (inv) {
            return inv.id === dat.id;
          });
          if (!match) {
            return;
          }

          $scope.shopBillChecker[dat.id] = $scope.shopBillChecker.checkAll;
        });
      }
    };

    $scope.onMainCheckBoxChange = function (currentInvoice, allInvoices) {
      if (!$scope.canUserClickPayNow) {
        return;
      }

      if (currentInvoice) {
        $scope.mainBillChecker[currentInvoice.invoice_ids] =
          !$scope.mainBillChecker[currentInvoice.invoice_ids];

        var hasItemUncheck = $scope.manageAllinvoicesList.find(
          function (invoice) {
            return !$scope.mainBillChecker[invoice.invoice_ids];
          }
        );

        $scope.mainBillChecker.checkAll = !hasItemUncheck;
      } else {
        $scope.manageAllinvoicesList.forEach(function (dat) {
          var match = (allInvoices || []).find(function (inv) {
            return inv.invoice_ids === dat.invoice_ids;
          });
          if (!match) {
            return;
          }

          $scope.mainBillChecker[dat.invoice_ids] =
            $scope.mainBillChecker.checkAll;
        });
      }
    };

    $scope.onColumnToolbarChange = function (columnList, variableName) {
      $scope[variableName] = {};

      columnList.excluded.forEach(function (key) {
        $scope[variableName][key] = true;
      });

      console.log("columnList", columnList);
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.allinvoices")
    .service("allInvoiceService", allInvoiceService);

  /** @ngInject */
  function allInvoiceService(Invoice) {
    var getBetweenDatesInvoices = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();
      console.log("date1", date1);
      console.log("date2", date2);

      Invoice.find({
        filter: {
          where: {
            and: [{ indate: { gte: date1 } }, { indate: { lte: date2 } }]
          },
          include: ["shop"]
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getInvoiceByZoneBetweenDates = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();
      console.log("date1", date1);
      console.log("date2", date2);

      Invoice.find({
        filter: {
          where: {
            and: [
              { indate: { gte: date1 } },
              { indate: { lte: date2 } },
              { zoneid: obj.params.zoneselection }
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createInvoice = function (obj) {
      var date = new Date();

      Invoice.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteInvoice = function (obj) {
      Invoice.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllInvoiceWithShop = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();

      Invoice.getAllInvoiceWithShop({
        adate: date1,
        bdate: date2,
        shopid: obj.params.shopid,
        agentid: obj.params.agentid ? obj.params.agentid : null,
        ispaid: obj.params.ispaid ? obj.params.ispaid : null,
        partnerid: obj.params.partnerid ? obj.params.partnerid : null,
        stateid: obj.params.stateid ? obj.params.stateid : null,
        categoryid: obj.params.categoryid,
        allowInvocing: obj.params.allowInvocing,
        ids: obj.params.ids ? obj.params.ids : null
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllInvoiceWithSales = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();
      console.log("date1", date1);
      console.log("date2", date2);

      Invoice.getAllInvoiceWithSales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid ? obj.params.agentid : null,
        ispaid: obj.params.ispaid ? obj.params.ispaid : null,
        partnerid: obj.params.partnerid ? obj.params.partnerid : null,
        stateid: obj.params.stateid ? obj.params.stateid : null,
        categoryid: obj.params.categoryid,
        allowInvocing: obj.params.allowInvocing
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var payInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getBetweenDatesInvoices: getBetweenDatesInvoices,
      getInvoiceByZoneBetweenDates: getInvoiceByZoneBetweenDates,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getAllInvoiceWithSales: getAllInvoiceWithSales,
      payInvoice: payInvoice,
      getAllInvoiceWithShop: getAllInvoiceWithShop
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.dailyinvoices")
    .controller("DailyinvoicesPageCtrl", DailyinvoicesPageCtrl);

  /** @ngInject */
  function DailyinvoicesPageCtrl(
    $scope,
    $filter,
    $state,
    editableOptions,
    editableThemes,
    collectorService,
    dailyInvoiceService,
    invoiceReceiptService,
    onlineShopService,
    gameService,
    shopService,
    zoneService,
    partnerService,
    stateService,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    toastr,
    $uibModal,
    userService,
    $rootScope,
    assigncollectorService,
    receiptService,
    shopCategoryService
  ) {
    console.log("Inside DailyinvoicesPageCtrl");

    var s3Client = new AWS.S3({
      sslEnabled: true,
      endpoint: "https://sgp1.digitaloceanspaces.com",
      region: "us-east-1",
      credentials: {
        accessKeyId: "DO00MVXY4KLLHBJ2G7UC",
        secretAccessKey: "doCg2gc1yEY4rPkMSE+hmlx7oXF8DrXr1tmKeG7YJ58"
      }
    });

    $scope.paidStatusList = [
      { value: "PAID" },
      { value: "PARTIALLY PAY" },
      { value: "UNPAY" }
    ];
    $scope.shopInvoicingOptions = [
      { id: null, label: "All" },
      { id: true, label: "YES" },
      { id: false, label: "NO" }
    ];

    $scope.zoomInMode = false;
    $scope.myImageStyle = {};
    var keySections = {
      info: [
        "index",
        "check",
        "shopcode",
        "shopname",
        "onrate",
        "partnername",
        "receipts",
        "action"
      ],
      daily: [
        "cafedart",
        "snooker",
        "monthly_snooker",
        "pshare",
        "apshare",
        "pw",
        "apw",
        "rewards",
        "netgaming",
        "net_collect",
        "total_payment_gateway",
        "total_pg_out",
        "d_ewallet",
        "tng_pin_charge",
        "d_cc",
        "sales",
        "serverpr",
        "claim",
        "total"
      ],
      other: ["localPaidStatus", "pdate", "agentid"],
      monthly: [
        "last_monthly_snooker",
        "monthly_pwin",
        "monthly_snooker",
        "monthly_bonus_win",
        "monthly_netgaming",
        "monthly_net_collect",
        "total_monthly_payment_gateway",
        "total_monthly_pg_out",
        "monthly_d_ewallet",
        "monthly_tng_pin_charge",
        "monthly_d_cc",
        "monthly_sales",
        "monthly_serverpr",
        "monthly_claim",
        "monthly_total",
        "last_monthly_sales"
      ]
    };

    $scope.columnList = [
      // info
      { key: "shopcode", title: "Shop Code" },
      { key: "shopname", title: "Shop Name" },
      { key: "onrate", title: "Shop Rate" },
      { key: "partnername", title: "Partner" },
      { key: "receipts", title: "Receipts" },

      // daily
      { key: "cafedart", title: "Daily Cafe & Dart" },
      { key: "snooker", title: "Daily Snooker" },
      { key: "monthly_snooker", title: "Monthly Snooker" },
      { key: "pw", title: "Daily PW" },
      { key: "apw", title: "Daily AP PW" },
      { key: "pshare", title: "Daily PShare" },
      { key: "apshare", title: "Daily AP PShare" },
      { key: "rewards", title: "Rewards" },
      { key: "netgaming", title: "Daily NG" },
      { key: "net_collect", title: "Daily Cash Collect" },
      { key: "total_payment_gateway", title: "Daily Bank In" },
      { key: "total_pg_out", title: "Daily Bank Out" },
      { key: "d_ewallet", title: "Daily D.Ewallet" },
      { key: "tng_pin_charge", title: "Daily TNG pin" },
      { key: "d_cc", title: "Daily D.CC" },
      { key: "sales", title: "Daily Sales" },
      { key: "serverpr", title: "Daily Server" },
      { key: "claim", title: "Daily Claim" },
      { key: "total", title: "Daily Total" },

      // toher
      { key: "localPaidStatus", title: "Paid Status" },
      { key: "pdate", title: "Paid Date" },
      { key: "agentid", title: "Agent" },

      // monthly
      { key: "last_monthly_snooker", title: "Last Monthly Snooker" },
      { key: "monthly_pwin", title: "Monthly PW" },
      { key: "monthly_apwin", title: "Monthly AP Win" },
      { key: "monthly_bonus_win", title: "Monthly B.Wins" },
      { key: "monthly_netgaming", title: "Monthly NG" },
      { key: "monthly_net_collect", title: "Monthly Cash Collect" },
      { key: "total_monthly_payment_gateway", title: "Monthly Bank In" },
      { key: "total_monthly_pg_out", title: "Monthly Bank Out" },
      { key: "monthly_d_ewallet", title: "Monthly D.Ewallet" },
      { key: "monthly_tng_pin_charge", title: "Monthly TNG Pin" },
      { key: "monthly_d_cc", title: "Monthly D.CC" },
      { key: "monthly_sales", title: "Monthly Sales" },
      { key: "monthly_serverpr", title: "Monthly Server" },
      { key: "monthly_claim", title: "Monthly Claim" },
      { key: "monthly_total", title: "Monthly Total" },
      { key: "last_monthly_sales", title: "Last Monthly Sales" }
    ];
    $scope.colspanSection = {
      info: 8,
      daily: 20,
      other: 3,
      monthly: 17,
      total: 44
    };
    $scope.triggerManuallyHeader = true;

    $scope.isAdmin = false;
    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteInvoice(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.loading = {
      generateInvoiceReceipt: false,
      searching: false
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.total = {};
    $scope.rate = {
      earn: 0,
      charge: 0,
      pr: 0
    };
    // $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];
    $scope.paidFilter = [
      {
        value: "PAID"
      },
      {
        value: "UNPAID"
      }
    ];
    $scope.showByDateOpt = [
      {
        value: "YES"
      },
      {
        value: "NO"
      }
    ];

    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      date: moment().subtract(1, "day").startOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null
      }
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType
        }
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5"
        },
        {
          value: "100%"
        }
      ];
    }

    $scope.billChecker = {
      checkAll: false
    };

    //get zone table data
    // $scope.zoneselection = -99;

    $scope.allowToViewShopCategory =
      $rootScope.userData.credentials.role === 1 ||
      $rootScope.userData.credentials.role === 5;
    $scope.shopCategory = [];
    $scope.initManageShopCategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.shopCategory = result;
      };
      obj.onFailure = function (err) {};
      shopCategoryService.getShopCategory(obj);
    };

    if ($scope.allowToViewShopCategory) {
      $scope.initManageShopCategory();
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index]
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        $scope.init();
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.manageUsersList = [];
    $scope.initManageUsers = function () {
      if ($rootScope.userData.roleId === 7) {
        console.log("Inside initManageOfficers");
        console.log("$rootScope.userData.id", $rootScope.userData.id);

        var obj = {};
        obj.params = {};
        obj.params.headid = $rootScope.userData.id;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageOfficers");
          console.log(result);

          if (result.length > 0) {
            var userIDs = [];
            for (var index = 0; index < result.length; index++) {
              if (result[index].staffid != null) {
                var user = result[index].staffid;
                userIDs.push(user);
              }
            }
            console.log("userIDs", userIDs);

            var obj = {};
            obj.params = {};
            obj.params.userIDs = userIDs;

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS initManageRolemappings");
              console.log(result);
              $scope.manageUsersList = result;
              console.log($scope.manageCollectorsList);
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure initManageRolemappings");
              console.log(err);
            };
            userService.getUsersFromList(obj);
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure initManageRolemappings");
          console.log(err);
        };
        assigncollectorService.getCollectormaps(obj);
      } else if (
        $rootScope.userData.roleId === 5 &&
        typeof $rootScope.userData.credentials.collectormap !== "undefined"
      ) {
        var obj = {
          params: {
            zoneid: null
          }
        };
        // if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        //   obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        // }
        obj.onSuccess = function (result) {
          $scope.manageUsersList = result
            .filter(function (collector) {
              if (!collector.user) {
                return false;
              }
              return $rootScope.userData.credentials.collectormap.includes(
                collector.id
              );
            })
            .map(function (collector) {
              return collector.user;
            });
        };
        collectorService.getCollector(obj);
      } else {
        var obj = {};
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsersList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUsersCSyncVIP(obj);
      }
    };
    $scope.initManageUsers();

    $scope.initManageInvoice = function () {
      $scope.isEdit = false;
    };

    $scope.onColumnToolbarChange = function (columnList) {
      $scope.hideTableColumns = {};
      $scope.triggerManuallyHeader = false;

      columnList.excluded.forEach(function (key) {
        $scope.hideTableColumns[key] = true;
      });

      $scope.colspanSection = {
        info: keySections.info.filter(function (k) {
          return !columnList.excluded.includes(k);
        }).length,
        daily: keySections.daily.filter(function (k) {
          return !columnList.excluded.includes(k);
        }).length,
        other: keySections.other.filter(function (k) {
          return !columnList.excluded.includes(k);
        }).length,
        monthly: keySections.monthly.filter(function (k) {
          return !columnList.excluded.includes(k);
        }).length
      };

      setTimeout(function () {
        $scope.triggerManuallyHeader = true;
      }, 10);
    };

    $scope.manageDailyinvoices = {};
    $scope.manageDailyinvoicesList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter = {
      upload: $scope.dateList.date,
      showByDate: { value: "NO" },
      allowInvocing: { id: null }
    };
    $scope.managePaidInvoicesList = [];

    $scope.searchAllinvoices = function (reportFilter) {
      console.log("Inside searchAllinvoices");
      console.log("reportFilter", reportFilter);

      var obj = {};
      obj.params = {};
      obj.params.ispaid = reportFilter.ispaid
        ? reportFilter.ispaid.value
        : null;
      obj.params.agentid = reportFilter.agent ? reportFilter.agent.id : null;
      obj.params.adate = moment(reportFilter.upload, "DD-MM-YYYY")
        .startOf("day")
        .format("YYYY-M-D");
      obj.params.categoryid = reportFilter.categoryid
        ? reportFilter.categoryid.id
        : null;

      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone
          ? "('" + reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        }
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype
          ? reportFilter.shoptype.value
          : null;
      }

      if (reportFilter.state) {
        obj.params.stateid = reportFilter.state.id;
      }

      if (
        reportFilter.allowInvocing &&
        reportFilter.allowInvocing.id !== null
      ) {
        obj.params.allowInvocing =
          reportFilter.allowInvocing && reportFilter.allowInvocing.id
            ? true
            : false;
      }

      obj.onSuccess = function (result) {
        console.log("Inside getAllZoneSales SUCCESS");
        $scope.billChecker = { checkAll: false };

        var dataOfShop = {};
        var indate = moment(reportFilter.upload, "DD-MM-YYYY")
          .utcOffset(8)
          .startOf("day");

        result.result.forEach(function (res) {
          var parseInDate = moment(res.indate).utcOffset(8).startOf("day");
          var isToday = parseInDate.diff(indate) === 0;

          if (dataOfShop[res.shopid] && !isToday) {
            return;
          }

          res.receipts = [];
          res.isToday = !!isToday;

          var hasMatch = dataOfShop[res.shopid];
          if (isToday) {
            if (res.algorithm === "NP") {
              res.net_collect =
                (hasMatch ? Number(hasMatch.net_collect || 0) : 0) +
                Number(res.net_collect || 0).toFixed(2);
            } else {
              res.net_collect =
                (hasMatch ? Number(hasMatch.net_collect || 0) : 0) +
                Number(res.net_collect || 0);
            }

            res.tng_pin_charge =
              (hasMatch ? Number(hasMatch.tng_pin_charge || 0) : 0) +
              Number(res.tng_pin_charge || 0);
            res.snooker =
              (hasMatch ? Number(hasMatch.snooker || 0) : 0) +
              Number(res.snooker || 0);
            res.cafeanddarts =
              (hasMatch ? Number(hasMatch.cafeanddarts || 0) : 0) +
              Number(res.cafeanddarts || 0);
            res.pwin =
              (hasMatch ? Number(hasMatch.pwin || 0) : 0) +
              Number(res.pwin || 0);
            res.apwin =
              (hasMatch ? Number(hasMatch.apwin || 0) : 0) +
              Number(res.apwin || 0);
            res.bonus_win =
              (hasMatch ? Number(hasMatch.bonus_win || 0) : 0) +
              Number(res.bonus_win || 0);
            res.rewards =
              (hasMatch ? Number(hasMatch.rewards || 0) : 0) +
              Number(res.rewards || 0);
            res.apshare =
              (hasMatch ? Number(hasMatch.apshare || 0) : 0) +
              Number(res.apshare || 0);
            res.netgaming =
              (hasMatch ? Number(hasMatch.netgaming || 0) : 0) +
              Number(res.netgaming || 0);
            res.serverpr =
              (hasMatch ? Number(hasMatch.serverpr || 0) : 0) +
              Number(res.serverpr || 0);
            res.claim =
              (hasMatch ? Number(hasMatch.claim || 0) : 0) +
              Number(res.claim || 0);
            res.payment_gateway =
              (hasMatch ? Number(hasMatch.payment_gateway || 0) : 0) +
              Number(res.payment_gateway || 0);
            res.pe_payment_gateway =
              (hasMatch ? Number(hasMatch.pe_payment_gateway || 0) : 0) +
              Number(res.pe_payment_gateway || 0);
            res.zpay_bank_in =
              (hasMatch ? Number(hasMatch.zpay_bank_in || 0) : 0) +
              Number(res.zpay_bank_in || 0);
            res.zpay_qr_in =
              (hasMatch ? Number(hasMatch.zpay_qr_in || 0) : 0) +
              Number(res.zpay_qr_in || 0);
            res.dgpay_bank_in =
              (hasMatch ? Number(hasMatch.dgpay_bank_in || 0) : 0) +
              Number(res.dgpay_bank_in || 0);
            res.telco =
              (hasMatch && hasMatch.shoptype === "100%"
                ? Number(hasMatch.telco || 0)
                : 0) + Number(res.telco || 0);
            res.crypto =
              (hasMatch && hasMatch.shoptype === "100%"
                ? Number(hasMatch.crypto || 0)
                : 0) + Number(res.crypto || 0);
            res.pg_out =
              (hasMatch ? Number(hasMatch.pg_out || 0) : 0) +
              Number(res.pg_out || 0);
            res.pe_pgout =
              (hasMatch ? Number(hasMatch.pe_pgout || 0) : 0) +
              Number(res.pe_pgout || 0);
            res.dgpay_w_bank_out =
              (hasMatch ? Number(hasMatch.dgpay_w_bank_out || 0) : 0) +
              Number(res.dgpay_w_bank_out || 0);
            res.d_ewallet =
              (hasMatch ? Number(hasMatch.d_ewallet || 0) : 0) +
              Number(res.d_ewallet || 0);
            res.total_payment_gateway =
              (hasMatch ? Number(hasMatch.total_payment_gateway || 0) : 0) +
              Number(res.total_payment_gateway);
            res.total_pg_out =
              (hasMatch ? Number(hasMatch.total_pg_out || 0) : 0) +
              Number(res.total_pg_out || 0);
          } else {
            res.mcsales = "0.00";
            res.net_collect = 0;
            res.payment_gateway = 0;
            res.pg_out = 0;
            res.pe_payment_gateway = 0;
            res.pe_pgout = 0;
            res.total_payment_gateway = 0;
            res.total_pg_out = 0;
            res.ocsales = "0.00";
            res.serverpr = 0;
            res.d_ewallet = 0;
            res.snooker = 0;
            res.cafeanddarts = 0;
            res.netgaming = 0;
            res.tng_pin_charge = 0;
            res.tng_pin = 0;
            res.vpay_tng_pin = 0;
            res.dgpay_w_bank_out = 0;
            res.crypto = 0;
            res.telco = 0;
            res.dgpay_bank_in = 0;
            res.zpay_qr_in = 0;
            res.zpay_bank_in = 0;
            res.claim = 0;
            res.bonus_win = 0;
            res.rewards = 0;
            res.pwin = 0;
            res.apwin = 0;
            res.apshare = 0;
          }

          dataOfShop[res.shopid] = res;
        });

        $scope.manageDailyinvoicesList = Object.keys(dataOfShop)
          .map(function (key) {
            return dataOfShop[key];
          })
          .filter(function (data) {
            return reportFilter.showByDate &&
              reportFilter.showByDate.value === "YES"
              ? data.isToday
              : true;
          });
        console.log(
          "$scope.manageDailyinvoicesList",
          $scope.manageDailyinvoicesList
        );
        $scope.totalSalesLabelFooter = 0;
        $scope.mSalesTotal = 0;
        $scope.oSalesTotal = 0;
        if ($scope.manageDailyinvoicesList) {
          for (
            var index = 0;
            index < $scope.manageDailyinvoicesList.length;
            index++
          ) {
            $scope.manageDailyinvoicesList[index].totalsales =
              parseFloat($scope.manageDailyinvoicesList[index].mcsales) +
              parseFloat($scope.manageDailyinvoicesList[index].net_collect);
            $scope.totalSalesLabelFooter =
              $scope.totalSalesLabelFooter +
              parseFloat($scope.manageDailyinvoicesList[index].totalsales);
            $scope.mSalesTotal =
              $scope.mSalesTotal +
              parseFloat($scope.manageDailyinvoicesList[index].mactotal);
            $scope.oSalesTotal =
              $scope.oSalesTotal +
              parseFloat($scope.manageDailyinvoicesList[index].net_collect);
          }
        }

        $scope.loading.searching = false;

        $scope.getInvoicePaid();
      };
      obj.onFailure = function (err) {
        console.log("Inside getAllZoneSales Failure");
        console.log(err);
        $scope.loading.searching = false;
      };

      $scope.loading.searching = true;
      dailyInvoiceService.getDailyInvoiceWithSales(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/invoices/dailyinvoices/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteInvoice = function (res) {
      console.log("Inside deleteInvoice");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Invoice has been deleted successfully!", "SUCCESS");
          //$scope.initManageStates();
          $scope.initManageInvoice();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyInvoiceService.deleteInvoice(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.viewInvoice = function (manageDailyinvoices) {
      $scope.isEdit = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      console.log("viewinvoice", $scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices);
    };

    $scope.saveInvoice = function (id) {
      var obj = {};
      obj.params = {};
      obj.params.machineshorts = $scope.manageDailyinvoices.machineshorts;
      obj.params.onlineshorts = $scope.manageDailyinvoices.onlineshorts;
      obj.params.id = id;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageDailyinvoices = result;
        toastr.success("Invoice has been updated successfully!", "SUCCESS");
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      dailyInvoiceService.saveInvoice(obj);
    };

    $scope.wanziList = [];
    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.wanziList = [];

        result.forEach(function (r) {
          if ((r.wanzi && r.wanzi > 0) || r.wanzi_remarks) {
            $scope.wanziList.push(r);
          }
        });

        $scope.onlineInvoiceDetails = {
          NG: result
            .filter(function (r) {
              return r.algorithm === "NG";
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.skl_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              return r;
            }),
          NP: result
            .filter(function (r) {
              return r.algorithm === "NP" || r.algorithm === null;
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.skl_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              return r;
            })
        };

        console.log("onlineInvoiceDetails", $scope.onlineInvoiceDetails);

        // set shop
        $scope.shopInvoiceDetails = result.length > 0 && result[0].shop;

        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        $scope.total.NP_csales_total = 0;
        $scope.total.NP_totalsales = 0;

        var selected =
          $scope.onlineInvoiceDetails.NP[0] ||
          $scope.onlineInvoiceDetails.NG[0];

        if (selected) {
          var onlineshop = selected.shop.onlineshop.find(function (os) {
            return os.playtechid === selected.playtechid;
          });
          var earn = selected.onrate
            ? selected.onrate
            : selected.playtechid === "WK8S6" && selected.shop.id === 1019
              ? 35
              : 0;
          var charge = Number(selected.server_fee_rate);
          var pr =
            selected.shop.shoptype === "20%PR"
              ? Number(selected.pr_fee_rate)
              : earn - charge;

          // if (
          //   moment(selected.indate, "YYYY-MM-DD")
          //     .utcOffset(8)
          //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
          //   selected.shop.zoneid === 83
          // ) {
          //   pr = Number(selected.pr_fee_rate);
          // }

          $scope.rate = {
            earn: earn,
            charge: charge,
            pr: pr
          };
        }

        $scope.total.NP_csales_total = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.csales);
          },
          0
        );

        $scope.total.NG_net_collect = $scope.onlineInvoiceDetails.NG.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_net_collect = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_totalsales = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.totalsales);
          },
          0
        );

        // if ($scope.onlineInvoiceDetails.length > 0) {
        //   for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
        //     $scope.total.online += parseFloat($scope.onlineInvoiceDetails[i].csales);
        //   }
        //   $scope.total.net_collect += parseFloat($scope.manageDailyinvoices.net_collect);
        // }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };
    $scope.ddmmyyyy = function (date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? "" : "0") + dd,
        (mm > 9 ? "" : "0") + mm,
        date.getFullYear()
      ].join("");
    };
    $scope.getMachineSales = function (manageDailyinvoices) {
      var obj = {};
      obj.params = {};
      // if (manageDailyinvoices.shop.shoptype==="100%"){
      //   var date = new Date(manageDailyinvoices.indate);
      //   var d = $scope.ddmmyyyy(date);
      //   var tempikey = manageDailyinvoices.shop.id+''+d
      //   console.log('tempikey',tempikey);
      //   obj.params.ikey = tempikey;
      // }else{
      //   obj.params.ikey = manageDailyinvoices.ikey;
      // }
      obj.params.ikey = manageDailyinvoices.ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }
        $scope.total.machine = 0;
        $scope.total.machineST = 0;
        var machine = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          $scope.total.machine = machine;
          $scope.total.machineST =
            machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };
    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageDailyinvoices) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageDailyinvoices.shop && $scope.managePartnerList.length) {
        console.log($scope.manageDailyinvoices);
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.manageDailyinvoices.shop.partnerid
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.saveShorts = function () {
      console.log($scope.manageDailyinvoices.machineshorts);
      console.log($scope.total.machineST);

      console.log($scope.manageDailyinvoices.onlineshorts);
      console.log($scope.total.onlineST);
      $scope.saveInvoice($scope.manageDailyinvoices.id);
      //$scope.total.machineST = $scope.total.machine + parseFloat($scope.manageDailyinvoices.machineshorts);
      //console.log($scope.total.machineST);
      $scope.initManageInvoice();
      $scope.manageDailyinvoices = {};
    };

    $scope.print = function () {
      window.print();
    };

    $scope.showUserById = function (userid) {
      if (userid && $scope.manageUsersList.length) {
        var selected = $filter("filter")(
          $scope.manageUsersList,
          {
            id: userid
          },
          true
        );
        if (selected.length)
          return selected.length
            ? selected[0].credentials.name
              ? selected[0].credentials.name
              : selected[0].credentials.firstName +
                " " +
                selected[0].credentials.lastName
            : "";

        // selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return "";
    };

    //Group Totals
    $scope.getCsales = function (item) {
      return item.algorithm === "NP"
        ? Number(item.csales)
        : Number(item.csales) -
            Number(item.apshare) -
            Number(item.pshare) -
            Number(item.p_bonus_bets) +
            Number(item.pwin) +
            Number(item.apwin) +
            Number(item.bonus_win);
    };
    $scope.getTotalDEwallet = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.d_ewallet;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalDCC = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.d_cc;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalmcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.mcsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalocsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.ocsales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };

    $scope.getTotalTotalServerSales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (acc, curr) {
          return acc + $scope.getServerSales(curr);
        }, 0);
      }
    };
    $scope.getTotaltotalsales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (acc, curr) {
          return acc + parseFloat($scope.getSales(curr));
        }, 0);
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.psales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items.length > 0) {
        return items
          .map(function (x) {
            return x.csales;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalNetCollect = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.net_collect);
        }, 0);
      }
    };
    $scope.getTotalCafeAndDarts = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.cafeanddarts);
        }, 0);
      }
    };
    $scope.getTotalSnooker = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.snooker);
        }, 0);
      }
    };

    $scope.getTotalPWin = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.pwin);
        }, 0);
      }
    };
    $scope.getTotalAPWin = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.apwin);
        }, 0);
      }
    };
    $scope.getTotalPShare = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.pshare);
        }, 0);
      }
    };
    $scope.getTotalRewards = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.rewards);
        }, 0);
      }
    };
    $scope.getTotalAPShare = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.apshare);
        }, 0);
      }
    };
    $scope.getTotalNetGaming = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.netgaming);
        }, 0);
      }
    };
    $scope.getTotalBank = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.total_payment_gateway);
        }, 0);
      }
    };
    $scope.getTotalBankOut = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.total_pg_out);
        }, 0);
      }
    };
    $scope.getTotalMOnthlySales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat($scope.getMonthlySales(b));
        }, 0);
      }
    };
    $scope.getTotalMonthlySnooker = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.monthly_snooker);
        }, 0);
      }
    };
    $scope.getLastTotalMOnthlySales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat($scope.getLastMonthlySales(b));
        }, 0);
      }
    };

    $scope.getMonthlyTotalServersales = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat($scope.getMonthlyServerSales(b));
        }, 0);
      }
    };
    $scope.getTotaTngPin = function (items) {
      if (items.length > 0) {
        return items.reduce(function (a, b) {
          return a + parseFloat(b.tng_pin_charge);
        }, 0);
      }
    };

    $scope.getSales = function (items) {
      if (!items.isToday) {
        return 0;
      }

      return items.shoptype === "100%"
        ? Number(items.net_collect) +
            Number(items.total_payment_gateway) -
            Number(items.total_pg_out) +
            Number(items.d_ewallet) +
            Number(items.tng_pin_charge)
        : items.ocsales;
    };

    $scope.getServerSales = function (items) {
      return parseFloat($scope.getSales(items)) - parseFloat(items.serverpr);
    };

    $scope.getMonthlyServerSales = function (item) {
      return $scope.getMonthlySales(item) - item.monthly_serverpr;
    };

    $scope.getLastMonthlySales = function (item) {
      return item.shoptype === "100%"
        ? Number(item.last_monthly_net_collect) +
            Number(item.last_total_monthly_payment_gateway) -
            Number(item.last_total_monthly_pg_out) +
            Number(item.last_monthly_d_ewallet) +
            Number(item.last_monthly_tng_pin_charge)
        : item.last_monthly_ocsales;
    };

    $scope.getMonthlySales = function (item) {
      return item.shoptype === "100%"
        ? Number(item.monthly_net_collect) +
            Number(item.total_monthly_payment_gateway) -
            Number(item.total_monthly_pg_out) +
            Number(item.monthly_d_ewallet) +
            Number(item.monthly_tng_pin_charge)
        : item.monthly_ocsales;
    };

    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log("receiptid", receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.viewReceipts = JSON.parse(result[0].content);
          console.log($scope.imageString);
          //$scope.open('app/pages/invoices/dailyinvoices/modals/receiptModal.html');
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);
    };

    $scope.init = function () {
      $scope.isAdmin =
        [1, 5].includes($rootScope.userData.roleId) ||
        ($rootScope.userData.roleId === 20 &&
          $rootScope.userData.credentials.partner.isparent);
      if ($state.params.zoneid || $state.params.shoptype) {
        $scope.reportFilter.zone = $scope.manageZonesList.find(function (zone) {
          return zone.id == $state.params.zoneid;
        });
        $scope.reportFilter.shoptype = {
          value: $state.params.shoptype
        };

        $scope.searchAllinvoices($scope.reportFilter);
      }
    };
    $scope.getFinalTotalPR = function () {
      return $scope.getFinalTotalEarn() - $scope.getFinalTotalCharge();
    };

    $scope.getFinalTotalCharge = function () {
      return $scope.getsubTotalCharge() + $scope.getTotalEarnCharge();
    };

    $scope.getFinalTotalEarn = function () {
      return $scope.getsubTotalEarn() + $scope.getTotalEarnCharge();
    };

    $scope.getTotalEarnCharge = function () {
      return (
        -$scope.getTotalGameOf("total_payment_gateway") -
        $scope.getTotalGameOf("d_ewallet") -
        $scope.getTotalGameOf("telco") -
        $scope.getTotalGameOf("crypto") +
        $scope.getTotalGameOf("tng_pin_charge") -
        $scope.getTotalGameOf("tng_pin") +
        $scope.getTotalGameOf("total_pg_out") +
        $scope.getTotalGameOf("pg_charge") +
        $scope.getTotalGameOf("pg_out_charge") +
        $scope.getTotalGameOf("d_ewallet_charge")
      );
    };

    $scope.getPGInRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_rate;
        });

      return (rate.pg_rate || 0) + "%";
    };

    $scope.getPGOutRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_out_rate;
        });

      return (rate.pg_out_rate || 0) + "%";
    };

    $scope.getEwalletRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.d_ewallet_rate;
        });

      return (rate.d_ewallet_rate || 0) + "%";
    };

    $scope.getTngPinRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.tng_pin_rate;
        });

      return (rate.tng_pin_rate || 0) + "%";
    };

    $scope.parseToNegativeList = function (key) {
      var value = $scope.getTotalGameOf(key);
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.parseToNegative = function (value) {
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.getPRGameEarnSubtotal = function (item, type) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return item.pr_fee;
      // }

      if (type === "NP") {
        return $scope.getTotalNpEarn(item) - $scope.getTotalNpCharge(item);
      }
      return $scope.getTotalNgEarn(item) - $scope.getTotalNgCharge(item);
    };

    $scope.getTotalGame = function (tableData, type) {
      return (
        $scope.getTotalGameEarn(tableData, type) -
        $scope.getTotalGameCharge(tableData, type)
      );
    };

    $scope.getTotalGameEarn = function (item, type) {
      var isPR = item.shop.shoptype === "20%PR";
      if (isPR) {
        return (
          $scope.getTotalPRCharge(item) + $scope.getTotalGameCharge(item, "NG")
        );
      }

      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });
      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return (subtotal * rate) / 100;
    };

    $scope.getTotalGameCharge = function (item, type) {
      var prcompany = Number(item.server_fee_rate);
      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      return (subtotal * prcompany) / 100;
    };

    $scope.getTotalPRCharge = function (item) {
      if (item.shop.shoptype !== "20%PR") {
        return 0;
      }

      return (
        ($scope.getFullTotal(item, item.shop.shoptype) *
          Number($scope.rate.pr)) /
        100
      );
    };

    $scope.getTotalGameName = function (item) {
      return "TOTAL " + item.game.name;
    };

    $scope.getGameName = function (item) {
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });
      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return rate + "%" + " " + item.game.name;
    };

    $scope.getFullGameName = function (item, type) {
      var gameType = type === "NP" ? "Net Purchase" : "Net Gaming";
      return "100%" + " " + gameType + " - " + item.game.name;
    };

    $scope.getItemGameName = function (item) {
      return item.game & item.game.name ? item.game.name : "";
    };

    $scope.getsubTotalEarn = function () {
      var totalNpEarn = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);
          var onlineshop = item.shop.onlineshop.find(function (os) {
            return os.playtechid === item.playtechid;
          });
          var rate = item.onrate
            ? item.onrate
            : item.playtechid === "WK8S6" && item.shop.id === 1019
              ? 35
              : 0;

          var npEarn =
            (subtotal * rate) / 100 +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);
          totalNpEarn += npEarn;
        });
      }

      var totalNGEarn = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGEarn += $scope.getTotalNgEarn(item);
        });
      }

      return totalNpEarn + totalNGEarn;
    };

    $scope.getsubTotalCharge = function () {
      var totalNpCharge = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var prcompany = Number(item.server_fee_rate);
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);
          var npcharge = (subtotal * prcompany) / 100;

          totalNpCharge +=
            npcharge +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);
        });
      }

      var totalNGCharge = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGCharge += $scope.getTotalNgCharge(item);
        });
      }

      return totalNpCharge + totalNGCharge;
    };

    $scope.getsubTotalNP = function (item) {
      return (
        $scope.getFullTotal(item, "NP") -
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.pwin) +
        Number(item.apwin) +
        Number(item.total_payment_gateway) -
        Number(item.total_pg_out) +
        Number(item.d_ewallet)
      );
    };

    $scope.getTotalNpEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }

      return (
        $scope.getTotalGameEarn(item, "NP") +
        Number(item.pshare) -
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNpCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NP") +
        Number(item.pshare) +
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNgCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) -
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    $scope.getTotalNgEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }

      return (
        $scope.getTotalGameEarn(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) -
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    // type: NP | NG
    $scope.getFullTotal = function (item, type) {
      var field =
        type === "NP"
          ? "netpurchase"
          : type === "20%PR"
            ? "totalsales"
            : "netgaming";
      return Number(item[field]) || 0;
    };

    $scope.getTotalGameOf = function (key) {
      return []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .filter(function (tdata) {
          return !!tdata[key];
        })
        .reduce(function (total, current) {
          return (total += current[key] ? Number(current[key]) : 0);
        }, 0);
    };

    $scope.onCheckBoxChange = function (invoiceId, currentInvocies) {
      if (invoiceId) {
        $scope.billChecker[invoiceId] = !$scope.billChecker[invoiceId];

        var hasItemUncheck = $scope.manageDailyinvoicesList.find(
          function (invoice) {
            return !$scope.billChecker[invoice.id];
          }
        );

        $scope.billChecker.checkAll = !hasItemUncheck;
      } else {
        $scope.manageDailyinvoicesList.forEach(function (dat) {
          var match = (currentInvocies || []).find(function (inv) {
            return inv.id === dat.id;
          });
          if (!match) {
            return;
          }

          $scope.billChecker[match.id] = $scope.billChecker.checkAll;
        });
      }
    };

    $scope.getInvoicePaid = function () {
      var obj = {};
      $scope.managePaidInvoicesList = [];
      obj.params = {
        adate: moment($scope.reportFilter.upload, "DD-MM-YYYY")
          .startOf("day")
          .format("YYYY-M-D"),
        ismonthly: true
      };

      if ($scope.reportFilter.zone) {
        obj.params.zoneid = $scope.reportFilter.zone
          ? "('" + $scope.reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        }
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if ($scope.reportFilter.state) {
        obj.params.stateid = $scope.reportFilter.state.id;
      }

      obj.onSuccess = function (result) {
        $scope.managePaidInvoicesList = result;

        $scope.manageDailyinvoicesList = $scope.manageDailyinvoicesList.map(
          function (invoice) {
            invoice.receipts = [];
            var hasPaidInovice = $scope.managePaidInvoicesList.filter(
              function (res) {
                return res.invoiceid === invoice.id;
              }
            );

            var totalPaid = hasPaidInovice.reduce(function (total, curr) {
              return (total += Number(curr.amount));
            }, 0);
            var localPaidStatus = !hasPaidInovice.length
              ? "UNPAY"
              : totalPaid >= invoice.net_collect ||
                  Math.abs(totalPaid - invoice.net_collect) < 0.1
                ? "PAID"
                : "PARTIALLY PAY";

            return Object.assign(invoice, {
              receipts: hasPaidInovice,
              localPaidStatus: localPaidStatus
            });
          }
        );
      };

      invoiceReceiptService.getInvoicePaid(obj);
    };
    $scope.paidSelectedInvoices = function (targetInvoice) {
      var selectedInovices = $scope.manageDailyinvoicesList.filter(
        function (invoice) {
          return targetInvoice
            ? invoice.id === targetInvoice.id
            : $scope.billChecker[invoice.id] === true;
        }
      );

      if (!selectedInovices.length) {
        toastr.error("No invoice is selected", "ERROR");
        return;
      }

      $scope.openPaidInvoiceModal(null, selectedInovices);
    };

    $scope.openPaidInvoiceModal = function (receiptid, invoices) {
      $scope.selectedInvoicesToPaid = {};

      var selectedPaidInvoices = [];
      var selectedReceipt = {};

      if (receiptid) {
        var hasReceipts = $scope.managePaidInvoicesList.filter(
          function (receipt) {
            return (
              receipt.invoicereceiptid && receipt.invoicereceiptid === receiptid
            );
          }
        );

        if (!hasReceipts.length) {
          toastr.warning("Error", "Receipt not found");
          return;
        }

        hasReceipts.forEach(function (paidInv) {
          var myInovice = $scope.manageDailyinvoicesList.find(
            function (invoice) {
              return invoice.id === paidInv.invoiceid;
            }
          );

          if (!myInovice) {
            return;
          }

          selectedPaidInvoices.push({
            photoURL: paidInv.photos,
            paidAmount: Number(Number(paidInv.amount).toFixed(2)),
            id: paidInv.id,
            invoice: myInovice
          });
        });

        selectedReceipt = hasReceipts[0];
      } else if (invoices.length) {
        invoices.forEach(function (invoice) {
          var paidAmount = invoice.net_collect;
          $scope.managePaidInvoicesList
            .filter(function (paidInvoice) {
              return paidInvoice.invoiceid === invoice.id;
            })
            .forEach(function (paidInv) {
              paidAmount -= Number(paidInv.amount);
            });

          selectedPaidInvoices.push({
            photoURL: [],
            paidAmount: Number(paidAmount.toFixed(2)),
            invoice: invoice
          });
        });
      }

      $scope.selectedInvoicesToPaid.id = selectedReceipt
        ? selectedReceipt.invoicereceiptid
        : null;
      $scope.selectedInvoicesToPaid.paidAt = moment(
        selectedReceipt ? selectedReceipt.paidAt : ""
      )
        .startOf("day")
        .utcOffset(8)
        .toDate();
      $scope.selectedInvoicesToPaid.orno = selectedReceipt
        ? selectedReceipt.orno
        : "";
      $scope.selectedInvoicesToPaid.description = selectedReceipt
        ? selectedReceipt.description
        : "";
      $scope.selectedInvoicesToPaid.receivedBy = "";
      $scope.selectedInvoicesToPaid.invoices = selectedPaidInvoices;
      $scope.selectedInvoicesToPaid.status = selectedReceipt
        ? selectedReceipt.status
        : false;

      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: "modal-scrollable",
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/paidInvoiceModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          $scope.loading.generateInvoiceReceipt = true;

          var obj = {};
          obj.params = {
            id: $scope.selectedInvoicesToPaid.id,
            paidAt: moment($scope.selectedInvoicesToPaid.paidAt)
              .startOf("day")
              .utcOffset(8)
              .toISOString(),
            description: $scope.selectedInvoicesToPaid.description
          };

          invoiceReceiptService.generateInvoiceReceipt(obj);
          obj.onSuccess = function (res) {
            // upload photo
            var promises = [];
            $scope.selectedInvoicesToPaid.invoices.forEach(
              function (paidInvoice) {
                var hasNewPhoto = paidInvoice.photoURL.filter(function (photo) {
                  return photo.buffer;
                });
                if (!hasNewPhoto.length) {
                  return;
                }

                hasNewPhoto.forEach(function (photo) {
                  promises.push({
                    id: paidInvoice.invoice.id,
                    buffer: photo.buffer,
                    filename: photo.filename
                  });
                });
              }
            );

            Promise.all(
              promises.length
                ? promises.map(function (pro) {
                    return new Promise(function (resolve) {
                      s3Client.putObject(
                        {
                          Bucket: "tswlab/" + "superman-v2",
                          Body: pro.buffer,
                          ACL: "public-read",
                          Key: pro.filename
                        },
                        function (err, res) {
                          return resolve({
                            url:
                              "https://tswlab.sgp1.cdn.digitaloceanspaces.com/superman-v2/" +
                              pro.filename,
                            id: pro.id
                          });
                        }
                      );
                    });
                  })
                : []
            ).then(function (photos) {
              var invoiceObj = {};
              invoiceObj.params = [];
              $scope.selectedInvoicesToPaid.invoices.forEach(
                function (paidInvoice) {
                  var params = {};
                  params.id = paidInvoice.id;
                  params.invoiceid = paidInvoice.invoice.id;
                  params.photos = photos.filter(function (photo) {
                    return photo.id === paidInvoice.invoice.id;
                  });

                  paidInvoice.photoURL
                    .filter(function (url) {
                      return !url.buffer;
                    })
                    .forEach(function (url) {
                      params.photos.push(url);
                    });

                  params.amount = Number(paidInvoice.paidAmount);

                  params.invoicereceiptid = res.result ? res.result.id : res.id;

                  invoiceObj.params.push(params);
                }
              );

              invoiceObj.onSuccess = function (result) {
                toastr.success(
                  "Official Receipt " +
                    (res.result ? res.result.orno : res.orno) +
                    " Generated!",
                  "SUCCESS"
                );

                $scope.getInvoicePaid();
                $scope.loading.generateInvoiceReceipt = false;
              };

              invoiceReceiptService.createInvoicePaidBulk(invoiceObj);
            });
          };
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.viewPaidReceipt = function (event, item) {
      event.stopPropagation();

      if (!item.invoicereceiptid) {
        return;
      }

      $scope.openPaidInvoiceModal(item.invoicereceiptid);
    };

    $scope.onFileChange = function (files, index) {
      if (!files.length) {
        return;
      }

      Array.from(files).forEach(function (file) {
        var reader = new FileReader();

        reader.addEventListener("load", function (result) {
          $scope.selectedInvoicesToPaid.invoices =
            $scope.selectedInvoicesToPaid.invoices.map(function (invoice, i) {
              if (i === index) {
                invoice.photoURL.unshift({
                  buffer: reader.result,
                  // file: file,
                  filename: file.name.toString().trim().replace(/ /g, ""),
                  url: window.URL.createObjectURL(file)
                });
              }

              return invoice;
            });
        });

        // reader.readAsDataURL(file);
        reader.readAsArrayBuffer(file);
      });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg"
      });
    };

    $scope.zoomInPhoto = function (event, photo) {
      if (!$scope.zoomInMode) {
        return;
      }

      var myWidth = Number(event.target.width);
      var myHeight = Number(event.target.height);

      if (!myWidth || !myHeight) {
        return;
      }

      var ratioWidth = (event.offsetX / myWidth) * 100;
      var ratioHeight = (event.offsetY / myHeight) * 100;

      $scope.myImageStyle = {
        backgroundImage: "url(" + photo + ")",
        backgroundSize: "200%",
        backgroundPosition: ratioWidth + "% " + ratioHeight + "%"
      };
    };

    $scope.toggleZoomMode = function () {
      $scope.zoomInMode = !$scope.zoomInMode;
      if (!$scope.zoomInMode) {
        $scope.myImageStyle = null;
      }
    };

    $scope.deleteImage = function (event, id, index) {
      event.stopPropagation();
      $scope.selectedInvoicesToPaid.invoices =
        $scope.selectedInvoicesToPaid.invoices.map(function (paidInovice) {
          if (paidInovice.invoice.id !== id) {
            return paidInovice;
          }

          paidInovice.photoURL = paidInovice.photoURL.filter(
            function (photo, i) {
              return i !== index;
            }
          );

          return paidInovice;
        });
    };

    $scope.getTotalPaidReceipt = function () {
      return $scope.selectedInvoicesToPaid.invoices.reduce(function (
        total,
        current
      ) {
        return (total += Number(current.paidAmount));
      }, 0);
    };
    $scope.getTotaPaidNetCollect = function () {
      return $scope.selectedInvoicesToPaid.invoices.reduce(function (
        total,
        current
      ) {
        return (total += Number(current.invoice.net_collect));
      }, 0);
    };

    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.onAfterChange = function () {
      $scope.myImageStyle = {};
      $scope.zoomInMode = false;

      $scope.$apply();
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.dailyinvoices")
    .service("invoiceReceiptService", invoiceReceiptService);

  /** @ngInject */
  function invoiceReceiptService(InvoiceReceipt, InvoicePaid) {
    var generateInvoiceReceipt = function (obj) {
      if (obj.params.id) {
        InvoiceReceipt.prototype$patchAttributes({
          id: obj.params.id,
          paidAt: moment(obj.params.paidAt).utcOffset(8).toISOString(),
          description: obj.params.description,
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {}
        );
      } else {
        InvoiceReceipt.generate({
          paidAt: moment(obj.params.paidAt).utcOffset(8).toISOString(),
          description: obj.params.description,
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {}
        );
      }
    };

    var createInvoicePaidBulk = function (obj) {
      var isUdpate = !!obj.params[0].id;
      var request = [];

      if (isUdpate) {
        obj.params.forEach(function (param) {
          request.push(
            InvoicePaid.prototype$patchAttributes({
              id: param.id,
              amount: param.amount,
              photos: param.photos,
              lastupdated: new Date(),
            }).$promise
          );
        });
      } else {
        request.push(
          InvoicePaid.createMany(
            obj.params.map(function (param) {
              param.created = new Date();
              param.lastupdated = new Date();
              return param;
            })
          ).$promise
        );
      }

      Promise.all(request).then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {}
      );
    };

    var getInvoicePaid = function (obj) {
      var from = obj.params.adate ? obj.params.adate : null;
      var to = obj.params.bdate ? obj.params.bdate : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();

      InvoicePaid.getPaidInvoicByDate({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        stateid: obj.params.stateid,
        ismonthly: !!obj.params.ismonthly,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data.result || []);
        },
        function (err) {}
      );
    };

    var getInvoiceReceipts = function (obj) {
      var from = obj.params.adate ? obj.params.adate : null;
      var to = obj.params.bdate ? obj.params.bdate : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();

      InvoiceReceipt.getAllByDate({
        adate: date1,
        bdate: date2,
        zoneid: obj.params.zoneid,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data.result || []);
        },
        function (err) {}
      );
    };

    var getInvoiceReceiptById = function (obj) {
      InvoicePaid.getInvoiceReceiptById({
        receiptid: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };
    var saveInvoiceReceipt = function (obj) {
      InvoiceReceipt.prototype$patchAttributes({
        id: obj.params.id,
        status: obj.params.status,
        approveby: obj.params.approveby,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteInvReceipt = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      InvoiceReceipt.prototype$patchAttributes({
        id: obj.params.id,
        deletedAt: moment().utcOffset(8).toISOString(),
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      generateInvoiceReceipt: generateInvoiceReceipt,
      createInvoicePaidBulk: createInvoicePaidBulk,
      getInvoicePaid: getInvoicePaid,
      getInvoiceReceipts: getInvoiceReceipts,
      getInvoiceReceiptById: getInvoiceReceiptById,
      saveInvoiceReceipt: saveInvoiceReceipt,
      deleteInvReceipt: deleteInvReceipt,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.dailyinvoices")
    .service("dailyInvoiceService", dailyInvoiceService);

  /** @ngInject */
  function dailyInvoiceService(Invoice) {
    var getInvoice = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.find({
        filter: {
          where: {
            indate: { gte: dailyDate },
          },
          include: ["shop"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDailyInvoiceWithSales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.getDailyInvoiceWithSales({
        adate: obj.params.adate || dailyDate,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid ? obj.params.agentid : null,
        ispaid: obj.params.ispaid ? obj.params.ispaid : null,
        stateid: obj.params.stateid,
        categoryid: obj.params.categoryid,
        allowInvocing: obj.params.allowInvocing,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getInvoiceByZone = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Invoice.find({
        filter: {
          where: {
            and: [
              { indate: { gte: dailyDate } },
              { zoneid: obj.params.zoneselection },
            ],
          },
          include: ["shop"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getInvoiceByKey = function (obj) {
      Invoice.find({
        filter: {
          where: {
            ikey: obj.params.ikey,
          },
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createInvoice = function (obj) {
      var date = new Date();

      Invoice.createMany(obj.params).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteInvoice = function (obj) {
      Invoice.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        onlineshorts: obj.params.onlineshorts,
        machineshorts: obj.params.machineshorts,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var payInvoice = function (obj) {
      var date = new Date();

      Invoice.prototype$patchAttributes({
        id: obj.params.id,
        ispaid: true,
        lastupdated: date,
        pdate: date,
        agentid: obj.params.agentid,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getInvoice: getInvoice,
      getInvoiceByZone: getInvoiceByZone,
      getInvoiceByKey: getInvoiceByKey,
      createInvoice: createInvoice,
      deleteInvoice: deleteInvoice,
      saveInvoice: saveInvoice,
      getDailyInvoiceWithSales: getDailyInvoiceWithSales,
      payInvoice: payInvoice,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.invoices.shopcategory")
    .controller("ShopCategoryInvoicePageCtrl", ShopCategoryInvoicePageCtrl);

  /** @ngInject */
  function ShopCategoryInvoicePageCtrl($scope, shopCategoryService) {
    $scope.reportFilter = { month: null };
    $scope.months = [];
    $scope.dates = [];
    $scope.categories = [];
    $scope.data = [];
    $scope.smartTablePageSize = 31;
    $scope.total = {};
    $scope.loading = false;

    $scope.getShopCategoryInvoice = function () {
      var obj = {};

      obj.date = $scope.reportFilter.month.value;
      $scope.loading = true;

      $scope.dates = [];
      $scope.categories = [];
      $scope.data = [];

      obj.onSuccess = function (result) {
        $scope.categories = result.result.categories;
        $scope.data = result.result.data;
        $scope.dates = result.result.dates;
        $scope.total = result.result.total || {};

        $scope.loading = false;
      };

      obj.onFailure = function (err) {
        $scope.loading = false;
      };

      shopCategoryService.getShopCategoryInvoice(obj);
    };

    $scope.init = function () {
      for (var i = 0; i < 4; i++) {
        var date = moment().utcOffset(8).startOf("month").subtract(i, "month");
        $scope.months.push({
          value: date.clone().format("YYYY-MM-DD"),
          label: date.clone().format("MM / YYYY"),
        });
      }

      $scope.reportFilter.month = $scope.months[0];
    };

    $scope.init();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.it")
    .controller("ITPageCtrl", ITPageCtrl);

  /** @ngInject */
  function ITPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    machineService,
    toastr,
    $uibModal,
    gameService,
    machineShopService,
    zoneService,
    $state,
    supplierService,
    shopService,
    $rootScope,
    gamecategoryService
  ) {
    console.log("Inside ITPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachine(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No",
    };

    $scope.datePickerOpened = { isOpen: false };
    $scope.openDatePicker = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.datePickerOpened[elementOpened] = !$scope.datePickerOpened[
        elementOpened
      ];
    };

    $scope.manageGamesCategoryList = [];
    $scope.initManageGameCategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageGamesCategoryList = result;
      };
      obj.onFailure = function (err) {};
      gamecategoryService.getGamecategory(obj);
    };
    $scope.manageGamesList = [];
    $scope.filterManageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
        $scope.filterManageGamesList = $scope.manageGamesList;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageActiveMachine");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function (zoneid) {
      var obj = {};
      obj.params = {};
      // obj.params.zoneid = zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManageGames();
      // $scope.initManageSupplier();
      // $scope.initManageGameCategory();
      // $scope.initManageActiveMachine();
    };
    $scope.init();

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.reportFilter = {};
    $scope.initManageMachine = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        } else {
          obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");

        $scope.manageMachineList = result.filter(function (re) {
          return re.gamecategoryid === 37;
        });
        console.log($scope.manageMachineList);

        if ($scope.manageMachineList.length > 0) {
          for (
            var index = 0;
            index < $scope.manageMachineList.length;
            index++
          ) {
            if ($scope.manageMachineList[index].machineshop.length > 0) {
              for (
                var nloop = 0;
                nloop < $scope.manageMachineList[index].machineshop.length;
                nloop++
              ) {
                if (
                  $scope.manageMachineList[index].machineshop[nloop].status ==
                  true
                ) {
                  $scope.manageMachineList[index].shop =
                    $scope.manageMachineList[index].machineshop[nloop].shop;
                  $scope.manageMachineList[index].supplier =
                    $scope.manageMachineList[index].machineshop[nloop].supplier;
                  $scope.manageMachineList[index].indate =
                    $scope.manageMachineList[index].machineshop[nloop].indate;
                }
              }
            }
          }
        }

        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine($scope.reportFilter);

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.gamecategoryid = manageMachine.gamecategory.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier
        ? manageMachine.supplier.id
        : null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success("New Machine has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/operational/it/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Machine has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machineService.deleteMachine(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveMachine = function (manageMachine) {
      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.gamecategoryid = manageMachine.gamecategory.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier
          ? manageMachine.supplier.id
          : null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success("Machine has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")($scope.manageGamesList, {
          id: game.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter("filter")($scope.manageZonesList, {
          id: zone.id,
        });
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter("filter")(
          $scope.manageActiveMachineList,
          {
            machineid: id,
          },
          true
        );
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);
    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      $scope.initManageShop();
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
      var obj = {};
      obj.params = {};
      obj.params = manageSupplier;
      //obj.params.created = $scope.manageSupplier.created;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplier = {};
        $scope.initManageSupplier();
        toastr.success("Supplier has been saved successfully!", "SUCCESS");
        $scope.isEditSupplier = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      supplierService.createSupplier(obj);
    };

    $scope.qrString = "";
    $scope.viewQRcode = function (code) {
      console.log("Inside viewQRcode", code);
      $scope.open("app/pages/operational/it/modals/qrModal.html");
      $scope.qrString = code;
    };

    $scope.print = function () {
      var canvasEle = document.getElementsByTagName("canvas");
      var canvas = canvasEle.length ? canvasEle[0].toDataURL() : null;
      if (!canvas) {
        window.alert("No Print Content Found");
        return;
      }

      var windowContent = "<!DOCTYPE html>";
      windowContent += "<html>";
      windowContent += "<body style='text-align:center'>";
      windowContent += '<img src="' + canvas + '">';
      windowContent +=
        "<div style='font-family:Arial; font-size: 18px'><b>" +
        $scope.qrString +
        "</b></div>";
      windowContent += "</body>";
      windowContent += "</html>";
      var printWin = window.open("", "", "width=1500,height=1500");
      printWin.document.open();
      printWin.document.write(windowContent);

      printWin.document.addEventListener(
        "load",
        function () {
          printWin.focus();
          printWin.print();
          printWin.document.close();
          printWin.close();
        },
        true
      );

      return true;
    };

    $scope.addMachineShop = function () {
      if ($scope.manageMachineshopList.length >= 1) {
        toastr.warning(
          "Only 1 shop is allowed. Please delete current one before proceed.",
          "Warning"
        );
        return;
      }

      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null,
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: supplierid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    $scope.showShop = function (shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageShopList,
          {
            id: shop.id,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.createMachineshop = function (manageMachineshop) {
      console.log("createMachineshop", manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;
        obj.params.remarks = manageMachineshop.remarks;
        obj.params.indate = manageMachineshop.indate;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Machines.",
          "Error"
        );
      }
    };

    $scope.saveMachineshop = function (manageMachineshop, id) {
      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.remarks = manageMachineshop.remarks;
        obj.params.indate = manageMachineshop.indate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.saveMachineshop(obj);
      }
    };

    $scope.openDeleteMachineshop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachineshop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function (id) {
      $scope.openDeleteMachineshop(
        "app/pages/operational/it/modals/dangerMachineGameModal.html"
      );
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function (res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log("Sure!");
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been deleted successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log("Not sure!");
      }
    };
    $scope.onCategoryChanged = function (item, model) {
      if (
        $scope.manageMachine.game &&
        $scope.manageMachine.game.gamecatid !== item.id
      ) {
        $scope.manageMachine.game = null;
      }

      $scope.filterManageGamesList = $scope.manageGamesList.filter(function (
        game
      ) {
        return game.gamecatid === item.id;
      });
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.machine")
    .controller("MachinePageCtrl", MachinePageCtrl);

  /** @ngInject */
  function MachinePageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    machineService,
    toastr,
    $uibModal,
    gameService,
    machineShopService,
    zoneService,
    $state,
    supplierService,
    shopService,
    $rootScope,
    gamecategoryService
  ) {
    console.log("Inside MachinePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachine(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No",
    };

    $scope.datePickerOpened = { isOpen: false };
    $scope.openDatePicker = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.datePickerOpened[elementOpened] = !$scope.datePickerOpened[
        elementOpened
      ];
    };

    $scope.manageGamesCategoryList = [];
    $scope.initManageGameCategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageGamesCategoryList = result;
      };
      obj.onFailure = function (err) {};
      gamecategoryService.getGamecategory(obj);
    };
    $scope.manageGamesList = [];
    $scope.filterManageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
        $scope.filterManageGamesList = $scope.manageGamesList;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageActiveMachine");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function (zoneid) {
      var obj = {};
      obj.params = {};
      // obj.params.zoneid = zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManageGames();
      $scope.initManageSupplier();
      $scope.initManageGameCategory();
      $scope.initManageActiveMachine();
    };
    $scope.init();

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.reportFilter = {};
    $scope.initManageMachine = function (reportFilter) {
      var obj = {};
      obj.params = {};
      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        } else {
          obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
        }
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineList = result;

        if ($scope.manageMachineList.length > 0) {
          for (
            var index = 0;
            index < $scope.manageMachineList.length;
            index++
          ) {
            if ($scope.manageMachineList[index].machineshop.length > 0) {
              for (
                var nloop = 0;
                nloop < $scope.manageMachineList[index].machineshop.length;
                nloop++
              ) {
                if (
                  $scope.manageMachineList[index].machineshop[nloop].status ==
                  true
                ) {
                  $scope.manageMachineList[index].shop =
                    $scope.manageMachineList[index].machineshop[nloop].shop;
                }
              }
            }
          }
        }

        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine($scope.reportFilter);

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.gamecategoryid = manageMachine.gamecategory.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier
        ? manageMachine.supplier.id
        : null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success("New Machine has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/operational/machine/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Machine has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machineService.deleteMachine(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveMachine = function (manageMachine) {
      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.gamecategoryid = manageMachine.gamecategory.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier
          ? manageMachine.supplier.id
          : null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success("Machine has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")($scope.manageGamesList, {
          id: game.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter("filter")($scope.manageZonesList, {
          id: zone.id,
        });
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter("filter")(
          $scope.manageActiveMachineList,
          {
            machineid: id,
          },
          true
        );
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);
    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      $scope.initManageShop();
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
      var obj = {};
      obj.params = {};
      obj.params = manageSupplier;
      //obj.params.created = $scope.manageSupplier.created;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplier = {};
        $scope.initManageSupplier();
        toastr.success("Supplier has been saved successfully!", "SUCCESS");
        $scope.isEditSupplier = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      supplierService.createSupplier(obj);
    };

    $scope.qrString = "";
    $scope.viewQRcode = function (code) {
      console.log("Inside viewQRcode", code);
      $scope.open("app/pages/operational/machine/modals/qrModal.html");
      $scope.qrString = code;
    };

    $scope.print = function () {
      var canvasEle = document.getElementsByTagName("canvas");
      var canvas = canvasEle.length ? canvasEle[0].toDataURL() : null;
      if (!canvas) {
        window.alert("No Print Content Found");
        return;
      }

      var windowContent = "<!DOCTYPE html>";
      windowContent += "<html>";
      windowContent += "<body style='text-align:center'>";
      windowContent += '<img src="' + canvas + '">';
      windowContent +=
        "<div style='font-family:Arial; font-size: 18px'><b>" +
        $scope.qrString +
        "</b></div>";
      windowContent += "</body>";
      windowContent += "</html>";
      var printWin = window.open("", "", "width=1500,height=1500");
      printWin.document.open();
      printWin.document.write(windowContent);

      printWin.document.addEventListener(
        "load",
        function () {
          printWin.focus();
          printWin.print();
          printWin.document.close();
          // printWin.close();
        },
        true
      );

      return true;
    };

    $scope.addMachineShop = function () {
      if ($scope.manageMachineshopList.length >= 1) {
        toastr.warning(
          "Only 1 shop is allowed. Please delete current one before proceed.",
          "Warning"
        );
        return;
      }

      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null,
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: supplierid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    $scope.showShop = function (shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageShopList,
          {
            id: shop.id,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.createMachineshop = function (manageMachineshop) {
      console.log("createMachineshop", manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;
        obj.params.remarks = manageMachineshop.remarks;
        obj.params.indate = manageMachineshop.indate;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Machines.",
          "Error"
        );
      }
    };

    $scope.saveMachineshop = function (manageMachineshop, id) {
      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.remarks = manageMachineshop.remarks;
        obj.params.indate = manageMachineshop.indate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.saveMachineshop(obj);
      }
    };

    $scope.openDeleteMachineshop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachineshop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function (id) {
      $scope.openDeleteMachineshop(
        "app/pages/operational/machine/modals/dangerMachineGameModal.html"
      );
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function (res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log("Sure!");
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been deleted successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log("Not sure!");
      }
    };
    $scope.onCategoryChanged = function (item, model) {
      if (
        $scope.manageMachine.game &&
        $scope.manageMachine.game.gamecatid !== item.id
      ) {
        $scope.manageMachine.game = null;
      }

      $scope.filterManageGamesList = $scope.manageGamesList.filter(function (
        game
      ) {
        return game.gamecatid === item.id;
      });
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.machine")
    .service("machineService", machineService);

  /** @ngInject */
  function machineService(Machine) {
    var getMachine = function (obj) {
      if (obj.params.zoneid != null) {
        Machine.find({
          filter: {
            where: {
              zoneid:
                obj.params.zoneid.length > 0
                  ? { inq: obj.params.zoneid }
                  : obj.params.zoneid,
            },
            include: [
              "game",
              "zone",
              "supplier",
              "gamecategory",
              {
                relation: "machineshop",
                scope: {
                  include: ["shop"],
                },
              },
            ],
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      } else {
        Machine.find({
          filter: {
            include: [
              "game",
              "zone",
              "supplier",
              "gamecategory",
              {
                relation: "machineshop",
                scope: {
                  include: ["shop", "supplier"],
                },
              },
            ],
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      }
    };

    var getAllMachine = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["supplier"],
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getMachineByZone = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid,
          },
          include: ["game", "zone", "supplier"],
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var createMachine = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        gamecategoryid: obj.params.gamecategoryid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteMachine = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveMachine = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.prototype$patchAttributes({
        id: obj.params.id,
        //description: obj.params.description,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        gamecategoryid: obj.params.gamecategoryid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getMachineByCode = function (obj) {
      Machine.find({
        filter: {
          where: {
            code: obj.code,
          },
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getMachine: getMachine,
      getAllMachine: getAllMachine,
      createMachine: createMachine,
      deleteMachine: deleteMachine,
      saveMachine: saveMachine,
      getMachineByZone: getMachineByZone,
      getMachineByCode: getMachineByCode,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shopcategory")
    .controller("ShopCategoryPageCtrl", ShopCategoryPageCtrl);

  /** @ngInject */
  function ShopCategoryPageCtrl(
    $scope,
    toastr,
    $uibModal,
    shopCategoryService
  ) {
    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          $scope.deleteShopCategory(selectedItem);
        },
        function () {}
      );
    };

    $scope.smartTablePageSize = 25;

    $scope.manageShopCategory = {};
    $scope.mangeShopCategoryList = [];

    $scope.initManageShopCategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log(result);
        $scope.mangeShopCategoryList = result;
      };
      obj.onFailure = function (err) {
        console.log(err);
      };

      shopCategoryService.getShopCategory(obj);
    };
    $scope.initManageShopCategory();

    $scope.addNewShopCategory = function () {
      $scope.inserted = {
        name: null,
      };
      $scope.mangeShopCategoryList.push($scope.inserted);
    };

    $scope.createShopCategory = function (shopCategory) {
      console.log(shopCategory);

      var obj = {};
      obj.params = {};
      obj.params.name = shopCategory.name;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopCategory = {};
        toastr.success(
          "New shop category has been saved successfully!",
          "SUCCESS"
        );

        $scope.initManageShopCategory();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
        } else {
        }
      };
      shopCategoryService.createShopCategory(obj);
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/operational/shopcategory/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteShopCategory = function (res) {
      if (res) {
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          $scope.initManageShopCategory();
        };
        obj.onFailure = function (err) {
          console.log(err);
          if (err.status === -1) {
          } else {
          }
        };
        shopCategoryService.deleteShopCategory(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.saveShopCategory = function (shopCategory, id) {
      if (id === undefined) {
        $scope.createShopCategory(shopCategory);
      } else {
        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = shopCategory.name;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageShopCategory = {};

          $scope.initManageShopCategory();
        };
        obj.onFailure = function (err) {
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        shopCategoryService.saveShopCategory(obj);

        //$scope.modal.hide();
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shopcategory")
    .service("shopCategoryService", shopCategoryService);

  /** @ngInject */
  function shopCategoryService(ShopCategory) {
    var getShopCategory = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      ShopCategory.find({
        filter: {},
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var createShopCategory = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      ShopCategory.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteShopCategory = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      ShopCategory.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveShopCategory = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      ShopCategory.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        //description: obj.params.description,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getShopCategoryInvoice = function (obj) {
      ShopCategory.getShopCategoryInvoice(obj).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getShopCategory: getShopCategory,
      createShopCategory: createShopCategory,
      deleteShopCategory: deleteShopCategory,
      saveShopCategory: saveShopCategory,
      getShopCategoryInvoice: getShopCategoryInvoice,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlinesales")
    .controller(
      "DailyonlinesalesreportPageCtrl",
      DailyonlinesalesreportPageCtrl
    );

  /** @ngInject */
  function DailyonlinesalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    stateService,
    dailyonlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    toastr,
    $uibModal,
    dailyInvoiceService,
    $rootScope,
    zoneService
  ) {
    console.log("Inside DailyonlinesalesreportPageCtrl");

    // To update custom date by invoices.
    // edit date below.
    // var uploadDate = moment('08-03-2020', 'MM-DD-YYYY');
    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      date: moment().subtract(1, "day").startOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null
      }
    };

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType
        }
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5"
        },
        {
          value: "100%"
        }
      ];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index]
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };
    $scope.reportFilter = {
      upload: $scope.dateList.date
    };
    $scope.loading = {
      generateInvocing: false,
      searching: false
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.totalSalesLabel = 0;

    $scope.getDailyOnlinesales = function (reportFilter) {
      var obj = {};
      obj.params = {};

      if (reportFilter.upload) {
        obj.params.adate = moment($scope.reportFilter.upload, "DD-MM-YYYY")
          .startOf("day")
          .format("MM/DD/YYYY");
      }

      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone
          ? "('" + reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype
          ? reportFilter.shoptype.value
          : null;
      }

      if (reportFilter.state) {
        obj.params.stateid = reportFilter.state.id;
      }

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        // $scope.initManageShop();
        $scope.totalSalesLabel = 0;

        $scope.manageOnlinesalesList = result.result.map(function (dat) {
          dat.tng_pin = Number(dat.tng_pin) + Number(dat.vpay_tng_pin);
          dat.cafeanddarts = Number(dat.dart || 0) + Number(dat.cafe || 0);

          return dat;
        });

        for (var i = 0; i < $scope.manageOnlinesalesList.length; i++) {
          //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          $scope.totalSalesLabel =
            $scope.totalSalesLabel +
            parseFloat($scope.manageOnlinesalesList[i].netpurchase) +
            parseFloat($scope.manageOnlinesalesList[i].pshare) +
            parseFloat($scope.manageOnlinesalesList[i].apshare) +
            parseFloat($scope.manageOnlinesalesList[i].pwin) +
            parseFloat($scope.manageOnlinesalesList[i].apwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;

        $scope.loading.searching = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        $scope.loading.searching = false;
      };

      $scope.loading.searching = true;
      dailyonlinesalesreportService.getOnlinesales(obj);
    };
    //$scope.getDailyOnlinesales();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    $scope.createOnlinesales = function (manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlinesales.id;
      obj.params.playtechid = manageOnlinesales.playtechid;
      obj.params.pshare = manageOnlinesales.pshare;
      obj.params.apshare = manageOnlinesales.apshare;
      obj.params.pwin = manageOnlinesales.pwin;
      obj.params.apwin = manageOnlinesales.apwin;
      obj.params.netpurchase = manageOnlinesales.netpurchase;
      obj.params.netgaming = manageOnlinesales.netgaming;
      obj.params.totalsales = manageOnlinesales.totalsales;
      obj.params.csales = manageOnlinesales.csales;
      obj.params.psales = manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success(
          "New Onlinesales has been saved successfully!",
          "SUCCESS"
        );
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.getDailyOnlinesales($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      dailyonlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/online/dailyonlinesales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function (res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Onlinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.getDailyOnlinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyonlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveOnlinesales = function (manageOnlinesales, id) {
      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid = manageOnlinesales.playtechid;
        obj.params.pshare = manageOnlinesales.pshare;
        obj.params.apshare = manageOnlinesales.apshare;
        obj.params.pwin = manageOnlinesales.pwin;
        obj.params.apwin = manageOnlinesales.apwin;
        obj.params.netpurchase = manageOnlinesales.netpurchase;
        obj.params.netgaming = manageOnlinesales.netgaming;
        obj.params.totalsales = manageOnlinesales.totalsales;
        obj.params.csales = manageOnlinesales.csales;
        obj.params.psales = manageOnlinesales.psales;
        obj.params.shopid = manageOnlinesales.shopid;
        obj.params.gameid = manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success("Onlinesales has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.getDailyOnlinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, "ERROR");
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyonlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }
    };

    /*
        $scope.datePickerPopup = function(onlinesales) {
            $scope.open = open;
            $scope.opened = false;
            $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
            $scope.format = $scope.formats[0];
            $scope.options = {
                showWeeks: false
            };

            function open() {
                $scope.opened = true;
            }
        }
    */
    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      console.log($scope.manageOnlinesales);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.manageOnlinesales.partnerid
          },
          true
        );
        return selected.length
          ? selected[0].code + ", " + selected[0].name
          : "Not set";
      } else return "Not set";
    };

    $scope.getInDate = function (date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
        date.getFullYear()
      ].join("/");
    };

    // $scope.genIvoiceOnlinesales =function (manageOnlinesalesList){
    //   console.log('Inside genIvoiceOnlinesales');
    //   console.log(manageOnlinesalesList);

    //   if (manageOnlinesalesList.length){
    //     var date = new Date();
    //     //var invoiceDate = new Date();
    //     //invoiceDate.setDate(date.getDate() - 1);

    //     var objInvoice = {};
    //     objInvoice.params=[];
    //     for (var index = 0; index < manageOnlinesalesList.length; index++) {
    //       var recordInvoice = {};

    //       var ikeyString = manageOnlinesalesList[index].ikey.toString();
    //       var ikeyDate = ikeyString.substring(ikeyString.length - 8);
    //       var shopid = parseInt(ikeyString.substring(0, ikeyString.length - 8));
    //       console.log('ikeyDate',ikeyDate);

    //       var tempDate = ikeyDate.substring(2,4)+'/'+ikeyDate.substring(0,2)+'/'+ikeyDate.substring(4,8);

    //       var invoiceDate = new Date(tempDate);
    //       var indate = new Date();
    //       // indate.setDate(indate.getDate()-1);
    //       console.log('invoiceDate',invoiceDate);

    //       recordInvoice.invoicedate = invoiceDate;
    //       recordInvoice.indate = $scope.getInDate(indate);
    //       recordInvoice.created = date;
    //       recordInvoice.lastupdated = date;
    //       recordInvoice.ikey = manageOnlinesalesList[index].ikey;
    //       recordInvoice.shopid = shopid;
    //       recordInvoice.zoneid = manageOnlinesalesList[index].shop.zoneid;
    //       objInvoice.params.push(recordInvoice);
    //     }
    //     console.log(objInvoice.params);

    //     objInvoice.onSuccess = function (result) {
    //       console.log("Inside SUCCESS genIvoiceOnlinesales");
    //       console.log(result);
    //       toastr.success('New Invoice has been generated successfully!', 'SUCCESS');

    //     }
    //     objInvoice.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
    //     };

    //     dailyInvoiceService.createInvoice(objInvoice);
    //   }

    // }
    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
        date.getFullYear()
      ].join("/");
    };

    $scope.genIvoiceOnlinesales = function () {
      console.log("Inside genIvoiceMachinesales");

      // var adate = new Date('10/24/2018');
      var adate = new Date();

      console.log("adate", adate);

      var obj = {};
      obj.params = {};
      // obj.params.adate = $scope.getInDate(adate, 2);
      obj.params.adate = moment($scope.reportFilter.upload, "DD-MM-YYYY")
        .startOf("day")
        .format("MM/DD/YYYY");

      console.log("obj.params.adate", obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log("Inside result.length ");

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            var newInDate = new Date(invoiceList[index].indate);
            var resultInDate = $scope.getInDate(newInDate, 0);

            recordInvoice.invoicedate = resultInDate;
            recordInvoice.indate = resultInDate;
            recordInvoice.created = date;
            recordInvoice.lastupdated = date;
            recordInvoice.ikey = invoiceList[index].ikey;
            recordInvoice.shopid = invoiceList[index].shopid;
            recordInvoice.zoneid = invoiceList[index].zoneid;

            if (!_.isEmpty(recordInvoice)) {
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success(
              "New Invoice has been generated successfully!",
              "SUCCESS"
            );

            $scope.loading.generateInvocing = false;
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success(
              "All Pending Invoices are generated successfully!",
              "SUCCESS"
            );

            $scope.loading.generateInvocing = false;
          };
          if (objInvoice.params.length) {
            dailyInvoiceService.createInvoice(objInvoice);
          } else {
            $scope.loading.generateInvocing = false;
            toastr.error("No Pending Invoices", "ERROR");
          }
        } else {
          $scope.loading.generateInvocing = false;
          toastr.error("No Pending Invoices", "ERROR");
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        $scope.loading.generateInvocing = false;
      };

      $scope.loading.generateInvocing = true;
      dailyonlinesalesreportService.generateInvoiceOnline(obj);
    };

    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlinesales")
    .service("dailyonlinesalesreportService", dailyonlinesalesreportService);

  /** @ngInject */
  function dailyonlinesalesreportService(Onlinesales) {
    // var getOnlinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();

    //   var dailyDate = year+'-'+month+'-'+day;

    //   console.log('date',dailyDate);

    //   Onlinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["game","shop"]
    //     }
    //   }).$promise.then(function(data) {
    // //  Onlinesales.find().$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getOnlinesales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      // To generate custom date invoice, edit date below.
      var dailyDate = year + "-" + month + "-" + day;

      console.log("dailyDate ", dailyDate);

      Onlinesales.getDailyOnlinesales({
        adate: obj.params.adate || dailyDate,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        stateid: obj.params.stateid
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDailyOnlinesalesByKey = function (obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          },
          include: [
            {
              shop: "onlineshop"
            },
            "game"
          ]
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var generateInvoiceOnline = function (obj) {
      Onlinesales.generateInvoiceOnline({
        adate: obj.params.adate
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      generateInvoiceOnline: generateInvoiceOnline
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shop")
    .controller("ShopPageCtrl", ShopPageCtrl);

  /** @ngInject */
  function ShopPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    shopService,
    toastr,
    $uibModal,
    partnerService,
    zoneService,
    $state,
    gameService,
    gameServerService,
    onlineShopService,
    machineShopService,
    machineService,
    supplierService,
    stateService,
    areaService,
    siteService,
    $rootScope,
    userService,
    billService,
    zonePRService,
    shopCategoryService,
    $stateParams,
    shopAddressService
  ) {
    var paramsShopId = $stateParams.shopid;
    if (paramsShopId) {
      $state.transitionTo($state.current.name, {}, { notify: false });
    }

    $scope.isAdmin = $rootScope.userData.roleId === 1;
    $scope.loading = false;

    $scope.paparichSalesPeriodDropdown = [
      {
        name: "Daily",
        value: "daily",
      },
      { name: "Weekly", value: "weekly" },
      { name: "Monthly", value: "monthly" },
    ];
    $scope.algorithms = ["NP", "NG", "NGX2"];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
        {
          value: "5/5 shop butterfly",
        },
        {
          value: "100% shop butterfly",
        },
        {
          value: "20%PR",
        },
      ];
    }

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteShop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
        {
          value: "5/5 shop butterfly",
        },
        {
          value: "100% shop butterfly",
        },
        {
          value: "20%PR",
        },
      ];
    }

    if (typeof $rootScope.userData.credentials.operational !== "undefined") {
      $scope.operationalFilter = [
        {
          value: $rootScope.userData.credentials.operational,
        },
      ];
    } else {
      $scope.operationalFilter = [
        {
          value: "Live",
        },
        {
          value: "Danger",
        },
        {
          value: "Warning",
        },
      ];
    }

    if (typeof $rootScope.userData.credentials.status !== "undefined") {
      $scope.statusFilter = [
        {
          value: $rootScope.userData.credentials.status,
        },
      ];
    } else {
      $scope.statusFilter = [
        {
          value: "Active",
        },
        {
          value: "Inactive",
        },
      ];
    }

    $scope.openDeleteOnlineShop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlineShop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.openDeleteMachineshop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachineshop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.openProfitSharing = function (shop) {
      $scope.selectedShop = shop;
      billService.getProfitSharingHistory(shop.id).then(function (res) {
        $scope.profitSharingHistory = res.data;
      });
    };

    $scope.addNewProfitSharing = function () {
      $scope.inserted = {
        profitSharing: 50,
        remarks: null,
      };
      $scope.profitSharingHistory.push($scope.inserted);
    };

    $scope.checkRate = function (rate) {
      if (!rate || isNaN(rate) || rate > 100 || rate < 0) {
        return "Rate must set from 0 to 100";
      }
    };

    $scope.saveProfitSharing = function (value) {
      billService
        .saveProfitSharingHistory({
          remarks: value.remarks,
          profitSharing: value.profitSharing,
          shop: { id: $scope.selectedShop.id },
        })
        .then(function (res) {
          toastr.success(
            "Profit Sharing has been updated successfully!",
            "SUCCESS"
          );

          if ($scope.selectedShop) {
            $scope.openProfitSharing($scope.selectedShop);
            $scope.selectedShop.profitsharing = value.profitSharing;
          }
        });
    };

    $scope.closeProfitSharing = function () {
      $scope.selectedShop = null;

      $scope.initManageShop();
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;

    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlineShopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlineShopService.getOnlineshop(obj);
      } else {
        $scope.manageOnlineShopList = [];
      }
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.manageGameServerList = [];
    $scope.initManageGamesServer = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageGameServerList = result.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      };
      obj.onFailure = function (err) {};
      gameServerService.getGameServer(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside partner SUCCESS ");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageZonesPRList = [];
    $scope.initManageZonesPR = function () {
      var obj = {
        params: {},
      };

      var isAdmin = [1].includes($rootScope.userData.roleId);

      if (!isAdmin) {
        if (typeof $rootScope.userData.credentials.statemap !== "undefined") {
          obj.params.stateid = $rootScope.userData.credentials.statemap;
        } else {
          obj.params.stateid = [0];
        }
      }

      obj.onSuccess = function (result) {
        $scope.manageZonesPRList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zonePRService.getZonesPR(obj);
    };

    $scope.manageAreaList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSites = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshop(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };
    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.params = {};
      // obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
      // machinesalesreportService.getAvailableMachineByZone(obj);
    };

    $scope.manageMachineListZone = [];
    $scope.initManageMachineZone = function () {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid); // ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachineZone");
        console.log(result);
        $scope.manageMachineListZone = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachineByZone(obj);
    };

    $scope.manageShopCategoryList = [];
    $scope.initManageShopCategory = function () {
      var obj = {};
      obj.params = {};

      obj.onSuccess = function (result) {
        $scope.manageShopCategoryList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopCategoryService.getShopCategory(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageAreas();
      $scope.initManageGames();
      $scope.initManageSupplier();
      $scope.initManageSites();
      $scope.initManageGamesServer();
      $scope.initManageZonesPR();
      $scope.initManageShopCategory();
    };
    $scope.init();

    $scope.manageShop = {};
    $scope.manageShopList = [];
    $scope.reportFilter = {};
    $scope.manageShopDeletedAddress = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};

      if ($scope.reportFilter.zone) {
        obj.params.zoneid = $scope.reportFilter.zone
          ? $scope.reportFilter.zone.id
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid = $rootScope.userData.credentials.zonemap;
        } else {
          obj.params.zoneid = $scope.reportFilter.zone
            ? $scope.reportFilter.zone.id
            : null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if (typeof $rootScope.userData.credentials.status !== "undefined") {
        $rootScope.userData.credentials.status = true;
      } else {
        obj.params.status =
          !!$scope.reportFilter.status && !!$scope.reportFilter.status.value
            ? $scope.reportFilter.status.value == "Active"
              ? true
              : false
            : null;
      }

      if (typeof $rootScope.userData.credentials.operational !== "undefined") {
        obj.params.operational = $rootScope.userData.credentials.operational;
      } else {
        obj.params.operational = $scope.reportFilter.operational
          ? $scope.reportFilter.operational.value
          : null;
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if ($scope.reportFilter.zonepr) {
        obj.params.zoneprid = $scope.reportFilter.zonepr
          ? $scope.reportFilter.zonepr.id
          : null;
      }

      if ($scope.reportFilter.category) {
        obj.params.categoryid = $scope.reportFilter.category
          ? $scope.reportFilter.category.id
          : null;
      }

      obj.params.hasWaiJiao =
        !!$scope.reportFilter.hasWaiJiao &&
        !!$scope.reportFilter.hasWaiJiao.value
          ? $scope.reportFilter.hasWaiJiao.value === "Active"
            ? true
            : false
          : null;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        // api unable to filter by relation
        if ($scope.reportFilter.state) {
          $scope.manageShopList = result.filter(function (res) {
            if (res.zone) {
              return res.zone.stateid == $scope.reportFilter.state.id;
            }
            return false;
          });
        } else {
          $scope.manageShopList = result;
        }

        $scope.manageShopList = result.map(function (res) {
          // if (res.terminatedBySpidermanPR) {
          //   res.status = res.status + "(Terminated";
          // }
          res.myaddress = (res.shopAddress || [])
            .map(function (add) {
              return add.name;
            })
            .join(",");

          return res;
        });

        //$scope.initManageOnlineShop();
        $scope.isEdit = false;
        for (var i = 0; i < $scope.manageShopList.length; i++) {
          if ($scope.manageShopList[i].contact1) {
            $scope.manageShopList[i].contact1 = JSON.parse(
              $scope.manageShopList[i].contact1
            );
          }
          if ($scope.manageShopList[i].contact2) {
            $scope.manageShopList[i].contact2 = JSON.parse(
              $scope.manageShopList[i].contact2
            );
          }
          if ($scope.manageShopList[i].contact3) {
            $scope.manageShopList[i].contact3 = JSON.parse(
              $scope.manageShopList[i].contact3
            );
          }
        }

        $scope.mergeShopsAndMachineShops();

        if (paramsShopId) {
          setTimeout(function () {
            var hasFoundShop = $scope.manageShopList.find(function (shop) {
              return shop.id === Number(paramsShopId);
            });

            paramsShopId = null;
            if (!hasFoundShop) {
              toastr.error("Shop not found!", "FAILED");
              return;
            }

            $scope.editShop(hasFoundShop);
          });
        }

        $scope.loading = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        $scope.loading = false;
      };
      shopService.getShop(obj);
    };
    $scope.initManageShop();

    $scope.manageMachineShops = [];
    $scope.manageShopGamesList = [];
    $scope.initMangeMachineShops = function () {
      var obj = {};
      obj.params = {};

      obj.onSuccess = function (result) {
        $scope.manageMachineShops = result;
        $scope.mergeShopsAndMachineShops();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initMangeMachineShops();

    $scope.createShop = function (manageShop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createShop");
      console.log(manageShop);

      var obj = {};
      obj.params = {};
      obj.params.code = manageShop.code;
      obj.params.name = manageShop.name;
      obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;

      obj.params.modes = manageShop.modes;
      obj.params.hasWaiJiao = manageShop.hasWaiJiao;
      obj.params.categoryid = manageShop.category
        ? manageShop.category.id
        : null;
      obj.params.zoneprid = manageShop.zonepr ? manageShop.zonepr.id : null;
      obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
      obj.params.areaid = manageShop.area ? manageShop.area.id : null;
      obj.params.siteid = manageShop.site ? manageShop.site.id : null;
      obj.params.onrate = manageShop.onrate;
      obj.params.macrate = manageShop.macrate;
      obj.params.onvirtual = manageShop.onvirtual;
      obj.params.d_cc_rate = manageShop.d_cc_rate;
      obj.params.d_ewallet_rate = manageShop.d_ewallet_rate;
      obj.params.ontips = manageShop.ontips;
      obj.params.pg_rate = manageShop.pg_rate;
      obj.params.pg_out_rate = manageShop.pg_out_rate;
      obj.params.tng_pin_rate = manageShop.tng_pin_rate;
      obj.params.creditlimit = manageShop.creditlimit;
      obj.params.shoptype = manageShop.shoptype
        ? manageShop.shoptype.value || manageShop.shoptype
        : null;
      obj.params.operational = manageShop.operational
        ? manageShop.operational.value || manageShop.operational
        : "Live";
      obj.params.photo = manageShop.photo;

      obj.params.address = manageShop.address;
      obj.params.status = manageShop.status;
      obj.params.allowInvocing = manageShop.allowInvocing;
      obj.params.contact1 = JSON.stringify(manageShop.contact1);
      obj.params.contact2 = JSON.stringify(manageShop.contact2);
      obj.params.contact3 = JSON.stringify(manageShop.contact3);
      obj.params.remarks = manageShop.remarks;
      obj.params.onrebate = manageShop.onrebate;
      obj.params.macrebate = manageShop.macrebate;
      obj.params.mactips = manageShop.mactips;
      obj.params.macvirtual = manageShop.macvirtual;
      obj.params.profitsharing = 50;
      obj.params.paparichAgentName = manageShop.paparichAgentName;
      obj.params.paparichSalesPeriod = manageShop.paparichSalesPeriod
        ? manageShop.paparichSalesPeriod.value
        : "";
      obj.params.jokaAgentName = manageShop.jokaAgentName;
      obj.params.jokaSalesPeriod = manageShop.jokaSalesPeriod
        ? manageShop.jokaSalesPeriod.value
        : "";

      if (obj.params.zoneid === null) {
        toastr.error("Please select daerah code.", "Error");
        return;
      }

      //obj.params.description = manageShop.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        toastr.success("New Shop has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Shop successfully created.");
        // $scope.initManageShop($scope.reportFilter);
        $scope.saveShopAddress(result.id);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        $scope.loading = false;
        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "Error");
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, "Error");
        }
      };

      $scope.loading = true;
      shopService.createShop(obj);

      //$scope.modal.hide();
    };
    $scope.remarks = "";
    $scope.viewRemarks = function (remarks) {
      console.log("Inside viewRemarks", remarks);
      $scope.open("app/pages/operational/shop/modals/viewRemarks.html");
      $scope.remarks = remarks;
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/operational/shop/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteShop = function (res) {
      console.log("Inside deleteShop");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Shop has been deleted successfully!", "SUCCESS");

          $scope.initManageShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        shopService.deleteShop(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (shop) {
      console.log("Inside editShop");
      console.log(shop);
      // $scope.manageShop.id = $scope.manageShop.id;
      // $scope.manageShop.name = state.name;
      // $scope.manageShop.description = state.description;
      // $scope.manageShop.created = state.created;
      // $scope.manageShop.lastupdated = state.lastupdated;
      $scope.manageShop = shop;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.reset = function () {
      $scope.reportFilter = {};
      $scope.initManageShop();
    };

    $scope.saveShop = function (manageShop) {
      if (manageShop.id === undefined) {
        $scope.createShop(manageShop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = manageShop.id;
        obj.params.code = manageShop.code;
        obj.params.name = manageShop.name;
        obj.params.partnerid = manageShop.partner
          ? manageShop.partner.id
          : null;
        obj.params.modes = manageShop.modes;
        obj.params.hasWaiJiao = manageShop.hasWaiJiao;
        obj.params.categoryid = manageShop.category
          ? manageShop.category.id
          : null;
        obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
        obj.params.zoneprid = manageShop.zonepr ? manageShop.zonepr.id : null;
        obj.params.areaid = manageShop.area ? manageShop.area.id : null;
        obj.params.siteid = manageShop.site ? manageShop.site.id : null;
        obj.params.onrate = manageShop.onrate;
        obj.params.macrate = manageShop.macrate;
        obj.params.onvirtual = manageShop.onvirtual;
        obj.params.ontips = manageShop.ontips;
        obj.params.d_cc_rate = manageShop.d_cc_rate;
        obj.params.d_ewallet_rate = manageShop.d_ewallet_rate;
        obj.params.pg_rate = manageShop.pg_rate;
        obj.params.pg_out_rate = manageShop.pg_out_rate;
        obj.params.tng_pin_rate = manageShop.tng_pin_rate;
        obj.params.creditlimit = manageShop.creditlimit;
        obj.params.shoptype = manageShop.shoptype
          ? manageShop.shoptype.value || manageShop.shoptype
          : null;
        obj.params.operational = manageShop.operational
          ? manageShop.operational.value || manageShop.operational
          : "Live";
        obj.params.address = manageShop.address;
        obj.params.status = manageShop.status;
        obj.params.allowInvocing = manageShop.allowInvocing;
        obj.params.contact1 = JSON.stringify(manageShop.contact1);
        obj.params.contact2 = JSON.stringify(manageShop.contact2);
        obj.params.contact3 = JSON.stringify(manageShop.contact3);
        obj.params.photo = manageShop.photo;

        obj.params.remarks = manageShop.remarks;
        obj.params.onrebate = manageShop.onrebate;
        obj.params.macrebate = manageShop.macrebate;
        obj.params.mactips = manageShop.mactips;
        obj.params.macvirtual = manageShop.macvirtual;
        obj.params.userid = manageShop.userid;
        obj.params.customerFee = manageShop.customerFee;
        obj.params.paparichAgentName = manageShop.paparichAgentName;
        obj.params.paparichSalesPeriod = manageShop.paparichSalesPeriod
          ? manageShop.paparichSalesPeriod.value
          : "";
        obj.params.jokaAgentName = manageShop.jokaAgentName;
        obj.params.jokaSalesPeriod = manageShop.jokaSalesPeriod
          ? manageShop.jokaSalesPeriod.value
          : "";
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;
        if (obj.params.zoneid === null) {
          toastr.error("Please select daerah code.", "Error");
          return;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          toastr.success("Shop has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");

          $scope.saveShopAddress(result.id);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.loading = false;
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };

        $scope.loading = true;
        shopService.saveShop(obj);
      }
    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter("filter")($scope.managePartnerList, {
          id: partner.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter("filter")($scope.manageZonesList, {
          id: zone.id,
        });
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes.bs3.submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editShop = function (manageShop) {
      $scope.isEdit = true;
      $scope.manageShop = manageShop;
      $scope.manageShopDeletedAddress = [];
      $scope.manageShop.photo = manageShop.photo || [];
      $scope.manageShop.shopAddress = manageShop.shopAddress || [];

      $scope.initManageMachine();
      $scope.initManageMachineZone();
      $scope.initManageOnlineShop();
      $scope.initManageMachineShop();
    };

    $scope.addShop = function () {
      $scope.isEdit = true;
      $scope.manageShop = {};
      $scope.manageShopDeletedAddress = [];
      $scope.manageShop.photo = [];
      $scope.manageShopDeletedAddress = [];
      $scope.manageShop.shopAddress = [];

      $scope.manageOnlineShopList = [];
      $scope.manageMachineshopList = [];
    };

    $scope.showGames = function (game) {
      if (game && $scope.manageGamesList.length) {
        var selected = $scope.manageGamesList.find(function (gamelist) {
          return gamelist.id === game.id;
        });

        return selected ? selected.name : "Not set";
      } else return "Not set";
    };

    //Online Games

    $scope.addOnlineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        gameid: null,
        playtechid: null,
        server: 35,
        pr: 0,
        bet_rate: 0,
        onrate: 100,
        algorithm: "NP",
      };
      $scope.manageOnlineShopList.push($scope.inserted);
    };

    $scope.saveOnlineShop = function (manageOnlineShop, id) {
      if (id === undefined) {
        $scope.createOnlineShop(manageOnlineShop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;
        obj.params.bet_rate = manageOnlineShop.bet_rate;
        obj.params.onrate = manageOnlineShop.onrate;
        obj.params.gameserverid = manageOnlineShop.gameserverid;
        obj.params.server = manageOnlineShop.server || 0;
        obj.params.pr = manageOnlineShop.pr || 0;
        obj.params.algorithm = manageOnlineShop.algorithm;

        if (isNaN(obj.params.bet_rate) || isNaN(obj.params.onrate)) {
          toastr.error("Please input value for Company and Bet.", "Error");
          return;
        }

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success("Online Game has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.saveOnlineshop(obj);
      }
    };

    $scope.createOnlineShop = function (manageOnlineShop) {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;
        obj.params.bet_rate = manageOnlineShop.bet_rate;
        obj.params.onrate = manageOnlineShop.onrate;
        obj.params.algorithm = manageOnlineShop.algorithm;

        obj.params.gameserverid = manageOnlineShop.gameserverid;
        obj.params.server = manageOnlineShop.server || 0;
        obj.params.pr = manageOnlineShop.pr || 0;

        if (isNaN(obj.params.bet_rate) || isNaN(obj.params.onrate)) {
          toastr.error("Please input value for Company and Bet.", "Error");
          return;
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Online Game has been saved successfully!", "SUCCESS");
          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.createOnlineshop(obj);
      } else {
        $scope.initManageOnlineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Online Games.",
          "Error"
        );
      }
    };

    $scope.deleteOnlineShopId = null;
    $scope.confirmOnlineShopDelete = function (item) {
      $scope.openDeleteOnlineShop(
        "app/pages/operational/shop/modals/dangerOnlineGameModal.html"
      );
      $scope.selectedOnlineShop = item;
    };

    $scope.deleteOnlineShop = function (res) {
      console.log("Inside deleteOnlineShop");
      if (res) {
        console.log("Sure!");
        console.log($scope.selectedOnlineShop);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.selectedOnlineShop.id;
        obj.params.shopid = null;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Online Game has been deleted successfully!",
            "SUCCESS"
          );

          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.saveOnlineshop(obj);
        $scope.selectedOnlineShop = null;
      }
    };

    //Machine Shop
    $scope.showMachine = function (machine) {
      if (machine && $scope.manageMachineListZone.length) {
        var selected = $filter("filter")(
          $scope.manageMachineListZone,
          {
            id: machine.id,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.addMachineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        machineid: null,
        macrate: null,
        macvirtual: null,
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.saveMachineshop = function (manageMachineshop, id) {
      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        //obj.params.supplierid = manageOnlineShop.supplier;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machineid;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.saveMachineshop(obj);
      }
    };

    $scope.createMachineshop = function (manageMachineshop) {
      console.log("createMachineshop", manageMachineshop);

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop();
          $scope.initManageMachine();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Machines.",
          "Error"
        );
      }
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function (id) {
      $scope.openDeleteMachineshop(
        "app/pages/operational/shop/modals/dangerMachineGameModal.html"
      );
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function (res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log("Sure!");
        //console.log($scope.deleteMachineshopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        // obj.params.shopid = $scope.manageShop.id;
        // obj.params.machineid = manageMachineshop.machineid;
        // obj.params.macrate = manageMachineshop.macrate;
        // obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = false;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been deleted successfully!",
            "SUCCESS"
          );
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: supplierid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    $scope.showSupplierComm = function (machine) {
      if (machine && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: machine.supplierid,
          },
          true
        );
        return selected.length ? selected[0].rate : "Not set";
      } else return "Not set";
    };

    $scope.userAccess = function (manageShop) {
      console.log("Inside userAccess");
      console.log("manageShop", manageShop);

      var obj = {};
      obj.params = {};
      obj.params.username = manageShop.code;
      obj.params.password = "password";
      obj.params.credentials = {};
      obj.params.credentials.name = manageShop.name;
      obj.params.credentials.mobile = null;
      obj.params.credentials.role = 15; //Shop Staff Role id
      obj.params.credentials.shop = manageShop;
      obj.params.challenges = manageShop.id;

      console.log("obj.params", obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageShop.userid = result.id;
        $scope.saveShop(manageShop);
        toastr.success(
          "Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.",
          "SUCCESS"
        );
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "ERROR");
        } else if (err.status === 422) {
          toastr.error("Username or Mobile Already Exists", "ERROR");
        } else {
          toastr.error("Unauthorized Access", "ERROR");
        }
      };

      userService.partnerSignup(obj);
    };

    $scope.shopPhoto = function () {
      var uppy = window.Robodog.pick({
        providers: ["url", "google-drive"],
        waitForEncoding: true,
        params: {
          auth: {
            key: "c673e93193e94bd4abea671bef1ce051",
          },
          template_id: "212613e1befa427c9393f3864fb39c62",
        },
        debug: true,
        restrictions: {
          maxFileSize: 5 * 1024 * 1024,
          maxNumberOfFiles: 1,
          minNumberOfFiles: 1,
          allowedFileTypes: ["image/*"],
        },
      })
        .then(function (bundle) {
          // Due to `waitForEncoding: true` this is fired after encoding is done.
          // Alternatively, set `waitForEncoding` to `false` and provide a `notify_url`
          // for Async Mode where your back-end receives the encoding results
          // so that your user can be on their way as soon as the upload completes.
          console.log(bundle.transloadit); // Array of Assembly Statuses
          console.log(bundle.results); // Array of all encoding results

          var hasPhoto =
            bundle.results && bundle.results.length ? bundle.results[0] : null;

          if (!hasPhoto) {
            return;
          }

          var myPhotoUrl = hasPhoto.url || hasPhoto.ssl_url;

          hasPhoto.url = myPhotoUrl;
          hasPhoto.ssl_url = myPhotoUrl;

          $scope.manageShop.photo.unshift(hasPhoto);
          $scope.$apply();
        })
        .catch(function (error) {
          toastr.error("Failed to upload photo.", "ERROR");
        });
    };

    $scope.viewPhotos = function (photos) {
      $scope.zoomInMode = false;
      $scope.selectedPhotos = [];
      $scope.myImageStyle = {};

      $scope.selectedPhotos = Array.isArray(photos) ? photos : [photos];

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/accDepartment/bill/modals/imgPreviewerModal.html",
        scope: $scope,
        windowClass: "modal-image-previewer",
        size: "lg",
      });
    };

    $scope.deleteImage = function (index) {
      $scope.manageShop.photo = $scope.manageShop.photo.filter(function (
        photo,
        i
      ) {
        return index !== i;
      });
    };

    $scope.mergeShopsAndMachineShops = function () {
      $scope.manageMachineShops.forEach(function (managemachine) {
        if (!managemachine.game) {
          return;
        }

        if (
          managemachine.gamecategoryid === 37 &&
          !$scope.manageShopGamesList.find(function (shopgame) {
            return shopgame.id === managemachine.game.id;
          })
        ) {
          $scope.manageShopGamesList.push(managemachine.game);
        }
      });

      $scope.manageShopList = $scope.manageShopList.map(function (shop) {
        shop.machine = 0;
        shop.game = {};

        $scope.manageMachineShops.forEach(function (managemachine) {
          var hasShop = managemachine.machineshop.filter(function (
            machineshop
          ) {
            return machineshop.shopid === shop.id && !!machineshop.status;
          });
          shop.machine += hasShop.length;

          var machineInShop = !!hasShop.length;
          var hasGame = $scope.manageShopGamesList.find(function (manageGame) {
            return manageGame.id === managemachine.gameid;
          });

          if (hasGame && machineInShop) {
            if (!shop.game[hasGame.id]) {
              shop.game[hasGame.id] = 0;
            }

            shop.game[hasGame.id] += 1;
          }
        });

        return shop;
      });
    };
    $scope.getTotalMachine = function (shops) {
      return shops.reduce(function (total, shop) {
        return (total += Number(shop.machine));
      }, 0);
    };
    $scope.getTotalGame = function (shops, game) {
      var total = 0;

      shops.forEach(function (shop) {
        var gameValue =
          shop.game && game && shop.game[game.id] ? shop.game[game.id] : 0;
        total += gameValue;
      });

      return total;
    };

    $scope.createAddressRow = function () {
      $scope.manageShop.shopAddress.push({ name: "" });
    };

    $scope.removeAddressRow = function (index) {
      $scope.manageShop.shopAddress = $scope.manageShop.shopAddress.filter(
        function (add, i) {
          if (i === index && add.id) {
            $scope.manageShopDeletedAddress.push(add.id);
          }

          return i !== index;
        }
      );
    };

    $scope.saveShopAddress = function (shopid) {
      var obj = {
        params: {
          address: $scope.manageShop.shopAddress
            .filter(function (address) {
              return address.id || address.name;
            })
            .map(function (address) {
              return {
                id: address.id,
                name: address.name,
                shopid: shopid,
              };
            }),
        },
      };

      obj.onSuccess = function (result) {
        $scope.deleteShopAddress();
      };
      obj.onFailure = function (err) {
        console.log("Failure");
        console.log(err);
        $scope.loading = false;
      };

      $scope.manageShop = {};

      shopAddressService.createMany(obj);
    };

    $scope.deleteShopAddress = function () {
      var obj = { params: $scope.manageShopDeletedAddress };
      obj.onSuccess = function (result) {
        $scope.initManageShop();
      };
      obj.onFailure = function (err) {
        $scope.loading = false;
        console.log(err);
      };
      shopAddressService.deleteByID(obj);
    };

    $scope.backToShopPage = function () {
      $scope.isEdit = false;
    };
  }
})();

/**
 * @author udit.jain
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shop")
    .service("machineShopService", machineShopService);

  /** @ngInject */
  function machineShopService(Machineshop) {
    var getMachineshop = function (obj) {
      Machineshop.find({
        filter: {
          where: {
            and: [{ shopid: obj.params.shopid }, { status: obj.params.status }],
          },
          include: ["shop", "machine", "supplier"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getMachineshopByMachineId = function (obj) {
      Machineshop.find({
        filter: {
          where: {
            and: [
              { machineid: obj.params.machineid },
              { status: obj.params.status },
            ],
          },
          include: ["shop", "machine", "supplier"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllMachineshop = function (obj) {
      Machineshop.find({
        filter: {
          where: {
            status: obj.params.status,
          },
          include: [
            { relation: "shop", scope: { include: ["zone"] } },
            {
              relation: "machine",
              scope: {
                include: ["game", "gamecategory", "supplier"],
              },
            },
          ],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllMachineshopWithoutStatus = function (obj) {
      Machineshop.find({
        filter: {
          include: ["shop", "machine"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };
    var createMachineshop = function (obj) {
      var date = new Date();

      Machineshop.create({
        created: date,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid,
        remarks: obj.params.remarks,
        indate: obj.params.indate,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    // var deleteMachineshop = function(obj) {

    //   Machineshop.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    var deleteMachineshop = function (obj) {
      var date = new Date();
      Machineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        status: obj.params.status,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };
    var saveMachineshop = function (obj) {
      var date = new Date();

      Machineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid,
        remarks: obj.params.remarks,
        indate: obj.params.indate,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getMachineshopByGameCategory = function (obj) {
      Machineshop.find({
        filter: {
          where: {},
          include: [
            { relation: "shop", scope: { include: ["zone"] } },
            {
              relation: "machine",
              scope: {
                include: ["game", "gamecategory", "supplier"],
              },
            },
          ],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getMachineshop: getMachineshop,
      getAllMachineshop: getAllMachineshop,
      getAllMachineshopWithoutStatus: getAllMachineshopWithoutStatus,
      createMachineshop: createMachineshop,
      deleteMachineshop: deleteMachineshop,
      saveMachineshop: saveMachineshop,
      getMachineshopByMachineId: getMachineshopByMachineId,
      getMachineshopByGameCategory: getMachineshopByGameCategory,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shop")
    .service("onlineShopService", onlineShopService);

  /** @ngInject */
  function onlineShopService(Onlineshop) {
    var getShopGameServer = function (obj) {
      Onlineshop.getOnlineShopAndGameServer({
        zoneid: obj.params.zoneid,
        shoptype: obj.params.shoptype,
        stateid: obj.params.stateid,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getOnlineshopByFilter = function (obj) {
      return Onlineshop.find({
        filter: {
          where: obj.params,
          include: ["shop"],
        },
      }).$promise;
    };

    var getOnlineshop = function (obj) {
      Onlineshop.find({
        filter: {
          where: {
            shopid: obj.params.shopid,
          },
          include: ["game", "shop", "gameserver"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllOnlineshop = function (obj) {
      Onlineshop.find({
        filter: {
          include: ["game", "shop"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };
    var createOnlineshop = function (obj) {
      var date = new Date();

      Onlineshop.create({
        created: date,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        bet_rate: obj.params.bet_rate,
        onrate: obj.params.onrate,
        playtechid: obj.params.playtechid,
        algorithm: obj.params.algorithm,
        gameserverid: obj.params.gameserverid,
        server: obj.params.server,
        pr: obj.params.pr,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlineshop = function (obj) {
      Onlineshop.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveOnlineshop = function (obj) {
      var date = new Date();

      Onlineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        bet_rate: obj.params.bet_rate,
        onrate: obj.params.onrate,
        playtechid: obj.params.playtechid,
        algorithm: obj.params.algorithm,
        gameserverid: obj.params.gameserverid,
        server: obj.params.server,
        pr: obj.params.pr,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getShopGameServer: getShopGameServer,
      getOnlineshop: getOnlineshop,
      createOnlineshop: createOnlineshop,
      deleteOnlineshop: deleteOnlineshop,
      saveOnlineshop: saveOnlineshop,
      getAllOnlineshop: getAllOnlineshop,
      getOnlineshopByFilter: getOnlineshopByFilter,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shop")
    .service("shopAddressService", shopAddressService);

  /** @ngInject */
  function shopAddressService(ShopAddress) {
    var createMany = function (obj) {
      ShopAddress.upsertMany(
        obj.params.address.map(function (address) {
          if (!address.id) {
            address.created = new Date();
          }

          address.lastupdated = new Date();

          return address;
        }),
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteByID = function (obj) {
      ShopAddress.deleteByID(
        obj.params,
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      createMany: createMany,
      deleteByID: deleteByID,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.operational.shop")
    .service("shopService", shopService);

  /** @ngInject */
  function shopService(Shop) {
    var getShop = function (obj) {
      var where = {};
      if (obj.params.zoneid != null) {
        where.zoneid =
          obj.params.zoneid.length > 0
            ? {
                inq: obj.params.zoneid.map(function (zone) {
                  return zone.toString();
                }),
              }
            : obj.params.zoneid;
      }
      if (obj.params.operational != null) {
        where.operational = obj.params.operational;
      }
      if (obj.params.status != null) {
        where.status = obj.params.status;
      }
      if (obj.params.shoptype != null) {
        where.shoptype = obj.params.shoptype;
      }
      if (obj.params.stateid != null) {
        where.stateid = obj.params.stateid;
      }
      if (obj.params.hasWaiJiao != null) {
        where.hasWaiJiao = obj.params.hasWaiJiao;
      }
      if (obj.params.zoneprid != null) {
        where.zoneprid = obj.params.zoneprid;
      }
      if (obj.params.categoryid != null) {
        where.categoryid = obj.params.categoryid;
      }
      if (obj.params.modes != null) {
        where.modes = obj.params.modes
          .map(function (mode) {
            return mode.value;
          })
          .sort()
          .join();
      }

      Shop.find({
        filter: {
          where: where,
          include: [
            "partner",
            "zone",
            "area",
            "site",
            "zonepr",
            "category",
            "shopAddress",
          ],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getShopById = function (obj) {
      Shop.findById({
        id: obj.params.shopid,
        filter: {
          include: ["partner", "zone", "area", "site", "category"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getShopByZone = function (obj) {
      Shop.find({
        filter: {
          where: {
            and: [
              {
                zoneid: obj.params.zoneid,
              },
              {
                status: true,
              },
            ],
          },
          include: ["partner", "zone", "area", "site"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getShopByZones = function (obj) {
      Shop.find({
        filter: {
          where: {
            and: [
              {
                zoneid: {
                  inq: obj.params.zoneid.map(function (zone) {
                    return zone.toString();
                  }),
                },
              },
              { status: true },
            ],
          },
          include: ["partner", "zone", "area", "site"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createShop = function (obj) {
      var date = new Date();

      Shop.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        modes: obj.params.modes,
        hasWaiJiao: obj.params.hasWaiJiao,
        zoneprid: obj.params.zoneprid,
        categoryid: obj.params.categoryid,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        operational: obj.params.operational,
        address: obj.params.address,
        allowInvocing: Boolean(obj.params.allowInvocing),
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual,
        bet_rate: obj.params.bet_rate,
        pg_rate: obj.params.pg_rate,
        pg_out_rate: obj.params.pg_out_rate,
        d_cc_rate: obj.params.d_cc_rate,
        d_ewallet_rate: obj.params.d_ewallet_rate,
        tng_pin_rate: obj.params.tng_pin_rate,
        photo: obj.params.photo,
        profitsharing: obj.params.profitsharing,
        paparichAgentName: obj.params.paparichAgentName,
        paparichSalesPeriod: obj.params.paparichSalesPeriod,
        jokaAgentName: obj.params.jokaAgentName,
        jokaSalesPeriod: obj.params.jokaSalesPeriod,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteShop = function (obj) {
      Shop.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveShop = function (obj) {
      var date = new Date();

      Shop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        modes: obj.params.modes,
        hasWaiJiao: obj.params.hasWaiJiao,
        categoryid: obj.params.categoryid,
        zoneprid: obj.params.zoneprid,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        operational: obj.params.operational,
        address: obj.params.address,
        status: obj.params.status,
        allowInvocing: Boolean(obj.params.allowInvocing),
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual,
        userid: obj.params.userid,
        bet_rate: obj.params.bet_rate,
        pg_rate: obj.params.pg_rate,
        pg_out_rate: obj.params.pg_out_rate,
        photo: obj.params.photo,
        tng_pin_rate: obj.params.tng_pin_rate,
        d_cc_rate: obj.params.d_cc_rate,
        d_ewallet_rate: obj.params.d_ewallet_rate,
        servercompany: obj.params.servercompany,
        customerFee: obj.params.customerFee,
        paparichAgentName: obj.params.paparichAgentName,
        paparichSalesPeriod: obj.params.paparichSalesPeriod,
        jokaAgentName: obj.params.jokaAgentName,
        jokaSalesPeriod: obj.params.jokaSalesPeriod,
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var findAssignedShop = function (obj) {
      Shop.find({
        filter: {
          where: {
            id: {
              inq: obj.params.shopmap,
            },
          },
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var findNotAssignedShop = function (obj) {
      if (obj.params.shopmap) {
        Shop.find({
          filter: {
            where: {
              and: [
                {
                  id: {
                    nin: obj.params.shopmap,
                  },
                },
                {
                  shoptype: obj.params.shoptype,
                },
                {
                  zoneid: {
                    inq: obj.params.zonemap,
                  },
                },
              ],
            },
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      } else {
        Shop.find({
          filter: {
            where: {
              and: [
                {
                  shoptype: obj.params.shoptype,
                },
                {
                  zoneid: {
                    inq: obj.params.zonemap,
                  },
                },
              ],
            },
          },
        }).$promise.then(
          function (data) {
            obj.onSuccess(data);
          },
          function (err) {
            obj.onFailure(err);
          }
        );
      }
    };

    var findNotAssignedShopForAdmin = function (obj) {
      Shop.find({
        filter: {
          where: {
            id: {
              nin: obj.params.shopmap,
            },
          },
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var unbindShopStaff = function (obj) {
      var date = new Date();

      Shop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getShopByPartner = function (partnerid) {
      return Shop.getShopByPartner({
        partnerid: partnerid
      }).$promise;
    };

    return {
      getShop: getShop,
      createShop: createShop,
      deleteShop: deleteShop,
      saveShop: saveShop,
      findAssignedShop: findAssignedShop,
      findNotAssignedShop: findNotAssignedShop,
      getShopById: getShopById,
      getShopByZone: getShopByZone,
      findNotAssignedShopForAdmin: findNotAssignedShopForAdmin,
      unbindShopStaff: unbindShopStaff,
      getShopByZones: getShopByZones,
      getShopByPartner: getShopByPartner
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineserver")
    .controller(
      "DailyOnlineServerReportPageCtrl",
      DailyOnlineServerReportPageCtrl
    );

  /** @ngInject */
  function DailyOnlineServerReportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    stateService,
    dailyonlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    toastr,
    $uibModal,
    dailyInvoiceService,
    $rootScope,
    zoneService,
    onlineserverService,
    inputserverService
  ) {
    $scope.reportFilter = {
      zone: null,
      from: moment().startOf("month").toDate(),
      to: moment().toDate(),
    };
    $scope.manageZonesList = [];
    $scope.dpOpenStatus = {};
    $scope.smartTablePageSize = 250;
    $scope.isDetail = false;

    $scope.manageDailyOnlineServerDetailList = [];
    $scope.manageDailyOnlineServerByGameList = [];
    $scope.selectedDetailList = [];

    $scope.saveInputServer = function (data) {
      setTimeout(function () {
        var obj = {};
        obj.params = {};
        obj.params.startdate = moment($scope.reportFilter.from, "DD-MM-YYYY")
          .startOf("day")
          .format("MM/DD/YYYY");
        obj.params.enddate = moment($scope.reportFilter.to, "DD-MM-YYYY")
          .startOf("day")
          .format("MM/DD/YYYY");
        obj.params.amount = data.isserver;
        obj.params.gameserverid = data.gsid;
        obj.params.charge = data.ischarge;

        obj.onSuccess = function (result) {
          $scope.getDailyOnlineServerByGame();
          toastr.success("Game server updated", "SUCCESS");
        };
        obj.onFailure = function (result) {};

        inputserverService.saveInputServer(obj);
      });
    };

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {};
      zoneService.getZones(obj);
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        zone: null,
        from: moment().startOf("month").toDate(),
        to: moment().toDate(),
      };
    };

    $scope.closeDetail = function () {
      $scope.isDetail = false;
      $scope.selectedDetailList = [];
    };

    $scope.getServerTotal = function (item) {
      return $scope.getInputServerTotal(item) - Number(item.ischarge);
    };

    $scope.getInputServerTotal = function (item) {
      return (item.rate / 100) * Number(item.isserver);
    };

    $scope.viewMore = function (item) {
      $scope.isDetail = item;
      $scope.selectedDetailList = $scope.manageDailyOnlineServerDetailList.filter(
        function (detail) {
          return detail.gid == item.gid;
        }
      );
    };

    $scope.getDailyOnlineServerByGame = function () {
      var obj = {};
      obj.params = {};
      obj.params.from = moment($scope.reportFilter.from, "DD-MM-YYYY")
        .startOf("day")
        .format("MM/DD/YYYY");
      obj.params.to = moment($scope.reportFilter.to, "DD-MM-YYYY")
        .startOf("day")
        .format("MM/DD/YYYY");

      if ($scope.reportFilter.zone) {
        obj.params.zoneid = $scope.reportFilter.zone
          ? "('" + $scope.reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        }
      }

      Promise.all([
        onlineserverService.getDailyOnlineServerByGame(obj),
        onlineserverService.getDailyOnlineServerDetail(obj),
      ]).then(function (res) {
        $scope.manageDailyOnlineServerByGameList = res[0].result;
        $scope.manageDailyOnlineServerDetailList = res[1].result.length
          ? res[1].result.map(function (res) {
              var data = res;
              data.istotal = $scope.getInputServerTotal(res);
              data.isservertotal = $scope.getServerTotal(res);
              return data;
            })
          : [];

        if ($scope.isDetail) {
          $scope.viewMore($scope.isDetail);
        }

        $scope.$apply();
      });
    };

    $scope.init = function () {
      $scope.initManageZones();
    };

    $scope.init();
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineserver")
    .service("onlineserverService", onlineserverService);

  /** @ngInject */
  function onlineserverService(Onlineserver) {
    var getDailyOnlineServerDetail = function (obj) {
      return Onlineserver.getDailyOnlineServerDetail({
        from: obj.params.from,
        to: obj.params.to,
        zoneid: obj.params.zoneid,
      }).$promise;
    };

    var getDailyOnlineServerByGame = function (obj) {
      return Onlineserver.getDailyOnlineServerByGame({
        from: obj.params.from,
        to: obj.params.to,
        // shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        // stateid: obj.params.stateid,
      }).$promise;
    };

    var getOnlineServerByShop = function (obj) {
      Onlineserver.getOnlineServerByShop({
        filter: obj.params,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveOnlineServer = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlineserver.createMany(
        obj.params.map(function (param) {
          return {
            ikey: param.ikey,
            indate: param.indate,
            amount: param.amount,
            playtechid: param.playtechid,
            shopid: param.shopid,
            gameserverid: param.gameserverid,
            lastupdated: date,
            created: date,
          };
        })
      ).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      saveOnlineServer: saveOnlineServer,
      getDailyOnlineServerDetail: getDailyOnlineServerDetail,
      getDailyOnlineServerByGame: getDailyOnlineServerByGame,
      getOnlineServerByShop: getOnlineServerByShop,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineserver")
    .service("inputserverService", inputserverService);

  /** @ngInject */
  function inputserverService(Inputserver) {
    var saveInputServer = function (obj) {
      Inputserver.saveInputServer({
        indate: obj.params.indate,
        amount: obj.params.amount,
        gameserverid: obj.params.gameserverid,
        charge: obj.params.charge,
        startdate: obj.params.startdate,
        enddate: obj.params.enddate,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      saveInputServer: saveInputServer,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineshop")
    .controller("DailyonlineshopreportPageCtrl", DailyonlineshopreportPageCtrl);

  /** @ngInject */
  function DailyonlineshopreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    dailyonlineshopreportService,
    dailyonlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    validationService,
    partnerService,
    toastr,
    $uibModal,
    dailyInvoiceService,
    $rootScope,
    zoneService
  ) {
    console.log("Inside DailyonlineshopreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getOnlineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageShopList = [];
    // $scope.initManageShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   shopService.getShop(obj);
    // };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        { value: $rootScope.userData.credentials.shopType }
      ];
    } else {
      $scope.shopTypeFilter = [{ value: "5/5" }, { value: "100%" }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index]
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageOnlineshop = {};
    $scope.manageOnlineshopList = [];
    $scope.totalSalesLabel = 0;
    $scope.reportFilter = {};
    $scope.getAllOnlinesales = function (reportFilter) {
      var obj = {};
      obj.params = {};

      if (reportFilter.zone) {
        obj.params.zoneid = reportFilter.zone
          ? "('" + reportFilter.zone.id + "')"
          : null;
      } else {
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value = "";
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            if (index == 0) {
              value =
                "('" + $rootScope.userData.credentials.zonemap[index] + "'";
            } else {
              value =
                value +
                ",'" +
                $rootScope.userData.credentials.zonemap[index] +
                "'";
            }
          }
          value = value + ")";
          obj.params.zoneid = value;
        } else {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        }
      }

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = reportFilter.shoptype
          ? reportFilter.shoptype.value
          : null;
      }

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        //$scope.initManageGames();
        //$scope.initManageShop();
        $scope.totalSalesLabel = 0;
        $scope.manageOnlineshopList = result.result;
        for (var i = 0; i < $scope.manageOnlineshopList.length; i++) {
          $scope.totalSalesLabel =
            $scope.totalSalesLabel +
            parseFloat($scope.manageOnlineshopList[i].netpurchase) +
            parseFloat($scope.manageOnlineshopList[i].pshare) +
            parseFloat($scope.manageOnlineshopList[i].apshare) +
            parseFloat($scope.manageOnlineshopList[i].pwin) +
            parseFloat($scope.manageOnlineshopList[i].apwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));

        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlineshopreportService.getDailyGroupedOnlinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.getAllOnlinesales();

    $scope.deleteId = null;
    // $scope.confirmDelete = function(id) {
    //   $scope.open('app/pages/online/dailyonlinesales/modals/dangerModal.html');
    //   $scope.deleteId = id;
    // };

    // $scope.deleteOnlinesales = function(res) {
    //   console.log("Inside deleteOnlinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
    //       $scope.getAllOnlinesales();
    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.deleteOnlinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // }

    $scope.editState = function (onlinesales) {
      console.log("Inside viewOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlineshop.id = $scope.manageOnlineshop.id;
      // $scope.manageOnlineshop.name = state.name;
      // $scope.manageOnlineshop.description = state.description;
      // $scope.manageOnlineshop.created = state.created;
      // $scope.manageOnlineshop.lastupdated = state.lastupdated;
      $scope.manageOnlineshop = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    // $scope.saveOnlinesales = function(manageOnlineshop, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlineshop);
    //   console.log(manageOnlineshop.id);

    //   if (manageOnlineshop.id === undefined) {
    //     $scope.createOnlinesales(manageOnlineshop);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlineshop;
    //     obj.params.id = manageOnlineshop.id;
    //     obj.params.playtechid= manageOnlineshop.playtechid;
    //     obj.params.pshare= manageOnlineshop.pshare;
    //     obj.params.pwin= manageOnlineshop.pwin;
    //     obj.params.netpurchase= manageOnlineshop.netpurchase;
    //     obj.params.netgaming= manageOnlineshop.netgaming;
    //     obj.params.totalsales= manageOnlineshop.totalsales;
    //     obj.params.csales= manageOnlineshop.csales;
    //     obj.params.psales= manageOnlineshop.psales;
    //     obj.params.shopid= manageOnlineshop.shopid;
    //     obj.params.gameid= manageOnlineshop.gameid;
    //     // obj.params.name = $scope.manageOnlineshop.name;
    //     // obj.params.description = $scope.manageOnlineshop.description;
    //     //obj.params.created = $scope.manageOnlineshop.created;

    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlineshop = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.getAllOnlinesales();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.saveOnlinesales(obj);
    //     //$scope.modal.hide();
    //   }
    // }

    /*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewOnlinesales = function (manageOnlineshop) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlineshop = manageOnlineshop;
      console.log($scope.manageOnlineshop);
      console.log(manageOnlineshop.ikey);
      $scope.onlineSalesInvoice = {};
      $scope.getOnlineInvoiceDetails(manageOnlineshop.ikey);
      console.log($scope.onlineSalesInvoice);
      $scope.getOnlineSales(manageOnlineshop.ikey);
      console.log($scope.onlineSalesDetails);
    };

    $scope.getOnlineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    };
    $scope.lookupDetails = {};
    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      $scope.onlineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.onlineSalesDetails = result;
        var data = {};
        //var shopDetails = $scope.getShopDetails($scope.onlineSalesDetails[0].shopid);
        //console.log(shopDetails)
        //console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(
          $scope.onlineSalesDetails[0].shop.partnerid
        );
        data.created = $scope.onlineSalesDetails[0].shop.created;
        $scope.lookupDetails.data = data;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (partnerid) {
      if (partnerid && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: partnerid
          },
          true
        );
        return selected.length
          ? selected[0].code + ", " + selected[0].name
          : "Not set";
      } else return "Not set";
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.dailyonlineshop")
    .service("dailyonlineshopreportService", dailyonlineshopreportService);

  /** @ngInject */
  function dailyonlineshopreportService(Onlinesales) {
    var getOnlinesales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Onlinesales.find({
        filter: {
          where: {
            indate: { gte: dailyDate }
          },
          include: ["game", "shop"]
        }
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDailyGroupedOnlinesales = function (obj) {
      var today = moment().subtract(1, "day");
      var adate = today.clone().startOf("day").format("YYYY-M-D");

      Onlinesales.grpShop({
        adate: adate,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getDailyOnlinesalesByKey = function (obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      getDailyGroupedOnlinesales: getDailyGroupedOnlinesales
      //    getByDateOnlinesales: getByDateOnlinesales,
      //createOnlinesales: createOnlinesales,
      //deleteOnlinesales: deleteOnlinesales,
      //saveOnlinesales: saveOnlinesales
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.gamesales")
    .controller("gameSalesreportPageCtrl", gameSalesreportPageCtrl);

  /** @ngInject */
  function gameSalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    partnersalesreportService,
    gameService,
    stateService,
    onlinesalesreportService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    $rootScope,
    zoneService,
    receiptService
  ) {
    console.log("Inside gameSalesreportPageCtrl");

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        var userPartner = $rootScope.userData.credentials
          ? $rootScope.userData.credentials.partner
          : null;

        $scope.manageParentPartnerList = userPartner
          ? result.filter(function (res) {
              return (
                res.code === userPartner.code ||
                (!!userPartner.isparent && res.parentid === userPartner.id)
              );
            })
          : [];
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManageParentPartner();

    $scope.reset = function () {
      $scope.reportFilter = {
        from: moment().startOf("month").toDate(),
        to: moment().toDate(),
      };
    };
    $scope.reset();

    $scope.searchGameSales = function () {
      console.log("Inside searchGameSales");
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.reportFilter.from) &&
        validationService.isEmptyOrNullValidation($scope.reportFilter.to)
      ) {
        if (
          !validationService.verifyDate($scope.reportFilter.from) ||
          !validationService.verifyDate($scope.reportFilter.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};
        obj.params.startDate = moment($scope.reportFilter.from).format(
          "YYYY-MM-DD"
        );
        obj.params.endDate = moment($scope.reportFilter.to).format(
          "YYYY-MM-DD"
        );

        if ($scope.reportFilter.zone) {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = $scope.reportFilter.zone
              ? "('" + $scope.reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = $scope.reportFilter.shoptype
            ? $scope.reportFilter.shoptype.value
            : null;
        }

        if (!$scope.reportFilter.parent) {
          obj.params.parentid = $scope.manageParentPartnerList.map(function (
            res
          ) {
            return res.id;
          });
        } else {
          obj.params.parentid = $scope.reportFilter.parent
            ? [$scope.reportFilter.parent.id]
            : [];
        }

        if ($scope.reportFilter.state) {
          obj.params.stateid = $scope.reportFilter.state.id;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          if (result.result) {
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              var onmacTotal =
                parseFloat($scope.managePartnersalesList[i].ontotal) +
                parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlinesalesreportService.getShopsReportWithGames(obj);
      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner();

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/external/partnersales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.deleteMachinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveMachinesales = function (managePartnersales, id) {
      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      if (managePartnersales.id === undefined) {
        $scope.createMachinesales(managePartnersales);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = managePartnersales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnersales = {};
          toastr.success(
            "Machinesales has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, "ERROR");
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales);
      $scope.getMachineSalesOfPartner(managePartnersales);
      //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getMachineSalesOfPartner = function (managePartnersales) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.reportFilter.from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();
      var td = new Date($scope.reportFilter.to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();

      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = "(" + managePartnersales.partner.id + ")";
      console.log(obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.mPSalesTotal = 0;
        $scope.mCSalesTotal = 0;
        $scope.mSalesTotal = 0;
        $scope.npTotal = 0;
        $scope.oPSalesTotal = 0;
        $scope.oCSalesTotal = 0;
        $scope.oNetCollectTotal = 0;
        $scope.oSalesTotal = 0;
        $scope.shopTotal = 0;
        $scope.compTotal = 0;
        $scope.shopOverTotal = 0;
        $scope.compOverTotal = 0;

        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 =
            parseFloat(result.result[i].ontotal) +
            parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter =
            $scope.totalSalesLabelFooter + onMacTotalL2;
          $scope.mPSalesTotal =
            $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
          $scope.mCSalesTotal =
            $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
          $scope.mSalesTotal =
            $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
          $scope.npTotal =
            $scope.npTotal + parseFloat(result.result[i].netpurchase);
          $scope.oPSalesTotal =
            $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
          $scope.oCSalesTotal =
            $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
          $scope.oNetCollectTotal =
            $scope.oNetCollectTotal + parseFloat(result.result[i].net_collect);
          $scope.oSalesTotal =
            $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
          $scope.machineSalesOfPartnerList.result[i].shopTotal =
            parseFloat(result.result[i].mpsales) +
            parseFloat(result.result[i].opsales);
          $scope.machineSalesOfPartnerList.result[i].compTotal =
            parseFloat(result.result[i].mcsales) +
            parseFloat(result.result[i].net_collect);
          $scope.shopOverTotal =
            $scope.shopOverTotal +
            $scope.machineSalesOfPartnerList.result[i].shopTotal;
          $scope.compOverTotal =
            $scope.compOverTotal +
            $scope.machineSalesOfPartnerList.result[i].compTotal;
        }
        console.log($scope.totalSalesLabelFooter);
        var filteredShops = $scope.machineSalesOfPartnerList.result.filter(
          function (sale) {
            return sale.shopid == managePartnersales.shop.id;
          }
        );
        $scope.getShopSalesOfPartner(filteredShops);
      };
      obj.onFailure = function (err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      partnersalesreportService.getMachinesalesByPartner(obj);
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: gid,
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (managePartnersales) {
      if (managePartnersales.shop && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.managePartnersales.shop.partnerid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.manageDailyinvoices = {};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isInvoice = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      if ($scope.manageDailyinvoices.ikey) {
        $scope.manageDailyinvoices.invoicedate = $scope.dateFormater(
          $scope.manageDailyinvoices.ikey
        );
      }
      console.log($scope.manageDailyinvoices);

      $scope.onlineInvoiceDetails = {};
      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices.ikey);
    };

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.onlineInvoiceDetails = {
          NG: result.filter(function (r) {
            return r.algorithm === "NG";
          }),
          NP: result.filter(function (r) {
            return r.algorithm === "NP" || r.algorithm === null;
          }),
        };

        // set shop
        $scope.shopInvoiceDetails = result.length > 0 && result[0].shop;

        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        $scope.total.NP_csales_total = 0;
        $scope.total.NP_totalsales = 0;

        $scope.total.NP_csales_total = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.csales);
          },
          0
        );

        $scope.total.NG_net_collect = $scope.onlineInvoiceDetails.NG.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_net_collect = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_totalsales = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.totalsales);
          },
          0
        );
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }

        var machine = 0;
        $scope.total.machineST = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          $scope.total.machine = parseFloat(machine);
          $scope.total.machineST =
            machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) {
          return x.mpsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) {
          return x.mcsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) {
          return x.mactotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) {
          return x.opsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaloNetCollect = function (items) {
      return items
        .map(function (x) {
          return x.net_collect;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalnetpurhase = function (items) {
      return items
        .map(function (x) {
          return x.netpurchase;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) {
          return x.ocsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) {
          return x.ontotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) {
          return x.shopTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) {
          return x.compTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) {
          return x.totalsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };

    $scope.getShopSalesOfPartner = function (salesOfPartnerList) {
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = false;
      $scope.shopSalesOfPartnerList = {};
      $scope.shopSalesOfPartnerList = salesOfPartnerList;
      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.npTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.oNetCollectTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 =
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal) +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter =
          $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal =
          $scope.mPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal =
          $scope.mCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal =
          $scope.mSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.npTotal =
          $scope.npTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].netpurchase);
        $scope.oPSalesTotal =
          $scope.oPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal =
          $scope.oCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oNetCollectTotal =
          $scope.oNetCollectTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].net_collect);
        $scope.oSalesTotal =
          $scope.oSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].net_collect);
        $scope.shopOverTotal =
          $scope.shopOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal =
          $scope.compOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].compTotal);
      }
    };

    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log("receiptid", receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open(
            "app/pages/invoices/dailyinvoices/modals/receiptModal.html"
          );
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.onlinesales")
    .controller("OnlinesalesreportPageCtrl", OnlinesalesreportPageCtrl);

  /** @ngInject */
  function OnlinesalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    stateService,
    onlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    dailyInvoiceService,
    toastr,
    $uibModal,
    validationService,
    $rootScope,
    zoneService
  ) {
    console.log("Inside OnlinesalesreportPageCtrl");
    $scope.canClickDelete = [1, 5].includes($rootScope.userData.roleId);

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };
    $scope.totalSalesLabel = 0;
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};
    $scope.loading = {
      searching: false
    };

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType
        }
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5"
        },
        {
          value: "100%"
        }
      ];
    }

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index]
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log("$scope.manageZonesList", $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null
      }
    };

    $scope.reportFilter = {};
    $scope.searchOnlinesales = function (reportFilter) {
      console.log("Inside searchOnlinesales", reportFilter);
      console.log($scope.dateList);

      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (
            typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
            Array.isArray($rootScope.userData.credentials.zonemap) &&
            $rootScope.userData.credentials.zonemap.length > 0
          ) {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        if (typeof $rootScope.userData.credentials.partner !== "undefined") {
          obj.params.partnerid = $rootScope.userData.credentials.partner.id;
        } else if (reportFilter.partnerid) {
          obj.params.partnerid = reportFilter.partnerid.id;
        }

        if (reportFilter.state) {
          obj.params.stateid = reportFilter.state.id;
        }

        if (reportFilter.kiosk) {
          obj.params.kiosk = reportFilter.kiosk;
        }

        function filterPartnerStaffShops(result) {
          if ($rootScope.userData.roleId == 13) {
            return result.filter(function (r) {
              return r.code.contains(
                $rootScope.userData.credentials.partner.code
              );
            });
          }

          return result;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          $scope.totalSalesLabel = 0;

          // result.result = filterPartnerStaffShops(result.result);

          $scope.manageOnlinesalesList = result.result.map(function (dat) {
            dat.wanzi = dat.wanzi || 0;
            dat.wanzi_com = dat.wanzi_com || 0;

            dat.cafeanddarts = Number(dat.dart || 0) + Number(dat.cafe || 0);
            dat.local_cafeanddarts = dat.cafeanddarts;
            dat.local_snooker = dat.snooker || 0;
            dat.local_snooker_fnb = dat.snooker_fnb || 0;
            dat.local_kitchen = dat.kitchen || 0;
            dat.local_netpurchase = dat.netpurchase || 0;
            dat.local_pshare = dat.pshare || 0;
            dat.local_apshare = dat.apshare || 0;
            dat.local_pwin = dat.pwin || 0;
            dat.local_apwin = dat.apwin || 0;
            dat.local_bonus_bet = dat.bonus_bet || 0;
            dat.local_bonus_win = dat.bonus_win || 0;
            dat.local_caishen = dat.caishen || 0;
            dat.local_plinko = dat.plinko || 0;
            dat.local_netgaming = dat.netgaming || 0;
            dat.local_total_payment_gateway = dat.total_payment_gateway || 0;
            dat.local_pg_charge = dat.pg_charge || 0;
            dat.local_total_pgout = dat.total_pgout || 0;
            dat.local_pg_out_charge = dat.pg_out_charge || 0;
            dat.local_d_ewallet = dat.d_ewallet || 0;
            dat.local_d_ewallet_charge = dat.d_ewallet_charge || 0;
            dat.local_telco = dat.telco || 0;
            dat.local_crypto = dat.crypto || 0;
            dat.local_tng_pin =
              Number(dat.tng_pin || 0) + Number(dat.vpay_tng_pin || 0);
            dat.local_tng_pin_charge = Number(dat.tng_pin_charge || 0);
            dat.local_d_cc = dat.d_cc || 0;
            dat.local_d_cc_charge = dat.d_cc_charge || 0;
            dat.local_pgsbonus = dat.pgsbonus || 0;
            dat.local_totalsales = dat.totalsales || 0;
            dat.local_csales = dat.csales || 0;
            dat.local_psales = dat.psales || 0;
            dat.local_net_collect = dat.net_collect || 0;
            dat.local_rewards = dat.rewards || 0;

            return dat;
          });

          for (var i = 0; i < $scope.manageOnlinesalesList.length; i++) {
            $scope.totalSalesLabel =
              $scope.totalSalesLabel +
              parseFloat($scope.manageOnlinesalesList[i].totalsales);
          }

          $scope.loading.searching = false;
          $scope.isEdit = false;
          $scope.initManagePartner();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);

          $scope.loading.searching = false;
        };

        $scope.loading.searching = true;
        onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      }
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.getOnlineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.onlineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (
        typeof $rootScope.userData.credentials.zonemap !== "undefined" &&
        Array.isArray($rootScope.userData.credentials.zonemap) &&
        $rootScope.userData.credentials.zonemap.length > 0
      ) {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    // $scope.initManageState = function () {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function (result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.initManagePartner();
    //     $scope.initManageGames();
    //     $scope.initManageShop();
    //     for (var i = 0; i < result.length; i++) {
    //       $scope.totalSalesLabel =
    //         $scope.totalSalesLabel + parseFloat(result[i].totalsales);
    //     }
    //     console.log($scope.totalSalesLabel.toFixed(2));
    //     $scope.manageOnlinesalesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function (err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   onlinesalesreportService.getBetweenDatesOnlinesales(obj);
    //   //onlinesalesreportService.getOnlinesales(obj);
    //   $scope.$broadcast("scroll.refreshComplete");
    // };

    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        var userPartner = $rootScope.userData.credentials
          ? $rootScope.userData.credentials.partner
          : null;

        console.log("user", $rootScope.userData);
        $scope.manageParentPartnerList =
          $rootScope.userData.roleId === 1
            ? result
            : userPartner
              ? result.filter(function (res) {
                  return (
                    res.code === userPartner.code ||
                    (!!userPartner.isparent && res.parentid === userPartner.id)
                  );
                })
              : [];

        console.log("partner", $scope.manageParentPartnerList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManageParentPartner();

    //    $scope.initManageStates();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    // $scope.createOnlinesales = function(manageOnlinesales) {
    //   //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
    //   console.log("Inside createOnlinesales");
    //   //console.log(manageOnlinesales.name);
    //   //console.log(manageOnlinesales.description);

    //   var obj = {};
    //   obj.params = {};

    //   obj.params.id = manageOnlinesales.id;
    //   obj.params.playtechid = manageOnlinesales.playtechid;
    //   obj.params.pshare = manageOnlinesales.pshare;
    //   obj.params.pwin = manageOnlinesales.pwin;
    //   obj.params.netpurchase = manageOnlinesales.netpurchase;
    //   obj.params.netgaming = manageOnlinesales.netgaming;
    //   obj.params.totalsales = manageOnlinesales.totalsales;
    //   obj.params.csales = manageOnlinesales.csales;
    //   obj.params.psales = manageOnlinesales.psales;

    //   //obj.params.description = manageOnlinesales.description;
    //   console.log(manageOnlinesales);
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageOnlinesales = {};
    //     toastr.success('New Onlinesales has been saved successfully!', 'SUCCESS');
    //     //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
    //     $scope.initManageStates();

    //   }
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //     if (err.status === -1) {
    //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //     } else {

    //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //     }
    //   }
    //   onlinesalesreportService.createOnlinesales(obj);

    //   //$scope.modal.hide();
    // };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/online/onlinesales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function (res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Onlinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");

          $scope.manageOnlinesalesList = $scope.manageOnlinesalesList.filter(
            function (sales) {
              return sales.salesid !== $scope.deleteId;
            }
          );

          for (var i = 0; i < $scope.manageOnlinesalesList.length; i++) {
            $scope.totalSalesLabel =
              $scope.totalSalesLabel +
              parseFloat($scope.manageOnlinesalesList[i].totalsales);
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        onlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    // $scope.saveOnlinesales = function(manageOnlinesales, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlinesales);
    //   console.log(manageOnlinesales.id);

    //   if (manageOnlinesales.id === undefined) {
    //     $scope.createOnlinesales(manageOnlinesales);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlinesales;
    //     obj.params.id = manageOnlinesales.id;
    //     obj.params.playtechid = manageOnlinesales.playtechid;
    //     obj.params.pshare = manageOnlinesales.pshare;
    //     obj.params.pwin = manageOnlinesales.pwin;
    //     obj.params.netpurchase = manageOnlinesales.netpurchase;
    //     obj.params.netgaming = manageOnlinesales.netgaming;
    //     obj.params.totalsales = manageOnlinesales.totalsales;
    //     obj.params.csales = manageOnlinesales.csales;
    //     obj.params.psales = manageOnlinesales.psales;
    //     obj.params.shopid = manageOnlinesales.shopid;
    //     obj.params.gameid = manageOnlinesales.gameid;
    //     // obj.params.name = $scope.manageOnlinesales.name;
    //     // obj.params.description = $scope.manageOnlinesales.description;
    //     //obj.params.created = $scope.manageOnlinesales.created;

    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlinesales = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.initManageStates();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     onlinesalesreportService.saveOnlinesales(obj);

    //     //$scope.modal.hide();
    //   }

    // }

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      $scope.getOnlineInvoiceDetails(manageOnlinesales.ikey);
      console.log($scope.manageOnlinesales);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: manageOnlinesales.partnerid
          },
          true
        );
        return selected.length
          ? selected[0].code + ", " + selected[0].name
          : "Not set";
      } else return "Not set";
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.onlinesales")
    .service("onlinesalesreportService", onlinesalesreportService);

  /** @ngInject */
  function onlinesalesreportService(Onlinesales, Machinesales) {
    var getShopsReportWithGames = function (obj) {
      Machinesales.shopsReportWithGames({
        filter: obj.params
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getAllPartnerShop = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();

      Onlinesales.getAllPartnerShop({
        adate: date1,
        bdate: date2,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        partnerid: obj.params.partnerid ? obj.params.partnerid : null,
        stateid: obj.params.stateid
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getBetweenDatesOnlinesales = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();
      console.log("client from date", fd);
      console.log("client from date1", date1);
      console.log("client to date", td);
      console.log("client to date2", date2);

      Onlinesales.getAllOnlinesales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        partnerid: obj.params.partnerid ? obj.params.partnerid : null,
        stateid: obj.params.stateid,
        kiosk: obj.params.kiosk ? obj.params.kiosk : null
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createOnlinesales = function (obj) {
      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      // getOnlinesales: getOnlinesales,
      //    getByDateOnlinesales: getByDateOnlinesales,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      // getDailyOnlinesales:getDailyOnlinesales,
      getBetweenDatesOnlinesales: getBetweenDatesOnlinesales,
      getShopsReportWithGames: getShopsReportWithGames,
      getAllPartnerShop: getAllPartnerShop
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.internalserverpr")
    .controller("internalServerPRPageCtrl", internalServerPRPageCtrl);

  /** @ngInject */
  function internalServerPRPageCtrl(
    $scope,
    $filter,
    validationService,
    toastr,
    $uibModal,
    $rootScope,
    zoneService,
    internalServerPRFileService,
    InternalServerOnlineSalesService,
    $state
  ) {
    $scope.selectedFile = null;
    $scope.manageFileList = [];
    $scope.manageOnlineSalesList = [];
    $scope.loading = false;
    $scope.detailLoading = false;

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        if ($rootScope.userData.credentials.role === 1) {
          $scope.manageZonesList = result;
        } else {
          $scope.manageZonesList = $rootScope.userData.credentials.zonemap
            ? result.filter(function (zone) {
                return $rootScope.userData.credentials.zonemap.includes(
                  zone.id
                );
              })
            : [];
        }
      };
      obj.onFailure = function (err) {
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.goToUploadPage = function () {
      $state.go("main.online.internalserverpr.upload");
    };

    $scope.reset = function () {
      $scope.reportFilter = {
        from: moment().startOf("day").toDate(),
        to: moment().endOf("day").toDate()
      };
    };
    $scope.reset();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.viewFile = function (item) {
      $scope.manageOnlineSalesList = [];
      $scope.selectedFile = item;

      $scope.detailLoading = true;

      InternalServerOnlineSalesService.getInternalServerPRFee({
        fileid: item.id
      })
        .then(
          function (res) {
            $scope.manageOnlineSalesList = res.result;
          },
          function (err) {
            toastr.error(err.data.message, "ERROR");
          }
        )
        .finally(function () {
          $scope.detailLoading = false;
        });
    };

    $scope.closeDetailPage = function () {
      $scope.selectedFile = null;
    };

    $scope.deleteFile = function (item) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/online/internalserverpr/modals/dangerModal.html",
        scope: $scope
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }

          internalServerPRFileService.deleteFile(item.id).then(
            function (res) {
              toastr.success("Data is deleted successfully", "SUCCESS");
              $scope.manageFileList = $scope.manageFileList.filter(
                function (file) {
                  return file.id !== item.id;
                }
              );
            },
            function (err) {
              toastr.error(err.data.message, "DELETE FAILED");
            }
          );
        },
        function () {}
      );
    };
    $scope.load = function () {
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.reportFilter.from) &&
        validationService.isEmptyOrNullValidation($scope.reportFilter.to)
      ) {
        if (
          !validationService.verifyDate($scope.reportFilter.from) ||
          !validationService.verifyDate($scope.reportFilter.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        $scope.loading = true;

        $scope.manageFileList = [];
        internalServerPRFileService
          .getList({
            created: {
              between: [
                moment($scope.reportFilter.from).toISOString(),
                moment($scope.reportFilter.to).toISOString()
              ]
            }
          })
          .then(function (res) {
            $scope.manageFileList = res;
          })
          .finally(function () {
            $scope.loading = false;
          });
      }
    };
    $scope.load();

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 25;
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.internalserverpr")
    .service("internalServerPRFileService", internalServerPRFileService);

  /** @ngInject */
  function internalServerPRFileService(InternalServerFile) {
    var getList = function (obj) {
      return InternalServerFile.find({
        filter: {
          where: obj,
          order: "created DESC",
        },
      }).$promise;
    };

    var create = function (obj) {
      var date = new Date();

      return InternalServerFile.create({
        created: date,
        lastupdated: date,
        name: obj.params.name,
        indate: obj.params.indate,
      }).$promise;
    };

    var deleteFile = function (id) {
      return InternalServerFile.deleteById({
        id: id,
      }).$promise;
    };

    return {
      getList: getList,
      create: create,
      deleteFile: deleteFile,
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.internalserverpr")
    .service(
      "InternalServerOnlineSalesService",
      InternalServerOnlineSalesService
    );

  /** @ngInject */
  function InternalServerOnlineSalesService(InternalServerOnlineSales) {
    var getInternalServerPRFee = function (obj) {
      return InternalServerOnlineSales.getInternalServerPRFee(obj).$promise;
    };

    var create = function (obj) {
      var date = new Date();
      //read data from gridoptions instead of table
      return InternalServerOnlineSales.createMany(obj.params).$promise;
    };

    return {
      getInternalServerPRFee: getInternalServerPRFee,
      create: create,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";
  angular
    .module("BlurAdmin.pages.online.internalserverpr")
    .controller(
      "internalServerPROnlinesalesPageCtrl",
      internalServerPROnlinesalesPageCtrl
    );

  /** @ngInject */
  function internalServerPROnlinesalesPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    onlinesalesService,
    toastr,
    $uibModal,
    SheetJSExportService,
    gameService,
    onlineShopService,
    shopService,
    validationService,
    $state,
    InternalServerOnlineSalesService,
    internalServerPRFileService
  ) {
    $scope.loading = false;

    $scope.smartTablePageSize = 100;
    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.manageGamesList = [];

    $scope.dpOpenStatus = {};
    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.formDate = {
      upload: moment().subtract(1, "days").toDate()
    };

    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {};
      gameService.getOnlineGame(obj);
    };

    $scope.init = function () {
      $scope.initManageGames();
      $scope.manageOnlinesales = {};
      $scope.gridOptions = {};

      var filename = document.querySelector("#uploadFile");
      angular.element(filename).val(null);
    };

    $scope.init();

    $scope.createOnlinesales = function (manageOnlinesales) {
      if (
        $scope.loading ||
        !$scope.gridOptions.data ||
        !$scope.gridOptions.data.length
      ) {
        return;
      }

      var uploadDate = moment($scope.formDate.upload, "DD-MM-YYYY").startOf(
        "day"
      );
      var cdate = moment();
      var indate = uploadDate.add(uploadDate.utcOffset(), "minutes"); //.subtract(1, 'days');

      var obj = {};
      obj.params = [];
      var invalidSales = [];

      var gsObj = {};
      gsObj.params = [];
      var filename = document.querySelector("#uploadFile");

      var formmattedFileName =
        filename.files && filename.files.length ? filename.files[0].name : null;

      var uploadKiosk = [];

      function parseNumber(data, columnName) {
        var _data = !!data ? data : "0";

        if (typeof _data === "string") {
          _data = _data.trim();
        }

        if (_data === "-") {
          _data = "0";
        }

        var result = _data
          .replace("MYR", "")
          .replace(/,/g, "")
          .replace("$", "");
        if (result.startsWith("(") && result.endsWith(")")) {
          result = result.replace("(", "").replace(")", "");
          if (!result.startsWith("-")) {
            result = result * -1;
          }
        }

        if (isNaN(result)) {
          throw new Error("Failed to get number from column " + columnName);
        }
        return +result;
      }

      function NetPurchaseAlgorithm(onlineShop, record) {
        var isFullShop = onlineShop.shop.shoptype === "100%";
        record.algorithm = "NP";

        if (isFullShop && onlineShop.onrate === 100) {
          // Sales = NP+ Bank
          // Net Collect = NP
          record.totalsales =
            Number(record.netpurchase) +
            Number(record.d_ewallet) +
            Number(record.d_cc) +
            Number(record.pe_payment_gateway) +
            Number(record.zpay_bank_in) +
            Number(record.zpay_qr_in) +
            Number(record.dgpay_qr_in) +
            Number(record.dgpay_bank_in) +
            Number(record.payment_gateway) -
            (Number(record.pg_out) +
              Number(record.pe_pgout) +
              Number(record.dgpay_w_bank_out)) +
            Number(record.tng_pin) +
            Number(record.vpay_tng_pin);
          record.csales = Number(record.netpurchase);
          record.net_collect = Number(record.netpurchase);
          record.psales = 0;

          var expenses =
            record.pshare -
            record.pwin +
            record.bonus_bet -
            record.bonus_win +
            record.pgsbonus;

          record.server_fee =
            (record.netgaming * record.server_fee_rate) / 100 + expenses;
          record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
          record.serverpr =
            (record.netgaming * Number(record.server_fee_rate)) / 100 +
            expenses;
        } else {
          record.totalsales = Number(
            Number(record.netpurchase) -
              Number(record.pshare) +
              Number(record.pwin)
          );

          record.d_ewallet_charge =
            Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
          record.d_cc_charge =
            Number((record.d_cc * record.d_cc_rate) / 100) || 0;
          record.pg_charge =
            Number(
              ((record.payment_gateway +
                record.dgpay_bank_in +
                record.d_ewallet +
                record.g_ewallet +
                record.dgpay_qr_in +
                record.zpay_bank_in +
                record.zpay_qr_in) *
                record.pg_rate) /
                100
            ) || 0;
          record.pg_out_charge =
            Number(
              ((record.pg_out + record.dgpay_w_bank_out) * record.pg_out_rate) /
                100
            ) || 0;

          var csales = Number(
            record.totalsales * Number(onlineShop.onrate / 100)
          );

          record.psales = Number(record.totalsales - csales);

          record.p_bonus_bets = Number(
            record.bonus_bet * Number(record.bet_rate / 100)
          );

          var finalCsales =
            csales + Number(record.pshare) - Number(record.pwin);

          var subCsales =
            Number(record.netpurchase) -
            Number(record.pshare) +
            Number(record.pwin) +
            Number(record.zpay_bank_in) +
            Number(record.zpay_qr_in) +
            Number(record.dgpay_qr_in) +
            Number(record.dgpay_bank_in) +
            Number(record.payment_gateway) +
            Number(record.pe_payment_gateway) +
            Number(record.d_ewallet) -
            (Number(record.pg_out) +
              Number(record.pe_pgout) +
              Number(record.dgpay_w_bank_out));
          record.csales =
            subCsales * Number(onlineShop.onrate / 100) +
            Number(record.pshare) -
            Number(record.pwin);

          var npSubtotal = subCsales + Number(record.g_ewallet);
          record.server_fee =
            (npSubtotal * Number(record.server_fee_rate)) / 100 +
            Number(record.pshare) -
            Number(record.pwin);
          record.pr_fee = (npSubtotal * Number(record.pr_fee_rate)) / 100;
          record.serverpr =
            npSubtotal * Number(onlineShop.onrate / 100) +
            Number(record.pshare) -
            Number(record.pwin);

          record.net_collect =
            finalCsales +
            record.p_bonus_bets -
            record.bonus_win -
            record.payment_gateway +
            +record.zpay_bank_in +
            record.zpay_qr_in +
            record.dgpay_qr_in +
            record.dgpay_bank_in +
            record.d_ewallet_charge +
            record.d_cc_charge +
            record.pg_charge +
            record.pg_out +
            record.pg_out_charge -
            record.d_ewallet -
            record.pe_payment_gateway +
            record.pe_pgout +
            record.dgpay_w_bank_out +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;
        }
      }

      function NetGamingAlgorithm(onlineShop, record) {
        record.algorithm = "NG";

        var isHalfShop = onlineShop.shop.shoptype === "5/5";
        var isHalfPR = onlineShop.shop.shoptype === "20%PR";

        record.totalsales = isHalfPR
          ? record.netgaming +
            record.angpao +
            record.promotion +
            record.fpromotion +
            record.commission
          : record.netgaming;

        var currentSales = Number(
          record.totalsales * Number(onlineShop.onrate / 100)
        );
        var currentPGout =
          Number(record.pg_out) +
          Number(record.pe_pgout) +
          Number(record.vpay_w_bank) +
          Number(record.luxepay_w_bank) +
          Number(record.dgpay_w_bank_out);

        var currentPGIn =
          Number(record.payment_gateway) +
          Number(record.zpay_bank_in) +
          Number(record.zpay_qr_in) +
          Number(record.dgpay_bank_in) +
          Number(record.dgpay_qr_in) +
          Number(record.vpay_d_bank) +
          Number(record.vpay_qr) +
          Number(record.luxepay_d_bank) +
          Number(record.luxepay_qr) +
          Number(record.d_ewallet) +
          Number(record.g_ewallet) +
          Number(record.pe_payment_gateway);

        record.d_ewallet_charge =
          Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
        record.d_cc_charge =
          Number((record.d_cc * record.d_cc_rate) / 100) || 0;
        record.pg_charge = (currentPGIn * record.pg_rate) / 100 || 0;
        record.pg_out_charge = (currentPGout * record.pg_out_rate) / 100 || 0;

        record.p_bonus_bets = Number(
          record.bonus_bet * Number(record.bet_rate / 100)
        );

        record.psales = Number(record.totalsales - currentSales);
        record.csales =
          currentSales +
          record.pshare -
          record.pwin +
          record.bonus_win +
          record.p_bonus_bets +
          record.caishen;

        // formula by MsThong
        var expenses =
          record.pshare -
          record.pwin +
          record.bonus_bet -
          record.bonus_win +
          record.pgsbonus;

        record.server_fee =
          (record.netgaming * record.server_fee_rate) / 100 + expenses;
        record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
        record.serverpr =
          (record.netgaming *
            (isHalfShop
              ? Number(onlineShop.onrate)
              : Number(record.server_fee_rate))) /
            100 +
          expenses;

        // deduct pgsbonus on csales when is 5/5 shop only
        if (isHalfShop) {
          record.csales = record.csales + record.pgsbonus;
        }

        if (isHalfPR) {
          var serverFeeTotal =
            (record.netgaming * Number(onlineShop.server)) / 100 +
            (record.pshare -
              record.pwin +
              record.bonus_win +
              record.p_bonus_bets +
              record.caishen +
              record.pgsbonus) -
            currentPGIn -
            record.d_ewallet -
            record.telco +
            currentPGout +
            record.pg_out_charge +
            record.pg_charge +
            record.d_ewallet_charge +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;

          record.net_collect =
            (record.totalsales * onlineShop.pr) / 100 + serverFeeTotal;
        } else {
          record.net_collect =
            record.csales -
            currentPGIn -
            record.d_ewallet -
            record.telco +
            currentPGout +
            record.pg_out_charge +
            record.pg_charge +
            record.d_ewallet_charge +
            record.tng_pin_charge -
            record.tng_pin -
            record.vpay_tng_pin;
        }
      }

      function NetGamingX2Algorithm(onlineShop, record) {
        record.algorithm = "NGX2";
        var isHalfPR = onlineShop.shop.shoptype === "20%PR";

        record.totalsales = isHalfPR
          ? record.netgaming +
            record.angpao +
            record.promotion +
            record.fpromotion +
            record.commission
          : record.netgaming * 2;

        var isHalfShop = onlineShop.shop.shoptype !== "100%";
        var currentSales = Number(
          record.totalsales * Number(onlineShop.onrate / 100)
        );
        var currentPGout =
          Number(record.pg_out) +
          Number(record.pe_pgout) +
          Number(record.vpay_w_bank) +
          Number(record.luxepay_w_bank) +
          Number(record.dgpay_w_bank_out);

        var currentPGIn =
          Number(record.payment_gateway) +
          Number(record.zpay_bank_in) +
          Number(record.zpay_qr_in) +
          Number(record.dgpay_bank_in) +
          Number(record.dgpay_qr_in) +
          Number(record.vpay_d_bank) +
          Number(record.vpay_qr) +
          Number(record.luxepay_d_bank) +
          Number(record.luxepay_qr) +
          Number(record.d_ewallet) +
          Number(record.g_ewallet) +
          Number(record.pe_payment_gateway);

        record.d_ewallet_charge =
          Number((record.d_ewallet * record.d_ewallet_rate) / 100) || 0;
        record.d_cc_charge =
          Number((record.d_cc * record.d_cc_rate) / 100) || 0;
        record.pg_charge = (currentPGIn * record.pg_rate) / 100 || 0;
        record.pg_out_charge = (currentPGout * record.pg_out_rate) / 100 || 0;
        record.p_bonus_bets = Number(
          record.bonus_bet * Number(record.bet_rate / 100)
        );

        record.psales = Number(record.totalsales - currentSales);

        // formula by MsThong
        var expenses =
          record.pshare -
          record.pwin +
          record.bonus_bet -
          record.bonus_win +
          record.pgsbonus;

        record.server_fee =
          (record.netgaming * record.server_fee_rate) / 100 + expenses;
        record.pr_fee = (record.netgaming * record.pr_fee_rate) / 100;
        record.serverpr =
          (record.netgaming *
            (isHalfShop
              ? Number(onlineShop.onrate)
              : Number(record.server_fee_rate))) /
            100 +
          expenses;

        record.csales =
          currentSales +
          record.pshare -
          record.pwin +
          record.bonus_win +
          record.p_bonus_bets +
          record.caishen;

        record.net_collect =
          record.csales -
          currentPGIn -
          record.d_ewallet -
          record.telco +
          currentPGout +
          record.pg_out_charge +
          record.pg_charge +
          record.d_ewallet_charge +
          record.tng_pin_charge -
          record.tng_pin -
          record.vpay_tng_pin;
      }

      $scope.gridOptions.data = $scope.gridOptions.data.map(function (dat) {
        var formatted = dat;
        Object.keys(formatted).forEach(function (key) {
          if (key) {
            formatted[key.toString().trim()] = dat[key];
          }
        });

        if (
          formatted.Kiosk &&
          uploadKiosk.indexOf(formatted.Kiosk.trim()) === -1
        ) {
          uploadKiosk.push(formatted.Kiosk.trim());
        }

        return formatted;
      });

      (uploadKiosk.length
        ? onlineShopService.getOnlineshopByFilter({
            params: {
              or: uploadKiosk.map(function (k) {
                var escaped = k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                return { playtechid: { regexp: "/^" + escaped + "$/i" } };
              })
            }
          })
        : Promise.resolve([])
      ).then(function (onlineshops) {
        var onlineShopsFromAPI = onlineshops || [];
        var dataLength = $scope.gridOptions.data.length;

        for (var i = 0; i < dataLength; i++) {
          var record = {};

          if (!$scope.gridOptions.data[i].Kiosk) {
            $scope.gridOptions.data[i].ERROR = "Blank Kiosk";
            invalidSales.push($scope.gridOptions.data[i]);
            continue;
          }

          record.playtechid = $scope.gridOptions.data[i].Kiosk.trim();
          var onlineShop = onlineShopsFromAPI.find(function (os) {
            return (
              record.playtechid &&
              os.playtechid.toLowerCase().toString() ===
                (record.playtechid || "").toLowerCase().toString()
            );
          });

          if (onlineShop === null || onlineShop === undefined) {
            $scope.gridOptions.data[i].ERROR = "No Shop Reference";
            invalidSales.push($scope.gridOptions.data[i]);
            continue;
          }

          try {
            record.wanzi_remarks = $scope.gridOptions.data[i].Remarks
              ? $scope.gridOptions.data[i].Remarks.trim()
              : "";
            record.cafe = parseNumber($scope.gridOptions.data[i].cafe, "Cafe");
            record.dart = parseNumber($scope.gridOptions.data[i].dart, "Dart");
            record.snooker = parseNumber(
              $scope.gridOptions.data[i].snooker,
              "Snooker"
            );
            record.snooker_fnb = parseNumber(
              $scope.gridOptions.data[i]["snooker F&B"],
              "Snooker F&B"
            );
            record.pshare = parseNumber($scope.gridOptions.data[i].PS, "PS");
            record.pwin = parseNumber($scope.gridOptions.data[i].PW, "PW");
            record.pgsbonus =
              parseNumber(
                $scope.gridOptions.data[i]["EVENT BONUS"],
                "EVENT BONUS"
              ) || 0;
            record.netpurchase = parseNumber(
              $scope.gridOptions.data[i].NP,
              "NP"
            );
            record.netgaming = parseNumber($scope.gridOptions.data[i].NG, "NG");
            record.angpao = parseNumber(
              $scope.gridOptions.data[i].Angpao,
              "Angpao"
            );
            record.commission = parseNumber(
              $scope.gridOptions.data[i].Commission,
              "Commission"
            );
            record.fpromotion = parseNumber(
              $scope.gridOptions.data[i].FPromotion,
              "FPromotion"
            );
            record.promotion = parseNumber(
              $scope.gridOptions.data[i].Promotion,
              "Promotion"
            );
            record.g_ewallet = 0;
            record.wanzi = parseNumber(
              $scope.gridOptions.data[i]["万字收"],
              "万字收"
            );

            record.wanzi_com = parseNumber(
              $scope.gridOptions.data[i]["公司佣金"],
              "公司佣金"
            );

            record.bonus_bet = parseNumber(
              $scope.gridOptions.data[i]["Token"],
              "Token"
            );
            record.bonus_win = parseNumber(
              $scope.gridOptions.data[i]["Lucky Wins"],
              "Lucky Wins"
            );
            record.payment_gateway = parseNumber(
              $scope.gridOptions.data[i].Bank,
              "Bank"
            );
            record.pg_rate = parseNumber(
              $scope.gridOptions.data[i]["Bank Rate %"],
              "Bank Rate %"
            );
            record.pe_payment_gateway = parseNumber(
              $scope.gridOptions.data[i]["PE Bank"],
              "PE_BANK"
            );
            record.pe_pgout = parseNumber(
              $scope.gridOptions.data[i]["PE Bank_Out"],
              "PE_BANK_OUT"
            );
            record.pg_out = parseNumber(
              $scope.gridOptions.data[i].Bank_Out,
              "Bank_Out"
            );
            record.pg_out_rate = parseNumber(
              $scope.gridOptions.data[i]["Bank_Out Rate %"],
              "Bank_Out Rate %"
            );
            record.d_ewallet = parseNumber(
              $scope.gridOptions.data[i]["e-wallet"],
              "e-wallet"
            );
            record.d_cc = 0; // || parseNumber($scope.gridOptions.data[i].d_cc, "d_cc");
            record.telco = parseNumber(
              $scope.gridOptions.data[i]["Telco"],
              "telco"
            );
            record.crypto = parseNumber(
              $scope.gridOptions.data[i]["Crypto Deposit"],
              "Crypto Deposit"
            );
            record.tng_pin = parseNumber(
              $scope.gridOptions.data[i]["Tng pin"],
              "Tng pin"
            );
            record.caishen = parseNumber(
              $scope.gridOptions.data[i]["Caishen"],
              "Caishen"
            );
            record.zpay_bank_in = parseNumber(
              $scope.gridOptions.data[i]["Zpay Bank In"],
              "Zpay Bank In"
            );
            record.zpay_qr_in = parseNumber(
              $scope.gridOptions.data[i]["Zpay QR In"],
              "Zpay QR In"
            );
            record.dgpay_bank_in = parseNumber(
              $scope.gridOptions.data[i]["DGpay D.Bank"],
              "DGpay D.Bank"
            );
            record.dgpay_qr_in = parseNumber(
              $scope.gridOptions.data[i]["DGpay QR"],
              "DGpay QR"
            );
            record.dgpay_w_bank_out = parseNumber(
              $scope.gridOptions.data[i]["DGpay W.Bank"],
              "DGpay W.Bank"
            );
            record.vpay_qr = parseNumber(
              $scope.gridOptions.data[i]["Vpay QR"],
              "Vpay QR"
            );
            record.vpay_d_bank = parseNumber(
              $scope.gridOptions.data[i]["Vpay D.Bank"],
              "Vpay D.Bank"
            );
            record.vpay_tng_pin = parseNumber(
              $scope.gridOptions.data[i]["Vpay Tng Pin"],
              "Vpay Tng Pin"
            );
            record.vpay_w_bank = parseNumber(
              $scope.gridOptions.data[i]["Vpay W.Bank"],
              "Vpay W.Bank"
            );
            record.luxepay_qr = parseNumber(
              $scope.gridOptions.data[i]["Luxepay QR"],
              "Luxepay QR"
            );
            record.luxepay_d_bank = parseNumber(
              $scope.gridOptions.data[i]["Luxepay D.Bank"],
              "Luxepay D.Bank"
            );
            record.luxepay_w_bank = parseNumber(
              $scope.gridOptions.data[i]["Luxepay W.Bank"],
              "Luxepay W.Bank"
            );
            record.wai_jiao_rate = $scope.gridOptions.data[i]["外交费%"];
            record.gong_shi_pan_rate =
              $scope.gridOptions.data[i]["盘口公司盘费%"];
            record.chang_zhu_rate = $scope.gridOptions.data[i]["跟场主收%"];

            record.wai_jiao_rate =
              record.wai_jiao_rate === "" || isNaN(record.wai_jiao_rate)
                ? 15
                : Number(record.wai_jiao_rate);
            record.gong_shi_pan_rate =
              record.gong_shi_pan_rate === "" || isNaN(record.gong_shi_pan_rate)
                ? 15
                : Number(record.gong_shi_pan_rate);
            record.chang_zhu_rate =
              record.chang_zhu_rate === "" || isNaN(record.chang_zhu_rate)
                ? 0
                : Number(record.chang_zhu_rate);
          } catch (err) {
            $scope.gridOptions.data[i].ERROR = err.message;
            invalidSales.push($scope.gridOptions.data[i]);
            continue;
          }

          if (!onlineShop.shop) {
            $scope.gridOptions.data[i].ERROR =
              "Online game not assign to shop.";
            invalidSales.push($scope.gridOptions.data[i]);
            continue;
          }

          record.shopid = onlineShop.shop.id;

          if (!onlineShop.gameid) {
            $scope.gridOptions.data[i].ERROR = "No Game Found";
            invalidSales.push($scope.gridOptions.data[i]);
            continue;
          }

          record.gameid = onlineShop.gameid;

          record.d_ewallet_rate = 2;
          record.d_cc_rate = onlineShop.shop.d_cc_rate || 0;

          record.bet_rate = onlineShop.bet_rate || 100;
          record.onrate = onlineShop.onrate || 0;
          record.server_fee_rate = Number(onlineShop.server) || 0;
          record.pr_fee_rate = Number(onlineShop.pr) || 0;
          record.tng_pin_rate = 5;
          record.tng_pin_charge =
            ((Number(record.tng_pin) + Number(record.vpay_tng_pin)) *
              record.tng_pin_rate) /
            100;

          if (onlineShop.algorithm === "NP") {
            NetPurchaseAlgorithm(onlineShop, record);
          } else if (onlineShop.algorithm === "NG") {
            NetGamingAlgorithm(onlineShop, record);
          } else if (onlineShop.algorithm === "NGX2") {
            NetGamingX2Algorithm(onlineShop, record);
          }

          record.created = cdate.toDate();
          record.lastupdated = cdate.toDate();
          record.indate = indate.toDate();

          obj.params.push(record);
        }

        if (!obj.params.length) {
          toastr.error("No valid sales record to upload!", "ERROR");
          $scope.loading = false;
          return;
        }

        obj.onSuccess = function (result) {
          $scope.gridOptions = {};

          $scope.loading = false;

          //$scope.dateList = {};
          if (invalidSales.length > 0) {
            $scope.gridOptions.data = invalidSales;
          } else {
            $scope.gridOptions = {};

            angular.element(filename).val(null);
            toastr.success(
              "New Online Sales has been saved successfully!",
              "SUCCESS"
            );
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "ERROR"
            );
          } else {
            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error("Issue with upload!", "ERROR");
            var errObj = [];

            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.Kiosk = err.config.data[i].playtechid;
                data.PS = err.config.data[i].pshare;
                data.PW = err.config.data[i].pwin;
                data.NP = err.config.data[i].netpurchase;
                data.NG = err.config.data[i].netgaming;
                if (typeof err.config.data[i].playtechid === "undefined") {
                  data.ERROR = "Blank Kiosk";
                } else if (err.config.data[i].shopid === null) {
                  data.ERROR = "No Shop Reference";
                }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        $scope.loading = true;

        internalServerPRFileService
          .create({
            params: {
              name: formmattedFileName || "UNKNOWN FILE NAME",
              indate: indate.toDate()
            }
          })
          .then(
            function (res) {
              var fileid = res.id;
              InternalServerOnlineSalesService.create({
                params: obj.params.map(function (p) {
                  p.fileid = fileid;
                  return p;
                })
              }).then(
                function (res) {
                  toastr.success(
                    "New Online Sales has been saved successfully!",
                    "SUCCESS"
                  );

                  setTimeout(function () {
                    $state.go("main.online.internalserverpr.list");
                  }, 100);
                },
                function (err) {
                  internalServerPRFileService.deleteFile(fileid).then();

                  $scope.loading = false;
                }
              );
            },
            function (err) {
              $scope.loading = false;
            }
          );
      });
    };

    $scope.goToListPage = function () {
      $state.go("main.online.internalserverpr.list");
    };

    $scope.confirmDelete = function (id) {
      if (confirm("Remove record?")) {
        $scope.gridOptions.data.splice(id, 1);
      }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.online.serversales")
    .controller("serverSalesreportPageCtrl", serverSalesreportPageCtrl);

  /** @ngInject */
  function serverSalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    partnersalesreportService,
    gameService,
    stateService,
    onlineserverService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    $rootScope,
    zoneService,
    receiptService
  ) {
    console.log("Inside serverSalesreportPageCtrl");

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        var userPartner = $rootScope.userData.credentials
          ? $rootScope.userData.credentials.partner
          : null;

        $scope.manageParentPartnerList = userPartner
          ? result.filter(function (res) {
              return (
                res.code === userPartner.code ||
                (!!userPartner.isparent && res.parentid === userPartner.id)
              );
            })
          : [];
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    // $scope.initManageParentPartner();

    $scope.reset = function () {
      $scope.reportFilter = {
        from: moment().startOf("month").toDate(),
        to: moment().toDate(),
      };
    };
    $scope.reset();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.searchGameSales = function () {
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.reportFilter.from) &&
        validationService.isEmptyOrNullValidation($scope.reportFilter.to)
      ) {
        if (
          !validationService.verifyDate($scope.reportFilter.from) ||
          !validationService.verifyDate($scope.reportFilter.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};
        obj.params.startDate = moment($scope.reportFilter.from).format(
          "YYYY-MM-DD"
        );
        obj.params.endDate = moment($scope.reportFilter.to).format(
          "YYYY-MM-DD"
        );

        if ($scope.reportFilter.zone) {
          obj.params.zoneid = $scope.reportFilter.zone
            ? "('" + $scope.reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = $scope.reportFilter.zone
              ? "('" + $scope.reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = $scope.reportFilter.shoptype
            ? $scope.reportFilter.shoptype.value
            : null;
        }

        if (!$scope.reportFilter.parent) {
          obj.params.parentid = $scope.manageParentPartnerList.map(function (
            res
          ) {
            return res.id;
          });
        } else {
          obj.params.parentid = $scope.reportFilter.parent
            ? [$scope.reportFilter.parent.id]
            : [];
        }

        if ($scope.reportFilter.state) {
          obj.params.stateid = $scope.reportFilter.state.id;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          if (result.result) {
            $scope.managePartnersalesList = result.result;
            $scope.managePartnersalesList.forEach(function (sales) {
              $scope.totalSalesLabel =
                $scope.totalSalesLabel + Number(sales.total);
            });

            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        console.log(obj);
        onlineserverService.getOnlineServerByShop(obj);
      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner();

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.partners.partnerinvoice")
    .controller("PartnerInvoicereportPageCtrl", PartnerInvoicereportPageCtrl);

  /** @ngInject */
  function PartnerInvoicereportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    partnerinvoicereportService,
    /*machineShopService,*/ gameService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    dailyonlinesalesreportService,
    dailymachinesalesreportService,
    $rootScope,
    receiptService
  ) {
    console.log("Inside PartnerInvoicereportPageCtrl");

    $scope.isAdmin =
      [1, 5].includes($rootScope.userData.roleId) ||
      ($rootScope.userData.roleId === 20 &&
        $rootScope.userData.credentials.partner.isparent);
    $scope.rate = {
      earn: 0,
      charge: 0,
      pr: 0
    };
    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {
      to: "",
      from: "",
      staff: ""
    };
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)
      ) {
        if (
          !validationService.verifyDate(dateList.from) ||
          !validationService.verifyDate(dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        isFormValidated = true;
        //toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {
        $scope.isEdit = false;
        $scope.isInvoice = false;
        var date1 = "";
        var date2 = "";

        if (dateList.from != "" && dateList.to != "") {
          var fd = new Date(dateList.from),
            y = fd.getFullYear(),
            m = fd.getMonth() + 1;
          date1 = y + "-" + m + "-" + fd.getDate();
          var td = new Date(dateList.to);
          y = td.getFullYear();
          m = td.getMonth() + 1;
          date2 = y + "-" + m + "-" + td.getDate();
        } else {
          var days = 60; // Days you want to subtract
          var td1 = new Date();
          var y1 = td1.getFullYear();
          var m1 = td1.getMonth() + 1;
          date2 = y1 + "-" + m1 + "-" + td1.getDate();

          var fd1 = new Date(td1.getTime() - days * 24 * 60 * 60 * 1000);
          var day = fd1.getDate();
          var month = fd1.getMonth() + 1;
          var year = fd1.getFullYear();
          date1 = year + "-" + month + "-" + day;
        }

        console.log("date1", date1);
        console.log("date2", date2);

        $scope.machineSalesOfPartner = {};
        $scope.machineSalesOfPartnerList = {};

        var obj = {};
        obj.params = {};
        obj.params.adate = date1;
        obj.params.bdate = date2;
        if (dateList.staff) {
          obj.params.partnerId = "(" + dateList.staff.id + ")";
        } else {
          if ($rootScope.userData.roleId == 9) {
            if ($scope.managePartnerList.length > 0) {
              var staffList = "";
              for (
                var index = 0;
                index < $scope.managePartnerList.length;
                index++
              ) {
                if (index == 0) {
                  staffList = "('" + $scope.managePartnerList[index].id + "'";
                } else {
                  staffList =
                    staffList + ",'" + $scope.managePartnerList[index].id + "'";
                }
              }
              staffList = staffList + ")";
              console.log("staffList", staffList);
              obj.params.partnerId = staffList;
            } else {
              obj.params.partnerId =
                "(" + $rootScope.userData.credentials.partner.id + ")";
            }
          } else {
            obj.params.partnerId =
              "(" + $rootScope.userData.credentials.partner.id + ")";
          }
        }
        console.log(obj.params);

        function filterPartnerStaffShops(result) {
          if ($rootScope.userData.roleId == 13) {
            return result.filter(function (r) {
              return r.code.contains(
                $rootScope.userData.credentials.partner.code
              );
            });
          }

          return result;
        }

        obj.onSuccess = function (result) {
          console.log("Inside searchMachinesales SUCCESS");
          console.log(result);
          $scope.totalSalesLabelFooter = 0;
          $scope.mPSalesTotal = 0;
          $scope.mCSalesTotal = 0;
          $scope.mSalesTotal = 0;
          $scope.npTotal = 0;
          $scope.oPSalesTotal = 0;
          $scope.oCSalesTotal = 0;
          $scope.oSalesTotal = 0;
          $scope.shopTotal = 0;
          $scope.compTotal = 0;
          $scope.shopOverTotal = 0;
          $scope.compOverTotal = 0;

          // result.result = filterPartnerStaffShops(result.result);

          $scope.machineSalesOfPartnerList = result;

          if (result.result && result.result.length) {
            for (var i = 0; i < result.result.length; i++) {
              var onMacTotalL2 =
                parseFloat(result.result[i].ontotal) +
                parseFloat(result.result[i].mactotal);
              $scope.machineSalesOfPartnerList.result[i].totalsales =
                onMacTotalL2;
              $scope.totalSalesLabelFooter =
                $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
              $scope.mPSalesTotal =
                $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
              $scope.mCSalesTotal =
                $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
              $scope.mSalesTotal =
                $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
              $scope.npTotal =
                $scope.npTotal + parseFloat(result.result[i].netpurchase);
              $scope.oPSalesTotal =
                $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
              $scope.oCSalesTotal =
                $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
              $scope.oSalesTotal =
                $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
              $scope.machineSalesOfPartnerList.result[i].shopTotal =
                parseFloat(result.result[i].mpsales) +
                parseFloat(result.result[i].opsales);
              $scope.machineSalesOfPartnerList.result[i].compTotal =
                parseFloat(result.result[i].mcsales) +
                parseFloat(result.result[i].ocsales);
              $scope.shopOverTotal =
                $scope.shopOverTotal +
                parseFloat(
                  $scope.machineSalesOfPartnerList.result[i].shopTotal
                );
              $scope.compOverTotal =
                $scope.compOverTotal +
                parseFloat(
                  $scope.machineSalesOfPartnerList.result[i].compTotal
                );
            }
          }

          console.log($scope.totalSalesLabelFooter);
        };
        obj.onFailure = function (err) {
          console.log("Inside searchMachinesales Failure");
        };
        partnerinvoicereportService.getMachinesalesByPartner(obj);
      }
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      // obj.params = {};
      obj.params.parentid = $rootScope.userData.credentials.partner.id;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
        $scope.managePartnerList.push($rootScope.userData.credentials.partner);
        $scope.searchMachinesales($scope.dateList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      if ($rootScope.userData.roleId == 9) {
        partnerService.getPartnerStaff(obj);
      } else if ($rootScope.userData.roleId == 17) {
        obj.params.parentid = null;
        obj.params.zoneid = null;

        partnerService.getPartnerStaff(obj);
      } else {
        partnerService.getPartner(obj);
      }
    };
    $scope.initManagePartner();

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      //$scope.getMachineSalesOfPartner(managePartnersales.partnerid);
      //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: gid
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.manageDailyinvoices = {};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

    $scope.viewInvoice = function (manageDailyinvoices) {
      console.log("Inside viewInvoice");
      $scope.isInvoice = true;
      $scope.manageDailyinvoices = manageDailyinvoices;
      $scope.manageDailyinvoices.invoicedate = $scope.dateFormater(
        $scope.manageDailyinvoices.ikey
      );
      console.log($scope.manageDailyinvoices);

      $scope.machineInvoiceDetails = {};
      $scope.shopInvoiceDetails = {};
      $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
      $scope.getMachineSales($scope.manageDailyinvoices.ikey);
    };

    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;

      $scope.onlineInvoiceDetails = {};

      obj.onSuccess = function (result) {
        console.log("Inside Online SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);

        $scope.wanziList = [];
        result.forEach(function (r) {
          if ((r.wanzi && r.wanzi > 0) || r.wanzi_remarks) {
            $scope.wanziList.push(r);
          }
        });

        // if (
        //   _.isEmpty($scope.machineInvoiceDetails) &&
        //   !_.isEmpty($scope.onlineInvoiceDetails)
        // ) {
        //   console.log("Inside Empty MachineShop");
        //   $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
        // }

        $scope.total.onlineST = 0;

        $scope.onlineInvoiceDetails = {
          NG: result
            .filter(function (r) {
              return r.algorithm === "NG";
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              return r;
            }),
          NP: result
            .filter(function (r) {
              return r.algorithm === "NP" || r.algorithm === null;
            })
            .map(function (r) {
              r.total_payment_gateway =
                Number(r.payment_gateway) +
                Number(r.pe_payment_gateway) +
                Number(r.zpay_bank_in) +
                Number(r.zpay_qr_in) +
                Number(r.dgpay_bank_in) +
                Number(r.dgpay_qr_in) +
                Number(r.fpay_qr) +
                Number(r.fpay_d_bank) +
                Number(r.skl_qr) +
                Number(r.skl_d_bank) +
                Number(r.vpay_qr) +
                Number(r.vpay_d_bank) +
                Number(r.novapay_qr) +
                Number(r.novapay_d_bank) +
                Number(r.luxepay_qr) +
                Number(r.luxepay_d_bank) +
                (r.shoptype === "100%" || r.shop.shoptype === "100%"
                  ? Number(r.telco) + Number(r.crypto)
                  : 0);
              r.total_pg_out =
                Number(r.pg_out) +
                Number(r.pe_pgout) +
                Number(r.fpay_w_bank) +
                Number(r.vpay_w_bank) +
                Number(r.novapay_w_bank) +
                Number(r.luxepay_w_bank) +
                Number(r.dgpay_w_bank_out);
              r.tng_pin = Number(r.tng_pin) + Number(r.vpay_tng_pin);
              r.d_ewallet = Number(r.d_ewallet) + Number(r.g_ewallet);
              return r;
            })
        };

        console.log("oid", $scope.onlineInvoiceDetails);

        $scope.shopInvoiceDetails = result.length > 0 && result[0].shop;

        $scope.total.NG_net_collect = 0;
        $scope.total.NP_net_collect = 0;
        $scope.total.NP_csales_total = 0;
        $scope.total.NP_totalsales = 0;

        var selected =
          $scope.onlineInvoiceDetails.NP[0] ||
          $scope.onlineInvoiceDetails.NG[0];

        if (selected) {
          var earn = selected.onrate
            ? selected.onrate
            : selected.playtechid === "WK8S6" && selected.shop.id === 1019
              ? 35
              : 0;
          var charge = Number(selected.server_fee_rate);
          var pr =
            selected.shop.shoptype === "20%PR"
              ? Number(selected.pr_fee_rate)
              : earn - charge;
          $scope.rate = {
            earn: earn,
            charge: charge,
            pr: pr
          };
        }

        $scope.total.NP_csales_total = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.csales);
          },
          0
        );

        $scope.total.NG_net_collect = $scope.onlineInvoiceDetails.NG.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_net_collect = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.net_collect);
          },
          0
        );

        $scope.total.NP_totalsales = $scope.onlineInvoiceDetails.NP.reduce(
          function (acc, curr) {
            return acc + Number(curr.totalsales);
          },
          0
        );

        // if ($scope.onlineInvoiceDetails.length > 0) {
        //   for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
        //     online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
        //   }
        //   $scope.total.online = online;
        //   $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
        // }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.getMachineSales = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        console.log($scope.manageDailyinvoices);
        $scope.machineInvoiceDetails = result;

        if (
          _.isEmpty($scope.onlineInvoiceDetails) &&
          !_.isEmpty($scope.machineInvoiceDetails)
        ) {
          console.log("Inside Empty OnlineShop");
          $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
        }

        var machine = 0;
        $scope.total.machineST = 0;
        if ($scope.machineInvoiceDetails.length > 0) {
          for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
            machine =
              machine + parseFloat($scope.machineInvoiceDetails[i].csales);
            $scope.machineInvoiceDetails[i].receipt =
              $scope.machineInvoiceDetails[i].receipt || {};
            $scope.machineInvoiceDetails[i].receipt.content = JSON.parse(
              $scope.machineInvoiceDetails[i].receipt.content || "{}"
            );
          }
          $scope.total.machine = machine;
          $scope.total.machineST =
            machine + parseFloat($scope.manageDailyinvoices.machineshorts);
        }
      };

      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    };

    $scope.shopInvoiceDetails = {};
    $scope.getManageShop = function (shopid) {
      var obj = {};
      obj.params = {};
      obj.params.shopid = shopid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getManageShop");
        console.log(result);
        $scope.shopInvoiceDetails = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure getManageShop");
        console.log(err);
      };
      shopService.getShopById(obj);
    };

    $scope.getTotal = function () {
      var total = 0;
      total =
        parseFloat($scope.total.onlineST) + parseFloat($scope.total.machineST);
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) {
          return x.mpsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) {
          return x.mcsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) {
          return x.mactotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) {
          return x.opsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalnetpurhase = function (items) {
      return items
        .map(function (x) {
          return x.netpurchase;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) {
          return x.ocsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) {
          return x.ontotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) {
          return x.shopTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) {
          return x.compTotal;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) {
          return x.totalsales;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    };
    $scope.shopFilter = "";
    $scope.viewShopInvoice = function (shopCode) {
      $scope.isEdit = true;
      $scope.shopFilter = shopCode;
    };

    $scope.getShopSalesOfPartner = function (shopSalesOfPartner) {
      $scope.isEdit = true;
      $scope.isInvoice = false;

      var obj = {};
      obj.params = {};
      //$scope.machineSalesOfPartner = {};
      $scope.shopSalesOfPartnerList = {};

      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.npTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      $scope.shopSalesOfPartnerList = shopSalesOfPartner;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 =
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal) +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter =
          $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal =
          $scope.mPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal =
          $scope.mCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal =
          $scope.mSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.npTotal =
          $scope.npTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].netpurchase);
        $scope.oPSalesTotal =
          $scope.oPSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal =
          $scope.oCSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oSalesTotal =
          $scope.oSalesTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mpsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal =
          parseFloat($scope.shopSalesOfPartnerList[i].mcsales) +
          parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.shopOverTotal =
          $scope.shopOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal =
          $scope.compOverTotal +
          parseFloat($scope.shopSalesOfPartnerList[i].compTotal);
      }
      console.log($scope.totalSalesLabelFooter);
    };

    $scope.showPartner = function (shopid) {
      if (shopid && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageShopList,
          {
            id: shopid
          },
          true
        );
        return selected.length
          ? selected[0].partner.code + ", " + selected[0].partner.name
          : "Not set";
      } else return "Not set";
    };
    $scope.showPartners = function (partner) {
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: partner
          },
          true
        );
        return selected.length
          ? selected[0].code + ", " + selected[0].name
          : "Not Set";
      } else return "Not set";
    };
    $scope.viewReceipts = {};
    $scope.imageString = "";
    $scope.zoomReceipts = function (receiptid) {
      console.log("receiptid", receiptid);

      var obj = {};
      obj.params = {};
      obj.params.receiptid = receiptid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        if (result[0]) {
          // $scope.viewReceipts = JSON.parse(result[0].content);
          // console.log($scope.viewReceipts);
          //console.log('Inside zoomReceipts', code);
          $scope.imageString = JSON.parse(result[0].content);
          console.log($scope.imageString);
          $scope.open(
            "app/pages/invoices/dailyinvoices/modals/receiptModal.html"
          );
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          var errdetails = [];
          errdetails = err.data.error.detail;
        }
      };
      receiptService.getReceipts(obj);
    };

    $scope.getFinalTotalPR = function () {
      return $scope.getFinalTotalEarn() - $scope.getFinalTotalCharge();
    };

    $scope.getFinalTotalCharge = function () {
      return $scope.getsubTotalCharge() + $scope.getTotalEarnCharge();
    };

    $scope.getFinalTotalEarn = function () {
      return $scope.getsubTotalEarn() + $scope.getTotalEarnCharge();
    };

    $scope.getTotalEarnCharge = function () {
      return (
        -$scope.getTotalGameOf("total_payment_gateway") -
        $scope.getTotalGameOf("d_ewallet") -
        $scope.getTotalGameOf("telco") -
        $scope.getTotalGameOf("crypto") +
        $scope.getTotalGameOf("tng_pin_charge") -
        $scope.getTotalGameOf("tng_pin") +
        $scope.getTotalGameOf("vpay_tng_pin") +
        $scope.getTotalGameOf("total_pg_out") +
        $scope.getTotalGameOf("pg_charge") +
        $scope.getTotalGameOf("pg_out_charge") +
        $scope.getTotalGameOf("d_ewallet_charge")
      );
    };

    $scope.getPGInRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_rate;
        });

      return (rate.pg_rate || 0) + "%";
    };

    $scope.getPGOutRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.pg_out_rate;
        });

      return (rate.pg_out_rate || 0) + "%";
    };

    $scope.getEwalletRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.d_ewallet_rate;
        });

      return (rate.d_ewallet_rate || 0) + "%";
    };

    $scope.getTngPinRate = function () {
      var rate = []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .find(function (dat) {
          return !!dat.tng_pin_rate;
        });

      return (rate.tng_pin_rate || 0) + "%";
    };

    $scope.parseToNegativeList = function (key) {
      var value = $scope.getTotalGameOf(key);
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.parseToNegative = function (value) {
      if (value === 0) {
        return value;
      }

      return -value;
    };

    $scope.getPRGameEarnSubtotal = function (item, type) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return item.pr_fee;
      // }

      if (type === "NP") {
        return $scope.getTotalNpEarn(item) - $scope.getTotalNpCharge(item);
      }
      return $scope.getTotalNgEarn(item) - $scope.getTotalNgCharge(item);
    };

    $scope.getTotalGame = function (tableData, type) {
      return (
        $scope.getTotalGameEarn(tableData, type) -
        $scope.getTotalGameCharge(tableData, type)
      );
    };

    $scope.getTotalGameEarn = function (item, type) {
      var isPR = item.shop.shoptype === "20%PR";
      if (isPR) {
        return (
          $scope.getTotalPRCharge(item) + $scope.getTotalGameCharge(item, "NG")
        );
      }

      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });
      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return (subtotal * rate) / 100;
    };

    $scope.getTotalGameCharge = function (item, type) {
      var prcompany = Number(item.server_fee_rate);
      var subtotal =
        type === "NP"
          ? $scope.getsubTotalNP(item)
          : $scope.getFullTotal(item, type);
      return (subtotal * prcompany) / 100;
    };

    $scope.getTotalPRCharge = function (item) {
      if (item.shop.shoptype !== "20%PR") {
        return 0;
      }

      return (
        ($scope.getFullTotal(item, item.shop.shoptype) *
          Number($scope.rate.pr)) /
        100
      );
    };

    $scope.getTotalGameName = function (item) {
      return "TOTAL " + item.game.name;
    };

    $scope.getGameName = function (item) {
      var onlineshop = item.shop.onlineshop.find(function (os) {
        return os.playtechid === item.playtechid;
      });
      var rate = item.onrate
        ? item.onrate
        : item.playtechid === "WK8S6" && item.shop.id === 1019
          ? 35
          : 0;
      return rate + "%" + " " + item.game.name;
    };

    $scope.getFullGameName = function (item, type) {
      var gameType = type === "NP" ? "Net Purchase" : "Net Gaming";
      return "100%" + " " + gameType + " - " + item.game.name;
    };

    $scope.getItemGameName = function (item) {
      return item.game & item.game.name ? item.game.name : "";
    };

    $scope.getsubTotalEarn = function () {
      var totalNpEarn = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);
          var onlineshop = item.shop.onlineshop.find(function (os) {
            return os.playtechid === item.playtechid;
          });
          var rate = item.onrate
            ? item.onrate
            : item.playtechid === "WK8S6" && item.shop.id === 1019
              ? 35
              : 0;

          var npEarn =
            (subtotal * rate) / 100 +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);
          totalNpEarn += npEarn;
        });
      }

      var totalNGEarn = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGEarn += $scope.getTotalNgEarn(item);
        });
      }

      return totalNpEarn + totalNGEarn;
    };

    $scope.getsubTotalCharge = function () {
      var totalNpCharge = 0;
      if ($scope.onlineInvoiceDetails.NP) {
        $scope.onlineInvoiceDetails.NP.forEach(function (item) {
          var prcompany = Number(item.server_fee_rate);
          var subtotal =
            $scope.getFullTotal(item, "NP") -
            Number(item.pshare) -
            Number(item.apshare) +
            Number(item.pwin) +
            Number(item.apwin);
          var npcharge = (subtotal * prcompany) / 100;

          totalNpCharge +=
            npcharge +
            Number(item.pshare) +
            Number(item.apshare) -
            Number(item.pwin) -
            Number(item.apwin);
        });
      }

      var totalNGCharge = 0;
      if ($scope.onlineInvoiceDetails.NG) {
        $scope.onlineInvoiceDetails.NG.forEach(function (item) {
          totalNGCharge += $scope.getTotalNgCharge(item);
        });
      }

      return totalNpCharge + totalNGCharge;
    };

    $scope.getsubTotalNP = function (item) {
      return (
        $scope.getFullTotal(item, "NP") -
        Number(item.pshare) -
        Number(item.apshare) +
        Number(item.pwin) +
        Number(item.apwin) +
        Number(item.total_payment_gateway) -
        Number(item.total_pg_out) +
        Number(item.d_ewallet)
      );
    };

    $scope.getTotalNpEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }

      return (
        $scope.getTotalGameEarn(item, "NP") +
        Number(item.pshare) +
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNpCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NP") +
        Number(item.pshare) +
        Number(item.apshare) -
        Number(item.pwin) -
        Number(item.apwin)
      );
    };

    $scope.getTotalNgCharge = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.server_fee);
      // }

      return (
        $scope.getTotalGameCharge(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) +
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    $scope.getTotalNgEarn = function (item) {
      // if (
      //   moment(item.indate, "YYYY-MM-DD")
      //     .utcOffset(8)
      //     .diff(moment("20230416").utcOffset(8).startOf("day")) &&
      //   item.shop.zoneid === 83
      // ) {
      //   return Number(item.serverpr);
      // }

      return (
        $scope.getTotalGameEarn(item, "NG") +
        Number(item.pshare) +
        Number(item.apshare) +
        Number(item.p_bonus_bets) -
        Number(item.pwin) +
        Number(item.apwin) +
        Number(item.bonus_win) +
        Number(item.caishen) +
        Number(item.plinko) +
        Number(item.pgsbonus)
      );
    };

    // type: NP | NG
    $scope.getFullTotal = function (item, type) {
      var field =
        type === "NP"
          ? "netpurchase"
          : type === "20%PR"
            ? "totalsales"
            : "netgaming";
      return Number(item[field]) || 0;
    };

    $scope.getTotalGameOf = function (key) {
      return []
        .concat($scope.onlineInvoiceDetails.NG || [])
        .concat($scope.onlineInvoiceDetails.NP || [])
        .filter(function (tdata) {
          return !!tdata[key];
        })
        .reduce(function (total, current) {
          return (total += current[key] ? Number(current[key]) : 0);
        }, 0);
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.partners.partnerinvoice')
    .service('partnerinvoicereportService', partnerinvoicereportService);

  /** @ngInject */
  function partnerinvoicereportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.partneraccount.partnerusers')
    .controller('PartnerUsersPageCtrl', PartnerUsersPageCtrl);

  /** @ngInject */
  function PartnerUsersPageCtrl($scope, $filter, editableOptions, editableThemes,
    userService, toastr, $uibModal, zoneService, roleService, $rootScope, rolemappingService, partnerService) {
    console.log("Inside PartnerUsersPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUser(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;
    $scope.status = [{value:'Active'},{value:'Inactive'}];
    $scope.emailVerified = [{value:'Yes'},{value:'No'}];

    //Getting Zones
    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Getting Roles
    $scope.manageRoleList=[];
    $scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
    //Getting Partners
    $scope.managePartnerList=[];
    $scope.initManagePartner = function (){
        var obj ={};
        obj.params={};
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          obj.params.zoneid=$rootScope.userData.credentials.zonemap;
        }else{
          obj.params.zoneid=null;
        }
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnerList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        partnerService.getPartner(obj);
    };
    //Getting Users   
    $scope.manageUsersList = [];
    $scope.manageUser = {};
    $scope.initManageUsers = function() {
      console.log('$rootScope.userData',$rootScope.userData);
      var obj = {};
      obj.params = {};
      obj.params.parentid = $rootScope.userData.credentials.partner.id;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsersList = result;
        $scope.initManageZones();
        $scope.initManageRole();
        $scope.initManagePartner();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getParterUsers(obj); 
    };
    $scope.initManageUsers();

    $scope.addUser = function() {
      //genericModalService.show('modules/modals/addUser.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageUsersList.push($scope.inserted);
    };

    $scope.createUser = function(manageUser) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUser");
      console.log(manageUser);

      var obj = {};
      obj.params = {};
      obj.params = manageUser;
      // obj.params.name = manageUser.name;
      // obj.params.description = manageUser.description;
      // obj.params.zoneid = manageUser.zones
      // obj.params.stateid = manageUser.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('New User has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New User successfully created.");
        $scope.initManageUsers();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      userService.createUser(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/partneraccount/users/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteUser = function(res) {
      console.log("Inside deleteUser");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('User has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","User successfully deleted.");
          $scope.initManageUsers();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.deleteUser(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editUser = function(state) {
      console.log("Inside editUser");
      console.log(state);
      // $scope.manageUser.id = $scope.manageUser.id;
      // $scope.manageUser.name = state.name;
      // $scope.manageUser.description = state.description;
      // $scope.manageUser.created = state.created;
      // $scope.manageUser.lastupdated = state.lastupdated;
      $scope.manageUser = state;
      genericModalService.show('modules/modals/addUser.html', $scope);
    };

    $scope.getPartnersForSave = function(user) {
      console.log('getPartnersForSave',user);
      if (user && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          code: user.username
        },true);

        if (selected.length){
          $scope.savePartner(user,selected[0].id);
        }
      }
    };

    $scope.savePartner = function (managePartner, id) {

      console.log("Inside savePartner");
      console.log(managePartner);
      console.log(id);

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = managePartner.credentials.name;
        obj.params.contact = managePartner.credentials.mobile;
        
        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartner = {};
          toastr.success('Partner has been saved successfully!', 'SUCCESS');
          $scope.initManageUsers();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnerService.savePartner(obj);

    };

    $scope.saveUser = function(manageUser, userid) {

      console.log("Inside saveUser");
      console.log(manageUser);
      console.log(userid);

      if (userid === undefined) {
        $scope.createUser(manageUser);
      } else {

        var objRoleMap = {};
        objRoleMap.params = {};
        objRoleMap.params.principalid = userid;
        objRoleMap.params.roleid = manageUser.role;

  
        objRoleMap.onSuccess = function(result) {
          console.log("Inside SUCCESS objRoleMap");
          console.log(result);
         
            var objUpdateRole = {};
            objUpdateRole.params = {};
            if (result[0]){
            objUpdateRole.params.id = result[0].id;
            }
            objUpdateRole.params.userid = userid;
            objUpdateRole.params.roleid = manageUser.role;
            objUpdateRole.onSuccess = function(result) {
              console.log("Inside SUCCESS objUpdateRole");
              console.log(result);

              var obj = {};
              obj.params = {};
              obj.params.id = userid;
              obj.params.credentials ={};
              obj.params.credentials.name = manageUser.name;
              obj.params.credentials.mobile = manageUser.mobile;
              obj.params.credentials.zonemap = manageUser.zonemap;
              obj.params.credentials.role = manageUser.role;
              obj.params.credentials.partner = manageUser.partner;
              obj.params.emailVerified = manageUser.emailVerified.value==='Yes'?true:false;

              console.log(obj.params);
      
              obj.onSuccess = function(result) {
                console.log("Inside SUCCESS");
                console.log(result);
                $scope.manageUser = {};
                $scope.getPartnersForSave(result);
                //toastr.success('User has been updated successfully!', 'SUCCESS');

      
              }
              obj.onFailure = function(err) {
                console.log("Inside Failure");
                console.log(err);
                if (err.status === -1) {
                  toastr.error('NO INTERNET CONNECTION', 'Error');
                } else {
                  toastr.error(err.data.error.message, 'Error');
                }
              }
              userService.saveUser(obj);
            }
            objUpdateRole.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                toastr.error('NO INTERNET CONNECTION', 'Error');
              } else {
                toastr.error(err.data.error.message, 'Error');
              }
            };
            rolemappingService.saveRoleMapping(objUpdateRole);
        };
        objRoleMap.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(err.data.error.message, 'Error');
          }
        };
        rolemappingService.getRoleMappingsbyID(objRoleMap);
      }
    }

    $scope.showStatus = function(status) {
        var selected = [];
        if(typeof status==="object") {
          //selected = $filter('filter')($scope.status, {value: status.value});
          return status.value ? status.value : 'Not set';
        }else{
            return status;
        }
      };

      $scope.showAccess = function(emailVerified) {
          var selected = [];
          if(typeof emailVerified==="object") {
            //selected = $filter('filter')($scope.status, {value: status.value});
            return emailVerified.value? emailVerified.value : 'No';
          }else{
              return emailVerified?'Yes' : 'No';
          }
        };

        $scope.showRoles = function(role) {
          if (role && $scope.manageRoleList.length) {
            var selected = $filter('filter')($scope.manageRoleList, {
              id: role
            },true);
            return selected.length ? selected[0].name : 'Not set';
          } else return 'Not set';
        };

        $scope.showZones = function(zone) {
          if (zone && $scope.manageZonesList.length) {
            var selected = $filter('filter')($scope.manageZonesList, {
              id: zone
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.showPartners = function(partner) {
          if (partner && $scope.managePartnerList.length) {
            var selected = $filter('filter')($scope.managePartnerList, {
              id: partner
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.generatePassword = function() {
          var length = 8,
              charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
              retVal = "";
          for (var i = 0, n = charset.length; i < length; ++i) {
              retVal += charset.charAt(Math.floor(Math.random() * n));
          }
          return retVal;
      };

      $scope.newPassword="";

      $scope.openPassword = function(page, size) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope: $scope,
          size: size
        });
        modalInstance.result.then(function(selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        }, function() {
          console.log('Modal dismissed at: ' + new Date());
        });
      };

    $scope.resetPassword = function (userid) {
      console.log('userid', userid);
      $scope.newPassword = $scope.generatePassword();
      console.log('newPassword',$scope.newPassword);

      var obj = {};
      obj.params = {};
      obj.params.id = userid;
      obj.params.password = $scope.newPassword;

      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('User has been updated successfully!', 'SUCCESS');
        $scope.initManageUsers();
        $scope.openPassword('app/pages/account/users/modals/passwordModal.html');

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          toastr.error(err.data.error.message, 'Error');
        }
      };
      userService.resetPassword(obj);

    };
        
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector')
    .controller('CollectorreportPageCtrl', CollectorreportPageCtrl);

  /** @ngInject */
  function CollectorreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorreportService, zoneService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside CollectorreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];

    $scope.searchSales = function (dateList) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log('dateList.zone',dateList.zone);
        console.log('dateList.shoptype',dateList.shoptype);
        
        obj.params.adate = date1;
        obj.params.bdate = date2;
        obj.params.shoptype = dateList.shoptype?dateList.shoptype.value:null;
        obj.params.zoneid = dateList.zone?dateList.zone.id:null;


        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          $scope.totalSalesLabel = 0;

          $scope.managePartnersalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.managePartnersalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.initManageCollector = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.managePartnersalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       collectorreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     collectorreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      // if (managePartnersales.id === undefined) {
      //   $scope.createMachinesales(managePartnersales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = managePartnersales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.managePartnersales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   collectorreportService.saveMachinesales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      console.log($scope.managePartnersales.sname);
      $scope.getSalesOfShop(managePartnersales.partnerid,managePartnersales.shopid );
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      collectorreportService.getGrpSalesForShopInRange(obj);
    }

    // $scope.showGameById = function (gid) {
    //   if (gid && $scope.manageGamesList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: gid
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set';
    // };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    // $scope.showPartnerById = function (managePartnersales) {
    //   if (managePartnersales.shop && $scope.managePartnerList.length) {
    //     var selected = $filter('filter')($scope.managePartnerList, {
    //       id: $scope.managePartnersales.shop.partnerid
    //     },true);
    //     return selected.length ? selected[0].code : 'Not set';
    //   } else return 'Not set'
    // };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.collector')
    .service('collectorreportService', collectorreportService);

  /** @ngInject */
  function collectorreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales')
    .controller('DailymachinesalesreportPageCtrl', DailymachinesalesreportPageCtrl);

  /** @ngInject */
  function DailymachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService) {
    console.log("Inside DailymachinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        $scope.totalSalesLabel = 0;
        for (var i = 0; i < result.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageMachinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.getDailyMachinesales(obj);
    };
    $scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachinesalesreportService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/reports/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachinesalesreportService.generateInvoice(obj);
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachinesales')
    .service('dailymachinesalesreportService', dailymachinesalesreportService);

  /** @ngInject */
  function dailymachinesalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where:{
            indate:{"gte": dailyDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop')
    .controller('DailymachineshopPageCtrl', DailymachineshopPageCtrl);

  /** @ngInject */
  function DailymachineshopPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineshopService, dailymachinesalesreportService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, $uibModal) {
    console.log("Inside DailymachineshopPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    // $scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    //get previous days machine sales readings from machine sales table
    /*
    $scope.managePrevMachineReadingList = [];
    $scope.initManagePrevMachineReading = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManagePrevMachineReading");
        console.log(result);
        $scope.managePrevMachineReadingList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machinesalesService.getMachinesales(obj);
    };
    */

    //machinesalesService.getMachinesales(obj);
    $scope.totalSalesLabel = 0;
    $scope.manageDailymachineshop = {};
    $scope.manageDailymachineshopList = [];
    $scope.initManageStates = function() {

      var d = new Date(); 
      // convert browser timestamp to UTC so that its in sync with your db date/time and zone
      var m = d.getUTCMonth() + 1;
      var date = d.getUTCFullYear() + '-' + m + '-' + d.getUTCDate();
      console.log('date', date);

      var obj = {};
      obj.params = {};
      obj.params.adate = date;
      console.log('obj', obj);
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        $scope.initManagePartner();
        //$scope.initManageGames();
        $scope.initManageMachineShop();
        $scope.totalSalesLabel = 0;
        //$scope.initManagePrevMachineReading();
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
        }
        $scope.manageDailymachineshopList = result;
        console.log($scope.manageDailymachineshopList);
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //dailymachineshopService.getDailyMachinesales(obj);
      dailymachineshopService.getDailyGroupedMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.deleteId = null;
/*
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/dailymachineshop/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };
*/

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageDailymachineshop = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageDailymachineshop, id) {

      console.log("Inside saveMachinesales");
      console.log(manageDailymachineshop);
      console.log(manageDailymachineshop.id);

      if (manageDailymachineshop.id === undefined) {
        $scope.createMachinesales(manageDailymachineshop);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageDailymachineshop;
        /*        obj.params.id = manageDailymachineshop.id;
                obj.params.playtechid= manageDailymachineshop.playtechid;
                obj.params.pshare= manageDailymachineshop.pshare;
                obj.params.pwin= manageDailymachineshop.pwin;
                obj.params.netpurchase= manageDailymachineshop.netpurchase;
                obj.params.netgaming= manageDailymachineshop.netgaming;
                obj.params.totalsales= manageDailymachineshop.totalsales;
                obj.params.csales= manageDailymachineshop.csales;
                obj.params.psales= manageDailymachineshop.psales;
                obj.params.shopid= manageDailymachineshop.shopid;
                obj.params.gameid= manageDailymachineshop.gameid;
                // obj.params.name = $scope.manageDailymachineshop.name;
                // obj.params.description = $scope.manageDailymachineshop.description;
                //obj.params.created = $scope.manageDailymachineshop.created;
        */
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.manageDailymachineshop = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailymachineshopService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.salesNumbers = {};
    $scope.viewMachinesales = function(manageDailymachineshop) {
      console.log("Inside viewMachinesales");
      console.log(manageDailymachineshop);
      $scope.isEdit = true;
      $scope.manageDailymachineshop = manageDailymachineshop;
            
      console.log(manageDailymachineshop.ikey);
      $scope.machineSalesInvoice = {};
      $scope.getMachineInvoiceDetails(manageDailymachineshop.ikey);
      console.log($scope.machineSalesInvoice);
      $scope.getMachineSales(manageDailymachineshop.ikey);
      console.log($scope.machineSalesDetails);
    };

    $scope.getMachineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.getMachineSales = function(ikey) {
      var obj = {};
      $scope.machineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function(result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.machineSalesDetails = result;
        var data = {};
        var shopDetails = $scope.getShopDetails($scope.machineSalesDetails[0].shopid);
        console.log(shopDetails)
        console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(shopDetails.shop.partnerid);
        data.created = shopDetails.shop.created;
        $scope.salesNumbers.data = data;
      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      }
      dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
    }

    $scope.getTotalAmount = function(items) {
      return items
          .map(function(x) { return x.totalsales; })
          .reduce(function(a, b) { return parseInt(a) + parseInt(b); });
    };
    
    $scope.showPartnerById = function(partnerid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (partnerid && $scope.managePartnerList.length) {
        //console.log($scope.manageDailymachineshop);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.getShopDetails = function(shopid) {
      if (shopid &&  $scope.manageMachineShopList.length){
        var selected = $filter('filter')($scope.manageMachineShopList, {shopid: shopid
        },true);
        console.log(selected);
        return selected.length ? selected[0] : null;
      }else return null;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports.dailymachineshop')
    .service('dailymachineshopService', dailymachineshopService);

  /** @ngInject */
  function dailymachineshopService(Machinesales) {
    var getDailyMachinesales = function (obj) {

      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.find({
        filter: {
          where: {
            indate: {
              "gte": dailyDate
            }
          },
          include: ["machine", "shop"]
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyGroupedMachinesales = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpShop({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function (obj) {
      Machinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    /*  var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
*/
    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyGroupedMachinesales: getDailyGroupedMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey
      //      createMachinesales: createMachinesales,
      //      deleteMachinesales: deleteMachinesales
      //    saveMachinesales: saveMachinesales
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.reports.dailyonlinesales")
    .controller(
      "DailyonlinesalesreportPageCtrl",
      DailyonlinesalesreportPageCtrl
    );

  /** @ngInject */
  function DailyonlinesalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    dailyonlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    toastr,
    $uibModal,
    dailyInvoiceService
  ) {
    console.log("Inside DailyonlinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.totalSalesLabel = 0;
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        $scope.totalSalesLabel = 0;
        for (var i = 0; i < result.length; i++) {
          //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          $scope.totalSalesLabel =
            $scope.totalSalesLabel +
            parseFloat(result[i].netpurchase) +
            parseFloat(result[i].pshare) +
            parseFloat(result[i].apshare) +
            parseFloat(result[i].pwin) +
            parseFloat(result[i].apwin);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast("scroll.refreshComplete");
    };
    $scope.initManageStates();
    /*
    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOnlinesalesList.push($scope.inserted);
    };
*/
    $scope.createOnlinesales = function (manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlinesales.id;
      obj.params.playtechid = manageOnlinesales.playtechid;
      obj.params.pshare = manageOnlinesales.pshare;
      obj.params.apshare = manageOnlinesales.apshare;
      obj.params.pwin = manageOnlinesales.pwin;
      obj.params.apwin = manageOnlinesales.apwin;
      obj.params.netpurchase = manageOnlinesales.netpurchase;
      obj.params.netgaming = manageOnlinesales.netgaming;
      obj.params.totalsales = manageOnlinesales.totalsales;
      obj.params.csales = manageOnlinesales.csales;
      obj.params.psales = manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success(
          "New Onlinesales has been saved successfully!",
          "SUCCESS"
        );
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      dailyonlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/reports/dailyonlinesales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function (res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Onlinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyonlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveOnlinesales = function (manageOnlinesales, id) {
      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid = manageOnlinesales.playtechid;
        obj.params.pshare = manageOnlinesales.pshare;
        obj.params.apshare = manageOnlinesales.apshare;
        obj.params.pwin = manageOnlinesales.pwin;
        obj.params.apwin = manageOnlinesales.apwin;
        obj.params.netpurchase = manageOnlinesales.netpurchase;
        obj.params.netgaming = manageOnlinesales.netgaming;
        obj.params.totalsales = manageOnlinesales.totalsales;
        obj.params.csales = manageOnlinesales.csales;
        obj.params.psales = manageOnlinesales.psales;
        obj.params.shopid = manageOnlinesales.shopid;
        obj.params.gameid = manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success("Onlinesales has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, "ERROR");
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        dailyonlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }
    };

    /*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      console.log($scope.manageOnlinesales);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales.shop && $scope.managePartnerList.length) {
        console.log($scope.manageOnlinesales);
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: $scope.manageOnlinesales.shop.partnerid
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.getInDate = function (date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
        date.getFullYear()
      ].join("/");
    };

    // $scope.genIvoiceOnlinesales =function (manageOnlinesalesList){
    //   console.log('Inside genIvoiceOnlinesales');
    //   console.log(manageOnlinesalesList);

    //   if (manageOnlinesalesList.length){
    //     var date = new Date();
    //     //var invoiceDate = new Date();
    //     //invoiceDate.setDate(date.getDate() - 1);

    //     var objInvoice = {};
    //     objInvoice.params=[];
    //     for (var index = 0; index < manageOnlinesalesList.length; index++) {
    //       var recordInvoice = {};

    //       var ikeyString = manageOnlinesalesList[index].ikey.toString();
    //       var ikeyDate = ikeyString.substring(ikeyString.length - 8);
    //       var shopid = parseInt(ikeyString.substring(0, ikeyString.length - 8));
    //       console.log('ikeyDate',ikeyDate);

    //       var tempDate = ikeyDate.substring(2,4)+'/'+ikeyDate.substring(0,2)+'/'+ikeyDate.substring(4,8);

    //       var invoiceDate = new Date(tempDate);
    //       var indate = new Date();
    //       // indate.setDate(indate.getDate()-1);
    //       console.log('invoiceDate',invoiceDate);

    //       recordInvoice.invoicedate = invoiceDate;
    //       recordInvoice.indate = $scope.getInDate(indate);
    //       recordInvoice.created = date;
    //       recordInvoice.lastupdated = date;
    //       recordInvoice.ikey = manageOnlinesalesList[index].ikey;
    //       recordInvoice.shopid = shopid;
    //       recordInvoice.zoneid = manageOnlinesalesList[index].shop.zoneid;
    //       objInvoice.params.push(recordInvoice);
    //     }
    //     console.log(objInvoice.params);

    //     objInvoice.onSuccess = function (result) {
    //       console.log("Inside SUCCESS genIvoiceOnlinesales");
    //       console.log(result);
    //       toastr.success('New Invoice has been generated successfully!', 'SUCCESS');

    //     }
    //     objInvoice.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
    //     };

    //     dailyInvoiceService.createInvoice(objInvoice);
    //   }

    // }
    $scope.getInDate = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
        date.getFullYear()
      ].join("/");
    };

    $scope.genIvoiceOnlinesales = function () {
      console.log("Inside genIvoiceMachinesales");

      var adate = new Date();
      console.log("adate", adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate, 2);
      console.log("obj.params.adate", obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log("Inside result.length ");

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            var newInDate = new Date(invoiceList[index].indate);
            var resultInDate = $scope.getInDate(newInDate, 0);

            recordInvoice.invoicedate = resultInDate;
            recordInvoice.indate = resultInDate;
            recordInvoice.created = date;
            recordInvoice.lastupdated = date;
            recordInvoice.ikey = invoiceList[index].ikey;
            recordInvoice.shopid = invoiceList[index].shopid;
            recordInvoice.zoneid = invoiceList[index].zoneid;

            if (!_.isEmpty(recordInvoice)) {
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success(
              "New Invoice has been generated successfully!",
              "SUCCESS"
            );
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success(
              "All Pending Invoices are generated successfully!",
              "SUCCESS"
            );
          };
          if (objInvoice.params.length) {
            dailyInvoiceService.createInvoice(objInvoice);
          } else {
            toastr.error("No Pending Invoices", "ERROR");
          }
        } else {
          toastr.error("No Pending Invoices", "ERROR");
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlinesalesreportService.generateInvoiceOnline(obj);
    };
  }
})();

// /**
//  * @author a.demeshko
//  * created on 12/29/15
//  */
// (function() {
//   'use strict';

//   angular.module('BlurAdmin.pages.reports.dailyonlinesales')
//     .service('dailyonlinesalesreportService', dailyonlinesalesreportService);

//   /** @ngInject */
//   function dailyonlinesalesreportService(Onlinesales) {
//     var getOnlinesales = function(obj) {

//       var days = 1; // Days you want to subtract
//       var td = new Date();
//       var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
//       var day =fd.getDate();
//       var month=fd.getMonth()+1;
//       var year=fd.getFullYear();
  
//       var dailyDate = year+'-'+month+'-'+day;
  
//       console.log('date',dailyDate);

//       Onlinesales.find({
//         filter: {
//           where:{
//             indate:{"gte": dailyDate}
//           },
//           include: ["game","shop"]
//         }
//       }).$promise.then(function(data) {
//     //  Onlinesales.find().$promise.then(function(data) {
//         //$ionicLoading.hide();
//         console.log(data);
//         obj.onSuccess(data);

//       }, function(err) {
//         //$ionicLoading.hide();
//         //console.log(err)
//         obj.onFailure(err);
//       });
//     };
// /*    var getByDateOnlinesales = function(obj) {
//       Onlinesales.find({
// //  Post.find({where: {and: [{title: 'My Post'}, {content: 'Hello'}]}},
// //          function (err, posts)

//         filter: {
//           where: {
//             and: [

//             ]
//           include: "gamecat"
//         }
//       }).$promise.then(function(data) {
//         //$ionicLoading.hide();
//         obj.onSuccess(data);
//       }, function(err) {
//         //$ionicLoading.hide();
//         obj.onFailure(err);
//       });
//     }; */

//     var getDailyOnlinesalesByKey = function(obj) {
//       Onlinesales.find({
//         filter: {
//           where: {
//             ikey:obj.params.ikey
//           },
//           include: ["game","shop"]
//         }
//       }).$promise.then(function(data) {
//         obj.onSuccess(data);
//       }, function(err) {
//         obj.onFailure(err);
//       });
//     };

//     var createOnlinesales = function(obj) {
//       //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

//       var date = new Date();

//       Onlinesales.create({
//         id: obj.params.id,
//         playtechid: obj.params.playtechid,
//         pshare: obj.params.pshare,
//         pwin: obj.params.pwin,
//         netpurchase: obj.params.netpurchase,
//         netgaming: obj.params.netgaming,
//         totalsales: obj.params.totalsales,
//         csales: obj.params.csales,
//         psales: obj.params.psales,
//         created: date,
//         lastupdated: date

//       }).$promise.then(function(data) {
//         //$ionicLoading.hide();
//         //console.log(data);
//         obj.onSuccess(data);

//       }, function(err) {
//         //$ionicLoading.hide();
//         //console.log(err)
//         obj.onFailure(err);
//       });
//     };


//     var deleteOnlinesales = function(obj) {
//       //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

//       Onlinesales.deleteById({
//         id: obj.params.id
//       }).$promise.then(function(data) {
//         //$ionicLoading.hide();
//         //console.log(data);
//         obj.onSuccess(data);

//       }, function(err) {
//         //$ionicLoading.hide();
//         //console.log(err)
//         obj.onFailure(err);
//       });
//     };

//     var saveOnlinesales = function(obj) {
//       //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

//       var date = new Date();

//       Onlinesales.prototype$patchAttributes({
//         id: obj.params.id,
//         playtechid: obj.params.playtechid,
//         pshare: obj.params.pshare,
//         pwin: obj.params.pwin,
//         netpurchase: obj.params.netpurchase,
//         netgaming: obj.params.netgaming,
//         totalsales: obj.params.totalsales,
//         csales: obj.params.csales,
//         psales: obj.params.psales,
//         shopid: obj.params.shopid,
//         gameid: obj.params.gameid,
//         lastupdated: date
//       }).$promise.then(function(data) {
//         //$ionicLoading.hide();
//         //console.log(data);
//         obj.onSuccess(data);

//       }, function(err) {
//         //$ionicLoading.hide();
//         //console.log(err)
//         obj.onFailure(err);
//       });
//     };

//     var generateInvoiceOnline = function (obj) {

//       Onlinesales.generateInvoiceOnline({
//         adate: obj.params.adate
//       }).$promise.then(function (data) {
//         obj.onSuccess(data);

//       }, function (err) {
//         obj.onFailure(err);
//       });
//     };

//     return {
//       getOnlinesales: getOnlinesales,
//       getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
//       createOnlinesales: createOnlinesales,
//       deleteOnlinesales: deleteOnlinesales,
//       saveOnlinesales: saveOnlinesales,
//       generateInvoiceOnline:generateInvoiceOnline
//     };

//   }

// })();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.reports.dailyonlineshop")
    .controller("DailyonlineshopreportPageCtrl", DailyonlineshopreportPageCtrl);

  /** @ngInject */
  function DailyonlineshopreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    dailyonlineshopreportService,
    dailyonlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    toastr,
    $uibModal,
    dailyInvoiceService
  ) {
    console.log("Inside DailyonlineshopreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlineshop = {};
    $scope.manageOnlineshopList = [];
    $scope.totalSalesLabel = 0;
    $scope.initManageStates = function () {
      var d = new Date();
      // convert local date to UTC date so that its in sync with your db date/time and zone

      var m = d.getUTCMonth() + 1;
      var date = d.getUTCFullYear() + "-" + m + "-" + d.getUTCDate();
      console.log("date", date);

      var obj = {};
      obj.params = {};
      obj.params.adate = date;
      console.log("obj", obj);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        $scope.totalSalesLabel = 0;
        //console.log(result.result.length)
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabel =
            $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlineshopList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailyonlineshopreportService.getDailyGroupedOnlinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();
    /*
    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageOnlineshopList.push($scope.inserted);
    };
*/
    $scope.createOnlinesales = function (manageOnlineshop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlineshop.name);
      //console.log(manageOnlineshop.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlineshop.id;
      obj.params.playtechid = manageOnlineshop.playtechid;
      obj.params.pshare = manageOnlineshop.pshare;
      obj.params.apshare = manageOnlineshop.apshare;
      obj.params.pwin = manageOnlineshop.pwin;
      obj.params.apwin = manageOnlineshop.apwin;
      obj.params.netpurchase = manageOnlineshop.netpurchase;
      obj.params.netgaming = manageOnlineshop.netgaming;
      obj.params.totalsales = manageOnlineshop.totalsales;
      obj.params.csales = manageOnlineshop.csales;
      obj.params.psales = manageOnlineshop.psales;

      //obj.params.description = manageOnlineshop.description;
      console.log(manageOnlineshop);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlineshop = {};
        toastr.success(
          "New Onlinesales has been saved successfully!",
          "SUCCESS"
        );
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      dailyonlineshopreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    // $scope.confirmDelete = function(id) {
    //   $scope.open('app/pages/reports/dailyonlinesales/modals/dangerModal.html');
    //   $scope.deleteId = id;
    // };

    // $scope.deleteOnlinesales = function(res) {
    //   console.log("Inside deleteOnlinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Onlinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
    //       $scope.initManageStates();
    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.deleteOnlinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // }

    $scope.editState = function (onlinesales) {
      console.log("Inside viewOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlineshop.id = $scope.manageOnlineshop.id;
      // $scope.manageOnlineshop.name = state.name;
      // $scope.manageOnlineshop.description = state.description;
      // $scope.manageOnlineshop.created = state.created;
      // $scope.manageOnlineshop.lastupdated = state.lastupdated;
      $scope.manageOnlineshop = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    // $scope.saveOnlinesales = function(manageOnlineshop, id) {

    //   console.log("Inside saveOnlinesales");
    //   console.log(manageOnlineshop);
    //   console.log(manageOnlineshop.id);

    //   if (manageOnlineshop.id === undefined) {
    //     $scope.createOnlinesales(manageOnlineshop);
    //   } else {

    //     var obj = {};
    //     obj.params = {};
    //     obj.params = manageOnlineshop;
    //     obj.params.id = manageOnlineshop.id;
    //     obj.params.playtechid= manageOnlineshop.playtechid;
    //     obj.params.pshare= manageOnlineshop.pshare;
    //     obj.params.pwin= manageOnlineshop.pwin;
    //     obj.params.netpurchase= manageOnlineshop.netpurchase;
    //     obj.params.netgaming= manageOnlineshop.netgaming;
    //     obj.params.totalsales= manageOnlineshop.totalsales;
    //     obj.params.csales= manageOnlineshop.csales;
    //     obj.params.psales= manageOnlineshop.psales;
    //     obj.params.shopid= manageOnlineshop.shopid;
    //     obj.params.gameid= manageOnlineshop.gameid;
    //     // obj.params.name = $scope.manageOnlineshop.name;
    //     // obj.params.description = $scope.manageOnlineshop.description;
    //     //obj.params.created = $scope.manageOnlineshop.created;

    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageOnlineshop = {};
    //       toastr.success('Onlinesales has been saved successfully!', 'SUCCESS');
    //       //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
    //       $scope.initManageStates();

    //     }
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //         toastr.error('NO INTERNET CONNECTION', 'Error');
    //       } else {
    //         var errdetails = [];
    //         errdetails = err.data.error.detail;
    //         toastr.error(errdetails, 'ERROR');
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     }
    //     dailyonlineshopreportService.saveOnlinesales(obj);
    //     //$scope.modal.hide();
    //   }
    // }

    /*
    $scope.datePickerPopup = function(onlinesales) {
        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
*/
    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewOnlinesales = function (manageOnlineshop) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlineshop = manageOnlineshop;
      console.log($scope.manageOnlineshop);
      console.log(manageOnlineshop.ikey);
      $scope.onlineSalesInvoice = {};
      $scope.getOnlineInvoiceDetails(manageOnlineshop.ikey);
      console.log($scope.onlineSalesInvoice);
      $scope.getOnlineSales(manageOnlineshop.ikey);
      console.log($scope.onlineSalesDetails);
    };

    $scope.getOnlineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    };
    $scope.lookupDetails = {};
    $scope.getOnlineSales = function (ikey) {
      var obj = {};
      $scope.onlineSalesDetails = {};
      obj.params = {};
      obj.params.ikey = ikey;
      obj.onSuccess = function (result) {
        console.log("Inside Machine SUCCESS");
        console.log(result);
        $scope.onlineSalesDetails = result;
        var data = {};
        //var shopDetails = $scope.getShopDetails($scope.onlineSalesDetails[0].shopid);
        //console.log(shopDetails)
        //console.log(shopDetails.shop.partnerid)
        data.partnerName = $scope.showPartnerById(
          $scope.onlineSalesDetails[0].shop.partnerid
        );
        data.created = $scope.onlineSalesDetails[0].shop.created;
        $scope.lookupDetails.data = data;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (partnerid) {
      if (partnerid && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: partnerid
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.genIvoiceOnlinesales = function (manageOnlineshopList) {
      console.log("Inside genIvoiceOnlinesales");
      console.log(manageOnlineshopList);

      if (manageOnlineshopList.length) {
        var date = new Date();
        var invoiceDate = new Date();
        invoiceDate.setDate(date.getDate() - 1);

        var objInvoice = {};
        objInvoice.params = [];
        for (var index = 0; index < manageOnlineshopList.length; index++) {
          var recordInvoice = {};

          recordInvoice.invoicedate = invoiceDate;
          recordInvoice.created = date;
          recordInvoice.lastupdated = date;
          recordInvoice.ikey = manageOnlineshopList[index].ikey;

          objInvoice.params.push(recordInvoice);
        }
        console.log(objInvoice.params);

        objInvoice.onSuccess = function (result) {
          console.log("Inside SUCCESS genIvoiceOnlinesales");
          console.log(result);
          toastr.success(
            "New Invoice has been generated successfully!",
            "SUCCESS"
          );
        };
        objInvoice.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          toastr.success(
            "All Pending Invoices are generated successfully!",
            "SUCCESS"
          );
        };

        dailyInvoiceService.createInvoice(objInvoice);
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.reports.dailyonlineshop")
    .service("dailyonlineshopreportService", dailyonlineshopreportService);

  /** @ngInject */
  function dailyonlineshopreportService(Onlinesales) {
    var getOnlinesales = function (obj) {
      var days = 1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - days * 24 * 60 * 60 * 1000);
      var day = fd.getDate();
      var month = fd.getMonth() + 1;
      var year = fd.getFullYear();

      var dailyDate = year + "-" + month + "-" + day;

      console.log("date", dailyDate);

      Onlinesales.find({
        filter: {
          where: {
            indate: { gte: dailyDate }
          },
          include: ["game", "shop"]
        }
      }).$promise.then(
        function (data) {
          //  Onlinesales.find().$promise.then(function(data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };
    /*    var getByDateOnlinesales = function(obj) {
      Onlinesales.find({
//  Post.find({where: {and: [{title: 'My Post'}, {content: 'Hello'}]}},
//          function (err, posts)

        filter: {
          where: {
            and: [

            ]
          include: "gamecat"
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);
      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    }; */

    var getDailyGroupedOnlinesales = function (obj) {
      Onlinesales.grpShop({
        adate: obj.params.adate
      }).$promise.then(
        function (data) {
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var getDailyOnlinesalesByKey = function (obj) {
      Onlinesales.find({
        filter: {
          where: {
            ikey: obj.params.ikey
          }
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getOnlinesales: getOnlinesales,
      getDailyOnlinesalesByKey: getDailyOnlinesalesByKey,
      getDailyGroupedOnlinesales: getDailyGroupedOnlinesales
      //    getByDateOnlinesales: getByDateOnlinesales,
      //createOnlinesales: createOnlinesales,
      //deleteOnlinesales: deleteOnlinesales,
      //saveOnlinesales: saveOnlinesales
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing')
    .controller('MarketingreportPageCtrl', MarketingreportPageCtrl);

  /** @ngInject */
  function MarketingreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    marketingreportService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, zoneService) {
    console.log("Inside MarketingreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'}];

    //getting Zones    
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.manageMarketingsales = {};
    $scope.manageMarketingsalesList = [];

    $scope.searchSales = function (dateList) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;
        obj.params.shoptype = dateList.shoptype?dateList.shoptype.value:null;
        obj.params.zoneid = dateList.zone?dateList.zone.id:null;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          $scope.totalSalesLabel = 0;

          $scope.manageMarketingsalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.manageMarketingsalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        marketingreportService.getGrpSalesInRange(obj)
      }
    };

    $scope.initManageMarketing = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
//     $scope.initManageStates = function() {
//       var obj = {};
//       obj.params = {};
//       obj.params.fromDt = $scope.dateList.from;
//       obj.params.toDt = $scope.dateList.to;

//       obj.onSuccess = function(result) {
//         console.log("Inside SUCCESS");
//         console.log(result);
//         $scope.initManagePartner();
//         $scope.initManageGames();
// //        $scope.initManageMachineShop();
//         //$scope.initManagePrevMachineReading();
//         $scope.manageMarketingsalesList = result;
//         $scope.isEdit = false;
//       };
//       obj.onFailure = function(err) {
//         console.log("Inside Failure");
//         console.log(err);
//       };
//       marketingreportService.getBetweenDatesMachinesales(obj);
//       //$scope.$broadcast('scroll.refreshComplete');
//     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/marketing/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     marketingreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewSales");
      console.log(onlinesales);

      $scope.manageMarketingsales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveSales = function(manageMarketingsales, id) {

      console.log("Inside saveSales");
      console.log(manageMarketingsales);
      console.log(manageMarketingsales.id);

      // if (manageMarketingsales.id === undefined) {
      //   $scope.createMachinesales(manageMarketingsales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = manageMarketingsales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.manageMarketingsales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   marketingreportService.saveSales(obj);

      //   //$scope.modal.hide();
      // }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewSales = function (manageMarketingsales) {
      console.log("Inside viewSales");
      $scope.isEdit = true;
      $scope.manageMarketingsales = manageMarketingsales;
      console.log($scope.manageMarketingsales.partnerid);
      console.log($scope.manageMarketingsales.sname);
      $scope.getSalesOfShop(manageMarketingsales.partnerid,manageMarketingsales.shopid );
    //  $scope.getMachineSalesPrevReadings(manageMarketingsales.mid);
    };

    $scope.getSalesOfShop = function(partnerid,sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;

      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      marketingreportService.getGrpSalesForShopInRange(obj);
    }

    // $scope.showGameById = function (gid) {
    //   if (gid && $scope.manageGamesList.length) {
    //     var selected = $filter('filter')($scope.manageGamesList, {
    //       id: gid
    //     },true);
    //     return selected.length ? selected[0].name : 'Not set';
    //   } else return 'Not set';
    // };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    // $scope.showPartnerById = function (manageMarketingsales) {
    //   if (manageMarketingsales.shop && $scope.managePartnerList.length) {
    //     var selected = $filter('filter')($scope.managePartnerList, {
    //       id: $scope.manageMarketingsales.shop.partnerid
    //     },true);
    //     return selected.length ? selected[0].code : 'Not set';
    //   } else return 'Not set'
    // };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.marketing')
    .service('marketingreportService', marketingreportService);

  /** @ngInject */
  function marketingreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.reports.onlinesales")
    .controller("OnlinesalesreportPageCtrl", OnlinesalesreportPageCtrl);

  /** @ngInject */
  function OnlinesalesreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    onlinesalesreportService,
    onlineShopService,
    gameService,
    shopService,
    partnerService,
    dailyInvoiceService,
    toastr,
    $uibModal,
    validationService
  ) {
    console.log("Inside OnlinesalesreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };
    $scope.totalSalesLabel = 0;
    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    //user.birthday = new Date(user.birthday);
    $scope.dateList = {};
    $scope.searchOnlinesales = function (dateList) {
      console.log("Inside searchOnlinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)
      ) {
        if (
          !validationService.verifyDate(dateList.from) ||
          !validationService.verifyDate(dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          //console.log(result);
          $scope.totalSalesLabel = 0;
          for (var i = 0; i < result.length; i++) {
            //$scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
            $scope.totalSalesLabel =
              $scope.totalSalesLabel +
              parseFloat(result[i].netpurchase) +
              parseFloat(result[i].pshare) +
              parseFloat(result[i].apshare) +
              parseFloat(result[i].pwin) +
              parseFloat(result[i].apwin);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageOnlinesalesList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      }
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.getOnlineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.onlineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getOnlineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.onlineSalesInvoice = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageShop();
        for (var i = 0; i < result.length; i++) {
          $scope.totalSalesLabel =
            $scope.totalSalesLabel + parseFloat(result[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.manageOnlinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlinesalesreportService.getBetweenDatesOnlinesales(obj);
      //onlinesalesreportService.getOnlinesales(obj);
      $scope.$broadcast("scroll.refreshComplete");
    };
    //    $scope.initManageStates();
    /*
        $scope.addState = function() {
          //genericModalService.show('modules/modals/addState.html',$scope);
          $scope.inserted = {
            name: null,
            description: null,
          };
          $scope.manageOnlinesalesList.push($scope.inserted);
        };
    */
    $scope.createOnlinesales = function (manageOnlinesales) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createOnlinesales");
      //console.log(manageOnlinesales.name);
      //console.log(manageOnlinesales.description);

      var obj = {};
      obj.params = {};

      obj.params.id = manageOnlinesales.id;
      obj.params.playtechid = manageOnlinesales.playtechid;
      obj.params.pshare = manageOnlinesales.pshare;
      obj.params.apshare = manageOnlinesales.apshare;
      obj.params.pwin = manageOnlinesales.pwin;
      obj.params.apwin = manageOnlinesales.apwin;
      obj.params.netpurchase = manageOnlinesales.netpurchase;
      obj.params.netgaming = manageOnlinesales.netgaming;
      obj.params.totalsales = manageOnlinesales.totalsales;
      obj.params.csales = manageOnlinesales.csales;
      obj.params.psales = manageOnlinesales.psales;

      //obj.params.description = manageOnlinesales.description;
      console.log(manageOnlinesales);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlinesales = {};
        toastr.success(
          "New Onlinesales has been saved successfully!",
          "SUCCESS"
        );
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Onlinesales successfully created.");
        $scope.initManageStates();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      onlinesalesreportService.createOnlinesales(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/reports/onlinesales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteOnlinesales = function (res) {
      console.log("Inside deleteOnlinesales");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Onlinesales has been deleted successfully!",
            "SUCCESS"
          );
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Onlinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        onlinesalesreportService.deleteOnlinesales(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (onlinesales) {
      console.log("Inside editOnlinesales");
      console.log(onlinesales);
      // $scope.manageOnlinesales.id = $scope.manageOnlinesales.id;
      // $scope.manageOnlinesales.name = state.name;
      // $scope.manageOnlinesales.description = state.description;
      // $scope.manageOnlinesales.created = state.created;
      // $scope.manageOnlinesales.lastupdated = state.lastupdated;
      $scope.manageOnlinesales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveOnlinesales = function (manageOnlinesales, id) {
      console.log("Inside saveOnlinesales");
      console.log(manageOnlinesales);
      console.log(manageOnlinesales.id);

      if (manageOnlinesales.id === undefined) {
        $scope.createOnlinesales(manageOnlinesales);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageOnlinesales;
        obj.params.id = manageOnlinesales.id;
        obj.params.playtechid = manageOnlinesales.playtechid;
        obj.params.pshare = manageOnlinesales.pshare;
        obj.params.apshare = manageOnlinesales.apshare;
        obj.params.pwin = manageOnlinesales.pwin;
        obj.params.apwin = manageOnlinesales.apwin;
        obj.params.netpurchase = manageOnlinesales.netpurchase;
        obj.params.netgaming = manageOnlinesales.netgaming;
        obj.params.totalsales = manageOnlinesales.totalsales;
        obj.params.csales = manageOnlinesales.csales;
        obj.params.psales = manageOnlinesales.psales;
        obj.params.shopid = manageOnlinesales.shopid;
        obj.params.gameid = manageOnlinesales.gameid;
        // obj.params.name = $scope.manageOnlinesales.name;
        // obj.params.description = $scope.manageOnlinesales.description;
        //obj.params.created = $scope.manageOnlinesales.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlinesales = {};
          toastr.success("Onlinesales has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, "ERROR");
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        onlinesalesreportService.saveOnlinesales(obj);

        //$scope.modal.hide();
      }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editOnlinesales = function (manageOnlinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageOnlinesales = manageOnlinesales;
      $scope.getOnlineInvoiceDetails(manageOnlinesales.ikey);
      console.log($scope.manageOnlinesales);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showShops = function (shop) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (shop && $scope.manageShopList.length) {
        var selected = $filter("filter")(
          $scope.manageGamesList,
          {
            id: game.id
          },
          true
        );
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showPartnerById = function (manageOnlinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageOnlinesales.shop && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: manageOnlinesales.shop.partnerid
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.reports.onlinesales")
    .service("onlinesalesreportService", onlinesalesreportService);

  /** @ngInject */
  function onlinesalesreportService(Onlinesales) {
    var getOnlinesales = function (obj) {
      Onlinesales.find({
        filter: {
          include: ["game", "shop"]
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getDailyOnlinesales = function (obj) {
      var d = new Date(),
        y = d.getFullYear(),
        m = d.getMonth();
      var date = y + "-" + m + "-" + d.getUTCDate();
      console.log("date", date);

      Onlinesales.find({
        filter: {
          where: {
            created: date
          },
          include: ["game", "shop"]
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var getBetweenDatesOnlinesales = function (obj) {
      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();

      var td = new Date(to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();
      console.log("client from date", fd);
      console.log("client from date1", date1);
      console.log("client to date", td);
      console.log("client to date2", date2);

      Onlinesales.find({
        filter: {
          where: {
            and: [{ indate: { gte: date1 } }, { indate: { lte: date2 } }]
          },
          include: ["game", "shop"]
        }
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.create({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        created: date,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Onlinesales.deleteById({
        id: obj.params.id
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveOnlinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$patchAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        apshare: obj.params.apshare,
        pwin: obj.params.pwin,
        apwin: obj.params.apwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        shopid: obj.params.shopid,
        gameid: obj.params.gameid,
        lastupdated: date
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getOnlinesales: getOnlinesales,
      //    getByDateOnlinesales: getByDateOnlinesales,
      createOnlinesales: createOnlinesales,
      deleteOnlinesales: deleteOnlinesales,
      saveOnlinesales: saveOnlinesales,
      getDailyOnlinesales: getDailyOnlinesales,
      getBetweenDatesOnlinesales: getBetweenDatesOnlinesales
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales')
    .controller('MachinesalesreportPageCtrl', MachinesalesreportPageCtrl);

  /** @ngInject */
  function MachinesalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal) {
    console.log("Inside MachinesalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.initManageGames();
          $scope.initManagePartner();
          $scope.initManageGames();
          $scope.totalSalesLabel = 0;
          for (var i=0; i<result.length;i++){
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.initManageMachineShop();
          //$scope.initManagePrevMachineReading();
          $scope.manageMachinesalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesreportService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageMachinesalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machinesalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;
      $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function(ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function(result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }
    
    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid, shopid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {machineid: machineid } && {shopid:shopid }
        ,true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageMachinesales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageMachinesales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageMachinesales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.machinesales')
    .service('machinesalesreportService', machinesalesreportService);

  /** @ngInject */
  function machinesalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      console.log('client from date',fd);
      console.log('client from date1',date1); 
      console.log('client to date',td);
      console.log('client to date2',date2); 

      Machinesales.find({
              filter: {
                where:{
                  and:[
                    {indate: {gte: date1}},
                    {indate: {lte: date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales')
    .controller('PartnersalesreportPageCtrl', PartnersalesreportPageCtrl);

  /** @ngInject */
  function PartnersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnersalesreportService, /*machineShopService,*/gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal, dailyonlinesalesreportService, dailymachinesalesreportService) {
    console.log("Inside PartnersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        // td.setHours(23);
        // td.setMinutes(59);
        // td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        console.log('From',fd);
        console.log('TO',td);
        obj.params.adate = date1;
        obj.params.bdate = date2;

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;

          $scope.managePartnersalesList = result;
          for (var i = 0; i < result.result.length; i++) {
            var onmacTotal = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
            $scope.managePartnersalesList.result[i].total = onmacTotal;
            $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
          }
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        partnersalesreportService.getGrpMacSalesInRange(obj);
      }
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
//        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.managePartnersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/partnersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(managePartnersales, id) {

      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      if (managePartnersales.id === undefined) {
        $scope.createMachinesales(managePartnersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = managePartnersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      $scope.getMachineSalesOfPartner(managePartnersales.partnerid);
    //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getMachineSalesOfPartner = function(partnerid) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = "("+partnerid+")";
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.mPSalesTotal = 0;
        $scope.mCSalesTotal = 0;
        $scope.mSalesTotal = 0;
        $scope.oPSalesTotal = 0;
        $scope.oCSalesTotal = 0;
        $scope.oSalesTotal = 0;
        $scope.shopTotal = 0;
        $scope.compTotal = 0;
        $scope.shopOverTotal = 0;
        $scope.compOverTotal = 0;

        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 = parseFloat(result.result[i].ontotal)+ parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + onMacTotalL2;
          $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat(result.result[i].mpsales);
          $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat(result.result[i].mcsales);
          $scope.mSalesTotal = $scope.mSalesTotal + parseFloat(result.result[i].mactotal);
          $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat(result.result[i].opsales);
          $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat(result.result[i].ocsales);
          $scope.oSalesTotal = $scope.oSalesTotal + parseFloat(result.result[i].ontotal);
          $scope.machineSalesOfPartnerList.result[i].shopTotal = parseFloat(result.result[i].mpsales)+ parseFloat(result.result[i].opsales);
          $scope.machineSalesOfPartnerList.result[i].compTotal = parseFloat(result.result[i].mcsales)+ parseFloat(result.result[i].ocsales);
          $scope.shopOverTotal = $scope.shopOverTotal + $scope.machineSalesOfPartnerList.result[i].shopTotal;
          $scope.compOverTotal = $scope.compOverTotal + $scope.machineSalesOfPartnerList.result[i].compTotal;

        }
        console.log($scope.totalSalesLabelFooter);
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      }
      partnersalesreportService.getMachinesalesByPartner(obj);
    }

    $scope.showGameById = function (gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    // $scope.showMachineShops = function (machineid) {
    //   if (machineid && $scope.manageMachineShopList.length) {
    //     var selected = $filter('filter')($scope.manageMachineShopList, {
    //       machineid: machineid
    //     },true);
    //     return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
    //   } else return 'Not set'
    // };

    $scope.showPartnerById = function (managePartnersales) {
      if (managePartnersales.shop && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.managePartnersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    $scope.manageDailyinvoices={};
    $scope.onlineInvoiceDetails = {};
    $scope.machineInvoiceDetails = {};
    $scope.total = {};
    $scope.total.online = 0;
    $scope.total.onlineST = 0;
    $scope.total.machine = 0;
    $scope.total.machineST = 0;

     $scope.viewInvoice = function (manageDailyinvoices) {
       console.log("Inside viewInvoice");
       $scope.isInvoice = true;
       $scope.manageDailyinvoices = manageDailyinvoices;
       if ($scope.manageDailyinvoices.ikey){
        $scope.manageDailyinvoices.invoicedate = $scope.dateFormater($scope.manageDailyinvoices.ikey);
       }
       console.log($scope.manageDailyinvoices);
 
       $scope.onlineInvoiceDetails = {};
       $scope.machineInvoiceDetails = {};
       $scope.shopInvoiceDetails = {};
       $scope.getOnlineSales($scope.manageDailyinvoices.ikey);
       $scope.getMachineSales($scope.manageDailyinvoices.ikey);
 
     };
 
     $scope.getOnlineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Online SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.onlineInvoiceDetails = result;
 
         if (_.isEmpty($scope.machineInvoiceDetails) && !(_.isEmpty($scope.onlineInvoiceDetails))) {
           console.log('Inside Empty MachineShop');
           $scope.getManageShop($scope.onlineInvoiceDetails[0].shopid);
         }

         var online = 0;
         $scope.total.onlineST=0;
         if ($scope.onlineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.onlineInvoiceDetails.length; i++) {
             online = online + parseFloat($scope.onlineInvoiceDetails[i].csales);
           }
           $scope.total.online = parseFloat(online);
           $scope.total.onlineST = online + parseFloat($scope.manageDailyinvoices.onlineshorts);
         }
       }
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailyonlinesalesreportService.getDailyOnlinesalesByKey(obj);
     };
 
     $scope.getMachineSales = function (ikey) {
       var obj = {};
       obj.params = {};
       obj.params.ikey = ikey;
       obj.onSuccess = function (result) {
         console.log("Inside Machine SUCCESS");
         console.log(result);
         console.log($scope.manageDailyinvoices);
         $scope.machineInvoiceDetails = result;
 
         if (_.isEmpty($scope.onlineInvoiceDetails) && !(_.isEmpty($scope.machineInvoiceDetails))) {
           console.log('Inside Empty OnlineShop');
           $scope.getManageShop($scope.machineInvoiceDetails[0].shopid);
         }

         var machine = 0;
         $scope.total.machineST=0;
         if ($scope.machineInvoiceDetails.length > 0) {
           for (var i = 0; i < $scope.machineInvoiceDetails.length; i++) {
             machine = machine + parseFloat($scope.machineInvoiceDetails[i].csales);
           }
           $scope.total.machine = parseFloat(machine);
           $scope.total.machineST = machine + parseFloat($scope.manageDailyinvoices.machineshorts);
         }
       }
 
       obj.onFailure = function (err) {
         console.log("Inside Failure");
       }
       dailymachinesalesreportService.getDailyMachinesalesByKey(obj);
     };
 
     $scope.shopInvoiceDetails = {};
     $scope.getManageShop = function (shopid) {
       var obj = {};
       obj.params = {};
       obj.params.shopid = shopid;
       obj.onSuccess = function (result) {
         console.log("Inside SUCCESS getManageShop");
         console.log(result);
         $scope.shopInvoiceDetails = result;
       };
       obj.onFailure = function (err) {
         console.log("Inside Failure getManageShop");
         console.log(err);
       };
       shopService.getShopById(obj);
     };

     $scope.getTotal = function () {
      var total = 0;
      total = $scope.total.onlineST + $scope.total.machineST;
      return total;
    };
    $scope.print = function () {
      window.print();
    };

    //Group Totals
    $scope.getTotalmpsales = function (items) {
      return items
        .map(function (x) { return x.mpsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmcsales = function (items) {
      return items
        .map(function (x) { return x.mcsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalmactotal = function (items) {
      return items
        .map(function (x) { return x.mactotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalopsales = function (items) {
      return items
        .map(function (x) { return x.opsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalocsales = function (items) {
      return items
        .map(function (x) { return x.ocsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalontotal = function (items) {
      return items
        .map(function (x) { return x.ontotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalshopTotal = function (items) {
      return items
        .map(function (x) { return x.shopTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotalcompTotal = function (items) {
      return items
        .map(function (x) { return x.compTotal; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };
    $scope.getTotaltotalsales = function (items) {
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    };

    $scope.getShopSalesOfPartner = function(salesOfPartnerList) {

      $scope.isEdit = true;
      $scope.isInvoice = false;
      $scope.isGroup = false;
      $scope.shopSalesOfPartnerList = {};
      $scope.shopSalesOfPartnerList = salesOfPartnerList;
      $scope.totalSalesLabelFooter = 0;
      $scope.mPSalesTotal = 0;
      $scope.mCSalesTotal = 0;
      $scope.mSalesTotal = 0;
      $scope.oPSalesTotal = 0;
      $scope.oCSalesTotal = 0;
      $scope.oSalesTotal = 0;
      $scope.shopTotal = 0;
      $scope.compTotal = 0;
      $scope.shopOverTotal = 0;
      $scope.compOverTotal = 0;

      for (var i = 0; i < $scope.shopSalesOfPartnerList.length; i++) {
        var onMacTotalL2 = parseFloat($scope.shopSalesOfPartnerList[i].ontotal)+ parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.shopSalesOfPartnerList[i].totalsales = onMacTotalL2;
        $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(onMacTotalL2);
        $scope.mPSalesTotal = $scope.mPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mpsales);
        $scope.mCSalesTotal = $scope.mCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mcsales);
        $scope.mSalesTotal = $scope.mSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].mactotal);
        $scope.oPSalesTotal = $scope.oPSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.oCSalesTotal = $scope.oCSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.oSalesTotal = $scope.oSalesTotal + parseFloat($scope.shopSalesOfPartnerList[i].ontotal);
        $scope.shopSalesOfPartnerList[i].shopTotal = parseFloat($scope.shopSalesOfPartnerList[i].mpsales)+ parseFloat($scope.shopSalesOfPartnerList[i].opsales);
        $scope.shopSalesOfPartnerList[i].compTotal = parseFloat($scope.shopSalesOfPartnerList[i].mcsales)+ parseFloat($scope.shopSalesOfPartnerList[i].ocsales);
        $scope.shopOverTotal = $scope.shopOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].shopTotal);
        $scope.compOverTotal = $scope.compOverTotal + parseFloat($scope.shopSalesOfPartnerList[i].compTotal);

      }

      // var obj = {};
      // obj.params = {};
      // //$scope.machineSalesOfPartner = {};


      // // var days = 60; // Days you want to subtract
      // // var td = new Date();
      // // var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      // // var day =fd.getDate();
      // // var month=fd.getMonth()+1;
      // // var year=fd.getFullYear();

      // var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      // var date1 = y+'-'+m+'-'+fd.getUTCDate();
      // var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      // td.setHours(23);
      // td.setMinutes(59);
      // td.setSeconds(59);
      // var date2 = y+'-'+m+'-'+td.getUTCDate();

      // console.log(fd);
      // console.log(td);

      // obj.params.adate = fd;
      // obj.params.bdate = td;
      // obj.params.partnerId = $scope.managePartnersales.partnerid;
      // console.log(obj.params);

      // obj.onSuccess = function(result) {
      //   console.log("Inside getShopSalesOfPartner SUCCESS");
      //   console.log(result);
      //   $scope.totalSalesLabelFooter = 0;
      //   $scope.mPSalesTotal = 0;
      //   $scope.mCSalesTotal = 0;
      //   $scope.mSalesTotal = 0;
      //   $scope.oPSalesTotal = 0;
      //   $scope.oCSalesTotal = 0;
      //   $scope.oSalesTotal = 0;
      //   $scope.shopTotal = 0;
      //   $scope.compTotal = 0;
      //   $scope.shopOverTotal = 0;
      //   $scope.compOverTotal = 0;

      //   //$scope.shopSalesOfPartnerList = result.result;
      //   console.log('scope.getShopSalesOfPartner', $scope.shopSalesOfPartnerList);
      //   $scope.shopSalesOfPartnerList = $filter('filter')(result.result, {
      //     code: shopCode
      //   },true);
      //   console.log('scope.getShopSalesOfPartner', $scope.shopSalesOfPartnerList);

      //   console.log($scope.totalSalesLabelFooter);
      // }
      // obj.onFailure = function(err) {
      //   console.log("Inside getMachineSalesOfPartner Failure");
      // }
      // partnersalesreportService.getMachinesalesByPartner(obj);
    };    
    

}
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.partnersales')
    .service('partnersalesreportService', partnersalesreportService);

  /** @ngInject */
  function partnersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      //var newDate  = new Date(date);
      console.log('date',date);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": date}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesByPartner = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfPartner({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesByPartner: getMachinesalesByPartner,
      getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales')
    .controller('SuppliersalesreportPageCtrl', SuppliersalesreportPageCtrl);

  /** @ngInject */
  function SuppliersalesreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    suppliersalesreportService, machineShopService,gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal) {
    console.log("Inside SuppliersalesreportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function(id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.searchMachinesales = function (dateList) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      

      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation(dateList.from) &&
        validationService.isEmptyOrNullValidation(dateList.to)) {

        if (!validationService.verifyDate(dateList.from) || !validationService.verifyDate(dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }

      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date(dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
        var date1 = y+'-'+m+'-'+fd.getUTCDate();

        var td = new Date(dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y+'-'+m+'-'+td.getUTCDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = fd;
        obj.params.bdate = td;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          $scope.totalSalesLabel = 0;
          $scope.totalSalesLabelFooter = 0;
          for (var i = 0; i < result.result.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat(result.result[i].totalsales);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.manageSuppliersalesList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        suppliersalesreportService.getGrpMacSalesInRange(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageSuppliersales = {};
    $scope.manageSuppliersalesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.params = {};
      obj.params.fromDt = $scope.dateList.from;
      obj.params.toDt = $scope.dateList.to;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.initManagePartner();
        $scope.initManageGames();
        $scope.initManageMachineShop();
        //$scope.initManagePrevMachineReading();
        $scope.manageSuppliersalesList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      suppliersalesreportService.getBetweenDatesMachinesales(obj);
      //$scope.$broadcast('scroll.refreshComplete');
    };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/reports/suppliersales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.initManageStates();
          //$scope.searchMachinesales(dateList)
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageSuppliersales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.dateFormater = function(ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm+'/'+dd+'/'+yy
    };

    $scope.saveMachinesales = function(manageSuppliersales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageSuppliersales);
      console.log(manageSuppliersales.id);

      if (manageSuppliersales.id === undefined) {
        $scope.createMachinesales(manageSuppliersales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSuppliersales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSuppliersales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        suppliersalesreportService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageSuppliersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.manageSuppliersales = manageSuppliersales;
      console.log($scope.manageSuppliersales.id);

      $scope.getMachineSalesOfSupplier(manageSuppliersales.id);
    };

    $scope.getMachineSalesOfSupplier = function(suppId) {
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfSupplier = {};
      $scope.machineSalesOfSupplierList = {};
      var fd = new Date($scope.dateList.from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();
      var td = new Date($scope.dateList.to); y = td.getFullYear(); m = td.getMonth()+1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      
      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = fd;
      obj.params.bdate = td;
      obj.params.suppId = suppId;
      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside getMachineSalesOfSupplier SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        for (var i = 0; i < result.result.length; i++) {
          $scope.totalSalesLabelFooter = $scope.totalSalesLabelFooter + parseFloat(result.result[i].totalsales);
        }
        console.log($scope.totalSalesLabelFooter);
        $scope.machineSalesOfSupplierList = result;
      }
      obj.onFailure = function(err) {
        console.log("Inside getMachineSalesOfSupplier Failure");
      }
      suppliersalesreportService.getMachinesalesBySupplier(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set'
    };

    $scope.showPartnerById = function (manageSuppliersales) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (manageSuppliersales.shop && $scope.managePartnerList.length) {
        //console.log($scope.manageSuppliersales);
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageSuppliersales.shop.partnerid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports.suppliersales')
    .service('suppliersalesreportService', suppliersalesreportService);

  /** @ngInject */
  function suppliersalesreportService(Machinesales) {
    var getDailyMachinesales = function(obj) {

      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var date = y+'-'+m+'-'+d.getUTCDate();
      var newDate  = new Date(date);
      console.log('date',newDate);

      Machinesales.find({
        filter: {
          where:{
            created:{"gte": newDate}
          },
          include: ["machine","shop"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpMacSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachinesalesBySupplier = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpSalesOfSupplier({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        suppId: obj.params.suppId
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };
    
    var getBetweenDatesMachinesales = function(obj) {

      var from = obj.params.fromDt?obj.params.fromDt:null;
      var to = obj.params.toDt?obj.params.toDt:null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
      var date1 = y+'-'+m+'-'+fd.getUTCDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
      var date2 = y+'-'+m+'-'+td.getUTCDate();
      console.log('date1',date1);
      console.log('date2',date2);

            Machinesales.find({
              filter: {
                where:{
                  and:[
                    {created: {gte: date1}},
                    {created: {lte:date2}}
                  ]
                },
                include: ["machine","shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });

    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getGrpMacSalesInRange: getGrpMacSalesInRange,
      getMachinesalesBySupplier: getMachinesalesBySupplier,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      getAvailableMachineByZone: getAvailableMachineByZone,
//      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales
  //    saveMachinesales: saveMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales')
    .controller('DailymachinesalesShopStaffPageCtrl', DailymachinesalesShopStaffPageCtrl);

  /** @ngInject */
  function DailymachinesalesShopStaffPageCtrl($scope, $filter, editableOptions, editableThemes,
    dailymachineShopStaffService, dailyInvoiceService, machineShopService, gameService, shopService, partnerService, machinesalesService, toastr, 
    $uibModal, receiptService,  $rootScope, zoneService, userService) {
    console.log("Inside DailymachinesalesShopStaffPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
         console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist',zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        }else{
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList',$scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageGames");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure initManageGames");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function() {
      var obj = {};
      // Is it possible that a machine is not associated with any shop and the sales are being uploaded? 
      // If yes alternate option is to be looked out
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.init = function(){
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
    };
    $scope.init();
    $scope.reportFilter={};
    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];

    $scope.getDailyMachinesales = function(reportFilter) {
      console.log('Inside getDailyMachinesales');
      console.log('$rootScope.userData',$rootScope.userData);
      
      
      var obj = {};
      obj.params={};
      if (reportFilter.zone){
        obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
      } else{
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          var value="";
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            if (index == 0){
              value = "('"+$rootScope.userData.credentials.zonemap[index]+"'";
            }else{
              value = value+",'"+$rootScope.userData.credentials.zonemap[index]+"'";
            }
          }
          value = value+")";
          obj.params.zoneid=value;
        }else{
          obj.params.zoneid=reportFilter.zone?"('"+reportFilter.zone.id+"')":null;
        }
      }
      if (typeof $rootScope.userData.credentials.shopType !== "undefined"){
        obj.params.shoptype=$rootScope.userData.credentials.shopType;
      }else{
        obj.params.shoptype=reportFilter.shoptype?reportFilter.shoptype.value:null;
      }
      if (reportFilter.agent){
        obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
      }
      if (reportFilter.daynight){
        obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
      }
      if (typeof $rootScope.userData.credentials.days !== "undefined") {
        obj.params.days=$rootScope.userData.credentials.days?$rootScope.userData.credentials.days:1;
      }
      if (typeof $rootScope.userData.credentials.shop !== "undefined") {
        console.log('Inside $rootScope.userData.credentials.shop');
        obj.params.shopid=$rootScope.userData.credentials.shop?$rootScope.userData.credentials.shop.id:null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.totalSalesLabel = 0;
        $scope.manageMachinesalesList = result.result;
        for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
          $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
        }
        console.log($scope.totalSalesLabel.toFixed(2));
        $scope.isEdit = false;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachineShopStaffService.getDailyMachinesales(obj);
    };
    //$scope.getDailyMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/shopstaff/dailymachinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function(res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(errdetails, 'ERROR');
          }
        };
        dailymachineShopStaffService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function(manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.getDailyMachinesales($scope.reportFilter);

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        dailymachineShopStaffService.saveMachinesales(obj);
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.viewMachinesales = function(manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.manageMachinesales = manageMachinesales;
      console.log($scope.manageMachinesales);

      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);

    };

    $scope.imageString = "";
    $scope.zoomReceipts = function (code){
      //console.log('Inside zoomReceipts', code);
      $scope.open('app/pages/shopstaff/dailymachinesales/modals/receiptModal.html');
      $scope.imageString = code;
    };

    $scope.showGameById = function(gid) {
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function(machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        },true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function(manageMachinesales) {
      if (manageMachinesales&& $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        },true);
        return selected.length ? selected[0].code+', '+selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };
    

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.genIvoiceMachinesales = function () {
      console.log('Inside genIvoiceMachinesales');

      var adate = new Date();
      console.log('adate', adate);

      var obj = {};
      obj.params = {};
      obj.params.adate = $scope.getInDate(adate,2);
      console.log('obj.params.adate', obj.params.adate);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS generateInvoice");
        console.log(result);
        var invoiceList = result.result;
        console.log(invoiceList.length);
        if (invoiceList.length) {
          console.log('Inside result.length ');

          var date = new Date();
          var objInvoice = {};
          objInvoice.params = [];
          for (var index = 0; index < invoiceList.length; index++) {
            var recordInvoice = {};
            if (invoiceList[index].shoptype === '5/5') {
              console.log('Inside 5/5 ');
              console.log(invoiceList[index]);
              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);

              recordInvoice.invoicedate = resultInDate;
              recordInvoice.indate = resultInDate;
              recordInvoice.created = date;
              recordInvoice.lastupdated = date;
              recordInvoice.ikey = invoiceList[index].ikey;
              recordInvoice.shopid = invoiceList[index].shopid;
              recordInvoice.zoneid = invoiceList[index].zoneid;

            } else if (invoiceList[index].shoptype === '100%') {
              console.log('Inside 100%');
              var newDate = new Date();
              var checkInDate = $scope.getInDate(newDate,1);

              var newInDate = new Date(invoiceList[index].indate);
              var resultInDate = $scope.getInDate(newInDate,0);
             
              console.log('checkInDate',checkInDate);
              console.log('resultInDate',resultInDate);

              if (checkInDate>=resultInDate){
                recordInvoice.invoicedate = resultInDate;
                recordInvoice.indate = resultInDate;
                recordInvoice.created = date;
                recordInvoice.lastupdated = date;
                recordInvoice.ikey = invoiceList[index].ikey;
                recordInvoice.shopid = invoiceList[index].shopid;
                recordInvoice.zoneid = invoiceList[index].zoneid;
              }
            }

            if (!_.isEmpty(recordInvoice)){
              objInvoice.params.push(recordInvoice);
            }
          }
          console.log(objInvoice.params);

          objInvoice.onSuccess = function (result) {
            console.log("Inside SUCCESS genIvoiceMachinesales");
            console.log(result);
            toastr.success('New Invoice has been generated successfully!', 'SUCCESS');
          };
          objInvoice.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            toastr.success('All Pending Invoices are generated successfully!', 'SUCCESS');
          };
          if (objInvoice.params.length){
          dailyInvoiceService.createInvoice(objInvoice);
          }else{
            toastr.error('No Pending Invoices', 'ERROR');
          }
        } else{
          toastr.error('No Pending Invoices', 'ERROR');
        }

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dailymachineShopStaffService.generateInvoice(obj);
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();


/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shopstaff.dailymachinesales')
    .service('dailymachineShopStaffService', dailymachineShopStaffService);

  /** @ngInject */
  function dailymachineShopStaffService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var days = 1; // Days you want to subtract
    //   var td = new Date();
    //   var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
    //   var day =fd.getDate();
    //   var month=fd.getMonth()+1;
    //   var year=fd.getFullYear();
  
    //   var dailyDate = year+'-'+month+'-'+day;
  
    //   console.log('date',dailyDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         indate:{"gte": dailyDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };


    var getDailyMachinesales = function(obj) {

      var days = obj.params.days?obj.params.days:1; // Days you want to subtract
      var td = new Date();
      var fd = new Date(td.getTime() - (days * 24 * 60 * 60 * 1000));
      var day =fd.getDate();
      var month=fd.getMonth()+1;
      var year=fd.getFullYear();
  
      var dailyDate = year+'-'+month+'-'+day;
  
      console.log('date',dailyDate);

      Machinesales.getDailyMachinesales({
        adate: dailyDate,
        shoptype: obj.params.shoptype?obj.params.shoptype:null,
        zoneid: obj.params.zoneid?obj.params.zoneid:null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        shopid: obj.params.shopid?obj.params.shopid:null,
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getDailyMachinesalesByKey = function(obj) {
      Machinesales.find({
        filter: {
          where:{
            ikey:obj.params.ikey
          },
          include: ["machineshop","machine"]
        }
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var deleteMachinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var generateInvoice = function (obj) {

      Machinesales.generateInvoice({
        adate: obj.params.adate
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getDailyMachinesales: getDailyMachinesales,
      getDailyMachinesalesByKey: getDailyMachinesalesByKey,
      deleteMachinesales: deleteMachinesales,
      generateInvoice:generateInvoice
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .controller('AreasPageCtrl', AreasPageCtrl);

  /** @ngInject */
  function AreasPageCtrl($scope, $filter, editableOptions, editableThemes,
    areaService, toastr, $uibModal, stateService, zoneService) {
    console.log("Inside AreasPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteArea(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageZonesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };




    $scope.manageAreasList = [];
    $scope.manageArea = {};
    $scope.initManageAreas = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
        $scope.initManageStates();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };
    $scope.initManageAreas();

    $scope.addArea = function() {
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageAreasList.push($scope.inserted);
    };

    $scope.createArea = function(manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createArea");
      console.log(manageArea);

      var obj = {};
      obj.params = {};
      obj.params = manageArea;
      // obj.params.name = manageArea.name;
      // obj.params.description = manageArea.description;
      // obj.params.zoneid = manageArea.zones
      // obj.params.stateid = manageArea.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageAreas();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      areaService.createArea(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/areas/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteArea = function(res) {
      console.log("Inside deleteArea");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageAreas();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.deleteArea(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html', $scope);
    }

    $scope.saveArea = function(manageArea, id) {

      console.log("Inside saveArea");
      console.log(manageArea);
      console.log(id);

      console.log(manageArea.zones);
      console.log(manageArea.state);


      if (id === undefined) {
        $scope.createArea(manageArea);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageArea;
        obj.params.id = id;
        // obj.params.name = $scope.manageArea.name;
        // obj.params.description = $scope.manageArea.description;
        //obj.params.created = $scope.manageArea.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageArea = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageAreas();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.saveArea(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .service('areaService', areaService);

  /** @ngInject */
  function areaService(Area) {
    var getAreas = function(obj) {

    Area.find({
      filter:{
        include:["state","zone"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.create({
      name:obj.params.name,
      description:obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	     zoneid: obj.params.zone,
      created: date,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Area.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.prototype$patchAttributes({
      id: obj.params.id,
      name: obj.params.name,
      description: obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	    zoneid: obj.params.zone,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getAreas: getAreas,
      createArea: createArea,
      deleteArea: deleteArea,
      saveArea: saveArea
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
      .controller('GamecategoryPageCtrl', GamecategoryPageCtrl);

  /** @ngInject */
  function GamecategoryPageCtrl($scope, $filter, editableOptions, editableThemes,
    gamecategoryService,toastr,$uibModal ) {
    console.log("Inside GamecategoryPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteGamecategory(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageGamecategory={};
    $scope.manageGamecategoryList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageGamecategoryList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        gamecategoryService.getGamecategory(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageGamecategoryList.push($scope.inserted);
    };

    $scope.createGamecategory = function(manageGamecategory) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGamecategory");
      console.log(manageGamecategory.name);
      //console.log(manageGamecategory.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageGamecategory.name;
      //obj.params.description = manageGamecategory.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('New Gamecategory has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Gamecategory successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.createGamecategory(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/gamecategory/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGamecategory = function (res){
      console.log("Inside deleteGamecategory");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Gamecategory has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            gamecategoryService.deleteGamecategory(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (gamecategory){
      console.log("Inside editGamecategory");
      console.log(gamecategory);
      // $scope.manageGamecategory.id = $scope.manageGamecategory.id;
      // $scope.manageGamecategory.name = state.name;
      // $scope.manageGamecategory.description = state.description;
      // $scope.manageGamecategory.created = state.created;
      // $scope.manageGamecategory.lastupdated = state.lastupdated;
      $scope.manageGamecategory = gamecategory;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveGamecategory = function (manageGamecategory, id){

      console.log("Inside saveGamecategory");
      console.log(manageGamecategory);
      console.log(id);

      if (id===undefined){
        $scope.createGamecategory(manageGamecategory);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageGamecategory
      obj.params.id = id;
      // obj.params.name = $scope.manageGamecategory.name;
      // obj.params.description = $scope.manageGamecategory.description;
      //obj.params.created = $scope.manageGamecategory.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('Gamecategory has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.saveGamecategory(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
    .service('gamecategoryService', gamecategoryService);
 
  /** @ngInject */
  function gamecategoryService(Gamecategory) {
    var getGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.create({
        name:obj.params.name,
       // description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getGamecategory: getGamecategory,
      createGamecategory: createGamecategory,
      deleteGamecategory: deleteGamecategory,
      saveGamecategory: saveGamecategory
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .controller('MachinePageCtrl', MachinePageCtrl);

  /** @ngInject */
  function MachinePageCtrl($scope, $filter, editableOptions, editableThemes,
    machineService, toastr, $uibModal, gameService, machineShopService, zoneService, $state,
    supplierService,shopService) {
    console.log("Inside MachinePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachine(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };


    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function(zoneid) {
      var obj = {};
      obj.params={};
      obj.params.zoneid = zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShopByZone(obj);

    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineList = result;
        $scope.initManageGames();
        $scope.initManageZones();
        $scope.initManageSupplier();
        $scope.initManageActiveMachine();
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier? manageMachine.supplier.id:null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success('New Machine has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine();

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/machine/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.deleteMachine(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveMachine = function (manageMachine) {

      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier?manageMachine.supplier.id:null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success('Machine has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter('filter')($scope.manageActiveMachineList, {
          machineid: id
        },true);
        return selected.length ? selected[0] : null;
      }else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);

    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;    
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;    
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
        var obj = {};
        obj.params = {};
        obj.params = manageSupplier
        //obj.params.created = $scope.manageSupplier.created;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          $scope.initManageSupplier();          
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          $scope.isEditSupplier = false;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.createSupplier(obj);
    }

    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/system/machine/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function(shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/system/machine/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .service('machineService', machineService);

  /** @ngInject */
  function machineService(Machine) {
    var getMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAllMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachineByZone = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid
          },
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.prototype$patchAttributes({
        id: obj.params.id,
        //description: obj.params.description,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getMachine: getMachine,
      getAllMachine: getAllMachine,
      createMachine: createMachine,
      deleteMachine: deleteMachine,
      saveMachine: saveMachine,
      getMachineByZone: getMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.memo")
    .controller("MemoPageCtrl", MemoPageCtrl);

  /** @ngInject */
  function MemoPageCtrl(
    $scope,
    $rootScope,
    toastr,
    $uibModal,
    zoneService,
    memoService,
    roleService,
    $sce
  ) {
    $scope.ckEditorOptions = {
      language: "en",
      extraPlugins: "colorbutton,colordialog,font,justify,pastetext",
      allowedContent: true,
      entities: false,
      toolbar: [
        { name: "clipboard", items: ["Undo", "Redo"] },
        {
          name: "forms",
          items: [
            "Form",
            "Checkbox",
            "Radio",
            "TextField",
            "Textarea",
            "Select",
            "Button",
            "HiddenField",
          ],
        },
        "/",
        {
          name: "basicstyles",
          items: ["Bold", "Italic", "Underline", "Strike"],
        },
        {
          name: "paragraph",
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
          ],
        },
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        {
          name: "insert",
          items: ["Table", "HorizontalRule", "Smiley", "SpecialChar"],
        },
        "/",
        { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
      ],
    };

    $scope.smartTablePageSize = 25;
    $scope.memoList = [];
    $scope.reportFilter = {
      zone: null,
    };
    $scope.manageZonesList = [];
    $scope.mangeUserRoleList = [];
    $scope.selectedMemo;

    $scope.loading = false;
    $scope.loaded = {
      zones: false,
      roles: false,
    };

    $scope.init = function () {
      $scope.getUserRoles();
      $scope.getZones();
    };

    $scope.getUserRoles = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.loaded.roles = true;
        $scope.getMemos();
        $scope.mangeUserRoleList = result;
      };

      roleService.getRoles(obj);
    };

    $scope.getZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageZonesList = result;
        $scope.loaded.zones = true;
        $scope.getMemos();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.getMemos = function () {
      if (!$scope.loaded.zones || !$scope.loaded.roles) {
        return;
      }

      var obj = {};
      obj.params = {};
      $scope.memoList = [];
      $scope.loading = true;

      obj.onSuccess = function (result) {
        $scope.loading = false;
        $scope.memoList = result
          .filter(function (data) {
            return !$scope.reportFilter.zone
              ? true
              : (data.zones || []).includes($scope.reportFilter.zone.id);
          })
          .map(function (data) {
            var myZones = (data.zones || [])
              .map(function (zones) {
                var myZone = $scope.manageZonesList.find(function (zone) {
                  return zone.id === zones;
                });
                return myZone;
              })
              .filter(function (zone) {
                return !!zone && !!zone.name;
              });

            var myRoles = (data.roles || [])
              .map(function (roles) {
                var myRole = $scope.mangeUserRoleList.find(function (role) {
                  return role.id === roles;
                });
                return myRole;
              })
              .filter(function (role) {
                return !!role && !!role.name;
              });

            data.zones = myZones;
            data.zonesname = myZones
              .map(function (zone) {
                return zone.name;
              })
              .join();

            data.roles = myRoles;
            data.rolesname = myRoles
              .map(function (role) {
                return role.name;
              })
              .join();

            data.activate = data.active ? "Yes" : "No";

            return data;
          });
      };

      obj.onFailure = function (result) {
        $scope.loading = false;
      };

      memoService.getMemos(obj);
    };

    $scope.onReady = function () {};

    $scope.createMemo = function () {
      $scope.selectedMemo = {
        id: "",
        title: "",
        description: "",
        active: true,
        zones: [],
        roles: [],
      };
    };

    $scope.viewMemo = function (memo) {
      $scope.selectedMemo = memo;
    };

    $scope.saveMemo = function () {
      var obj = {};
      obj.params = Object.assign({}, $scope.selectedMemo);
      obj.params.zones = $scope.selectedMemo.zones.map(function (zone) {
        return zone.id;
      });
      obj.params.roles = $scope.selectedMemo.roles.map(function (role) {
        return role.id;
      });

      obj.onSuccess = function () {
        $scope.selectedMemo = null;
        $scope.getMemos();
      };

      $scope.selectedMemo.id
        ? memoService.saveMemo(obj)
        : memoService.createMemo(obj);
    };

    $scope.search = function (reset) {
      if (reset) {
        $scope.reportFilter = {};
      }

      $scope.getMemos();
    };

    $scope.goToListPage = function () {
      $scope.selectedMemo = null;
    };

    $scope.confirmDelete = function (id) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/system/memo/modals/dangerModal.html",
        scope: $scope,
        size: "sm",
      });
      modalInstance.result.then(
        function () {
          $scope.deleteMemo(id);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.deleteMemo = function (id) {
      var obj = {};
      obj.params = {};
      obj.params.id = id;
      obj.onSuccess = function (result) {
        toastr.success("Memo has been deleted successfully!", "SUCCESS");

        $scope.getMemos();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "Error");
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, "Error");
        }
      };

      memoService.deleteMemo(obj);
    };

    $scope.init();
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.memo")
    .service("memoService", memoService);

  /** @ngInject */
  function memoService(Memo) {
    var getMemos = function (obj) {
      var where = {};
      if (obj.params) {
        if (obj.params.zoneid) {
          where.zoneid = obj.params.zoneid;
        }
      }
      Memo.find({
        filter: {
          where: where,
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var createMemo = function (obj) {
      var date = new Date();

      Memo.create({
        title: obj.params.title,
        description: obj.params.description,
        created: date,
        lastupdated: date,
        zones: obj.params.zones,
        roles: obj.params.roles,
        active: obj.params.active,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteMemo = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Memo.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveMemo = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Memo.prototype$patchAttributes({
        id: obj.params.id,
        title: obj.params.title,
        description: obj.params.description,
        lastupdated: date,
        active: obj.params.active,
        zones: obj.params.zones,
        roles: obj.params.roles,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getMemos: getMemos,
      createMemo: createMemo,
      deleteMemo: deleteMemo,
      saveMemo: saveMemo,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games')
    .controller('GamesPageCtrl', GamesPageCtrl);

  /** @ngInject */
  function GamesPageCtrl($scope, $filter, editableOptions, editableThemes,
    gameService, toastr, $uibModal, gamecategoryService) {
    console.log("Inside GamesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteGame(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;
    $scope.status = [{
      value: 'Active'
    }, {
      value: 'Inactive'
    }];

    //Getting States
    $scope.manageGamecategoryList = [];
    $scope.initManageGamecategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategoryList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gamecategoryService.getGamecategory(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };






    $scope.manageGamesList = [];
    $scope.manageArea = {};
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
        $scope.initManageGamecategory();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };
    $scope.initManageGames();

    $scope.addArea = function () {
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        //description:null,
        gamecatid: null,
        status: null,
      };
      $scope.manageGamesList.push($scope.inserted);
    };

    $scope.createGame = function (manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGame");
      console.log(manageArea.name);
      console.log(manageArea.status);

      var obj = {};
      obj.params = {};
      obj.params.name = manageArea.name;
      obj.params.gamecatid = manageArea.gamecategory;
      obj.params.status = manageArea.status.value;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageGames();
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gameService.createGame(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/games/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGame = function (res) {
      console.log("Inside deleteGame");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Game has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Game successfully deleted.");
          $scope.initManageGames();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        gameService.deleteGame(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function (state) {
      console.log("Inside editGame");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html', $scope);
    }

    $scope.saveGame = function (manageArea, id) {

      console.log("Inside saveGame");
      console.log(manageArea);
      console.log(id);

      if (id === undefined) {
        $scope.createGame(manageArea);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageArea
        obj.params.id = id;
        obj.params.gamecatid = manageArea.gamecategory;
        obj.params.status = manageArea.status.value;
        // obj.params.name = $scope.manageArea.name;
        // obj.params.description = $scope.manageArea.description;
        //obj.params.created = $scope.manageArea.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.statuses = result.status;
          $scope.manageArea = {};
          toastr.success('Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          console.log("sandip");
          console.log(result.status);
          $scope.initManageGames();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }

        gameService.saveGame(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showStatus = function (status) {
      var selected = [];
      if (typeof status === "object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : 'Not set';
      } else {
        return status;
      }

    };

    $scope.showGamecategory = function (gamecategory) {
      //console.log("Inside showGamecategory = "+JSON.stringify(state));
      //console.log(gamecategory);
      //console.log(item.gamecategory.id);
      if (gamecategory && $scope.manageGamecategoryList.length) {
        //console.log(gamecategory.id);
        //console.log(gamecategory.id);
        var selected = $filter('filter')($scope.manageGamecategoryList, {
          id: gamecategory.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.games")
    .service("gameService", gameService);

  /** @ngInject */
  function gameService(Games) {
    var getGame = function (obj) {
      Games.find({
        filter: {
          include: "gamecat",
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          obj.onFailure(err);
        }
      );
    };

    var getOnlineGame = function (obj) {
      Games.find({
        filter: {
          where: {
            gamecatid: 1,
          },
          include: "gamecat",
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          obj.onFailure(err);
        }
      );
    };

    var getMachineGame = function (obj) {
      Games.find({
        filter: {
          where: {
            gamecatid: 2,
          },
          include: "gamecat",
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          obj.onFailure(err);
        }
      );
    };

    var createGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Games.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        gamecatid: obj.params.gamecatid,
        status: obj.params.status,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Games.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveGame = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Games.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        gamecatid: obj.params.gamecatid,
        status: obj.params.status,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          console.log(err);
          obj.onFailure(err);
        }
      );
    };

    return {
      getGame: getGame,
      createGame: createGame,
      deleteGame: deleteGame,
      saveGame: saveGame,
      getOnlineGame: getOnlineGame,
      getMachineGame: getMachineGame,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.shop")
    .controller("ShopPageCtrl", ShopPageCtrl);

  /** @ngInject */
  function ShopPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    shopService,
    toastr,
    $uibModal,
    partnerService,
    zoneService,
    $state,
    gameService,
    onlineShopService,
    machineShopService,
    machineService,
    suppliersalesreportService,
    supplierService,
    areaService,
    siteService
  ) {
    console.log("Inside ShopPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteShop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.openDeleteOnlineShop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteOnlineShop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.openDeleteMachineshop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachineshop(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;

    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageOnlineShopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        onlineShopService.getOnlineshop(obj);
      } else {
        $scope.manageOnlineShopList = [];
      }
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageAreaList = [];
    $scope.initManageAreas = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSites = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshop(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };
    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid); // ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result.result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //machineService.getMachineByZone(obj);
      suppliersalesreportService.getAvailableMachineByZone(obj);
    };

    $scope.manageMachineListZone = [];
    $scope.initManageMachineZone = function () {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid); // ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineListZone = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachineByZone(obj);
    };

    $scope.manageShop = {};
    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
        $scope.initManagePartner();
        $scope.initManageZones();
        $scope.initManageAreas();
        $scope.initManageGames();
        $scope.initManageSupplier();
        $scope.initManageSites();
        //$scope.initManageOnlineShop();
        $scope.isEdit = false;
        for (var i = 0; i < result.length; i++) {
          if ($scope.manageShopList[i].contact1) {
            $scope.manageShopList[i].contact1 = JSON.parse(
              $scope.manageShopList[i].contact1
            );
          }
          if ($scope.manageShopList[i].contact2) {
            $scope.manageShopList[i].contact2 = JSON.parse(
              $scope.manageShopList[i].contact2
            );
          }
          if ($scope.manageShopList[i].contact3) {
            $scope.manageShopList[i].contact3 = JSON.parse(
              $scope.manageShopList[i].contact3
            );
          }
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };
    $scope.initManageShop();

    $scope.createShop = function (manageShop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createShop");
      console.log(manageShop);

      var obj = {};
      obj.params = {};
      obj.params.code = manageShop.code;
      obj.params.name = manageShop.name;
      obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;

      obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
      obj.params.areaid = manageShop.area ? manageShop.area.id : null;
      obj.params.siteid = manageShop.site ? manageShop.site.id : null;
      obj.params.onrate = manageShop.onrate;
      obj.params.macrate = manageShop.macrate;
      obj.params.onvirtual = manageShop.onvirtual;
      obj.params.d_ewallet_rate = manageShop.d_ewallet_rate;
      obj.params.d_cc_rate = manageShop.d_cc_rate;
      obj.params.ontips = manageShop.ontips;
      obj.params.creditlimit = manageShop.creditlimit;
      obj.params.shoptype = manageShop.shoptype;
      obj.params.address = manageShop.address;
      obj.params.status = manageShop.status;
      obj.params.contact1 = JSON.stringify(manageShop.contact1);
      obj.params.contact2 = JSON.stringify(manageShop.contact2);
      obj.params.contact3 = JSON.stringify(manageShop.contact3);
      obj.params.remarks = manageShop.remarks;
      obj.params.onrebate = manageShop.onrebate;
      obj.params.macrebate = manageShop.macrebate;
      obj.params.mactips = manageShop.mactips;
      obj.params.macvirtual = manageShop.macvirtual;

      //obj.params.description = manageShop.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShop = {};
        toastr.success("New Shop has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Shop successfully created.");
        $scope.initManageShop();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("Service Unavailable. Please try again later", "Error");
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, "Error");
        }
      };
      shopService.createShop(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/system/shop/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteShop = function (res) {
      console.log("Inside deleteShop");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Shop has been deleted successfully!", "SUCCESS");

          $scope.initManageShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        shopService.deleteShop(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (shop) {
      console.log("Inside editShop");
      console.log(shop);
      // $scope.manageShop.id = $scope.manageShop.id;
      // $scope.manageShop.name = state.name;
      // $scope.manageShop.description = state.description;
      // $scope.manageShop.created = state.created;
      // $scope.manageShop.lastupdated = state.lastupdated;
      $scope.manageShop = shop;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveShop = function (manageShop) {
      console.log("Inside saveShop");
      console.log(manageShop);

      console.log(manageShop.zone);
      console.log(manageShop.partner);

      if (manageShop.id === undefined) {
        $scope.createShop(manageShop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = manageShop.id;
        obj.params.code = manageShop.code;
        obj.params.name = manageShop.name;
        obj.params.partnerid = manageShop.partner
          ? manageShop.partner.id
          : null;
        obj.params.zoneid = manageShop.zone ? manageShop.zone.id : null;
        obj.params.areaid = manageShop.area ? manageShop.area.id : null;
        obj.params.siteid = manageShop.site ? manageShop.site.id : null;
        obj.params.onrate = manageShop.onrate;
        obj.params.macrate = manageShop.macrate;
        obj.params.onvirtual = manageShop.onvirtual;
        obj.params.d_ewallet_rate = manageShop.d_ewallet_rate;
        obj.params.d_cc_rate = manageShop.d_cc_rate;
        obj.params.ontips = manageShop.ontips;
        obj.params.creditlimit = manageShop.creditlimit;
        obj.params.shoptype = manageShop.shoptype;
        obj.params.address = manageShop.address;
        obj.params.status = manageShop.status;
        obj.params.contact1 = JSON.stringify(manageShop.contact1);
        obj.params.contact2 = JSON.stringify(manageShop.contact2);
        obj.params.contact3 = JSON.stringify(manageShop.contact3);

        obj.params.remarks = manageShop.remarks;
        obj.params.onrebate = manageShop.onrebate;
        obj.params.macrebate = manageShop.macrebate;
        obj.params.mactips = manageShop.mactips;
        obj.params.macvirtual = manageShop.macvirtual;

        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageShop = {};
          toastr.success("Shop has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        shopService.saveShop(obj);
      }
    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter("filter")($scope.managePartnerList, {
          id: partner.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter("filter")($scope.manageZonesList, {
          id: zone.id,
        });
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes.bs3.submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.editShop = function (manageShop) {
      console.log("Inside editShop");
      $scope.isEdit = true;
      $scope.manageShop = manageShop;
      $scope.initManageMachine();
      $scope.initManageMachineZone();
      $scope.initManageOnlineShop();
      $scope.initManageMachineShop();
      console.log($scope.manageShop);
    };

    $scope.addShop = function () {
      console.log("Inside addShop");
      $scope.isEdit = true;
      $scope.manageShop = {};
      $scope.manageOnlineShopList = [];
      $scope.manageMachineshopList = [];
      console.log($scope.manageZonesList);
    };

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter("filter")($scope.manageGamesList, {
          id: game.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    //Online Games

    $scope.addOnlineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        gameid: null,
        playtechid: null,
      };
      $scope.manageOnlineShopList.push($scope.inserted);
    };

    $scope.saveOnlineShop = function (manageOnlineShop, id) {
      console.log("Inside saveOnlineShop");
      console.log(manageOnlineShop);
      console.log(id);

      if (id === undefined) {
        $scope.createOnlineShop(manageOnlineShop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success("Online Game has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.saveOnlineshop(obj);
      }
    };

    $scope.createOnlineShop = function (manageOnlineShop) {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Online Game has been saved successfully!", "SUCCESS");
          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.createOnlineshop(obj);
      } else {
        $scope.initManageOnlineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Online Games.",
          "Error"
        );
      }
    };

    $scope.deleteOnlineShopId = null;
    $scope.confirmOnlineShopDelete = function (id) {
      $scope.openDeleteOnlineShop(
        "app/pages/system/shop/modals/dangerOnlineGameModal.html"
      );
      $scope.deleteOnlineShopId = id;
    };

    $scope.deleteOnlineShop = function (res) {
      console.log("Inside deleteOnlineShop");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteOnlineShopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteOnlineShopId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Online Game has been deleted successfully!",
            "SUCCESS"
          );

          $scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        onlineShopService.deleteOnlineshop(obj);
      }
    };

    //Machine Shop
    $scope.showMachine = function (machine) {
      if (machine && $scope.manageMachineListZone.length) {
        var selected = $filter("filter")(
          $scope.manageMachineListZone,
          {
            id: machine.id,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };

    $scope.addMachineShop = function () {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        machineid: null,
        macrate: null,
        macvirtual: null,
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.saveMachineshop = function (manageMachineshop, id) {
      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {
        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        //obj.params.supplierid = manageOnlineShop.supplier;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machineid;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.saveMachineshop(obj);
      }
    };

    $scope.createMachineshop = function (manageMachineshop) {
      console.log("createMachineshop", manageMachineshop);

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been saved successfully!",
            "SUCCESS"
          );
          $scope.initManageMachineShop();
          $scope.initManageMachine();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          }
          if (err.data.error.code === "23505") {
            toastr.error("This Machine is already assigned.", "Error");
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error(
          "Please make sure that this shop is SAVED, before setting up Machines.",
          "Error"
        );
      }
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function (id) {
      $scope.openDeleteMachineshop(
        "app/pages/system/shop/modals/dangerMachineGameModal.html"
      );
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function (res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log("Sure!");
        //console.log($scope.deleteMachineshopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        // obj.params.shopid = $scope.manageShop.id;
        // obj.params.machineid = manageMachineshop.machineid;
        // obj.params.macrate = manageMachineshop.macrate;
        // obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = false;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success(
            "Machine Game has been deleted successfully!",
            "SUCCESS"
          );
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error(
              "Service Unavailable. Please try again later",
              "Error"
            );
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, "Error");
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: supplierid,
          },
          true
        );
        return selected.length ? selected[0].code : "Not set";
      } else return "Not set";
    };
    $scope.showSupplierComm = function (machine) {
      if (machine && $scope.manageSupplierList.length) {
        var selected = $filter("filter")(
          $scope.manageSupplierList,
          {
            id: machine.supplierid,
          },
          true
        );
        return selected.length ? selected[0].rate : "Not set";
      } else return "Not set";
    };
  }
})();

/**
 * @author udit.jain
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('machineShopService', machineShopService);

  /** @ngInject */
  function machineShopService(Machineshop) {
    var getMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {shopid: obj.params.shopid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getMachineshopByMachineId = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {machineid: obj.params.machineid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            status: obj.params.status
          },
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshopWithoutStatus = function(obj) {
      
      Machineshop.find({
        filter: {
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var createMachineshop = function(obj) {
      var date = new Date();

      Machineshop.create({
        created: date,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    // var deleteMachineshop = function(obj) {

    //   Machineshop.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    var deleteMachineshop = function(obj) {
      var date = new Date();
      Machineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        status: obj.params.status
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var saveMachineshop = function(obj) {

      var date = new Date();

      Machineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
        
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getMachineshop: getMachineshop,
      getAllMachineshop:getAllMachineshop,
      getAllMachineshopWithoutStatus: getAllMachineshopWithoutStatus,
      createMachineshop: createMachineshop,
      deleteMachineshop: deleteMachineshop,
      saveMachineshop: saveMachineshop,
      getMachineshopByMachineId: getMachineshopByMachineId
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('onlineShopService', onlineShopService);

  /** @ngInject */
  function onlineShopService(Onlineshop) {
    var getOnlineshop = function(obj) {

      Onlineshop.find({
        filter: {
          where:{
            shopid:obj.params.shopid
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllOnlineshop = function(obj) {
      
            Onlineshop.find({
              filter: {
                include: ["game", "shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });
          };
    var createOnlineshop = function(obj) {
      var date = new Date();

      Onlineshop.create({
        created: date,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var deleteOnlineshop = function(obj) {

      Onlineshop.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveOnlineshop = function(obj) {

      var date = new Date();

      Onlineshop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlineshop: getOnlineshop,
      createOnlineshop: createOnlineshop,
      deleteOnlineshop: deleteOnlineshop,
      saveOnlineshop: saveOnlineshop,
      getAllOnlineshop:getAllOnlineshop
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('shopService', shopService);

  /** @ngInject */
  function shopService(Shop) {
    var getShop = function (obj) {
      Shop.find({
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopById = function (obj) {
      Shop.findById({
        id: obj.params.shopid,
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopByZone = function (obj) {
      Shop.find({
        filter: {
          where:{
            and:[
              {zoneid: obj.params.zoneid},
              {status: true}
            ]
          },
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createShop = function (obj) {
      var date = new Date();

      Shop.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteShop = function (obj) {

      Shop.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveShop = function (obj) {
      var date = new Date();

      Shop.prototype$patchAttributes({
        id: obj.params.id,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findAssignedShop = function (obj) {
      Shop.find({
        filter: {
          where:{
            id: {
              inq: obj.params.shopmap
            }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findNotAssignedShop = function (obj) {
      if (obj.params.shopmap){
        Shop.find({
          filter: {
            where:{
              and:[
                {id: { nin: obj.params.shopmap}},
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }else{
        Shop.find({
          filter: {
            where:{
              and:[
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }
        ).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }

    };

    
    var findNotAssignedShopForAdmin = function (obj) {

      Shop.find({
        filter: {
          where: {
            id: { nin: obj.params.shopmap }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getShop: getShop,
      createShop: createShop,
      deleteShop: deleteShop,
      saveShop: saveShop,
      findAssignedShop: findAssignedShop,
      findNotAssignedShop: findNotAssignedShop,
      getShopById:getShopById,
      getShopByZone:getShopByZone,
      findNotAssignedShopForAdmin:findNotAssignedShopForAdmin
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.site")
    .controller("SitePageCtrl", SitePageCtrl);

  /** @ngInject */
  function SitePageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    siteService,
    toastr,
    $uibModal,
    stateService,
    areaService,
    zoneService,
    zonePRService
  ) {
    console.log("Inside SitePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteSite(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageAreaList = [];
    $scope.manageZonePRList = [];

    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageArea = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.initManageZone = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZoneList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.initManageZonePR = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.manageZonePRList = result;
      };
      obj.onFailure = function (err) {};
      zonePRService.getZonesPR(obj);
    };

    $scope.manageSiteList = [];
    $scope.manageSite = {};
    $scope.initManageSite = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
        $scope.initManageStates();
        $scope.initManageArea();
        $scope.initManageZone();
        $scope.initManageZonePR();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    $scope.initManageSite();

    $scope.addSite = function () {
      //genericModalService.show('modules/modals/addSite.html',$scope);
      $scope.inserted = {
        name: null,
      };
      $scope.manageSiteList.push($scope.inserted);
    };

    $scope.createSite = function (manageSite) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSite");
      console.log(manageSite);

      var obj = {};
      obj.params = {};
      obj.params = manageSite;
      // obj.params.name = manageSite.name;
      // obj.params.areaid = manageSite.area
      // obj.params.stateid = manageSite.state;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSite = {};
        toastr.success("New Site has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageSite();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      siteService.createSite(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/system/site/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteSite = function (res) {
      console.log("Inside deleteSite");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Site has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Site successfully deleted.");
          $scope.initManageSite();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        siteService.deleteSite(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editSite = function (state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageSite.id = $scope.manageSite.id;
      // $scope.manageSite.name = state.name;
      // $scope.manageSite.description = state.description;
      // $scope.manageSite.created = state.created;
      // $scope.manageSite.lastupdated = state.lastupdated;
      $scope.manageSite = state;
      genericModalService.show("modules/modals/addSite.html", $scope);
    };

    $scope.saveSite = function (manageSite, id) {
      console.log("Inside saveSite");
      console.log(manageSite);
      console.log(id);

      console.log(manageSite.zone);
      console.log(manageSite.state);

      if (id === undefined) {
        $scope.createSite(manageSite);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageSite;
        obj.params.id = id;
        // obj.params.name = $scope.manageSite.name;
        // obj.params.description = $scope.manageSite.description;
        //obj.params.created = $scope.manageSite.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSite = {};
          toastr.success("Site has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageSite();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        siteService.saveSite(obj);

        //$scope.modal.hide();
      }
    };

    $scope.showState = function (state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter("filter")($scope.manageStatesList, {
          id: state.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showArea = function (area) {
      //console.log("Inside showState = "+JSON.stringify(area));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter("filter")($scope.manageAreaList, {
          id: area.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZone = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(area));
      if (zone && $scope.manageZoneList && $scope.manageZoneList.length) {
        var selected = $filter("filter")($scope.manageZoneList, {
          id: zone.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.showZonePR = function (zonepr) {
      //console.log("Inside showState = "+JSON.stringify(area));
      if (zonepr && $scope.manageZonePRList && $scope.manageZonePRList.length) {
        var selected = $filter("filter")($scope.manageZonePRList, {
          id: zonepr.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.site")
    .service("siteService", siteService);

  /** @ngInject */
  function siteService(Site) {
    var getSite = function (obj) {
      Site.find({
        filter: {
          include: ["state", "zone", "zonepr"],
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          obj.onFailure(err);
        }
      );
    };

    var createSite = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.create({
        name: obj.params.name,
        stateid: obj.params.state,
        zoneid: obj.params.zone,
        zoneprid: obj.params.zonepr,
        created: date,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteSite = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Site.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveSite = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        stateid: obj.params.state,
        zoneid: obj.params.zone,
        zoneprid: obj.params.zonepr,
        lastupdated: date,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getSite: getSite,
      createSite: createSite,
      deleteSite: deleteSite,
      saveSite: saveSite,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.zones")
    .controller("ZonesPageCtrl", ZonesPageCtrl);

  /** @ngInject */
  function ZonesPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    zoneService,
    toastr,
    $uibModal,
    stateService,
    billService,
    $rootScope
  ) {
    console.log("Inside ZonesPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteZones(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.status = [
      {
        value: "Active",
      },
      {
        value: "Inactive",
      },
    ];

    $scope.billCategoryList = [];
    $scope.initBillCategory = function () {
      billService.getBillCategory($rootScope.userData).then(function (res) {
        $scope.billCategoryList = res.data;
      });
    };
    $scope.initBillCategory();

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.manageStatesList = [];

    $scope.initManageZone = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
      $scope.$broadcast("scroll.refreshComplete");
    };
    $scope.initManageZone();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        status: null,
        //description:null,
      };
      $scope.manageZonesList.push($scope.inserted);
    };

    $scope.createZones = function (manageZones) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createZones");
      console.log(manageZones);
      console.log(manageZones.name);
      console.log(manageZones.code);
      console.log(manageZones.status);
      //console.log(manageZones.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageZones.name;
      obj.params.code = manageZones.code;
      obj.params.status = manageZones.status.value;
      //obj.params.description = manageZones.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZones = {};
        toastr.success("New Zones has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Zones successfully created.");
        $scope.initManageZone();

        if (
          $rootScope.userData.roleId === 1 ||
          $rootScope.userData.credentials.role === 1
        ) {
          $scope.openBillZonesModal(result);
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      zoneService.createZones(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/system/zones/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteZones = function (res) {
      console.log("Inside deleteZones");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success("Zones has been deleted successfully!", "SUCCESS");
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageZone();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        zoneService.deleteZones(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editState = function (zones) {
      console.log("Inside editZones");
      console.log(zones);
      // $scope.manageZones.id = $scope.manageZones.id;
      // $scope.manageZones.name = state.name;
      // $scope.manageZones.description = state.description;
      // $scope.manageZones.created = state.created;
      // $scope.manageZones.lastupdated = state.lastupdated;
      $scope.manageZones = zones;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveZones = function (manageZones, id) {
      console.log("Inside saveZones");
      console.log(manageZones);
      console.log(id);

      if (id === undefined) {
        $scope.createZones(manageZones);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageZones;
        obj.params.id = id;
        obj.params.status =
          manageZones.status && manageZones.status.value
            ? manageZones.status.value
            : manageZones.status;
        // obj.params.name = $scope.manageZones.name;
        // obj.params.description = $scope.manageZones.description;
        //obj.params.created = $scope.manageZones.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageZones = {};
          toastr.success("Zones has been saved successfully!", "SUCCESS");
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          console.log(result.status);

          if (
            $rootScope.userData.roleId === 1 ||
            $rootScope.userData.credentials.role === 1
          ) {
            $scope.openBillZonesModal(result);
          }

          $scope.initManageZone();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        zoneService.saveZones(obj);

        //$scope.modal.hide();
      }
    };

    $scope.showStatus = function (status) {
      var selected = [];

      if (status && typeof status === "object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : "Not set";
      } else {
        return status;
      }
    };

    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.showState = function (state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter("filter")($scope.manageStatesList, {
          id: state.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    $scope.openBillZonesModal = function (zone) {
      $scope.selectedZone = zone;
      $scope.selectedZone.codes = $scope.billCategoryList.filter(function (
        cat
      ) {
        return cat.zones.find(function (zat) {
          return zat.vipZoneId === zone.id;
        });
      });

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: "app/pages/system/zones/modals/billZonesModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (isConfirm) {
          if (!isConfirm || !$scope.selectedZone.codes.length) {
            return;
          }

          billService
            .saveCategoryToZones(
              $scope.selectedZone.codes.map(function (code) {
                return {
                  id: code.id,
                  zones: [zone],
                };
              })
            )
            .then(
              function (res) {
                $scope.initBillCategory();

                toastr.success("Code save to zones", "SUCCESS");
                $scope.selectedZone = null;
              },
              function (err) {
                toastr.error(err.data.message, "DELETE FAILED");
              }
            );
        },
        function () {}
      );
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones')
    .service('zoneService', zoneService);

  /** @ngInject */
  function zoneService(Zones) {
    var getZones = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.find({
        filter: {
          include: ["state"]
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createZones = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.create({
        name: obj.params.name,
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        status: obj.params.status || null,
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteZones = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveZones = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        //description: obj.params.description,
        lastupdated: date,
        status: obj.params.status || null,
        stateid: obj.params.state,
        code: obj.params.code
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getZones: getZones,
      createZones: createZones,
      deleteZones: deleteZones,
      saveZones: saveZones
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.zonespr")
    .controller("ZonesPRPageCtrl", ZonesPRPageCtrl);

  /** @ngInject */
  function ZonesPRPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    zonePRService,
    toastr,
    $uibModal,
    stateService,
    billService,
    $rootScope
  ) {
    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteZonesPR(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.status = [
      {
        value: "Active",
      },
      {
        value: "Inactive",
      },
    ];

    $scope.manageZonesPR = {};
    $scope.manageZonesPRList = [];
    $scope.manageStatesList = [];

    $scope.initManageZonePR = function () {
      var obj = {
        params: {},
      };
      var isAdmin = [1].includes($rootScope.userData.roleId);

      if (!isAdmin) {
        if (typeof $rootScope.userData.credentials.statemap !== "undefined") {
          obj.params.stateid = $rootScope.userData.credentials.statemap;
        } else {
          obj.params.stateid = [0];
        }
      }

      obj.onSuccess = function (result) {
        console.log(result);
        $scope.manageZonesPRList = result.map(function (res) {
          res.status =
            res.status === $scope.status[1].value
              ? $scope.status[1]
              : $scope.status[0];
          return res;
        });
      };
      obj.onFailure = function (err) {
        console.log(err);
      };
      zonePRService.getZonesPR(obj);
      $scope.$broadcast("scroll.refreshComplete");
    };
    $scope.initManageZonePR();

    $scope.addNewZone = function () {
      $scope.inserted = {
        name: null,
        status: $scope.status[0],
      };
      $scope.manageZonesPRList.push($scope.inserted);
    };

    $scope.createZonesPR = function (manageZonesPR) {
      console.log("Inside createZones");
      console.log(manageZonesPR);

      var obj = {};
      obj.params = {};
      obj.params.name = manageZonesPR.name;
      obj.params.code = manageZonesPR.code;
      obj.params.status = manageZonesPR.status.value;
      obj.params.stateid = manageZonesPR.state || null;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesPR = {};
        toastr.success("New Zones has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Zones successfully created.");
        $scope.initManageZonePR();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      zonePRService.createZonesPR(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/system/zonespr/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteZonesPR = function (res) {
      if (res) {
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          $scope.initManageZonePR();
        };
        obj.onFailure = function (err) {
          console.log(err);
          if (err.status === -1) {
          } else {
          }
        };
        zonePRService.deleteZonesPR(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.saveZonesPR = function (manageZonesPR, id) {
      if (id === undefined) {
        $scope.createZonesPR(manageZonesPR);
      } else {
        var obj = {};
        obj.params = {};
        obj.params = manageZonesPR;
        obj.params.id = id;
        obj.params.status =
          manageZonesPR.status && manageZonesPR.status.value
            ? manageZonesPR.status.value
            : manageZonesPR.status;
        // obj.params.name = $scope.manageZones.name;
        // obj.params.description = $scope.manageZones.description;
        //obj.params.created = $scope.manageZones.created;

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageZonesPR = {};

          $scope.initManageZonePR();
        };
        obj.onFailure = function (err) {
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        zonePRService.saveZonesPR(obj);

        //$scope.modal.hide();
      }
    };

    $scope.showStatus = function (status) {
      if (status && typeof status === "object") {
        return status.value;
      }

      return status || "";
    };

    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.showState = function (state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter("filter")($scope.manageStatesList, {
          id: state.id,
        });
        return selected.length ? selected[0].name : "Not set";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.system.zonespr")
    .service("zonePRService", zonePRService);

  /** @ngInject */
  function zonePRService(ZonesPR) {
    var getZonesPR = function (obj) {
      var where = {};

      if (obj.params && obj.params.stateid != null) {
        where.stateid =
          obj.params.stateid.length > 0
            ? {
                inq: obj.params.stateid.map(function (state) {
                  return state.toString();
                }),
              }
            : obj.params.stateid;
      }

      ZonesPR.find({
        filter: {
          where: where,
          include: ["state"],
        },
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var createZonesPR = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      ZonesPR.create({
        name: obj.params.name,
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        status: obj.params.status,
        stateid: obj.params.stateid,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var deleteZonesPR = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      ZonesPR.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    var saveZonesPR = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      ZonesPR.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        //description: obj.params.description,
        lastupdated: date,
        status: obj.params.status || null,
        stateid: obj.params.state,
        code: obj.params.code,
      }).$promise.then(
        function (data) {
          //$ionicLoading.hide();
          //console.log(data);
          obj.onSuccess(data);
        },
        function (err) {
          //$ionicLoading.hide();
          //console.log(err)
          obj.onFailure(err);
        }
      );
    };

    return {
      getZonesPR: getZonesPR,
      createZonesPR: createZonesPR,
      deleteZonesPR: deleteZonesPR,
      saveZonesPR: saveZonesPR,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
      .controller('StatesPageCtrl', StatesPageCtrl);

  /** @ngInject */
  function StatesPageCtrl($scope, $filter, editableOptions, editableThemes,
    stateService,toastr,$uibModal ) {
    console.log("Inside StatesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteState(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageState={};
    $scope.manageStatesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageStatesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        stateService.getStates(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageStatesList.push($scope.inserted);
    };

    $scope.createState = function(manageState) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createState");
      console.log(manageState.name);
      console.log(manageState.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageState.name;
      obj.params.description = manageState.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('New State has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New State successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.createState(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/states/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteState = function (res){
      console.log("Inside deleteState");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('State has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            stateService.deleteState(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (state){
      console.log("Inside editState");
      console.log(state);
      // $scope.manageState.id = $scope.manageState.id;
      // $scope.manageState.name = state.name;
      // $scope.manageState.description = state.description;
      // $scope.manageState.created = state.created;
      // $scope.manageState.lastupdated = state.lastupdated;
      $scope.manageState = state;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveState = function (manageState, id){

      console.log("Inside saveState");
      console.log(manageState);
      console.log(id);

      if (id===undefined){
        $scope.createState(manageState);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageState
      obj.params.id = id;
      // obj.params.name = $scope.manageState.name;
      // obj.params.description = $scope.manageState.description;
      //obj.params.created = $scope.manageState.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('State has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.saveState(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
    .service('stateService', stateService);

  /** @ngInject */
  function stateService(State) {
    var getStates = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getStates: getStates,
      createState: createState,
      deleteState: deleteState,
      saveState: saveState
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier.machinesales")
    .controller("GameProviderPageCtrl", GameProviderPageCtrl);

  /** @ngInject */
  function GameProviderPageCtrl(
    $rootScope,
    $scope,
    gameService,
    $uibModal,
    gameProviderService,
    zoneService,
    toastr
  ) {
    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          $scope.deleteGameProvider(selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.manageParentGameProviderList = [];
    $scope.initManageParentGameProvider = function () {
      var obj = {};

      var zonemap = $rootScope.userData.credentials.zonemap || [];
      var isSuper = $rootScope.userData.credentials.role === 1;

      obj.onSuccess = function (result) {
        $scope.manageParentGameProviderList = result
          .map(function (res) {
            res.serverFee = Number(res.serverFee);
            return res;
          })
          .filter(function (res) {
            var validGame = res.game ? res.game.status === "Active" : true;

            return (
              validGame &&
              (isSuper ||
                zonemap.find(function (zm) {
                  return res.zones && res.zones.length
                    ? res.zones.includes(zm)
                    : false;
                }))
            );
          });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameProviderService.getGameProvider(obj);
    };

    $scope.gameList = [];
    $scope.initManageGameList = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.gameList = result.filter(function (res) {
          return res.gamecatid === 1 && res.status === "Active";
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };

      gameService.getGame(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        var zonemap = $rootScope.userData.credentials.zonemap || [];
        var isSuper = $rootScope.userData.credentials.role === 1;
        $scope.manageZonesList = result.filter(function (zone) {
          return isSuper || zonemap.includes(zone.id);
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.init = function () {
      $scope.initManageGameList();
      $scope.initManageZones();
      $scope.initManageParentGameProvider();
    };
    $scope.init();

    $scope.addNew = function () {
      $scope.inserted = {
        name: null,
        game: null,
        id: null,
      };
      $scope.manageParentGameProviderList.push($scope.inserted);
    };

    $scope.saveServerFee = function (data, id) {
      var obj = {};
      obj.params = {};
      obj.params.id = id;
      obj.params.name = data.name;
      obj.params.gameid = data.game || null;
      obj.params.zones = data.zones || [];

      if (!obj.params.zones.length) {
        toastr.error("Zones cannot be empty", "Error");
        return;
      }

      obj.onSuccess = function (result) {
        toastr.success("Game provider saved successfully!", "SUCCESS");

        $scope.initManageParentGameProvider();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      gameProviderService.saveGameProvider(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/supplier/gameprovider/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.showZones = function (itemZones) {
      if (!itemZones || !itemZones.length) {
        return "";
      }

      return $scope.manageZonesList
        .filter(function (zl) {
          return itemZones.includes(zl.id);
        })
        .map(function (zone) {
          return zone.code || zone.name;
        })
        .join(",");
    };

    $scope.deleteGameProvider = function (res) {
      if (res) {
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          $scope.initManageParentGameProvider();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            PopupMessagesService.showErrorPopupMessage(
              "ERROR",
              "NO INTERNET CONNECTION"
            );
          } else {
            PopupMessagesService.showErrorPopupMessage(
              "ERROR",
              err.data.error.detail
            );
          }
        };
        gameProviderService.deleteGameProvider(obj);
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier.machinesales")
    .service("gameProviderService", gameProviderService);

  /** @ngInject */
  function gameProviderService(GameProvider) {
    var getGameProvider = function (obj) {
      GameProvider.find({
        filter: {
          include: ["game"],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteGameProvider = function (obj) {
      GameProvider.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveGameProvider = function (obj) {
      var date = new Date();

      GameProvider.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        gameid: obj.params.gameid,
        created: obj.params.id ? undefined : date,
        zones: obj.params.zones,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getGameProvider: getGameProvider,
      saveGameProvider: saveGameProvider,
      deleteGameProvider: deleteGameProvider,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier.machinesales")
    .controller("GameServerPageCtrl", GameServerPageCtrl);

  /** @ngInject */
  function GameServerPageCtrl(
    $scope,
    $rootScope,
    gameService,
    $uibModal,
    gameServerService,
    gameProviderService,
    onlineShopService,
    zoneService,
    stateService,
    shopService,
    toastr
  ) {
    $scope.isViewShop = false;
    $scope.reportFilter = {};
    $scope.algorithms = ["NP", "NG", "NGX2"];
    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          $scope.deleteGameServer(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Collector List
    $scope.manageParentGameServerList = [];
    $scope.initManageParentServerFee = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        var zonemap = $rootScope.userData.credentials.zonemap || [];
        var isSuper = $rootScope.userData.credentials.role === 1;

        $scope.manageParentGameServerList = result
          .filter(function (res) {
            return (
              isSuper ||
              (res.gameprovider &&
                res.gameprovider.zones &&
                res.gameprovider.zones.length &&
                zonemap.find(function (zone) {
                  return res.gameprovider.zones.includes(zone);
                }))
            );
          })
          .map(function (res) {
            res.serverFee = Number(res.serverFee);
            res.customerFee = Number(res.customerFee);
            return res;
          });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameServerService.getGameServer(obj);
    };

    $scope.providerList = [];
    $scope.initManageProviderList = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        var zonemap = $rootScope.userData.credentials.zonemap || [];
        var isSuper = $rootScope.userData.credentials.role === 1;

        $scope.providerList = result.filter(function (res) {
          return (
            isSuper ||
            zonemap.find(function (zm) {
              return res.zones && res.zones.length
                ? res.zones.includes(zm)
                : false;
            })
          );
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };

      gameProviderService.getGameProvider(obj);
    };

    $scope.gameList = [];
    $scope.initManageGameList = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        $scope.gameList = result.filter(function (res) {
          return res.gamecatid === 1;
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };

      gameService.getGame(obj);
    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        var zonemap = $rootScope.userData.credentials.zonemap || [];
        var isSuper = $rootScope.userData.credentials.role === 1;
        $scope.manageZonesList = result.filter(function (zone) {
          return isSuper || zonemap.includes(zone.id);
        });
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.manageShopGameServerList = [];
    $scope.initManageShopGameServer = function () {
      var obj = {};
      obj.params = {};
      var isSuper = $rootScope.userData.credentials.role === 1;

      obj.params.zoneid = $scope.reportFilter.zone
        ? [$scope.reportFilter.zone.id]
        : isSuper
        ? $scope.manageZonesList.map(function (zone) {
            return zone.id;
          })
        : $rootScope.userData.credentials.zonemap;

      if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
        obj.params.shoptype = $rootScope.userData.credentials.shopType;
      } else {
        obj.params.shoptype = $scope.reportFilter.shoptype
          ? $scope.reportFilter.shoptype.value
          : null;
      }

      if ($scope.reportFilter.stateid) {
        obj.params.stateid = $scope.reportFilter.stateid.id;
      }

      obj.onSuccess = function (result) {
        $scope.manageShopGameServerList = result.result;
      };
      obj.onFailure = function (err) {};
      onlineShopService.getShopGameServer(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function () {
      var obj = {};
      obj.params = {};
      // if ($scope.reportFilter.zone) {
      //   obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
      // } else {
      //   if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
      //     obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      //   } else {
      //     obj.params.zoneid = reportFilter.zone ? reportFilter.zone.id : null;
      //   }
      // }
      // if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      //   obj.params.shoptype = $rootScope.userData.credentials.shopType;
      // } else {
      //   obj.params.shoptype = reportFilter.shoptype
      //     ? reportFilter.shoptype.value
      //     : null;
      // }

      // if (typeof $rootScope.userData.credentials.status !== "undefined") {
      //   $rootScope.userData.credentials.status = true;
      // } else {
      //   obj.params.status =
      //     !!reportFilter.status && !!reportFilter.status.value
      //       ? reportFilter.status.value == "Active"
      //         ? true
      //         : false
      //       : null;
      // }

      // if (typeof $rootScope.userData.credentials.operational !== "undefined") {
      //   obj.params.operational = $rootScope.userData.credentials.operational;
      // } else {
      //   obj.params.operational = reportFilter.operational
      //     ? reportFilter.operational.value
      //     : null;
      // }

      // if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      //   obj.params.shoptype = $rootScope.userData.credentials.shopType;
      // } else {
      //   obj.params.shoptype = $scope.reportFilter.shoptype
      //     ? $scope.reportFilter.shoptype.value
      //     : null;
      // }

      obj.onSuccess = function (result) {
        // // api unable to filter by relation
        // if (reportFilter.state) {
        //   $scope.manageShopList = result.filter(function (res) {
        //     if (res.zone) {
        //       return res.zone.stateid == reportFilter.state.id;
        //     }
        //     return false;
        //   });
        // } else {
        $scope.manageShopList = result;

        // }
        //$scope.initManageOnlineShop();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.init = function () {
      window.a = $scope;
      $scope.initManageParentServerFee();
      $scope.initManageProviderList();
      $scope.initManageGameList();
      $scope.initManageShopGameServer();
      $scope.initManageStates();
      $scope.initManageZones();
      $scope.initManageShop();
    };
    $scope.init();

    // $scope.manageCollector = {};
    // $scope.manageCollectorList = [];

    $scope.addNew = function () {
      $scope.inserted = {
        name: null,
        serverFee: null,
        provider: null,
        gameprovider: {
          gameid: null,
        },
      };
      $scope.manageParentGameServerList.push($scope.inserted);
    };

    $scope.saveGameServer = function (data, id) {
      var obj = {};
      obj.params = {};
      obj.params.id = id;
      obj.params.name = data.name;
      obj.params.serverFee = data.serverFee;
      obj.params.customerFee = data.customerFee;
      obj.params.providerid = data.provider || null;

      if (!obj.params.providerid) {
        toastr.error("Game provider cannot be empty", "Error");
        return;
      }

      obj.onSuccess = function (result) {
        $scope.manageCollector = {};
        $scope.initManageParentServerFee();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      gameServerService.saveGameServer(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/supplier/gameserver/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    $scope.deleteGameServer = function (res) {
      if (res) {
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          $scope.initManageParentServerFee();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            PopupMessagesService.showErrorPopupMessage(
              "ERROR",
              "NO INTERNET CONNECTION"
            );
          } else {
            PopupMessagesService.showErrorPopupMessage(
              "ERROR",
              err.data.error.detail
            );
          }
        };
        gameServerService.deleteGameServer(obj);
      } else {
        console.log("Not sure!");
      }
    };

    $scope.viewShop = function () {
      $scope.isViewShop = true;
    };

    $scope.viewGameServer = function () {
      $scope.isViewShop = false;
    };

    $scope.reset = function () {
      $scope.reportFilter = {};
      $scope.initManageShopGameServer();
    };

    $scope.confirmOnlineShopDelete = function (item) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/supplier/gameserver/modals/dangerOnlineGameModal.html",
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          if (!selectedItem) {
            return;
          }

          var obj = {};
          obj.params = {};
          obj.params.id = item.id;
          obj.params.shopid = null;

          obj.onSuccess = function (result) {
            toastr.success(
              "Online Game has been deleted successfully!",
              "SUCCESS"
            );

            $scope.initManageShopGameServer();
          };
          obj.onFailure = function (err) {
            $scope.initManageShopGameServer();
            if (err.status === -1) {
              toastr.error(
                "Service Unavailable. Please try again later",
                "Error"
              );
            } else {
              var errdetails = err.data.error.detail;
              toastr.error(errdetails, "Error");
            }
          };
          onlineShopService.saveOnlineshop(obj);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.openShopGameServerModal = function (item) {
      $scope.selected = item
        ? $scope.manageShopGameServerList.find(function (shopgs) {
            return shopgs.id === item.id;
          })
        : {};

      if ($scope.selected) {
        $scope.selected.shop = $scope.manageShopList.find(function (shop) {
          return shop.id === $scope.selected.shopid;
        });

        $scope.selected.game = $scope.gameList.find(function (game) {
          return game.id === $scope.selected.gameid;
        });

        $scope.selected.gameserver = $scope.manageParentGameServerList.find(
          function (gs) {
            return gs.id === $scope.selected.gameserverid;
          }
        );
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/supplier/gameserver/modals/shopGameServerUpdateModal.html",
        scope: $scope,
      });
      modalInstance.result.then(
        function (selectedItem) {
          console.log("selected", $scope.selected);

          var obj = {};
          obj.params = {};
          obj.params.id = $scope.selected.id;
          obj.params.gameid = $scope.selected.game
            ? $scope.selected.game.id
            : null;
          obj.params.shopid = $scope.selected.shop
            ? $scope.selected.shop.id
            : null;
          obj.params.playtechid = $scope.selected.playtechid;
          obj.params.bet_rate = $scope.selected.bet_rate;
          obj.params.onrate = $scope.selected.onrate;
          obj.params.gameserverid = $scope.selected.gameserver
            ? $scope.selected.gameserver.id
            : null;
          obj.params.server = $scope.selected.server || 0;
          obj.params.pr = $scope.selected.pr || 0;
          obj.params.algorithm = $scope.selected.algorithm;

          if (
            isNaN(obj.params.bet_rate) ||
            isNaN(obj.params.onrate) ||
            !obj.params.shopid ||
            !obj.params.playtechid
          ) {
            var error = !obj.params.shopid
              ? "Shop"
              : !obj.params.playtechid
              ? "PlaytechID"
              : !obj.params.bet_rate
              ? "Bonus Bet"
              : "Company %";
            toastr.error("Please input value for " + error, "Error");
            return;
          }

          console.log(obj.params);
          obj.onSuccess = function (result) {
            toastr.success(
              "Online Game has been saved successfully!",
              "SUCCESS"
            );
            $scope.initManageShopGameServer();
          };
          obj.onFailure = function (err) {
            $scope.initManageShopGameServer();
            if (err.status === -1) {
              toastr.error(
                "Service Unavailable. Please try again later",
                "Error"
              );
            } else {
              var errdetails = err.data.error.detail;
              toastr.error(errdetails, "Error");
            }
          };
          obj.params.id
            ? onlineShopService.saveOnlineshop(obj)
            : onlineShopService.createOnlineshop(obj);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.supplier.machinesales")
    .service("gameServerService", gameServerService);

  /** @ngInject */
  function gameServerService(GameServer) {
    var getGameServer = function (obj) {
      GameServer.find({
        filter: {
          include: [{ relation: "gameprovider", scope: { include: ["game"] } }],
        },
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var deleteGameServer = function (obj) {
      GameServer.deleteById({
        id: obj.params.id,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    var saveGameServer = function (obj) {
      var date = new Date();

      GameServer.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        providerid: obj.params.providerid,
        serverFee: obj.params.serverFee,
        customerFee: obj.params.customerFee,
        created: obj.params.id ? undefined : date,
      }).$promise.then(
        function (data) {
          obj.onSuccess(data);
        },
        function (err) {
          obj.onFailure(err);
        }
      );
    };

    return {
      getGameServer: getGameServer,
      saveGameServer: saveGameServer,
      deleteGameServer: deleteGameServer,
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales')
    .controller('MachinesalesSupplierPageCtrl', MachinesalesSupplierPageCtrl);

  /** @ngInject */
  function MachinesalesSupplierPageCtrl($scope, $filter, editableOptions, editableThemes,
    machinesalesSupplierService, machineShopService, gameService, shopService, partnerService, machinesalesService, dailyInvoiceService, validationService, toastr, $uibModal, $rootScope, zoneService, receiptService, userService, supplierService) {
    console.log("Inside MachinesalesSupplierPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachinesales(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    
    $scope.dayNightFilter = [{ value: 'day' }, { value: 'night' }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{ value: $rootScope.userData.credentials.shopType }];
    } else {
      $scope.shopTypeFilter = [{ value: '5/5' }, { value: '100%' }];
    }

    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
        console.log('$scope.manageZonesList', $scope.manageZonesList);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageUsersList = [];
    $scope.initAgents = function(){
      var obj = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS initAgents");
        console.log(result);
        $scope.manageUsersList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure initAgents");
        console.log(err);
      };
      userService.getUsersCSync(obj);
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function() {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.init = function () {
      $scope.initManageZones();
      $scope.initManagePartner();
      $scope.initManageGames();
      $scope.initManageMachineShop();
      $scope.initAgents();
      $scope.initManageSupplier();
    };
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchMachinesales = function (reportFilter) {
      console.log("Inside searchMachinesales");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0) {
                value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
          }
        }
        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }
        if (reportFilter.agent){
          obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        }
        if (reportFilter.daynight){
          obj.params.daynight=reportFilter.daynight?reportFilter.daynight.value:null;
        }
        if (reportFilter.supplier) {
          obj.params.supplierid=reportFilter.supplier?reportFilter.supplier.id:null;
        } else {
        if (typeof $rootScope.userData.credentials.supplier !== "undefined") {
          obj.params.supplierid = $rootScope.userData.credentials.supplier?$rootScope.userData.credentials.supplier.id:null;
        }
      }
        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.totalCommissionLabel = 0;
          $scope.manageMachinesalesList = result.result;
          for (var i = 0; i < $scope.manageMachinesalesList.length; i++) {
            $scope.totalSalesLabel = $scope.totalSalesLabel + parseFloat($scope.manageMachinesalesList[i].totalsales);
            $scope.manageMachinesalesList[i].commission = parseFloat($scope.manageMachinesalesList[i].totalsales) * parseFloat($scope.manageMachinesalesList[i].suprate/100);
            $scope.totalCommissionLabel = $scope.totalCommissionLabel + parseFloat($scope.manageMachinesalesList[i].commission);
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          // $scope.initManagePartner();
          // $scope.initManageGames();
          // $scope.initManageMachineShop();
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machinesalesSupplierService.getBetweenDatesMachinesales(obj)
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params={};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid=$rootScope.userData.credentials.zonemap;
      }else{
        obj.params.zoneid=null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    $scope.manageMachineShopList = [];
    $scope.initManageMachineShop = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineShopList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshopWithoutStatus(obj);
    };

    $scope.totalSalesLabel = 0;
    $scope.manageMachinesales = {};
    $scope.manageMachinesalesList = [];
    // $scope.searchMachinesales = function() {
    //   var obj = {};
    //   obj.params = {};
    //   obj.params.fromDt = $scope.dateList.from;
    //   obj.params.toDt = $scope.dateList.to;

    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.initManagePartner();
    //     $scope.initManageGames();
    //     $scope.initManageMachineShop();
    //     //$scope.initManagePrevMachineReading();
    //     $scope.manageMachinesalesList = result;
    //     $scope.isEdit = false;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machinesalesSupplierService.getBetweenDatesMachinesales(obj);
    //   //$scope.$broadcast('scroll.refreshComplete');
    // };
    //$scope.searchMachinesales();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/supplier/machinesales/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachinesales = function (res) {
      console.log("Inside deleteMachinesales");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
          $scope.searchMachinesales($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesSupplierService.deleteMachinesales(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.manageMachinesales = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveMachinesales = function (manageMachinesales, id) {

      console.log("Inside saveMachinesales");
      console.log(manageMachinesales);
      console.log(manageMachinesales.id);

      if (manageMachinesales.id === undefined) {
        $scope.createMachinesales(manageMachinesales);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageMachinesales;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachinesales = {};
          toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
          $scope.searchMachinesales($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
            toastr.error(errdetails, 'ERROR');
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        machinesalesSupplierService.saveMachinesales(obj);

        //$scope.modal.hide();
      }

    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (manageMachinesales) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      console.log(manageMachinesales);
      $scope.manageMachinesales = manageMachinesales;
      
      $scope.viewReceipts = {};

      var obj = {};
        obj.params = {};
        obj.params.receiptid = manageMachinesales.receiptid;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          if (result[0]){
            $scope.viewReceipts = JSON.parse(result[0].content);
            console.log($scope.viewReceipts);
          }
          $scope.getMachineInvoiceDetails(manageMachinesales.ikey);
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            var errdetails = [];
            errdetails = err.data.error.detail;
          }
        };
        receiptService.getReceipts(obj);
      
    };

    // $scope.dateformater = function(ikey) {
    //   var strikey = ikey.toString()
    //   var date = strikey.substring(strikey.length - 8);
    //   return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
    // };

    $scope.getMachineInvoiceDetails = function (ikey) {
      var obj = {};
      obj.params = {};
      obj.params.ikey = ikey;
      $scope.machineSalesInvoice = {};
      obj.onSuccess = function (result) {
        console.log("Inside getMachineInvoiceDetails SUCCESS");
        console.log(result);
        $scope.machineSalesInvoice = result;

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
      };
      dailyInvoiceService.getInvoiceByKey(obj);
    }

    $scope.showGameById = function (gid) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (gid && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: gid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showMachineShops = function (machineid) {
      if (machineid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: machineid
        }, true);
        return selected.length ? parseFloat(selected[0].macrate) : 'Not set';
      } else return 'Not set';
    };

    $scope.showPartnerById = function (manageMachinesales) {
      if (manageMachinesales && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: $scope.manageMachinesales.partnerid
        }, true);
        return selected.length ? selected[0].code + ', ' + selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showAgentsById = function(agentid) {
      if (agentid && $scope.manageUsersList.length) {
        var selected = $filter('filter')($scope.manageUsersList, {
          id: agentid
        },true);
        return selected.length ? selected[0].credentials.firstName+" "+selected[0].credentials.lastName : '';
      } else return 'Not set';
    };

    $scope.getTotaltotalsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.totalsales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.csales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalpsales = function (items) {
      if (items){
      return items
        .map(function (x) { return x.psales; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcommission = function (items) {
      if (items){
      return items
        .map(function (x) { return x.commission; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.supplier.machinesales')
    .service('machinesalesSupplierService', machinesalesSupplierService);

  /** @ngInject */
  function machinesalesSupplierService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getUTCDate();
    //   //var newDate  = new Date(date);
    //   console.log('date',date);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": date}
    //       },
    //       include: ["supplier","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   td.setHours(23);
    //   td.setMinutes(59);
    //   td.setSeconds(59);
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('client from date',fd);
    //   console.log('client from date1',date1); 
    //   console.log('client to date',td);
    //   console.log('client to date2',date2); 

    //   Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {indate: {gte: date1}},
    //                 {indate: {lte: date2}}
    //               ]
    //             },
    //             include: ["supplier","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    var getBetweenDatesMachinesales = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Machinesales.getAllSuppliersales({
        adate: date1,
        bdate: date2,
        shoptype: obj.params.shoptype ? obj.params.shoptype : null,
        zoneid: obj.params.zoneid ? obj.params.zoneid : null,
        agentid: obj.params.agentid?obj.params.agentid:null,
        daynight: obj.params.daynight?obj.params.daynight:null,
        supplierid: obj.params.supplierid?obj.params.supplierid:null,
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var deleteMachinesales = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
      Machinesales.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAvailableMachineByZone = function(obj) {
      Machinesales.getAvailableMacByZone({
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      // getDailyMachinesales: getDailyMachinesales,
      getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //      createMachinesales: createMachinesales,
      deleteMachinesales: deleteMachinesales,
     getAvailableMachineByZone:getAvailableMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.totalsales.collector")
    .controller("CollectorreportPageCtrl", CollectorreportPageCtrl);

  /** @ngInject */
  function CollectorreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    collectorreportService,
    zoneService,
    stateService,
    gameService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    $rootScope
  ) {
    console.log("Inside CollectorreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        {
          value: $rootScope.userData.credentials.shopType,
        },
      ];
    } else {
      $scope.shopTypeFilter = [
        {
          value: "5/5",
        },
        {
          value: "100%",
        },
      ];
    }

    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null,
      },
    };
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.reportFilter = {};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }

        // if (!validationService.compareDates(dateList.from,dateList.to)){
        //   isFormValidated = false;
        //   toastr.error('From Date should be less than To Date', 'ERROR');
        // }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from),
          y = fd.getFullYear(),
          m = fd.getMonth() + 1;
        var date1 = y + "-" + m + "-" + fd.getDate();

        var td = new Date($scope.dateList.to);
        y = td.getFullYear();
        m = td.getMonth() + 1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y + "-" + m + "-" + td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        // console.log('dateList.zone',dateList.zone);
        // console.log('dateList.shoptype',dateList.shoptype);

        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        if (reportFilter.state) {
          obj.params.stateid = reportFilter.state.id;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result) {
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {
              var onmacTotal =
                parseFloat($scope.managePartnersalesList[i].ontotal) +
                parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.initManageCollector = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    //     $scope.initManageStates = function() {
    //       var obj = {};
    //       obj.params = {};
    //       obj.params.fromDt = $scope.dateList.from;
    //       obj.params.toDt = $scope.dateList.to;

    //       obj.onSuccess = function(result) {
    //         console.log("Inside SUCCESS");
    //         console.log(result);
    //         $scope.initManagePartner();
    //         $scope.initManageGames();
    // //        $scope.initManageMachineShop();
    //         //$scope.initManagePrevMachineReading();
    //         $scope.managePartnersalesList = result;
    //         $scope.isEdit = false;
    //       };
    //       obj.onFailure = function(err) {
    //         console.log("Inside Failure");
    //         console.log(err);
    //       };
    //       collectorreportService.getBetweenDatesMachinesales(obj);
    //       //$scope.$broadcast('scroll.refreshComplete');
    //     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/totalsales/partnersales/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     collectorreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewMachinesales");
      console.log(onlinesales);

      $scope.managePartnersales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveMachinesales = function (managePartnersales, id) {
      console.log("Inside saveMachinesales");
      console.log(managePartnersales);
      console.log(managePartnersales.id);

      // if (managePartnersales.id === undefined) {
      //   $scope.createMachinesales(managePartnersales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = managePartnersales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.managePartnersales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   collectorreportService.saveMachinesales(obj);

      //   //$scope.modal.hide();
      // }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewMachinesales = function (managePartnersales) {
      console.log("Inside viewMachinesales");
      $scope.isEdit = true;
      $scope.managePartnersales = managePartnersales;
      console.log($scope.managePartnersales.partnerid);
      console.log($scope.managePartnersales.sname);
      $scope.getSalesOfShop(
        managePartnersales.partnerid,
        managePartnersales.shopid
      );
      //  $scope.getMachineSalesPrevReadings(managePartnersales.mid);
    };

    $scope.getSalesOfShop = function (partnerid, sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();
      var td = new Date($scope.dateList.to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);

      var date2 = y + "-" + m + "-" + td.getDate();

      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;
      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 =
            parseFloat(result.result[i].ontotal) +
            parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter =
            $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      };
      obj.onFailure = function (err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      collectorreportService.getGrpSalesForShopInRange(obj);
    };

    $scope.getTotalmactotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.mactotal;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalontotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.ontotal;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaltotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.total;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.collector')
    .service('collectorreportService', collectorreportService);

  /** @ngInject */
  function collectorreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        stateid: obj.params.stateid,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopC({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.totalsales.marketing")
    .controller("MarketingreportPageCtrl", MarketingreportPageCtrl);

  /** @ngInject */
  function MarketingreportPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    marketingreportService,
    shopService,
    partnerService,
    machinesalesService,
    validationService,
    toastr,
    $uibModal,
    zoneService,
    $rootScope
  ) {
    console.log("Inside MarketingreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteMachinesales(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [
        { value: $rootScope.userData.credentials.shopType },
      ];
    } else {
      $scope.shopTypeFilter = [{ value: "5/5" }, { value: "100%" }];
    }

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log("Inside Zonemap");
          for (
            var index = 0;
            index < $rootScope.userData.credentials.zonemap.length;
            index++
          ) {
            var zonelist = $filter("filter")(
              result,
              {
                id: $rootScope.userData.credentials.zonemap[index],
              },
              true
            );
            console.log("zonelist", zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    $scope.initManageZones();

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    var userReportDuration = $rootScope.userData.credentials.months;
    $scope.dateList = {
      from: moment().startOf("month").toDate(),
      to: moment().endOf("day").toDate(),
      options: {
        minDate: userReportDuration
          ? moment()
              .subtract(userReportDuration - 1, "month")
              .startOf("month")
              .toDate()
          : null,
      },
    };
    $scope.manageMarketingsales = {};
    $scope.manageMarketingsalesList = [];
    $scope.reportFilter = {};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (
        validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)
      ) {
        if (
          !validationService.verifyDate($scope.dateList.from) ||
          !validationService.verifyDate($scope.dateList.to)
        ) {
          isFormValidated = false;
          toastr.error(
            "Please enter a valid Date (dd/mm/yyyy) or Select from date picker",
            "ERROR"
          );
        }
      } else {
        isFormValidated = false;
        toastr.error("Please fill From and To Date for Search", "ERROR");
      }

      if (isFormValidated) {
        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from),
          y = fd.getFullYear(),
          m = fd.getMonth() + 1;
        var date1 = y + "-" + m + "-" + fd.getDate();

        var td = new Date($scope.dateList.to);
        y = td.getFullYear();
        m = td.getMonth() + 1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y + "-" + m + "-" + td.getDate();
        // obj.params.adate = date1;
        // obj.params.bdate = date2;
        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone
            ? "('" + reportFilter.zone.id + "')"
            : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (
              var index = 0;
              index < $rootScope.userData.credentials.zonemap.length;
              index++
            ) {
              if (index == 0) {
                value =
                  "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value =
                  value +
                  ",'" +
                  $rootScope.userData.credentials.zonemap[index] +
                  "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone
              ? "('" + reportFilter.zone.id + "')"
              : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype
            ? reportFilter.shoptype.value
            : null;
        }

        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result) {
            $scope.totalSalesLabel = 0;

            $scope.manageMarketingsalesList = result.result;
            for (var i = 0; i < result.result.length; i++) {
              var onmacTotal =
                parseFloat($scope.manageMarketingsalesList[i].ontotal) +
                parseFloat($scope.manageMarketingsalesList[i].mactotal);
              $scope.manageMarketingsalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        marketingreportService.getGrpSalesInRange(obj);
      }
    };

    $scope.initManageMarketing = function () {
      $scope.isEdit = false;
    };

    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length;
      var mm = dateRaw.substring(0, dateLength - 6);
      var dd = dateRaw.substring(2, dateLength - 4);
      var yy = dateRaw.substring(dateLength - 4);

      return mm + "/" + dd + "/" + yy;
    };

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    //$scope.manageGamesList = [];
    // $scope.initManageGames = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageGamesList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   gameService.getMachineGame(obj);
    // };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };

    // $scope.manageMachineShopList = [];
    // $scope.initManageMachineShop = function() {
    //   var obj = {};
    //   obj.onSuccess = function(result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     $scope.manageMachineShopList = result;
    //   };
    //   obj.onFailure = function(err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   machineShopService.getAllMachineshopWithoutStatus(obj);
    // };

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;
    //     $scope.initManageStates = function() {
    //       var obj = {};
    //       obj.params = {};
    //       obj.params.fromDt = $scope.dateList.from;
    //       obj.params.toDt = $scope.dateList.to;

    //       obj.onSuccess = function(result) {
    //         console.log("Inside SUCCESS");
    //         console.log(result);
    //         $scope.initManagePartner();
    //         $scope.initManageGames();
    // //        $scope.initManageMachineShop();
    //         //$scope.initManagePrevMachineReading();
    //         $scope.manageMarketingsalesList = result;
    //         $scope.isEdit = false;
    //       };
    //       obj.onFailure = function(err) {
    //         console.log("Inside Failure");
    //         console.log(err);
    //       };
    //       marketingreportService.getBetweenDatesMachinesales(obj);
    //       //$scope.$broadcast('scroll.refreshComplete');
    //     };
    //$scope.initManageStates();

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open("app/pages/totalsales/marketing/modals/dangerModal.html");
      $scope.deleteId = id;
    };

    // $scope.deleteMachinesales = function(res) {
    //   console.log("Inside deleteMachinesales");
    //   if (res) {
    //     console.log('Sure!');
    //     console.log($scope.deleteId);
    //     var obj = {};
    //     obj.params = {};
    //     obj.params.id = $scope.deleteId;
    //     obj.onSuccess = function(result) {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       toastr.success('Machinesales has been deleted successfully!', 'SUCCESS');
    //       //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Machinesales successfully deleted.");
    //       $scope.initManageStates();
    //       //$scope.searchSales(dateList)
    //     };
    //     obj.onFailure = function(err) {
    //       console.log("Inside Failure");
    //       console.log(err);
    //       if (err.status === -1) {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
    //       } else {
    //         //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
    //       }
    //     };
    //     marketingreportService.deleteMachinesales(obj);
    //   } else {
    //     console.log('Not sure!');
    //   }

    // };

    $scope.editState = function (onlinesales) {
      console.log("Inside viewSales");
      console.log(onlinesales);

      $scope.manageMarketingsales = onlinesales;
      genericModalService.show("modules/modals/addState.html", $scope);
    };

    $scope.saveSales = function (manageMarketingsales, id) {
      console.log("Inside saveSales");
      console.log(manageMarketingsales);
      console.log(manageMarketingsales.id);

      // if (manageMarketingsales.id === undefined) {
      //   $scope.createMachinesales(manageMarketingsales);
      // } else {

      //   var obj = {};
      //   obj.params = {};
      //   obj.params = manageMarketingsales;
      //   obj.onSuccess = function(result) {
      //     console.log("Inside SUCCESS");
      //     console.log(result);
      //     $scope.manageMarketingsales = {};
      //     toastr.success('Machinesales has been saved successfully!', 'SUCCESS');
      //     $scope.initManageStates();

      //   }
      //   obj.onFailure = function(err) {
      //     console.log("Inside Failure");
      //     console.log(err);
      //     if (err.status === -1) {
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
      //       toastr.error('NO INTERNET CONNECTION', 'Error');
      //     } else {
      //       var errdetails = [];
      //       errdetails = err.data.error.detail;
      //       toastr.error(errdetails, 'ERROR');
      //       //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
      //     }
      //   };
      //   marketingreportService.saveSales(obj);

      //   //$scope.modal.hide();
      // }
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.viewSales = function (manageMarketingsales) {
      console.log("Inside viewSales");
      $scope.isEdit = true;
      $scope.manageMarketingsales = manageMarketingsales;
      console.log($scope.manageMarketingsales.partnerid);
      console.log($scope.manageMarketingsales.sname);
      $scope.getSalesOfShop(
        manageMarketingsales.partnerid,
        manageMarketingsales.shopid
      );
      //  $scope.getMachineSalesPrevReadings(manageMarketingsales.mid);
    };

    $scope.getSalesOfShop = function (partnerid, sname) {
      console.log("Inside getSalesOfShop");
      var obj = {};
      obj.params = {};
      $scope.machineSalesOfPartner = {};
      $scope.machineSalesOfPartnerList = {};
      var fd = new Date($scope.dateList.from),
        y = fd.getFullYear(),
        m = fd.getMonth() + 1;
      var date1 = y + "-" + m + "-" + fd.getDate();
      var td = new Date($scope.dateList.to);
      y = td.getFullYear();
      m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + "-" + m + "-" + td.getDate();

      // obj.params.adate = date1;
      // obj.params.bdate = date2;
      obj.params.adate = date1;
      obj.params.bdate = date2;

      obj.params.partnerId = partnerid;
      obj.params.shopname = sname;
      console.log(obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside getMachineSalesOfPartner SUCCESS");
        console.log(result);
        $scope.totalSalesLabelFooter = 0;
        $scope.machineSalesOfPartnerList = result;
        for (var i = 0; i < result.result.length; i++) {
          var onMacTotalL2 =
            parseFloat(result.result[i].ontotal) +
            parseFloat(result.result[i].mactotal);
          $scope.machineSalesOfPartnerList.result[i].totalsales = onMacTotalL2;
          $scope.totalSalesLabelFooter =
            $scope.totalSalesLabelFooter + onMacTotalL2;
        }
        console.log($scope.totalSalesLabelFooter);
      };
      obj.onFailure = function (err) {
        console.log("Inside getMachineSalesOfPartner Failure");
      };
      marketingreportService.getGrpSalesForShopInRange(obj);
    };

    $scope.getTotalmactotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.mactotal;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalontotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.ontotal;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaltotal = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.total;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.totalsales.marketing')
    .service('marketingreportService', marketingreportService);

  /** @ngInject */
  function marketingreportService(Machinesales) {
    // var getDailyMachinesales = function(obj) {

    //   var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
    //   var date = y+'-'+m+'-'+d.getDate();
    //   var newDate  = new Date(date);
    //   console.log('date',newDate);

    //   Machinesales.find({
    //     filter: {
    //       where:{
    //         created:{"gte": newDate}
    //       },
    //       include: ["machine","shop"]
    //     }
    //   }).$promise.then(function(data) {
    //     console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    var getGrpSalesInRange = function (obj) {
      console.log(obj.params.test);
      Machinesales.grpByPartnerByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        shoptype: obj.params.shoptype,
        zoneid: obj.params.zoneid
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getGrpSalesForShopInRange = function (obj) {

      Machinesales.grpSalesByShopM({
        adate: obj.params.adate,
        bdate: obj.params.bdate,
        partnerId: obj.params.partnerId,
        shopname: obj.params.shopname
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //console.log(err)
        obj.onFailure(err);
      });
    };

    // var getBetweenDatesMachinesales = function(obj) {

    //   var from = obj.params.fromDt?obj.params.fromDt:null;
    //   var to = obj.params.toDt?obj.params.toDt:null;

    //   var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth()+1;
    //   var date1 = y+'-'+m+'-'+fd.getDate();

    //   var td = new Date(to); y = td.getFullYear(); m = td.getMonth()+1;
    //   var date2 = y+'-'+m+'-'+td.getDate();
    //   console.log('date1',date1);
    //   console.log('date2',date2);

    //         Machinesales.find({
    //           filter: {
    //             where:{
    //               and:[
    //                 {created: {gte: date1}},
    //                 {created: {lte:date2}}
    //               ]
    //             },
    //             include: ["machine","shop"]
    //           }
    //         }).$promise.then(function(data) {
    //           obj.onSuccess(data);
    //         }, function(err) {
    //           obj.onFailure(err);
    //         });

    // };

    // var deleteMachinesales = function(obj) {
    //   //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    //   Machinesales.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     //$ionicLoading.hide();
    //     //console.log(data);
    //     obj.onSuccess(data);

    //   }, function(err) {
    //     //$ionicLoading.hide();
    //     //console.log(err)
    //     obj.onFailure(err);
    //   });
    // };

    return {
      getGrpSalesInRange: getGrpSalesInRange,
      getGrpSalesForShopInRange: getGrpSalesForShopInRange
      //getDailyMachinesales: getDailyMachinesales,
      //getBetweenDatesMachinesales: getBetweenDatesMachinesales,
      //deleteMachinesales: deleteMachinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 300);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles')
      .controller('RolesPageCtrl', RolesPageCtrl);

  /** @ngInject */
  function RolesPageCtrl($scope, $filter, editableOptions, editableThemes,
    roleService,toastr,$uibModal ) {
    console.log("Inside RolesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteRole(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageRole={};
    $scope.manageRolesList=[];
    $scope.initManageRoles = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageRolesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        roleService.getRoles(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageRoles();

    $scope.addRole = function (){
      //genericModalService.show('modules/modals/addRole.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageRolesList.push($scope.inserted);
    };

    $scope.createRole = function(manageRole) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createRole");
      console.log(manageRole.name);
      console.log(manageRole.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageRole.name;
      obj.params.description = manageRole.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('New Role has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Role successfully created.");
          $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.createRole(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/usersetup/roles/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteRole = function (res){
      console.log("Inside deleteRole");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Role has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully deleted.");
              $scope.initManageRoles();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            roleService.deleteRole(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editRole = function (role){
      console.log("Inside editRole");
      console.log(role);
      // $scope.manageRole.id = $scope.manageRole.id;
      // $scope.manageRole.name = role.name;
      // $scope.manageRole.description = role.description;
      // $scope.manageRole.created = role.created;
      // $scope.manageRole.lastupdated = role.lastupdated;
      $scope.manageRole = role;
      genericModalService.show('modules/modals/addRole.html',$scope);
    }

    $scope.saveRole = function (manageRole, id){

      console.log("Inside saveRole");
      console.log(manageRole);
      console.log(id);

      if (id===undefined){
        $scope.createRole(manageRole);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageRole
      obj.params.id = id;
      // obj.params.name = $scope.manageRole.name;
      // obj.params.description = $scope.manageRole.description;
      //obj.params.created = $scope.manageRole.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('Role has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully Updated.");
        $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.saveRole(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.usersetup.roles')
    .service('roleService', roleService);

  /** @ngInject */
  function roleService(Role) {
    var getRoles = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.prototype$patchAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getRoles: getRoles,
      createRole: createRole,
      deleteRole: deleteRole,
      saveRole: saveRole
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.pages.usersetup.users")
    .controller("UsersPageCtrl", UsersPageCtrl);

  /** @ngInject */
  function UsersPageCtrl(
    $scope,
    $filter,
    editableOptions,
    editableThemes,
    stateService,
    userService,
    toastr,
    $uibModal,
    zoneService,
    roleService,
    $rootScope,
    rolemappingService,
    partnerService,
    collectorService,
    shopService,
    supplierService
  ) {
    console.log("Inside UsersPageCtrl");

    $scope.isTopLevelAdmin = $rootScope.userData.roleId === 1;

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.smartTablePageSize = 25;
    $scope.status = [
      {
        value: "Active"
      },
      {
        value: "Inactive"
      }
    ];
    $scope.emailVerified = [
      {
        value: true,
        text: "Yes"
      },
      {
        value: false,
        text: "No"
      }
    ];
    $scope.shopTypeFilter = [
      {
        value: "5/5"
      },
      {
        value: "100%"
      },
      {
        value: ""
      }
    ];

    $scope.accountHeadFilterRoles = [6, 7, 8, 9, 13, 16, 15, 17];
    $scope.isNotSuper = $rootScope.userData.credentials.role !== 1;

    //Getting Zones
    $scope.manageZonesList = [];
    $scope.filteredZoneList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.manageZonesList = result;
        var zoneMap = $rootScope.userData.credentials.zonemap || [];
        if ($scope.isNotSuper) {
          $scope.filteredZoneList = result.filter(function (r) {
            return zoneMap.includes(r.id);
          });
        } else {
          $scope.filteredZoneList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Getting Roles
    $scope.manageRoleList = [];
    $scope.filteredRoneList = [];
    $scope.initManageRole = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        $scope.manageRoleList = result;
        var myrole = $rootScope.userData.credentials.role;
        if ($scope.isNotSuper) {
          $scope.filteredRoneList = result.filter(function (r) {
            return $scope.accountHeadFilterRoles.includes(r.id);
          });
        } else {
          $scope.filteredRoneList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
    //Getting Partners
    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      var obj = {};
      obj.params = {};
      var myzone = $rootScope.userData.credentials.zonemap || [0];
      if ($scope.isNotSuper) {
        obj.params.zoneid = myzone;
      } else {
        obj.params.zoneid = null;
      }
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    //Getting Users
    $scope.manageUsersList = [];
    $scope.manageUser = {};
    $scope.initManageUsers = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);

        var hasZones = function (zonemap) {
          return (
            typeof zonemap !== "undefined" &&
            Array.isArray(zonemap) &&
            zonemap.length > 0
          );
        };

        var usersList = [];

        var loggedInUserZones = $rootScope.userData.credentials.zonemap || [];
        if ($scope.isNotSuper) {
          usersList = result.filter(function (r) {
            var userHasZones = hasZones(r.credentials.zonemap);
            if (!userHasZones) {
              return false;
            }
            return r.credentials.zonemap.some(function (z) {
              return loggedInUserZones.includes(z);
            });
          });
        } else {
          usersList = result;
        }

        if ($scope.isNotSuper) {
          usersList = usersList.filter(function (r) {
            if (r.roles.length === 0 && !!r.credentials.role) {
              r.roles[0] = {
                id: r.credentials.role
              };
              return $scope.accountHeadFilterRoles.includes(r.credentials.role);
            }
            return $scope.accountHeadFilterRoles.includes(r.roles[0].id);
          });
        }

        $scope.manageUsersList = usersList;

        $scope.initManageZones();
        $scope.initManageRole();
        $scope.initManagePartner();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };
    $scope.initManageUsers();

    //Getting States
    $scope.manageStatesList = [];
    $scope.initManageStates = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };
    $scope.initManageStates();

    $scope.initCollectors = function () {
      var obj = {
        params: {
          zoneid: null
        }
      };
      if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        obj.params.zoneid = $rootScope.userData.credentials.zonemap;
      }
      obj.onSuccess = function (result) {
        $scope.manageCollectors = result;
      };
      collectorService.getCollector(obj);
    };
    $scope.initCollectors();

    $scope.addUser = function () {
      //genericModalService.show('modules/modals/addUser.html',$scope);
      $scope.inserted = {
        name: null,
        description: null
      };
      $scope.manageUsersList.push($scope.inserted);
    };

    $scope.createUser = function (manageUser) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUser");
      console.log(manageUser);

      var obj = {};
      obj.params = {};
      obj.params = manageUser;
      // obj.params.name = manageUser.name;
      // obj.params.description = manageUser.description;
      // obj.params.zoneid = manageUser.zones
      // obj.params.stateid = manageUser.state;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success("New User has been saved successfully!", "SUCCESS");
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New User successfully created.");
        $scope.initManageUsers();
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {
          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      };
      userService.createUser(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.partnerRecordid = null;
    $scope.collectorRecordid = null;
    $scope.shopRecordid = null;
    $scope.supplierRecordid = null;
    $scope.confirmDelete = function (
      id,
      partnerRecordid,
      collectorRecordid,
      shopRecordid,
      supplierRecordid
    ) {
      $scope.open("app/pages/usersetup/users/modals/dangerModal.html");
      console.log("partnerRecordid", partnerRecordid);
      console.log("collectorRecordid", collectorRecordid);
      console.log("shopRecordid", shopRecordid);
      console.log("supplierRecordid", supplierRecordid);

      $scope.deleteId = id;
      if (typeof partnerRecordid !== "undefined") {
        $scope.partnerRecordid = partnerRecordid;
      }
      if (typeof collectorRecordid !== "undefined") {
        $scope.collectorRecordid = collectorRecordid;
      }
      if (typeof shopRecordid !== "undefined") {
        $scope.shopRecordid = shopRecordid;
      }
      if (typeof supplierRecordid !== "undefined") {
        $scope.supplierRecordid = supplierRecordid;
      }
    };

    $scope.deleteUser = function (res) {
      console.log("Inside deleteUser");
      if (res) {
        console.log("Sure!");
        console.log($scope.deleteId);
        if ($scope.partnerRecordid !== null) {
          var objParnter = {};
          objParnter.params = {};
          objParnter.params.id = $scope.partnerRecordid;

          objParnter.onSuccess = function (result) {
            console.log("Inside SUCCESS");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Partner");
              console.log(result);
              toastr.success("User has been deleted successfully!", "SUCCESS");
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Partner");
              console.log(err);
            };

            userService.deleteUser(obj);
          };
          objParnter.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);

            // special handle if partner is deleted
            if (err.status === 404) {
              var obj = {};
              obj.params = {};
              obj.params.id = $scope.deleteId;
              obj.onSuccess = function (result) {
                console.log("Inside SUCCESS Partner");
                console.log(result);
                toastr.success(
                  "User has been deleted successfully!",
                  "SUCCESS"
                );
                $scope.initManageUsers();
              };
              obj.onFailure = function (err) {
                console.log("Inside Failure Partner");
                console.log(err);
              };

              userService.deleteUser(obj);
            }
          };

          partnerService.unbindPartner(objParnter);
        } else if ($scope.collectorRecordid !== null) {
          var objCollector = {};
          objCollector.params = {};
          objCollector.params.id = $scope.collectorRecordid;

          objCollector.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Collector");
              console.log(result);
              toastr.success("User has been deleted successfully!", "SUCCESS");
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Collector");
              console.log(err);
            };

            userService.deleteUser(obj);
          };
          objCollector.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          collectorService.unbindCollector(objCollector);
        } else if ($scope.shopRecordid !== null) {
          var objShop = {};
          objShop.params = {};
          objShop.params.id = $scope.shopRecordid;

          objShop.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Shop");
              console.log(result);
              toastr.success("User has been deleted successfully!", "SUCCESS");
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Shop");
              console.log(err);
            };

            userService.deleteUser(obj);
          };
          objShop.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          shopService.unbindShopStaff(objShop);
        } else if ($scope.supplierRecordid !== null) {
          var objSupplier = {};
          objSupplier.params = {};
          objSupplier.params.id = $scope.supplierRecordid;

          objSupplier.onSuccess = function (result) {
            console.log("Inside SUCCESS Supplier");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Supplier");
              console.log(result);
              toastr.success("User has been deleted successfully!", "SUCCESS");
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Supplier");
              console.log(err);
            };

            userService.deleteUser(obj);
          };
          objSupplier.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          supplierService.unbindSupplier(objSupplier);
        } else if (
          $scope.collectorRecordid === null &&
          $scope.partnerRecordid === null &&
          $scope.shopRecordid === null &&
          $scope.supplierRecordid === null
        ) {
          var obj = {};
          obj.params = {};
          obj.params.id = $scope.deleteId;
          obj.onSuccess = function (result) {
            console.log("Inside SUCCESS");
            console.log(result);
            toastr.success("User has been deleted successfully!", "SUCCESS");
            $scope.initManageUsers();
          };
          obj.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };
          userService.deleteUser(obj);
        }
      } else {
        console.log("Not sure!");
      }
    };

    $scope.editUser = function (state) {
      console.log("Inside editUser");
      console.log(state);
      // $scope.manageUser.id = $scope.manageUser.id;
      // $scope.manageUser.name = state.name;
      // $scope.manageUser.description = state.description;
      // $scope.manageUser.created = state.created;
      // $scope.manageUser.lastupdated = state.lastupdated;
      $scope.manageUser = state;
      genericModalService.show("modules/modals/addUser.html", $scope);
    };

    $scope.saveUser = function (manageUser, userid, item) {
      console.log("Inside saveUser");
      console.log(manageUser);
      console.log(userid);

      if (userid === undefined) {
        $scope.createUser(manageUser);
      } else {
        var objRoleMap = {};
        objRoleMap.params = {};
        objRoleMap.params.principalid = userid;
        objRoleMap.params.roleid = manageUser.role;

        objRoleMap.onSuccess = function (result) {
          console.log("Inside SUCCESS objRoleMap");
          console.log(result);

          var objUpdateRole = {};
          objUpdateRole.params = {};
          if (result[0]) {
            objUpdateRole.params.id = result[0].id;
          }
          objUpdateRole.params.userid = userid;
          objUpdateRole.params.roleid = manageUser.role;
          objUpdateRole.onSuccess = function (result) {
            console.log("Inside SUCCESS objUpdateRole");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = userid;
            obj.params.credentials = {};
            obj.params.credentials.name = manageUser.name;
            obj.params.credentials.mobile = manageUser.mobile;
            obj.params.credentials.months = manageUser.months;
            obj.params.credentials.paparichMasterID =
              manageUser.paparichMasterID;
            obj.params.credentials.collectedDeposit =
              manageUser.collectedDeposit;
            obj.params.credentials.pan_limit = manageUser.pan_limit;
            obj.params.credentials.zonemap = manageUser.zonemap;
            obj.params.credentials.role = manageUser.role;
            obj.params.credentials.partner = manageUser.partner;
            obj.params.credentials.statemap = manageUser.statemap;
            obj.params.credentials.collectormap = manageUser.collectormap;
            if (manageUser.shopType != "") {
              obj.params.credentials.shopType = manageUser.shopType;
            }
            if (typeof item.credentials.shop !== "undefined") {
              obj.params.credentials.shop = item.credentials.shop;
            }
            if (typeof item.credentials.supplier !== "undefined") {
              obj.params.credentials.supplier = item.credentials.supplier;
            }
            obj.params.emailVerified = manageUser.emailVerified;

            console.log(obj.params);

            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS");
              console.log(result);
              $scope.manageUser = {};
              toastr.success("User has been updated successfully!", "SUCCESS");
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                toastr.error("NO INTERNET CONNECTION", "Error");
              } else {
                toastr.error(err.data.error.message, "Error");
              }
            };
            userService.saveUser(obj);
          };
          objUpdateRole.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
            if (err.status === -1) {
              toastr.error("NO INTERNET CONNECTION", "Error");
            } else {
              toastr.error(err.data.error.message, "Error");
            }
          };
          rolemappingService.saveRoleMapping(objUpdateRole);
        };
        objRoleMap.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error("NO INTERNET CONNECTION", "Error");
          } else {
            toastr.error(err.data.error.message, "Error");
          }
        };
        rolemappingService.getRoleMappingsbyID(objRoleMap);
      }
    };

    $scope.showStatus = function (status) {
      var selected = [];
      if (typeof status === "object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : "Not set";
      } else {
        return status;
      }
    };

    $scope.showAccess = function (emailVerified) {
      var selected = [];
      if (typeof emailVerified === "object" && emailVerified !== null) {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return emailVerified.value ? emailVerified.value : "No";
      } else {
        return emailVerified ? "Yes" : "No";
      }
    };

    $scope.showRoles = function (role) {
      if (role && $scope.manageRoleList.length) {
        var selected = $filter("filter")(
          $scope.manageRoleList,
          {
            id: role
          },
          true
        );
        return selected.length ? selected[0].name : "-";
      } else return "Not set";
    };

    $scope.showZones = function (zone) {
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter("filter")(
          $scope.manageZonesList,
          {
            id: zone
          },
          true
        );
        return selected.length ? selected[0].code : "-";
      } else return "Not set";
    };

    $scope.showCollectors = function (collector) {
      if (collector && $scope.manageCollectors.length) {
        var selected = $filter("filter")(
          $scope.manageCollectors,
          {
            id: collector
          },
          true
        );
        return selected.length ? selected[0].code : "-";
      } else return "Not set";
    };

    $scope.showPartners = function (partner) {
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter("filter")(
          $scope.managePartnerList,
          {
            id: partner
          },
          true
        );
        return selected.length ? selected[0].code : "-";
      } else return "Not set";
    };

    $scope.generatePassword = function () {
      var length = 8,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    };

    $scope.newPassword = "";

    $scope.openPassword = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size
      });
      modalInstance.result.then(
        function (selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        },
        function () {
          console.log("Modal dismissed at: " + new Date());
        }
      );
    };

    $scope.resetPassword = function (userid) {
      console.log("userid", userid);
      $scope.newPassword = $scope.generatePassword();
      console.log("newPassword", $scope.newPassword);

      var obj = {};
      obj.params = {};
      obj.params.id = userid;
      obj.params.password = $scope.newPassword;

      console.log(obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success("User has been updated successfully!", "SUCCESS");
        $scope.initManageUsers();
        $scope.openPassword(
          "app/pages/usersetup/users/modals/passwordModal.html"
        );
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error("NO INTERNET CONNECTION", "Error");
        } else {
          toastr.error(err.data.error.message, "Error");
        }
      };
      userService.resetPassword(obj);
    };

    $scope.showStates = function (state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter("filter")($scope.manageStatesList, {
          id: typeof state === "object" ? state.id : state
        });
        return selected.length ? selected[0].name : "-";
      } else return "Not set";
    };

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular
    .module("BlurAdmin.theme.components")
    .controller("BaSidebarCtrl", BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, $rootScope) {
    console.log($rootScope.userData);
    //$scope.menuItems = baSidebarService.getMenuItems();
    $scope.menuItems = baSidebarService.getAuthorizedMenuItems(
      $rootScope.userData
    );
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop =
        $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on("$stateChangeSuccess", function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
  "use strict";

  angular
    .module("BlurAdmin.theme.components")
    .provider("baSidebarService", baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function () {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function ($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function () {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function (item) {
            return item.level == 0;
          });

          menuItems.forEach(function (item) {
            var children = states.filter(function (child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.getAuthorizedMenuItems = function (user) {
          var role = user.roleId;
          var states = defineMenuItemStates();
          var menuItems = states.filter(function (item) {
            var conditionalRole = true;
            if (item.title === "Server Invoice") {
              conditionalRole =
                user.credentials &&
                user.credentials.partner &&
                user.credentials.partner.isparent;
            }

            return (
              item.level == 0 &&
              _.includes(item.authRoles, role) &&
              conditionalRole
            );
          });
          menuItems.forEach(function (item) {
            var children = states.filter(function (child) {
              var hasChildAuthRoles =
                child.authRoles &&
                Array.isArray(child.authRoles) &&
                child.authRoles.length > 0;
              return (
                child.level == 1 &&
                child.name.indexOf(item.name) === 0 &&
                (!hasChildAuthRoles || _.includes(child.authRoles, role))
              );
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function (isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function () {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function () {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function (item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu &&
              currentItem.subMenu.forEach(function (subItem) {
                subItem.stateRef && result.push(subItem.stateRef);
                _iterateSubItems(subItem);
              });
          }
        };

        function defineMenuItemStates() {
          return $state
            .get()
            .filter(function (s) {
              return s.sidebarMeta;
            })
            .map(function (s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: (s.name.match(/\./g) || []).length - 1,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                authRoles: s.authRoles,
              };
            })
            .sort(function (a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  "use strict";

  angular.module("BlurAdmin.theme.components").directive("pageTop", pageTop);

  /** @ngInject */
  function pageTop(memoService, $rootScope, $uibModal) {
    return {
      restrict: "E",
      templateUrl: "app/theme/components/pageTop/pageTop.html",
      link: function (scope) {
        scope.myInterval = 5000;
        scope.noWrapSlides = false;
        scope.active = 0;
        scope.isMemoOpen = false;
        var timer;

        var obj = {};
        memoService.getMemos(obj);

        obj.onSuccess = function (memos) {
          var role = $rootScope.userData.credentials.role;
          var zones = $rootScope.userData.credentials.zones;

          scope.memos = memos.filter(function (memo) {
            return role === 1
              ? true
              : (memo.zones || []).find(function (zone) {
                  return zones.includes(zone.id);
                }) && (memo.roles || []).includes(role);
          });

          if (!!scope.memos.length) {
            scope.openMemo();
          }
        };

        scope.openMemo = function () {
          if (scope.isMemoOpen || !scope.memos.length) {
            return;
          }

          scope.isMemoOpen = true;
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: "app/theme/components/pageTop/memo-slick.html",
            scope: scope,
            windowClass: "modal-memo",
          });
          modalInstance.result.then(
            function (isConfirm) {
              if (!isConfirm) {
                return;
              }
            },
            function () {
              scope.isMemoOpen = false;
            }
          );
        };

        scope.removeListener = function () {
          document.removeEventListener("visibilitychange", listener);
        };

        var listener = function (event) {
          if (document.hidden) {
            setpopUpTimer();
          } else {
            timer && clearTimeout(timer);
          }
        };

        document.addEventListener("visibilitychange", listener);

        function setpopUpTimer() {
          timer = setTimeout(function () {
            scope.openMemo();
          }, 60 * 1000);
        }
      },
    };
  }
})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
  "use strict";
  angular
    .module("BlurAdmin.pages.accDepartment.pnl")
    .directive("stFilteredCollection", stExport);

  function stExport() {
    return {
      restrict: "A",
      require: "^stTable",
      link: function (scope, element, smartTable, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function (val) {
          scope.filteredCollection = val;
        });
      },
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/authSignIn/authSignIn.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign in to Portal</h1><a ui-sref="authSignUp" class="auth-link">New to Portal? Sign up!</a><form class="form-horizontal" ng-submit="login(user)"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-model="user.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="user.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign in</button> <a href="" class="forgot-pass">Forgot password?</a></div></div></form></div></main></div>');
$templateCache.put('app/pages/authSignUp/authSignUp.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign up to Portal</h1><a ui-sref="authSignIn" class="auth-link">Already have a Portal account? Sign in!</a><form class="form-horizontal" ng-submit="validateRegistration(register)"><div class="form-group"><label for="inputName3" class="col-sm-3 control-label">State</label><div class="col-sm-9" ng-if="states.length > 0"><select class="form-control show-tick" title="State" selectpicker="" ng-model="register.state" data-style="btn-primary" data-container="body" ng-options="state.name for state in states"></select></div></div><div class="form-group"><label for="inputName3" class="col-sm-3 control-label">Name</label><div class="col-sm-9"><input type="text" ng-model="register.name" class="form-control" id="inputName3" placeholder="Full Name"></div></div><div class="form-group"><label for="inputMobile3" class="col-sm-3 control-label">Mobile (+60)</label><div class="col-sm-9"><input type="tel" ng-model="register.mobile" class="form-control" id="inputMobile3" placeholder="Mobile Number"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-3 control-label">Username</label><div class="col-sm-9"><input type="text" ng-model="register.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" ng-model="register.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-3 col-sm-9"><button type="submit" class="btn btn-default btn-auth">Sign up</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<span ng-if="!filterZone.stateid"><div class="row" ng-if="userData.roleId===1 || userData.roleId===3 || userData.roleId===5 || userData.roleId===18"><div class="col-lg-12"><h2>States Result:</h2></div><div class="col-lg-12" ng-repeat="group in dashboardV1List | groupBy: \'[stateid]\'"><div class="row"><div class="col-xlg-6 col-lg-7 col-md-12 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color: chocolate; color: black">{{ group[0].state }} - Revenue (\u6BCF\u65E5\u6536\u5165) <button class="btn btn-primary btn-xs margin-left" ng-click="viewStateDetail(group[0].stateid)">View Zones</button></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="group"><thead><tr><th class="text-center bold-text">Shop Type</th><th class="text-center bold-text bg-info" style="color: black">Online (\u7F51\u673A)</th><th class="text-center bold-text bg-info" style="color: black">Bank (pay - charge)</th><th class="text-center bold-text bg-info" style="color: black">Bank Out (pay - charge)</th><th class="text-center bold-text bg-info" style="color: black">E-wallet</th><th class="text-center bold-text bg-purple" style="color: black">Total (\u603B\u6570)</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in group | groupBy: \'[shoptype]\'"><td class="text-center">{{item[0].shoptype}}</td><td class="text-right bg-info" style="color: black">{{ getTotalontotal(item) | currency:\'\' }}</td><td class="text-right bg-info" style="color: black">{{ getTotalbanktotal(item) | currency:\'\' }}</td><td class="text-right bg-info" style="color: black">{{ getTotalbankouttotal(item) | currency:\'\' }}</td><td class="text-right bg-info" style="color: black">{{ getTotalEWalletTotal(item) | currency:\'\' }}</td><td class="text-right bg-purple" style="color: black">{{ getTotaltotal(item) | currency:\'\' }}</td></tr><tr class="popular-app-info"><td class="text-right" style="background-color: chocolate; color: black"></td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalontotal(group) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalbanktotal(group) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{ getTotalbankouttotal(group) | currency:\'\' }}</td><td class="text-right" style="background-color: chocolate; color: black">{{ getTotalEWalletTotal(group) | currency:\'\' }}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotaltotal(group) | currency:\'\'}}</td></tr></tbody></table></div></div><div class="col-xlg-6 col-lg-5 col-md-12 col-xs-12"><div ba-panel="" ba-panel-title="{{group[0].state}} - 10 Days Report (10\u5929\u62A5\u544A)" ba-panel-class="horizontal-scroll"><div>{{ group[0].stateid | json }}<canvas id="bar" class="chart chart-bar" chart-data="statesChartData[group[0].stateid]" chart-labels="group[0].weekLabels" chart-series="weekSeries" chart-dataset-override="datasetOverride"></canvas></div></div></div></div></div></div></span> <span ng-if="filterZone.stateid"><div class="row" ng-if="userData.roleId===1 || userData.roleId===3 || userData.roleId===5 || userData.roleId===18"><div class="col-lg-6"><h2>Zones Result:</h2><button class="btn btn-primary" ng-click="viewStateDetail(null)">View States</button></div><div class="col-lg-12" ng-repeat="v2 in dashboardV2ListDailysales | filter: filterZone"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color: chocolate; color: black"><div class="col-xs-9">{{v2.zone}} - Revenue (\u6BCF\u65E5\u6536\u5165)</div></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="group"><thead><tr><th class="text-center bold-text">Date</th><th class="text-center bold-text">Shop Type</th><th class="text-center bold-text bg-info" style="color: black">Online (\u7F51\u673A)</th><th class="text-center bold-text bg-info" style="color: black">Bank (pay - charge)</th><th class="text-center bold-text bg-info" style="color: black">Bank Out (pay - charge)</th><th class="text-center bold-text bg-info" style="color: black">E-wallet</th><th class="text-center bold-text bg-purple" style="color: black">Total (\u603B\u6570)</th><th class="text-center bold-text bg-info" style="color: black">Server</th><th class="text-center bold-text bg-info" style="color: black">Claim</th><th class="text-center bold-text bg-purple" style="color: black">Total</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in v2.dailysales"><td class="text-right bg-info" style="color: black">{{item.displayDate}}</td><td class="text-center"><a href="" ng-click="gotoDailyInvoice(item)">{{item.shoptype}} <i class="ion-eye"></i></a></td><td class="text-right bg-info" style="color: black">{{item.sales || 0 | currency:\'\'}}</td><td class="text-right bg-info" style="color: black">{{item.banksales || 0 | currency:\'\'}}</td><td class="text-right bg-info" style="color: black">{{getParsedBankOut(item) || 0 | currency:\'\'}}</td><td class="text-right bg-info" style="color: black">{{item.dewallet || 0 | currency:\'\'}}</td><td class="text-right bg-purple" style="color: black">{{getV2Totaltotal(item) || 0 | currency:\'\'}}</td><td class="text-right bg-info" style="color: black">{{getV2Server(item) || 0 | currency:\'\'}}</td><td class="text-right bg-info" style="color: black">{{ 0 | currency:\'\'}}</td><td class="text-right bg-purple" style="color: black">{{ getTotalServerClaim(item) || 0 | currency:\'\'}}</td></tr><tr class="popular-app-info"><td class="text-right" style="background-color: chocolate; color: black"></td><td class="text-right" style="background-color: chocolate; color: black"></td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalSales(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalbanktotal(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalbankouttotal(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalEWalletTotal(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getV2Totaltotal(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalserver(v2.dailysales) | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{0 | currency:\'\'}}</td><td class="text-right" style="background-color: chocolate; color: black">{{getTotalServerClaim(v2.dailysales) | currency:\'\'}}</td></tr></tbody></table></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-xs-12"><div ba-panel="" ba-panel-title="{{v2.zone}} - 10 Days Report (10\u5929\u62A5\u544A)" ba-panel-class="horizontal-scroll"><div><canvas id="bar" class="chart chart-bar" chart-data="v2ListMerge[v2.zoneid]" chart-labels="v2.weekLabels" chart-series="weekSeries" chart-dataset-override="datasetOverride"></canvas></div></div></div></div></div></div></span><div class="row"><div class="col-xlg-12 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-main clearfix"><div class="al-copy"><i class="fa fa-copyright"></i>Portal 2024</div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/paparichpointapproval/paparichpointapproval.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage \u52A0\u5206 ({{pointApprovalList.length}})" ba-panel-class="with-scroll"><div ng-if="!errorMessage" include-with-scope="app/pages/paparichpointapproval/widgets/paparichpointapprovalTable.html"></div><div ng-if="errorMessage" class="font-bold text-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Full Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" ng-model="manageProfile.credentials.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">System Role</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-3 control-label">{{ showRoles(manageProfile.credentials.role) }}</label></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" ng-model="manageProfile.password"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder="" ng-model="manageProfile.confirmPassword"></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" ng-model="manageProfile.credentials.mobile"></div></div></div></div><button type="button" class="btn btn-primary save-profile" ng-click="udpateProfile(manageProfile)">Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/scanner/scanner.html','<div id="reader" width="300px"></div><div><div class="row form-group"><div class="col-xs-12 col-sm-4">Shop</div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="selected.shop" uib-typeahead="shop as shop.name for shop in list.shops | filter:{name:$viewValue}" typeahead-template-url="customTemplate.html" class="form-control" typeahead-show-hint="true" typeahead-min-length="0"></div></div><div class="row form-group"><div class="col-xs-12 col-sm-4">Type</div><div class="col-xs-12 col-sm-8"><select class="form-control show-tick" ng-model="selected.type"><option ng-repeat="type in list.types" ng-value="type.value">{{type.label}}</option></select></div></div><div class="row form-group"><div class="col-xs-12 col-sm-4">Remarks</div><div class="col-xs-12 col-sm-8"><textarea class="form-control" ng-model="selected.remark"></textarea></div></div></div><div class="row"><div class="col-xs-12 text-right"><button class="btn btn-primary" ng-click="openCamera()">Scan</button></div></div><script type="text/ng-template" id="customTemplate.html"><a> <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span> </a></script>');
$templateCache.put('app/pages/shopad/shopad.html','<div class="widgets" ng-hide="selectedShopAd"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage \u9876\u5E97 ({{manageShopAdList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopad/widgets/shopadTable.html"></div></div></div></div></div><div class="row" ng-if="!!selectedShopAd"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopad/widgets/shopadInfo.html"></div></div></div></div>');
$templateCache.put('app/pages/shopaddress/shopaddress.html','<div class="widgets" ng-hide="selectedShopAddress"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage \u5730\u5740 ({{manageShopAddressList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopaddress/widgets/shopaddressTable.html"></div></div></div></div></div><div class="row" ng-if="!!selectedShopAddress"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopaddress/widgets/shopaddressInfo.html"></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/approval/approval.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Official Receipts ({{invReceipts.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/approval/widgets/invReceiptTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/accountType/accountType.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Account Type ({{accountTypeList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/accountType/widgets/accountTypeTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="createOtEditAccountType()">Add Account Type</button></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/ledger/ledger.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ledger ({{data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/ledger/widgets/ledgerTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/bill/bill.html','<div class="widgets" ng-show="!selectedBillExpDetailHistory"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Payment Voucher ({{billExpList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/bill/widgets/billTable.html"></div></div></div></div></div><div class="row" ng-show="selectedBillExpDetailHistory"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Payment Voucher Payment History ({{selectedBillExpDetailHistory.billNo}})" ba-panel-class="with-scroll panel-warning"><div include-with-scope="app/pages/accDepartment/bill/widgets/billPaymentHistory.html"></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/pnl/pnl.html','<div class="widgets" ng-if="!selectedPNL && !selectedLedger"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Profit & Loss ({{data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/pnl/widgets/pnlTable.html"></div></div></div></div></div><div class="row" ng-if="selectedPNL && !selectedLedger"><div class="col-md-12"><div ba-panel="" ba-panel-title="Profit & Loss ({{selectedPNL.shopname}})" ba-panel-class="with-scroll panel-info"><div include-with-scope="app/pages/accDepartment/pnl/widgets/pnlDetailTable.html"></div><button type="button" class="btn btn-default" ng-click="closePNLeDetail()">Close</button></div></div></div><div class="row" ng-if="selectedLedger"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ledger #{{reportFilter.month.title}} , {{selectedPNL.shopname}} , {{selectedLedger.catname}}" ba-panel-class="with-scroll panel-warning"><div include-with-scope="app/pages/accDepartment/pnl/widgets/ledgerTable.html"></div><button type="button" class="btn btn-default" ng-click="closeLedger()">Close</button></div></div></div>');
$templateCache.put('app/pages/account/partner/partner.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Partners ({{managePartnerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/partner/widgets/partnerTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/collector/collector.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Collectors ({{manageCollectorList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/collector/widgets/collectorTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/category/category.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Code ({{categoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/accDepartment/category/widgets/categoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="createOtEditCategory()">Add New Code</button></div></div></div></div>');
$templateCache.put('app/pages/account/supplier/supplier.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Suppliers ({{manageSupplierList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/supplier/widgets/supplierTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/usermapping/usermapping.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage User Mapping ({{manageUsermappingList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/usermapping/widgets/usermappingTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUsermapping()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/dailyinvoices.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Invoices ({{manageDailyinvoicesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoicesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif; font-size: 30px"><b>INVOICE</b></h1><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/collectors/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/collectors/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/csync/assigncollector/assigncollector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Assignment ({{manageCollectorsList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/csync/assigncollector/widgets/assigncollectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Collector and Shop Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="username" class="col-sm-3 control-label">Collector Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageCollector.credentials.firstName + " " + manageCollector.credentials.lastName}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"></div></div></div><h4>Assigned shops &nbsp; &nbsp;<button class="btn btn-primary btn-xs" ng-click="addShop()">Assign New</button></h4><table class="table table-striped table-condensed" st-safe-src="selectedShopList" st-table="selectedShopL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in selectedShopL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td>{{ item.name || \'Not Set\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="removeShop(item)">Remove</button></div></td></tr></tbody></table><div ng-show="isAssignNewShop"><br><h4>Unassigned shops</h4><br><div class="col-2 pt-5"><div class="form-check"><input id="flexCheckDefault" class="form-check-input" type="checkbox" ng-model="shopFilter.byUserZoneAndState" ng-change="getNotSelectedShops(manageCollector)"> <label class="form-check-label" for="flexCheckDefault">Filter shops by User\'s Zones.</label></div></div><table class="table table-striped table-condensed" st-safe-src="notSelectedShopList" st-table="notSelectedShopL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in notSelectedShopL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td>{{ item.name || \'Not Set\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="assignShop(item)">Assign</button></div></td></tr></tbody></table></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageOfficers()">Close</button></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/external/partnersales/partnersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Partner Sales ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/external/partnersales/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isEdit && !isInvoice"><div class="panel-content"><h2 class="text-success"></h2>000.<h3 class="with-line">Partner Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.name}}</label></div></div></div></div><hr><table ng-hide="isGroup" class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="npng" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="net_collect" class="bg-info" style="color:black">Company(Net Collect)</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey) | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.npng | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.net_collect | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oNetCollectTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody></table><table ng-show="isGroup" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="code" st-sort-default="true">Shop Code</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="net_collect" class="bg-info" style="color:black">Company(Net Collect)</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[code]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalnetpurhase(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotaloNetCollect(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oNetCollectTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype === \'5/5\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype !== \'5/5\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/invoice_for_rate_100.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="viewMachinesales(managePartnersales)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/external/suppliersales/suppliersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Sales By Supplier ({{manageSuppliersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/external/suppliersales/widgets/suppliersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Commission</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.rate}}%</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Supplier Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.contact}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfSupplierList.result" st-table="machineSalesOfSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="commission">Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey)}}</td><td>{{item.created | date: \'dd/MM/yyyy\'}}</td><td>{{(item.totalsales*manageSuppliersales.rate)/100 | currency:\'\' }}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/machinesales/machinesales.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Machine Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/machinesales/widgets/machinesalesTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createMachinesales(manageMachinesales)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachinesales()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/onlinesales/onlinesales.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Online Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/onlinesales/widgets/onlinesalesTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-disabled="!!loading" ng-click="createOnlinesales(manageOnlinesales)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageOnlinesales()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/allinvoices.html','<div class="widgets" ng-hide="selectedInvoiceWithShop || isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Invoices ({{manageAllinvoicesList.length }})" ba-panel-class="with-scroll"><div ng-show="loading.paidMainInvoiceReceipt" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesTable.html"></div></div></div></div></div><div class="widgets" ng-if="selectedInvoiceWithShop && !isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage {{selectedInvoiceWithShop.shopcode}} Invoices ({{manageAllinvoicesListWithShop.length }})" ba-panel-class="with-scroll bg-primary"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesShopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: &quot;Cooper Black&quot;, serif; font-size: 50px;"><b>Invoice</b></h1><h2 class="text-success"></h2><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesHeader.html"></div></div></div><br><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && (shopInvoiceDetails.shoptype === \'5/5\' || shopInvoiceDetails.shoptype === \'20%PR\')"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype === \'100%\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/invoice_for_rate_100.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/allinvoices/widgets/allinvoicesMachine.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/invoices/companyserverinvoice/companyserverinvoice.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Shops ({{manageOnlinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/invoices/companyserverinvoice/widgets/companyserverinvoiceTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/dailyinvoices.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Invoices ({{manageDailyinvoicesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoicesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif; font-size: 30px"><b>INVOICE</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && (shopInvoiceDetails.shoptype === \'5/5\' || shopInvoiceDetails.shoptype === \'20%PR\')"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype === \'100%\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/invoice_for_rate_100.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="initManageInvoice()" print-remove="">Close</button> <button type="button" class="btn btn-info save-profile" ng-click="saveShorts()" print-remove="">Save</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/invoices/shopcategory/shopCategory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Category Invoice" ba-panel-class="with-scroll"><div include-with-scope="app/pages/invoices/shopcategory/widgets/shopCategoryTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right"><span editable-text="manageMachinesales.cm_in" blur="cancel">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.cm_out" blur="cancel">{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_in" blur="cancel">{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_out" blur="cancel">{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}</span></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="saveCorrection(manageMachinesales)">Save</button></div>');
$templateCache.put('app/pages/machine/dailymachineshop/dailymachineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machine Sales By Shop ({{manageDailymachineshopList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineshopLevel2.html"></div></div>');
$templateCache.put('app/pages/machine/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/machine/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right"><span editable-text="manageMachinesales.cm_in" blur="cancel">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.cm_out" blur="cancel">{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_in" blur="cancel">{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}</span><br><span editable-text="manageMachinesales.bm_out" blur="cancel">{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}</span></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="saveCorrection(manageMachinesales)">Save</button></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/msync/importofficers/importofficers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Officer Details ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/importofficers/widgets/importofficersTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createImportofficers()">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageImportofficers()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/msync/officers/officers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Officers ({{manageOfficersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/officers/widgets/officersTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addOfficer()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/online/dailyonlinesales/dailyonlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Online Sales ({{manageOnlinesalesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/dailyonlinesales/widgets/dailyonlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Game</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.gamename}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Shop Code</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Upload Date</label><div class="col-sm-8"><label class="col-sm-5 control-label">{{manageOnlinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Kiosk</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Shop Name</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner</label><div class="col-sm-8"><label class="col-sm-8 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Progressive Share</label><div class="col-sm-6"><label class="col-sm-4 control-label">{{manageOnlinesales.pshare | currency:\'\' }}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Progressive Wins</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.pwin | currency:\'\' }}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Purchase</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Gaming</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bank</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.total_payment_gateway | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bank Charges({{manageOnlinesales.pg_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.pg_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.Ewallet</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_ewallet | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.Ewallet Charges({{manageOnlinesales.d_ewallet_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_ewallet_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.CC</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_cc | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.CC Charges({{manageOnlinesales.d_cc_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_cc_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Token</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.bonus_bet | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Lucky Wins</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.bonus_win | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner Bonus Bet({{manageOnlinesales.bet_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.p_bonus_bets | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Sales</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Company({{manageOnlinesales.onrate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner({{100 - manageOnlinesales.onrate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Collect</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.net_collect | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyOnlinesales(reportFilter)">Close</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineserver/dailyonlineserver.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ng-if="!isDetail" ba-panel="" ba-panel-title="Manage Input Online Server ({{manageDailyOnlineServerByGameList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/dailyonlineserver/widgets/dailyonlineserverbygameTable.html"></div></div><div ba-panel="" ba-panel-title="Manage Input Online Server Detail ({{selectedDetailList.length }})" ba-panel-class="with-scroll" ng-if="isDetail"><div include-with-scope="app/pages/online/dailyonlineserver/widgets/dailyonlineserverTable.html"></div></div><div class="add-row-editable-table" ng-if="isDetail"><button class="btn btn-primary" ng-click="closeDetail()">Close</button></div></div></div></div>');
$templateCache.put('app/pages/msync/paylist/paylist.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Paylist ({{managePaylistList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/msync/paylist/widgets/paylistTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/msync/paylist/widgets/paylistAdd.html"></div></div>');
$templateCache.put('app/pages/online/gamesales/gamesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Partner Sales ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/gamesales/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isEdit && !isInvoice"><div class="panel-content"><h2 class="text-success"></h2><h3 class="with-line">Partner Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.name}}</label></div></div></div></div><hr><table ng-hide="isGroup" class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color: black">Machine</th><th colspan="4" class="text-center bg-info" style="color: black">Online</th><th colspan="3" class="text-center bg-purple" style="color: black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color: black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color: black">Company</th><th st-sort="mactotal" class="bg-warning" style="color: black">Total</th><th st-sort="netpurchase" class="bg-info" style="color: black">NP</th><th st-sort="opsales" class="bg-info" style="color: black">Shop</th><th st-sort="net_collect" class="bg-info" style="color: black">Company(Net Collect)</th><th st-sort="ontotal" class="bg-info" style="color: black">Total</th><th st-sort="totalsales" class="bg-purple" style="color: black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color: black">Company</th><th st-sort="totalsales" class="bg-purple" style="color: black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey) | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color: black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color: black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color: black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ item.netpurchase | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ item.net_collect | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ item.totalsales | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td style="background-color: chocolate; color: black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{npTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oNetCollectTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{compOverTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody></table><table ng-show="isGroup" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color: black">Machine</th><th colspan="4" class="text-center bg-info" style="color: black">Online</th><th colspan="3" class="text-center bg-purple" style="color: black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="code" st-sort-default="true">Shop Code</th><th st-sort="mpsales" class="bg-warning" style="color: black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color: black">Company</th><th st-sort="mactotal" class="bg-warning" style="color: black">Total</th><th st-sort="opsales" class="bg-info" style="color: black">NP</th><th st-sort="opsales" class="bg-info" style="color: black">Shop</th><th st-sort="net_collect" class="bg-info" style="color: black">Company(Net Collect)</th><th st-sort="ontotal" class="bg-info" style="color: black">Total</th><th st-sort="totalsales" class="bg-purple" style="color: black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color: black">Company</th><th st-sort="totalsales" class="bg-purple" style="color: black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[code]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td class="bg-warning" style="color: black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color: black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color: black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ getTotalnetpurhase(item) | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ getTotaloNetCollect(item) | currency:\'\'}}</td><td class="bg-info" style="color: black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><div class="buttons text-center"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td style="background-color: chocolate; color: black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{npTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oNetCollectTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{compOverTotal | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchGameSales()">Close</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif; font-size: 50px"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype === \'5/5\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><div class="row" ng-if="(onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0) && shopInvoiceDetails.shoptype !== \'5/5\'"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/invoice_for_rate_100.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="viewMachinesales(managePartnersales)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineshop/dailyonlineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlineshopList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/dailyonlineshop/widgets/dailyonlineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{lookupDetails.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{lookupDetails.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/online/dailyonlineshop/widgets/viewOnlineShop.html"></div></div></div><hr><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Company %</label><div class="col-sm-8"><label class="col-sm-3 control-label">{{manageOnlineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner %</label><div class="col-sm-8"><label class="col-sm-3 control-label">{{manageOnlineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Sales</label><div class="col-sm-8"><label class="col-sm-3 control-label">{{manageOnlineshop.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Net Collect</label><div class="col-sm-8"><label class="col-sm-3 control-label">{{manageOnlineshop.net_collect | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getAllOnlinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/online/internalserverpr/internalserverpr.html','<div class="widgets" ng-show="!selectedFile"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Internal Server PR ({{manageFileList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/internalserverpr/widgets/internalserverPRFileTable.html"></div></div></div></div></div><div class="widgets" ng-show="!!selectedFile"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Internal Server PR ({{manageOnlineSalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/internalserverpr/widgets/internalserverprTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/online/onlinesales/onlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/onlinesales/widgets/onlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div include-with-scope="app/pages/online/onlinesales/widgets/viewSale.html"></div></div></div>');
$templateCache.put('app/pages/online/serversales/serversales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Server Sales ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/online/serversales/widgets/serversalesTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/operational/it/it.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/it/widgets/machineTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game Category</label><div class="col-sm-9"><ui-select ng-model="manageMachine.gamecategory" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="onCategoryChanged($item, $model)"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesCategoryList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game List</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in filterManageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/operational/it/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine(reportFilter)">Cancel</button></div>');
$templateCache.put('app/pages/operational/machine/machine.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/machine/widgets/machineTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addMachine()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game Category</label><div class="col-sm-9"><ui-select ng-model="manageMachine.gamecategory" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="onCategoryChanged($item, $model)"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesCategoryList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game List</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in filterManageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/operational/machine/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine(reportFilter)">Cancel</button></div>');
$templateCache.put('app/pages/operational/shop/shop.html','<div class="widgets" ng-hide="selectedShop || isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/shop/widgets/shopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addShop()">Add New</button></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Shop Information" form="vm.personalInfoForm"><div include-with-scope="app/pages/operational/shop/widgets/shopInfo.html"></div></ba-wizard-step><ba-wizard-step title="Online Games" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/shop/widgets/onlineGames.html"></div></ba-wizard-step><ba-wizard-step title="Machines" form="vm.addressForm"><div include-with-scope="app/pages/operational/shop/widgets/machines.html"></div></ba-wizard-step><ba-wizard-step title="Partner & Contact"><div include-with-scope="app/pages/operational/shop/widgets/partner.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-disabled="loading" ng-click="saveShop(manageShop)">Save</button> <button type="button" ng-disabled="loading" class="btn btn-default save-profile" ng-click="backToShopPage()">Back</button></div></div></div><div class="widgets" ng-show="selectedShop"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{selectedShop.code}} Profit Sharing" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/shop/widgets/profitsharingTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addNewProfitSharing()">Add New</button> <button class="btn btn-default" ng-click="closeProfitSharing()">Close</button></div></div></div></div>');
$templateCache.put('app/pages/operational/shopcategory/shopCategory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop Category ({{mangeShopCategoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/shopcategory/widgets/shopCategoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addNewShopCategory()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/paparichpointapproval/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this data!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="confirmDelete()">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/paparichpointapproval/modals/pointApprovalFormModal.html','<div ng-show="formLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selectedPointApproval.id ? \'Edit\' : \'Create New\'}} \u52A0\u5206</span></div><div class="modal-body text-left"><div class="row"><div class="col-sm-12 col-12"><div style="text-align: center"><div class="bg-danger" style="color: white; padding: 5px">Paparich Master ID</div><div style="padding: 5px; border: 1px solid #e3e3e3; border-top: none">{{selectedPointApproval.paparichMasterID}}</div></div></div><div class="col-sm-12 col-12"><div style="text-align: center"><div class="bg-danger" style="color: white; padding: 5px">Paparich Withdraw Limit</div><div style="padding: 5px; border: 1px solid #e3e3e3; border-top: none">{{selectedPointApproval.withdrawlimit | currency: \' \'}}</div></div></div><div class="col-sm-12 col-12"><div style="text-align: center"><div class="bg-danger" style="color: white; padding: 5px">Deposit Collected</div><div style="padding: 5px; border: 1px solid #e3e3e3; border-top: none">{{selectedPointApproval.depositcollected | currency: \' \'}}</div></div></div></div><div><h3 style="margin-top: 10px; margin-bottom: 5px">\u8FDB\u5206</h3><div class="row"><div class="col-12 col-sm-12"><div style="border: 1px solid #e3e3e3"><div class="row"><div class="col-sm-6 col-12"><div class="bg-danger" style="color: white; padding: 5px">\u76D8\u8D39\u989D\u5EA6Limit</div></div><div class="col-sm-6 col-12"><div style="padding: 5px; text-align: right">{{selectedPointApproval.panlimit | currency: \' \'}}</div></div></div></div></div><div class="col-12 col-sm-12"><div style="border: 1px solid #e3e3e3"><div class="row"><div class="col-sm-6 col-12"><div class="bg-danger" style="color: white; padding: 5px">\u672A\u4ED8\u76D8\u8D39Unpaid</div></div><div class="col-sm-6 col-12"><div style="padding: 5px; text-align: right">{{selectedPointApproval.unpaidinvoice | currency: \' \'}}</div></div></div></div></div><div class="col-12 col-sm-12"><div style="border: 1px solid #e3e3e3"><div class="row"><div class="col-sm-6 col-12"><div class="bg-danger" style="color: white; padding: 5px">\u9884\u4F30\u672A\u7ED3\u91D1\u989D Estimate outstanding</div></div><div class="col-sm-6 col-12"><div style="padding: 5px; text-align: right">{{selectedPointApproval.estimateoutstanding | currency: \' \'}}</div></div></div></div><div style="color: red; margin-top: 5px; font-weight: bold" ng-if="selectedPointApproval.estimateoutstanding > selectedPointApproval.panlimit">* \u9650\u989D\u5DF2\u5230\uFF0C\u8BF7\u5B89\u6392\u4ED8\u6B3E\u624D\u80FD\u8FDB\u5206 Your limit has been reached. Please arrange payment before points can be credited.</div></div></div></div><div style="margin: 20px 0"><div><div class="row"><div class="col-9 col-sm-9"></div><div class="col-3 col-sm-3"><div style="text-align: right">40%</div></div><div class="col-12 col-sm-12"><div><div style="display: flex; align-items: flex-end"><div style="width: 33%"><div class=""><div>\u4ECA\u5929\u8FDB\u7684\u5206\u6570 ({{selectedPointApproval.totalpointaddedcount}})</div><div style="margin-top: 5px">Total Point Added</div></div></div><div style="width: 33%; text-align: right"><div>{{selectedPointApproval.totalpointadded | currency: \' \'}}</div></div><div style="width: 33%; text-align: right"><div>{{selectedPointApproval.totalpointaddedafterrate | currency: \' \'}}</div></div></div></div></div><div class="col-12 col-sm-12" style="margin-top: 10px"><div><div style="display: flex; align-items: flex-end"><div style="width: 33%"><div><div>\u8981\u6C42\u8FDB\u5206</div><div style="margin-top: 5px">Points Request</div></div></div><div style="width: 33%; text-align: right"><div><input class="form-control" type="number" id="amount" ng-model="selectedPointApproval.point" ng-change="onInputChanged()" ng-if="allowToUpdate" ng-pattern="/^[0-9]+$/" min="0" onkeydown="return ( [\'Minus\', \'KeyE\', \'Equal\'].indexOf(event.code) === -1 );"><div ng-if="!allowToUpdate">{{selectedPointApproval.point | currency: \' \'}}</div></div></div><div style="width: 33%; text-align: right"><div>{{selectedPointApproval.pointafterrate | currency: \' \'}}</div></div></div><div style="color: red; margin-top: 5px; font-weight: bold" ng-if="selectedPointApproval.estimateoutstanding > selectedPointApproval.panlimit">* \u9650\u989D\u5DF2\u5230\uFF0C\u8BF7\u5B89\u6392\u4ED8\u6B3E\u624D\u80FD\u8FDB\u5206 Your limit has been reached. Please arrange payment before points can be credited.</div></div></div></div></div></div><div ng-if="selectedPointApproval.status !== \'Pending\'" style="text-align: center; font-weight: bold; padding: 10px" ng-style="selectedPointApproval.status === \'Rejected\' ? {\'color\': \'red\'} : {\'color\': \'green\'}">{{selectedPointApproval.status}}</div><div style="text-align: right"><button ng-if="isPartner && selectedPointApproval.status === \'Pending\'" type="button" class="btn btn-primary" ng-disabled="formLoading || selectedPointApproval.estimateoutstanding > selectedPointApproval.panlimit" ng-click="savePointApproval($dismiss)">Confirm</button> &nbsp; <button ng-if="(isAdmin || isAmy) && selectedPointApproval.status === \'Pending\'" ng-disabled="formLoading || selectedPointApproval.estimateoutstanding > selectedPointApproval.panlimit" type="button" class="btn btn-success" ng-click="toggleApprovalDialog(true, $dismiss)">Approve</button> &nbsp; <button ng-if="(isAdmin || isAmy) && selectedPointApproval.status === \'Pending\'" type="button" class="btn btn-danger" ng-click="toggleApprovalDialog(false, $dismiss)" ng-disabled="formLoading">Reject</button> &nbsp; <button type="button" ng-disabled="formLoading" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div></div>');
$templateCache.put('app/pages/paparichpointapproval/modals/pointApprovalStatusModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Approval Confirmation</span></div><div class="modal-body text-center">Are you sure you want to {{selectedPointApproval.status ? \'Approve\' : \'Reject\'}} this data?</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="confirmApproval()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/paparichpointapproval/widgets/paparichpointapprovalInfo.html','<div ng-show="formLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="row"><div class="col-12 col-sm-6"><div ng-if="summary.active" include-with-scope="app/pages/paparichpointapproval/widgets/pointaprovalSummary.html"></div></div><div class="col-12 col-sm-6"><div><div class="row"><div class="col-4 col-sm-4"></div><div class="col-4 col-sm-4"></div><div class="col-4 col-sm-4">40%\u8BA1\u7B97</div></div><div class="row"><div class="col-4 col-sm-4"><div>\u4ECA\u5929\u8FDB\u7684\u5206\u6570</div><div>Today\'s Point Added</div></div><div class="col-4 col-sm-4">{{summary.currentPointAdded | currency: \' \' }}</div><div class="col-4 col-sm-4">{{summary.currentPointAdded * 0.4 | currency: \' \'}}</div></div><div class="row"><div class="col-4 col-sm-4"><div>\u8981\u6C42\u8FDB\u5206\u6570</div><div>Point Request</div></div><div class="col-4 col-sm-4"><input class="form-control" type="number" id="input-point-request" ng-model="selectedPointApproval.point"></div><div class="col-4 col-sm-4">{{selectedPointApproval.point * 0.4 | currency: \' \'}}</div></div></div></div><div><button type="button" class="btn btn-primary" ng-disabled="formLoading || allowToUpdate" ng-click="savePointApproval()">Save</button> <button type="button" ng-disabled="formLoading || allowToUpdate" class="btn btn-default" ng-click="back()">Back</button></div></div>');
$templateCache.put('app/pages/paparichpointapproval/widgets/paparichpointapprovalTable.html','<div class="with-scroll"><div ng-show="tableLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-1" ng-if="isPartner && curentUserMasterID"><label>&nbsp;</label><div><button type="button" class="btn btn-success" ng-click="openDetailInfo()">Create</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="pointApprovalList" st-table="approvals"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="date">Date</th><th st-sort="paparichMasterID">Paparich Master ID</th><th st-sort="point">Request Point</th><th st-sort="status">Status</th><th st-sort="username">Created By</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="paparichMasterID" placeholder="Search Paparich Master ID" class="input-sm form-control search-input" type="search"></th><th></th><th><select placeholder="Filter Status" st-search="status" ng-model="statusFilter" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in approvalStatus | unique:\'value\'" value="{{status.value}}">{{status.label}}</option></select></th><th><input st-search="username" placeholder="Search Created By" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-if="!pointApprovalList.length"><td colspan="10">{{loading ? \'Loading...\' : \'No Data\'}}</td></tr><tr ng-repeat="item in approvals" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.date | date: \'dd/MM/yyyy\'}}</td><td>{{ item.paparichMasterID }}</td><td>{{ item.point | currency: \' \'}}</td><td ng-class="{ \'text-danger font-bold\': item.status === \'Rejected\', \'text-success font-bold\': item.status === \'Approved\' }">{{item.status}}</td><td>{{ item.username }}</td><td><div class="buttons"><button type="button" class="btn btn-info editable-table-button btn-xs" ng-click="openDetailInfo(item)">Edit</button> &nbsp; <button type="button" class="btn btn-danger editable-table-button btn-xs" ng-click="toggleDeleteDialog(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/paparichpointapproval/widgets/pointaprovalSummary.html','<div><div class="form-group row clearfix"><label for="paparichMasterID" class="col-sm-4 control-label">Paparich Master ID</label><div class="col-sm-8"><div>{{selectedPointApproval.paparichMasterID}}</div></div></div><div class="form-group row clearfix"><label for="paparichMasterID" class="col-sm-4 control-label">Paparich Bank Withdraw Limit</label><div class="col-sm-8"><div>{{summary.withdrawLimit | currency: \' \'}}</div></div></div><div class="form-group row clearfix"><label for="depositCollected" class="col-sm-4 control-label">Deposit Collected</label><div class="col-sm-8"><div>{{summary.depositCollected | currency: \' \'}}</div></div></div><div><div style="background-color: rgb(158, 33, 33); display: flex; justify-content: space-between; align-items: center;"><div style="flex: 1">\u76D8\u8D39\u989D\u5EA6 Limit</div><div style="width: 30%; text-align: right">{{summary.currentUserPointLimit | currency: \' \'}}</div></div><div style="display: flex; justify-content: space-between; align-items: center"><div style="flex: 1">\u672A\u4ED8\u76D8\u8D39 Unpaid</div><div style="width: 30%; text-align: right">{{summary.unpaidInvoice | currency: \' \'}}</div></div><div style="display: flex; justify-content: space-between; align-items: center"><div style="flex: 1">\u9884\u4F30\u672A\u7ED3\u91D1\u989D Estimate Outstanding</div><div style="width: 30%; text-align: right">{{summary.estimateOutstanding | currency: \' \'}}</div></div></div></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/partnerusers.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Users ({{manageUsersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/partneraccount/partnerusers/widgets/usersTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/partners/partnerinvoice/partnerinvoice.html','<div class="widgets" ng-hide="isInvoice"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Partner Sales ({{machineSalesOfPartnerList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/partners/partnerinvoice/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.NP.length>0 || onlineInvoiceDetails.NG.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br></div><button type="button" class="btn btn-default save-profile" ng-click="getShopSalesOfPartner(shopSalesOfPartnerList)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/reports/collector/collector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Collector ({{managePartnersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/collector/widgets/collectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ispaid" placeholder="Search Invoice Status" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageCollector()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.machine.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.machine.cmRate}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cmIn==0?\'-\':(manageMachinesales.cmIn | currency: \'\':0) }}<br>{{manageMachinesales.cmOut==0?\'-\':(manageMachinesales.cmOut | currency: \'\':0) }}<br>{{manageMachinesales.bmIn==0?\'-\':(manageMachinesales.bmIn | currency: \'\':0) }}<br>{{manageMachinesales.bmOut==0?\'-\':(manageMachinesales.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cmInP==0?\'-\':(manageMachinesales.cmInP | currency: \'\':0) }}<br>{{manageMachinesales.cmOutP==0?\'-\':(manageMachinesales.cmOutP | currency: \'\':0) }}<br>{{manageMachinesales.bmInP==0?\'-\':(manageMachinesales.bmInP | currency: \'\':0) }}<br>{{manageMachinesales.bmOutP==0?\'-\':(manageMachinesales.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cmIn - manageMachinesales.cmInP)==0?\'-\':(manageMachinesales.cmIn - manageMachinesales.cmInP | currency: \'\':0) }}<br>{{(manageMachinesales.cmOut - manageMachinesales.cmOutP)==0?\'-\':(manageMachinesales.cmOut - manageMachinesales.cmOutP | currency: \'\':0) }}<br>{{(manageMachinesales.bmIn - manageMachinesales.bmInP)==0?\'-\':(manageMachinesales.bmIn - manageMachinesales.bmInP | currency: \'\':0) }}<br>{{(manageMachinesales.bmOut - manageMachinesales.bmOutP)==0?\'-\':(manageMachinesales.bmOut - manageMachinesales.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div>');
$templateCache.put('app/pages/reports/dailymachineshop/dailymachineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machine Sales By Shop ({{manageDailymachineshopList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineshopLevel2.html"></div></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/dailyonlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Online Sales ({{manageOnlinesalesList.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailyonlinesales/widgets/dailyonlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.game.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-6"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\' }}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\' }}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/dailyonlineshop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlineshopList.result.length }})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/dailyonlineshop/widgets/dailyonlineshopTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{lookupDetails.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{lookupDetails.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/reports/dailyonlineshop/widgets/viewOnlineShop.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner %</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button></div>');
$templateCache.put('app/pages/reports/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.machine.gameid)}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><h5><u>Current Readings</u></h5><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmIn}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmOut}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmIn}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmOut}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><h5><u>Previous Readings</u></h5><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmInP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.cmOutP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM IN</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmInP}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM OUT</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.bmOutP}}</label></div></div><p><br></p></div></div><hr><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{showMachineShops(manageMachinesales.machineid, manageMachinesales.shopid)}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - showMachineShops(manageMachinesales.machineid, manageMachinesales.shopid)}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.psales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div>');
$templateCache.put('app/pages/reports/marketing/marketing.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Marketing ({{manageMarketingsalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/marketing/widgets/marketingTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageMarketing()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/reports/onlinesales/onlinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Online Sales ({{manageOnlinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/onlinesales/widgets/onlinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div include-with-scope="app/pages/reports/onlinesales/widgets/viewSale.html"></div></div></div>');
$templateCache.put('app/pages/reports/partnersales/partnersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Partner Sales ({{managePartnersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/partnersales/widgets/partnersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isEdit && !isInvoice"><div class="panel-content"><h3 class="with-line">Partner Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.name}}</label></div></div></div></div><hr><table ng-hide="isGroup" class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="3" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey) | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ocsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody></table><table ng-show="isGroup" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="3" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[shopid]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalocsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-show="isInvoice"><div class="panel-content"><div class="print-content" print-section="" print-avoid-break=""><div class="row"><div class="col-md-12"><h1 style="font-family: \'Cooper Black\', serif;font-size: 50px;"><b>V {{shopInvoiceDetails.zone.name | uppercase}}</b></h1><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html"></div></div></div><br><div class="row" ng-if="onlineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html"></div></div></div><br><div class="row" ng-if="machineInvoiceDetails.length>0"><div class="col-md-12"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html"></div></div></div><br><div class="row"><div class="col-md-10" print-remove=""></div><div class="col-md-2"><div include-with-scope="app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html"></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="viewMachinesales(managePartnersales)" print-remove="">Close</button> <button type="button" class="btn btn-primary save-profile" ng-click="print()" print-remove="">Print</button></div></div>');
$templateCache.put('app/pages/reports/suppliersales/suppliersales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Sales By Supplier ({{manageSuppliersalesList.result.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/suppliersales/widgets/suppliersalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Supplier Commission</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.rate}}%</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Supplier Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageSuppliersales.contact}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfSupplierList.result" st-table="machineSalesOfSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="commission">Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{dateFormater(item.ikey)}}</td><td>{{item.created | date: \'dd/MM/yyyy\'}}</td><td>{{(item.totalsales*manageSuppliersales.rate)/100 | currency:\'\' }}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(dateList)">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/shopad/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopad/modals/deleteShopAdModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this data!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopad/widgets/shopadInfo.html','<div><div ng-show="formLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="row"><div class="col-12 col-sm-12"><div class="form-group row clearfix"><label for="unit" class="col-sm-3 control-label">Shop</label><div class="col-sm-9"><ui-select ng-model="selectedShopAd.shop" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" close-on-select="true" on-select="onShopSelect($item)"><ui-select-match placeholder="Searching Shop" allow-clear="true">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="shop in searchShopList | filter: $select.search track by shop.id"><span style="color: black">{{shop.code}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="address" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea placeholder="Address" class="form-control" ng-model="selectedShopAd.address" ng-disabled="formDisabled"></textarea></div></div><div class="form-group row clearfix"><label for="address" class="col-sm-3 control-label">\u9876\u4EF7</label><div class="col-sm-9"><input class="form-control" type="number" id="amount" ng-model="selectedShopAd.amount"></div></div><div class="form-group row clearfix"><label for="input-personInCharge" class="col-sm-3 control-label">\u8054\u7EDC\u4EBA</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="selectedShopAd.contactName" ng-disabled="formDisabled"></div></div><div class="form-group row clearfix"><label for="input-phone" class="col-sm-3 control-label">\u8054\u7EDC\u4EBA\u7535\u8BDD 1</label><div class="col-sm-9"><input type="tel" class="form-control" ng-model="selectedShopAd.contactPhoneNumbersOne" ng-disabled="formDisabled"></div></div><div class="form-group row clearfix"><label for="input-phone" class="col-sm-3 control-label">\u8054\u7EDC\u4EBA\u7535\u8BDD 2</label><div class="col-sm-9"><input type="tel" class="form-control" ng-model="selectedShopAd.contactPhoneNumbersTwo" ng-disabled="formDisabled"></div></div><div class="form-group row clearfix"><label for="photo" class="col-sm-3 control-label">Photos</label><div class="col-sm-9"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files)" ng-model="file" name="file" ngf-pattern="\'image/*\'" ng-disabled="formDisabled" ngf-resize-if="$width > 1000 || $height > 1000 || $file.size > 400000" ngf-resize="{width: 1000, height: 1000, quality: 0.7, type: \'image/jpeg\'}" ngf-accept="\'image/*\'"><div ng-if="!selectedShopAd.photos.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo)" ng-style="{\'background-image\': \'url(\\\'\' + photo.url + \'\\\')\'}" ng-repeat="photo in selectedShopAd.photos"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-click="deleteImage($index)"></i></div></div></div></div></div><div><button type="button" class="btn btn-primary save-profile" ng-disabled="formLoading || formDisabled" ng-click="saveShopAd()">Save</button> <button type="button" ng-disabled="formLoading" class="btn btn-default save-profile" ng-click="back()">Back</button></div></div></div>');
$templateCache.put('app/pages/shopad/widgets/shopadTable.html','<div class="with-scroll" style="overflow-y: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="form-group col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="row clearfix"><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-success" ng-click="editOrCreateShopAd()">Create</button></div></div></div></div></div><table-scroller-bar></table-scroller-bar><table class="table table-striped table-condensed" st-safe-src="manageShopAdList" st-table="manageShopAd"><thead sticky-on-scroll="" ng-if="showHeader"><tr class="sortable"><th class="table-id">#</th><th>Action</th><th st-sort="createdAt">Created Date</th><th st-sort="contactName">\u8054\u7EDC\u4EBA</th><th st-sort="contactPhoneNumbersOne">\u8054\u7EDC\u7535\u8BDD 1</th><th st-sort="contactPhoneNumbersTwo">\u8054\u7EDC\u7535\u8BDD 2</th><th st-sort="address">\u5730\u5740</th><th st-sort="shop.code">Shop</th><th st-sort="amount">\u9876\u4EF7</th><th>Photos</th></tr><tr><th></th><th></th><th></th><th><input st-search="contactName" placeholder="Search \u8054\u7EDC\u4EBA." class="input-sm form-control search-input" type="search"></th><th><input st-search="contactPhoneNumbersOne" placeholder="Search \u8054\u7EDC\u7535\u8BDD 1" class="input-sm form-control search-input" type="search"></th><th><input st-search="contactPhoneNumbersTwo" placeholder="Search \u8054\u7EDC\u7535\u8BDD 2" class="input-sm form-control search-input" type="search"></th><th><input st-search="address" placeholder="Search \u5730\u5740" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-if="loading"><td colspan="5">Loading...</td><td colspan="5">Loading...</td></tr><tr ng-if="!loading && manageShopAd.length == 0" style="background-color: white"><td colspan="5" class="text-center">No data found</td><td colspan="5" class="text-center">No data found</td></tr><tr ng-repeat="item in manageShopAd" class="editable-row"><td class="table-id">{{$index+1}}</td><td><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOrCreateShopAd(item)" ng-disabled="!item.canDeleteData">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDeleteShopAd(item.id)" ng-disabled="!item.canDeleteData">Delete</button></td><td>{{item.createdAt | date:\'dd/MM/yyyy HH:mm a\'}}</td><td>{{item.contactName}}</td><td>{{item.contactPhoneNumbersOne}}</td><td>{{item.contactPhoneNumbersTwo}}</td><td>{{item.address}}</td><td>{{item.shop.code}}</td><td>{{item.amount | currency: \' \'}}</td><td><button class="btn btn-success editable-table-button btn-xs" ng-click="viewPhotos(item.photos)" ng-disabled="!item.photos.length">{{item.photos.length ? item.photos.length + \' photo\' : \'No photo\'}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/shopaddress/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopaddress/modals/deleteShopAddressModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this data!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopaddress/widgets/shopaddressInfo.html','<div><div ng-show="formLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="row"><div style="padding: 15px; text-align: center; border: 1px solid black; margin-bottom: 15px; font-weight: bold;" class="col-12 col-sm-12 bg-warning" ng-if="currentStep == 1 && (selectedShopAddress.localfourDStatus == \'Pending\' || selectedShopAddress.localtopupStatus == \'Pending\')">Pending for {{selectedShopAddress.localfourDStatus ? \'4D\' : \'\'}} {{selectedShopAddress.localfourDStatus && selectedShopAddress.localtopupStatus ? \' & \' : \'\'}} {{selectedShopAddress.localtopupStatus ? \'Top Up (Paparich)\' : \'\'}} Approval</div><div class="col-12 col-sm-12" ng-if="currentStep > 2"><div class="form-group" style="border-bottom: 1px solid lightgrey; padding-bottom: 15px; font-size: 2rem; font-weight: bold; margin-bottom: 15px; text-transform: uppercase;">3. Confirm Address</div><div class="form-group row clearfix"><label for="photo" class="col-sm-3 control-label">\u88C5\u4FEE\u540E\u7167\u7247</label><div class="col-sm-9"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files, \'photosAfterRenovation\')" ng-model="file" ng-disabled="currentStep > 3 || formDisabled" name="file" ngf-pattern="\'image/*\'" ngf-resize="{width: 1000, height: 1000, quality: 0.7, type: \'image/jpeg\'}" ngf-resize-if="$width > 1000 || $height > 1000 || $file.size > 400000" ngf-accept="\'image/*\'"><div ng-if="!selectedShopAddress.photosAfterRenovation.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo)" ng-style="{\'background-image\': \'url(\\\'\' + photo.url + \'\\\')\'}" ng-repeat="photo in selectedShopAddress.photosAfterRenovation"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-hide="currentStep > 3 || formDisabled" ng-click="deleteImage($index, \'photosAfterRenovation\')"></i></div></div></div></div><div class="form-group row clearfix"><label for="input-confirmedAddress" class="col-sm-3 control-label">\u786E\u8BA4\u6700\u540E\u6C34\u7535\u5355\u5730\u5740</label><div class="col-sm-9"><input type="text" class="form-control" id="input-confirmedAddress" ng-model="selectedShopAddress.confirmedAddress" ng-disabled="currentStep > 3 || formDisabled"> <small>*\u8981\u548C\u4E4B\u524D\u6C34\u7535\u5355\u5730\u5740\u4E00\u6837</small><div class="text-danger" ng-if="!isAdmin && selectedShopAddress.confirmedAddress && selectedShopAddress.confirmedAddress.trim().toLowerCase() !== selectedShopAddress.address.trim().toLowerCase()">\u5730\u5740\u4E0D\u5339\u914D\uFF01</div></div></div></div><div class="col-12 col-sm-12" ng-if="currentStep > 1"><div class="form-group" style="border-bottom: 1px solid lightgrey; padding-bottom: 15px; font-size: 2rem; font-weight: bold; margin-bottom: 15px; text-transform: uppercase;">2. Tenancy Agreement</div><div class="form-group row clearfix"><label for="photo" class="col-sm-3 control-label">Tenancy Agreement</label><div class="col-sm-9"><button ng-if="currentStep === 2" type="button" class="btn btn-primary" ng-disabled="formLoading || formDisabled" ng-click="saveShopAddress()">Confirmed Tenancy Agreement</button><div ng-if="currentStep !== 2 && selectedShopAddress.tenancyAgreementConfirmAt">{{selectedShopAddress.tenancyAgreementConfirmAt | date: \'dd/MM/yyyy hh:mm a\'}}</div><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo)" ng-style="{\'background-image\': \'url(\\\'\' + photo.url + \'\\\')\'}" ng-repeat="photo in selectedShopAddress.photosTenancyAgreement"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-hide="currentStep > 2 || formDisabled" ng-click="deleteImage($index, \'photosTenancyAgreement\')"></i></div></div></div></div><div class="col-12 col-sm-12"><div class="form-group" style="border-bottom: 1px solid lightgrey; padding-bottom: 15px; font-size: 2rem; font-weight: bold; margin-bottom: 15px; text-transform: uppercase;">{{!selectedShopAddress.id ? \'\u65B0\u5730\u5740\' : \'1. \u7F16\u8F91\u5730\u5740\'}}</div><div class="form-group row clearfix"><label for="unit" class="col-sm-3 control-label">Unit/No.</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="selectedShopAddress.houseUnitNo" ng-disabled="currentStep > 1 || formDisabled" ng-keydown="$event.keyCode === 32 && $event.preventDefault()"> <small>*\u95E8\u724C\u8981\u6B63\u786E\u3002\u4E0D\u80FD\u6709\u7A7A\u683C</small></div></div><div class="form-group row clearfix"><label for="address" class="col-sm-3 control-label">\u6C34\u7535\u5355\u5730\u5740</label><div class="col-sm-9"><input id="autocomplete" class="form-control" type="text" placeholder="Search address" ng-model="selectedShopAddress.address" ng-disabled="currentStep > 1 || formDisabled"><div style="margin-top: 5px" map-lazy-load="https://maps.google.com/maps/api/js" map-lazy-load-params="{{lazyLoadGoogleMapsUrl}}"><ng-map id="map-canvas" center="{{mapCenter}}" zoom="15" default-style="true"><marker position="{{markerPos}}" visible="{{!!markerPos}}" draggable="true" on-dragend="onMarkerDragEnd($event)"></marker></ng-map><div style="margin-top: 5px"><button style="width: 120px" type="button" class="btn btn-danger" ng-if="search.googleMapsUrl" ng-click="openUrl(search.googleMapsUrl)">Google Maps</button> <button style="width: 120px" type="button" class="btn btn-info" ng-if="search.wazeUrl" ng-click="openUrl(search.wazeUrl)">Waze</button></div></div></div></div><div class="form-group row clearfix"><label for="input-pr-code" class="col-sm-3 control-label">Daerah PR</label><div class="col-sm-9 form-group"><ui-select ng-model="selectedShopAddress.zonepr" class="btn-group bootstrap-select form-control" ng-disabled="currentStep > 1 || formDisabled" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesPRList | filter: $select.search"><span>{{ zone.code }}, {{ zone.name }}</span></ui-select-choices></ui-select></div></div><div class="row clearfix form-group"><label for="input-modes" class="col-sm-3 control-label">\u6A21\u5F0FA</label><div class="col-sm-9"><ui-select style="border: 1px solid #cbcbcb" ng-model="selectedShopAddress.modes" class="btn-group bootstrap-select form-control" ng-disabled="currentStep > 1 || formDisabled" append-to-body="true" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.title}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="mode in manageSAJModes | filter: $select.search"><span style="color: black" ng-bind-html="mode.title"></span></ui-select-choices></ui-select><div style="margin-top: 5px"><div ng-repeat="package in shopAddressPackageTypeList"><input ng-model="selectedShopAddress.myModePackage[package.value]" type="checkbox" id="{{package.value}}"> <label style="padding: 0 0 10px 5px; margin: 0" for="{{package.value}}">{{package.label}}</label></div></div></div></div><div class="form-group row clearfix"><label for="photo" class="col-sm-3 control-label">\u6C34\u7535\u5355\u7167\u7247</label><div class="col-sm-9"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files, \'photos\')" ng-model="file" ng-disabled="currentStep > 1 || formDisabled" name="file" ngf-pattern="\'image/*\'" ngf-resize="{width: 1000, height: 1000, quality: 0.7, type: \'image/jpeg\'}" ngf-resize-if="$width > 1000 || $height > 1000 || $file.size > 400000" ngf-accept="\'image/*\'"><div ng-if="!selectedShopAddress.photos.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo)" ng-style="{\'background-image\': \'url(\\\'\' + photo.url + \'\\\')\'}" ng-repeat="photo in selectedShopAddress.photos"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-hide="currentStep > 1" ng-click="deleteImage($index, \'photos\')"></i></div></div></div></div><div class="form-group row clearfix"><label for="photo" class="col-sm-3 control-label">\u88C5\u4FEE\u524D\u7167\u7247</label><div class="col-sm-9"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files, \'photosBeforeRenovation\')" ng-model="file" name="file" ngf-pattern="\'image/*\'" ng-disabled="currentStep > 1 || formDisabled" ngf-resize-if="$width > 1000 || $height > 1000 || $file.size > 400000" ngf-resize="{width: 1000, height: 1000, quality: 0.7, type: \'image/jpeg\'}" ngf-accept="\'image/*\'"><div ng-if="!selectedShopAddress.photosBeforeRenovation.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo)" ng-style="{\'background-image\': \'url(\\\'\' + photo.url + \'\\\')\'}" ng-repeat="photo in selectedShopAddress.photosBeforeRenovation"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-click="deleteImage($index, \'photosBeforeRenovation\')" ng-hide="currentStep > 1"></i></div></div></div></div><div class="form-group row clearfix"><label for="input-createdAtRemark" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea type="text" class="form-control" ng-model="selectedShopAddress.createdAtRemark" ng-disabled="currentStep > 1 || formDisabled"></textarea></div></div><div class="form-group row clearfix"><label for="input-remarkFromSuperman" class="col-sm-3 control-label">Remarks To PR</label><div class="col-sm-9"><textarea type="text" class="form-control" ng-model="selectedShopAddress.remarkFromSuperman" ng-disabled="currentStep > 1 || formDisabled"></textarea></div></div><div class="form-group row clearfix"><label for="input-approvalAtRemark" class="col-sm-3 control-label">Remarks From PR</label><div class="col-sm-9"><textarea type="text" class="form-control" ng-model="selectedShopAddress.approvalAtRemark" ng-disabled="true"></textarea></div></div><div class="form-group row clearfix"><label for="input-personInCharge" class="col-sm-3 control-label">\u8054\u7EDC\u4EBA</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="selectedShopAddress.personInCharge" ng-disabled="currentStep > 1 || formDisabled"></div></div><div class="form-group row clearfix"><label for="input-phone" class="col-sm-3 control-label">\u8054\u7EDC\u4EBA\u7535\u8BDD</label><div class="col-sm-9"><input type="tel" class="form-control" ng-model="selectedShopAddress.phone" ng-disabled="currentStep > 1"></div></div></div><div><button ng-if="currentStep !== 2" type="button" class="btn btn-primary save-profile" ng-disabled="formLoading || formDisabled" ng-click="saveShopAddress()">Save</button> <button type="button" ng-disabled="formLoading" class="btn btn-default save-profile" ng-click="back()">Back</button></div></div></div>');
$templateCache.put('app/pages/shopaddress/widgets/shopaddressTable.html','<div class="with-scroll" style="overflow-y: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="form-group col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="row clearfix"><div class="form-group col-12 col-sm-2"><label>Select Daerah PR</label><ui-select ng-model="reportFilter.zonepr" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesPRList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="form-group col-xs-4 col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-success" ng-click="editOrCreateShopAddress()">Create</button></div></div></div></div></div><table-scroller-bar></table-scroller-bar><table class="table table-striped table-condensed" st-safe-src="manageShopAddressList" st-table="manageShopAddress"><thead sticky-on-scroll="" ng-if="showHeader"><tr class="sortable"><th class="table-id">#</th><th>Action</th><th>Approve 4D</th><th>Approve TopUp</th><th st-sort="createdAt">Created Date</th><th st-sort="houseUnitNo">Unit/No.</th><th st-sort="address">\u6C34\u7535\u5355Address</th><th st-sort="zonepr.code">Daerah PR</th><th st-sort="modesTitle">\u6A21\u5F0FA</th><th>\u6C34\u7535\u5355\u7167\u7247</th><th>\u88C5\u4FEE\u524D\u7684\u7167\u7247</th><th st-sort="createdAtRemark">Remarks</th><th st-sort="approvalAtRemark">Remarks From PR</th><th st-sort="createdBySupermanUser.username">Partner User</th><th st-sort="personInCharge">\u8054\u7EDC\u4EBA</th><th st-sort="phone">\u8054\u7EDC\u4EBA\u7535\u8BDD</th><th st-sort="approvalAt">PR\u5BA1\u6279\u65E5\u671F</th><th st-sort="tenancyAggrementCountdownDuration">Tenancy Agreement Countdown</th><th st-sort="renovationCountdownDuration">Renovation Countdown</th></tr><tr><th></th><th></th><th><select placeholder="Filter Approve 4D" st-search="localfourDStatus" ng-model="localFourDStatusFilter" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in modesApprovalStatusList | unique:\'value\'" value="{{status.value}}">{{status.label}}</option></select></th><th><select placeholder="Filter Approve TopUp" st-search="localtopupStatus" ng-model="localTopUpStatusFilter" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in modesApprovalStatusList | unique:\'value\'" value="{{status.value}}">{{status.label}}</option></select></th><th></th><th><input st-search="houseUnitNo" placeholder="Search Unit/No." class="input-sm form-control search-input" type="search"></th><th><input st-search="address" placeholder="Search Address" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonepr.code" placeholder="Search Daerah PR" class="input-sm form-control search-input" type="search"></th><th><input st-search="modesTitle" placeholder="Search \u6A21\u5F0FA" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="createdAtRemark" placeholder="Search Remarks" class="input-sm form-control search-input" type="search"></th><th><input st-search="approvalAtRemark" placeholder="Search Remarks From PR" class="input-sm form-control search-input" type="search"></th><th><input st-search="createdBySupermanUser.username" placeholder="Search Partner User" class="input-sm form-control search-input" type="search"></th><th><input st-search="personInCharge" placeholder="Search \u8054\u7EDC\u4EBA" class="input-sm form-control search-input" type="search"></th><th><input st-search="phone" placeholder="Search \u8054\u7EDC\u4EBA\u7535\u8BDD" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="loading"><td colspan="8">Loading...</td><td colspan="8">Loading...</td></tr><tr ng-if="!loading && manageShopAddress.length == 0" style="background-color: white"><td colspan="8" class="text-center">No data found</td><td colspan="8" class="text-center">No data found</td></tr><tr ng-repeat="item in manageShopAddress" class="editable-row"><td class="table-id">{{$index+1}}</td><td><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOrCreateShopAddress(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDeleteShopAddress(item.id)">Delete</button></td><td ng-class="{ \'text-danger\': [\'Rejected\'].includes(item.localfourDStatus), \'text-warning\': [\'Pending\'].includes(item.localfourDStatus)}">{{item.localfourDStatus}}</td><td ng-class="{ \'text-danger\': [\'Rejected\'].includes(item.localtopupStatus), \'text-warning\': [\'Pending\'].includes(item.localtopupStatus)}">{{item.localtopupStatus}}</td><td>{{item.createdAt | date:\'dd/MM/yyyy HH:mm a\'}}</td><td>{{item.houseUnitNo}}</td><td>{{item.address}}</td><td>{{item.zonepr.code}}</td><td>{{item.modesTitle}}</td><td><button class="btn btn-success editable-table-button btn-xs" ng-click="viewPhotos(item.photos)" ng-disabled="!item.photos.length">{{item.photos.length ? item.photos.length + \' photo\' : \'No photo\'}}</button></td><td><button class="btn btn-info editable-table-button btn-xs" ng-click="viewPhotos(item.photosBeforeRenovation)" ng-disabled="!item.photosBeforeRenovation.length">{{item.photosBeforeRenovation.length ? item.photosBeforeRenovation.length + \' photo\' : \'No photo\'}}</button></td><td><span style="white-space: pre-line">{{item.createdAtRemark}}</span></td><td><span style="white-space: pre-line">{{item.approvalAtRemark}}</span></td><td>{{item.createdBySupermanUser.username}}</td><td>{{item.personInCharge}}</td><td>{{item.phone}}</td><td>{{item.approvalAt ? (item.approvalAt | date:\'dd/MM/yyyy HH:mm a\') : \'\'}}</td><td ng-class="{\'text-danger\': item.tenancyAggrementCountdownDuration !== null}">{{item.tenancyAggrementCountdownDuration}}</td><td ng-class="{\'text-danger\': item.renovationCountdownDuration !== null}">{{item.renovationCountdownDuration}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/supplier/gameprovider/gameprovider.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Game Provider ({{manageParentGameProviderList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/supplier/gameprovider/widgets/gameProviderTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addNew()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/supplier/gameserver/gameserver.html','<div class="widgets"><div class="row"><div class="col-md-12" ng-if="!isViewShop"><div ba-panel="" ba-panel-title="Manage Game Server ({{manageParentGameServerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/supplier/gameserver/widgets/gameserverTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addNew()">Add New</button></div></div><div class="col-md-12" ng-if="isViewShop"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopGameServerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/supplier/gameserver/widgets/gameserverShopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="openShopGameServerModal()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/supplier/machinesales/machinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage All Supplier Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/supplier/machinesales/widgets/machinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Supplier Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Rate%</th><th class="text-center">Commission</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br>{{manageMachinesales.created | date: \'hh:mm a\'}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td>{{manageMachinesales.suprate}}%</td><td>{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales*(manageMachinesales.suprate/100) | currency: \'\')}}</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="searchMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/dailymachinesales.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daily Machine Sales ({{manageMachinesalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/shopstaff/dailymachinesales/widgets/dailymachinesalesTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.shopcode}}</label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showGameById(manageMachinesales.gameid)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageMachinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Agent</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{showAgentsById(manageMachinesales.agentid)}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.name}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMachinesales.mid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageMachinesales)}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><table class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th></tr></thead><tbody><tr class="editable-tr-wrap"><td class="align-right">{{manageMachinesales.mid}}<br>{{manageMachinesales.cm_rate}}<br></td><td><img ng-show="viewReceipts.cm!==null" ng-src="{{viewReceipts.cm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.cm)"> <img ng-show="viewReceipts.bm!==null" ng-src="{{viewReceipts.bm}}" style="text-align: center; width:200px;height:200px" ng-click="zoomReceipts(viewReceipts.bm)"></td><td class="align-right">{{manageMachinesales.cm_in==0?\'-\':(manageMachinesales.cm_in | currency: \'\':0) }}<br>{{manageMachinesales.cm_out==0?\'-\':(manageMachinesales.cm_out | currency: \'\':0) }}<br>{{manageMachinesales.bm_in==0?\'-\':(manageMachinesales.bm_in | currency: \'\':0) }}<br>{{manageMachinesales.bm_out==0?\'-\':(manageMachinesales.bm_out | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.cm_in_p==0?\'-\':(manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.cm_out_p==0?\'-\':(manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_in_p==0?\'-\':(manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{manageMachinesales.bm_out_p==0?\'-\':(manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{(manageMachinesales.cm_in - manageMachinesales.cm_in_p)==0?\'-\':(manageMachinesales.cm_in - manageMachinesales.cm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.cm_out - manageMachinesales.cm_out_p)==0?\'-\':(manageMachinesales.cm_out - manageMachinesales.cm_out_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_in - manageMachinesales.bm_in_p)==0?\'-\':(manageMachinesales.bm_in - manageMachinesales.bm_in_p | currency: \'\':0) }}<br>{{(manageMachinesales.bm_out - manageMachinesales.bm_out_p)==0?\'-\':(manageMachinesales.bm_out - manageMachinesales.bm_out_p | currency: \'\':0) }}<br></td><td class="align-right">{{manageMachinesales.totalsales==0?\'-\':(manageMachinesales.totalsales | currency: \'\')}}</td><td class="align-right">{{manageMachinesales.psales==0?\'-\':(manageMachinesales.psales | currency: \'\')}}<br>({{100 - showMachineShops(manageMachinesales.machineid)}}%)</td><td class="align-right">{{manageMachinesales.csales==0?\'-\':(manageMachinesales.csales | currency: \'\')}}<br>({{showMachineShops(manageMachinesales.machineid)}}%)</td></tr></tbody></table><hr></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyMachinesales(reportFilter)">Close</button></div>');
$templateCache.put('app/pages/system/areas/areas.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daerah ({{manageAreasList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/areas/widgets/areasTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/gamecategory/gamecategory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Game Category ({{manageGamecategoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/gamecategory/widgets/gamecategoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/games/games.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Games ({{manageGamesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/games/widgets/gamesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/machine/machine.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/machine/widgets/machineTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addMachine()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/system/machine/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine()">Cancel</button></div>');
$templateCache.put('app/pages/system/memo/memo.html','<div class="widgets" ng-if="!selectedMemo"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Memo ({{memoList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/memo/widgets/memoTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="createMemo()">Create</button></div></div></div></div><div class="row" ng-if="selectedMemo"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{selectedMemo.id ? \'Edit\' : \'Create\'}} Memo" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/memo/widgets/memoDetail.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMemo()" ng-disabled="!selectedMemo.description || !selectedMemo.title">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="goToListPage()">Back</button></div></div></div>');
$templateCache.put('app/pages/system/site/site.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Balai ({{manageSiteList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/site/widgets/siteTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addSite()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/shop/old.html','<div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.shoptype"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.address"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Machine and Online %</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Online Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Online Game Tips%</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Online Game %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Online %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Mach Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Mach Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Machine %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Mach %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macvirtual"></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.remarks"></div></div></div></div><h3 class="with-line">Partner info</h3><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div>');
$templateCache.put('app/pages/system/shop/shop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/shop/widgets/shopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addShop()">Add New</button></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Shop Information" form="vm.personalInfoForm"><div include-with-scope="app/pages/system/shop/widgets/shopInfo.html"></div></ba-wizard-step><ba-wizard-step title="Online Games" form="vm.productInfoForm"><div include-with-scope="app/pages/system/shop/widgets/onlineGames.html"></div></ba-wizard-step><ba-wizard-step title="Machines" form="vm.addressForm"><div include-with-scope="app/pages/system/shop/widgets/machines.html"></div></ba-wizard-step><ba-wizard-step title="Partner & Contact"><div include-with-scope="app/pages/system/shop/widgets/partner.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div></div>');
$templateCache.put('app/pages/system/states/states.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage States ({{manageStatesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/states/widgets/statesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/zones/zones.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daerah ({{manageZonesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/zones/widgets/zonesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/zonespr/zonesPR.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Daerah PR ({{manageZonesPRList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/zonespr/widgets/zonesPRTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addNewZone()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/totalsales/collector/collector.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Collector ({{managePartnersalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/totalsales/collector/widgets/collectorTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{managePartnersales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th><th st-sort="net_collect">Net Collect</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ispaid" placeholder="Search Invoice Status" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.net_collect" e-name="net_collect" e-form="rowform" e-required="">{{ item.net_collect | currency:\'\'}}</span></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageCollector()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/totalsales/marketing/marketing.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Total Sales by Marketing ({{manageMarketingsalesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/totalsales/marketing/widgets/marketingTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Detailed Report</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.contact}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.pname}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageMarketingsales.code}}</label></div></div></div></div><hr><table class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="invoice">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="totalsales">Total Sales</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'Not Generated\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\' }}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\'}}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody></table><hr><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default save-profile" ng-click="initManageMarketing()">Close</button></div><div class="col-md-7"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label"></label></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabelFooter | currency:\'\'}}</label></div></div></div></div></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/usersetup/users/users.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Users ({{manageUsersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/usersetup/users/widgets/usersTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/usersetup/roles/roles.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Roles ({{manageRolesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/usersetup/roles/widgets/rolesTable.html"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/memo-slick.html','<slick dots="true" infinite="true" speed="300" slides-to-show="1" slides-to-scroll="1" ng-if="!!memos.length"><div ng-repeat="memo in memos" style="position: relative"><div style="width: 100%"><h4 style="padding: 20px; border-bottom: 1px solid #cbcbcb; margin-bottom: 20px; font-weight: bold;">{{memo.title}}</h4><div style="padding: 20px; max-height: 550px; overflow: auto" ng-bind-html="memo.description"></div></div></div></slick>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span></span>Portal</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="kameleon-icon with-round-bg danger"><img ng-src="assets/img/theme/icon/kameleon/Money-Increase.svg"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/main/profile"><i class="fa fa-user"></i>Profile</a></li><li ng-click="openMemo()" ng-if="!!memos.length"><a style="cursor: pointer"><i class="fa fa-bell"></i>Memo</a></li><li><a href=""><i class="fa fa-cog"></i>Settings</a></li><li ng-click="removeListener()"><a href="#/authSignIn" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><div class="user-profile clearfix" style="margin-top: 0px"><a href="" class="al-logo"><span>Greetings,</span>{{userData.credentials.name}}</a></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/accDepartment/approval/modals/deleteModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this official receipt!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/approval/modals/paidInvoiceModal.html','<div class="modal-header bg-warning"><i class="ion-flame modal-icon"></i><span>Approval</span> <span style="font-weight: bold">{{getTotaPaidNetCollect() | currency: \'\'}}</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label for="orno" class="col-sm-4 control-label">ORNO</label><div class="col-sm-8">{{selectedInvReceipts.orno}}</div></div><div class="row clearfix"><label class="col-sm-4">Date</label><div class="col-sm-8"><div class="input-group">{{selectedInvReceipts.paidAt | date: \'dd/MM/yyyy\' }}</div></div></div><div class="form-group row clearfix"><label for="description" class="col-sm-4 control-label">Description</label><div class="col-sm-8">{{ selectedInvReceipts.description }}</div></div><div class="form-group row clearfix"><label for="total" class="col-sm-4 control-label">Total</label><div class="col-sm-8">{{getTotalPaidReceipt() | currency: \'\'}}</div></div><div class="clearfix" ng-repeat="paidInovice in selectedInvReceipts.invoices"><h3 style="margin-bottom: 20px; margin-top: 20px; border-bottom: 1px solid black;"></h3><div class="form-group row"><label for="shop" class="col-sm-4 control-label">Shop Code</label><div class="col-sm-8">{{paidInovice.shopcode}}</div></div><div class="form-group row"><label class="col-sm-4 control-label">Net Collect</label><div class="col-sm-8">{{paidInovice.net_collect | currency: \'\'}}</div></div><div class="form-group row"><label class="col-sm-4 control-label">Paid Amount</label><div class="col-sm-8">{{paidInovice.amount | currency: \'\'}}</div></div><div class="row clearfix"><label for="photo" class="col-sm-4 control-label">Photo</label><div class="col-sm-8"><div ng-if="!paidInovice.photos.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo.url)" ng-style="{backgroundImage: \'url(\' + photo.url + \')\' }" ng-repeat="photo in paidInovice.photos"></div></div></div></div></div></div>');
$templateCache.put('app/pages/accDepartment/ledger/modals/billExpModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>Edit Bill</span></div><div class="modal-body text-left"><div class="form-group row clearfix" ng-if="isPetrolCategory"><label for="carplate" class="col-sm-4 control-label">Car Plate</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Car Plate" ng-model="editBillExp.carPlateNo"></div></div><div class="form-group row clearfix" ng-if="isPetrolCategory"><label for="milelage" class="col-sm-4 control-label">Mileage</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Mileage" ng-model="editBillExp.milelage"></div></div><div class="form-group row clearfix" ng-if="isTNGCategory"><label for="tng" class="col-sm-4 control-label">Touch & Go</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Touch & Go" ng-model="editBillExp.touchAndGo"></div></div><div class="form-group row clearfix"><label for="desc" class="col-sm-4 control-label">Description</label><div class="col-sm-8"><textarea placeholder="Description" class="form-control" ng-model="editBillExp.description"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="saveBillExp($close)" ng-disabled="!!loading">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/approval/widgets/invReceiptTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" datepicker-options="dateList.options" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-if="manageZonesList.length>1" class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><div class="col-sm-1"><div><button type="submit" class="btn btn-primary" ng-click="getInvoicePaid()">Search</button></div></div><div class="col-sm-1"><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="invReceipts" st-table="receipts"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="created">Created Date</th><th st-sort="paid_at">Paid Date</th><th st-sort="orno">OR No.</th><th st-sort="amount">Receive Amount</th><th>Action</th></tr><tr><th></th><th></th><th></th><th><input st-search="orno" placeholder="Search OR No." class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in receipts" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.paid_at ? (item.paid_at| date: \'dd/MM/yyyy\') : \'\'}}</td><td><span>{{ item.orno }}</span></td><td><span>{{ item.amount | currency: \'\' }}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoiceReceipt(item)">view</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/accDepartment/accountType/widgets/accountTypeTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="load(true)">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="accountTypeList" st-table="accountTypes"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="createdAt">Created Date</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Search Account Type" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in accountTypes" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.createdAt | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span>{{ item.name }}</span></td><td><span ng-bind-html="item.description"></span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="createOtEditAccountType(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/accDepartment/accountType/modals/accountTypeDetailModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selectedAccountType.id ? \'Edit\' : \'Create\'}} Account Type</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label for="name" class="col-sm-4 control-label">Name</label><div class="col-sm-8"><input type="text" placeholder="Name" class="form-control" ng-model="selectedAccountType.name"></div></div><div class="form-group row clearfix"><label for="desc" class="col-sm-4 control-label">Description</label><div class="col-sm-8"><textarea placeholder="Description" class="form-control" ng-model="selectedAccountType.description"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/accountType/modals/deleteAccountTypeModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Account Type!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/ledger/widgets/ledgerTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices style="color: black" repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clear-fix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-default" ng-click="exportLedger(items)">Export</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="data" st-table="items"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="date">Date</th><th st-sort="billNo">Payment Voucher</th><th st-sort="zonename">Daerah</th><th st-sort="shopname">Shop</th><th st-sort="code">Code</th><th style="width: 30%" st-sort="customDescription">Description</th><th st-sort="debit">Debit</th><th st-sort="credit">Credit</th><th st-sort="balance">Balance</th><th>Action</th><th>Photos</th></tr><tr><th></th><th></th><th><input st-search="billNo" placeholder="Payment Voucher No" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonename" placeholder="Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="code" placeholder="Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="customDescription" placeholder="Description" class="input-sm form-control search-input" type="search"></th><th class="bg-info">{{ getTotal(items, \'debit\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'credit\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'balance\') | currency:\'\'}}</th><th></th><th></th></tr></thead><tbody><tr ng-if="loading" style="background-color: lightgrey"><td colspan="6">Loading...</td><td colspan="6">Loading...</td></tr><tr ng-repeat="item in items" class="editable-row" ng-if="!loading"><td class="table-id">{{$index+1}}</td><td><span>{{item.date | date: \'dd/MM/yyyy\' }}</span></td><td><span>{{item.billNo}}</span></td><td><span>{{item.zonename }}</span></td><td><span>{{item.shopname }}</span></td><td><span>{{item.code }}</span></td><td><span style="white-space: pre-line">{{item.customDescription }}</span></td><td><span>{{item.debit | currency: \'\' }}</span></td><td><span>{{item.credit | currency: \'\' }}</span></td><td><span>{{item.balance | currency: \'\' }}</span></td><td><button class="btn btn-warning editable-table-button btn-xs" ng-click="editLedger(item)">Edit</button></td><td><button class="btn btn-info editable-table-button btn-xs" ng-click="viewPhotos(item.photos)" ng-disabled="!item.photos.length">{{item.photos.length || \'No\'}} Photos</button></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/accDepartment/bill/widgets/billPaymentHistory.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="paymentHistoryList" st-table="paidHistories"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="createdAt">Created At</th><th st-sort="username">Created By</th><th st-sort="type">Type</th><th st-sort="paidToCode">Code</th><th st-sort="description">Description</th><th st-sort="ramount">Request Amount</th><th st-sort="pamount">Paid Amount</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="username" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><select placeholder="Filter Type" st-search="type" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="type in billLogTypes | unique:\'type\'" value="{{type}}">{{type}}</option></select></th><th><input st-search="paidToCode" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th></th><th class="bg-info">{{ getTotal(paidHistories, \'ramount\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(paidHistories, \'pamount\') | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in paidHistories" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.createdAt | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span>{{ item.username }}</span></td><td><span>{{ item.type }}</span></td><td><span>{{ item.paidToCode }}</span></td><td><span>{{ item.description }}</span></td><td><span>{{ item.ramount | currency: \'\' }}</span></td><td><span>{{ item.pamount | currency: \'\' }}</span></td><td><div class="buttons" ng-show="!rowform.$visible" ng-if="!!item.pid"><button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDeleteBillPaymentHistory(item.pid)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div><button type="button" class="btn btn-default" ng-click="closeDetail()">Close</button>');
$templateCache.put('app/pages/accDepartment/bill/widgets/billTable.html','<div class="horizontal-scroll" style="overflow-y: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></div><div class="col-sm-2"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" ng-if="allowToViewShopCategory"><label>Shop Category</label><ui-select ng-model="reportFilter.categoryid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="cat in shopCategory | filter: $select.search"><span ng-bind-html="cat.name"></span></ui-select-choices></ui-select></div><div class="col-sm-5"><label>&nbsp;</label><div><button class="btn btn-primary" ng-click="generateBill()">New Payment Voucher</button> <button class="btn btn-warning" ng-click="createOrEditBillExp()">New Payment Voucher Exp</button></div></div></div><div class="form-group row clear-fix"><div class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices style="color: black" repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices style="color: black" repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><div ng-repeat="(type, count) in countStatus" style="display: flex; align-items: center; justify-content: space-between; font-size: 1.3rem;" ng-class="{ \'text-warning\': type === \'Pending\', \'text-primary\': type === \'New\', \'text-success\': type === \'Pending Approved\', \'text-danger\': type === \'Rejected\', }"><div>{{type}}</div><div>{{searching ? \'loading...\' : count}}</div></div></div><div class="col-sm-5"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()" ng-disabled="!!searching">Search</button> <button ng-disabled="!!searching" type="submit" class="btn btn-info" ng-click="load(true)">Reset</button> <button type="button" class="btn btn-warning" ng-click="paidSelected()" ng-disabled="!!searching">Paid Selected</button> <button type="button" class="btn btn-info" ng-click="paidSelected(billExps)" ng-disabled="!!searching">Paid All</button> <button type="button" class="btn btn-danger" ng-click="approvedOrRejectSelected(false)" ng-disabled="!!searching">Reject Selected</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="billExpList" st-table="billExps"><thead sticky-on-scroll=""><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="dispalyClaimedDate">Date</th><th st-sort="billNo">Payment Voucher No.</th><th st-sort="name">User</th><th st-sort="zonename">Zone</th><th st-sort="shopcategory">Shop Category</th><th st-sort="shopname">Shop</th><th st-sort="catname">Code</th><th st-sort="type">Type</th><th st-sort="customDescription">Description</th><th st-sort="status">Status</th><th st-sort="ramount">Total Request</th><th st-sort="pamount">Total Paid</th><th></th><th>More</th><th>Action</th></tr><tr><th></th><th><input st-search="dispalyClaimedDate" placeholder="Search Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="billNo" placeholder="Search Payment Voucher No." class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search User" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonename" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcategory" placeholder="Search Category" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="catname" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="type" placeholder="Search Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="customDescription" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><select placeholder="Filter Status" st-search="status" ng-model="statusFilter" class="input-sm form-control search-input" ng-change="onStatusFilterChange(statusFilter)"><option value="">All</option><option ng-repeat="status in billExpStatus | unique:\'status\'" value="{{status}}">{{status}}</option></select></th><th class="bg-info">{{ getTotal(billExps, \'ramount\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(billExps, \'pamount\') | currency:\'\'}}</th><th><input type="checkbox" id="inlineCheckbox03" ng-model="billChecker.checkAll" ng-click="onCheckBoxChange()"></th><th></th><th></th></tr></thead><tbody><tr ng-if="searching || !billExps.length"><td colspan="6">{{searching ? \'Loading...\' : \'No Data\'}}</td><td colspan="5">{{searching ? \'Loading...\' : \'No Data\'}}</td><td colspan="5">{{searching ? \'Loading...\' : \'No Data\'}}</td></tr><tr ng-if="!searching" ng-repeat="item in billExps" class="editable-row" ng-class="{\'bg-light-blue \' : !!billChecker[item.id]}"><td ng-click="onColumnClick(item, \'sm\', $index)" class="table-id">{{$index+1}}</td><td ng-click="onColumnClick(item, \'sm\', $index)">{{item.dispalyClaimedDate }}</td><td ng-click="onColumnClick(item, \'sm\', $index)"><span>{{ item.billNo }}</span></td><td ng-click="onColumnClick(item, \'sm\', $index)"><span>{{ item.name }}</span></td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.zonename}}</td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.shopcategory}}</td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.shopname}}</td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.catname}}</td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.type}}</td><td ng-click="onColumnClick(item, \'sm\', $index)" style="min-width: 150px"><span style="white-space: pre-line">{{ item.customDescription}}</span></td><td ng-click="onColumnClick(item, \'sm\', $index)">{{ item.status}}</td><td ng-click="onColumnClick(item, \'sm\', $index)"><span>{{item.ramount | currency: \'\' }}</span></td><td ng-click="onColumnClick(item, \'sm\', $index)"><span>{{item.pamount | currency: \'\' }}</span></td><td ng-click="onCheckBoxChange(item.id)"><input type="checkbox" id="inlineCheckbox03" ng-model="billChecker[item.id]"></td><td><button class="btn btn-info editable-table-button btn-xs" ng-click="createOrEditBillExp(item)">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDeleteBillExpDetail(item.id)">Delete</button> <button class="btn btn-success editable-table-button btn-xs" ng-click="viewPhotos(item.photos)" ng-disabled="!item.photos.length">Attachments</button> <button class="btn btn-warning editable-table-button btn-xs" ng-click="paidBillExpDetail(item)">Paid</button></td><td><div class="buttons" ng-show="!rowform.$visible"><div class="buttons"><button class="btn btn-danger editable-table-button btn-xs" ng-click="approveOrRejectBillExp(item, false)" ng-disabled="item.status === \'Rejected\'">Reject</button></div><div class="buttons"><button class="btn btn-warning editable-table-button btn-xs" ng-click="confirmPending(item)" ng-disabled="item.status === \'Pending\'">Pending</button></div><div class="buttons"><button class="btn editable-table-button btn-xs" ng-click="viewPaymentHistory(item)">History</button></div></div></td></tr></tbody><tfoot><tr><td colspan="16" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/billExpPendingModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-flame modal-icon"></i><span>Pending Payment Voucher Exp</span></div><div class="modal-body text-center"><div class="form-group row clearfix"><label for="desc" class="col-sm-4 control-label">Pending Reason</label><div class="col-sm-8"><textarea placeholder="Pending Reason" class="form-control" ng-model="pendingBillExp.pendingReason"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/billModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selectedEditBill.id ? \'Edit\' : \'Create New\'}} Bill</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Date</label><div class="col-sm-8"><div class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="selectedEditBill.claimedDate" show-button-bar="false" is-open="dpOpenStatus.required" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'required\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group row clearfix"><label for="category" class="col-sm-4 control-label">Zones</label><div class="col-sm-8"><ui-select ng-model="selectedEditBill.zones" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="zone in manageZonesList | filter: $select.search"><span style="color: black" ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)" ng-disabled="!selectedEditBill.zones.length">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/billexpModal.html','<div class="modal-content"><div ng-if="pendingApprovalConfig.loading" style="background-color: rgba(0, 0, 0, 0.5); position: absolute; left: 0; right: 0; bottom: 0; top: 0; z-index: 1; display: flex; align-items: center; justify-content: center; color: white; font-size: 2rem;"><div>Loading...</div></div><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selectedBillExpDetail.id ? \'Edit\' : \'Create\'}} Payment Voucher Exps</span></div><div class="modal-body text-left"><div class="form-group row clearfix" ng-if="!selectedBillExpDetail.id"><label for="category" class="col-sm-4 control-label">Payment Voucher</label><div class="col-sm-8"><ui-select ng-model="selectedBillExpDetail.bill" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" close-on-select="true" on-select="onPaymentVoucherSelect($item)"><ui-select-match placeholder="Searching Payment Voucher">{{$select.selected.billNo}}</ui-select-match><ui-select-choices repeat="bill in searchBillList track by bill.id" refresh="searchRepositories($select.search)" refresh-delay="300"><span style="color: black">{{bill.billNo}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix" ng-if="selectedBillExpDetail.id"><label for="desc" class="col-sm-4 control-label">Pending Reason <span ng-if="pendingApprovalConfig.pendingCount">({{pendingApprovalConfig.pendingCount}})</span></label><div class="col-sm-8"><textarea placeholder="Pending Reason" class="form-control" ng-model="selectedBillExpDetail.pendingReason" disabled=""></textarea></div></div><div class="form-group row clearfix"><label for="amount" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.type && {\'color\': \'red\'}">Type</label><div class="col-sm-8"><label class="custom-radio"><input type="radio" ng-model="selectedBillExpDetail.type" name="toasts" value="credit" ng-disabled="!!pendingApprovalConfig.data.type"><span>Credit</span></label> <label class="custom-radio"><input type="radio" ng-model="selectedBillExpDetail.type" name="toasts" value="debit"><span>Debit</span></label></div></div><div class="form-group row clearfix"><label for="amount" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.amount && {\'color\': \'red\'}">Amount</label><div class="col-sm-8"><input class="form-control" type="number" id="amount" ng-model="selectedBillExpDetail.amount"></div></div><div class="form-group row clearfix"><label for="category" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.mycategories && {\'color\': \'red\'}">Code</label><div class="col-sm-8"><ui-select ng-model="selectedBillExpDetail.mycategories" class="btn-group bootstrap-select form-control" multiple="" append-to-body="false" search-enabled="true" close-on-select="false" on-select="onCategorySelect($item)" on-remove="onCategoryRemove($item)"><ui-select-match placeholder="Nothing Selected">{{$item.name}} - {{$item.description}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="cat in categories | filter: $select.search track by cat.id"><span ng-bind-html="cat.name + \' - \' + cat.description"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix" ng-if="isPetrolCategory"><label for="carplate" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.carPlateNo && {\'color\': \'red\'}">Car Plate</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Car Plate" ng-model="selectedBillExpDetail.carPlateNo"></div></div><div class="form-group row clearfix" ng-if="isPetrolCategory"><label for="milelage" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.milelage && {\'color\': \'red\'}">Mileage</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Mileage" ng-model="selectedBillExpDetail.milelage"></div></div><div class="form-group row clearfix" ng-if="isTNGCategory"><label for="tng" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.touchAndGo && {\'color\': \'red\'}">Touch & Go</label><div class="col-sm-8"><input type="text" class="form-control" placeholder="Touch & Go" ng-model="selectedBillExpDetail.touchAndGo"></div></div><div class="form-group row clearfix" ng-if="selectedBillExpDetail.id && (isTNGCategory || isPetrolCategory)"><label for="spname" class="col-sm-4 control-label">SP Name</label><div class="col-sm-8"><input type="text" disabled="" class="form-control" placeholder="-" ng-model="selectedBillExpDetail.name"></div></div><div class="form-group row clearfix"><label for="photo" class="col-sm-4 control-label" ng-style="pendingApprovalConfig.data.photos && {\'color\': \'red\'}">Photo</label><div class="col-sm-8"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files)" ng-model="file" name="file" ngf-pattern="\'image/*\'" ngf-resize="{width: 1500, height: 1500, quality: 1}" ngf-resize-if="$width > 1500 || $height > 1500" ngf-accept="\'image/*\'"><div ng-if="!photoURL.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo.url)" ng-style="{backgroundImage: \'url(\' + photo.url + \')\' }" ng-repeat="photo in photoURL"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-click="deleteImage($index)"></i></div></div></div></div><div class="form-group row clearfix"><label for="zones" class="col-sm-4 control-label">Zones</label><div class="col-sm-8"><ui-select ng-model="selectedBillExpDetail.myzones" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false" on-select="onZoneSelect($item, $model)"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="zone in manageZonesList | filter: $select.search track by zone.id"><span style="color: black" ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="shops" class="col-sm-4 control-label">Shops</label><div class="col-sm-8"><ui-select ng-model="selectedBillExpDetail.myshops" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false" on-select="onShopSelect($item, $model)" on-remove="onShopRemove($item)"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="shop in manageShopsListByZone | filter: $select.search track by shop.id"><span style="color: black" ng-bind-html="shop.name"></span></ui-select-choices></ui-select><div ng-if="selectedBillExpDetail.mycategories.length && !!selectedBillExpDetail.myshops.length"><div ng-repeat="code in selectedBillExpCodeByShops" style="margin-top: 10px" ng-style="!$first && {\'border-top\': \'1px solid #e3e3e3\', \'padding-top\': \'10px\'}"><h4 style="font-weight: bold; text-transform: capitalize">{{$index + 1}}. {{code.name}}</h4><div><div ng-repeat="shop in code.shops;" style="margin-top: 10px"><div class="row clearfix" style="display: flex; align-items: flex-start"><label for="amount" class="col-sm-4 control-label" style="display: flex; align-items: flex-start; padding-top: 10px;"><span style="width: 20px">{{\'i,ii,iii,iv,v,vi,vii,viii,ix,x\'.split(\',\')[$index]}}.</span> <span style="flex: 1">{{shop.shopname}}</span></label><div class="col-sm-8"><input type="number" class="form-control" ng-model="shop.amount" placeholder="Request Amount" ng-style="pendingApprovalConfig.data.shops && pendingApprovalConfig.data.shops[shop.shopid] && pendingApprovalConfig.data.shops[shop.shopid].amount && {\'color\': \'red\'}"> <textarea placeholder="Description" class="form-control mt-2" ng-model="shop.description" rows="2" ng-style="pendingApprovalConfig.data.shops && pendingApprovalConfig.data.shops[shop.shopid] && pendingApprovalConfig.data.shops[shop.shopid].description && {\'color\': \'red\'}"></textarea></div></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-disabled="loading" ng-click="saveBillExp($close)">Confirm</button> <button type="button" ng-disabled="loading" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Bill!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/deleteBillExpModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Payment Voucher Exp!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/deletePaymentHistoryModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this payment history!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/imgPreviewerModal.html','<slick dots="true" infinite="true" speed="300" slides-to-show="1" slides-to-scroll="1" on-after-change="onAfterChange();"><div ng-repeat="photo in selectedPhotos" style="position: relative"><img ng-style="{cursor: !zoomInMode ? \'zoom-in\' : \'zoom-out\', transform: \'rotate(\' + rotateDegree + \'deg)\'}" ng-mousemove="zoomInPhoto($event, photo)" ng-click="toggleZoomMode()" ng-src="{{photo}}" style="width: 100%; object-fit: contain; max-height: 800px"><div ng-style="myImageStyle" style="z-index: 0; pointer-events: none; position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-repeat: no-repeat;"></div><div class="footer-icon-toolbar"><i class="icon-btn-rotate fa fa-undo" aria-hidden="true" ng-click="rotateImage(\'left\')"></i> <i class="icon-btn-rotate fa fa-repeat" aria-hidden="true" ng-click="rotateImage(\'right\')"></i></div></div></slick>');
$templateCache.put('app/pages/accDepartment/bill/modals/paidBillExpModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-flame modal-icon"></i><span>Paid Payment Voucher Exps #{{selectedBill.claimedDate | date: \'dd/MM/yyyy\'}}</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label for="Shop Name" class="col-sm-4 control-label">Credit From / Debit To</label><div class="col-sm-8"><ui-select ng-model="selectedBillExpsToPaid.paidTo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.id">{{$select.selected.name}} - {{$select.selected.description}}</span> <span ng-hide="$select.selected.id">{{$select.selected}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="cat in categoryToPaid | filter: $select.search"><span style="color: black" ng-bind-html="cat.name + \'-\' + cat.description"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Paid At</label><div class="col-sm-8"><div class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="selectedBillExpsToPaid.paidAt" show-button-bar="false" is-open="dpOpenStatus.required" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'required\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div ng-repeat="exp in selectedBillExpsToPaid.exps"><div class="with-line-title">{{$index + 1}}. {{exp.shop.name}}</div><div class="row"><div class="col-sm-8"><div class="form-group row clearfix"><label for="ramount" class="col-sm-4 control-label">Requeset Amount</label><div class="col-sm-8">{{exp.ramount | currency: \'\'}}</div></div><div class="form-group row clearfix"><label for="Shop Name" class="col-sm-4 control-label">Total Paid</label><div class="col-sm-8">{{(exp.pamount || 0) | currency: \'\'}}</div></div><div class="form-group row clearfix"><label for="pamount" class="col-sm-4 control-label">Paid Amount</label><div class="col-sm-4"><input type="number" class="form-control" ng-model="exp.shouldPaidAmount" placeholder="Paid Amount"></div></div></div><div class="col-sm-4"><img ng-if="exp.photo" ng-src="{{exp.photo}}" style="width: 100%; max-width: 200px; max-height: 300px; object-fit: cover;" uib-popover-template="popUpUrl" popover-trigger="\'mouseenter\'" popover-placement="right" ng-mouseenter="togglePhotoModal(exp, \'lg\')"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)" ng-disabled="!selectedBillExpsToPaid.paidTo">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/bill/modals/rejectModal.html','<div class="modal-content"><div class="modal-header" ng-class="{ \'bg-danger\': !approvedRejectBillExpStatus.status, \'bg-success\': approvedRejectBillExpStatus.status }"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to {{!!approvedRejectBillExpStatus.status ? "Approved" : "Reject"}} {{approvedRejectBillExpStatus.items.length > 1 ? approvedRejectBillExpStatus.items.length : ""}} Bill!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/pnl/widgets/ledgerTable.html','<div class="with-scroll"><div class="row form-group"><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-default" ng-click="exportLedgerDetail(items)">Export</button></div></div></div><table class="table table-striped table-condensed" st-safe-src="ledgerDetail" st-table="items"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="date">Date</th><th st-sort="billNo">Payment Voucher</th><th st-sort="zonename">Daerah</th><th st-sort="shopname">Shop</th><th st-sort="description">Description</th><th st-sort="debit">Debit</th><th st-sort="credit">Credit</th><th st-sort="balance">Balance</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th class="bg-info">{{ getTotal(items, \'debit\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'credit\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'netProfit\') | currency:\'\'}}</th></tr></thead><tbody><tr ng-repeat="item in items" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{item.date | date: \'dd/MM/yyyy\' }}</span></td><td><span>{{item.billNo}}</span></td><td><span>{{item.zonename }}</span></td><td><span>{{item.shopname }}</span></td><td><span>{{item.description }}</span></td><td><span>{{item.debit | currency: \'\' }}</span></td><td><span>{{item.credit | currency: \'\' }}</span></td><td><span>{{item.balance | currency: \'\' }}</span></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/accDepartment/pnl/widgets/pnlDetailTable.html','<div class="with-scroll"><table class="table table-condensed" st-safe-src="categoryList" st-table="categories"><thead><tr class="sortable"><th style="text-align: left">Month</th><th style="width: 150px" ng-repeat="month in pnlDetail.month">{{month.title}}</th><th style="width: 120px">Action</th></tr></thead><tbody><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">Sales 100%</td><td ng-repeat="month in pnlDetail.month">{{getFullSales(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="text-align: left">Sales 50%</td><td ng-repeat="month in pnlDetail.month">{{getHalfSales(month.value) | currency: \'\'}}</td><td></td></tr><tr ng-repeat="sales in pnlDetail.salesRows.codes"><td style="text-align: left">{{sales.catname}}</td><td ng-repeat="month in pnlDetail.month">{{getSalesRow(month.value, sales) | currency: \'\'}}</td><td><div class="buttons"><button class="btn btn-warning editable-table-button btn-xs" ng-click="viewLedger(sales)" ng-disabled="pnlDetail.month.length ? getExpRow(pnlDetail.month[0].value, sales) === 0 : true">ledger</button></div></td></tr><tr><td></td><td style="border-top: 2px solid black" ng-repeat="month in pnlDetail.month">{{getTotalSales(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">COST:</td><td><span ng-if="!pnlDetail.costRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td><span ng-if="!pnlDetail.costRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td><span ng-if="!pnlDetail.costRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td></td></tr><tr ng-repeat="cost in pnlDetail.costRows.codes"><td style="text-align: left">{{cost.catname}}</td><td ng-repeat="month in pnlDetail.month">{{getCostRow(month.value, cost) | currency: \'\'}}</td><td><div class="buttons"><button class="btn btn-warning editable-table-button btn-xs" ng-click="viewLedger(cost)" ng-disabled="pnlDetail.month.length ? getCostRow(pnlDetail.month[0].value, cost) === 0 : true">ledger</button></div></td></tr><tr><td></td><td style="border-top: 2px solid black" ng-repeat="month in pnlDetail.month">{{getTotalCost(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">Gross Profit</td><td ng-repeat="month in pnlDetail.month">{{getGrossProfit(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">Expenses:</td><td><span ng-if="!pnlDetail.expensesRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td><span ng-if="!pnlDetail.expensesRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td><span ng-if="!pnlDetail.expensesRows.codes.length">{{\'0\' | currency: \'\'}}</span></td><td></td></tr><tr ng-repeat="exp in pnlDetail.expensesRows.codes"><td style="text-align: left">{{exp.catname}}</td><td ng-repeat="month in pnlDetail.month">{{getExpRow(month.value, exp) | currency: \'\'}}</td><td><div class="buttons"><button class="btn btn-warning editable-table-button btn-xs" ng-click="viewLedger(exp)" ng-disabled="pnlDetail.month.length ? getExpRow(pnlDetail.month[0].value, exp) === 0 : true">ledger</button></div></td></tr><tr><td></td><td style="border-top: 2px solid black" ng-repeat="month in pnlDetail.month">{{getTotalExpenses(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">Net Profit</td><td ng-repeat="month in pnlDetail.month">{{getNetProfit(month.value) | currency: \'\'}}</td><td></td></tr><tr><td style="text-align: left">Profit Sharing (%)</td><td ng-repeat="month in pnlDetail.month">{{getProfitSharingRate(month.value)}}</td><td></td></tr><tr><td style="padding-top: 35px" colspan="10"></td></tr><tr><td style="text-align: left">Total</td><td ng-repeat="month in pnlDetail.month">{{getTotalProfitSharing(month.value) | currency: \'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/accDepartment/pnl/widgets/pnlTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>Month</label><ui-select ng-model="reportFilter.month" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.title}}</span></ui-select-match><ui-select-choices style="color: black" repeat="month in months | filter: $select.search"><span ng-bind-html="month.title"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices style="color: black" repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clear-fix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()" ng-disabled="!!loading">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-default" ng-click="exportPNL(items)">Export</button></div></div></div></div></div><table st-filtered-collection="" class="table table-striped table-condensed" st-safe-src="data" st-table="items"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="zonename">Daerah</th><th st-sort="shopname">Shop</th><th st-sort="sales">Sales</th><th st-sort="cost">Cost</th><th st-sort="grossProfit">Gross Profit</th><th st-sort="exp">Expenses</th><th st-sort="netProfit">Net Profit</th><th>Action</th></tr><tr><th></th><th><input st-search="zonename" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th class="bg-info">{{ getTotal(items, \'sales\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'cost\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'grossProfit\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'exp\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(items, \'netProfit\') | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-if="!!loading"><td colspan="5">Loading</td><td colspan="4">Loading</td></tr><tr ng-if="!loading" ng-repeat="item in items" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{item.zonename}}</span></td><td><span>{{item.shopname}}</span></td><td><span>{{item.sales | currency: \'\' }}</span></td><td><span>{{item.cost | currency: \'\' }}</span></td><td><span>{{item.grossProfit | currency: \'\' }}</span></td><td><span>{{item.exp | currency: \'\' }}</span></td><td><span>{{item.netProfit | currency: \'\' }}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-info editable-table-button btn-xs" ng-click="viewPNL(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/account/partner/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/partner/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/account/partner/widgets/partnerTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManagePartner(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManagePartner(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnerList" st-table="managePartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="parent.code">Parent Partner</th><th st-sort="zones">Daerah</th><th>Action</th><th></th><th></th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required=""></span> {{ item.code || \'empty\'}} <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Partner Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td class="select-td"><span editable-select="item.zoneid" e-name="zoneid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="savePartner($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Collector!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageCollector(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManageCollector(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCollectorList" st-table="manageCollector"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Collector Code</th><th st-sort="name">Collector Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="zone">Daerah</th><th st-sort="parent.code">Parent Collector</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Collector Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Collector Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCollector" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><span editable-select="item.zoneid" e-name="zones" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid)}}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Collector Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentCollectorList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td><form editable-form="" name="rowform" onbeforesave="saveCollector($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid || !item.isparent" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/accDepartment/category/modals/categoryDetailModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selectedCategory.id ? \'Edit\' : \'Create\'}} Cateogry</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label for="name" class="col-sm-4 control-label">Name</label><div class="col-sm-8"><input type="text" placeholder="Name" class="form-control" ng-model="selectedCategory.name"></div></div><div class="form-group row clearfix"><label for="desc" class="col-sm-4 control-label">Account Type</label><div class="col-sm-8"><ui-select ng-model="selectedCategory.accountType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.id">{{$select.selected.name}}</span> <span ng-hide="$select.selected.id">{{$select.selected}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="emp in accountTypes | filter: $select.search"><span ng-bind-html="emp.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="states" class="col-sm-4 control-label">States</label><div class="col-sm-8"><ui-select ng-model="selectedCategory.states" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="state in states | filter: $select.search"><span style="color: black" ng-bind-html="state.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="states" class="col-sm-4 control-label">Zones</label><div class="col-sm-8"><ui-select ng-model="selectedCategory.zones" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="zone in zones | filter: $select.search"><span style="color: black" ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="desc" class="col-sm-4 control-label">Description</label><div class="col-sm-8"><textarea placeholder="Description" class="form-control" ng-model="selectedCategory.description"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/category/modals/deleteCategoryModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/accDepartment/category/widgets/categoryTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="load(true)">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="categoryList" st-table="categories"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="createdAt">Created Date</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="myAccountType">Account Type</th><th st-sort="myStates">States</th><th st-sort="myZones">Zones</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Search Category" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="myAccountType" placeholder="Search Account Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="myStates" placeholder="Search States" class="input-sm form-control search-input" type="search"></th><th><input st-search="myZones" placeholder="Search Zones" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in categories" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.createdAt | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span>{{ item.name }}</span></td><td><span ng-bind-html="item.description"></span></td><td><span>{{item.myAccountType}}</span></td><td><span>{{item.myStates}}</span></td><td><span>{{item.myZones}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="createOtEditCategory(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/account/supplier/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/supplier/widgets/supplierTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageStates(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="initManageStates(reportFilter={})">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSupplierList" st-table="manageSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="contact">Contact Details</th><th st-sort="zones">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.name" e-name="zones" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as (g.code +\', \' + g.name) for g in manageZonesList">{{ showZones(item.zoneid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSupplier($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/usermapping/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this User Mapping!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/usermapping/widgets/usermappingTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageUsermappingList" st-table="manageUsermappings"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="role.name">Role</th><th st-sort="user.username">User Name</th><th st-sort="zone.code">Daerah</th><th st-sort="area.name">Area</th><th>Action</th></tr><tr><th></th><th><input st-search="role.name" placeholder="Search Role" class="input-sm form-control search-input" type="search"></th><th><input st-search="user.username" placeholder="Search User Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Area" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsermappings" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.role.id" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageRoleList">{{ showRoles(item.role) }}</span></td><td class="select-td"><span editable-select="item.user.id" e-name="user" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.username for g in manageUserList">{{ showUsers(item.user) }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.area.id" e-name="area" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreaList">{{ showAreas(item.area) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUsermapping($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px;"><thead><tr><th class="text-center" style="padding: 0px"><b>Partner</b></th><th class="text-center" style="padding: 0px"><b>Shop ID</b></th><th class="text-center" style="padding: 0px"><b>Shop Name</b></th><th class="text-center" style="padding: 0px"><b>Invoice Date</b></th><th class="text-center" style="padding: 0px"><b>Invoice No.</b></th></tr></thead><tbody><tr><td class="text-center" style="padding: 0px">{{shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name}}</td><td class="text-center">{{shopInvoiceDetails.code}}</td><td class="text-center">{{shopInvoiceDetails.name}}</td><td class="text-center">{{manageDailyinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td class="text-center">{{manageDailyinvoices.invoiceid}}</td></tr></tbody></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoiceOnline.html','<span ng-if="onlineInvoiceDetails[0].algorithm === \'NP\'"><div class="row"><div class="col-sm-12"><h5>Net Purchase</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">AP P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">AP P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Bonus Bet(+)</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Bank(+)</th><th class="text-center">Bank.C(+)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.payment_gateway==0?\'-\':(item.payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td class="align-right" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-if="total.NP_net_collect != 0">{{ total.NP_net_collect | currency: \'\' }}</span> <span ng-if="total.NP_net_collect == 0">-</span></td></tr></tbody></table></span> <span ng-if="onlineInvoiceDetails[0].algorithm === \'NG\'"><br><br><div class="row"><div class="col-sm-12"><h5>Net Gaming</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NG</th><th class="text-center">Company ({{onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">Shop ({{100-onlineInvoiceDetails[0].shop.onrate}}%)</th><th class="text-center">P/S(-)</th><th class="text-center">AP P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">AP P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Bonus Bet</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Partner Bonus Bet(+)</th><th class="text-center">Bank(-)</th><th class="text-center">Bank.C(+)</th><th class="text-center">Bank Out(+)</th><th class="text-center">Bank Out.C(+)</th><th class="text-center">Shorts</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netgaming==0?\'-\':(item.netgaming | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.bonus_bet==0?\'-\':(item.bonus_bet | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.payment_gateway==0?\'-\':(item.payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.pg_out==0?\'-\':(item.pg_out | currency: \'\')}}</td><td class="align-right">{{item.pg_out_charge==0?\'-\':(item.pg_out_charge | currency: \'\')}}</td><td lass="text-right" rowspan="{{onlineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageDailyinvoices.onlineshorts" blur="cancel">{{ manageDailyinvoices.onlineshorts ==0?\'-\':(manageDailyinvoices.onlineshorts | currency: \'\' )}}</span></td><td class="align-right">{{item.net_collect==0?\'-\':(item.net_collect | currency: \'\')}}</td></tr></tbody></table></span><br><br><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Net Collect</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect) | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/collectors/dailyinvoices/widgets/dailyinvoicesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.ispaid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in paidFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><div class="form-group row clearfix"><div class="col-sm-12"><label>Invoice Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.upload" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchAllinvoices(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><hr><br><table class="table table-striped table-condensed" st-safe-src="manageDailyinvoicesList" st-table="manageDailyinvoices"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="invoiceid">Invoice No.</th><th st-sort="invoicedate">Invoice Date</th><th st-sort="shopcode">Shop Code</th><th st-sort="shopname">Shop Name</th><th st-sort="partnername">Partner Name</th><th st-sort="mactotal" class="bg-warning" style="color: black">Machine</th><th st-sort="ontotal" class="bg-info" style="color: black">Online</th><th st-sort="" class="bg-purple" style="color: black">Total</th><th st-sort="net_collect" class="bg-success" style="color: black">Net Collect</th><th st-sort="ispaid">Status</th><th st-sort="pdate">Paid Date</th><th st-sort="agentid">Agent</th><th>Action</th></tr><tr><th></th><th><input st-search="invoiceid" placeholder="Invoice Id" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="partnername" placeholder="Partner Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageDailyinvoices" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.invoiceid || \'empty\'}}</td><td>{{ item.ikey | limitTo: -8}}</td><td>{{item.shopcode}}</td><td>{{item.shopname}}</td><td>{{item.partnername}}</td><td class="bg-warning" style="color: black">{{item.mcsales | currency: \'\'}}</td><td class="bg-info" style="color: black">{{item.ocsales | currency: \'\'}}</td><td class="bg-purple" style="color: black">{{item.totalsales | currency: \'\'}}</td><td class="bg-success" style="color: black">{{item.net_collect | currency: \'\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }" style="color: black">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td>{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td>{{showUserById(item.agentid)}}</td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp;<button ng-if="!item.ispaid" class="btn btn-info editable-table-button btn-xs" ng-click="confirmPayNow(item.id)">Pay Now</button></div></td></tr><tr ng-if="totalSalesLabelFooter!=0"><td></td><td></td><td></td><td></td><td></td><td></td><td style="background-color: chocolate; color: black">{{getTotalmcsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{getTotalocsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{getTotaltotalsales(manageDailyinvoices) | currency:\'\'}}</td><td style="background-color: chocolate; color: black">{{getTotalTotalNetCollect(manageDailyinvoices) | currency:\'\'}}</td><td></td><td></td><td></td><td></td></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/collectors/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/csync/assigncollector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Collector!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/csync/assigncollector/widgets/assigncollectorTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100, 200, 500, 1000]"></select></label></div><table ng-hide="isAgentView" class="table table-striped" st-safe-src="manageCollectorsList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Collector Head Name</th><th st-sort="shops">Agent count</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers | groupBy: \'credentials.manager.id\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item[0].credentials.manager.credentials.firstName +" " + item[0].credentials.manager.credentials.lastName || \'empty\' }}</td><td>{{ item.length || \'empty\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewAgents(item)">View</button> &nbsp;</div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><table ng-show="isAgentView" class="table table-striped" st-safe-src="manageCollectorsList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Collector Agent Name</th><th st-sort="shops">Shop count</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.credentials.name || item.credentials.firstName + " " + item.credentials.lastName || \'-\' }}</td><td>{{ item.credentials.shopmap.length || \'-\' }}</td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewCollectorDetails(item)">Edit</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><button ng-show="isAgentView" type="button" class="btn btn-default save-profile" ng-click="initManageOfficers()">Back</button></div>');
$templateCache.put('app/pages/external/partnersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/external/partnersales/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.parent" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.parent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.id}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/external/suppliersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/external/suppliersales/widgets/suppliersalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSuppliersalesList.result" st-table="manageSuppliersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSuppliersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/form/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine Sales!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-3"><label>Upload Machine Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/machinesales/widgets/sampleMachineUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageMachinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="machineid">Machine Code</th><th st-sort="cmin">CM IN</th><th st-sort="cmout">CM OUT</th><th st-sort="bmin">BM IN</th><th st-sort="bmout">BM OUT</th><th></th><th>Action</th></tr><tr><th></th><th><input st-search="machineid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.machineid" e-name="machineid" e-form="rowform" e-required="">{{ item.machineid || \'empty\'}}</span></td><td><span editable-text="item.cmin" e-name="cmin" e-form="rowform" e-required="">{{item.cmin.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.cmout" e-name="cmout" e-form="rowform" e-required="">{{item.cmout.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.bmin" e-name="bmin" e-form="rowform" e-required="">{{item.bmin.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.bmout" e-name="bmout" e-form="rowform" e-required="">{{item.bmout.replace(\'MYR\',\'\') || 0 }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Sales!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/onlinesales/widgets/onlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-4"><label>Invoice Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" ng-click="clickedInvoiceInput()" uib-datepicker-popup="dd/MM/yyyy" ng-model="formDate.upload" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/onlinesales/widgets/sampleUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageOnlinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="Remarks">Remarks</th><th st-sort="Kiosk">Kiosk</th><th st-sort="snooker">Snooker</th><th st-sort="\'snooker F&B\'">Snooker F&B</th><th st-sort="PS">Progressive Share</th><th st-sort="\'AP PS\'">AP Progressive Share</th><th st-sort="PW">Progressive Wins</th><th st-sort="\'AP PW\'">AP Progressive Wins</th><th st-sort="Token">Token</th><th st-sort="\'Lucky Wins\'">Lucky Wins</th><th st-sort="\'Caishen\'">Caishen</th><th st-sort="\'Plinko\'">Plinko</th><th st-sort="pgsbonus">EVENT BONUS</th><th st-sort="Telco">Telco</th><th st-sort="\'Tng pin\'">Tng Pin</th><th st-sort="\'Crypto Deposit\'">Crypto</th><th st-sort="Bank">Bank</th><th st-sort="Bank_Out">Bank Out</th><th st-sort="PE_Bank">PE Bank</th><th st-sort="PE_Bank_Out">PE Bank Out</th><th st-sort="e-wallet">D.Ewallet</th><th st-sort="e-wallet">G.Ewallet</th><th st-sort="d_cc">D.CC</th><th st-sort="\'\u4E07\u5B57\u6536\'">\u4E07\u5B57\u6536</th><th st-sort="\'\u516C\u53F8\u4F63\u91D1\'">\u516C\u53F8\u4F63\u91D1</th><th st-sort="\'Angpao\'">Angpao</th><th st-sort="\'Commission\'">Commission</th><th st-sort="\'Promotion\'">Promotion</th><th st-sort="\'FPromotion\'">FPromotion</th><th st-sort="\'Zpay Bank In\'">Zpay BANK IN</th><th st-sort="\'Zpay QR In\'">Zpay QR IN</th><th st-sort="\'Vpay QR\'">Vpay QR</th><th st-sort="Vpay D.Bank">Vpay D.Bank</th><th st-sort="\'Vpay Tng Pin\'">Vpay Tng Pin</th><th st-sort="\'Vpay W.Bank\'">Vpay W.Bank</th><th st-sort="\'Luxepay QR\'">Luxepay QR</th><th st-sort="Luxepay D.Bank">Luxepay D.Bank</th><th st-sort="\'Luxepay W.Bank\'">Luxepay W.Bank</th><th st-sort="\'Fpay QR\'">Fpay QR</th><th st-sort="Fpay D.Bank">Fpay D.Bank</th><th st-sort="\'Fpay W.Bank\'">Fpay W.Bank</th><th st-sort="\'SKL QR\'">SKL QR</th><th st-sort="NP">Net Purchase</th><th st-sort="NG">Net Gaming</th><th st-sort="chang_zhu_rate">\u8DDF\u573A\u4E3B\u6536%</th><th st-sort="gong_shi_pan_rate">\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%</th><th st-sort="wai_jiao_rate">\u5916\u4EA4\u8D39%</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.Remarks" e-name="Remarks" e-form="rowform" e-required="">{{ item.Remarks || \'empty\'}}</span></td><td><span editable-text="item.Kiosk" e-name="Kiosk" e-form="rowform" e-required="">{{ item.Kiosk || \'empty\'}}</span></td><td><span editable-text="item.Snooker" e-name="Snooker" e-form="rowform" e-required="">{{item.Snooker.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item[\'Snooker F&B\']" e-name="Snooker F&B" e-form="rowform" e-required="">{{item[\'Snooker F&B\'].replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PS" e-name="PS" e-form="rowform" e-required="">{{item.PS.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item[\'AP PS\']" e-name="AP PS" e-form="rowform" e-required="">{{item[\'AP PS\'].replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PW" e-name="PW" e-form="rowform" e-required="">{{item.PW.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'AP PW\']" e-name="AP PW" e-form="rowform" e-required="">{{item[\'AP PW\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Token\']" e-name="\'Token\'" e-form="rowform" e-required="">{{item[\'Token\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Lucky Wins\']" e-name="\'Lucky Wins\'" e-form="rowform" e-required="">{{item[\'Lucky Wins\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Caishen\']" e-name="\'Caishen\'" e-form="rowform" e-required="">{{item[\'Caishen\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Plinko\']" e-name="\'Plinko\'" e-form="rowform" e-required="">{{item[\'Plinko\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'EVENT BONUS\']" e-name="\'EVENT BONUS\'" e-form="rowform" e-required="">{{item[\'EVENT BONUS\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Telco\']" e-name="\'Telco\'" e-form="rowform" e-required="">{{item[\'Telco\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Tng pin\']" e-name="\'Telco\'" e-form="rowform" e-required="">{{item[\'Tng pin\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Crypto Deposit\']" e-name="\'Crypto Deposit\'" e-form="rowform" e-required="">{{item[\'Crypto Deposit\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Bank\']" e-name="\'Bank\'" e-form="rowform" e-required="">{{item[\'Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Bank_Out\']" e-name="\'Bank_Out\'" e-form="rowform" e-required="">{{item[\'Bank_Out\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'PE Bank\']" e-name="\'PE Bank\'" e-form="rowform" e-required="">{{item[\'PE Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'PE Bank_Out\']" e-name="\'PE Bank_Out\'" e-form="rowform" e-required="">{{item[\'PE Bank_Out\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'e-wallet\']" e-name="\'e-wallet\'" e-form="rowform" e-required="">{{item[\'e-wallet\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'e-wallet\']" e-name="\'e-wallet\'" e-form="rowform" e-required="">{{item[\'G-ewallet\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'d_cc\']" e-name="\'d_cc\'" e-form="rowform" e-required="">{{item[\'d_cc\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u4E07\u5B57\u6536\']" e-name="\'\u4E07\u5B57\u6536\'" e-form="rowform" e-required="">{{item[\'\u4E07\u5B57\u6536\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u516C\u53F8\u4F63\u91D1\']" e-name="\'\u516C\u53F8\u4F63\u91D1\'" e-form="rowform" e-required="">{{item[\'\u516C\u53F8\u4F63\u91D1\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Angpao\']" e-name="\'Angpao\'" e-form="rowform" e-required="">{{item[\'Angpao\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Commission\']" e-name="\'Commission\'" e-form="rowform" e-required="">{{item[\'Commission\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Promotion\']" e-name="\'Promotion\'" e-form="rowform" e-required="">{{item[\'Promotion\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'FPromotion\']" e-name="\'FPromotion\'" e-form="rowform" e-required="">{{item[\'FPromotion\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Zpay Bank In\']" e-name="\'Zpay Bank In\'" e-form="rowform" e-required="">{{item[\'Zpay Bank In\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Zpay QR In\']" e-name="\'Zpay QR In\'" e-form="rowform" e-required="">{{item[\'Zpay QR In\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay QR\']" e-name="\'Vpay QR\'" e-form="rowform" e-required="">{{item[\'Vpay QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay D.Bank\']" e-name="\'Vpay D.Bank\'" e-form="rowform" e-required="">{{item[\'Vpay D.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay Tng Pin\']" e-name="\'Vpay Tng Pin\'" e-form="rowform" e-required="">{{item[\'Vpay Tng Pin\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay W.Bank\']" e-name="\'Vpay W.Bank\'" e-form="rowform" e-required="">{{item[\'Vpay W.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay QR\']" e-name="\'Luxepay QR\'" e-form="rowform" e-required="">{{item[\'Luxepay QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay D.Bank\']" e-name="\'Luxepay D.Bank\'" e-form="rowform" e-required="">{{item[\'Luxepay D.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay W.Bank\']" e-name="\'Luxepay W.Bank\'" e-form="rowform" e-required="">{{item[\'Luxepay W.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Fpay QR\']" e-name="\'Fpay QR\'" e-form="rowform" e-required="">{{item[\'Fpay QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Fpay D.Bank\']" e-name="\'Fpay D.Bank\'" e-form="rowform" e-required="">{{item[\'Fpay D.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Fpay W.Bank\']" e-name="\'Fpay W.Bank\'" e-form="rowform" e-required="">{{item[\'Fpay W.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'SKL QR\']" e-name="\'SKL QR\'" e-form="rowform" e-required="">{{item[\'SKL QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NP" e-name="NP" e-form="rowform" e-required="">{{item.NP.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NG" e-name="NG" e-form="rowform" e-required="">{{item.NG.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item[\'\u8DDF\u573A\u4E3B\u6536%\']" e-name="chang_zhu_rate" e-form="rowform" e-required="">{{item[\'\u8DDF\u573A\u4E3B\u6536%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%\']" e-name="gong_shi_pan_rate" e-form="rowform" e-required="">{{item[\'\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u5916\u4EA4\u8D39%\']" e-name="wai_jiao_rate" e-form="rowform" e-required="">{{item[\'\u5916\u4EA4\u8D39%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete($index)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="46" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-eye modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString.cm}}"> <img ng-src="{{imageString.bm}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr><tr><th class="align-right">TOTAL Net Collect</th><th class="align-right">{{ total.net_collect | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px; width: 100%; max-width: 500px"><thead><tr><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice Date</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice No.</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Shop ID</b></th></tr></thead><tbody><tr><td style="padding: 0; text-align: left" class="text-left">{{manageAllinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.code}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.name}}</td></tr></tbody></table><table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px; width: 100%; max-width: 500px; margin-top: 10px;"><thead><tr><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice No.</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Partner</b></th><th style="width: 33%"></th></tr></thead><tbody><tr><td style="padding: 0; text-align: left" class="text-left">{{manageAllinvoices.invoiceid || \'-\'}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.partner.code ? shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name : \'-\'}}</td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center" print-remove="">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td print-remove=""><img ng-if="item.receipt.content.cm!==null" ng-src="{{item.receipt.content.cm}}" style="text-align: center; width:200px;height:200px"> <img ng-if="item.receipt.content.bm!==null" ng-src="{{item.receipt.content.bm}}" style="text-align: center; width:200px;height:200px"></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span editable-text="manageAllinvoices.machineshorts" blur="cancel">{{ manageAllinvoices.machineshorts==0?\'-\':(manageAllinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table><br><div class="row"><div class="col-md-offset-8 col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect + getTotalcsales(machineInvoiceDetails)) | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesOnline.html','<span ng-if="onlineInvoiceDetails.NP.length > 0"><div class="row"><div class="col-sm-12"><h5>Net Purchase</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">AP P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">AP/W(+)</th><th class="text-center">Sales</th><th class="text-center">Bonus Bet(+)</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Bank(+)</th><th class="text-center">Bank.C(+)</th><th class="text-center">D.Ewallet(+)</th><th class="text-center">D.Ewallet.C(+)</th><th class="text-center">D.CC(+)</th><th class="text-center">D.CC.C(+)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NP" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\')}}</td><td class="align-right" rowspan="{{onlineInvoiceDetails.NP.length}}" ng-hide="$index>0"><span ng-if="total.NP_totalsales != 0">{{ total.NP_totalsales | currency: \'\' }}</span> <span ng-if="total.NP_totalsales == 0">-</span></td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.payment_gateway==0?\'-\':(item.payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet_charge==0?\'-\':(item.d_ewallet_charge | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.d_cc_charge==0?\'-\':(item.d_cc_charge | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{getCsales(item) | currency: \'\'}}</td><td class="align-right" rowspan="{{onlineInvoiceDetails.NP.length}}" ng-hide="$index>0"><span ng-if="total.NP_net_collect != 0">{{ total.NP_net_collect | currency: \'\' }}</span> <span ng-if="total.NP_net_collect == 0">-</span></td></tr></tbody></table></span> <span ng-if="onlineInvoiceDetails.NG.length > 0"><br><br><div class="row"><div class="col-sm-12"><h5>Net Gaming</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NG</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">P/S(+)</th><th class="text-center">AP P/S(+)</th><th class="text-center">P/W(-)</th><th class="text-center">AP/W(-)</th><th class="text-center">Bonus Bet</th><th class="text-center">Bonus Win(-)</th><th class="text-center">AP Bonus Win(-)</th><th class="text-center">Partner Bonus Bet(+)</th><th class="text-center">Bank(-)</th><th class="text-center">Bank.C(+)</th><th class="text-center">Bank Out(+)</th><th class="text-center">Bank Out.C(+)</th><th class="text-center">D.Ewallet(-)</th><th class="text-center">D.Ewallet.C(+)</th><th class="text-center">D.CC(-)</th><th class="text-center">D.CC.C(+)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NG" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netgaming==0?\'-\':(item.netgaming | currency: \'\')}}</td><td class="align-right">{{getCsales(item) | currency: \'\'}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\') }}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\') }}</td><td class="align-right">{{item.bonus_bet==0?\'-\':(item.bonus_bet | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.payment_gateway==0?\'-\':(item.payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.pg_out==0?\'-\':(item.pg_out | currency: \'\')}}</td><td class="align-right">{{item.pg_out_charge==0?\'-\':(item.pg_out_charge | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet_charge==0?\'-\':(item.d_ewallet_charge | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.d_cc_charge==0?\'-\':(item.d_cc_charge | currency: \'\')}}</td><td class="align-right">{{item.net_collect==0?\'-\':(item.net_collect | currency: \'\')}}</td></tr></tbody></table></span><br><br><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Net Collect</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect) | currency: \'\'}}</th></tr></thead></table></div></div><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Sales</th><th class="align-right">{{ total.totalSales | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesShopTable.html','<div class="horizontal-scroll" style="overflow-y: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2" ng-if="!!canUserClickPayNow"><label>&nbsp;</label><div><button type="button" class="btn btn-warning" ng-click="paidSelectedInvoices()">Paid Invoices</button></div></div><div class="col-sm-2"><label>&nbsp;</label><div><button type="button" class="btn btn-default" ng-click="backToList()">Back</button></div></div><div class="col-sm-4"></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesOfShop | currency:\'\'}}</strong></label></div></div></div></div></div><table-column-toolbar column-list="columnList" storage-key="\'allinvoicesshop\'" on-changed="onColumnToolbarChange($value, \'hideTableColumnsShop\')"></table-column-toolbar><hr><table-scroller-bar></table-scroller-bar><table sticky-columns="" class="table table-striped table-condensed" st-safe-src="manageAllinvoicesListWithShop" st-table="manageAllinvoicesWithShop"><thead sticky-on-scroll=""><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th ng-if="canUserClickPayNow"></th><th ng-hide="hideTableColumnsShop.invoiceid" st-sort="invoiceid" sticky="true">Invoice No.</th><th ng-hide="hideTableColumnsShop.invoicedate" st-sort="invoicedate" sticky="true">Invoice Date</th><th ng-hide="hideTableColumnsShop.shopcode" st-sort="shopcode" sticky="true">Shop Code</th><th ng-hide="hideTableColumnsShop.shopname" st-sort="shopname" sticky="true">Shop Name</th><th ng-hide="hideTableColumnsShop.partnername" st-sort="partnername" sticky="true">Partner</th><th ng-hide="hideTableColumnsShop.netgaming" st-sort="netgaming" class="bg-light-yellow" style="color: black">Net Gaming</th><th ng-hide="hideTableColumnsShop.cafeanddart" st-sort="cafeanddart" class="bg-light-yellow" style="color: black">Cafe & Darts</th><th ng-hide="hideTableColumnsShop.snooker" st-sort="snooker" class="bg-light-yellow" style="color: black">Snooker</th><th ng-hide="hideTableColumnsShop.net_collect" st-sort="net_collect" class="bg-info" style="color: black">Net Collect</th><th ng-hide="hideTableColumnsShop.total_payment_gateway" st-sort="total_payment_gateway" class="bg-info" style="color: black">Bank</th><th ng-hide="hideTableColumnsShop.total_pg_out" st-sort="total_pg_out" class="bg-info" style="color: black">Bank Out</th><th ng-hide="hideTableColumnsShop.d_ewallet" st-sort="d_ewallet" class="bg-info" style="color: black">D.Ewallet</th><th ng-hide="hideTableColumnsShop.tng_pin_charge" st-sort="tng_pin_charge" class="bg-info" style="color: black">Tng pin</th><th ng-hide="hideTableColumnsShop.d_cc" st-sort="d_cc" class="bg-info" style="color: black">D.CC</th><th ng-hide="hideTableColumnsShop.sales" st-sort="sales" class="bg-light-blue" style="color: black">Sales</th><th ng-hide="hideTableColumnsShop.serverpr" st-sort="serverpr" class="bg-light-grey" style="color: black">Server</th><th ng-hide="hideTableColumnsShop.claim" st-sort="claim" class="bg-light-purple" style="color: black">Claim</th><th ng-hide="hideTableColumnsShop.total" st-sort="total" class="bg-light-yellow" style="color: black">Total</th><th ng-hide="hideTableColumnsShop.localPaidStatus" style="min-width: 120px" st-sort="localPaidStatus">Paid Status</th><th ng-hide="hideTableColumnsShop.pdate" st-sort="pdate">Paid Date</th><th ng-hide="hideTableColumnsShop.agentid" st-sort="agentid">Agent</th><th ng-hide="hideTableColumnsShop.receipts">Receipts</th><th>Action</th></tr><tr><th></th><th ng-if="canUserClickPayNow"><input type="checkbox" id="inlineCheckbox" ng-model="shopBillChecker.checkAll" ng-click="onCheckBoxChange(null, manageAllinvoicesWithShop)"></th><th ng-hide="hideTableColumnsShop.invoiceid"><input st-search="invoiceid" placeholder="Invoice Id" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumnsShop.invoicedate"><input st-search="ikeyToDate" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumnsShop.shopcode"><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumnsShop.shopname"><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumnsShop.partnername"><input st-search="partnername" placeholder="Partner" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumnsShop.netgaming" style="background-color: chocolate; color: black">{{getTotalNetGaming(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.cafeanddart" style="background-color: chocolate; color: black">{{getTotalCafeAndDarts(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.snooker" style="background-color: chocolate; color: black">{{getTotalSnooker(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.net_collect" style="background-color: chocolate; color: black">{{getTotalNetCollect(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.total_payment_gateway" style="background-color: chocolate; color: black">{{getTotalBank(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.total_pg_out" style="background-color: chocolate; color: black">{{getTotalBankOut(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.d_ewallet" style="background-color: chocolate; color: black">{{getTotalEwallet(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.tng_pin_charge" style="background-color: chocolate; color: black">{{getTotalTngPin(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.d_cc" style="background-color: chocolate; color: black">{{getTotalCC(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.sales" style="background-color: chocolate; color: black">{{getTotaltotalsales(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.serverpr" style="background-color: chocolate; color: black">{{getTotalServerFee(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumnsShop.total" style="background-color: chocolate; color: black">{{getTotalServerSales(manageAllinvoicesWithShop) | currency:\'\'}}</th><th style="margin-left: 2px" ng-hide="hideTableColumnsShop.localPaidStatus"><select st-search="localPaidStatus" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in paidStatusList | unique:\'localPaidStatus\'" value="{{status.value}}">{{status.value}}</option></select></th><th ng-hide="hideTableColumnsShop.pdate"></th><th ng-hide="hideTableColumnsShop.agentid"></th><th ng-hide="hideTableColumnsShop.receipts"></th><th></th></tr></thead><tbody><tr ng-if="loading.detail"><td colspan="100">Loading...</td></tr><tr ng-if="!loading.detail" ng-repeat="item in manageAllinvoicesWithShop" ng-click="onCheckBoxChange(item.id)" ng-class="{\'bg-light-blue \' : !!shopBillChecker[item.id]}" class="editable-row"><td class="table-id">{{$index+1}}</td><td ng-if="canUserClickPayNow"><input type="checkbox" id="inlineCheckbox" ng-model="shopBillChecker[item.id]" disabled=""></td><td ng-hide="hideTableColumnsShop.invoiceid">{{ item.invoiceid || \'empty\'}}</td><td ng-hide="hideTableColumnsShop.invoicedate">{{item.ikeyToDate}}</td><td ng-hide="hideTableColumnsShop.shopcode">{{item.shopcode}}</td><td ng-hide="hideTableColumnsShop.shopname">{{item.shopname}}</td><td ng-hide="hideTableColumnsShop.partnername">{{item.partnername}}</td><td ng-hide="hideTableColumnsShop.netgaming" class="bg-light-yellow" style="color: black">{{(item.netgaming || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.cafeanddart" class="bg-light-yellow" style="color: black">{{(item.cafeanddarts || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.snooker" class="bg-light-yellow" style="color: black">{{(item.snooker || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.net_collect" class="bg-info" style="color: black">{{item.net_collect | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.total_payment_gateway" class="bg-info" style="color: black">{{item.total_payment_gateway | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.total_pg_out" class="bg-info" style="color: black">{{item.total_pg_out | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.d_ewallet" class="bg-info" style="color: black">{{item.d_ewallet | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.tng_pin_charge" class="bg-info" style="color: black">{{item.tng_pin_charge | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.d_cc" class="bg-info" style="color: black">{{item.d_cc | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.sales" class="bg-light-blue" style="color: black">{{getTotalSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.serverpr" class="bg-light-grey" style="color: black">{{item.serverpr | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.claim" class="bg-light-purple" style="color: black">{{0.00 | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.total" class="bg-light-yellow" style="color: black">{{getServerSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumnsShop.localPaidStatus" ng-class="{\'bg-success\':item.localPaidStatus === \'PAID\',\'bg-danger\':item.localPaidStatus === \'UNPAY\', \'bg-warning\': item.localPaidStatus === \'PARTIALLY PAY\' }" style="color: black">{{item.localPaidStatus}}</td><td ng-hide="hideTableColumnsShop.pdate">{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td ng-hide="hideTableColumnsShop.agentid">{{showUserById(item.agentid)}}</td><td ng-hide="hideTableColumnsShop.receipts"><div class="button" style="padding: 8px 0"><button ng-click="viewPaidReceipt($event, receipt)" ng-repeat="receipt in item.receipts" class="btn btn-info btn-xs" style="display: block; margin-bottom: 3px">{{receipt.orno}}</button></div></td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp; <button ng-if="canUserClickDelete" class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-if="!item.ispaid && canUserClickPayNow" class="btn btn-info editable-table-button btn-xs" ng-click="paidSelectedInvoices(item)">Pay Now</button></div></td></tr><tr><td></td><td ng-if="canUserClickPayNow"></td><td ng-hide="hideTableColumnsShop.invoiceid"></td><td ng-hide="hideTableColumnsShop.invoicedate"></td><td ng-hide="hideTableColumnsShop.shopcode"></td><td ng-hide="hideTableColumnsShop.shopname"></td><td ng-hide="hideTableColumnsShop.partnername"></td><td ng-hide="hideTableColumnsShop.netgaming" style="background-color: chocolate; color: black">{{getTotalNetGaming(manageAllinvoicesWithShop) | currency:\'\'}}</td><td ng-hide="hideTableColumnsShop.cafeanddart" style="background-color: chocolate; color: black">{{getTotalCafeAndDarts(manageAllinvoicesWithShop) | currency:\'\'}}</td><td ng-hide="hideTableColumnsShop.snooker" style="background-color: chocolate; color: black">{{getTotalSnooker(manageAllinvoicesWithShop) | currency:\'\'}}</td><td ng-hide="hideTableColumnsShop.net_collect" style="background-color: chocolate; color: black">{{getTotalNetCollect(manageAllinvoicesWithShop) | currency:\'\'}}</td><td ng-hide="hideTableColumnsShop.total_payment_gateway" style="background-color: chocolate; color: black">{{getTotalBank(manageAllinvoicesWithShop) | currency:\'\'}}</td><td ng-hide="hideTableColumnsShop.total_pg_out" style="background-color: chocolate; color: black">{{getTotalBankOut(manageAllinvoicesWithShop) | currency:\'\'}}</td><th ng-hide="hideTableColumnsShop.d_ewallet" style="background-color: chocolate; color: black">{{getTotalEwallet(manageAllinvoicesWithShop) | currency:\'\'}}</th><td ng-hide="hideTableColumnsShop.tng_pin_charge" style="background-color: chocolate; color: black">{{getTotalTngPin(manageAllinvoicesWithShop) | currency:\'\'}}</td><th ng-hide="hideTableColumnsShop.d_cc" style="background-color: chocolate; color: black">{{getTotalCC(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.sales" style="background-color: chocolate; color: black">{{getTotaltotalsales(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.serverpr" style="background-color: chocolate; color: black">{{getTotalServerFee(manageAllinvoicesWithShop) | currency:\'\'}}</th><th ng-hide="hideTableColumnsShop.claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumnsShop.total" style="background-color: chocolate; color: black">{{getTotalServerSales(manageAllinvoicesWithShop) | currency:\'\'}}</th><td ng-hide="hideTableColumnsShop.localPaidStatus"></td><td ng-hide="hideTableColumnsShop.pdate"></td><td ng-hide="hideTableColumnsShop.agentid"></td><td ng-hide="hideTableColumnsShop.receipts"></td><td></td></tr></tbody><tfoot><tr><td colspan="19" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/allinvoices/widgets/allinvoicesTable.html','<div class="horizontal-scroll" style="overflow-y: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2"><label>Filter Shop Invoicing</label><select class="form-control selectpicker show-tick" title="Invoicing" selectpicker="" ng-model="reportFilter.allowInvocing" ng-options="item as item.label for item in shopInvoicingOptions track by item.id"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.partner" class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3" ng-if="allowToViewShopCategory"><label>Shop Category</label><ui-select ng-model="reportFilter.categoryid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="cat in shopCategory | filter: $select.search"><span ng-bind-html="cat.name"></span></ui-select-choices></ui-select></div></div><div class="row"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-disabled="loading.searching" ng-click="searchAllinvoices(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button ng-disabled="loading.searching" type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-2" ng-if="!!canUserClickPayNow"><label>&nbsp;</label><div><button type="button" class="btn btn-warning" ng-click="paidSelectedMainInvoices()">Paid Invoices</button></div></div></div><table-column-toolbar column-list="columnList" storage-key="\'allinvoices\'" on-changed="onColumnToolbarChange($value, \'hideTableColumns\')"></table-column-toolbar><hr><table-scroller-bar></table-scroller-bar><table sticky-columns="" class="table table-striped table-condensed" st-safe-src="manageAllinvoicesList" st-table="manageAllinvoices"><thead sticky-on-scroll="" ng-if="showHeader"><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th ng-if="canUserClickPayNow"></th><th ng-hide="hideTableColumns.shopcode" st-sort="shopcode" sticky="true">Shop Code</th><th ng-hide="hideTableColumns.shopname" st-sort="shopname" sticky="true">Shop Name</th><th ng-hide="hideTableColumns.partnername" st-sort="partnername" sticky="true">Partner</th><th ng-hide="hideTableColumns.netgaming" st-sort="netgaming" class="bg-light-yellow" style="color: black">Net Gaming</th><th ng-hide="hideTableColumns.cafeanddart" st-sort="cafeanddart" class="bg-light-yellow" style="color: black">Cafe & Darts</th><th ng-hide="hideTableColumns.snooker" st-sort="snooker" class="bg-light-yellow" style="color: black">Snooker</th><th ng-hide="hideTableColumns.net_collect" st-sort="net_collect" class="bg-info" style="color: black">Net Collect</th><th ng-hide="hideTableColumns.total_payment_gateway" st-sort="total_payment_gateway" class="bg-info" style="color: black">Bank</th><th ng-hide="hideTableColumns.total_pg_out" st-sort="total_pg_out" class="bg-info" style="color: black">Bank Out</th><th ng-hide="hideTableColumns.d_ewallet" st-sort="d_ewallet" class="bg-info" style="color: black">D.Ewallet</th><th ng-hide="hideTableColumns.tng_pin_charge" st-sort="tng_pin_charge" class="bg-info" style="color: black">Tng pin</th><th ng-hide="hideTableColumns.d_cc" st-sort="d_cc" class="bg-info" style="color: black">D.CC</th><th ng-hide="hideTableColumns.sales" st-sort="sales" class="bg-light-blue" style="color: black">Sales</th><th ng-hide="hideTableColumns.serverpr" st-sort="serverpr" class="bg-light-grey" style="color: black">Server</th><th ng-hide="hideTableColumns.claim" st-sort="claim" class="bg-light-purple" style="color: black">Claim</th><th ng-hide="hideTableColumns.total" st-sort="total" class="bg-light-yellow" style="color: black">Total</th><th ng-hide="hideTableColumns.localPaidStatus" style="min-width: 120px" st-sort="localPaidStatus">Paid Status</th><th ng-hide="hideTableColumns.pdate" st-sort="pdate">Paid Date</th><th ng-hide="hideTableColumns.agentid" st-sort="agentid">Agent</th><th ng-hide="hideTableColumns.receipts">Receipts</th><th>Action</th></tr><tr><th></th><th ng-if="canUserClickPayNow"><input type="checkbox" id="inlineCheckbox" ng-model="mainBillChecker.checkAll" ng-click="onMainCheckBoxChange(null, manageAllinvoices)"></th><th ng-hide="hideTableColumns.shopcode"><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.shopname"><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.partnername"><input st-search="partnername" placeholder="Partner" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.netgaming" style="background-color: chocolate; color: black">{{getTotalNetGaming(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.cafeanddart" style="background-color: chocolate; color: black">{{getTotalCafeAndDarts(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.snooker" style="background-color: chocolate; color: black">{{getTotalSnooker(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.net_collect" style="background-color: chocolate; color: black">{{getTotalNetCollect(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.total_payment_gateway" style="background-color: chocolate; color: black">{{getTotalBank(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.total_pg_out" style="background-color: chocolate; color: black">{{getTotalBankOut(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.d_ewallet" style="background-color: chocolate; color: black">{{getTotalEwallet(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.tng_pin_charge" style="background-color: chocolate; color: black">{{getTotalTngPin(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.d_cc" style="background-color: chocolate; color: black">{{getTotalCC(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.sales" style="background-color: chocolate; color: black">{{getTotaltotalsales(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.serverpr" style="background-color: chocolate; color: black">{{getTotalServerFee(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumns.total" style="background-color: chocolate; color: black">{{getTotalServerSales(manageAllinvoices) | currency:\'\'}}</th><th style="margin-left: 2px" ng-hide="hideTableColumns.localPaidStatus"><select st-search="localPaidStatus" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in paidStatusList | unique:\'localPaidStatus\'" value="{{status.value}}">{{status.value}}</option></select></th><th ng-hide="hideTableColumns.pdate"></th><th ng-hide="hideTableColumns.agentid"></th><th ng-hide="hideTableColumns.receipts"></th><th></th></tr></thead><tbody><tr ng-if="loading.searching"><td colspan="100">Loading...</td></tr><tr ng-class="{\'bg-light-blue \' : !!mainBillChecker[item.invoice_ids]}" ng-if="!loading.searching" ng-repeat="item in manageAllinvoices" class="editable-row" ng-click="onMainCheckBoxChange(item)"><td class="table-id">{{$index+1}}</td><td ng-if="canUserClickPayNow"><input type="checkbox" id="inlineCheckbox" ng-model="mainBillChecker[item.invoice_ids]" disabled=""></td><td ng-hide="hideTableColumns.shopcode">{{item.shopcode}}</td><td ng-hide="hideTableColumns.shopname">{{item.shopname}}</td><td ng-hide="hideTableColumns.partnername">{{item.partnername}}</td><td ng-hide="hideTableColumns.netgaming" class="bg-light-yellow" style="color: black">{{(item.netgaming || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumns.cafeanddart" class="bg-light-yellow" style="color: black">{{(item.cafeanddarts || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumns.snooker" class="bg-light-yellow" style="color: black">{{(item.snooker || 0)| currency: \'\'}}</td><td ng-hide="hideTableColumns.net_collect" class="bg-info" style="color: black">{{item.net_collect | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_payment_gateway" class="bg-info" style="color: black">{{item.total_payment_gateway | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_pg_out" class="bg-info" style="color: black">{{item.total_pg_out | currency: \'\'}}</td><td ng-hide="hideTableColumns.d_ewallet" class="bg-info" style="color: black">{{item.d_ewallet | currency: \'\'}}</td><td ng-hide="hideTableColumns.tng_pin_charge" class="bg-info" style="color: black">{{item.tng_pin_charge | currency: \'\'}}</td><td ng-hide="hideTableColumns.d_cc" class="bg-info" style="color: black">{{item.d_cc | currency: \'\'}}</td><td ng-hide="hideTableColumns.sales" class="bg-light-blue" style="color: black">{{getTotalSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.serverpr" class="bg-light-grey" style="color: black">{{item.serverpr | currency: \'\'}}</td><td ng-hide="hideTableColumns.claim" class="bg-light-purple" style="color: black">{{0.00 | currency: \'\'}}</td><td ng-hide="hideTableColumns.total" class="bg-light-yellow" style="color: black">{{getServerSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.localPaidStatus" ng-class="{\'bg-success\':item.localPaidStatus === \'PAID\',\'bg-danger\':item.localPaidStatus === \'UNPAY\', \'bg-warning\': item.localPaidStatus === \'PARTIALLY PAY\' }" style="color: black">{{item.localPaidStatus}}</td><td ng-hide="hideTableColumns.pdate">{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td ng-hide="hideTableColumns.agentid">{{showUserById(item.agentid)}}</td><td ng-hide="hideTableColumns.receipts"><div class="button" style="padding: 8px 0"><button ng-click="viewPaidReceipt($event, receipt)" ng-repeat="receipt in item.receipts" class="btn btn-info btn-xs" style="display: block; margin-bottom: 3px">{{receipt.orno}}</button></div></td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getAllInvoiceWithShop(item)">View</button> &nbsp; &nbsp; <button ng-if="!item.ispaid && canUserClickPayNow" class="btn btn-info editable-table-button btn-xs" ng-click="paidSelectedMainInvoices(item)">Pay Now</button></div></td></tr><tr><td></td><td ng-if="canUserClickPayNow"></td><td ng-hide="hideTableColumns.shopcode"></td><td ng-hide="hideTableColumns.shopname"></td><td ng-hide="hideTableColumns.partnername"></td><td ng-hide="hideTableColumns.netgaming" style="background-color: chocolate; color: black">{{getTotalNetGaming(manageAllinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.cafeanddart" style="background-color: chocolate; color: black">{{getTotalCafeAndDarts(manageAllinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.snooker" style="background-color: chocolate; color: black">{{getTotalSnooker(manageAllinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.net_collect" style="background-color: chocolate; color: black">{{getTotalNetCollect(manageAllinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.total_payment_gateway" style="background-color: chocolate; color: black">{{getTotalBank(manageAllinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.total_pg_out" style="background-color: chocolate; color: black">{{getTotalBankOut(manageAllinvoices) | currency:\'\'}}</td><th ng-hide="hideTableColumns.d_ewallet" style="background-color: chocolate; color: black">{{getTotalEwallet(manageAllinvoices) | currency:\'\'}}</th><td ng-hide="hideTableColumns.tng_pin_charge" style="background-color: chocolate; color: black">{{getTotalTngPin(manageAllinvoices) | currency:\'\'}}</td><th ng-hide="hideTableColumns.d_cc" style="background-color: chocolate; color: black">{{getTotalCC(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.sales" style="background-color: chocolate; color: black">{{getTotaltotalsales(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.serverpr" style="background-color: chocolate; color: black">{{getTotalServerFee(manageAllinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumns.total" style="background-color: chocolate; color: black">{{getTotalServerSales(manageAllinvoices) | currency:\'\'}}</th><td ng-hide="hideTableColumns.localPaidStatus"></td><td ng-hide="hideTableColumns.pdate"></td><td ng-hide="hideTableColumns.agentid"></td><td ng-hide="hideTableColumns.receipts"></td><td></td></tr></tbody><tfoot><tr><td colspan="19" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/companyserverinvoice/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/companyserverinvoice/widgets/companyserverinvoiceTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000,50000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div ng-if="!!manageParentPartnerList.length" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.partnerid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.id}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shopcode">Shop Code</th><th st-sort="shopname">Shop Name</th><th st-sort="finalearn">35 %</th><th st-sort="finalcharge">15 %</th><th st-sort="finaltotal">20 %</th></tr><tr><th></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finalearn\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finalcharge\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finaltotal\') | currency:\'\'}}</th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.shopcode || \'empty\'}}</td><td>{{ item.shopname || \'empty\'}}</td><td>{{ item.finalearn | currency:\'\'}}</td><td>{{ item.finalcharge | currency:\'\'}}</td><td>{{ item.finaltotal | currency:\'\'}}</td></tr></tbody><tfoot><tr><th></th><th></th><th></th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finalearn\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finalcharge\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'finaltotal\') | currency:\'\'}}</th></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/PayNowModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-cash modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to Pay this Invoice. Please make sure you have collected the payment.</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Invoice!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/imgPreviewerModal.html','<slick dots="true" infinite="true" speed="300" slides-to-show="1" slides-to-scroll="1" on-after-change="onAfterChange();"><div ng-repeat="photo in selectedPhotos" style="position: relative"><img ng-style="{cursor: !zoomInMode ? \'zoom-in\' : \'zoom-out\'}" ng-mousemove="zoomInPhoto($event, photo)" ng-click="toggleZoomMode()" ng-src="{{photo}}" style="width: 100%; object-fit: contain; max-height: 800px"><div ng-style="myImageStyle" style="z-index: 0; pointer-events: none; position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-repeat: no-repeat;"></div></div></slick>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/paidInvoiceModal.html','<div class="modal-header bg-warning"><i class="ion-flame modal-icon"></i><span>Paid Now: <span style="font-weight: bold">{{getTotaPaidNetCollect() | currency: \'\'}}</span></span></div><div class="modal-body text-left"><div class="form-group row clearfix" ng-if="!!selectedInvoicesToPaid.id"><label for="orno" class="col-sm-4 control-label">ORNO</label><div class="col-sm-8">{{selectedInvoicesToPaid.orno}}</div></div><div class="row clearfix"><label class="col-sm-4">Date</label><div class="col-sm-8"><div class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="selectedInvoicesToPaid.paidAt" show-button-bar="false" is-open="dpOpenStatus.required" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'required\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group row clearfix"><label for="description" class="col-sm-4 control-label">Description</label><div class="col-sm-8"><input class="form-control" type="text" id="description" ng-model="selectedInvoicesToPaid.description"></div></div><div class="form-group row clearfix"><label for="total" class="col-sm-4 control-label">Total Paid</label><div class="col-sm-8">{{getTotalPaidReceipt() | currency: \'\'}}</div></div><div class="clearfix" ng-repeat="paidInovice in selectedInvoicesToPaid.invoices"><h3 style="margin-bottom: 20px; margin-top: 20px; border-bottom: 1px solid black;"></h3><div class="form-group row"><label for="shop" class="col-sm-4 control-label">Shop Code</label><div class="col-sm-8">{{paidInovice.invoice.shopcode}}</div></div><div class="form-group row"><label class="col-sm-4 control-label">Net Collect</label><div class="col-sm-8">{{paidInovice.invoice.net_collect | currency: \'\'}}</div></div><div class="form-group row"><label class="col-sm-4 control-label">Paid Amount</label><div class="col-sm-8"><input type="number" class="form-control" ng-model="paidInovice.paidAmount" placeholder="0"></div></div><div class="row clearfix"><label for="photo" class="col-sm-4 control-label">Photo</label><div class="col-sm-8"><input class="form-control" type="file" id="uploadFile" multiple="true" accept="image/*" ngf-select="onFileChange($files, $index)" ng-model="file" name="file" ngf-pattern="\'image/*\'" ngf-resize="{width: 500, height: 500, quality: .8,}" ngf-resize-if="$width > 800 || $height > 800" ngf-accept="\'image/*\'"><div ng-if="!paidInovice.photoURL.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo.url)" ng-style="{backgroundImage: \'url(\' + photo.url + \')\' }" ng-repeat="photo in paidInovice.photoURL"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black; z-index: 99;" ng-click="deleteImage($event, paidInovice.invoice.id, $index)"></i></div></div></div></div></div></div><div class="modal-footer"><div ng-if="!!selectedInvoicesToPaid.status" style="font-weight: bold; color: green; font-size: 1.3rem; text-align: center;">Receipt is {{selectedInvoicesToPaid.status}}.</div><button ng-if="!selectedInvoicesToPaid.status" type="button" class="btn btn-primary" ng-click="$close(true)" ng-disabled="loading.generateInvoiceReceipt">CONFIRM</button> <button ng-if="!selectedInvoicesToPaid.status" type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-eye modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString.cm}}"> <img ng-src="{{imageString.bm}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceFooter.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">TOTAL</th><th class="align-right">{{getTotal() | currency: \'\'}}</th></tr><tr><th class="align-right">TOTAL Net Collect</th><th class="align-right">{{ total.net_collect | currency: \'\'}}</th></tr></thead></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceHeader.html','<table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px; width: 100%; max-width: 500px"><thead><tr><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice Date</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice No.</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Shop ID</b></th></tr></thead><tbody><tr><td style="padding: 0; text-align: left" class="text-left">{{manageDailyinvoices.invoicedate | date: \'dd/MM/yyyy\'}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.code}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.name}}</td></tr></tbody></table><table id="dotMatrixHeader" class="table table-no-borders" style="padding: 0px; margin-top: 0px; width: 100%; max-width: 500px; margin-top: 10px;"><thead><tr><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Invoice No.</b></th><th class="text-left" style="width: 33%; text-align: left; padding: 0px"><b>Partner</b></th><th style="width: 33%"></th></tr></thead><tbody><tr><td style="padding: 0; text-align: left" class="text-left">{{manageDailyinvoices.invoiceid || \'-\'}}</td><td style="padding: 0; text-align: left" class="text-left">{{shopInvoiceDetails.partner.code ? shopInvoiceDetails.partner.code+\', \'+shopInvoiceDetails.partner.name : \'-\'}}</td><td></td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceMachine.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center" print-remove="">Picture</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br>{{item.created | date: \'hh:mm a\'}}</td><td print-remove=""><img ng-if="item.receipt.content.cm!==null" ng-src="{{item.receipt.content.cm}}" style="text-align: center; width:200px;height:200px"> <img ng-if="item.receipt.content.bm!==null" ng-src="{{item.receipt.content.bm}}" style="text-align: center; width:200px;height:200px"></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td class="align-right">{{getTotaltotalsales(machineInvoiceDetails)==0?\'-\':(getTotaltotalsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalpsales(machineInvoiceDetails)==0?\'-\':(getTotalpsales(machineInvoiceDetails) | currency: \'\')}}</td><td class="align-right">{{getTotalcsales(machineInvoiceDetails)==0?\'-\':(getTotalcsales(machineInvoiceDetails) | currency: \'\')}}</td><td></td><td></td></tr></tbody></table><br><div class="row"><div class="col-md-offset-8 col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect + getTotalcsales(machineInvoiceDetails)) | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnline.html','<table id="dotMatrix" class="table table-sm" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr style="background-color: black; color: white"><th></th><th>{{rate.earn}}%</th><th ng-if="isAdmin">Server {{rate.charge}}%</th><th ng-if="isAdmin">PR {{rate.pr}}%</th></tr></thead><tbody ng-repeat="item in onlineInvoiceDetails.NP"><tr><td style="text-align: left; font-weight: bold">{{getFullGameName(item, \'NP\')}}</td><td>{{getFullTotal(item, \'NP\') | currency: \'\'}}</td><td ng-if="isAdmin">{{getFullTotal(item, \'NP\') | currency: \'\'}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+Bank In</td><td>{{item.total_payment_gateway | currency: \'\'}}</td><td ng-if="isAdmin">{{item.total_payment_gateway | currency: \'\'}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-Bank Out</td><td>{{parseToNegative(item.total_pg_out)==0 ? \'-\' : (parseToNegative(item.total_pg_out) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.total_pg_out)==0 ? \'-\' : (parseToNegative(item.total_pg_out) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+Ewallet</td><td>{{item.d_ewallet | currency: \'\'}}</td><td ng-if="isAdmin">{{item.d_ewallet | currency: \'\'}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(P.BETS)</td><td>{{parseToNegative(item.pshare)==0 ? \'-\' : (parseToNegative(item.pshare) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.pshare)==0 ? \'-\' : (parseToNegative(item.pshare) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(AP.BETS)</td><td>{{parseToNegative(item.apshare)==0 ? \'-\' : (parseToNegative(item.apshare) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.apshare)==0 ? \'-\' : (parseToNegative(item.apshare) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+PT(P.WINS)</td><td>{{item.pwin==0 ? \'-\' : (item.pwin | currency: \'\')}}</td><td ng-if="isAdmin">{{item.pwin==0 ? \'-\' : (item.pwin | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+PT(AP.WINS)</td><td>{{item.apwin==0 ? \'-\' : (item.apwin | currency: \'\')}}</td><td ng-if="isAdmin">{{item.apwin==0 ? \'-\' : (item.apwin | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="border-top: 1px solid; border-bottom: 1px solid"></td><td style="border-top: 1px solid; border-bottom: 1px solid">{{getsubTotalNP(item) | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getsubTotalNP(item) | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin"></td></tr><tr><td style="text-align: left">{{getGameName(item)}}</td><td>{{getTotalGameEarn(item, \'NP\') | currency: \'\'}}</td><td ng-if="isAdmin">{{getTotalGameCharge(item, \'NP\') | currency: \'\'}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+PT(P.BETS)</td><td>{{item.pshare==0 ? \'-\' : (item.pshare | currency: \'\')}}</td><td ng-if="isAdmin">{{item.pshare==0 ? \'-\' : (item.pshare | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+PT(AP.BETS)</td><td>{{item.apshare==0 ? \'-\' : (item.apshare | currency: \'\')}}</td><td ng-if="isAdmin">{{item.apshare==0 ? \'-\' : (item.apshare | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(P.WINS)</td><td>{{parseToNegative(item.pwin)==0 ? \'-\' : (parseToNegative(item.pwin) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.pwin)==0 ? \'-\' : (parseToNegative(item.pwin) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(AP.WINS)</td><td>{{parseToNegative(item.apwin)==0 ? \'-\' : (parseToNegative(item.apwin) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.apwin)==0 ? \'-\' : (parseToNegative(item.apwin) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="background-color: cadetblue; color: white"><td style="border-top: 1px solid; border-bottom: 1px solid; text-align: left;">{{getTotalGameName(item)}}</td><td style="border-top: 1px solid; border-bottom: 1px solid">{{getTotalNpEarn(item) | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getTotalNpCharge(item) | currency: \'\'}}</td><td ng-if="isAdmin" style="border-top: 1px solid; border-bottom: 1px solid">{{getPRGameEarnSubtotal(item, \'NP\') ? (getPRGameEarnSubtotal(item, \'NP\') | currency: \'\') : \'-\'}}</td></tr></tbody><tbody ng-repeat="item in onlineInvoiceDetails.NG" style="border-top: none"><tr style="height: 25px" ng-if="onlineInvoiceDetails.NG.length && onlineInvoiceDetails.NP.length"><td></td><td></td><td></td><td></td></tr><tr><td style="text-align: left; font-weight: bold">{{getFullGameName(item, \'NG\')}}</td><td>{{ item.shop.shoptype !== \'20%PR\' ? (getFullTotal(item, \'NG\') | currency: \'\') : \'\'}}</td><td ng-if="isAdmin">{{getFullTotal(item, \'NG\') | currency: \'\'}}</td><td ng-if="isAdmin">{{ item.shop.shoptype === \'20%PR\' ? (getFullTotal(item, \'NG\') | currency: \'\') : \'\'}}</td></tr><tr style="color: red" ng-if="item.shop.shoptype === \'20%PR\'"><td style="text-align: left">-Angpao</td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin">{{item.angpao==0 ? \'-\' : (item.angpao | currency: \'\')}}</td></tr><tr style="color: red" ng-if="item.shop.shoptype === \'20%PR\'"><td style="text-align: left">-Commission</td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin">{{item.commission==0 ? \'-\' : (item.commission | currency: \'\')}}</td></tr><tr style="color: red" ng-if="item.shop.shoptype === \'20%PR\'"><td style="text-align: left">-Promotion</td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin">{{item.promotion==0 ? \'-\' : (item.promotion | currency: \'\')}}</td></tr><tr style="color: red" ng-if="item.shop.shoptype === \'20%PR\'"><td style="text-align: left">-FPromotion</td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin">{{item.fpromotion==0 ? \'-\' : (item.fpromotion | currency: \'\')}}</td></tr><tr><td style="text-align: left">{{getGameName(item)}}</td><td>{{getTotalGameEarn(item, \'NG\') | currency: \'\'}}</td><td ng-if="isAdmin">{{getTotalGameCharge(item, \'NG\') | currency: \'\'}}</td><td ng-if="isAdmin">{{item.shop.shoptype === \'20%PR\' ? (getTotalPRCharge(item) | currency: \'\') : \'\'}}</td></tr><tr><td style="text-align: left">+PT(P.BETS)</td><td>{{item.pshare==0 ? \'-\' : (item.pshare | currency: \'\')}}</td><td ng-if="isAdmin">{{item.pshare==0 ? \'-\' : (item.pshare | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+PT(AP.BETS)</td><td>{{item.apshare==0 ? \'-\' : (item.apshare | currency: \'\')}}</td><td ng-if="isAdmin">{{item.apshare==0 ? \'-\' : (item.apshare | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">+TOKEN</td><td>{{item.p_bonus_bets==0 ? \'-\' : (item.p_bonus_bets | currency: \'\')}}</td><td ng-if="isAdmin">{{item.p_bonus_bets==0 ? \'-\' : (item.p_bonus_bets | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(P.WINS)</td><td>{{parseToNegative(item.pwin)==0 ? \'-\' : (parseToNegative(item.pwin) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.pwin)==0 ? \'-\' : (parseToNegative(item.pwin) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-PT(AP.WINS)</td><td>{{parseToNegative(item.apwin)==0 ? \'-\' : (parseToNegative(item.apwin) | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegative(item.apwin)==0 ? \'-\' : (parseToNegative(item.apwin) | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-Lucky Wins</td><td>{{item.bonus_win==0 ? \'-\' : (item.bonus_win | currency: \'\')}}</td><td ng-if="isAdmin">{{item.bonus_win==0 ? \'-\' : (item.bonus_win | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-CAISHEN</td><td>{{item.caishen==0 ? \'-\' : (item.caishen | currency: \'\')}}</td><td ng-if="isAdmin">{{item.caishen==0 ? \'-\' : (item.caishen | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-Plinko</td><td>{{!item.plinko ? \'-\' : (item.plinko | currency: \'\')}}</td><td ng-if="isAdmin">{{!item.plinko ? \'-\' : (item.plinko | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">-EVENT BONUS</td><td>{{item.pgsbonus==0 ? \'-\' : (item.pgsbonus | currency: \'\')}}</td><td ng-if="isAdmin">{{item.pgsbonus==0 ? \'-\' : (item.pgsbonus | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="background-color: yellowgreen; color: white"><td style="border-top: 1px solid; border-bottom: 1px solid; text-align: left;">{{getTotalGameName(item)}}</td><td style="border-top: 1px solid; border-bottom: 1px solid">{{getTotalNgEarn(item) | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getTotalNgCharge(item) | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getPRGameEarnSubtotal(item, \'NG\') ? (getPRGameEarnSubtotal(item, \'NG\') | currency: \'\') : \'-\'}}</td></tr></tbody><tbody style="border-top: none"><tr style="height: 25px"><td></td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin"></td></tr><tr style="font-weight: bold"><td style="border-top: 1px solid; border-bottom: 1px solid; text-align: left;">Sub Total</td><td style="border-top: 1px solid; border-bottom: 1px solid">{{getsubTotalEarn() | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getsubTotalCharge() | currency: \'\'}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin"></td></tr></tbody><tbody style="border-top: none"><tr><td style="text-align: left">-Payment Gateway In</td><td>{{parseToNegativeList(\'total_payment_gateway\')==0 ? \'-\' : (parseToNegativeList(\'total_payment_gateway\') | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegativeList(\'total_payment_gateway\')==0 ? \'-\' : (parseToNegativeList(\'total_payment_gateway\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">-E-Wallet In</td><td>{{parseToNegativeList(\'d_ewallet\')==0 ? \'-\' : (parseToNegativeList(\'d_ewallet\') | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegativeList(\'d_ewallet\')==0 ? \'-\' : (parseToNegativeList(\'d_ewallet\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">-Telco</td><td>{{parseToNegativeList(\'telco\')==0 ? \'-\' : (parseToNegativeList(\'telco\') | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegativeList(\'telco\')==0 ? \'-\' : (parseToNegativeList(\'telco\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">-Crypto</td><td>{{parseToNegativeList(\'crypto\')==0 ? \'-\' : (parseToNegativeList(\'crypto\') | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegativeList(\'crypto\')==0 ? \'-\' : (parseToNegativeList(\'crypto\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="text-align: left">-TNG Pin</td><td>{{parseToNegativeList(\'tng_pin\')==0 ? \'-\' : (parseToNegativeList(\'tng_pin\') | currency: \'\')}}</td><td ng-if="isAdmin">{{parseToNegativeList(\'tng_pin\')==0 ? \'-\' : (parseToNegativeList(\'tng_pin\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">+Payment Gateway Out</td><td>{{getTotalGameOf(\'total_pg_out\')==0 ? \'-\' : (getTotalGameOf(\'total_pg_out\') | currency: \'\')}}</td><td ng-if="isAdmin">{{getTotalGameOf(\'total_pg_out\')==0 ? \'-\' : (getTotalGameOf(\'total_pg_out\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">+Payment Gateway In Charges {{getPGInRate()}}</td><td>{{getTotalGameOf(\'pg_charge\')==0 ? \'-\' : (getTotalGameOf(\'pg_charge\') | currency: \'\')}}</td><td ng-if="isAdmin">{{getTotalGameOf(\'pg_charge\')==0 ? \'-\' : (getTotalGameOf(\'pg_charge\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">+Payment Gateway Out Charges {{getPGOutRate()}}</td><td>{{getTotalGameOf(\'pg_out_charge\')==0 ? \'-\' : (getTotalGameOf(\'pg_out_charge\') | currency: \'\')}}</td><td ng-if="isAdmin">{{getTotalGameOf(\'pg_out_charge\')==0 ? \'-\' : (getTotalGameOf(\'pg_out_charge\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">+E-Wallet In {{getEwalletRate()}}</td><td>{{getTotalGameOf(\'d_ewallet_charge\')==0 ? \'-\' : (getTotalGameOf(\'d_ewallet_charge\') | currency: \'\')}}</td><td ng-if="isAdmin">{{getTotalGameOf(\'d_ewallet_charge\')==0 ? \'-\' : (getTotalGameOf(\'d_ewallet_charge\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr style="color: red"><td style="text-align: left">+Tng Pin In {{getTngPinRate()}}</td><td>{{getTotalGameOf(\'tng_pin_charge\')==0 ? \'-\' : (getTotalGameOf(\'tng_pin_charge\') | currency: \'\')}}</td><td ng-if="isAdmin">{{getTotalGameOf(\'tng_pin_charge\')==0 ? \'-\' : (getTotalGameOf(\'tng_pin_charge\') | currency: \'\')}}</td><td ng-if="isAdmin"></td></tr><tr><td style="border-top: 1px solid; border-bottom: 1px solid"></td><td style="border-top: 1px solid; border-bottom: 1px solid">{{getTotalEarnCharge()==0 ? \'-\' : (getTotalEarnCharge() | currency: \'\')}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin">{{getTotalEarnCharge()==0 ? \'-\' : (getTotalEarnCharge() | currency: \'\')}}</td><td style="border-top: 1px solid; border-bottom: 1px solid" ng-if="isAdmin"></td></tr><tr ng-repeat="wanziItem in wanziList"><td style="text-align: left">{{wanziItem.playtechid || \'\'}} {{wanziItem.wanzi_remarks}}</td><td>{{wanziItem.wanzi && wanziItem.wanzi !== 0 ? (wanziItem.wanzi | currency: \'\') : \'-\'}}</td><td ng-if="isAdmin">-</td><td ng-if="isAdmin"></td></tr><tr style="height: 25px"><td></td><td></td><td ng-if="isAdmin"></td><td ng-if="isAdmin"></td></tr><tr style="font-weight: bold; background-color: yellow; border-top: 1px solid yellow;"><td style="text-align: left">Amount collect/pay to partner</td><td>{{getFinalTotalEarn()==0 ? \'-\' : (getFinalTotalEarn() | currency: \'\')}}</td><td ng-if="isAdmin">{{getFinalTotalCharge()==0 ? \'-\' : (getFinalTotalCharge() | currency: \'\')}}</td><td ng-if="isAdmin">{{getFinalTotalPR()==0 ? \'-\' : (getFinalTotalPR() | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoiceOnlineBackup.html','<span ng-if="onlineInvoiceDetails.NP.length > 0"><div class="row"><div class="col-sm-12"><h5>Net Purchase</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NP</th><th class="text-center">P/S(-)</th><th class="text-center">AP P/S(-)</th><th class="text-center">P/W(+)</th><th class="text-center">AP P/W(+)</th><th class="text-center">Sales</th><th class="text-center">Bonus Bet(+)</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Bank(+)</th><th class="text-center">Bank.C(+)</th><th class="text-center">D.Ewallet(+)</th><th class="text-center">D.Ewallet.C(+)</th><th class="text-center">D.CC(+)</th><th class="text-center">D.CC.C(+)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NP" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\')}}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.total_payment_gateway==0?\'-\':(item.total_payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet_charge==0?\'-\':(item.d_ewallet_charge | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.d_cc_charge==0?\'-\':(item.d_cc_charge | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{getCsales(item) | currency: \'\'}}</td><td class="align-right" rowspan="{{onlineInvoiceDetails.NP.length}}" ng-hide="$index>0"><span ng-if="total.NP_net_collect != 0">{{ total.NP_net_collect | currency: \'\' }}</span> <span ng-if="total.NP_net_collect == 0">-</span></td></tr></tbody></table></span> <span ng-if="onlineInvoiceDetails.NG.length > 0"><br><br><div class="row"><div class="col-sm-12"><h5>Net Gaming</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NG</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">P/S(+)</th><th class="text-center">AP P/S(+)</th><th class="text-center">P/W(-)</th><th class="text-center">AP P/W(-)</th><th class="text-center">Bonus Bet</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Partner Bonus Bet(+)</th><th class="text-center">Bank(-)</th><th class="text-center">Bank.C(+)</th><th class="text-center">Bank Out(+)</th><th class="text-center">Bank Out.C(+)</th><th class="text-center">D.Ewallet(-)</th><th class="text-center">D.Ewallet.C(+)</th><th class="text-center">D.CC(-)</th><th class="text-center">D.CC.C(+)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NG" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netgaming==0?\'-\':(item.netgaming | currency: \'\')}}</td><td class="align-right">{{getCsales(item) | currency: \'\'}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\') }}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\') }}</td><td class="align-right">{{item.bonus_bet==0?\'-\':(item.bonus_bet | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.total_payment_gateway==0?\'-\':(item.total_payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.total_pg_out==0?\'-\':(item.total_pg_out | currency: \'\')}}</td><td class="align-right">{{item.pg_out_charge==0?\'-\':(item.pg_out_charge | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet_charge==0?\'-\':(item.d_ewallet_charge | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.d_cc_charge==0?\'-\':(item.d_cc_charge | currency: \'\')}}</td><td class="align-right">{{item.net_collect==0?\'-\':(item.net_collect | currency: \'\')}}</td></tr></tbody></table></span><br><br><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Net Collect</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect) | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/dailyinvoicesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Filter by selected date</label><ui-select ng-model="reportFilter.showByDate" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="opt in showByDateOpt | filter: $select.search"><span ng-bind-html="opt.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Filter Shop Invoicing</label><select class="form-control selectpicker show-tick" title="Invoicing" selectpicker="" ng-model="reportFilter.allowInvocing" ng-options="item as item.label for item in shopInvoicingOptions track by item.id"></select></div><div class="col-sm-2" ng-if="allowToViewShopCategory"><label>Shop Category</label><ui-select ng-model="reportFilter.categoryid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="cat in shopCategory | filter: $select.search"><span ng-bind-html="cat.name"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><div class="form-group row clearfix"><div class="col-sm-12"><label>Invoice Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.upload" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchAllinvoices(reportFilter)" ng-disabled="loading.searching">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button ng-disabled="loading.searching" type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-warning" ng-click="paidSelectedInvoices()">Paid Invoices</button></div></div></div><hr><table-column-toolbar column-list="columnList" storage-key="\'dailyInvoices\'" on-changed="onColumnToolbarChange($value)"></table-column-toolbar><table-scroller-bar></table-scroller-bar><table sticky-columns="" class="table table-striped table-condensed" st-safe-src="manageDailyinvoicesList" st-table="manageDailyinvoices"><thead sticky-on-scroll="" ng-if="triggerManuallyHeader"><tr class="hide-on-sticky"><th colspan="{{colspanSection.info}}" ng-show="colspanSection.info > 0"></th><th ng-show="colspanSection.daily > 0" style="background-color: #ffb179; color: black; text-align: center" colspan="{{colspanSection.daily}}">DAILY</th><th colspan="{{colspanSection.other}}" ng-show="colspanSection.other > 0"></th><th ng-show="colspanSection.monthly > 0" style="background-color: #ffb179; color: black; text-align: center" colspan="{{colspanSection.monthly}}">MONTHLY (Company)</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th></th><th st-sort="shopcode" ng-hide="hideTableColumns.shopcode" sticky="true">Shop Code</th><th st-sort="shopname" ng-hide="hideTableColumns.shopname" sticky="true">Shop Name</th><th st-sort="onrate" ng-hide="hideTableColumns.onrate" sticky="true">Shop Rate</th><th st-sort="partnername" ng-hide="hideTableColumns.partnername" sticky="true">Partner</th><th ng-hide="hideTableColumns.receipts">Receipts</th><th>Action</th><th st-sort="cafeanddarts" class="bg-light-yellow" ng-hide="hideTableColumns.cafedart">Cafe & Darts</th><th st-sort="snooker" class="bg-light-yellow" ng-hide="hideTableColumns.snooker">Snooker</th><th st-sort="monthly_snooker" class="bg-light-yellow" ng-hide="hideTableColumns.monthly_snooker">Monthly Snooker</th><th st-sort="pshare" class="bg-light-grey" ng-hide="hideTableColumns.pshare">PS</th><th st-sort="appshare" class="bg-light-grey" ng-hide="hideTableColumns.apshare">AP PS</th><th st-sort="pwin" class="bg-light-grey" ng-hide="hideTableColumns.pw">PW</th><th st-sort="apwin" class="bg-light-grey" ng-hide="hideTableColumns.apw">AP PW</th><th st-sort="rewards" class="bg-light-grey" ng-hide="hideTableColumns.rewards">Rewards</th><th st-sort="netgaming" class="bg-light-grey" ng-hide="hideTableColumns.netgaming">NG</th><th st-sort="net_collect" class="bg-info" style="color: black" ng-hide="hideTableColumns.net_collect">Cash Collect</th><th st-sort="total_payment_gateway" class="bg-info" style="color: black" ng-hide="hideTableColumns.total_payment_gateway">Bank In</th><th st-sort="total_pg_out" class="bg-info" style="color: black" ng-hide="hideTableColumns.total_pg_out">Bank Out</th><th st-sort="d_ewallet" class="bg-info" style="color: black" ng-hide="hideTableColumns.d_ewallet">D.Ewallet</th><th st-sort="tng_pin_charge" class="bg-info" style="color: black" ng-hide="hideTableColumns.tng_pin_charge">Tng pin</th><th st-sort="d_cc" class="bg-info" style="color: black" ng-hide="hideTableColumns.d_cc">D.CC</th><th st-sort="" class="bg-light-blue" style="color: black" ng-hide="hideTableColumns.sales">Sales</th><th st-sort="serverpr" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.serverpr">Server</th><th st-sort="claim" class="bg-light-purple" style="color: black" ng-hide="hideTableColumns.claim">Claim</th><th st-sort="" class="bg-light-yellow" style="color: black" ng-hide="hideTableColumns.total">Total</th><th style="min-width: 120px" st-sort="localPaidStatus" ng-hide="hideTableColumns.localPaidStatus">Paid Status</th><th st-sort="pdate" ng-hide="hideTableColumns.pdate">Paid Date</th><th st-sort="agentid" ng-hide="hideTableColumns.agentid">Agent</th><th st-sort="monthly_snooker" class="bg-light-yellow" style="color: black" ng-hide="hideTableColumns.monthly_snooker">Snooker</th><th st-sort="last_monthly_snooker" class="bg-light-yellow" style="color: black" ng-hide="hideTableColumns.last_monthly_snooker">Last Monthly Snooker</th><th st-sort="monthly_pwin" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.monthly_pwin">PW</th><th st-sort="monthly_apwin" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.monthly_apwin">AP PW</th><th st-sort="monthly_bonus_win" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.monthly_bonus_win">B.Wins</th><th st-sort="monthly_netgaming" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.monthly_netgaming">NG</th><th st-sort="monthly_net_collect" class="bg-info" style="color: black" ng-hide="hideTableColumns.monthly_net_collect">Cash Collect</th><th st-sort="total_monthly_payment_gateway" class="bg-info" style="color: black" ng-hide="hideTableColumns.total_monthly_payment_gateway">Bank In</th><th st-sort="total_monthly_pg_out" class="bg-info" style="color: black" ng-hide="hideTableColumns.total_monthly_pg_out">Bank Out</th><th st-sort="monthly_d_ewallet" class="bg-info" style="color: black" ng-hide="hideTableColumns.monthly_d_ewallet">D.Ewallet</th><th st-sort="monthly_tng_pin_charge" class="bg-info" style="color: black" ng-hide="hideTableColumns.monthly_tng_pin_charge">Tng pin</th><th st-sort="monthly_d_cc" class="bg-info" style="color: black" ng-hide="hideTableColumns.monthly_d_cc">D.CC</th><th st-sort="" class="bg-light-blue" style="color: black" ng-hide="hideTableColumns.monthly_sales">Monthly Sales</th><th st-sort="monthly_serverpr" class="bg-light-grey" style="color: black" ng-hide="hideTableColumns.monthly_serverpr">Server</th><th st-sort="monthly_claim" class="bg-light-purple" style="color: black" ng-hide="hideTableColumns.monthly_claim">Claim</th><th st-sort="" style="color: black" class="bg-light-yellow" ng-hide="hideTableColumns.monthly_total">Total</th><th st-sort="" style="color: black" class="bg-light-orange" ng-hide="hideTableColumns.last_monthly_sales">Last Monthly Sales</th></tr><tr><th></th><th><input type="checkbox" id="inlineCheckbox" ng-model="billChecker.checkAll" ng-click="onCheckBoxChange(null, manageDailyinvoices)"></th><th ng-hide="hideTableColumns.shopcode"><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.shopname"><input st-search="shopname" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.onrate"><input st-search="onrate" placeholder="Shop Rate" class="input-sm form-control search-input" type="search"></th><th ng-hide="hideTableColumns.partnername"><input st-search="partnername" placeholder="Partner" class="input-sm form-control search-input" type="search"></th><td ng-hide="hideTableColumns.receipts"></td><td></td><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.cafedart">{{getTotalCafeAndDarts(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.snooker">{{getTotalSnooker(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_snooker">{{getTotalMonthlySnooker(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.pshare">{{getTotalPShare(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.apshare">{{getTotalAPShare(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.pw">{{getTotalPWin(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.apw">{{getTotalAPWin(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.rewards">{{getTotalRewards(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.netgaming">{{getTotalNetGaming(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.net_collect">{{getTotalNetCollect(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total_payment_gateway">{{getTotalBank(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total_pg_out">{{getTotalBankOut(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.d_ewallet">{{getTotalDEwallet(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.tng_pin_charge">{{getTotaTngPin(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.d_cc">{{getTotalDCC(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.sales">{{getTotaltotalsales(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.serverpr">{{getTotal(manageDailyinvoices, \'serverpr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.claim">0.00</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total">{{getTotalTotalServerSales(manageDailyinvoices) | currency:\'\'}}</th><th style="margin-left: 2px" ng-hide="hideTableColumns.localPaidStatus"><select st-search="localPaidStatus" class="input-sm form-control search-input"><option value="">All</option><option ng-repeat="status in paidStatusList | unique:\'localPaidStatus\'" value="{{status.value}}">{{status.value}}</option></select></th><th ng-hide="hideTableColumns.pdate"></th><th ng-hide="hideTableColumns.agentid"></th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_snooker">{{getTotal(manageDailyinvoices, \'monthly_snooker\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.last_monthly_snooker">{{getTotal(manageDailyinvoices, \'last_monthly_snooker\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_pwin">{{getTotal(manageDailyinvoices, \'monthly_pwin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_apwin">{{getTotal(manageDailyinvoices, \'monthly_apwin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_bonus_win">{{getTotal(manageDailyinvoices, \'monthly_bonus_win\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_netgaming">{{getTotal(manageDailyinvoices, \'monthly_netgaming\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_net_collect">{{getTotal(manageDailyinvoices, \'monthly_net_collect\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total_monthly_payment_gateway">{{getTotal(manageDailyinvoices, \'total_monthly_payment_gateway\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total_monthly_pg_out">{{getTotal(manageDailyinvoices, \'total_monthly_pg_out\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_d_ewallet">{{getTotal(manageDailyinvoices, \'monthly_d_ewallet\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_tng_pin_charge">{{getTotal(manageDailyinvoices, \'monthly_tng_pin_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_d_cc">{{getTotal(manageDailyinvoices, \'monthly_d_cc\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_sales">{{getTotalMOnthlySales(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_serverpr">{{getTotal(manageDailyinvoices, \'monthly_serverpr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_claim">0.00</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.monthly_total">{{getMonthlyTotalServersales(manageDailyinvoices) | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.last_monthly_sales">{{getLastTotalMOnthlySales(manageDailyinvoices) | currency:\'\'}}</th></tr></thead><tbody><tr ng-if="loading.searching"><td colspan="13">Loading...</td><td colspan="14">Loading...</td><td colspan="12">Loading...</td><td colspan="12">Loading...</td></tr><tr ng-if="!loading.searching" ng-repeat="item in manageDailyinvoices" class="editable-row" ng-click="onCheckBoxChange(item.id)" ng-class="{\'bg-light-blue \' : !!billChecker[item.id]}"><td class="table-id">{{$index+1}}</td><td><input type="checkbox" id="inlineCheckbox03" ng-model="billChecker[item.id]" disabled=""></td><td ng-hide="hideTableColumns.shopcode">{{item.shopcode}}</td><td ng-hide="hideTableColumns.shopname">{{item.shopname}}</td><td ng-hide="hideTableColumns.onrate">{{item.onrate}}</td><td ng-hide="hideTableColumns.partnername">{{item.partnername}}</td><td ng-hide="hideTableColumns.receipts"><div class="button" style="padding: 8px 0"><button ng-click="viewPaidReceipt($event, receipt)" ng-repeat="receipt in item.receipts" class="btn btn-info btn-xs" style="display: block; margin-bottom: 3px">{{receipt.orno}}</button></div></td><td><form editable-form="" name="rowform" onbeforesave="saveInvoice($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button ng-disabled="!item.isToday" class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button> &nbsp; <button ng-if="userData.roleId != 3" class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-if="!item.ispaid && userData.roleId != 3" class="btn btn-info editable-table-button btn-xs" ng-click="paidSelectedInvoices(item)">Pay Now</button></div></td><td ng-hide="hideTableColumns.cafedart" class="bg-light-yellow">{{item.cafeanddarts | currency: \'\'}}</td><td ng-hide="hideTableColumns.snooker" class="bg-light-yellow">{{item.snooker | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_snooker" class="bg-light-yellow">{{item.monthly_snooker | currency: \'\'}}</td><td ng-hide="hideTableColumns.pshare" class="bg-light-grey">{{item.pshare | currency: \'\'}}</td><td ng-hide="hideTableColumns.apshare" class="bg-light-grey">{{item.apshare | currency: \'\'}}</td><td ng-hide="hideTableColumns.pw" class="bg-light-grey">{{item.pwin | currency: \'\'}}</td><td ng-hide="hideTableColumns.apw" class="bg-light-grey">{{item.apwin | currency: \'\'}}</td><td ng-hide="hideTableColumns.rewards" class="bg-light-grey">{{item.rewards | currency: \'\'}}</td><td ng-hide="hideTableColumns.netgaming" class="bg-light-grey">{{item.netgaming | currency: \'\'}}</td><td ng-hide="hideTableColumns.net_collect" class="bg-info" style="color: black">{{item.net_collect | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_payment_gateway" class="bg-info" style="color: black">{{item.total_payment_gateway | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_pg_out" class="bg-info" style="color: black">{{item.total_pg_out | currency: \'\'}}</td><td ng-hide="hideTableColumns.d_ewallet" class="bg-info" style="color: black">{{item.d_ewallet | currency: \'\'}}</td><td ng-hide="hideTableColumns.tng_pin_charge" class="bg-info" style="color: black">{{item.tng_pin_charge | currency: \'\'}}</td><td class="bg-info" style="color: black" ng-hide="hideTableColumns.d_cc">{{item.d_cc | currency: \'\'}}</td><td ng-hide="hideTableColumns.sales" class="bg-light-blue" style="color: black">{{ getSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.serverpr" class="bg-light-grey" style="color: black">{{item.serverpr | currency: \'\'}}</td><td ng-hide="hideTableColumns.claim" class="bg-light-purple" style="color: black">{{0.00 | currency: \'\'}}</td><td ng-hide="hideTableColumns.total" class="bg-light-yellow" style="color: black">{{getServerSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.localPaidStatus" ng-class="{\'bg-success\':item.localPaidStatus === \'PAID\',\'bg-danger\':item.localPaidStatus === \'UNPAY\', \'bg-warning\': item.localPaidStatus === \'PARTIALLY PAY\' }" style="color: black">{{item.localPaidStatus}}</td><td ng-hide="hideTableColumns.pdate">{{item.pdate | date: \'dd/MM/yyyy\'}}</td><td ng-hide="hideTableColumns.agentid">{{showUserById(item.agentid)}}</td><td ng-hide="hideTableColumns.monthly_snooker" class="bg-light-yellow" style="color: black">{{item.monthly_snooker | currency: \'\'}}</td><td ng-hide="hideTableColumns.last_monthly_snooker" class="bg-light-yellow" style="color: black">{{item.last_monthly_snooker | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_pwin" class="bg-light-grey" style="color: black">{{item.monthly_pwin | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_apwin" class="bg-light-grey" style="color: black">{{item.monthly_apwin | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_bonus_win" class="bg-light-grey" style="color: black">{{item.monthly_bonus_win | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_netgaming" class="bg-light-grey" style="color: black">{{item.monthly_netgaming | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_net_collect" class="bg-info" style="color: black">{{item.monthly_net_collect | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_monthly_payment_gateway" class="bg-info" style="color: black">{{item.total_monthly_payment_gateway | currency: \'\'}}</td><td ng-hide="hideTableColumns.total_monthly_pg_out" class="bg-info" style="color: black">{{item.total_monthly_pg_out | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_d_ewallet" class="bg-info" style="color: black">{{item.monthly_d_ewallet | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_tng_pin_charge" class="bg-info" style="color: black">{{item.monthly_tng_pin_charge | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_d_cc" class="bg-info" style="color: black">{{item.monthly_d_cc | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_sales" class="bg-light-blue" style="color: black">{{getMonthlySales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_serverpr" class="bg-light-grey" style="color: black">{{item.monthly_serverpr | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_claim" class="bg-light-purple" style="color: black">{{0.00 | currency: \'\'}}</td><td ng-hide="hideTableColumns.monthly_total" class="bg-light-yellow" style="color: black">{{getMonthlyServerSales(item) | currency: \'\'}}</td><td ng-hide="hideTableColumns.last_monthly_sales" style="color: black" class="bg-light-orange">{{getLastMonthlySales(item) | currency: \'\'}}</td></tr><tr ng-if="totalSalesLabelFooter!=0"><td></td><td></td><td ng-hide="hideTableColumns.shopcode"></td><td ng-hide="hideTableColumns.shopname"></td><td ng-hide="hideTableColumns.onrate"></td><td ng-hide="hideTableColumns.partnername"></td><td ng-hide="hideTableColumns.receipts"></td><td></td><td ng-hide="hideTableColumns.cafedart" style="background-color: chocolate; color: black">{{getTotalCafeAndDarts(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.snooker" style="background-color: chocolate; color: black">{{getTotalSnooker(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.monthly_snooker" style="background-color: chocolate; color: black">{{getTotalMonthlySnooker(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.pshare" style="background-color: chocolate; color: black">{{getTotalPShare(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.apshare" style="background-color: chocolate; color: black">{{getTotalAPShare(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.pw" style="background-color: chocolate; color: black">{{getTotalPWin(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.apw" style="background-color: chocolate; color: black">{{getTotalAPWin(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.rewards" style="background-color: chocolate; color: black">{{getTotalRewards(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.netgaming" style="background-color: chocolate; color: black">{{getTotalNetGaming(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.net_collect" style="background-color: chocolate; color: black">{{getTotalNetCollect(manageDailyinvoices) | currency:\'\'}}</td><td ng-hide="hideTableColumns.total_payment_gateway" style="background-color: chocolate; color: black">{{getTotalBank(manageDailyinvoices) | currency:\'\'}}</td><th ng-hide="hideTableColumns.total_pg_out" style="background-color: chocolate; color: black">{{getTotalBankOut(manageDailyinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.d_ewallet" style="background-color: chocolate; color: black">{{getTotalDEwallet(manageDailyinvoices) | currency:\'\'}}</th><td ng-hide="hideTableColumns.tng_pin_charge" style="background-color: chocolate; color: black">{{getTotaTngPin(manageDailyinvoices) | currency:\'\'}}</td><th ng-hide="hideTableColumns.d_cc" style="background-color: chocolate; color: black">{{getTotalDCC(manageDailyinvoices) | currency:\'\'}}</th><td ng-hide="hideTableColumns.sales" style="background-color: chocolate; color: black">{{getTotaltotalsales(manageDailyinvoices) | currency:\'\'}}</td><th ng-hide="hideTableColumns.serverpr" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'serverpr\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumns.total" style="background-color: chocolate; color: black">{{getTotalTotalServerSales(manageDailyinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.localPaidStatus"></th><th ng-hide="hideTableColumns.pdate"></th><th ng-hide="hideTableColumns.agentid"></th><th ng-hide="hideTableColumns.monthly_snooker" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_snooker\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.last_monthly_snooker" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'last_monthly_snooker\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_pwin" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_pwin\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_apwin" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_apwin\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_bonus_win" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_bonus_win\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_netgaming" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_netgaming\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_net_collect" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_net_collect\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black" ng-hide="hideTableColumns.total_monthly_payment_gateway">{{getTotal(manageDailyinvoices, \'total_monthly_payment_gateway\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.total_monthly_pg_out" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'total_monthly_pg_out\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_d_ewallet" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_d_ewallet\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_tng_pin_charge" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_tng_pin_charge\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_d_cc" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_d_cc\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_sales" style="background-color: chocolate; color: black">{{getTotalMOnthlySales(manageDailyinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_serverpr" style="background-color: chocolate; color: black">{{getTotal(manageDailyinvoices, \'monthly_serverpr\') | currency:\'\'}}</th><th ng-hide="hideTableColumns.monthly_claim" style="background-color: chocolate; color: black">0.00</th><th ng-hide="hideTableColumns.monthly_total" style="background-color: chocolate; color: black">{{getMonthlyTotalServersales(manageDailyinvoices) | currency:\'\'}}</th><th ng-hide="hideTableColumns.last_monthly_sales" style="background-color: chocolate; color: black">{{getLastTotalMOnthlySales(manageDailyinvoices) | currency:\'\'}}</th></tr></tbody><tfoot><tr><td colspan="{{colspanSection.total}}" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/invoices/dailyinvoices/widgets/invoice_for_rate_100.html','<span ng-if="onlineInvoiceDetails.NP.length > 0"><div class="row"><div class="col-sm-12"><h5>Net Purchase</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">Playtech</th><th class="text-center">\u4E07\u5B57\u6536</th><th class="text-center">\u516C\u53F8\u4F63\u91D1</th><th class="text-center">NP</th><th class="text-center">Bank(+)</th><th class="text-center">Bank Out(-)</th><th class="text-center">D.Ewallet(+)</th><th class="text-center">D.CC(+)</th><th class="text-center">TNG (+)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Net Collect</th><th class="text-center">Sales</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NP" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.playtechid}}</td><td class="align-right">{{item.wanzi==0 ? \'-\' : (item.wanzi | currency: \'\')}}</td><td class="align-right">{{(item.wanzi_com==0 || !item.wanzi_com)? \'-\' : (item.wanzi_com | currency: \'\')}}</td><td class="align-right">{{item.netpurchase==0?\'-\':(item.netpurchase | currency: \'\')}}</td><td class="align-right">{{item.total_payment_gateway==0?\'-\':(item.total_payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.total_pg_out==0?\'-\':(item.total_pg_out | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.tng_pin==0?\'-\':(item.tng_pin | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td class="align-right">{{item.net_collect==0?\'-\':(item.net_collect | currency: \'\')}}</td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td></tr></tbody></table></span> <span ng-if="onlineInvoiceDetails.NG.length > 0"><br><br><div class="row"><div class="col-sm-12"><h5>Net Gaming</h5></div></div><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Online</th><th class="text-center">NG</th><th class="text-center">Company ({{shopInvoiceDetails.onrate}}%)</th><th class="text-center">Shop ({{100-shopInvoiceDetails.onrate}}%)</th><th class="text-center">P/S(+)</th><th class="text-center">AP P/S(+)</th><th class="text-center">P/W(-)</th><th class="text-center">AP P/W(-)</th><th class="text-center">Bonus Bet</th><th class="text-center">Bonus Win(-)</th><th class="text-center">Partner Bonus Bet(+)</th><th class="text-center">Bank(-)</th><th class="text-center">Bank.C(+)</th><th class="text-center">D.Ewallet(-)</th><th class="text-center">D.Ewallet.C(+)</th><th class="text-center">D.CC(-)</th><th class="text-center">D.CC.C(+)</th><th class="text-center">Net Collect</th></tr></thead><tbody><tr ng-repeat="item in onlineInvoiceDetails.NG" class="editable-tr-wrap"><td>{{item.game.name}}</td><td class="align-right">{{item.netgaming==0?\'-\':(item.netgaming | currency: \'\')}}</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}</td><td class="align-right">{{item.pshare==0?\'-\':(item.pshare | currency: \'\') }}</td><td class="align-right">{{item.apshare==0?\'-\':(item.apshare | currency: \'\') }}</td><td class="align-right">{{item.pwin==0?\'-\':(item.pwin | currency: \'\') }}</td><td class="align-right">{{item.apwin==0?\'-\':(item.apwin | currency: \'\') }}</td><td class="align-right">{{item.bonus_bet==0?\'-\':(item.bonus_bet | currency: \'\')}}</td><td class="align-right">{{item.bonus_win==0?\'-\':(item.bonus_win | currency: \'\')}}</td><td class="align-right">{{item.p_bonus_bets==0?\'-\':(item.p_bonus_bets | currency: \'\')}}</td><td class="align-right">{{item.total_payment_gateway==0?\'-\':(item.total_payment_gateway | currency: \'\')}}</td><td class="align-right">{{item.pg_charge==0?\'-\':(item.pg_charge | currency: \'\')}}</td><td class="align-right">{{item.d_ewallet==0?\'-\':(item.d_ewallet | currency: \'\')}}</td><td class="align-right">{{item.d_wallet_charge==0?\'-\':(item.d_wallet_charge | currency: \'\')}}</td><td class="align-right">{{item.d_cc==0?\'-\':(item.d_cc | currency: \'\')}}</td><td class="align-right">{{item.d_cc_charge==0?\'-\':(item.d_cc_charge | currency: \'\')}}</td><td class="align-right">{{item.net_collect==0?\'-\':(item.net_collect | currency: \'\')}}</td></tr></tbody></table></span><br><br><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Net Collect</th><th class="align-right">{{ (total.NG_net_collect + total.NP_net_collect) | currency: \'\'}}</th></tr></thead></table></div></div><br><div class="row"><div class="col-md-8" print-remove=""></div><div class="col-md-4"><table id="dotMatrix" class="table" style="border: 1px solid gainsboro" cellpadding="0" cellspacing="0" border="1"><thead><tr><th class="align-right">Total Sales</th><th class="align-right">{{ (total.NP_totalsales) | currency: \'\'}}</th></tr></thead></table></div></div>');
$templateCache.put('app/pages/invoices/shopcategory/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this shop category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/invoices/shopcategory/widgets/shopCategoryTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-5 col-sm-3"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,15,31]"></select></div><div class="col-5 col-sm-3"><label>Month</label><ui-select ng-model="reportFilter.month" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices style="color: black" repeat="month in months | filter: $select.search"><span ng-bind-html="month.label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getShopCategoryInvoice()">Search</button></div></div></div><hr><br><table class="table table-striped table-condensed" st-safe-src="dates" st-table="manageDates"><thead sticky-on-scroll=""><tr class="sortable" style="background-color: #bae0ff"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Date</th><th style="text-transform: capitalize" ng-repeat="cat in categories">{{cat.name}} ({{cat.shopcount}})</th></tr><tr><th></th><th></th><th ng-repeat="cat in categories" style="background-color: chocolate; color: black">{{ total[cat.id] | currency:\'\'}}</th></tr></thead><tbody><tr ng-repeat="item in manageDates"><td class="table-id">{{$index+1}}</td><td>{{ item.label || \'empty\'}}</td><td ng-repeat="cat in categories">{{data[item.value][cat.id] | currency: \'\'}}</td></tr></tbody><tfoot><tr><td colspan="18" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/machine/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/machine/dailymachineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineView.html','<table class="table table-bordered"><thead><tr><th>Machine</th><th class="align-right">New Meter</th><th class="align-right">Previous Meter</th><th class="align-right">Difference</th><th class="align-right">Sales</th><th class="align-right">Shop</th><th class="align-right">Company</th></tr></thead><tbody><tr ng-repeat="item in machineSalesDetails"><td>{{item.mid}}</td><td class="align-right">{{item.cmIn}}<br>{{item.cmOut}}<br>{{item.bmIn}}<br>{{item.bmOut}}<br></td><td class="align-right">{{item.cmInP}}<br>{{item.cmOutP}}<br>{{item.bmInP}}<br>{{item.bmOutP}}<br></td><td class="align-right">{{item.cmIn - item.cmInP}}<br>{{item.cmOut - item.cmOutP}}<br>{{item.bmIn - item.bmInP}}<br>{{item.bmOut - item.bmOutP}}<br></td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}} ({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales | currency: \'\'}} ({{item.machineshop.macrate}}%)</td></tr></tbody></table>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineshopLevel2.html','<div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{salesNumbers.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{salesNumbers.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Machine Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/machine/dailymachineshop/widgets/dailymachineView.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="getDailyGroupedMachinesales(reportFilter)">Close</button>');
$templateCache.put('app/pages/machine/dailymachineshop/widgets/dailymachineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyGroupedMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div><div class="col-sm-2"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales :</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageDailymachineshopList" st-table="manageDailymachineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop Code</th><th st-sort="shop.name">Shop Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="group in manageDailymachineshop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="group.code" e-name="code" e-form="rowform" e-required="">{{ group.code || \'empty\'}}</span></td><td><span editable-text="group.name" e-name="name" e-form="rowform" e-required="">{{ group.name || \'empty\' }}</span></td><td><span editable-text="group.csales" e-name="csales" e-form="rowform" e-required="">{{ group.csales | currency:\'\' }}</span></td><td><span editable-text="group.psales" e-name="psales" e-form="rowform" e-required="">{{ group.psales | currency:\'\'}}</span></td><td><span editable-text="group.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ group.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(group)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/machine/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/importofficers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Officer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/importofficers/widgets/importofficersTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageImportofficers.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName +"("+$select.selected.credentials.mobile+")"}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName + \'(\'+user.credentials.mobile+\')\'"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/msync/importofficers/widgets/officerUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageImportofficersList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="post">Pangkat</th><th st-sort="name">Officer Name</th><th st-sort="rate">Amount 1</th><th st-sort="rate1">Amount 2</th><th st-sort="department">Bahagian</th><th st-sort="area">Daerah</th><th st-sort="balai">Balai</th><th></th><th>Action</th></tr><tr><th></th><th><input st-search="post" placeholder="Search Post" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Office Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageImportofficersList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.post" e-name="post" e-form="rowform" e-required="">{{ item.post || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{item.name || \'empty\' }}</span></td><td><span editable-text="item.rate" e-name="rate" e-form="rowform" e-required="">{{item.rate || \'0\' }}</span></td><td><span editable-text="item.rate1" e-name="rate1" e-form="rowform" e-required="">{{item.rate1 || \'0\' }}</span></td><td><span editable-text="item.department" e-name="department" e-form="rowform" e-required="">{{item.department ||\'empty\' }}</span></td><td><span editable-text="item.area" e-name="area" e-form="rowform" e-required="">{{item.area || \'empty\' }}</span></td><td><span editable-text="item.balai" e-name="balai" e-form="rowform" e-required="">{{item.balai || \'empty\' }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/msync/officers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Officer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/officers/widgets/officersTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageOfficer.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName +"("+$select.selected.credentials.mobile+")"}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName + \'(\'+user.credentials.mobile+\')\'"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOfficers(manageOfficer.user.id)">Search</button></div></div><div class="col-sm-3"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Amount 1:</strong></label> <label class="col-md-4 control-label">{{totalAmount.toFixed(2) | currency:\'\'}}</label></div></div><div class="col-sm-3"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Total Amount 2:</strong></label> <label class="col-md-4 control-label">{{totalAmount1.toFixed(2) | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped" st-safe-src="manageOfficersList" st-table="manageOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate || \'empty\' }}</span></td><td><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 || \'empty\' }}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.zoneid" e-name="zoneid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageZoneList | orderBy: \'name\'">{{ getZoneId(item.zoneid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOfficer($data,item.id,item.ownerid)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/dailyonlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/dailyonlinesales/widgets/dailyonlinesalesTable.html','<div class="horizontal-scroll" style="overflow-x: hidden"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-3"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-disabled="loading.searching" ng-click="getDailyOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" ng-disabled="loading.searching" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><div class="form-group row clearfix"><div class="col-sm-12"><label>Invoice Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.upload" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-3"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-disabled="loading.generateInvocing" ng-click="genIvoiceOnlinesales()">Generate Invoice</button></div></div><div class="col-sm-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales :</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div><div></div><div class="alert bg-info">B.Bets = Bonus Bets&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; B.Wins = Bonus Wins &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; P.B.Bets = Partner Bonus Bets &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div><div style="transform: rotateX(180deg); overflow-x: auto"><table sticky-columns="" style="transform: rotatex(180deg)" class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead sticky-on-scroll=""><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid" sticky="true">Kiosk</th><th st-sort="code" sticky="true">Shop</th><th st-sort="gamename" sticky="true">Game</th><th st-sort="ikey" sticky="true">Upload Date</th><th st-sort="cafeanddarts">Cafe & Darts</th><th st-sort="snooker">Snooker</th><th st-sort="snooker_fnb">Snooker F&B</th><th st-sort="kitchen">Kitchen</th><th st-sort="netgaming">NG</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="apshare">AP PS</th><th st-sort="pwin">PW</th><th st-sort="apwin">AP PW</th><th st-sort="rewards">Rewards</th><th st-sort="telco">Telco</th><th st-sort="crypto">Crypto</th><th st-sort="tng_pin">Tng Pin</th><th st-sort="tng_pin_charge">Tng Pin%</th><th st-sort="total_payment_gateway">Bank In</th><th st-sort="pg_charge">Bank In %</th><th st-sort="total_pgout">Bank Out</th><th st-sort="pg_out_charge">Bank Out %</th><th st-sort="d_ewallet">D.Ewallet</th><th st-sort="d_ewallet_charge">D.Ewallet %</th><th st-sort="d_cc">D.CC</th><th st-sort="d_cc_charge">D.CC %</th><th st-sort="pgsbonus">EVENT BONUS</th><th st-sort="bonus_bet">Token</th><th st-sort="bonus_win">Lucky Wins</th><th st-sort="p_bonus_bets">P.B.Bets</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="net_collect">Net Collect</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamename" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-if="loading.searching"><td colspan="17">Loading...</td><td colspan="17">Loading...</td><td colspan="16">Loading...</td></tr><tr ng-if="!loading.searching" ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.code || \'empty\'}}</td><td>{{ item.gamename || \'empty\' }}</td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ (item.cafeanddarts || 0) | currency:\'\'}}</td><td>{{ (item.snooker || 0) | currency:\'\'}}</td><td>{{ (item.snooker_fnb || 0) | currency:\'\'}}</td><td>{{ (item.kitchen || 0) | currency:\'\'}}</td><td>{{ item.netgaming | currency:\'\'}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.apshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td>{{ item.apwin | currency:\'\'}}</td><td>{{ item.rewards | currency:\'\'}}</td><td>{{ item.telco | currency:\'\'}}</td><td>{{ item.crypto | currency:\'\'}}</td><td>{{ item.tng_pin || \'0\' | currency:\'\'}}</td><td>{{ item.tng_pin_charge || \'0\' | currency:\'\'}}</td><td>{{ item.total_payment_gateway | currency:\'\'}}</td><td>{{ item.pg_charge | currency:\'\'}}</td><td>{{ item.total_pgout | currency:\'\'}}</td><td>{{ item.pg_out_charge | currency:\'\'}}</td><td>{{ item.d_ewallet | currency:\'\'}}</td><td>{{ item.d_ewallet_charge | currency:\'\'}}</td><td>{{ item.d_cc | currency:\'\'}}</td><td>{{ item.d_cc_charge | currency:\'\'}}</td><td>{{ item.pgsbonus | currency:\'\'}}</td><td>{{ item.bonus_bet | currency:\'\'}}</td><td>{{ item.bonus_win | currency:\'\'}}</td><td>{{ item.p_bonus_bets | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><span editable-text="item.net_collect" e-name="net_collect" e-form="rowform" e-required="">{{ item.net_collect | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="23" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/online/dailyonlineserver/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineserver/widgets/dailyonlineserverTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="selectedDetailList" st-table="detailList"><thead><tr><th colspan="4"></th><th style="background-color: #ffb179; color: black; text-align: center">Customer</th><th style="background-color: #79ffa9; color: black; text-align: center">PR</th><th style="background-color: #79c9ff; color: black; text-align: center">Server</th><th style="background-color: #ff7979; color: black; text-align: center" colspan="5">\u4EBA\u624B</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="gname">Game</th><th st-sort="gpname">Provider</th><th st-sort="gsname">Server Name</th><th st-sort="customer">Customer Fee</th><th st-sort="pr">PR</th><th st-sort="server">Server Fee</th><th st-sort="isserver">\u4EBA\u624BNG</th><th st-sort="rate">Rate(%)</th><th st-sort="istotal">Total</th><th st-sort="ischarge">Charge</th><th st-sort="isservertotal">Net Server Fee</th><th>Action</th></tr><tr><th></th><th><input st-search="gname" placeholder="Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="gpname" placeholder="Provider" class="input-sm form-control search-input" type="search"></th><th><input st-search="gsname" placeholder="Server" class="input-sm form-control search-input" type="search"></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'oscustomer\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'pr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'osserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'isserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'istotal\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'isservertotal\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th></tr></thead><tbody><tr ng-if="!selectedDetailList.length"><td colspan="10">No Data</td></tr><tr ng-repeat="item in detailList" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.gname }}</td><td>{{ item.gpname }}</td><td>{{ item.gsname}}</td><td>{{ item.oscustomer | currency:\'\'}}</td><td>{{ item.pr | currency:\'\'}}</td><td>{{ item.osserver | currency:\'\'}}</td><td><span editable-text="item.isserver" e-name="isserver" e-form="rowform" e-required="">{{ item.isserver | currency: \'\'}}</span></td><td>{{item.rate}}</td><td>{{item.istotal | currency: \'\'}}</td><td><span editable-text="item.ischarge" e-name="ischarge" e-form="rowform" e-required="">{{item.ischarge | currency: \'\'}}</span></td><td>{{item.isservertotal | currency: \'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveInputServer(item)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button></div></td></tr><tr ng-if="detailList.length"><th></th><th></th><th></th><th></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'oscustomer\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'pr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'osserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'isserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'istotal\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{getTotal(detailList, \'isservertotal\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/dailyonlineserver/widgets/dailyonlineserverbygameTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-primary" ng-click="getDailyOnlineServerByGame()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-info" ng-click="reset()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageDailyOnlineServerByGameList" st-table="manageDailyOnlineServerByGame"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="gname">Game</th><th st-sort="oscustomer">Total Customer Fee</th><th st-sort="pr">Total PR</th><th st-sort="osserver">Total Server Fee</th><th st-sort="isserver">Total Input Server Fee</th><th>Action</th></tr><tr><th></th><th><input st-search="gname" placeholder="Game" class="input-sm form-control search-input" type="search"></th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'oscustomer\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'pr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'osserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'isserver\') | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageDailyOnlineServerByGame" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.gname }}</td><td>{{item.oscustomer | currency: \'\'}}</td><td>{{item.pr | currency: \'\'}}</td><td>{{ item.osserver | currency:\'\'}}</td><td>{{item.isserver | currency: \'\'}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMore(item)">View</button></div></td></tr><tr ng-if="manageDailyOnlineServerByGame!=0"><th></th><th></th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'oscustomer\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'pr\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'osserver\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{getTotal(manageDailyOnlineServerByGame, \'isserver\') | currency:\'\'}}</th><th></th></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/msync/paylist/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Paylist!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/msync/paylist/widgets/paylistAdd.html','<div><h3 class="with-line">Paylist Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 bold-text"><strong>Paylist Name</strong></label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageOfficer.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label"><strong>Total Amount</strong></label><div class="col-sm-9"><label class="col-sm-3 control-label"><strong>{{manageOfficer.amount | currency:\'\'}}</strong></label></div></div></div></div><h4 class="with-line">Assigned Officers ({{manageOfficer.plist.length}}) &nbsp; &nbsp;<button class="btn btn-primary btn-xs" ng-click="addOfficer()">Assign New</button></h4><table class="table table-striped table-condensed" st-safe-src="manageOfficer.plist" st-table="plist"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in plist" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td ng-class="{\'bg-success\':item.issprate}" style="color:black"><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate | currency:\'\'}}</span></td><td ng-class="{\'bg-success\':item.issprate1}" style="color:black"><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 | currency:\'\'}}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.areaid" e-name="areaid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreasList | orderBy: \'name\'">{{ getAreaId(item.areaid) }}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="removeOfficer(item)">Remove</button></div></td></tr></tbody></table><hr><br><h4 ng-show="isAssignNewOfficer">Unassigned Officers ({{notSelectedOfficerList.length}}) &nbsp; &nbsp;<button class="btn btn-default btn-xs" ng-click="closeOfficer()">Close</button></h4><table ng-show="isAssignNewOfficer" class="table table-striped table-condensed" st-safe-src="notSelectedOfficerList" st-table="notSelectedOfficers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="emprate.name">Pangkat</th><th st-sort="firstname">Officer Name</th><th st-sort="sprate">Amount 1</th><th st-sort="sprate1">Amount 2</th><th st-sort="department.name">Bahagian</th><th st-sort="site.name">Balai</th><th st-sort="area.name">Daerah</th><th>Action</th></tr><tr><th></th><th><input st-search="emprate.name" placeholder="Search Pangkat" class="input-sm form-control search-input" type="search"></th><th><input st-search="firstname" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="sprate1" placeholder="Search Amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="department.name" placeholder="Search Bahagian" class="input-sm form-control search-input" type="search"></th><th><input st-search="site.name" placeholder="Search Balai" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in notSelectedOfficers" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.emprateid" e-name="emprateid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageEmprateList | orderBy: \'name\'">{{ getEmprateId(item.emprateid) }}</span></td><td><span editable-text="item.firstname" e-name="firstname" e-form="rowform" e-required="">{{ item.firstname || \'empty\' }}</span></td><td ng-class="{\'bg-success\':item.issprate}" style="color:black" ng-click="selectAmount(item,true,false)"><span editable-text="item.sprate" e-name="sprate" e-form="rowform" e-required="">{{ item.sprate | currency:\'\'}}</span></td><td ng-class="{\'bg-success\':item.issprate1}" style="color:black" ng-click="selectAmount(item,false,true)"><span editable-text="item.sprate1" e-name="sprate1" e-form="rowform" e-required="">{{ item.sprate1 | currency:\'\'}}</span></td><td class="select-td"><span editable-select="item.departmentid" e-name="departmentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageDepartmentList | orderBy: \'name\'">{{ getDepartmentId(item.departmentid) }}</span></td><td class="select-td"><span editable-select="item.siteid" e-name="siteid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageSiteList | orderBy: \'name\'">{{ getSiteId(item.siteid) }}</span></td><td class="select-td"><span editable-select="item.areaid" e-name="areaid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreasList | orderBy: \'name\'">{{ getAreaId(item.areaid) }}</span></td><td><div ng-if="item.issprate==null || item.issprate1==null" class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="assignOfficer(item)">Assign</button></div></td></tr></tbody></table></div><button type="button" class="btn btn-primary save-profile" ng-click="savePaylist(manageOfficer)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="searchPaylist(manageOfficer.ownerid)">Close</button>');
$templateCache.put('app/pages/msync/paylist/widgets/paylistTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300,400]"></select></div><div class="col-sm-2"><label>Select Mobile User</label><ui-select ng-model="manageOfficer.user" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.credentials.firstName}}</span></ui-select-match><ui-select-choices repeat="user in manageUserList | filter: $select.search"><span ng-bind-html="user.credentials.firstName"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchPaylist(manageOfficer.user.id)">Search</button></div></div></div></div></div><div class="row"><div class="col-md-8"><table class="table table-striped" st-safe-src="managePaylistList" st-table="managePaylist"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="amount">Amount</th><th st-sort="account.name">Account</th><th st-sort="shared">Share To</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Paylist" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePaylist" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.name}}</td><td class="text-right">{{item.amount | currency:\'\'}}</td><td>{{item.account.name}}</td><td>{{item.shared.credentials.firstName}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editPaylist(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr><tr><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td><td ng-if="managePaylistList.length>0" class="text-right" style="background-color:chocolate ;color:black">{{ getTotaltotal(managePaylistList) | currency:\'\'}}</td><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td><td style="background-color:chocolate ;color:black"></td></tr></tbody><br><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/online/gamesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/gamesales/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.parent" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.parent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.id}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchGameSales()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop</th><th st-sort="partner_name">Partner Name</th><th ng-repeat="(key, value) in managePartnersales[0].game">{{ key }}</th><th st-sort="online_totalsales">Online Total</th><th st-sort="machine_totalsales">Machine Total</th><th>Total Sales</th><th st-sort="online_csales">Company</th><th st-sort="payment_gateway">Bank In</th><th st-sort="pg_charge">Bank In %</th><th st-sort="pg_out">Bank Out</th><th st-sort="pg_out_charge">Bank Out %</th><th st-sort="net_collect">Net Collect</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th ng-repeat="(key, value) in managePartnersales[0].game"></th><th class="bg-info">{{ getTotal(managePartnersales, \'online_totalsales\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'machine_totalsales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(managePartnersales, \'online_totalsales\', \'machine_totalsales\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'online_csales\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'payment_gateway\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'pg_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'pg_out\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(managePartnersales, \'pg_out_charge\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(managePartnersales, \'net_collect\') | currency:\'\'}}</th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.shop.code" e-name="shop.code" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.partner.name" e-name="partner.name" e-form="rowform" e-required="">{{ item.partner.name || \'empty\'}}</span></td><td ng-repeat="game in item.game">{{ game }}</td><td><span editable-text="item.online_totalsales" e-name="online_totalsales" e-form="rowform" e-required="">{{ item.online_totalsales | currency:\'\' }}</span></td><td><span editable-text="item.machine_totalsales" e-name="machine_totalsales" e-form="rowform" e-required="">{{ item.machine_totalsales | currency:\'\'}}</span></td><td><span>{{ (item.online_totalsales - item.machine_totalsales) | currency:\'\'}}</span></td><td><span>{{ (item.online_csales) | currency:\'\'}}</span></td><td><span>{{ (item.payment_gateway) | currency:\'\'}}</span></td><td><span>{{ (item.pg_charge) | currency:\'\'}}</span></td><td><span>{{ (item.pg_out) | currency:\'\'}}</span></td><td><span>{{ (item.pg_out_charge) | currency:\'\'}}</span></td><td><span>{{ (item.net_collect) | currency:\'\'}}</span></td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/dailyonlineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/dailyonlineshop/widgets/dailyonlineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label class="control-label"><strong>Overall Total Sales :</strong></label><div class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getAllOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlineshopList" st-table="manageOnlineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop</th><th st-sort="name">Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th st-sort="net_collect">Net Collect</th><th st-sort="monthly_net_gaming">Monthly Net Gaming</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th>{{getTotalNetCollect(manageOnlineshop) | currency:\'\'}}</th><th>{{getTotalNetGaming(manageOnlineshop) | currency:\'\'}}</th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineshop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.net_collect" e-name="net_collect" e-form="rowform" e-required="">{{ item.net_collect | currency:\'\'}}</span></td><td><span editable-text="item.monthly_net_gaming" e-name="monthly_net_gaming" e-form="rowform" e-required="">{{ item.monthly_net_gaming | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewOnlinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/online/dailyonlineshop/widgets/viewOnlineshop.html','<table class="table table-bordered"><thead><tr><th>Games</th><th class="align-right">Net Purchase</th><th class="align-right">Net Gaming</th><th class="align-right">P/S (-)</th><th class="align-right">AP P/S (-)</th><th class="align-right">P/W (+)</th><th class="align-right">AP P/W (+)</th><th class="align-right">B.Bet</th><th class="align-right">P.B.Bet</th><th class="align-right">B.Win</th><th class="align-right">Sales</th><th class="align-right">Net Collect</th><th class="align-right">Shop ({{ 100 - onlineSalesDetails[0].shop.onrate }}%)</th><th class="align-right">Company ({{ onlineSalesDetails[0].shop.onrate }}%)</th></tr></thead><tbody><tr ng-repeat="item in onlineSalesDetails"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase | currency: \'\'}}</td><td class="align-right">{{item.netgaming | currency: \'\'}}</td><td class="align-right">{{item.pshare | currency: \'\'}}</td><td class="align-right">{{item.apshare | currency: \'\'}}</td><td class="align-right">{{item.pwin | currency: \'\'}}</td><td class="align-right">{{item.apwin | currency: \'\'}}</td><td class="align-right">{{item.bonus_bet | currency: \'\'}}</td><td class="align-right">{{item.p_bonus_bets | currency: \'\'}}</td><td class="align-right">{{item.bonus_win | currency: \'\'}}</td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.net_collect | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}}</td><td class="align-right">{{item.csales | currency: \'\'}}</td></tr></tbody></table>');
$templateCache.put('app/pages/online/internalserverpr/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this file and all data within it!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/internalserverpr/widgets/internalserverPRFileTable.html','<div class="horizontal-scroll" style="min-height: 300px"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="load()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="button" class="btn btn-success" ng-click="goToUploadPage()">Upload Page</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageFileList" st-table="files"><thead sticky-on-scroll=""><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="created">Created Date</th><th st-sort="name">Filename</th><th style="width: 80px">Action</th></tr><tr><th></th><th></th><th><input st-search="name" placeholder="Search Filename" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-if="loading"><td colspan="5">Loading...</td></tr><tr ng-if="!loading && files.length == 0" style="background-color: white"><td colspan="5" class="text-center">No data found</td></tr><tr ng-repeat="item in files"><td class="table-id">{{$index+1}}</td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ item.name}}</td><td><button class="btn btn-success editable-table-button btn-xs" ng-click="viewFile(item)">View</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="deleteFile(item)">Delete</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/online/internalserverpr/widgets/internalserveronlinesales.html','<div class="widgets"><div ng-show="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.7); z-index: 10; display: flex; align-items: center; justify-content: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Online Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-4"><label>Invoice Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" style="color: unset" readonly="" ng-click="clickedInvoiceInput()" uib-datepicker-popup="dd/MM/yyyy" ng-model="formDate.upload" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/online/internalserverpr/widgets/sampleUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageOnlinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="Remarks">Remarks</th><th st-sort="Kiosk">Kiosk</th><th st-sort="snooker">Snooker</th><th st-sort="\'snooker F&B\'">Snooker F&B</th><th st-sort="PS">Progressive Share</th><th st-sort="PW">Progressive Wins</th><th st-sort="Token">Token</th><th st-sort="\'Lucky Wins\'">Lucky Wins</th><th st-sort="\'Caishen\'">Caishen</th><th st-sort="pgsbonus">EVENT BONUS</th><th st-sort="Telco">Telco</th><th st-sort="\'Tng pin\'">Tng Pin</th><th st-sort="\'Crypto Deposit\'">Crypto</th><th st-sort="Bank">Bank</th><th st-sort="Bank_Out">Bank Out</th><th st-sort="PE_Bank">PE Bank</th><th st-sort="PE_Bank_Out">PE Bank Out</th><th st-sort="e-wallet">D.Ewallet</th><th st-sort="e-wallet">G.Ewallet</th><th st-sort="d_cc">D.CC</th><th st-sort="\'\u4E07\u5B57\u6536\'">\u4E07\u5B57\u6536</th><th st-sort="\'\u516C\u53F8\u4F63\u91D1\'">\u516C\u53F8\u4F63\u91D1</th><th st-sort="\'Angpao\'">Angpao</th><th st-sort="\'Commission\'">Commission</th><th st-sort="\'Promotion\'">Promotion</th><th st-sort="\'FPromotion\'">FPromotion</th><th st-sort="\'Zpay Bank In\'">Zpay BANK IN</th><th st-sort="\'Zpay QR In\'">Zpay QR IN</th><th st-sort="\'Vpay QR\'">Vpay QR</th><th st-sort="\'Vpay D.Bank\'">Vpay D.Bank</th><th st-sort="\'Vpay Tng Pin\'">Vpay Tng Pin</th><th st-sort="\'Vpay W.Bank\'">Vpay W.Bank</th><th st-sort="\'Luxepay QR\'">Luxepay QR</th><th st-sort="\'Luxepay D.Bank\'">Luxepay D.Bank</th><th st-sort="\'Luxepay W.Bank\'">Luxepay W.Bank</th><th st-sort="NP">Net Purchase</th><th st-sort="NG">Net Gaming</th><th st-sort="chang_zhu_rate">\u8DDF\u573A\u4E3B\u6536%</th><th st-sort="gong_shi_pan_rate">\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%</th><th st-sort="wai_jiao_rate">\u5916\u4EA4\u8D39%</th><th></th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.Remarks" e-name="Remarks" e-form="rowform" e-required="">{{ item.Remarks || \'empty\'}}</span></td><td><span editable-text="item.Kiosk" e-name="Kiosk" e-form="rowform" e-required="">{{ item.Kiosk || \'empty\'}}</span></td><td><span editable-text="item.snooker" e-name="snooker" e-form="rowform" e-required="">{{item.snooker.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item[\'snooker F&B\']" e-name="snooker F&B" e-form="rowform" e-required="">{{item[\'snooker F&B\'].replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PS" e-name="PS" e-form="rowform" e-required="">{{item.PS.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PW" e-name="PW" e-form="rowform" e-required="">{{item.PW.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Token\']" e-name="\'Token\'" e-form="rowform" e-required="">{{item[\'Token\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Lucky Wins\']" e-name="\'Lucky Wins\'" e-form="rowform" e-required="">{{item[\'Lucky Wins\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Caishen\']" e-name="\'Caishen\'" e-form="rowform" e-required="">{{item[\'Caishen\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'EVENT BONUS\']" e-name="\'EVENT BONUS\'" e-form="rowform" e-required="">{{item[\'EVENT BONUS\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Telco\']" e-name="\'Telco\'" e-form="rowform" e-required="">{{item[\'Telco\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Tng pin\']" e-name="\'Telco\'" e-form="rowform" e-required="">{{item[\'Tng pin\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Crypto Deposit\']" e-name="\'Crypto Deposit\'" e-form="rowform" e-required="">{{item[\'Crypto Deposit\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Bank\']" e-name="\'Bank\'" e-form="rowform" e-required="">{{item[\'Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Bank_Out\']" e-name="\'Bank_Out\'" e-form="rowform" e-required="">{{item[\'Bank_Out\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'PE Bank\']" e-name="\'PE Bank\'" e-form="rowform" e-required="">{{item[\'PE Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'PE Bank_Out\']" e-name="\'PE Bank_Out\'" e-form="rowform" e-required="">{{item[\'PE Bank_Out\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'e-wallet\']" e-name="\'e-wallet\'" e-form="rowform" e-required="">{{item[\'e-wallet\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'e-wallet\']" e-name="\'e-wallet\'" e-form="rowform" e-required="">{{item[\'G-ewallet\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'d_cc\']" e-name="\'d_cc\'" e-form="rowform" e-required="">{{item[\'d_cc\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u4E07\u5B57\u6536\']" e-name="\'\u4E07\u5B57\u6536\'" e-form="rowform" e-required="">{{item[\'\u4E07\u5B57\u6536\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u516C\u53F8\u4F63\u91D1\']" e-name="\'\u516C\u53F8\u4F63\u91D1\'" e-form="rowform" e-required="">{{item[\'\u516C\u53F8\u4F63\u91D1\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Angpao\']" e-name="\'Angpao\'" e-form="rowform" e-required="">{{item[\'Angpao\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Commission\']" e-name="\'Commission\'" e-form="rowform" e-required="">{{item[\'Commission\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Promotion\']" e-name="\'Promotion\'" e-form="rowform" e-required="">{{item[\'Promotion\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'FPromotion\']" e-name="\'FPromotion\'" e-form="rowform" e-required="">{{item[\'FPromotion\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Zpay Bank In\']" e-name="\'Zpay Bank In\'" e-form="rowform" e-required="">{{item[\'Zpay Bank In\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Zpay QR In\']" e-name="\'Zpay QR In\'" e-form="rowform" e-required="">{{item[\'Zpay QR In\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay QR\']" e-name="\'Vpay QR\'" e-form="rowform" e-required="">{{item[\'Vpay QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay D.Bank\']" e-name="\'Vpay D.Bank\'" e-form="rowform" e-required="">{{item[\'Vpay D.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay Tng Pin\']" e-name="\'Vpay Tng Pin\'" e-form="rowform" e-required="">{{item[\'Vpay Tng Pin\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Vpay W.Bank\']" e-name="\'Vpay W.Bank\'" e-form="rowform" e-required="">{{item[\'Vpay W.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay QR\']" e-name="\'Luxepay QR\'" e-form="rowform" e-required="">{{item[\'Luxepay QR\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay D.Bank\']" e-name="\'Luxepay D.Bank\'" e-form="rowform" e-required="">{{item[\'Luxepay D.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'Luxepay W.Bank\']" e-name="\'Luxepay W.Bank\'" e-form="rowform" e-required="">{{item[\'Luxepay W.Bank\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NP" e-name="NP" e-form="rowform" e-required="">{{item.NP.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NG" e-name="NG" e-form="rowform" e-required="">{{item.NG.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item[\'\u8DDF\u573A\u4E3B\u6536%\']" e-name="chang_zhu_rate" e-form="rowform" e-required="">{{item[\'\u8DDF\u573A\u4E3B\u6536%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%\']" e-name="gong_shi_pan_rate" e-form="rowform" e-required="">{{item[\'\u76D8\u53E3\u516C\u53F8\u76D8\u8D39%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item[\'\u5916\u4EA4\u8D39%\']" e-name="wai_jiao_rate" e-form="rowform" e-required="">{{item[\'\u5916\u4EA4\u8D39%\'].replace(\'MYR\',\'\') || 0}}</span></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete($index)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="39" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-disabled="!!loading" ng-click="createOnlinesales(manageOnlinesales)">Save</button> &nbsp; <button type="button" class="btn btn-default save-profile" ng-click="goToListPage()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/online/internalserverpr/widgets/internalserverprTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100]"></select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-default" ng-click="closeDetailPage()">Back</button></div></div></div></div></div><table-scroller-bar></table-scroller-bar><table sticky-columns="" class="table table-striped table-condensed" st-safe-src="manageOnlineSalesList" st-table="onlinesales"><thead sticky-on-scroll=""><tr class="hide-on-sticky"><th colspan="9"></th><th colspan="2" style="background-color: #ffe679; color: black">\u8DDF\u573A\u4E3B\u6536</th><th colspan="2" style="background-color: #ffe679; color: black">\u76D8\u53E3\u516C\u53F8\u76D8\u8D39</th><th style="background-color: #79e0ff; color: black" colspan="6"></th><th style="background-color: grey"></th><th style="background-color: #bcff79; color: black; text-align: center" colspan="8">Payment Gateway</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid" sticky="true">Username</th><th st-sort="sales">Sales</th><th st-sort="netgaming">Netgaming</th><th st-sort="pshare">+PS</th><th st-sort="pwin">-PW</th><th st-sort="token">+Token</th><th st-sort="lucky_win">-Luck Wins</th><th st-sort="caishen">-CaiShen</th><th style="background-color: #ffe679; color: black" st-sort="chang_zhu_rate">\u573A\u4E3B\u6536%</th><th style="background-color: #ffe679; color: black" st-sort="chang_zhu_fee">\u573A\u4E3B\u6536</th><th style="background-color: #ffe679; color: black" st-sort="gong_shi_pan_rate">\u76D8\u8D39%</th><th style="background-color: #ffe679; color: black" st-sort="gong_shi_pan_fee">\u76D8\u8D39</th><th style="background-color: #79e0ff; color: black" st-sort="angpao">-Angpao</th><th style="background-color: #79e0ff; color: black" st-sort="promotion">-Promotion</th><th style="background-color: #79e0ff; color: black" st-sort="fpromotion">-FPromotion</th><th style="background-color: #79e0ff; color: black" st-sort="commission">-Commission</th><th style="background-color: #79e0ff; color: black" st-sort="wai_jiao_rate">\u5916\u4EA4\u8D39%</th><th style="background-color: #79e0ff; color: black" st-sort="wai_jiao_fee">\u5916\u4EA4\u8D39</th><th style="background-color: grey; color: white" st-sort="profit">Profit</th><th style="background-color: #bcff79; color: black" st-sort="total_payment_gateway">In</th><th style="background-color: #bcff79; color: black" st-sort="tng_pin">TNG PIN</th><th style="background-color: #bcff79; color: black" st-sort="total_pgout">Out</th><th style="background-color: #bcff79; color: black" st-sort="total_bank">Total</th><th style="background-color: #bcff79; color: black" st-sort="pg_charge">In 2%</th><th style="background-color: #bcff79; color: black" st-sort="pg_out_charge">Out 1%</th><th style="background-color: #bcff79; color: black" st-sort="tng_pin_charge">TNG PIN 5%</th><th style="background-color: #bcff79; color: black" st-sort="total_bank_charge">Total</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'sales\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'netgaming\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pshare\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pwin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'token\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'lucky_win\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'caishen\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'chang_zhu_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'gong_shi_pan_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'angpao\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'promotion\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'fpromotion\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'commission\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'wai_jiao_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'profit\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_payment_gateway\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'tng_pin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_pgout\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_bank\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pg_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pg_out_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'tng_pin_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_bank_charge\') | currency:\'\'}}</th></tr></thead><tbody><tr ng-if="detailLoading"><td colspan="9">Loading...</td><td colspan="9">Loading...</td><td colspan="10">Loading...</td></tr><tr ng-if="!detailLoading && onlinesales.length == 0" style="background-color: white"><td colspan="9" class="text-center">No data found</td><td colspan="9" class="text-center">No data found</td><td colspan="10" class="text-center">No data found</td></tr><tr ng-repeat="item in onlinesales"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid}}</td><td>{{ item.sales | currency: \'\'}}</td><td>{{ item.netgaming | currency: \'\'}}</td><td>{{item.pshare | currency: \'\'}}</td><td>{{item.pwin | currency: \'\'}}</td><td>{{item.token | currency: \'\'}}</td><td>{{item.lucky_win | currency: \'\'}}</td><td>{{item.caishen | currency: \'\'}}</td><td style="background-color: #ffe679; color: black">{{item.chang_zhu_rate}}</td><td style="background-color: #ffe679; color: black">{{item.chang_zhu_fee | currency: \'\'}}</td><td style="background-color: #ffe679; color: black">{{item.gong_shi_pan_rate}}</td><td style="background-color: #ffe679; color: black">{{item.gong_shi_pan_fee | currency: \'\'}}</td><td style="background-color: #79e0ff; color: black">{{item.angpao | currency: \'\'}}</td><td style="background-color: #79e0ff; color: black">{{item.promotion | currency: \'\'}}</td><td style="background-color: #79e0ff; color: black">{{item.fpromotion | currency: \'\'}}</td><td style="background-color: #79e0ff; color: black">{{item.commission | currency: \'\'}}</td><td style="background-color: #79e0ff; color: black">{{item.wai_jiao_rate}}</td><td style="background-color: #79e0ff; color: black">{{item.wai_jiao_fee | currency: \'\'}}</td><td style="background-color: grey; color: white">{{item.profit | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.total_payment_gateway | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.tng_pin | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.total_pgout | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.total_bank | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.pg_charge | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.pg_out_charge | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.tng_pin_charge | currency: \'\'}}</td><td style="background-color: #bcff79; color: black">{{item.total_bank_charge | currency: \'\'}}</td></tr></tbody><tfoot><tr><th></th><th></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'sales\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'netgaming\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pshare\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pwin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'token\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'lucky_win\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'caishen\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'chang_zhu_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'gong_shi_pan_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'angpao\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'promotion\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'fpromotion\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'commission\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black"></th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'wai_jiao_fee\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'profit\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_payment_gateway\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'tng_pin\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_pgout\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_bank\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pg_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'pg_out_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'tng_pin_charge\') | currency:\'\'}}</th><th style="background-color: chocolate; color: black">{{ getTotal(onlinesales, \'total_bank_charge\') | currency:\'\'}}</th></tr><tr><td colspan="28" class="text-center" style="padding: 8px"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/online/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/onlinesales/widgets/onlinesalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000, 2500, 5000]"></select></div><div class="col-sm-2"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required="" datepicker-options="dateList.options"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" datepicker-options="dateList.options" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><div><label>Kiosk</label> <input type="text" class="input-md form-control search-input" ng-model="reportFilter.kiosk" placeholder="Enter Kiosk"></div></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div ng-if="!!manageParentPartnerList.length" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.partnerid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-disabled="loading.searching" ng-click="searchOnlinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-disabled="loading.searching" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div style="transform: rotateX(180deg); overflow-x: auto"><table sticky-columns="" style="transform: rotatex(180deg)" class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead sticky-on-scroll=""><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid" sticky="true">Kiosk</th><th st-sort="code" sticky="true">Shop Code</th><th st-sort="name" sticky="true">Shop Name</th><th st-sort="gamename" sticky="true">Game</th><th st-sort="ikey" sticky="true">Invoice Date</th><th st-sort="cafeanddarts">Cafe & Darts</th><th st-sort="snooker">Snooker</th><th st-sort="snooker_fnb">Snooker F&B</th><th st-sort="local_kitchen">Kitchen</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="apshare">AP P/S</th><th st-sort="pwin">PW</th><th st-sort="apwin">AP PW</th><th st-sort="rewards">Rewards</th><th st-sort="bonus_bet">Token</th><th st-sort="bonus_win">Lucky Wins</th><th st-sort="caishen">Caishen</th><th st-sort="plinko">Plinko</th><th st-sort="netgaming">NG</th><th st-sort="toatl_payment_gateway">Bank In</th><th st-sort="pg_charge">Bank In %</th><th st-sort="total_pgout">Bank Out</th><th st-sort="pg_out_charge">Bank Out %</th><th st-sort="d_ewallet">D.Ewallet</th><th st-sort="d_ewallet_charge">D.Ewallet %</th><th st-sort="telco">Telco</th><th st-sort="crypto">Crypto</th><th st-sort="local_tng_pin">Tng pin</th><th st-sort="tng_pin_charge">Tng pin%</th><th st-sort="d_cc">D.CC</th><th st-sort="d_cc_charge">D.CC %</th><th st-sort="pgsbonus">EVENT BONUS</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="net_collect">Net Collect</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamename" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th></th><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_cafeanddarts\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'snooker\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'snooker_fnb\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_kitchen\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netpurchase\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'apshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'apwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'rewards\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'bonus_bet\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'bonus_win\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'caishen\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'plinko\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netgaming\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'total_payment_gateway\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pg_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'total_pgout\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pg_out_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_ewallet\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_ewallet_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'telco\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'crypto\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_tng_pin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'tng_pin_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_cc\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_cc_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pgsbonus\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'totalsales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'csales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'psales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'net_collect\') | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-if="loading.searching"><td colspan="14">Loading...</td><td colspan="14">Loading...</td><td colspan="13">Loading...</td></tr><tr ng-if="!loading.searching" ng-repeat="item in manageOnlinesales track by item.salesid" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.code || \'empty\'}}</td><td>{{ item.name || \'empty\'}}</td><td>{{ item.gamename || \'empty\' }}</td><td>{{ item.indate | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY\'}}</td><td>{{ item.local_cafeanddarts | currency: \' \' }}</td><td>{{ item.local_snooker | currency: \' \' }}</td><td>{{ item.local_snooker_fnb | currency: \' \'}}</td><td>{{ item.local_kitchen | currency: \' \'}}</td><td>{{ item.local_netpurchase | currency: \' \' }}</td><td>{{ item.local_pshare | currency: \' \' }}</td><td>{{ item.local_apshare | currency: \' \' }}</td><td>{{ item.local_pwin | currency: \' \' }}</td><td>{{ item.local_apwin | currency: \' \' }}</td><td>{{ item.local_rewards | currency: \' \' }}</td><td>{{ item.local_bonus_bet | currency: \' \' }}</td><td>{{ item.local_bonus_win | currency: \' \' }}</td><td>{{ item.local_caishen | currency: \' \' }}</td><td>{{ item.local_plinko | currency: \' \' }}</td><td>{{ item.local_netgaming | currency: \' \' }}</td><td>{{ item.local_total_payment_gateway | currency: \' \' }}</td><td>{{ item.local_pg_charge | currency: \' \' }}</td><td>{{ item.local_total_pgout | currency: \' \' }}</td><td>{{ item.local_pg_out_charge | currency: \' \' }}</td><td>{{ item.local_d_ewallet | currency: \' \' }}</td><td>{{ item.local_d_ewallet_charge | currency: \' \' }}</td><td>{{ item.local_telco | currency: \' \' }}</td><td>{{ item.local_crypto | currency: \' \' }}</td><td>{{ item.local_tng_pin | currency: \' \'}}</td><td>{{ item.local_tng_pin_charge | currency: \' \' }}</td><td>{{ item.local_d_cc | currency: \' \' }}</td><td>{{ item.local_d_cc_charge | currency: \' \' }}</td><td>{{ item.local_pgsbonus | currency: \' \' }}</td><td>{{ item.local_totalsales | currency: \' \'}}</td><td>{{ item.local_csales | currency: \' \' }}</td><td>{{ item.local_psales | currency: \' \'}}</td><td>{{ item.local_net_collect | currency: \' \'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.salesid)" ng-if="canClickDelete">Delete</button></div></td></tr></tbody><tfoot><td colspan="17" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tfoot><tfoot><tr><td></td><td></td><td></td><td></td><td></td><td></td><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_cafeanddarts\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'snooker\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'snooker_fnb\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_kitchen\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netpurchase\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'apshare\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'apwin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'rewards\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'bonus_bet\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'bonus_win\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'caishen\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'plinko\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'netgaming\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'total_payment_gateway\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pg_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'total_pgout\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pg_out_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_ewallet\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_ewallet_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'telco\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'crypto\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'local_tng_pin\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'tng_pin_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_cc\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'d_cc_charge\') | currency:\'\'}}</th><th class="bg-info">{{ getTotal(manageOnlinesales, \'pgsbonus\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'totalsales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'csales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'psales\') | currency:\'\'}}</th><th class="bg-primary">{{ getTotal(manageOnlinesales, \'net_collect\') | currency:\'\'}}</th></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/online/onlinesales/widgets/viewSale.html','<h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Game</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.gamename}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Shop Code</label><div class="col-sm-8"><label class="ontrol-label">{{manageOnlinesales.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner</label><div class="col-sm-8"><label class="control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Invoice Number</label><div class="col-sm-8"><label class="control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Kiosk</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Shop Name</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Upload Date</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-4 control-label">Invoice Date</label><div class="col-sm-8"><label class="control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Progressive Share</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.pshare | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Progressive Wins</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.pwin | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Purchase</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Gaming</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bank</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.total_payment_gateway | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bank Charges({{manageOnlinesales.pg_rate}}%)</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.pg_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.Ewallet</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_ewallet | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.Ewallet Charges({{manageOnlinesales.d_ewallet_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_ewallet_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.CC</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_cc | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">D.CC Charges({{manageOnlinesales.d_cc_rate}}%)</label><div class="col-sm-8"><label class="col-sm-4 control-label">{{manageOnlinesales.d_cc_charge | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bonus Bet</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.bonus_bet | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Bonus Win</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.bonus_win | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner Bonus Bet({{manageOnlinesales.shop.bet_rate}}%)</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.p_bonus_bets | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Sales</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Net Collect</label><div class="col-sm-8"><label class="control-label">{{manageOnlinesales.net_collect | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="searchOnlinesales(reportFilter)">Close</button>');
$templateCache.put('app/pages/online/serversales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/online/serversales/widgets/serversalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="reportFilter.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.parent" class="col-sm-2"><label>Select Partner</label><ui-select ng-model="reportFilter.parent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.id}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search"><span ng-bind-html="parent.id+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchGameSales()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shopcode">Shop</th><th st-sort="partnername">Partner Name</th><th ng-repeat="ga in managePartnersales[0].game" style="text-transform: capitalize">{{ga.name}}</th><th st-sort="total">Total Sales</th></tr><tr><th></th><th><input st-search="shopcode" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="partnername" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th ng-repeat="(name, value) in managePartnersales[0].game"></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.shopcode || \'empty\'}}</td><td>{{ item.partnername || \'empty\'}}</td><td ng-repeat="game in item.game">{{ game.value | currency: \'\' }}</td><td>{{item.total | currency: \'\'}}</td></tr></tbody></table></div>--><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot>');
$templateCache.put('app/pages/operational/it/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/it/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/it/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/it/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/operational/it/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th style="padding: 8px 150px 8px 0">Date</th><th style="padding: 8px 100px 8px 0">Remarks</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><span editable-bsdate="item.indate" e-is-open="datePickerOpened.$data" e-ng-click="openDatePicker($event, \'$data\')" e-datepicker-popup="dd-MMMM-yyyy" e-name="indate" e-form="rowform">{{ (item.indate | date:\'dd-MM-yyyy\') || \'empty\' }}</span></td><td><span editable-text="item.remarks" e-name="remarks" e-form="rowform">{{ item.remarks || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/it/widgets/machineTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="status">Status</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Daerah</th><th st-sort="shop.code">Shop</th><th st-sort="supplier.code">Supplier Code</th><th style="padding: 8px 150px 8px 0">Date</th><th st-sort="remarks" style="padding: 8px 100px 8px 0">Remarks</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><select st-search="status" class="input-sm form-control search-input"><option value="">All</option><option value="true">Active</option><option value="false">Inactive</option></select></th><th><input st-search="game.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}} <i class="ion-eye" ng-click="viewQRcode(item.machine.code)"></i></td><td>{{ item.status?\'Active\':\'Inactive\'}}</td><td>{{item.game.name}}</td><td>{{item.zone.code}}</td><td>{{item.shop.code || \'Not Set\'}}</td><td>{{ item.supplier.code || \'empty\'}}</td><td>{{ item.indate ? (item.indate | date:\'dd-MM-yyyy\') : \'empty\' }}</td><td>{{item.remarks || \'\'}}</td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/operational/it/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/operational/machine/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/machine/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/machine/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/machine/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/operational/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th style="padding: 8px 150px 8px 0">Date</th><th style="padding: 8px 100px 8px 0">Remarks</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><span editable-bsdate="item.indate" e-is-open="datePickerOpened.$data" e-ng-click="openDatePicker($event, \'$data\')" e-datepicker-popup="dd-MMMM-yyyy" e-name="indate" e-form="rowform">{{ (item.indate | date:\'dd-MM-yyyy\') || \'empty\' }}</span></td><td><span editable-text="item.remarks" e-name="remarks" e-form="rowform">{{ item.remarks || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/machine/widgets/machineTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageMachine(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Daerah</th><th st-sort="shop.code">Shop</th><th st-sort="isjackpot">is Jackpot?</th><th st-sort="calby">Calc By?</th><th st-sort="cm_rate">CM Rate</th><th st-sort="bm_rate">BM Rate</th><th st-sort="">CM to BM</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="games.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}} <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td>{{item.game.name}}</td><td>{{item.zone.code}}</td><td>{{item.shop.code || \'Not Set\'}}</td><td>{{ item.isjackpot?\'Yes\':\'No\' || \'empty\'}}</td><td>{{ item.calby?\'CM\':\'BM\' || \'empty\'}}</td><td>{{ item.cmRate || \'empty\'}}</td><td>{{ item.bmRate || \'empty\'}}</td><td>{{(item.cmRate/item.bmRate)|currency: \'\'}}</td><td>{{ item.status?\'Active\':\'Inactive\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editMachine(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/operational/machine/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/operational/shop/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shop/modals/viewRemarks.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-star modal-icon"></i><span>Remarks</span></div><div class="modal-body text-center" ng-if="remarks"><div id="remarks"><span>{{remarks}}</span><br></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/machines.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div></div></div><h3 class="with-line">Machine Setup &nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Machine</button></h3><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Machine Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.machine" data-e-form="rowform" data-e-name="machine" e-name="machine" data-e-ng-model="machine" append-to-body="true">{{ showMachine(item.machine) }}<editable-ui-select-match placeholder="Machine Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="machine in manageMachineList | filter: $select.search track by $index">{{machine.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/onlineGames.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company % (Display Only)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrebate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">D.Bank % (2.0%)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.pg_rate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">W.Bank % (1.0%)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.pg_out_rate"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Server Company(15%)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.servercompany"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Game Server Customer Fee (15%)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.customerFee"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div><div class="form-group row clearfix"><label for="inputewallet" class="col-sm-3 control-label">D.E-Wallet</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.d_ewallet_rate"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">D.CC</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.d_cc_rate"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">TNG Pin Rate(5%)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.tng_pin_rate"></div></div></div></div><h3 class="with-line">Auto Crawl</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Paparich Terms</label><div class="col-sm-9"><ui-select ng-model="manageShop.paparichSalesPeriod" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span ng-show="$select.selected.value">{{$select.selected.name}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in paparichSalesPeriodDropdown | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Joka Terms</label><div class="col-sm-9"><ui-select ng-model="manageShop.jokaSalesPeriod" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span ng-show="$select.selected.value">{{$select.selected.name}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in paparichSalesPeriodDropdown | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Paparich Agent (Get sales under agent)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.paparichAgentName"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Joka Agent (Get sales under agent)</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.jokaAgentName"></div></div></div></div><h3 class="with-line">Online Games Setup &nbsp; <button class="btn btn-primary editable-table-button btn-xs" ng-click="addOnlineShop()" ng-disabled="!manageShop.id">Add</button></h3><div class="alert bg-danger" ng-if="!manageShop.id"><strong>Please save shop before add games.</strong></div><div class="row"><div class="col-md-6"><table class="table" st-safe-src="manageOnlineShopList" st-table="manageOnlineShop"><thead><tr class="black-muted-bg"><th>Online Game</th><th style="min-width: 120px">ID</th><th>Company %</th><th>Bonus Bet %</th><th>NP/NG</th><th>Provider</th><th style="min-width: 80px">Server %</th><th style="min-width: 80px">PR %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineShop" class="editable-row"><td class="select-td"><span editable-select="item.game.id" e-name="games" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamesList | filter: { gamecatid: 1 }">{{ showGames(item.game) }}</span></td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><span editable-number="item.onrate" e-name="onrate" e-form="rowform" e-required="">{{ item.onrate === null ? \'-\' : item.onrate }}</span></td><td><span editable-number="item.bet_rate" e-name="bet_rate" e-form="rowform" e-required="">{{ item.bet_rate === null ? \'-\' : item.bet_rate }}</span></td><td class="select-td"><span editable-select="item.algorithm" e-name="algorithm" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g for g in algorithms">{{item.algorithm}}</span></td><td class="select-td"><span editable-select="item.gameserver.id" e-name="gameserverid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGameServerList">{{item.gameserver.name}}</span></td><td><span editable-number="item.server" e-name="server" e-form="rowform" e-required="">{{ item.server === null ? \'-\' : item.server }}</span></td><td><span editable-number="item.pr" e-name="pr" e-form="rowform" e-required="">{{ item.pr === null ? \'-\' : item.pr }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlineShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/partner.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.code+\', \'+$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code+\', \'+partner.name"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Name & Contact</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-9 control-label">{{manageShop.partner.name+\' (\'+manageShop.partner.contact+\')\'}}</label></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">1. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">2. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">3. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">1. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">2. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">3. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.number"></div></div></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/profitsharingTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-3"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>Current Profit Sharing: {{selectedShop.profitsharing}}%</label></div></div></div></div><table class="table table-striped table-condensed table-bordered" st-safe-src="profitSharingHistory" st-table="items"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="createdAt">Created</th><th st-sort="profitSharing">Rate</th><th st-sort="remarks">Remarks</th><th>Action</th></tr></thead><tbody><tr ng-show="!profitSharingHistory.length"><td colspan="8">No Data</td></tr><tr ng-repeat="item in items" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.createdAt | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span editable-number="item.profitSharing" e-name="profitSharing" e-form="rowform" e-required="" onbeforesave="checkRate($data)">{{ item.profitSharing }}</span></td><td><span editable-text="item.remarks" e-name="remarks" e-form="rowform">{{ item.remarks || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveProfitSharing($data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/operational/shop/widgets/shopInfo.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><ui-select ng-model="manageShop.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><button type="button" ng-click="createAddressRow()" class="btn btn-primary">+ New</button><div><div class="row" ng-repeat="add in manageShop.shopAddress" style="margin-top: 5px"><div class="col-1 col-sm-1">{{$index + 1}}.</div><div class="col-9 col-sm-8"><textarea rows="2" class="form-control" ng-model="add.name"></textarea></div><div class="col-3 col-sm-3"><button type="button" ng-click="removeAddressRow($index)" class="btn btn-danger">Delete</button></div></div></div></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.status"> <span>{{manageShop.status?"Active":"Inactive"}}</span></label><div class="text-danger" ng-if="manageShop.terminatedBySpidermanPR"><div>Terminated By PR</div><div ng-if="manageShop.terminateReason">Reason: {{manageShop.terminateReason}}</div></div></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">\u5305\u5916\u4EA4</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.hasWaiJiao"> <span>{{manageShop.hasWaiJiao?"Active":"Inactive"}}</span></label></div></div><div class="form-group row clearfix"><label for="input-mode" class="col-sm-3 control-label">\u6A21\u5F0F</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.modes"></div></div><div class="form-group row clearfix"><label for="shopcategory" class="col-sm-3 control-label">Category</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected" allow-clear="true"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="category in manageShopCategoryList | filter: $select.search"><span>{{ category.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="allow-invocing" class="col-sm-3 control-label">Invoicing</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.allowInvocing"> <span>{{manageShop.allowInvocing?"Yes":"No"}}</span></label><div><small>{{manageShop.allowInvocing ? \'Onlinesales will show in daily and all invoice\' : \'Onlinesales will not show in daily and all invoice\'}}</small></div></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Unit / No.</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Account</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span>{{ zone.code }}, {{ zone.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="input-pr-code" class="col-sm-3 control-label">Daerah PR Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zonepr" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}, {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesPRList | filter: $select.search"><span>{{ zone.code }}, {{ zone.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Balai</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.site" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="site in manageSiteList | filter: $select.search"><span ng-bind-html="site.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Operational</label><div class="col-sm-9"><ui-select ng-model="manageShop.operational" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in operationalFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="shop-photo" class="col-sm-3 control-label">Photo</label><div class="col-sm-9"><div ng-if="!manageShop.photo || !manageShop.photo.length">No Photo</div><div class="photo-row" style="white-space: nowrap; overflow-x: scroll" ng-if="manageShop.photo && manageShop.photo.length > 0"><div style="display: inline-block; border-radius: 5px; border: 1px solid black; position: relative; margin-top: 5px; margin-left: 5px; width: 30%; min-width: 100px; padding-bottom: 30%; background-position: center; background-size: cover; cursor: zoom-in;" ng-click="viewPhotos(photo.ssl_url)" ng-style="{backgroundImage: \'url(\' + photo.ssl_url + \')\' }" ng-repeat="photo in manageShop.photo"><i class="ion-ios-close-outline modal-icon" style="position: absolute; top: 0; right: 0; padding-top: 5px; padding-right: 5px; font-size: 2rem; cursor: pointer; color: black;" ng-click="deleteImage($index)"></i></div></div><button type="button" ng-click="shopPhoto()" class="btn btn-primary">Upload</button></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="float" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.remarks"></textarea></div></div></div></div>');
$templateCache.put('app/pages/operational/shop/widgets/shopTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="form-group col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="form-group col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="manageZonesList.length>1" class="form-group col-sm-2"><label>Select Status</label><ui-select ng-model="reportFilter.status" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in statusFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageZonesList.length>1" class="form-group col-sm-2"><label>Select Operational</label><ui-select ng-model="reportFilter.operational" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in operationalFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="form-group col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="form-group col-sm-2"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div ng-if="manageZonesPRList.length>1" class="form-group col-sm-2"><label>Select Daerah PR</label><ui-select ng-model="reportFilter.zonepr" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesPRList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2"><label>Select \u5305\u5916\u4EA4</label><ui-select ng-model="reportFilter.hasWaiJiao" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.value">{{$select.selected.value}}</span> <span ng-hide="$select.selected.value">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in statusFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2" ng-if="isAdmin"><label>Select Category</label><ui-select ng-model="reportFilter.category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-show="$select.selected.name">{{$select.selected.name}}</span> <span ng-hide="$select.selected.name">{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in manageShopCategoryList | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageShop()">Search</button></div></div><div class="form-group col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageShopList" st-table="manageShop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop ID</th><th st-sort="name">Unit / No.</th><th st-sort="myaddress">Address</th><th st-sort="onrate">Rate</th><th st-sort="partner.code">Partner</th><th st-sort="zone.code">Daerah Account</th><th st-sort="zonepr.code">Daerah PR</th><th st-sort="status">Status</th><th st-sort="hasWaiJiao">\u5305\u5916\u4EA4</th><th st-sort="modes">\u6A21\u5F0F</th><th st-sort="machine">Machine</th><th st-sort="{{game.id}}" ng-repeat="game in manageShopGamesList">{{game.name}}</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop ID" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="myaddress" placeholder="Search address" class="input-sm form-control search-input" type="search"></th><th><input st-search="onrate" placeholder="Search Shop Rate" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.code" placeholder="Search Partner" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonepr.code" placeholder="Search Daerah PR" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="hasWaiJiao" placeholder="Search \u5305\u5916\u4EA4" class="input-sm form-control search-input" type="search"></th><th><input st-search="modes" placeholder="Search \u6A21\u5F0F" class="input-sm form-control search-input" type="search"></th><th><span>{{getTotalMachine(manageShop)}}</span></th><th ng-repeat="game in manageShopGamesList">{{getTotalGame(manageShop, game)}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShop" class="editable-row"><td class="table-id">{{$index+1}}</td><td ng-class="{\'bg-warning\':item.operational==\'Warning\',\'bg-success\':item.operational==\'Live\', \'bg-danger\':item.operational==\'Danger\'}" style="color: black"><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}} <i ng-if="item.remarks" class="ion-star" ng-click="viewRemarks(item.remarks)"></i></span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.myaddress" e-name="address" e-form="rowform" e-required="">{{ item.myaddress || \'empty\'}}</span></td><td><span editable-text="item.onrate" e-name="rate" e-form="rowform" e-required="">{{ item.onrate || \'empty\'}}</span></td><td class="select-td">{{item.partner.code+\', \'+item.partner.name}}</td><td class="select-td">{{item.zone.code}}</td><td class="select-td">{{item.zonepr.code}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td>{{ item.hasWaiJiao?\'Active\':\'Inactive\'}}</td><td>{{ item.modes }}</td><td><span editable-text="item.machine" e-name="machine" e-form="rowform" e-required="">{{ item.machine }}</span></td><td ng-repeat="game in manageShopGamesList"><span editable-text="game.name" e-name="game.name" e-form="rowform" e-required="">{{ item.game[game.id] || \'0\' }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editShop(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)">Access</button> &nbsp; <button ng-show="isAdmin" class="btn btn-info editable-table-button btn-xs" ng-click="openProfitSharing(item)">Profit Share</button></div></td></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/operational/shopcategory/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this shop category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/shopcategory/widgets/shopCategoryTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="mangeShopCategoryList" st-table="manageShopCategory"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShopCategory" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveShopCategory($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Users!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/partneraccount/partnerusers/widgets/usersTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageUsersList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="username">Username</th><th st-sort="credentials.name">Name</th><th st-sort="credentials.mobile">Mobile</th><th st-sort="emailVerified">Access?</th><th st-sort="credentials.role">Role</th><th st-sort="credentials.partnerid">Partner Code</th><th>Action</th></tr><tr><th></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.mobile" placeholder="Search Mobile" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.username}}</td><td><span editable-text="item.credentials.name" e-name="name" e-form="rowform" e-required="">{{ item.credentials.name || \'empty\'}}</span></td><td><span editable-text="item.credentials.mobile" e-name="mobile" e-form="rowform" e-required="">{{ item.credentials.mobile || \'empty\' }}</span></td><td><span editable-radiolist="item.emailVerified" e-ng-options="s.value for s in ::emailVerified track by s.value" e-name="emailVerified" e-form="rowform">{{ showAccess(item.emailVerified) }}</span></td><td class="select-td"><span editable-select="item.credentials.role" e-name="role" e-form="rowform" e-selectpicker="">{{ showRoles(item.credentials.role) }}</span></td><td class="select-td"><span editable-select="item.credentials.partner" e-name="partner" e-form="rowform" e-selectpicker="">{{ item.credentials.partner.code }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-warning editable-table-button btn-xs" ng-click="resetPassword(item.id)">Reset</button></div></td></tr></tbody><br><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/partners/partnerinvoice/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/partners/partnerinvoice/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-show="userData.roleId==9" class="col-sm-2"><label>Select Staff</label><ui-select ng-model="dateList.staff" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="staff in managePartnerList | filter: $select.search"><span ng-bind-html="staff.code"></span> <span ng-bind-html="staff.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getMachineSalesOfPartner()">Reset</button></div></div></div></div></div><div ng-if="isEdit"><table class="table table-striped table-condensed" st-safe-src="shopSalesOfPartnerList" st-table="shopSalesOfPartner"><thead><tr><th></th><th></th><th></th><th><input st-search="invoiceid" placeholder="Search Invoice Number" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="invoiceid">Invoice Number</th><th st-sort="indate">Invoice Date</th><th st-sort="ispaid">Status</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="item in shopSalesOfPartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.invoiceid" e-name="invoiceid" e-form="rowform" e-required="">{{ item.invoiceid || \'empty\' }}</span></td><td>{{item.indate | date: \'dd/MM/yyyy\'}}</td><td ng-class="{\'bg-success\':item.ispaid,\'bg-danger\':!item.ispaid }">{{item.ispaid?\'PAID\':\'UNPAID\'}}</td><td class="bg-warning" style="color:black">{{ item.mpsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mcsales | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ item.mactotal | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.netpurchase | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.opsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ocsales | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.shopTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.compTotal | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ item.totalsales | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewInvoice(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><button type="button" class="btn btn-default save-profile" ng-click="dateList.from&&dateList.to?searchMachinesales(dateList):searchMachinesales(dateList)" print-remove="">Close</button></div><table ng-hide="isEdit" class="table table-striped table-condensed" st-safe-src="machineSalesOfPartnerList.result" st-table="machineSalesOfPartner"><thead><tr><th></th><th></th><th><input st-search="code" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th colspan="3" class="text-center bg-warning" style="color:black">Machine</th><th colspan="4" class="text-center bg-info" style="color:black">Online</th><th colspan="3" class="text-center bg-purple" style="color:black">Overall</th></tr><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th>Partner</th><th st-sort="code">Shop Code</th><th st-sort="code">Shop Name</th><th st-sort="mpsales" class="bg-warning" style="color:black">Shop</th><th st-sort="mcsales" class="bg-warning" style="color:black">Company</th><th st-sort="mactotal" class="bg-warning" style="color:black">Total</th><th st-sort="opsales" class="bg-info" style="color:black">NP</th><th st-sort="opsales" class="bg-info" style="color:black">Shop</th><th st-sort="ocsales" class="bg-info" style="color:black">Company</th><th st-sort="ontotal" class="bg-info" style="color:black">Total</th><th st-sort="totalsales" class="bg-purple" style="color:black">Shop</th><th st-sort="totalsales" class="bg-purple" style="color:black">Company</th><th st-sort="totalsales" class="bg-purple" style="color:black">Total</th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="item in machineSalesOfPartner | groupBy: \'[partnerid, shopid]\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{showPartners(item[0].partnerid)}}</td><td><span editable-text="item[0].code" e-name="code" e-form="rowform" e-required="">{{ item[0].code || \'empty\'}}</span></td><td><span editable-text="item[0].name" e-name="name" e-form="rowform" e-required="">{{ item[0].name || \'empty\'}}</span></td><td class="bg-warning" style="color:black">{{ getTotalmpsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmcsales(item) | currency:\'\'}}</td><td class="bg-warning" style="color:black">{{ getTotalmactotal(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalnetpurhase(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalopsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalocsales(item) | currency:\'\'}}</td><td class="bg-info" style="color:black">{{ getTotalontotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalshopTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotalcompTotal(item) | currency:\'\'}}</td><td class="bg-purple" style="color:black">{{ getTotaltotalsales(item) | currency:\'\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons text-center" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="getShopSalesOfPartner(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td style="background-color:chocolate ;color:black">{{mPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{mSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{npTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oPSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oCSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{oSalesTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{shopOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{compOverTotal | currency:\'\'}}</td><td style="background-color:chocolate ;color:black">{{totalSalesLabelFooter | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="dateList.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="dateList.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList.result" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="sname">Shop Code</th><th st-sort="mactotal">Machine Company Sales</th><th st-sort="ontotal">Online Company Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.pname" e-name="pname" e-form="rowform" e-required="">{{ item.pname || \'empty\'}}</span></td><td><span editable-text="item.sname" e-name="sname" e-form="rowform" e-required="">{{ item.sname || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/reports/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel.toFixed(2) | currency:\'\'}}</label></div></div><div class="col-sm-6"><br><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="genIvoiceMachinesales()">Generate Machine Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="created">Upload Date</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.machine.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.machine.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/dailymachineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineView.html','<table class="table table-bordered"><thead><tr><th>Machine</th><th class="align-right">New Meter</th><th class="align-right">Previous Meter</th><th class="align-right">Difference</th><th class="align-right">Sales</th><th class="align-right">Shop</th><th class="align-right">Company</th></tr></thead><tbody><tr ng-repeat="item in machineSalesDetails"><td>{{item.mid}}</td><td class="align-right">{{item.cmIn}}<br>{{item.cmOut}}<br>{{item.bmIn}}<br>{{item.bmOut}}<br></td><td class="align-right">{{item.cmInP}}<br>{{item.cmOutP}}<br>{{item.bmInP}}<br>{{item.bmOutP}}<br></td><td class="align-right">{{item.cmIn - item.cmInP}}<br>{{item.cmOut - item.cmOutP}}<br>{{item.bmIn - item.bmInP}}<br>{{item.bmOut - item.bmOutP}}<br></td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}} ({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales | currency: \'\'}} ({{item.machineshop.macrate}}%)</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineshopLevel2.html','<div class="panel-content"><h3 class="with-line">Shop and Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{salesNumbers.data.partnerName}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{machineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{salesNumbers.data.created | date: \'dd/MM/yyyy \'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{machineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy \'}}</label></div></div></div></div><h3 class="with-line">Machine Sales Information</h3><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/reports/dailymachineshop/widgets/dailymachineView.html"></div></div></div><hr><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.csales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner%</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.psales | currency:\'\'}}</label></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageDailymachineshop.totalsales | currency:\'\'}}</label></div></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="viewDetailedMachinesales(group)">View</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button>');
$templateCache.put('app/pages/reports/dailymachineshop/widgets/dailymachineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel.toFixed(2) | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageDailymachineshopList" st-table="manageDailymachineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop Code</th><th st-sort="shop.name">Shop Name</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="group in manageDailymachineshop[0].result" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="group.code" e-name="code" e-form="rowform" e-required="">{{ group.code || \'empty\'}}</span></td><td><span editable-text="group.name" e-name="name" e-form="rowform" e-required="">{{ group.name || \'empty\' }}</span></td><td><span editable-text="group.csales" e-name="csales" e-form="rowform" e-required="">{{ group.csales | currency:\'\' }}</span></td><td><span editable-text="group.psales" e-name="psales" e-form="rowform" e-required="">{{ group.psales | currency:\'\'}}</span></td><td><span editable-text="group.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ group.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(group)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlinesales/widgets/dailyonlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales :</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div><div class="col-md-6"><br><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="genIvoiceOnlinesales()">Generate Online Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="apshare">AP PS</th><th st-sort="pwin">PW</th><th st-sort="apwin">AP PW</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="game.name" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.shop.code || \'empty\'}}</td><td>{{ item.game.name || \'empty\' }}</td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.apshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td>{{ item.apwin | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/widgets/dailyonlineshopTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-md-4"><br><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales :</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlineshopList" st-table="manageOnlineshop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shop.code">Shop</th><th st-sort="shop.name">Game</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineshop[0].result" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewOnlinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/dailyonlineshop/widgets/viewOnlineshop.html','<table class="table table-bordered"><thead><tr><th>Games</th><th class="align-right">Net Purchase</th><th class="align-right">P/S (-)</th><th class="align-right">P/W (+)</th><th class="align-right">Sales</th><th class="align-right">Shop ({{100-onlineSalesDetails[0].shop.onrate}}%)</th><th class="align-right">Company ({{onlineSalesDetails[0].shop.onrate}}%)</th></tr></thead><tbody><tr ng-repeat="item in onlineSalesDetails"><td>{{item.game.name}}</td><td class="align-right">{{item.netpurchase | currency: \'\'}}</td><td class="align-right">{{item.pshare | currency: \'\'}}</td><td class="align-right">{{item.pwin | currency: \'\'}}</td><td class="align-right">{{item.totalsales | currency: \'\'}}</td><td class="align-right">{{item.psales | currency: \'\'}}</td><td class="align-right">{{item.csales | currency: \'\'}}</td></tr></tbody></table>');
$templateCache.put('app/pages/reports/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="created">Invoice Date</th><th st-sort="upload">Upload Date</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.machine.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.machine.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/marketing/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Marketing sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/marketing/widgets/marketingTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="dateList.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="dateList.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMarketingsalesList.result" st-table="manageMarketingsales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="sname">Shop Code</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="sid" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMarketingsales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.pname" e-name="pname" e-form="rowform" e-required="">{{ item.pname || \'empty\'}}</span></td><td><span editable-text="item.sname" e-name="sname" e-form="rowform" e-required="">{{ item.sname || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveSales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewSales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/onlinesales/widgets/onlinesalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchOnlinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageOnlinesalesList" st-table="manageOnlinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="playtechid">Kiosk</th><th st-sort="shop.code">Shop</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="ikey">Upload Date</th><th st-sort="netpurchase">NP</th><th st-sort="pshare">PS</th><th st-sort="apshare">AP PS</th><th st-sort="pwin">PW</th><th st-sort="apwin">AP PW</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th><input st-search="shop.code" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="game.name" placeholder="Game Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><span editable-text="item.shopid" e-name="shopid" e-form="rowform" e-required="">{{ item.shop.code || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ item.game.name || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.created | date: \'dd/MM/yyyy\'}}</td><td>{{ item.netpurchase | currency:\'\'}}</td><td>{{ item.pshare | currency:\'\'}}</td><td>{{ item.apshare | currency:\'\'}}</td><td>{{ item.pwin | currency:\'\'}}</td><td>{{ item.apwin | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editOnlinesales(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/onlinesales/widgets/viewSale.html','<h3 class="with-line">Shop and Game Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Game</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.game.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Code</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.code}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{showPartnerById(manageOnlinesales)}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Number</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoiceid}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Kiosk</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.playtechid}}</label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.shop.name}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Upload Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{manageOnlinesales.created | date: \'dd/MM/yyyy hh:mm a\'}}</label></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Invoice Date</label><div class="col-sm-9"><label class="col-sm-5 control-label">{{onlineSalesInvoice[0].invoicedate | date: \'dd/MM/yyyy\'}}</label></div></div></div></div><h3 class="with-line">Sales Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Share</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pshare | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Progressive Wins</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.pwin | currency:\'\'}}</label></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Purchase</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netpurchase | currency:\'\'}}</label></div></div><p><br></p><div class="form-group row clearfix"><label class="col-sm-3 control-label">Total Sales</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.totalsales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Net Gaming</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.netgaming | currency:\'\'}}</label></div></div></div></div><div class="row"><hr><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company({{manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.csales | currency:\'\'}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner({{100 - manageOnlinesales.shop.onrate}}%)</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageOnlinesales.psales | currency:\'\'}}</label></div></div></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageStates()">Close</button>');
$templateCache.put('app/pages/reports/partnersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/suppliersales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/partnersales/widgets/partnersalesTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Grand Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList.result" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="mactotal">Machine Total Sales</th><th st-sort="ontotal">Online Total Sales</th><th st-sort="total">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.mactotal" e-name="mactotal" e-form="rowform" e-required="">{{ item.mactotal | currency:\'\' }}</span></td><td><span editable-text="item.ontotal" e-name="ontotal" e-form="rowform" e-required="">{{ item.ontotal | currency:\'\'}}</span></td><td><span editable-text="item.total" e-name="total" e-form="rowform" e-required="">{{ item.total | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/suppliersales/widgets/suppliersalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(dateList)">Search</button></div></div><div class="col-md-4"><label>&nbsp;</label><div class="form-group row clearfix"><label class="col-md-4 control-label"><strong>Overall Total Sales:</strong></label> <label class="col-md-4 control-label">{{totalSalesLabel | currency:\'\'}}</label></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageSuppliersalesList.result" st-table="manageSuppliersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSuppliersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\' }}</span></td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/supplier/gameprovider/widgets/gameProviderTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageParentGameProvider(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageParentGameProviderList" st-table="manageGameProvider"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="game.name">Game</th><th st-sort="name">Name</th><th st-sort="">Zones</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="game.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th></th>><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGameProvider" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.gameid" e-name="game" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in gameList">{{item.game.name}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.zones" e-name="zones" onshow="loadGroups()" e-form="rowform" e-multiple="" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList"><span>{{ showZones(item.zones) }}</span></span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveServerFee($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/supplier/gameprovider/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Server!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/gameserver/widgets/gameserverShopTable.html','<div style="overflow-y: hidden"><div class="row"><div class="col-sm-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.stateid" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="initManageShopGameServer()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reset()">Reset</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-danger" ng-click="viewGameServer()">Back</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageShopGameServerList" st-table="manageShopGameServer"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="shopname">Shop</th><th st-sort="shopcode">Code</th><th st-sort="gamesname">Online Game</th><th st-sort="playtechid">PlayTech ID</th><th st-sort="onrate">Company %</th><th st-sort="bet_Rate">Bonus Bet %</th><th st-sort="algorithm">NP/NG</th><th st-sort="gameservername">Provider</th><th st-sort="server" style="min-width: 80px">Server %</th><th st-sort="pr" style="min-width: 80px">PR %</th><th>Action</th></tr><tr><th></th><th><input st-search="shopname" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamesname" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="playtechid" placeholder="Search PlaytechId" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="algorithm" placeholder="Search PlaytechId" class="input-sm form-control search-input" type="search"></th><th><input st-search="gameservername" placeholder="Search Provider" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShopGameServer" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td">{{ item.shopname }}</td><td class="select-td">{{item.shopcode}}</td><td class="select-td">{{item.gamesname}}</td><td>{{ item.playtechid || \'empty\'}}</td><td>{{ item.onrate === null ? \'-\' : item.onrate }}</td><td>{{ item.bet_rate === null ? \'-\' : item.bet_rate }}</td><td class="select-td">{{item.algorithm}}</td><td class="select-td">{{item.gameservername}}</td><td>{{ item.server === null ? \'-\' : item.server }}</td><td>{{ item.pr === null ? \'-\' : item.pr }}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="openShopGameServerModal(item)">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/supplier/gameserver/widgets/gameserverTable.html','<div style="overflow-y: hidden"><div class="form-group clearfix"><div class="row"><div class="col-sm-3"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-2 col-sm-offset-7"><label>&nbsp;</label><div><button type="button" class="btn btn-primary" ng-click="viewShop()">View Shop</button></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageParentGameServerList" st-table="manageGameServer"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="gameprovider.name">Provider</th><th st-sort="gameprovider.game.name">Game</th><th st-sort="name">Server Name</th><th st-sort="serverFee">Server Fee(%)</th><th st-sort="customerFee">Customer Fee(%)</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="gameprovider.name" placeholder="Search Provider" class="input-sm form-control search-input" type="search"></th><th><input st-search="gameprovider.game.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Server Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGameServer" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.providerid" e-name="provider" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in providerList">{{item.gameprovider.name}}</span></td><td class="select-td"><span>{{item.gameprovider.game.name}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-number="item.serverFee" e-name="serverFee" e-form="rowform" e-required="">{{ item.serverFee || \'0\'}}</span></td><td><span editable-number="item.customerFee" e-name="customerFee" e-form="rowform" e-required="">{{ item.customerFee || \'0\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGameServer($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/supplier/gameserver/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Server!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/gameserver/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/gameserver/modals/shopGameServerUpdateModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>{{ selected.id ? \'Edit\' : \'Create\'}} Online Game</span></div><div class="modal-body text-center"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shops</label><div class="col-sm-9 form-group"><ui-select ng-model="selected.shop" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="shop in manageShopList | filter: $select.search"><span>{{ shop.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Online Game</label><div class="col-sm-9 form-group"><ui-select ng-model="selected.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="game in gameList | filter: $select.search"><span>{{ game.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">PlaytechID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="selected.playtechid"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><input type="number" class="form-control" ng-model="selected.onrate"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Bonus Bet</label><div class="col-sm-9"><input type="number" class="form-control" ng-model="selected.bet_rate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Algorithm</label><div class="col-sm-9 form-group"><ui-select ng-model="selected.algorithm" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="alg in algorithms | filter: $select.search"><span>{{ alg }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Provider</label><div class="col-sm-9 form-group"><ui-select ng-model="selected.gameserver" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="gameserver in manageParentGameServerList | filter: $select.search"><span>{{ gameserver.name }}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">Server %</label><div class="col-sm-9"><input type="number" class="form-control" ng-model="selected.server"></div></div><div class="form-group row clearfix"><label for="inputdcc" class="col-sm-3 control-label">PR %</label><div class="col-sm-9"><input type="number" class="form-control" ng-model="selected.pr"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/machinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/supplier/machinesales/widgets/machinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div><div class="col-sm-2"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Commission:</strong></label> <label class="control-label"><strong>{{totalCommissionLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.supplier" class="col-sm-2"><label>Select Supplier</label><ui-select ng-model="reportFilter.supplier" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search"><span ng-bind-html="supplier.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="supcode">Supplier Code</th><th st-sort="supname">Supplier Name</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop Code</th><th st-sort="name">Shop Name</th><th st-sort="game.name">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th st-sort="suprate">Rate%</th><th>Commission</th><th st-sort="totalsales">Total Sales</th><th>Action</th></tr><tr><th></th><th><input st-search="supcode" placeholder="Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="supname" placeholder="Supplier Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Shop Name" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Invoice Date" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="suprate" placeholder="Supplier Rates" class="input-sm form-control search-input" type="search"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcommission(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.supcode || \'empty\'}}</td><td>{{ item.supname || \'empty\'}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="shopid" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo:-8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.suprate}}%</td><td>{{item.commission | currency:\'\'}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcommission(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/modals/receiptModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>Zoom Picture</span></div><div class="modal-body text-center"><img ng-src="{{imageString}}"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/widgets/dailymachinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageUsersList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Time</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="getDailyMachinesales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-warning" ng-click="genIvoiceMachinesales()">Generate Invoice</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMachinesalesList" st-table="manageMachinesales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="mid">Machine Code</th><th st-sort="shopcode">Shop</th><th st-sort="showGameById(item.gameid)">Game</th><th st-sort="ikey">Invoice Date</th><th st-sort="uploaddate">Upload Date</th><th>Agent</th><th st-sort="totalsales">Total Sales</th><th st-sort="csales">Company %</th><th st-sort="psales">Partner %</th><th>Action</th></tr><tr><th></th><th><input st-search="mid" placeholder="Machine Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="shopcode" placeholder="Shop Code" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="ikey" placeholder="Upload Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-hide="manageMachinesales.length>0"></th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</th><th ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachinesales" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.mid" e-name="mid" e-form="rowform" e-required="">{{ item.mid || \'empty\'}}</span></td><td><span editable-text="item.shopcode" e-name="shopid" e-form="rowform" e-required="">{{ item.shopcode || \'empty\'}}</span></td><td><span editable-text="item.gameid" e-name="gameid" e-form="rowform" e-required="">{{ showGameById(item.gameid) || \'empty\' }}</span></td><td>{{ item.ikey | limitTo: -8}}</td><td>{{ item.uploaddate | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{ showAgentsById(item.agentid)}}</td><td><span editable-text="item.totalsales" e-name="totalsales" e-form="rowform" e-required="">{{ item.totalsales | currency:\'\'}}</span></td><td><span editable-text="item.csales" e-name="csales" e-form="rowform" e-required="">{{ item.csales | currency:\'\' }}</span></td><td><span editable-text="item.psales" e-name="psales" e-form="rowform" e-required="">{{ item.psales | currency:\'\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotaltotalsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalcsales(manageMachinesales) | currency:\'\'}}</td><td ng-if="manageMachinesales.length>0" style="background-color:chocolate ;color:black">{{ getTotalpsales(manageMachinesales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/shopstaff/dailymachinesales/widgets/viewMachineSales.html','<table id="dotMatrix" class="table" style="border: 1px solid gainsboro;" cellpadding="4" cellspacing="0" border="1"><thead><tr><th>Machine</th><th class="text-center">New(M)</th><th class="text-center">Pre(M)</th><th class="text-center">Diff</th><th class="text-center">Sales</th><th class="text-center">Shop</th><th class="text-center">Company</th><th class="text-center">Shorts</th><th class="text-center">Total</th></tr></thead><tbody><tr ng-repeat="item in machineInvoiceDetails" class="editable-tr-wrap"><td class="align-right">{{item.mid}}<br>{{item.machine.cmRate}}<br></td><td class="align-right">{{item.cmIn==0?\'-\':(item.cmIn | currency: \'\':0) }}<br>{{item.cmOut==0?\'-\':(item.cmOut | currency: \'\':0) }}<br>{{item.bmIn==0?\'-\':(item.bmIn | currency: \'\':0) }}<br>{{item.bmOut==0?\'-\':(item.bmOut | currency: \'\':0) }}<br></td><td class="align-right">{{item.cmInP==0?\'-\':(item.cmInP | currency: \'\':0) }}<br>{{item.cmOutP==0?\'-\':(item.cmOutP | currency: \'\':0) }}<br>{{item.bmInP==0?\'-\':(item.bmInP | currency: \'\':0) }}<br>{{item.bmOutP==0?\'-\':(item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{(item.cmIn - item.cmInP)==0?\'-\':(item.cmIn - item.cmInP | currency: \'\':0) }}<br>{{(item.cmOut - item.cmOutP)==0?\'-\':(item.cmOut - item.cmOutP | currency: \'\':0) }}<br>{{(item.bmIn - item.bmInP)==0?\'-\':(item.bmIn - item.bmInP | currency: \'\':0) }}<br>{{(item.bmOut - item.bmOutP)==0?\'-\':(item.bmOut - item.bmOutP | currency: \'\':0) }}<br></td><td class="align-right">{{item.totalsales==0?\'-\':(item.totalsales | currency: \'\')}}</td><td class="align-right">{{item.psales==0?\'-\':(item.psales | currency: \'\')}}<br>({{100-item.machineshop.macrate}}%)</td><td class="align-right">{{item.csales==0?\'-\':(item.csales | currency: \'\')}}<br>({{item.machineshop.macrate}}%)</td><td class="align-right" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0"><span ng-hide="isInvoice" editable-text="manageDailyinvoices.machineshorts" blur="cancel">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span> <span ng-show="isInvoice">{{ manageDailyinvoices.machineshorts==0?\'-\':(manageDailyinvoices.machineshorts | currency: \'\')}}</span></td><td class="text-center" rowspan="{{machineInvoiceDetails.length}}" ng-hide="$index>0">{{total.machineST==0?\'-\':(total.machineST | currency: \'\')}}</td></tr></tbody></table>');
$templateCache.put('app/pages/system/areas/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Area!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/areas/widgets/areasTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageAreasList" st-table="manageAreas"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="zone.code">Daerah</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageAreas" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveArea($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/gamecategory/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game Category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/gamecategory/widgets/gamecategoryTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamecategoryList" st-table="manageGamecategory"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGamecategory" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGamecategory($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/games/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/games/widgets/gamesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamesList" st-table="manageGames"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="gamecategory.name">Game Category</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamecategory.name" placeholder="Search Game Category" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Game Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGames" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.gamecatid" e-name="gamecategory" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamecategoryList">{{ showGamecategory(item.gamecat) }}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGame($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/system/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Daerah</th><th st-sort="isjackpot">is Jackpot?</th><th st-sort="calby">Calc By?</th><th st-sort="cm_rate">CM Rate</th><th st-sort="bm_rate">BM Rate</th><th st-sort="">CM to BM</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="games.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span> <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td class="select-td">{{item.game.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.isjackpot" e-name="isjackpot" e-form="rowform" e-required="">{{ item.isjackpot?\'Yes\':\'No\' || \'empty\'}}</span></td><td><span editable-text="item.calby" e-name="calby" e-form="rowform" e-required="">{{ item.calby?\'CM\':\'BM\' || \'empty\'}}</span></td><td><span editable-text="item.cmRate" e-name="cm_rate" e-form="rowform" e-required="">{{ item.cmRate || \'empty\'}}</span></td><td><span editable-text="item.bmRate" e-name="bm_rate" e-form="rowform" e-required="">{{ item.bmRate || \'empty\'}}</span></td><td>{{(item.cmRate/item.bmRate)|currency: \'\'}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachine($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editMachine(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/system/memo/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Memo!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/memo/widgets/memoDetail.html','<div class="row form-group"><label for="inputtitle" class="col-sm-3 control-label">Active</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="selectedMemo.active"> <span>{{selectedMemo.active?"Yes":"No"}}</span></label></div></div><div class="row form-group"><label for="inputtitle" class="col-sm-3 control-label">Title</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="selectedMemo.title"></div></div><div class="row form-group"><label for="inputtitle" class="col-sm-3 control-label">Description</label><div class="col-sm-9"><div ckeditor="ckEditorOptions" ng-model="selectedMemo.description" ready="onReady()"></div></div></div><div class="form-group row"><label for="zones" class="col-sm-3 control-label">Zones</label><div class="col-sm-9"><ui-select style="border: 1px solid #cbcbcb" ng-model="selectedMemo.zones" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="zone in manageZonesList | filter: $select.search"><span style="color: black" ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row"><label for="zones" class="col-sm-3 control-label">Roles</label><div class="col-sm-9"><ui-select style="border: 1px solid #cbcbcb" ng-model="selectedMemo.roles" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="role in mangeUserRoleList | filter: $select.search"><span style="color: black" ng-bind-html="role.name"></span></ui-select-choices></ui-select></div></div>');
$templateCache.put('app/pages/system/memo/widgets/memoTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices style="color: black" repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="search()">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="search(true)">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="memoList" st-table="memo"><thead><tr class="sortable"><th class="table-id" st-sort="id">#</th><th st-sort="created">Created Date</th><th st-sort="title">Title</th><th st-sort="zonesname">Zones</th><th st-sort="rolesname">Roles</th><th st-sort="activate">Active</th><th>Action</th></tr><tr><th></th><th></th><th><input st-search="title" placeholder="Search Title" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonesname" placeholder="Search zones" class="input-sm form-control search-input" type="search"></th><th><input st-search="rolesname" placeholder="Search roles" class="input-sm form-control search-input" type="search"></th><th><input st-search="activate" placeholder="Search active" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-if="!memoList.length"><td colspan="10">{{loading ? \'Loading...\' : \'No Data\'}}</td></tr><tr ng-repeat="item in memo" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><span>{{ item.title }}</span></td><td>{{ item.zonesname}}</td><td><span>{{item.rolesname }}</span></td><td><span>{{ item.activate }}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-info editable-table-button btn-xs" ng-click="viewMemo(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/system/site/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Site!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/site/widgets/siteTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageSiteList" st-table="manageSites"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="zone.name">Zone</th><th st-sort="zonepr.name">Zone PR</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.name" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="zonepr.name" placeholder="Search ZonePR" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSites" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageZoneList">{{ showZone(item.zone) }}</span></td><td class="select-td"><span editable-select="item.zonepr.id" e-name="zonepr" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageZonePRList">{{ showZonePR(item.zonepr) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveSite($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/shop/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/widgets/machines.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div></div></div><h3 class="with-line">Machine Setup &nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Machine</button></h3><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Machine Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.machine" data-e-form="rowform" data-e-name="machine" e-name="machine" data-e-ng-model="machine" append-to-body="true">{{ showMachine(item.machine) }}<editable-ui-select-match placeholder="Machine Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="machine in manageMachineList | filter: $select.search track by $index">{{machine.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/onlineGames.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div></div></div><h3 class="with-line">Online Games Setup &nbsp; <button class="btn btn-primary editable-table-button btn-xs" ng-click="addOnlineShop()">Add</button></h3><div class="row"><div class="col-md-6"><table class="table" st-safe-src="manageOnlineShopList" st-table="manageOnlineShop"><thead><tr class="black-muted-bg"><th>Online Game</th><th>PlayTech ID</th><th>Action</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineShop" class="editable-row"><td class="select-td"><span editable-select="item.game.id" e-name="games" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamesList">{{ showGames(item.game) }}</span></td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlineShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/partner.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Name & Contact</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-9 control-label">{{manageShop.partner.name+\' (\'+manageShop.partner.contact+\')\'}}</label></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">1. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">2. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">3. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">1. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">2. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">3. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.number"></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopInfo.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><select class="form-control" ng-model="manageShop.shoptype" selectpicker=""><option selected="">100%</option><option>5/5</option></select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.address"></textarea></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.status"> <span>{{manageShop.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Daerah Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Area</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.area" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in manageAreaList | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Balai</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.site" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="site in manageSiteList | filter: $select.search"><span ng-bind-html="site.name"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="float" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.remarks"></textarea></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageShopList" st-table="manageShop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop ID</th><th st-sort="name">Shop Name</th><th st-sort="shoptype">Shop Type</th><th st-sort="partner.name">Partner ID</th><th st-sort="zone.code">Daerah</th><th st-sort="status">Status</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop ID" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="shoptype" placeholder="Search Shop Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.name" placeholder="Search Partner" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Daerah" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.shoptype" e-name="shoptype" e-form="rowform" e-required="">{{ item.shoptype || \'empty\'}}</span></td><td class="select-td">{{item.partner.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editShop(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/system/states/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/states/widgets/statesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageStatesList" st-table="manageStates"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageStates" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveState($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/zones/modals/billZonesModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-flame modal-icon"></i><span>Update Payment Voucher code by zone</span></div><div class="modal-body text-left"><div class="form-group row clearfix"><label for="category" class="col-sm-4 control-label">Zone</label><div class="col-sm-8">{{selectedZone.name}}</div></div><div class="form-group row clearfix"><label for="category" class="col-sm-4 control-label">Payment Voucher Codes</label><div class="col-sm-8"><ui-select ng-model="selectedZone.codes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" multiple="" close-on-select="false"><ui-select-match placeholder="Nothing Selected">{{$item.name}} - {{$item.description}}</ui-select-match><ui-select-choices ng-hide="!$select.open" repeat="code in billCategoryList track by code.name | filter: $select.search"><span style="color: black" ng-bind-html="code.name + \' - \' + code.description"></span></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close(true)">Confirm</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/zones/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Daerah!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/zones/widgets/zonesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageZonesList" st-table="manageZones"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Daerah Code</th><th st-sort="name">Name</th><th st-sort="state.name">State</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Daerah Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageZones" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveZones($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/zonespr/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Daerah PR!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/zonespr/widgets/zonesPRTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageZonesPRList" st-table="manageZonesPR"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="name">Name</th><th st-sort="state.name">State</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Daerah PR Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageZonesPR" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveZonesPR($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr><tr ng-if="!manageZonesPRList.length"><td colspan="10">No Data</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/totalsales/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/totalsales/collector/widgets/collectorTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" datepicker-options="dateList.options" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" datepicker-options="dateList.options" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div ng-if="manageStatesList.length>1" class="col-sm-3"><label>Select State</label><ui-select ng-model="reportFilter.state" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="state in manageStatesList | filter: $select.search"><span ng-bind-html="state.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="managePartnersalesList" st-table="managePartnersales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="scode">Shop Code</th><th st-sort="sname">Shop Name</th><th st-sort="mactotal" class="text-center bg-warning" style="color: black">Machine</th><th st-sort="ontotal" class="text-center bg-info" style="color: black">Online</th><th st-sort="total" class="text-center bg-purple" style="color: black">Overall</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="scode" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotalmactotal(managePartnersales) | currency:\'\'}}</th><th ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotalontotal(managePartnersales) | currency:\'\'}}</th><th ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotaltotal(managePartnersales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartnersales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.pname}}</td><td>{{ item.scode}}</td><td>{{ item.sname}}</td><td class="bg-warning" style="color: black">{{ item.mactotal | currency:\'\' }}</td><td class="bg-info" style="color: black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ item.total | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewMachinesales(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotalmactotal(managePartnersales) | currency:\'\'}}</td><td ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotalontotal(managePartnersales) | currency:\'\'}}</td><td ng-if="managePartnersales.length>0" style="background-color: chocolate; color: black">{{ getTotaltotal(managePartnersales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/totalsales/marketing/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Marketing sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/totalsales/marketing/widgets/marketingTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="dateList.options" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="dateList.options" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>&nbsp;</label><div class="form-group row clearfix"><label class="control-label"><strong>Overall Total Sales:</strong></label> <label class="control-label"><strong>{{totalSalesLabel | currency:\'\'}}</strong></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="manageZonesList.length>1" class="col-sm-2"><label>Select Daerah</label><ui-select ng-model="reportFilter.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.name"></span></ui-select-choices></ui-select></div><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Shop Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchSales(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="reportFilter={}">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageMarketingsalesList" st-table="manageMarketingsales"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="pname">Partner Name</th><th st-sort="scode">Shop Code</th><th st-sort="sname">Shop Name</th><th st-sort="mactotal" class="text-center bg-warning" style="color: black">Machine</th><th st-sort="ontotal" class="text-center bg-info" style="color: black">Online</th><th st-sort="total" class="text-center bg-purple" style="color: black">Overall</th><th>Action</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="pname" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="scode" placeholder="Search Shop Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="sname" placeholder="Search Shop Name" class="input-sm form-control search-input" type="search"></th><th ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotalmactotal(manageMarketingsales) | currency:\'\'}}</th><th ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotalontotal(manageMarketingsales) | currency:\'\'}}</th><th ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotaltotal(manageMarketingsales) | currency:\'\'}}</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMarketingsales" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.pname}}</td><td>{{ item.scode}}</td><td>{{ item.sname}}</td><td class="bg-warning" style="color: black">{{ item.mactotal | currency:\'\' }}</td><td class="bg-info" style="color: black">{{ item.ontotal | currency:\'\'}}</td><td class="bg-purple" style="color: black">{{ item.total | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewSales(item)">View</button></div></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotalmactotal(manageMarketingsales) | currency:\'\'}}</td><td ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotalontotal(manageMarketingsales) | currency:\'\'}}</td><td ng-if="manageMarketingsales.length>0" style="background-color: chocolate; color: black">{{ getTotaltotal(manageMarketingsales) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/usersetup/users/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Users!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/usersetup/users/modals/passwordModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-locked modal-icon"></i><span>Password</span></div><div class="modal-body text-center"><div id="qrLabel"><span>{{newPassword}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/usersetup/users/widgets/usersTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageUsersList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="username">Username</th><th st-sort="credentials.name">Name</th><th st-sort="credentials.mobile">Mobile</th><th st-sort="emailVerified">Access?</th><th st-sort="credentials.role">Role</th><th st-sort="credentials.zonemap">Daerah</th><th st-sort="credentials.statemap" ng-if="isTopLevelAdmin">State</th><th st-sort="credentials.shoptype">Shop Type</th><th st-sort="credentials.paparichMasterID">Paparich Master ID</th><th st-sort="credentials.collectedDeposit">Deposit Collected</th><th st-sort="credentials.pan_limit">\u76D8\u8D39\u989D\u5EA6Limit</th><th st-sort="credentials.partnerid">Partner Code</th><th st-sort="credentials.collectormap">Collectors</th><th st-sort="credentials.months">Report Duration (in Month)</th><th>Action</th></tr><tr><th></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.mobile" placeholder="Search Mobile" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th><input st-search="credentials.paparichMasterID" placeholder="Search Paparich Master ID" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th><input st-search="credentials.months" placeholder="Search Duration" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.username}}</td><td><span editable-text="item.credentials.name" e-name="name" e-form="rowform" e-required="">{{ item.credentials.name || item.credentials.firstName || \'empty\'}}</span></td><td><span editable-text="item.credentials.mobile" e-name="mobile" e-form="rowform" e-required="">{{ item.credentials.mobile || \'empty\' }}</span></td><td><span editable-radiolist="item.emailVerified" e-ng-options="s.value as s.text for s in ::emailVerified track by s.value" e-name="emailVerified" e-form="rowform">{{ showAccess(item.emailVerified) }}</span></td><td class="select-td"><span editable-select="item.credentials.role" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in filteredRoneList">{{ showRoles(item.roles[0].id) }}</span></td><td class="select-td"><span editable-select="item.credentials.zonemap" e-name="zonemap" onshow="loadGroups()" e-form="rowform" e-multiple="" e-selectpicker="" e-ng-options="g.id as g.code for g in filteredZoneList"><span ng-repeat="zoneitem in item.credentials.zonemap">{{ showZones(zoneitem) }},</span></span></td><td class="select-td" ng-if="isTopLevelAdmin"><span editable-select="item.credentials.statemap" e-name="statemap" onshow="loadGroups()" e-form="rowform" e-multiple="" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList"><span ng-repeat="stateitem in item.credentials.statemap">{{ showStates(stateitem) }},</span></span></td><td class="select-td"><span editable-select="item.credentials.shopType" e-name="shopType" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.value as g.value for g in shopTypeFilter">{{ item.credentials.shopType }}</span></td><td><span editable-text="item.credentials.paparichMasterID" e-name="paparichMasterID" e-form="rowform" e-required="">{{ item.credentials.paparichMasterID || \'\' }}</span></td><td><span editable-number="item.credentials.collectedDeposit" e-name="collectedDeposit" e-form="rowform" e-required="">{{ item.credentials.collectedDeposit || \'\' }}</span></td><td><span editable-number="item.credentials.pan_limit" e-name="pan_limit" e-form="rowform" e-required="">{{ item.credentials.pan_limit || \'\' }}</span></td><td class="select-td"><span editable-ui-select="item.credentials.partner" data-e-form="rowform" data-e-name="partner" name="partner" data-e-ng-model="item.credentials.partner">{{ item.credentials.partner.code }}<editable-ui-select-match placeholder="Partner Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="partner in managePartnerList | filter: $select.search track by $index">{{partner.code}}, {{partner.name}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-select="item.credentials.collectormap" e-name="collectormap" onshow="loadGroups()" e-form="rowform" e-multiple="" e-selectpicker="" e-ng-options="g.id as g.name for g in manageCollectors"><span ng-repeat="collector in item.credentials.collectormap">{{ showCollectors(collector) }},</span></span></td><td><span editable-text="item.credentials.months" e-name="months" e-form="rowform" e-required="">{{ item.credentials.months || \'empty\' }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id,item)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id,item.credentials.partner.id,item.credentials.collector.id,item.credentials.shop.id,item.credentials.supplier.id)">Delete</button> &nbsp;&nbsp; <button class="btn btn-warning editable-table-button btn-xs" ng-click="resetPassword(item.id)">Reset</button></div></td></tr></tbody><br><tfoot><tr><td colspan="15" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/usersetup/roles/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/usersetup/roles/widgets/rolesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageRolesList" st-table="manageRoles"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="modified">Last Updated</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="modified" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in manageRoles" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.modified | date: \'dd/MM/yyyy hh:mm a\'}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');}]);